// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/captcha-reload.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bg-nav-dropdown.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/clarovideo-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/bg-registro-xl.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/bg-registro-xl_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/bg-registro-lg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/bg-registro-lg_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/bg-registro-xl-peru.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/bg-registro-xl-peru_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/bg-registro-lg-peru.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/bg-registro-lg-peru_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/bg-registro-md.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/bg-registro-md_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/bg-registro-sm.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/bg-registro-sm_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/bg-registro-xs_blur.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/select2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/select2-spinner.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAMAAABmmnOVAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAeHAAAHhwFd+hRDAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAHVQTFRFAAAAOTk5MzMzOzs7Nzc3QUFBQEBAPz8/Pj4+QUFBQEBAPz8/Pj4+QUFBQEBAPz8/QUFBPj4+Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pj4+Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/QEBAPz8/n3QmjwAAACZ0Uk5TAAkKDQ4zODk6OzxBQkNERUusrbG0tba7vL3Excbu8fL19fb3+PgucqJgAAACqklEQVR42sXc23LCIBAGYKy2pgft0WpP2vTA+z9i0+goCZAs7O7P3oWZTL5ZYAh7sca0MXmYG3jM7yfu4/TV1jdow01tX6cdg4UrGoN1FNM3a+GK1nBSzPYGrOJgsPZt1hrerYUrjoa9wjHgFI7B2veZWVk3tpCdWm07H30y8+4AIhedPFj7cW7wioABrggawIqIAaroGbYXzlGCUvQNnc0IUgwaQIoRA0QxagAoCAZ1BcmgrCAaVBVkg6IiwaCmSDIoKRINKopkg4IiwyCuyDIIKzINoopsg6CCYRBTsAxCCqZBRLGo2RcrtkLAwFaIGJgKIQNLIWZgKAQN2QpRg1dKoCmEDVkKcUOGQsGQrFAxJCqUDEkKNUOCQtFAVqgaiAplg69YFDAQFADDqAJiGFGADI1iF1XADAOKvqHSLApHFFBDRAE2BBVwQ0BRwOApfn8LGDxFEcOQAmeIK5CGmAJrCCvQBq8A8r9Zrw08qp6irvAGs/zpIr4XBQxf3nQsyhvwipABrQgbsIqYAamIG3CKnqH+LKDoGXbVwD84zDB4E4AZ4IqgAayIGKCKqMGYS5RiwOArlgUMnuJrWcAAUYwaAAqCQV1BMigriAZVBdmgqEgwqCmSDEqKRIOKItmgoMgwiCv6hkvaa6KKTIOoItsgqGAYxBQsg5CCaRBRsA0CCgEDWyFiYCqEDCyFmIGhEDRkK0QNmQphQ5ZC3JChUDAkK1QMiQolQ5JCzZCguNUzkBV3P4oGokLZQFKoGwgKgGFUATGMKECGQQXMYMxVTAE0RBVQQ0QBNgQVcENI8QwoBo8cUiszWYPz4OVi3bQ9cBQoQ0exblsvTDZwg6PYHNo/tE0XmvVwa4BxWBentgtnL+A8HHPxcnYaaBRoQ6twDY3iEW5oFI8Hwx/QxSE448b+MwAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAADcBAMAAAAig/QJAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAFtDAABbQwH5xg68AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAB5QTFRFAAAA////cXFxaWlp////ZmZmnJycoaGhpqam////1D9b6wAAAAV0Uk5TAAgJERExZxYzAAAAYklEQVRYw+3WoQ2AUBAE0SsBOiBUQEIDCArA4FFoHBaJxNItFYz/x5+xz282VmwJTdM0rRzbsS1e7Pm9zdgUVn491rkFmqZpSezEjqo/Sos1HoAEjdjgFmiapiWxG7tq/igfnYteFlnOWZEAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/fonts/fontawesome-webfont.eot?v=4.0.3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/fonts/fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/fonts/fontawesome-webfont.woff?v=4.0.3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/fonts/fontawesome-webfont.ttf?v=4.0.3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/fonts/fontawesome-webfont.svg?v=4.0.3", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___, { hash: "?#iefix&v=4.0.3" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "#fontawesomeregular" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-anonimus {
  margin: 0px 10px !important;
}
.container2 {
  margin-right: auto;
  margin-left: auto;
  padding-left: 5px;
  padding-right: 5px;
}
.container2:before,
.container2:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.container2:after {
  clear: both;
}
.container2:before,
.container2:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.container2:after {
  clear: both;
}
/*! normalize.css v2.1.3 | MIT License | git.io/normalize */
*:focus,
*:active {
  outline: transparent !important;
  outline: none !important;
  -moz-outline-style: none !important;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
video {
  display: inline-block;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
html {
  font-family: Roboto;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
a {
  background: transparent;
}
a:focus {
  outline: thin dotted;
}
a:active,
a:hover {
  outline: 0;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
abbr[title] {
  border-bottom: 1px dotted;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}
mark {
  background: #ff0;
  color: #000;
}
code,
kbd,
pre,
samp {
  font-family: Roboto;
  font-size: 1em;
}
pre {
  white-space: pre-wrap;
}
q {
  quotes: "\\201C" "\\201D" "\\2018" "\\2019";
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 0;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
button,
input,
select,
textarea {
  font-family: Roboto;
  font-size: 100%;
  margin: 0;
}
textarea {
  resize: none !important;
}
button,
input {
  line-height: normal;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
  vertical-align: top;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
@media print {
  * {
    text-shadow: none !important;
    color: #000 !important;
    background: transparent !important;
    box-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  a[href^="javascript:"]:after,
  a[href^="#"]:after {
    content: "";
  }
  pre,
  blockquote {
    border: 1px solid #999999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  img {
    max-width: 100% !important;
  }
  @page {
    margin: 2cm 0.5cm;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  select {
    background: #FFF !important;
  }
  .navbar {
    display: none;
  }
  .table td,
  .table th {
    background-color: #FFF !important;
  }
  .btn > .caret,
  .dropup > .btn > .caret {
    border-top-color: #000 !important;
  }
  .label {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #DDD !important;
  }
}
*,
*:before,
*:after {
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  font-size: 62.5%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  font-family: Roboto;
  font-size: 14px;
  line-height: 1.42857143;
  color: #FFF;
  background-color: #121212;
}
input,
button,
select,
textarea {
  font-family: Roboto;
  font-size: inherit;
  line-height: inherit;
}
a {
  color: #999999;
  text-decoration: none;
}
a:hover,
a:focus {
  color: #737373;
  text-decoration: underline;
}
a:focus {
  outline: thin dotted #333333;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
img {
  vertical-align: middle;
}
.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
.img-rounded {
  border-radius: 6px;
}
.img-thumbnail {
  padding: 4px;
  line-height: 1.42857143;
  background-color: #121212;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transition: all all 0.2s ease-in-out ease-out;
  -moz-transition: all all 0.2s ease-in-out ease-out;
  -o-transition: all all 0.2s ease-in-out ease-out;
  transition: all all 0.2s ease-in-out ease-out;
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.img-circle {
  border-radius: 50%;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #232323;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.item-format {
  padding: 0;
  line-height: 1.3;
}
.title-fox--div {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: -webkit-linear-gradient(bottom, black, transparent);
  background: -moz-linear-gradient(bottom, black, transparent);
  background: -o-linear-background(bottom, black, transparent);
  background: -ms-linear-gradient(bottom, black, transparent);
}
.title-fox--p {
  margin-left: 10px;
  word-wrap: break-word;
}
@media (max-width: 768px) {
  .title-fox--p {
    text-overflow: ellipsis;
    /* Required for text-overflow to do anything */
    white-space: nowrap;
    overflow: hidden;
  }
}
p {
  margin: 0 0 10px;
}
.lead {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 200;
  line-height: 1.4;
}
@media (min-width: 768px) {
  .lead {
    font-size: 21px;
  }
}
small,
.small {
  font-size: 85%;
}
cite {
  font-style: normal;
}
.text-muted {
  color: #999999;
}
.text-primary {
  color: #FFF;
}
.text-primary:hover {
  color: #e6e6e6;
}
.text-warning {
  color: #c09853;
}
.text-warning:hover {
  color: #a47e3c;
}
.text-danger {
  color: #6D6D6D;
}
.text-danger:hover {
  color: #535353;
}
.text-success {
  color: #468847;
}
.text-success:hover {
  color: #356635;
}
.text-info {
  color: #3a87ad;
}
.text-info:hover {
  color: #2d6987;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small,
.h1 small,
.h2 small,
.h3 small,
.h4 small,
.h5 small,
.h6 small,
h1 .small,
h2 .small,
h3 .small,
h4 .small,
h5 .small,
h6 .small,
.h1 .small,
.h2 .small,
.h3 .small,
.h4 .small,
.h5 .small,
.h6 .small {
  font-weight: normal;
  line-height: 1;
  color: #999999;
}
h1,
h2,
h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}
h1 small,
h2 small,
h3 small,
h1 .small,
h2 .small,
h3 .small {
  font-size: 65%;
}
h4,
h5,
h6 {
  margin-top: 10px;
  margin-bottom: 10px;
}
h4 small,
h5 small,
h6 small,
h4 .small,
h5 .small,
h6 .small {
  font-size: 75%;
}
h1,
.h1 {
  font-size: 36px;
}
h2,
.h2 {
  font-size: 30px;
}
h3,
.h3 {
  font-size: 24px;
}
h4,
.h4 {
  font-size: 18px;
}
h5,
.h5 {
  font-size: 14px;
}
h6,
.h6 {
  font-size: 12px;
}
.page-header {
  padding-bottom: 9px;
  margin: 40px 0 20px;
  border-bottom: 1px solid #eeeeee;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
}
ul ul,
ol ul,
ul ol,
ol ol {
  margin-bottom: 0;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.list-inline {
  padding-left: 0;
  list-style: none;
}
.list-inline > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}
.list-inline > li:first-child {
  padding-left: 0;
}
dl {
  margin-bottom: 20px;
}
dt,
dd {
  line-height: 1.42857143;
}
dt {
  font-weight: bold;
}
dd {
  margin-left: 0;
}
@media (min-width: 768px) {
  .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dl-horizontal dd {
    margin-left: 180px;
  }
  .dl-horizontal dd:before,
  .dl-horizontal dd:after {
    content: " ";
    /* 1 */
    display: table;
    /* 2 */
  }
  .dl-horizontal dd:after {
    clear: both;
  }
  .dl-horizontal dd:before,
  .dl-horizontal dd:after {
    content: " ";
    /* 1 */
    display: table;
    /* 2 */
  }
  .dl-horizontal dd:after {
    clear: both;
  }
}
abbr[title],
abbr[data-original-title] {
  cursor: help;
  border-bottom: 1px dotted #999999;
}
abbr.initialism {
  font-size: 90%;
  text-transform: uppercase;
}
blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  border-left: 5px solid #eeeeee;
}
blockquote p {
  font-size: 17.5px;
  font-weight: 300;
  line-height: 1.25;
}
blockquote p:last-child {
  margin-bottom: 0;
}
blockquote small {
  display: block;
  line-height: 1.42857143;
  color: #999999;
}
blockquote small:before {
  content: '\\2014 \\00A0';
}
blockquote.pull-right {
  padding-right: 15px;
  padding-left: 0;
  border-right: 5px solid #eeeeee;
  border-left: 0;
}
blockquote.pull-right p,
blockquote.pull-right small,
blockquote.pull-right .small {
  text-align: right;
}
blockquote.pull-right small:before,
blockquote.pull-right .small:before {
  content: '';
}
blockquote.pull-right small:after,
blockquote.pull-right .small:after {
  content: '\\00A0 \\2014';
}
blockquote:before,
blockquote:after {
  content: "";
}
address {
  margin-bottom: 20px;
  font-style: normal;
  line-height: 1.42857143;
}
code,
kbd,
pre,
samp {
  font-family: Roboto;
}
code {
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  white-space: nowrap;
  border-radius: 4px;
}
pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  word-break: break-all;
  word-wrap: break-word;
  color: #333333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}
pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}
.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}
.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 5px;
  padding-right: 5px;
}
.container:before,
.container:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.container:after {
  clear: both;
}
.container:before,
.container:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.container:after {
  clear: both;
}
.row {
  margin-left: -5px;
  margin-right: -5px;
}
.row:before,
.row:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.row:after {
  clear: both;
}
.row:before,
.row:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.row:after {
  clear: both;
}
.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-left: 5px;
  padding-right: 5px;
}
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11 {
  float: left;
}
.col-xs-12 {
  width: 100%;
}
.col-xs-11 {
  width: 91.66666667%;
}
.col-xs-10 {
  width: 83.33333333%;
}
.col-xs-9 {
  width: 75%;
}
.col-xs-8 {
  width: 66.66666667%;
}
.col-xs-7 {
  width: 58.33333333%;
}
.col-xs-6 {
  width: 50%;
}
.col-xs-5 {
  width: 41.66666667%;
}
.col-xs-4 {
  width: 33.33333333%;
}
.col-xs-3 {
  width: 25%;
}
.col-xs-2 {
  width: 16.66666667%;
}
.col-xs-1 {
  width: 8.33333333%;
}
.col-xs-pull-12 {
  right: 100%;
}
.col-xs-pull-11 {
  right: 91.66666667%;
}
.col-xs-pull-10 {
  right: 83.33333333%;
}
.col-xs-pull-9 {
  right: 75%;
}
.col-xs-pull-8 {
  right: 66.66666667%;
}
.col-xs-pull-7 {
  right: 58.33333333%;
}
.col-xs-pull-6 {
  right: 50%;
}
.col-xs-pull-5 {
  right: 41.66666667%;
}
.col-xs-pull-4 {
  right: 33.33333333%;
}
.col-xs-pull-3 {
  right: 25%;
}
.col-xs-pull-2 {
  right: 16.66666667%;
}
.col-xs-pull-1 {
  right: 8.33333333%;
}
.col-xs-pull-0 {
  right: 0%;
}
.col-xs-push-12 {
  left: 100%;
}
.col-xs-push-11 {
  left: 91.66666667%;
}
.col-xs-push-10 {
  left: 83.33333333%;
}
.col-xs-push-9 {
  left: 75%;
}
.col-xs-push-8 {
  left: 66.66666667%;
}
.col-xs-push-7 {
  left: 58.33333333%;
}
.col-xs-push-6 {
  left: 50%;
}
.col-xs-push-5 {
  left: 41.66666667%;
}
.col-xs-push-4 {
  left: 33.33333333%;
}
.col-xs-push-3 {
  left: 25%;
}
.col-xs-push-2 {
  left: 16.66666667%;
}
.col-xs-push-1 {
  left: 8.33333333%;
}
.col-xs-push-0 {
  left: 0%;
}
.col-xs-offset-12 {
  margin-left: 100%;
}
.col-xs-offset-11 {
  margin-left: 91.66666667%;
}
.col-xs-offset-10 {
  margin-left: 83.33333333%;
}
.col-xs-offset-9 {
  margin-left: 75%;
}
.col-xs-offset-8 {
  margin-left: 66.66666667%;
}
.col-xs-offset-7 {
  margin-left: 58.33333333%;
}
.col-xs-offset-6 {
  margin-left: 50%;
}
.col-xs-offset-5 {
  margin-left: 41.66666667%;
}
.col-xs-offset-4 {
  margin-left: 33.33333333%;
}
.col-xs-offset-3 {
  margin-left: 25%;
}
.col-xs-offset-2 {
  margin-left: 16.66666667%;
}
.col-xs-offset-1 {
  margin-left: 8.33333333%;
}
.col-xs-offset-0 {
  margin-left: 0%;
}
@media (min-width: 768px) {
  .container {
    width: 730px;
  }
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11 {
    float: left;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-11 {
    width: 91.66666667%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-8 {
    width: 66.66666667%;
  }
  .col-sm-7 {
    width: 58.33333333%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-5 {
    width: 41.66666667%;
  }
  .col-sm-4 {
    width: 33.33333333%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-2 {
    width: 16.66666667%;
  }
  .col-sm-1 {
    width: 8.33333333%;
  }
  .col-sm-pull-12 {
    right: 100%;
  }
  .col-sm-pull-11 {
    right: 91.66666667%;
  }
  .col-sm-pull-10 {
    right: 83.33333333%;
  }
  .col-sm-pull-9 {
    right: 75%;
  }
  .col-sm-pull-8 {
    right: 66.66666667%;
  }
  .col-sm-pull-7 {
    right: 58.33333333%;
  }
  .col-sm-pull-6 {
    right: 50%;
  }
  .col-sm-pull-5 {
    right: 41.66666667%;
  }
  .col-sm-pull-4 {
    right: 33.33333333%;
  }
  .col-sm-pull-3 {
    right: 25%;
  }
  .col-sm-pull-2 {
    right: 16.66666667%;
  }
  .col-sm-pull-1 {
    right: 8.33333333%;
  }
  .col-sm-pull-0 {
    right: 0%;
  }
  .col-sm-push-12 {
    left: 100%;
  }
  .col-sm-push-11 {
    left: 91.66666667%;
  }
  .col-sm-push-10 {
    left: 83.33333333%;
  }
  .col-sm-push-9 {
    left: 75%;
  }
  .col-sm-push-8 {
    left: 66.66666667%;
  }
  .col-sm-push-7 {
    left: 58.33333333%;
  }
  .col-sm-push-6 {
    left: 50%;
  }
  .col-sm-push-5 {
    left: 41.66666667%;
  }
  .col-sm-push-4 {
    left: 33.33333333%;
  }
  .col-sm-push-3 {
    left: 25%;
  }
  .col-sm-push-2 {
    left: 16.66666667%;
  }
  .col-sm-push-1 {
    left: 8.33333333%;
  }
  .col-sm-push-0 {
    left: 0%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-sm-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 992px) {
  .container {
    width: 950px;
  }
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11 {
    float: left;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-11 {
    width: 91.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-8 {
    width: 66.66666667%;
  }
  .col-md-7 {
    width: 58.33333333%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-5 {
    width: 41.66666667%;
  }
  .col-md-4 {
    width: 33.33333333%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-1 {
    width: 8.33333333%;
  }
  .col-md-pull-12 {
    right: 100%;
  }
  .col-md-pull-11 {
    right: 91.66666667%;
  }
  .col-md-pull-10 {
    right: 83.33333333%;
  }
  .col-md-pull-9 {
    right: 75%;
  }
  .col-md-pull-8 {
    right: 66.66666667%;
  }
  .col-md-pull-7 {
    right: 58.33333333%;
  }
  .col-md-pull-6 {
    right: 50%;
  }
  .col-md-pull-5 {
    right: 41.66666667%;
  }
  .col-md-pull-4 {
    right: 33.33333333%;
  }
  .col-md-pull-3 {
    right: 25%;
  }
  .col-md-pull-2 {
    right: 16.66666667%;
  }
  .col-md-pull-1 {
    right: 8.33333333%;
  }
  .col-md-pull-0 {
    right: 0%;
  }
  .col-md-push-12 {
    left: 100%;
  }
  .col-md-push-11 {
    left: 91.66666667%;
  }
  .col-md-push-10 {
    left: 83.33333333%;
  }
  .col-md-push-9 {
    left: 75%;
  }
  .col-md-push-8 {
    left: 66.66666667%;
  }
  .col-md-push-7 {
    left: 58.33333333%;
  }
  .col-md-push-6 {
    left: 50%;
  }
  .col-md-push-5 {
    left: 41.66666667%;
  }
  .col-md-push-4 {
    left: 33.33333333%;
  }
  .col-md-push-3 {
    left: 25%;
  }
  .col-md-push-2 {
    left: 16.66666667%;
  }
  .col-md-push-1 {
    left: 8.33333333%;
  }
  .col-md-push-0 {
    left: 0%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
  .col-md-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-md-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-md-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-md-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-md-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-md-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1150px;
  }
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11 {
    float: left;
  }
  .col-lg-12 {
    width: 100%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
  .col-lg-10 {
    width: 83.33333333%;
  }
  .col-lg-9 {
    width: 75%;
  }
  .col-lg-8 {
    width: 66.66666667%;
  }
  .col-lg-7 {
    width: 58.33333333%;
  }
  .col-lg-6 {
    width: 50%;
  }
  .col-lg-5 {
    width: 41.66666667%;
  }
  .col-lg-4 {
    width: 33.33333333%;
  }
  .col-lg-3 {
    width: 25%;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-1 {
    width: 8.33333333%;
  }
  .col-lg-pull-12 {
    right: 100%;
  }
  .col-lg-pull-11 {
    right: 91.66666667%;
  }
  .col-lg-pull-10 {
    right: 83.33333333%;
  }
  .col-lg-pull-9 {
    right: 75%;
  }
  .col-lg-pull-8 {
    right: 66.66666667%;
  }
  .col-lg-pull-7 {
    right: 58.33333333%;
  }
  .col-lg-pull-6 {
    right: 50%;
  }
  .col-lg-pull-5 {
    right: 41.66666667%;
  }
  .col-lg-pull-4 {
    right: 33.33333333%;
  }
  .col-lg-pull-3 {
    right: 25%;
  }
  .col-lg-pull-2 {
    right: 16.66666667%;
  }
  .col-lg-pull-1 {
    right: 8.33333333%;
  }
  .col-lg-pull-0 {
    right: 0%;
  }
  .col-lg-push-12 {
    left: 100%;
  }
  .col-lg-push-11 {
    left: 91.66666667%;
  }
  .col-lg-push-10 {
    left: 83.33333333%;
  }
  .col-lg-push-9 {
    left: 75%;
  }
  .col-lg-push-8 {
    left: 66.66666667%;
  }
  .col-lg-push-7 {
    left: 58.33333333%;
  }
  .col-lg-push-6 {
    left: 50%;
  }
  .col-lg-push-5 {
    left: 41.66666667%;
  }
  .col-lg-push-4 {
    left: 33.33333333%;
  }
  .col-lg-push-3 {
    left: 25%;
  }
  .col-lg-push-2 {
    left: 16.66666667%;
  }
  .col-lg-push-1 {
    left: 8.33333333%;
  }
  .col-lg-push-0 {
    left: 0%;
  }
  .col-lg-offset-12 {
    margin-left: 100%;
  }
  .col-lg-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-lg-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-lg-offset-9 {
    margin-left: 75%;
  }
  .col-lg-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-lg-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-lg-offset-6 {
    margin-left: 50%;
  }
  .col-lg-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-lg-offset-3 {
    margin-left: 25%;
  }
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-lg-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-lg-offset-0 {
    margin-left: 0%;
  }
}
table {
  max-width: 100%;
  background-color: transparent;
}
th {
  text-align: left;
}
.table {
  width: 100%;
  margin-bottom: 20px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
}
.table > tbody + tbody {
  border-top: 2px solid #ddd;
}
.table .table {
  background-color: #121212;
}
.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}
.table-bordered {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover > td,
.table-hover > tbody > tr:hover > th {
  background-color: #f5f5f5;
}
table col[class*="col-"] {
  float: none;
  display: table-column;
}
table td[class*="col-"],
table th[class*="col-"] {
  float: none;
  display: table-cell;
}
.table > thead > tr > td.active,
.table > tbody > tr > td.active,
.table > tfoot > tr > td.active,
.table > thead > tr > th.active,
.table > tbody > tr > th.active,
.table > tfoot > tr > th.active,
.table > thead > tr.active > td,
.table > tbody > tr.active > td,
.table > tfoot > tr.active > td,
.table > thead > tr.active > th,
.table > tbody > tr.active > th,
.table > tfoot > tr.active > th {
  background-color: #f5f5f5;
}
.table > thead > tr > td.success,
.table > tbody > tr > td.success,
.table > tfoot > tr > td.success,
.table > thead > tr > th.success,
.table > tbody > tr > th.success,
.table > tfoot > tr > th.success,
.table > thead > tr.success > td,
.table > tbody > tr.success > td,
.table > tfoot > tr.success > td,
.table > thead > tr.success > th,
.table > tbody > tr.success > th,
.table > tfoot > tr.success > th {
  background-color: #dff0d8;
}
.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6;
}
.table > thead > tr > td.danger,
.table > tbody > tr > td.danger,
.table > tfoot > tr > td.danger,
.table > thead > tr > th.danger,
.table > tbody > tr > th.danger,
.table > tfoot > tr > th.danger,
.table > thead > tr.danger > td,
.table > tbody > tr.danger > td,
.table > tfoot > tr.danger > td,
.table > thead > tr.danger > th,
.table > tbody > tr.danger > th,
.table > tfoot > tr.danger > th {
  background-color: #f2dede;
}
.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc;
}
.table > thead > tr > td.warning,
.table > tbody > tr > td.warning,
.table > tfoot > tr > td.warning,
.table > thead > tr > th.warning,
.table > tbody > tr > th.warning,
.table > tfoot > tr > th.warning,
.table > thead > tr.warning > td,
.table > tbody > tr.warning > td,
.table > tfoot > tr.warning > td,
.table > thead > tr.warning > th,
.table > tbody > tr.warning > th,
.table > tfoot > tr.warning > th {
  background-color: #fcf8e3;
}
.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc;
}
@media (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    overflow-x: scroll;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive > .table {
    margin-bottom: 0;
  }
  .table-responsive > .table > thead > tr > th,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > tfoot > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive > .table-bordered {
    border: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:first-child,
  .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive > .table-bordered > thead > tr > td:first-child,
  .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:last-child,
  .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive > .table-bordered > thead > tr > td:last-child,
  .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .table-responsive > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
fieldset {
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
  font-size: 21px;
  line-height: inherit;
  color: #333333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
label {
  display: inline-block;
  margin-bottom: 5px;
  font-weight: bold;
}
input[type="search"] {
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  /* IE8-9 */
  line-height: normal;
}
input[type="file"] {
  display: block;
}
select[multiple],
select[size] {
  height: auto;
}
select optgroup {
  font-size: inherit;
  font-style: inherit;
  font-family: Roboto;
}
input[type="file"]:focus,
input[type="radio"]:focus,
input[type="checkbox"]:focus {
  outline: thin dotted #333333;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  height: auto;
}
output {
  display: block;
  padding-top: 7px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #1E1E1E;
  vertical-align: middle;
}
.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #1E1E1E;
  vertical-align: middle;
  background-color: rgba(35, 35, 35, 0.8);
  background-image: none;
  border: 1px solid #666666;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  -webkit-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;
  -moz-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;
  -o-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;
  transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;
}
.form-control:focus {
  border-color: #66afe9;
  outline: 0;
}
.form-control:-moz-placeholder {
  color: #6D6D6D;
}
.form-control::-moz-placeholder {
  color: #6D6D6D;
}
.form-control:-ms-input-placeholder {
  color: #6D6D6D;
}
.form-control::-webkit-input-placeholder {
  color: #6D6D6D;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  cursor: not-allowed;
  background-color: #333333;
}
textarea.form-control {
  height: auto;
}
.form-group {
  margin-bottom: 15px;
}
.radio,
.checkbox {
  display: block;
  min-height: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  vertical-align: middle;
}
.radio label,
.checkbox label {
  display: inline;
  margin-bottom: 0;
  font-weight: normal;
  cursor: pointer;
}
.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  float: left;
  margin-left: -20px;
}
.radio + .radio,
.checkbox + .checkbox {
  margin-top: -5px;
}
.radio-inline,
.checkbox-inline {
  display: inline-block;
  padding-left: 23px;
  margin-bottom: 0;
  vertical-align: middle;
  font-weight: normal;
  cursor: pointer;
}
.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
}
input[type="radio"][disabled],
input[type="checkbox"][disabled],
.radio[disabled],
.radio-inline[disabled],
.checkbox[disabled],
.checkbox-inline[disabled],
fieldset[disabled] input[type="radio"],
fieldset[disabled] input[type="checkbox"],
fieldset[disabled] .radio,
fieldset[disabled] .radio-inline,
fieldset[disabled] .checkbox,
fieldset[disabled] .checkbox-inline {
  cursor: not-allowed;
}
.input-sm {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px;
}
select.input-sm {
  height: 30px;
  line-height: 30px;
}
textarea.input-sm {
  height: auto;
}
.input-lg {
  height: 45px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
}
select.input-lg {
  height: 45px;
  line-height: 45px;
}
textarea.input-lg {
  height: auto;
}
.has-warning .help-block,
.has-warning .control-label,
.has-warning .radio,
.has-warning .checkbox,
.has-warning .radio-inline,
.has-warning .checkbox-inline {
  color: #c09853;
}
.has-warning .form-control {
  border-color: #fcf8e3;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-warning .form-control:focus {
  border-color: #f7ecb5;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
}
.has-warning .input-group-addon {
  color: #c09853;
  border-color: #fcf8e3;
  background-color: #f5f5f5;
}
.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline {
  color: #6D6D6D;
}
.has-error .form-control {
  border-color: #f2dede;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-error .form-control:focus {
  border-color: #e4b9b9;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
}
.has-error .input-group-addon {
  color: #6D6D6D;
  border-color: #f2dede;
  background-color: #f5f5f5;
}
.has-success .help-block,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline {
  color: #468847;
}
.has-success .form-control {
  border-color: #dff0d8;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-success .form-control:focus {
  border-color: #c1e2b3;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
}
.has-success .input-group-addon {
  color: #468847;
  border-color: #dff0d8;
  background-color: #f5f5f5;
}
.form-control-static {
  margin-bottom: 0;
}
.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #ffffff;
  font-style: italic;
  font-size: 12px;
}
@media (min-width: 768px) {
  .form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .form-control {
    display: inline-block;
  }
  .form-inline .radio,
  .form-inline .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
  }
  .form-inline .radio input[type="radio"],
  .form-inline .checkbox input[type="checkbox"] {
    float: none;
    margin-left: 0;
  }
}
.form-horizontal .control-label,
.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 7px;
}
.form-horizontal .form-group {
  margin-left: -5px;
  margin-right: -5px;
}
.form-horizontal .form-group:before,
.form-horizontal .form-group:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.form-horizontal .form-group:after {
  clear: both;
}
.form-horizontal .form-group:before,
.form-horizontal .form-group:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.form-horizontal .form-group:after {
  clear: both;
}
.form-horizontal .form-control-static {
  padding-top: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
@media (min-width: 768px) {
  .form-horizontal .control-label {
    text-align: right;
  }
}
.btn,
.nav li a.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  -o-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.btn:focus,
.nav li a.btn:focus {
  outline: thin dotted #333333;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.btn:hover,
.nav li a.btn:hover,
.btn:focus,
.nav li a.btn:focus {
  color: #FFF;
  text-decoration: none;
}
.btn:active,
.nav li a.btn:active,
.btn.active,
.nav li a.btn.active {
  outline: 0;
  background-image: none;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn.disabled,
.nav li a.btn.disabled,
.btn[disabled],
.nav li a.btn[disabled],
fieldset[disabled] .btn,
fieldset[disabled] .nav li a.btn {
  cursor: not-allowed;
  pointer-events: none;
  -moz-opacity: 0.65;
  -khtml-opacity: 0.65;
  -webkit-opacity: 0.65;
  opacity: 0.65;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=65);
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  color: white!important;
}
.nav li a.btn-default {
  color: #FFF;
  background-color: transparent;
  border-color: #f1f1f1;
}
.nav li a.btn-default:hover,
.nav li a.btn-default:focus,
.nav li a.btn-default:active,
.nav li a.btn-default.active,
.open .dropdown-toggle.nav li a.btn-default {
  color: #FFF;
  background-color: rgba(0, 0, 0, 0);
  border-color: #d2d2d2;
}
.nav li a.btn-default:active,
.nav li a.btn-default.active,
.open .dropdown-toggle.nav li a.btn-default {
  background-image: none;
}
.nav li a.btn-default.disabled,
.nav li a.btn-default[disabled],
fieldset[disabled] .nav li a.btn-default,
.nav li a.btn-default.disabled:hover,
.nav li a.btn-default[disabled]:hover,
fieldset[disabled] .nav li a.btn-default:hover,
.nav li a.btn-default.disabled:focus,
.nav li a.btn-default[disabled]:focus,
fieldset[disabled] .nav li a.btn-default:focus,
.nav li a.btn-default.disabled:active,
.nav li a.btn-default[disabled]:active,
fieldset[disabled] .nav li a.btn-default:active,
.nav li a.btn-default.disabled.active,
.nav li a.btn-default[disabled].active,
fieldset[disabled] .nav li a.btn-default.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.nav li a.btn-default:hover,
.nav li a.btn-default:focus,
.nav li a.btn-default:active,
.nav li a.btn-default.active,
.open .dropdown-toggle.nav li a.btn-default {
  color: #FFF;
  background-color: rgba(0, 0, 0, 0);
  border-color: #989898;
}
.btn-default {
  color: #FFF;
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #f1f1f1;
}
.btn-default:hover,
.btn-default:focus,
.btn-default:active,
.btn-default.active,
.open .dropdown-toggle.btn-default {
  color: #FFF;
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #d2d2d2;
}
.btn-default:active,
.btn-default.active,
.open .dropdown-toggle.btn-default {
  background-image: none;
}
.btn-default.disabled,
.btn-default[disabled],
fieldset[disabled] .btn-default,
.btn-default.disabled:hover,
.btn-default[disabled]:hover,
fieldset[disabled] .btn-default:hover,
.btn-default.disabled:focus,
.btn-default[disabled]:focus,
fieldset[disabled] .btn-default:focus,
.btn-default.disabled:active,
.btn-default[disabled]:active,
fieldset[disabled] .btn-default:active,
.btn-default.disabled.active,
.btn-default[disabled].active,
fieldset[disabled] .btn-default.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-default:hover,
.btn-default:focus,
.btn-default:active,
.btn-default.active,
.open .dropdown-toggle.btn-default {
  color: #FFF;
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #989898;
}
.btn-primary {
  color: #0c0c0c;
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  color: #0c0c0c;
  background-color: #dddddd;
  border-color: #d2d2d2;
}
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  background-image: none;
}
.btn-primary.disabled,
.btn-primary[disabled],
fieldset[disabled] .btn-primary,
.btn-primary.disabled:hover,
.btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary:hover,
.btn-primary.disabled:focus,
.btn-primary[disabled]:focus,
fieldset[disabled] .btn-primary:focus,
.btn-primary.disabled:active,
.btn-primary[disabled]:active,
fieldset[disabled] .btn-primary:active,
.btn-primary.disabled.active,
.btn-primary[disabled].active,
fieldset[disabled] .btn-primary.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  color: #0c0c0c;
  background-color: #a4a4a4;
  border-color: #989898;
}
.btn-warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
  color: #fff;
  background-color: #ed9c28;
  border-color: #d58512;
}
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
  background-image: none;
}
.btn-warning.disabled,
.btn-warning[disabled],
fieldset[disabled] .btn-warning,
.btn-warning.disabled:hover,
.btn-warning[disabled]:hover,
fieldset[disabled] .btn-warning:hover,
.btn-warning.disabled:focus,
.btn-warning[disabled]:focus,
fieldset[disabled] .btn-warning:focus,
.btn-warning.disabled:active,
.btn-warning[disabled]:active,
fieldset[disabled] .btn-warning:active,
.btn-warning.disabled.active,
.btn-warning[disabled].active,
fieldset[disabled] .btn-warning.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active,
.open .dropdown-toggle.btn-warning {
  color: #fff;
  background-color: #985f0d;
  border-color: #694109;
}
.btn-danger {
  color: #fff;
  background-color: #FFF;
  border-color: #f2f2f2;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  color: #fff;
  background-color: #ebebeb;
  border-color: #d4d4d4;
}
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  background-image: none;
}
.btn-danger.disabled,
.btn-danger[disabled],
fieldset[disabled] .btn-danger,
.btn-danger.disabled:hover,
.btn-danger[disabled]:hover,
fieldset[disabled] .btn-danger:hover,
.btn-danger.disabled:focus,
.btn-danger[disabled]:focus,
fieldset[disabled] .btn-danger:focus,
.btn-danger.disabled:active,
.btn-danger[disabled]:active,
fieldset[disabled] .btn-danger:active,
.btn-danger.disabled.active,
.btn-danger[disabled].active,
fieldset[disabled] .btn-danger.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active,
.open .dropdown-toggle.btn-danger {
  color: #fff;
  background-color: #b3b3b3;
  border-color: #999999;
}
.btn-success {
  color: #fff;
  background-color: #FFF;
  border-color: #f2f2f2;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  color: #fff;
  background-color: #ebebeb;
  border-color: #d4d4d4;
}
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  background-image: none;
}
.btn-success.disabled,
.btn-success[disabled],
fieldset[disabled] .btn-success,
.btn-success.disabled:hover,
.btn-success[disabled]:hover,
fieldset[disabled] .btn-success:hover,
.btn-success.disabled:focus,
.btn-success[disabled]:focus,
fieldset[disabled] .btn-success:focus,
.btn-success.disabled:active,
.btn-success[disabled]:active,
fieldset[disabled] .btn-success:active,
.btn-success.disabled.active,
.btn-success[disabled].active,
fieldset[disabled] .btn-success.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active,
.open .dropdown-toggle.btn-success {
  color: #fff;
  background-color: #b3b3b3;
  border-color: #999999;
}
.btn-info {
  color: #fff;
  background-color: #999999;
  border-color: #8c8c8c;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  color: #fff;
  background-color: #858585;
  border-color: #6e6e6e;
}
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  background-image: none;
}
.btn-info.disabled,
.btn-info[disabled],
fieldset[disabled] .btn-info,
.btn-info.disabled:hover,
.btn-info[disabled]:hover,
fieldset[disabled] .btn-info:hover,
.btn-info.disabled:focus,
.btn-info[disabled]:focus,
fieldset[disabled] .btn-info:focus,
.btn-info.disabled:active,
.btn-info[disabled]:active,
fieldset[disabled] .btn-info:active,
.btn-info.disabled.active,
.btn-info[disabled].active,
fieldset[disabled] .btn-info.active {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #FFFFFF;
}
.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active,
.open .dropdown-toggle.btn-info {
  color: #fff;
  background-color: #4d4d4d;
  border-color: #333333;
}
.btn-link {
  color: #999999;
  font-weight: normal;
  cursor: pointer;
  border-radius: 0;
}
.btn-link,
.btn-link:active,
.btn-link[disabled],
fieldset[disabled] .btn-link {
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.btn-link,
.btn-link:hover,
.btn-link:focus,
.btn-link:active {
  border-color: transparent;
}
.btn-link:hover,
.btn-link:focus {
  color: #737373;
  text-decoration: underline;
  background-color: transparent;
}
.btn-link[disabled]:hover,
fieldset[disabled] .btn-link:hover,
.btn-link[disabled]:focus,
fieldset[disabled] .btn-link:focus {
  color: #999999;
  text-decoration: none;
}
.btn-lg {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 4px;
}
.btn-sm,
.btn-xs {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px;
}
.btn-xs {
  padding: 1px 5px;
}
.btn-block {
  display: block;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}
.btn-block + .btn-block {
  margin-top: 5px;
}
input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}
/* Object Button with states */
@keyframes button-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.o-button {
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  outline: none;
  border: 1px solid #f1f1f1;
  background: #f1f1f1 none;
  border-radius: 4px;
  color: #0c0c0c;
  font-family: Roboto;
  margin: 0em 0.25em 0em 0em;
  padding: 6px 12px;
  text-transform: none;
  text-shadow: none;
  line-height: 1.42857143;
  font-style: normal;
  text-align: center;
  text-decoration: none;
  user-select: none;
  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
  will-change: "";
}
.o-button:hover {
  background-color: #a4a4a4;
  border-color: #989898;
}
.o-button--right {
  float: right;
}
.o-button--fluid {
  display: block;
  width: 100%;
}
.o-button--basic {
  background: rgba(0, 0, 0, 0.2);
  border-color: #f1f1f1;
  color: #FFF;
}
.o-button--basic:hover {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: #989898;
}
.o-button--loading {
  position: relative;
  cursor: default;
  text-shadow: none !important;
  color: transparent !important;
  opacity: 1;
  pointer-events: none !important;
  transition: all 0s linear, opacity 0.1s ease;
}
.o-button--loading:before,
.o-button--loading:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.64285714em 0em 0em -0.64285714em;
  width: 1.28571429em;
  height: 1.28571429em;
  border-radius: 500rem;
}
.o-button--loading:before {
  border: 0.2em solid rgba(0, 0, 0, 0.15);
}
.o-button--loading:after {
  animation: button-spin 0.6s linear;
  animation-iteration-count: infinite;
  border-color: #ffffff transparent transparent;
  border-style: solid;
  border-width: 0.2em;
  box-shadow: 0px 0px 0px 1px transparent;
}
.o-button--disabled,
.o-button--disabled:hover {
  cursor: default;
  opacity: 0.75 !important;
  background-image: none !important;
  box-shadow: none !important;
  pointer-events: none !important;
}
.o-button--touchable:hover {
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}
/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
  -webkit-transition: all opacity 0.15s linear ease-out;
  -moz-transition: all opacity 0.15s linear ease-out;
  -o-transition: all opacity 0.15s linear ease-out;
  transition: all opacity 0.15s linear ease-out;
}
.fade.in {
  opacity: 1;
}
.collapse {
  display: none;
}
.collapse.in {
  display: block;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  -webkit-transition: height 0.35s ease;
  transition: height 0.35s ease;
  -webkit-transition: all height 0.35s ease ease-out;
  -moz-transition: all height 0.35s ease ease-out;
  -o-transition: all height 0.35s ease ease-out;
  transition: all height 0.35s ease ease-out;
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 10px;
  vertical-align: middle;
  border-top: 7px solid #000;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  border-bottom: 0 dotted;
}
.dropdown {
  position: relative;
}
.dropdown-toggle:focus {
  outline: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: -60px;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 0;
  list-style: none;
  font-size: 14px;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}
.dropdown-menu.pull-right {
  right: 0;
  left: auto;
}
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.dropdown-menu > li > a {
  display: block;
  padding: 0 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.42857143;
  color: #333333;
  white-space: nowrap;
}
.dropdown-menu > .active > a,
.dropdown-menu > .active > a:hover,
.dropdown-menu > .active > a:focus {
  color: #737373;
  text-decoration: none;
  outline: 0;
  background-color: #FFF;
}
.dropdown-menu > .disabled > a,
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  color: #999999;
}
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  text-decoration: none;
  background-color: transparent;
  background-image: none;
  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
  cursor: not-allowed;
}
.open > .dropdown-menu {
  display: block;
}
.open > a {
  outline: 0;
}
.dropdown-header {
  display: block;
  padding: 3px 20px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #999999;
}
.dropdown-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 990;
}
.pull-right > .dropdown-menu {
  right: 0;
  left: auto;
}
.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  border-top: 0 dotted;
  border-bottom: 4px solid #000;
  content: "";
}
.dropup .dropdown-menu,
.navbar-fixed-bottom .dropdown .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 1px;
}
@media (min-width: 768px) {
  .navbar-right .dropdown-menu {
    right: 0;
    left: auto;
  }
}
@media screen and (max-width: 917px) {
  .dropdown-menu {
    right: -16px;
    left: auto;
    overflow: auto;
  }
}
.btn-default .caret {
  border-top-color: #FFF;
}
.btn-primary .caret,
.btn-success .caret,
.btn-warning .caret,
.btn-danger .caret,
.btn-info .caret {
  border-top-color: #fff;
}
.dropup .btn-default .caret {
  border-bottom-color: #FFF;
}
.dropup .btn-primary .caret,
.dropup .btn-success .caret,
.dropup .btn-warning .caret,
.dropup .btn-danger .caret,
.dropup .btn-info .caret {
  border-bottom-color: #fff;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  float: left;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover,
.btn-group > .btn:focus,
.btn-group-vertical > .btn:focus,
.btn-group > .btn:active,
.btn-group-vertical > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn.active {
  z-index: 2;
}
.btn-group > .btn:focus,
.btn-group-vertical > .btn:focus {
  outline: none;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px;
}
.btn-toolbar:before,
.btn-toolbar:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.btn-toolbar:after {
  clear: both;
}
.btn-toolbar:before,
.btn-toolbar:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.btn-toolbar:after {
  clear: both;
}
.btn-toolbar .btn-group {
  float: left;
}
.btn-toolbar > .btn + .btn,
.btn-toolbar > .btn-group + .btn,
.btn-toolbar > .btn + .btn-group,
.btn-toolbar > .btn-group + .btn-group {
  margin-left: 5px;
}
.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}
.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.btn-group > .btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.btn-group > .btn-group {
  float: left;
}
.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group > .btn-group:first-child > .btn:last-child,
.btn-group > .btn-group:first-child > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.btn-group > .btn-group:last-child > .btn:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.btn-group .dropdown-toggle:active,
.btn-group.open .dropdown-toggle {
  outline: 0;
}
.btn-group-xs > .btn {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px;
  padding: 1px 5px;
}
.btn-group-sm > .btn {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px;
}
.btn-group-lg > .btn {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 4px;
}
.btn-group > .btn + .dropdown-toggle {
  padding-left: 8px;
  padding-right: 8px;
}
.btn-group > .btn-lg + .dropdown-toggle {
  padding-left: 12px;
  padding-right: 12px;
}
.btn-group.open .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.open .dropdown-toggle.btn-link {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.btn .caret {
  margin-left: 0;
}
.btn-lg .caret {
  border-width: 5px 5px 0;
  border-bottom-width: 0;
}
.dropup .btn-lg .caret {
  border-width: 0 5px 5px;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
}
.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.btn-group-vertical > .btn-group:after {
  clear: both;
}
.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.btn-group-vertical > .btn-group:after {
  clear: both;
}
.btn-group-vertical > .btn-group > .btn {
  float: none;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .btn:first-child:not(:last-child) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:last-child:not(:first-child) {
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child > .btn:last-child,
.btn-group-vertical > .btn-group:first-child > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child > .btn:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.btn-group-justified .btn {
  float: none;
  display: table-cell;
  width: 1%;
}
[data-toggle="buttons"] > .btn > input[type="radio"],
[data-toggle="buttons"] > .btn > input[type="checkbox"] {
  display: none;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.input-group.col {
  float: none;
  padding-left: 0;
  padding-right: 0;
}
.input-group .form-control {
  width: 100%;
  margin-bottom: 0;
}
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 45px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
}
select.input-group-lg > .form-control,
select.input-group-lg > .input-group-addon,
select.input-group-lg > .input-group-btn > .btn {
  height: 45px;
  line-height: 45px;
}
textarea.input-group-lg > .form-control,
textarea.input-group-lg > .input-group-addon,
textarea.input-group-lg > .input-group-btn > .btn {
  height: auto;
}
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 2px;
}
select.input-group-sm > .form-control,
select.input-group-sm > .input-group-addon,
select.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  line-height: 30px;
}
textarea.input-group-sm > .form-control,
textarea.input-group-sm > .input-group-addon,
textarea.input-group-sm > .input-group-btn > .btn {
  height: auto;
}
.input-group-addon,
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}
.input-group-addon:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child),
.input-group .form-control:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.input-group-addon,
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1;
  color: #1E1E1E;
  text-align: center;
  background-color: #eeeeee;
  border: 1px solid #666666;
  border-left: none;
  border-radius: 4px;
}
.input-group-addon.input-sm {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 2px;
}
.input-group-addon.input-lg {
  padding: 10px 16px;
  font-size: 18px;
  border-radius: 6px;
}
.input-group-addon input[type="radio"],
.input-group-addon input[type="checkbox"] {
  margin-top: 0;
}
.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group-addon:first-child {
  border-right: 0;
}
.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.input-group-addon:last-child {
  border-left: 0;
}
.input-group-btn {
  position: relative;
  white-space: nowrap;
}
.input-group-btn:first-child > .btn {
  margin-right: -1px;
}
.input-group-btn:last-child > .btn {
  margin-left: -1px;
}
.input-group-btn > .btn {
  position: relative;
}
.input-group-btn > .btn + .btn {
  margin-left: -4px;
}
.input-group-btn > .btn:hover,
.input-group-btn > .btn:active {
  z-index: 2;
}
.nav {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  /*.open > a {
    &,
    &:hover,
    &:focus {
      background-color: @nav-link-hover-bg;
      border-color: @link-color;

      .caret {
        border-top-color: @link-hover-color;
        border-bottom-color: @link-hover-color;
      }
    }
  }*/
}
.nav:before,
.nav:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.nav:after {
  clear: both;
}
.nav:before,
.nav:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.nav:after {
  clear: both;
}
.nav > li {
  position: relative;
  display: block;
}
.nav > li > a {
  position: relative;
  display: block;
  padding: 7px 15px;
  font-family: "Roboto";
  font-size: 18px;
  font-weight: lighter;
}
.nav > li > a:hover,
.nav > li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.nav > li.disabled > a {
  color: #999999;
}
.nav > li.disabled > a:hover,
.nav > li.disabled > a:focus {
  color: #999999;
  text-decoration: none;
  background-color: transparent;
  cursor: not-allowed;
}
.nav .nav-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.nav > li > a > img {
  max-width: none;
}
.nav-tabs {
  border-bottom: 1px solid #ddd;
}
.nav-tabs > li {
  float: left;
  margin-bottom: -1px;
}
.nav-tabs > li > a {
  margin-right: 2px;
  line-height: 1.42857143;
  border: 1px solid transparent;
  border-radius: 4px 4px 0 0;
}
.nav-tabs > li > a:hover {
  border-color: #eeeeee #eeeeee #ddd;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  color: #555555;
  background-color: #121212;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
  cursor: default;
}
.nav-tabs.nav-justified {
  width: 100%;
  border-bottom: 0;
}
.nav-tabs.nav-justified > li {
  float: none;
}
.nav-tabs.nav-justified > li > a {
  text-align: center;
  margin-bottom: 5px;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-tabs.nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs.nav-justified > li > a {
  margin-right: 0;
  border-radius: 4px;
}
.nav-tabs.nav-justified > .active > a,
.nav-tabs.nav-justified > .active > a:hover,
.nav-tabs.nav-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }
  .nav-tabs.nav-justified > .active > a,
  .nav-tabs.nav-justified > .active > a:hover,
  .nav-tabs.nav-justified > .active > a:focus {
    border-bottom-color: #121212;
  }
}
.nav-pills > li {
  float: left;
}
.nav-pills > li > a {
  border-radius: 4px;
  font-size: 13px;
}
.nav-pills > li + li {
  margin-left: 2px;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
  color: #737373;
  background-color: #FFF;
}
.nav-pills > li.active > a .caret,
.nav-pills > li.active > a:hover .caret,
.nav-pills > li.active > a:focus .caret {
  border-top-color: #737373;
  border-bottom-color: #737373;
}
.nav-pills > li.active > a.btn:hover,
.nav-pills > li.active > a.btn:focus {
  /* background-color: #d01f14; */
  /* border-color: #be1c12;*/
}
.nav-stacked > li {
  float: none;
}
.nav-stacked > li + li {
  margin-top: 2px;
  margin-left: 0;
}
.nav-justified {
  width: 100%;
}
.nav-justified > li {
  float: none;
}
.nav-justified > li > a {
  text-align: center;
  margin-bottom: 5px;
}
.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs-justified {
  border-bottom: 0;
}
.nav-tabs-justified > li > a {
  margin-right: 0;
  border-radius: 4px;
}
.nav-tabs-justified > .active > a,
.nav-tabs-justified > .active > a:hover,
.nav-tabs-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }
  .nav-tabs-justified > .active > a,
  .nav-tabs-justified > .active > a:hover,
  .nav-tabs-justified > .active > a:focus {
    border-bottom-color: #121212;
  }
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.nav .caret {
  border-top-color: #999999;
  border-bottom-color: #999999;
}
.nav a:hover .caret {
  border-top-color: #737373;
  border-bottom-color: #737373;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
@media (min-width: 768px) {
  .nav .open > li > a.menu_user {
    background-color: transparent !important;
  }
}
.menu_user-on-hover > li > a,
.menu_user-on-hover > li > a:hover,
.menu_user-on-hover > li > a:focus {
  background-color: #333333;
}
@media (min-width: 768px) {
  .menu_user-on-hover > li > a,
  .menu_user-on-hover > li > a:hover,
  .menu_user-on-hover > li > a:focus {
    background-color: transparent;
  }
}
@media (max-width: 821px) {
  .buscar {
    width: 185px !important;
  }
}
.navbar {
  position: relative;
  min-height: 50px;
  border: 1px solid transparent;
}
.navbar:before,
.navbar:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar:after {
  clear: both;
}
.navbar:before,
.navbar:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar:after {
  clear: both;
}
@media (min-width: 768px) {
  .navbar {
    border-radius: 6px;
  }
}
.navbar-header:before,
.navbar-header:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar-header:after {
  clear: both;
}
.navbar-header:before,
.navbar-header:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar-header:after {
  clear: both;
}
@media (min-width: 768px) {
  .navbar-header {
    float: left;
  }
}
.navbar-collapse {
  overflow-x: visible;
  padding-right: 15px;
  padding-left: 15px;
  border-top: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  -webkit-overflow-scrolling: touch;
}
.navbar-collapse:before,
.navbar-collapse:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar-collapse:after {
  clear: both;
}
.navbar-collapse:before,
.navbar-collapse:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.navbar-collapse:after {
  clear: both;
}
.navbar-collapse.in {
  overflow-y: auto;
}
@media (min-width: 768px) {
  .navbar-collapse {
    width: auto;
    border-top: 0;
    box-shadow: none;
  }
  .navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
  }
  .navbar-collapse.in {
    overflow-y: auto;
  }
  .navbar-collapse .navbar-nav.navbar-left:first-child {
    margin-left: -15px;
  }
  .navbar-collapse .navbar-nav.navbar-right:last-child {
    margin-right: -15px;
  }
  .navbar-collapse .navbar-text:last-child {
    margin-right: 0;
  }
}
.container > .navbar-header,
.container > .navbar-collapse {
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  .container > .navbar-header,
  .container > .navbar-collapse {
    margin-right: 0;
    margin-left: 0;
    display: none;
  }
}
.navbar-static-top {
  z-index: 1000;
  border-width: 0 0 1px;
}
@media (min-width: 768px) {
  .navbar-static-top {
    border-radius: 0;
  }
}
.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}
@media (min-width: 768px) {
  .navbar-fixed-top,
  .navbar-fixed-bottom {
    border-radius: 0;
  }
}
.navbar-fixed-top {
  top: 0;
  border-width: 0 0 1px;
}
.navbar-fixed-bottom {
  bottom: 0;
  margin-bottom: 0;
  border-width: 1px 0 0;
}
.navbar-brand {
  float: left;
  padding: 15px 15px;
  font-size: 18px;
  line-height: 20px;
}
.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}
@media (min-width: 768px) {
  .navbar > .container .navbar-brand {
    margin-left: -15px;
  }
}
button#buscadorXsButton {
  text-overflow: clip !important;
}
.navbar-toggle {
  position: relative;
  float: right;
  margin-right: 15px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  top: -5px;
}
.navbar-toggle .icon-bar {
  margin-top: 14px;
  margin-left: 27px;
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
  background-color: #FFF !important;
}
.navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}
@media (min-width: 768px) {
  .navbar-toggle {
    display: none;
  }
}
#menu360.responsive ul li:nth-child(1),
#menu360.responsive ul li:nth-child(2) {
  display: inline-block;
}
#menu360.responsive ul li:nth-child(2) a {
  padding-left: 0px;
}
#menu360.responsive ul li:not(:nth-child(1)):not(:nth-child(2)) {
  display: none;
}
#menu360.responsive ul li {
  float: none !important;
}
#menu360 .container {
  width: 100%;
}
.navMenu--user {
  top: auto !important;
}
#menu360 {
  background-color: #303030 !important;
  vertical-align: middle !important;
  border: none !important;
  font-family: Roboto !important;
  color: #ffffff !important;
}
#menu360 ul li a {
  color: #fff !important;
}
#menu360:not(.responsive) ul {
  margin: 0 auto !important;
  display: table !important;
  vertical-align: middle;
  float: none !important;
}
#menu360 ul li:nth-child(2) {
  display: none;
  width: 24px !important;
  height: 24px !important;
}
#menu360 ul li:not(:nth-child(1)):not(:nth-child(2)) {
  margin-top: 5px;
}
.navbar-nav {
  margin: 5px 0px -4px -2px;
}
.navbar-nav > li > a {
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 20px;
}
.navbar-nav .nav-item {
  color: #cccccc;
}
.navbar-nav .nav-item:hover {
  color: #FFF;
}
.navbar-nav .nav-item--active {
  box-shadow: 0 -3px 0 #FFF inset !important;
}
.navbar-nav .nav-item--active > a > span {
  color: #FFF;
  font-weight: bolder;
}
@media (max-width: 767px) {
  .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-nav .open .dropdown-menu > li > a,
  .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 15px 5px 25px;
  }
  .navbar-nav .open .dropdown-menu > li > a {
    line-height: 20px;
  }
  .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-nav .open .dropdown-menu > li > a:focus {
    background-image: none;
  }
  .navbar-nav .nav-item {
    margin: -1px;
    border-bottom: 3px solid #333333;
  }
  .navbar-nav.menu_user-top-margin.menu-anonymous {
    margin-top: 0 !important;
  }
}
@media (min-width: 768px) {
  .navbar-nav {
    float: left;
    margin: 0;
  }
  .navbar-nav > li {
    float: left;
  }
}
@media (min-width: 768px) {
  .navbar-left {
    float: left !important;
    float: left;
  }
  .navbar-right {
    float: right !important;
    float: right;
  }
}
.navbar-form {
  margin-left: -15px;
  margin-right: -15px;
  padding: 10px 15px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  margin-top: 8px;
  margin-bottom: 8px;
}
@media (min-width: 1200px) {
  .navbar-form {
    margin-top: 6px;
    margin-bottom: 0;
  }
}
@media (min-width: 768px) {
  .navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .form-control {
    display: inline-block;
  }
  .navbar-form .radio,
  .navbar-form .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
  }
  .navbar-form .radio input[type="radio"],
  .navbar-form .checkbox input[type="checkbox"] {
    float: none;
    margin-left: 0;
  }
}
@media (max-width: 767px) {
  .navbar-form .form-group {
    margin-bottom: 5px;
  }
}
@media (min-width: 768px) {
  .navbar-form {
    width: auto;
    border: 0;
    margin-left: 0;
    margin-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
}
.navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.navbar-nav.pull-right > li > .dropdown-menu,
.navbar-nav > li > .dropdown-menu.pull-right {
  left: auto;
  right: 0;
}
.navbar-btn {
  margin-top: 8px;
  margin-bottom: 8px;
}
.navbar-text {
  float: left;
  margin-top: 15px;
  margin-bottom: 15px;
}
@media (min-width: 768px) {
  .navbar-text {
    margin-left: 15px;
    margin-right: 15px;
  }
}
.navbar-text2 {
  float: left;
  margin-top: 15px;
  margin-bottom: 15px;
}
@media (min-width: 768px) {
  .navbar-text2 {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 8px !important;
  }
}
.navbar-default {
  background-color: #f8f8f8;
  border-color: #e7e7e7;
}
.navbar-default .navbar-brand {
  color: #777;
}
.navbar-default .navbar-brand:hover,
.navbar-default .navbar-brand:focus {
  color: #5e5e5e;
  background-color: transparent;
}
.navbar-default .navbar-text {
  color: #777;
}
.navbar-default .navbar-nav > li > a {
  color: #777;
}
.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
  color: #333;
  background-color: transparent;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
  color: #555;
  background-color: #e7e7e7;
}
.navbar-default .navbar-nav > .disabled > a,
.navbar-default .navbar-nav > .disabled > a:hover,
.navbar-default .navbar-nav > .disabled > a:focus {
  color: #ccc;
  background-color: transparent;
}
.navbar-default .navbar-toggle {
  border-color: #ddd;
}
.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #ddd;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #ccc;
}
.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
  border-color: #e7e7e7;
}
.navbar-default .navbar-nav > .dropdown > a:hover .caret,
.navbar-default .navbar-nav > .dropdown > a:focus .caret {
  border-top-color: #333;
  border-bottom-color: #333;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  background-color: #e7e7e7;
  color: #555;
}
.navbar-default .navbar-nav > .open > a .caret,
.navbar-default .navbar-nav > .open > a:hover .caret,
.navbar-default .navbar-nav > .open > a:focus .caret {
  border-top-color: #555;
  border-bottom-color: #555;
}
.navbar-default .navbar-nav > .dropdown > a .caret {
  border-top-color: #777;
  border-bottom-color: #777;
}
@media (max-width: 767px) {
  .navbar-default .navbar-nav .open .dropdown-menu > li > a {
    color: #777;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #333;
    background-color: transparent;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #555;
    background-color: #e7e7e7;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #ccc;
    background-color: transparent;
  }
}
.navbar-default .navbar-link {
  color: #777;
}
.navbar-default .navbar-link:hover {
  color: #333;
}
.navbar-inverse {
  background-color: #222;
  border-color: #080808;
}
.navbar-inverse .navbar-brand {
  color: #999999;
}
.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-brand:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-text {
  color: #999999;
}
.navbar-inverse .navbar-nav > li > a {
  color: #999999;
}
.navbar-inverse .navbar-nav > li > a:hover,
.navbar-inverse .navbar-nav > li > a:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-nav > .active > a,
.navbar-inverse .navbar-nav > .active > a:hover,
.navbar-inverse .navbar-nav > .active > a:focus {
  color: #fff;
  background-color: #080808;
}
.navbar-inverse .navbar-nav > .disabled > a,
.navbar-inverse .navbar-nav > .disabled > a:hover,
.navbar-inverse .navbar-nav > .disabled > a:focus {
  color: #444;
  background-color: transparent;
}
.navbar-inverse .navbar-toggle {
  border-color: #333;
}
.navbar-inverse .navbar-toggle:hover,
.navbar-inverse .navbar-toggle:focus {
  background-color: #333;
}
.navbar-inverse .navbar-toggle .icon-bar {
  background-color: #fff;
}
.navbar-inverse .navbar-collapse,
.navbar-inverse .navbar-form {
  border-color: #101010;
}
.navbar-inverse .navbar-nav > .open > a,
.navbar-inverse .navbar-nav > .open > a:hover,
.navbar-inverse .navbar-nav > .open > a:focus {
  background-color: #080808;
  color: #fff;
}
.navbar-inverse .navbar-nav > .dropdown > a:hover .caret {
  border-top-color: #fff;
  border-bottom-color: #fff;
}
.navbar-inverse .navbar-nav > .dropdown > a .caret {
  border-top-color: #999999;
  border-bottom-color: #999999;
}
.navbar-inverse .navbar-nav > .open > a .caret,
.navbar-inverse .navbar-nav > .open > a:hover .caret,
.navbar-inverse .navbar-nav > .open > a:focus .caret {
  border-top-color: #fff;
  border-bottom-color: #fff;
}
@media (max-width: 767px) {
  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
    border-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
    color: #999999;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #fff;
    background-color: transparent;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #fff;
    background-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #444;
    background-color: transparent;
  }
}
.navbar-inverse .navbar-link {
  color: #999999;
}
.navbar-inverse .navbar-link:hover {
  color: #fff;
}
a.dropdown-toggle.dropdownUser {
  padding-top: 4px;
  padding-bottom: 4px;
}
@media only screen and (max-width: 768px) {
  a.dropdown-toggle.dropdownUser {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
.navbar-nav > li.no-highlight > .dropdown-menu {
  width: auto;
  min-width: auto;
}
.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div {
  border: none;
  min-height: auto;
}
.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div:last-of-type {
  background: none;
  margin-top: -7px;
}
.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div > li {
  padding: 12px 0px;
}
.navbar-nav span.nav-image {
  margin-top: -5px;
  display: block;
}
.navbar-nav .section-nav img.nav-icon {
  padding: 0px 5px;
  width: 30px;
}
.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 20px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 4px;
}
.breadcrumb > li {
  display: inline-block;
}
.breadcrumb > li + li:before {
  content: "/\\00a0";
  padding: 0 5px;
  color: #ccc;
}
.breadcrumb > .active {
  color: #999999;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline;
}
.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  line-height: 1.42857143;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  margin-left: -1px;
}
.pagination > li:first-child > a,
.pagination > li:first-child > span {
  margin-left: 0;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.pagination > li > a:hover,
.pagination > li > span:hover,
.pagination > li > a:focus,
.pagination > li > span:focus {
  background-color: #eeeeee;
}
.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
  z-index: 2;
  color: #fff;
  background-color: #FFF;
  border-color: #FFF;
  cursor: default;
}
.pagination > .disabled > span,
.pagination > .disabled > span:hover,
.pagination > .disabled > span:focus,
.pagination > .disabled > a,
.pagination > .disabled > a:hover,
.pagination > .disabled > a:focus {
  color: #999999;
  background-color: #fff;
  border-color: #ddd;
  cursor: not-allowed;
}
.pagination-lg > li > a,
.pagination-lg > li > span {
  padding: 10px 16px;
  font-size: 18px;
}
.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
}
.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
}
.pagination-sm > li > a,
.pagination-sm > li > span {
  padding: 5px 10px;
  font-size: 12px;
}
.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
}
.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px;
}
.pager {
  padding-left: 0;
  margin: 20px 0;
  list-style: none;
  text-align: center;
}
.pager:before,
.pager:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.pager:after {
  clear: both;
}
.pager:before,
.pager:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.pager:after {
  clear: both;
}
.pager li {
  display: inline;
}
.pager li > a,
.pager li > span {
  display: inline-block;
  padding: 5px 14px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 15px;
}
.pager li > a:hover,
.pager li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.pager .next > a,
.pager .next > span {
  float: right;
}
.pager .previous > a,
.pager .previous > span {
  float: left;
}
.pager .disabled > a,
.pager .disabled > a:hover,
.pager .disabled > a:focus,
.pager .disabled > span {
  color: #999999;
  background-color: #fff;
  cursor: not-allowed;
}
.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
.label[href]:hover,
.label[href]:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.label:empty {
  display: none;
}
.label-default {
  background-color: #F2F2F2;
}
.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #d9d9d9;
}
.label-primary {
  background-color: #FFF;
}
.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #e6e6e6;
}
.label-success {
  background-color: #FFF;
}
.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #e6e6e6;
}
.label-info {
  background-color: #999999;
}
.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #808080;
}
.label-warning {
  background-color: #f0ad4e;
}
.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ec971f;
}
.label-danger {
  background-color: #FFF;
}
.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #e6e6e6;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  background-color: #555555;
  border-radius: 10px;
}
.badge:empty {
  display: none;
}
a.badge:hover,
a.badge:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.btn .badge {
  position: relative;
  top: -1px;
}
@-moz-document url-prefix() {
  .btn .badge {
    top: -1px;
    margin-left: 4px;
    right: 0px!important;
  }
}
a.list-group-item.active > .badge,
.nav-pills > .active > a > .badge {
  color: #999999;
  background-color: #fff;
}
.nav-pills > li > a > .badge {
  margin-left: 3px;
}
.jumbotron {
  padding: 30px;
  margin-bottom: 30px;
  font-size: 21px;
  font-weight: 200;
  line-height: 2.14285714;
  color: inherit;
  background-color: #eeeeee;
}
.jumbotron h1 {
  line-height: 1;
  color: inherit;
}
.jumbotron p {
  line-height: 1.4;
}
.container .jumbotron {
  border-radius: 6px;
}
@media screen and (min-width: 768px) {
  .jumbotron {
    padding-top: 48px;
    padding-bottom: 48px;
  }
  .container .jumbotron {
    padding-left: 60px;
    padding-right: 60px;
  }
  .jumbotron h1 {
    font-size: 63px;
  }
}
.thumbnail {
  padding: 4px;
  line-height: 1.42857143;
  background-color: #121212;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-transition: all all 0.2s ease-in-out ease-out;
  -moz-transition: all all 0.2s ease-in-out ease-out;
  -o-transition: all all 0.2s ease-in-out ease-out;
  transition: all all 0.2s ease-in-out ease-out;
  display: inline-block;
  max-width: 100%;
  height: auto;
  display: block;
  margin-bottom: 20px;
}
.thumbnail > img {
  display: block;
  max-width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
a.thumbnail:hover,
a.thumbnail:focus,
a.thumbnail.active {
  border-color: #999999;
}
.thumbnail .caption {
  padding: 9px;
  color: #FFF;
}
.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}
.alert h4 {
  margin-top: 0;
  color: inherit;
}
.alert .alert-link {
  font-weight: bold;
}
.alert > p,
.alert > ul {
  margin-bottom: 0;
}
.alert > p + p {
  margin-top: 5px;
}
.alert-dismissable {
  padding-right: 35px;
}
.alert-dismissable .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}
.alert-success {
  background-color: #dff0d8;
  border-color: #d6e9c6;
  color: #468847;
}
.alert-success hr {
  border-top-color: #c9e2b3;
}
.alert-success .alert-link {
  color: #356635;
}
.alert-info {
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #3a87ad;
}
.alert-info hr {
  border-top-color: #a6e1ec;
}
.alert-info .alert-link {
  color: #2d6987;
}
.alert-warning {
  background-color: #fcf8e3;
  border-color: #faebcc;
  color: #c09853;
}
.alert-warning hr {
  border-top-color: #f7e1b5;
}
.alert-warning .alert-link {
  color: #a47e3c;
}
.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #6D6D6D;
}
.alert-danger hr {
  border-top-color: #e4b9c0;
}
.alert-danger .alert-link {
  color: #535353;
}
@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
@-moz-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
@-o-keyframes progress-bar-stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 40px 0;
  }
}
@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  overflow: hidden;
  height: 20px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #FFF;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
  -webkit-transition: all width 0.6s ease ease-out;
  -moz-transition: all width 0.6s ease ease-out;
  -o-transition: all width 0.6s ease ease-out;
  transition: all width 0.6s ease ease-out;
}
.progress-striped .progress-bar {
  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 40px 40px;
}
.progress.active .progress-bar {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite;
}
.progress-bar-success {
  background-color: #FFF;
}
.progress-striped .progress-bar-success {
  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-info {
  background-color: #999999;
}
.progress-striped .progress-bar-info {
  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-warning {
  background-color: #f0ad4e;
}
.progress-striped .progress-bar-warning {
  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-danger {
  background-color: #FFF;
}
.progress-striped .progress-bar-danger {
  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));
  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}
.media,
.media .media {
  margin-top: 15px;
}
.media:first-child {
  margin-top: 0;
}
.media-object {
  display: block;
}
.media-heading {
  margin: 0 0 5px;
}
.media > .pull-left {
  margin-right: 10px;
}
.media > .pull-right {
  margin-left: 10px;
}
.media-list {
  padding-left: 0;
  list-style: none;
}
.list-group {
  margin-bottom: 20px;
  padding-left: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group-item:first-child {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.list-group-item > .badge {
  float: right;
}
.list-group-item > .badge + .badge {
  margin-right: 5px;
}
a.list-group-item {
  color: #555;
}
a.list-group-item .list-group-item-heading {
  color: #333;
}
a.list-group-item:hover,
a.list-group-item:focus {
  text-decoration: none;
  background-color: #f5f5f5;
}
a.list-group-item.active,
a.list-group-item.active:hover,
a.list-group-item.active:focus {
  z-index: 2;
  color: #737373;
  background-color: #FFF;
  border-color: #FFF;
}
a.list-group-item.active .list-group-item-heading,
a.list-group-item.active:hover .list-group-item-heading,
a.list-group-item.active:focus .list-group-item-heading {
  color: inherit;
}
a.list-group-item.active .list-group-item-text,
a.list-group-item.active:hover .list-group-item-text,
a.list-group-item.active:focus .list-group-item-text {
  color: #ffffff;
}
.list-group-item-heading {
  margin-top: 0;
  margin-bottom: 5px;
}
.list-group-item-text {
  margin-bottom: 0;
  line-height: 1.3;
}
.panel {
  margin-bottom: 20px;
  background-color: rgba(30, 30, 30, 0.75);
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel-light {
  background: #3f3f3f;
}
.panel-gray {
  background: #555555;
}
.panel-graydark {
  background: #3f3f3f;
}
.panel-dark {
  background: #222222;
}
.panel-transp-50 {
  background: rgba(30, 30, 30, 0.5);
}
.panel-dark-70 {
  background: rgba(30, 30, 30, 0.7);
  display: inline-block;
}
.panel-gray-light {
  background-color: #c7c7c7;
  display: inline-block;
}
.panel-gray-lighter {
  background: #e6e6e6;
  display: inline-block;
}
.panel-transp-100 {
  background: #1e1e1e;
}
.panel-body {
  padding: 15px;
}
.panel-body:before,
.panel-body:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.panel-body:after {
  clear: both;
}
.panel-body:before,
.panel-body:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.panel-body:after {
  clear: both;
}
.panel > .list-group {
  margin-bottom: 0;
}
.panel > .list-group .list-group-item {
  border-width: 1px 0;
}
.panel > .list-group .list-group-item:first-child {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.panel > .list-group .list-group-item:last-child {
  border-bottom: 0;
}
.panel-heading + .list-group .list-group-item:first-child {
  border-top-width: 0;
}
.panel > .table,
.panel > .table-responsive {
  margin-bottom: 0;
}
.panel > .panel-body + .table,
.panel > .panel-body + .table-responsive {
  border-top: 1px solid #ddd;
}
.panel > .table-bordered,
.panel > .table-responsive > .table-bordered {
  border: 0;
}
.panel > .table-bordered > thead > tr > th:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,
.panel > .table-bordered > tbody > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,
.panel > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-bordered > thead > tr > td:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,
.panel > .table-bordered > tbody > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.panel > .table-bordered > tfoot > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
  border-left: 0;
}
.panel > .table-bordered > thead > tr > th:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,
.panel > .table-bordered > tbody > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,
.panel > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-bordered > thead > tr > td:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,
.panel > .table-bordered > tbody > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.panel > .table-bordered > tfoot > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
  border-right: 0;
}
.panel > .table-bordered > thead > tr:last-child > th,
.panel > .table-responsive > .table-bordered > thead > tr:last-child > th,
.panel > .table-bordered > tbody > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,
.panel > .table-bordered > tfoot > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th,
.panel > .table-bordered > thead > tr:last-child > td,
.panel > .table-responsive > .table-bordered > thead > tr:last-child > td,
.panel > .table-bordered > tbody > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,
.panel > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td {
  border-bottom: 0;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}
.panel-heading > .dropdown .dropdown-toggle {
  color: inherit;
}
.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.panel-title > a {
  color: inherit;
}
.panel-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #232323;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
  overflow: hidden;
}
.panel-group .panel + .panel {
  margin-top: 5px;
}
.panel-group .panel-heading {
  border-bottom: 0;
}
.panel-group .panel-heading + .panel-collapse .panel-body {
  border-top: 1px solid #232323;
}
.panel-group .panel-footer {
  border-top: 0;
}
.panel-group .panel-footer + .panel-collapse .panel-body {
  border-bottom: 1px solid #232323;
}
.panel-default {
  border-color: #ddd;
}
.panel-default > .panel-heading {
  color: #333333;
  background-color: #f5f5f5;
  border-color: #ddd;
}
.panel-default > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #ddd;
}
.panel-default > .panel-heading > .dropdown .caret {
  border-color: #333333 transparent;
}
.panel-default > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #ddd;
}
.panel-primary {
  border-color: #FFF;
}
.panel-primary > .panel-heading {
  color: #fff;
  background-color: #FFF;
  border-color: #FFF;
}
.panel-primary > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #FFF;
}
.panel-primary > .panel-heading > .dropdown .caret {
  border-color: #fff transparent;
}
.panel-primary > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #FFF;
}
.panel-success {
  border-color: #d6e9c6;
}
.panel-success > .panel-heading {
  color: #468847;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
.panel-success > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #d6e9c6;
}
.panel-success > .panel-heading > .dropdown .caret {
  border-color: #468847 transparent;
}
.panel-success > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #d6e9c6;
}
.panel-warning {
  border-color: #faebcc;
}
.panel-warning > .panel-heading {
  color: #c09853;
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.panel-warning > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #faebcc;
}
.panel-warning > .panel-heading > .dropdown .caret {
  border-color: #c09853 transparent;
}
.panel-warning > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #faebcc;
}
.panel-danger {
  border-color: #ebccd1;
}
.panel-danger > .panel-heading {
  color: #6D6D6D;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.panel-danger > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #ebccd1;
}
.panel-danger > .panel-heading > .dropdown .caret {
  border-color: #6D6D6D transparent;
}
.panel-danger > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #ebccd1;
}
.panel-info {
  border-color: #bce8f1;
}
.panel-info > .panel-heading {
  color: #3a87ad;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.panel-info > .panel-heading + .panel-collapse .panel-body {
  border-top-color: #bce8f1;
}
.panel-info > .panel-heading > .dropdown .caret {
  border-color: #3a87ad transparent;
}
.panel-info > .panel-footer + .panel-collapse .panel-body {
  border-bottom-color: #bce8f1;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}
.well blockquote {
  border-color: #ddd;
  border-color: rgba(0, 0, 0, 0.15);
}
.well-lg {
  padding: 24px;
  border-radius: 6px;
}
.well-sm {
  padding: 9px;
  border-radius: 2px;
}
.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #FFF;
  text-shadow: 0 1px 0 #fff;
}
.close:hover,
.close:focus {
  color: #FFF;
  text-decoration: none;
  cursor: pointer;
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  -webkit-opacity: 0.5;
  opacity: 0.5;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);
  filter: alpha(opacity=50);
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}
.modal-open {
  overflow: hidden;
}
.modal {
  display: none;
  overflow: auto;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
}
.modal.fade .modal-dialog {
  -webkit-transform: translate(0, -25%);
  -moz-transform: translate(0, -25%);
  -o-transform: translate(0, -25%);
  -ms-transform: translate(0, -25%);
  transform: translate(0, -25%);
  -webkit-transition: -webkit-transform 0.3s ease-out;
  -moz-transition: -moz-transform 0.3s ease-out;
  -o-transition: -o-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
}
.modal.in .modal-dialog {
  -webkit-transform: translate(0, 0);
  -moz-transform: translate(0, 0);
  -o-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.modal-dialog {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  padding: 10px;
  z-index: 1050;
}
.modal-content {
  position: relative;
  background-color: #000;
  border: 1px solid #999;
  border: 1px solid #555555;
  border-radius: 6px;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  outline: none;
  color: #FFF;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background-color: #000;
}
.modal-backdrop.fade {
  -moz-opacity: 0;
  -khtml-opacity: 0;
  -webkit-opacity: 0;
  opacity: 0;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
  filter: alpha(opacity=0);
}
.modal-backdrop.in {
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  -webkit-opacity: 0.5;
  opacity: 0.5;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);
  filter: alpha(opacity=50);
}
.modal-header {
  padding: 15px;
  min-height: 16.42857143px;
}
.modal-header .close {
  margin-top: -2px;
}
.modal-title {
  margin: 0;
  line-height: 1.42857143;
}
.modal-body {
  position: relative;
  padding: 20px 40px;
}
.modal-footer {
  margin-top: 0px;
  padding: 19px 20px 20px;
  text-align: right;
}
.modal-footer:before,
.modal-footer:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.modal-footer:after {
  clear: both;
}
.modal-footer:before,
.modal-footer:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.modal-footer:after {
  clear: both;
}
.modal-footer .btn + .btn {
  margin-left: 5px;
  margin-bottom: 0;
}
.modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}
.modal-footer .btn-block + .btn-block {
  margin-left: 0;
}
@media screen and (min-width: 768px) {
  .modal-dialog {
    width: 600px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
}
.dynover-frame {
  z-index: 99999;
}
.tooltip {
  position: absolute;
  z-index: 1030;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.4;
  -moz-opacity: 0;
  -khtml-opacity: 0;
  -webkit-opacity: 0;
  opacity: 0;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
  filter: alpha(opacity=0);
}
.tooltip.in {
  -moz-opacity: 0.9;
  -khtml-opacity: 0.9;
  -webkit-opacity: 0.9;
  opacity: 0.9;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=90);
  filter: alpha(opacity=90);
}
.tooltip.top {
  margin-top: -3px;
  padding: 5px 0;
}
.tooltip.right {
  margin-left: 3px;
  padding: 0 5px;
}
.tooltip.bottom {
  margin-top: 3px;
  padding: 5px 0;
}
.tooltip.left {
  margin-left: -3px;
  padding: 0 5px;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #000;
  border-radius: 4px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-left .tooltip-arrow {
  bottom: 0;
  left: 5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  right: 5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  left: 5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  right: 5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1010;
  display: none;
  max-width: 276px;
  padding: 1px;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  white-space: normal;
}
.popover.top {
  margin-top: -10px;
}
.popover.right {
  margin-left: 10px;
}
.popover.bottom {
  margin-top: 10px;
}
.popover.left {
  margin-left: -10px;
}
.popover-title {
  margin: 0;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}
.popover-content {
  padding: 9px 14px;
}
.popover .arrow,
.popover .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popover .arrow {
  border-width: 11px;
}
.popover .arrow:after {
  border-width: 10px;
  content: "";
}
.popover.top .arrow {
  left: 50%;
  margin-left: -11px;
  border-bottom-width: 0;
  border-top-color: #999;
  border-top-color: rgba(0, 0, 0, 0.25);
  bottom: -11px;
}
.popover.top .arrow:after {
  content: " ";
  bottom: 1px;
  margin-left: -10px;
  border-bottom-width: 0;
  border-top-color: #fff;
}
.popover.right .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-left-width: 0;
  border-right-color: #999;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.popover.right .arrow:after {
  content: " ";
  left: 1px;
  bottom: -10px;
  border-left-width: 0;
  border-right-color: #fff;
}
.popover.bottom .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px;
}
.popover.bottom .arrow:after {
  content: " ";
  top: 1px;
  margin-left: -10px;
  border-top-width: 0;
  border-bottom-color: #fff;
}
.popover.left .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.popover.left .arrow:after {
  content: " ";
  right: 1px;
  border-right-width: 0;
  border-left-color: #fff;
  bottom: -10px;
}
.carousel {
  position: relative;
}
.carousel-inner {
  position: relative;
  overflow: hidden;
  width: 100%;
  border-bottom: 1px solid #222222;
}
.carousel-inner > .item {
  display: none;
  position: relative;
  -webkit-transition: 0.6s ease-in-out left;
  transition: 0.6s ease-in-out left;
  -webkit-transition: all 0.6s ease-in-out left ease-out;
  -moz-transition: all 0.6s ease-in-out left ease-out;
  -o-transition: all 0.6s ease-in-out left ease-out;
  transition: all 0.6s ease-in-out left ease-out;
}
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  display: block;
  max-width: 100%;
  height: auto;
  line-height: 1;
}
.carousel-inner > .active,
.carousel-inner > .next,
.carousel-inner > .prev {
  display: block;
}
.carousel-inner > .active {
  left: 0;
}
.carousel-inner > .next,
.carousel-inner > .prev {
  position: absolute;
  top: 0;
  width: 100%;
}
.carousel-inner > .next {
  left: 100%;
}
.carousel-inner > .prev {
  left: -100%;
}
.carousel-inner > .next.left,
.carousel-inner > .prev.right {
  left: 0;
}
.carousel-inner > .active.left {
  left: -100%;
}
.carousel-inner > .active.right {
  left: 100%;
}
.carousel-control {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 15%;
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  -webkit-opacity: 0.5;
  opacity: 0.5;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);
  filter: alpha(opacity=50);
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}
.carousel-control.left {
  background-image: -webkit-gradient(linear, 0% top, 100% top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0.0001)));
  background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.5) 0%), color-stop(rgba(0, 0, 0, 0.0001) 100%));
  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
}
.carousel-control.right {
  left: auto;
  right: 0;
  background-image: -webkit-gradient(linear, 0% top, 100% top, from(rgba(0, 0, 0, 0.0001)), to(rgba(0, 0, 0, 0.5)));
  background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.0001) 0%), color-stop(rgba(0, 0, 0, 0.5) 100%));
  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
}
.carousel-control:hover,
.carousel-control:focus {
  color: #fff;
  text-decoration: none;
  -moz-opacity: 0.9;
  -khtml-opacity: 0.9;
  -webkit-opacity: 0.9;
  opacity: 0.9;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=90);
  filter: alpha(opacity=90);
}
.carousel-control .icon-prev,
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-left,
.carousel-control .glyphicon-chevron-right {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: inline-block;
}
.carousel-control .icon-prev,
.carousel-control .glyphicon-chevron-left {
  left: 50%;
}
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-right {
  right: 50%;
}
.carousel-control .icon-prev,
.carousel-control .icon-next {
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  font-family: Roboto;
}
.carousel-control .icon-prev:before {
  content: '\\2039';
}
.carousel-control .icon-next:before {
  content: '\\203a';
}
.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 15;
  width: 60%;
  margin-left: -30%;
  padding-left: 0;
  list-style: none;
  text-align: center;
}
.carousel-indicators li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  border: 1px solid #fff;
  border-radius: 10px;
  cursor: pointer;
  background-color: #000 \\9;
  background-color: rgba(0, 0, 0, 0);
}
.carousel-indicators .active {
  margin: 0;
  width: 12px;
  height: 12px;
  background-color: #FFF !important;
  border-color: #FFF;
}
.carousel-caption {
  position: absolute;
  left: 15%;
  right: 15%;
  bottom: 20px;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}
.carousel-caption .btn {
  text-shadow: none;
}
@media screen and (min-width: 768px) {
  .carousel-control .glyphicons-chevron-left,
  .carousel-control .glyphicons-chevron-right,
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 30px;
    height: 30px;
    margin-top: -15px;
    margin-left: -15px;
    font-size: 30px;
  }
  .carousel-caption {
    left: 20%;
    right: 20%;
    padding-bottom: 30px;
  }
  .carousel-indicators {
    bottom: 20px;
  }
}
/* BUSCADOR COMBO PREDICTIVO
-------------------------------------------------- */
.autocomplete-w1 {
  /* background:url(img/shadow.png) no-repeat bottom right;*/
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 8px 0 0 6px;
  /* IE6 fix: */
  _background: none;
  _margin: 0;
}
.autocomplete {
  /*width:207px !important;*/
  color: #000;
  border-top: 1px solid #1E1E1E;
  background: #FFFFFF;
  cursor: default;
  text-align: left;
  /*overflow:auto;*/
  overflow: auto;
  margin: 0 0 0 -6px;
  /* IE6 specific: */
  _height: 350px;
  _margin: 0;
  _overflow-x: hidden;
  padding: 0 10px;
}
@media (min-width: 768px) {
  .autocompleteContainter {
    width: 240px !important;
  }
}
.autocomplete .selected {
  background: #E0E0E0;
  border-radius: 2px;
  color: #222222;
}
.autocomplete div {
  /*border-top: 1px dotted #E0E0E0;*/
  font-size: 13px;
  line-height: 15px;
  padding: 6px 0 !important;
}
.autocomplete-category {
  color: #333333;
  margin-left: 0;
}
.autocomplete-category-suggest {
  border-bottom: 1px solid #DADADA;
}
.autocomplete a {
  color: #333333;
  padding: 5px !important;
}
.autocomplete img {
  padding-left: 0;
}
.autocomplete h5 {
  margin-top: 6px;
  margin-bottom: 6px;
}
.autocomplete li:first-child {
  padding-left: 5px;
}
@media (max-width: 767px) {
  .resultado-busqueda h2 {
    font-size: 10px;
  }
}
.clearfix:before,
.clearfix:after {
  content: " ";
  /* 1 */
  display: table;
  /* 2 */
}
.clearfix:after {
  clear: both;
}
.center-block {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.pull-right {
  float: right !important;
}
.pull-left {
  float: left !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
.invisible {
  visibility: hidden;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.hidden {
  display: none !important;
  visibility: hidden !important;
}
.affix {
  position: fixed;
}
@-ms-viewport {
  width: device-width;
}
.visible-xxs,
tr.visible-xxs,
th.visible-xxs,
td.visible-xxs {
  display: none !important;
}
@media (max-width: 479px) {
  .visible-xxs {
    display: block !important;
  }
  tr.visible-xxs {
    display: table-row !important;
  }
  th.visible-xxs,
  td.visible-xxs {
    display: table-cell !important;
  }
}
@media (min-width: 480px) and (max-width: 767px) {
  .visible-xxs.visible-xs {
    display: block !important;
  }
  tr.visible-xxs.visible-xs {
    display: table-row !important;
  }
  th.visible-xxs.visible-xs,
  td.visible-xxs.visible-xs {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-xxs.visible-sm {
    display: block !important;
  }
  tr.visible-xxs.visible-sm {
    display: table-row !important;
  }
  th.visible-xxs.visible-sm,
  td.visible-xxs.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-xxs.visible-md {
    display: block !important;
  }
  tr.visible-xxs.visible-md {
    display: table-row !important;
  }
  th.visible-xxs.visible-md,
  td.visible-xxs.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-xxs.visible-lg {
    display: block !important;
  }
  tr.visible-xxs.visible-lg {
    display: table-row !important;
  }
  th.visible-xxs.visible-lg,
  td.visible-xxs.visible-lg {
    display: table-cell !important;
  }
}
.visible-xs,
tr.visible-xs,
th.visible-xs,
td.visible-xs {
  display: none !important;
}
@media (max-width: 767px) {
  .visible-xs {
    display: block !important;
  }
  tr.visible-xs {
    display: table-row !important;
  }
  th.visible-xs,
  td.visible-xs {
    display: table-cell !important;
  }
}
@media (min-width: 320px) and (max-width: 479px) {
  .visible-xs.visible-xss {
    display: block !important;
  }
  tr.visible-xs.visible-xss {
    display: table-row !important;
  }
  th.visible-xs.visible-xss,
  td.visible-xs.visible-xss {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-xs.visible-sm {
    display: block !important;
  }
  tr.visible-xs.visible-sm {
    display: table-row !important;
  }
  th.visible-xs.visible-sm,
  td.visible-xs.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-xs.visible-md {
    display: block !important;
  }
  tr.visible-xs.visible-md {
    display: table-row !important;
  }
  th.visible-xs.visible-md,
  td.visible-xs.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-xs.visible-lg {
    display: block !important;
  }
  tr.visible-xs.visible-lg {
    display: table-row !important;
  }
  th.visible-xs.visible-lg,
  td.visible-xs.visible-lg {
    display: table-cell !important;
  }
}
.visible-sm,
tr.visible-sm,
th.visible-sm,
td.visible-sm {
  display: none !important;
}
@media (min-width: 320px) and (max-width: 479px) {
  .visible-sm.visible-xss {
    display: block !important;
  }
  tr.visible-sm.visible-xss {
    display: table-row !important;
  }
  th.visible-sm.visible-xss,
  td.visible-sm.visible-xss {
    display: table-cell !important;
  }
}
@media (max-width: 767px) {
  .visible-sm.visible-xs {
    display: block !important;
  }
  tr.visible-sm.visible-xs {
    display: table-row !important;
  }
  th.visible-sm.visible-xs,
  td.visible-sm.visible-xs {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm {
    display: block !important;
  }
  tr.visible-sm {
    display: table-row !important;
  }
  th.visible-sm,
  td.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-sm.visible-md {
    display: block !important;
  }
  tr.visible-sm.visible-md {
    display: table-row !important;
  }
  th.visible-sm.visible-md,
  td.visible-sm.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-sm.visible-lg {
    display: block !important;
  }
  tr.visible-sm.visible-lg {
    display: table-row !important;
  }
  th.visible-sm.visible-lg,
  td.visible-sm.visible-lg {
    display: table-cell !important;
  }
}
.visible-md,
tr.visible-md,
th.visible-md,
td.visible-md {
  display: none !important;
}
@media (min-width: 320px) and (max-width: 479px) {
  .visible-md.visible-xss {
    display: block !important;
  }
  tr.visible-md.visible-xss {
    display: table-row !important;
  }
  th.visible-md.visible-xss,
  td.visible-md.visible-xss {
    display: table-cell !important;
  }
}
@media (max-width: 767px) {
  .visible-md.visible-xs {
    display: block !important;
  }
  tr.visible-md.visible-xs {
    display: table-row !important;
  }
  th.visible-md.visible-xs,
  td.visible-md.visible-xs {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-md.visible-sm {
    display: block !important;
  }
  tr.visible-md.visible-sm {
    display: table-row !important;
  }
  th.visible-md.visible-sm,
  td.visible-md.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md {
    display: block !important;
  }
  tr.visible-md {
    display: table-row !important;
  }
  th.visible-md,
  td.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-md.visible-lg {
    display: block !important;
  }
  tr.visible-md.visible-lg {
    display: table-row !important;
  }
  th.visible-md.visible-lg,
  td.visible-md.visible-lg {
    display: table-cell !important;
  }
}
.visible-lg,
tr.visible-lg,
th.visible-lg,
td.visible-lg {
  display: none !important;
}
@media (min-width: 320px) and (max-width: 479px) {
  .visible-lg.visible-xss {
    display: block !important;
  }
  tr.visible-lg.visible-xss {
    display: table-row !important;
  }
  th.visible-lg.visible-xss,
  td.visible-lg.visible-xss {
    display: table-cell !important;
  }
}
@media (max-width: 767px) {
  .visible-lg.visible-xs {
    display: block !important;
  }
  tr.visible-lg.visible-xs {
    display: table-row !important;
  }
  th.visible-lg.visible-xs,
  td.visible-lg.visible-xs {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-lg.visible-sm {
    display: block !important;
  }
  tr.visible-lg.visible-sm {
    display: table-row !important;
  }
  th.visible-lg.visible-sm,
  td.visible-lg.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-lg.visible-md {
    display: block !important;
  }
  tr.visible-lg.visible-md {
    display: table-row !important;
  }
  th.visible-lg.visible-md,
  td.visible-lg.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg {
    display: block !important;
  }
  tr.visible-lg {
    display: table-row !important;
  }
  th.visible-lg,
  td.visible-lg {
    display: table-cell !important;
  }
}
.hidden-xxs {
  display: block !important;
}
tr.hidden-xxs {
  display: table-row !important;
}
th.hidden-xxs,
td.hidden-xxs {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden-xxs,
  tr.hidden-xxs,
  th.hidden-xxs,
  td.hidden-xxs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-xxs.hidden-sm,
  tr.hidden-xxs.hidden-sm,
  th.hidden-xxs.hidden-sm,
  td.hidden-xxs.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-xxs.hidden-md,
  tr.hidden-xxs.hidden-md,
  th.hidden-xxs.hidden-md,
  td.hidden-xxs.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-xxs.hidden-lg,
  tr.hidden-xxs.hidden-lg,
  th.hidden-xxs.hidden-lg,
  td.hidden-xxs.hidden-lg {
    display: none !important;
  }
}
.hidden-xs {
  display: block !important;
}
tr.hidden-xs {
  display: table-row !important;
}
th.hidden-xs,
td.hidden-xs {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden-xs,
  tr.hidden-xs,
  th.hidden-xs,
  td.hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-xs.hidden-sm,
  tr.hidden-xs.hidden-sm,
  th.hidden-xs.hidden-sm,
  td.hidden-xs.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-xs.hidden-md,
  tr.hidden-xs.hidden-md,
  th.hidden-xs.hidden-md,
  td.hidden-xs.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-xs.hidden-lg,
  tr.hidden-xs.hidden-lg,
  th.hidden-xs.hidden-lg,
  td.hidden-xs.hidden-lg {
    display: none !important;
  }
}
.hidden2-xs {
  display: table-cell !important;
}
tr.hidden2-xs {
  display: table-row !important;
}
th.hidden2-xs,
td.hidden2-xs {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden2-xs,
  tr.hidden2-xs,
  th.hidden2-xs,
  td.hidden2-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden2-xs.hidden-sm,
  tr.hidden2-xs.hidden-sm,
  th.hidden2-xs.hidden-sm,
  td.hidden2-xs.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden2-xs.hidden-md,
  tr.hidden2-xs.hidden-md,
  th.hidden2-xs.hidden-md,
  td.hidden2-xs.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden2-xs.hidden-lg,
  tr.hidden2-xs.hidden-lg,
  th.hidden2-xs.hidden-lg,
  td.hidden2-xs.hidden-lg {
    display: none !important;
  }
}
.hidden-sm {
  display: block !important;
}
tr.hidden-sm {
  display: table-row !important;
}
th.hidden-sm,
td.hidden-sm {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden-sm.hidden-xs,
  tr.hidden-sm.hidden-xs,
  th.hidden-sm.hidden-xs,
  td.hidden-sm.hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-sm,
  tr.hidden-sm,
  th.hidden-sm,
  td.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-sm.hidden-md,
  tr.hidden-sm.hidden-md,
  th.hidden-sm.hidden-md,
  td.hidden-sm.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-sm.hidden-lg,
  tr.hidden-sm.hidden-lg,
  th.hidden-sm.hidden-lg,
  td.hidden-sm.hidden-lg {
    display: none !important;
  }
}
.hidden-md {
  display: block !important;
}
tr.hidden-md {
  display: table-row !important;
}
th.hidden-md,
td.hidden-md {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden-md.hidden-xs,
  tr.hidden-md.hidden-xs,
  th.hidden-md.hidden-xs,
  td.hidden-md.hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-md.hidden-sm,
  tr.hidden-md.hidden-sm,
  th.hidden-md.hidden-sm,
  td.hidden-md.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-md,
  tr.hidden-md,
  th.hidden-md,
  td.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-md.hidden-lg,
  tr.hidden-md.hidden-lg,
  th.hidden-md.hidden-lg,
  td.hidden-md.hidden-lg {
    display: none !important;
  }
}
.hidden-lg {
  display: block !important;
}
tr.hidden-lg {
  display: table-row !important;
}
th.hidden-lg,
td.hidden-lg {
  display: table-cell !important;
}
@media (max-width: 767px) {
  .hidden-lg.hidden-xs,
  tr.hidden-lg.hidden-xs,
  th.hidden-lg.hidden-xs,
  td.hidden-lg.hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-lg.hidden-sm,
  tr.hidden-lg.hidden-sm,
  th.hidden-lg.hidden-sm,
  td.hidden-lg.hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-lg.hidden-md,
  tr.hidden-lg.hidden-md,
  th.hidden-lg.hidden-md,
  td.hidden-lg.hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-lg,
  tr.hidden-lg,
  th.hidden-lg,
  td.hidden-lg {
    display: none !important;
  }
}
.visible-print,
tr.visible-print,
th.visible-print,
td.visible-print {
  display: none !important;
}
@media print {
  .visible-print {
    display: block !important;
  }
  tr.visible-print {
    display: table-row !important;
  }
  th.visible-print,
  td.visible-print {
    display: table-cell !important;
  }
  .hidden-print,
  tr.hidden-print,
  th.hidden-print,
  td.hidden-print {
    display: none !important;
  }
}
/*---------------------------------------------------
    LESS Elements 0.9
  ---------------------------------------------------
    A set of useful LESS mixins
    More info at: http://lesselements.com
  ---------------------------------------------------*/
.navbar-inverse {
  background: #000;
}
.panel {
  display: inline-block;
}
/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */
/*carousel */
.carousel.slide img {
  width: 100%;
  height: auto;
}
/* Carousel base class */
/* Since positioning the image, we need to help out the caption */
.carousel.destacado .carousel-caption {
  z-index: 10;
  text-align: left;
}
/* Declare heights because of positioning of img element */
.carousel.destacado .carousel-inner > .item > img {
  min-width: 100%;
  height: auto;
  cursor: pointer;
}
.carousel-control {
  width: 5%;
}
/* .carousel-caption {
  left:10%;
  right:10%;
  padding-bottom: 0;
} */
/*deprecado v1.0 2016*/
.landing.layout-landing03 .container-false.container {
  position: relative;
  padding: 0;
}
.landing.layout-landing03 .carousel-caption {
  left: auto;
  right: auto;
  padding-bottom: 0;
  width: 100%;
}
.carousel.slide.destacado h2 {
  /*font-size: (@font-size-base * 1.25);*/
  margin-top: 0;
  padding-bottom: 10px;
}
.jcarousel {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.jcarousel .image {
  padding-left: 0;
  padding-right: 0;
}
/* Smooth Div Scroll */
/* Invisible left hotspot */
div.scrollinghotspotleft {
  min-width: 40px;
  width: 10%;
  width: 40px;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: #000;
  cursor: pointer;
  opacity: 0.35;
  -moz-opacity: 0.35;
  zoom: 1;
  z-index: 1;
}
/* Visible left hotspot */
div.scrollinghotspotleftvisible {
  background-color: #000;
  background-repeat: no-repeat;
  opacity: 0.35;
  -moz-opacity: 0.35;
  zoom: 1;
}
/* Invisible right hotspot */
div.scrollinghotspotright {
  min-width: 40px;
  width: 10%;
  width: 40px;
  height: 100%;
  background-color: #000;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  opacity: 0.35;
  -moz-opacity: 0.35;
  zoom: 1;
  z-index: 1;
}
/* Visible right hotspot */
div.scrollinghotspotrightvisible {
  background-color: #000;
  background-repeat: no-repeat;
  opacity: 0.35;
  -moz-opacity: 0.35;
  zoom: 1;
}
/* The scroll wrapper is always the same width and height as the containing element (div).
   Overflow is hidden because you don't want to show all of the scrollable area.
*/
div.scrollwrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
div.scrollablearea {
  position: relative;
  width: auto;
  height: 100%;
  display: table;
}
.jcarousel-item {
  clear: both;
  position: relative;
}
.blabla .item-wrapper .item-img {
  display: table;
  position: relative;
  overflow: hidden;
}
@media (max-width: 767px) {
  .blabla .item-wrapper .item-img {
    height: 90px;
    width: 270px;
  }
}
@media (min-width: 768px) {
  .blabla .item-wrapper .item-img {
    height: 125px;
    width: 375px;
  }
}
.jcarousel .item-wrapper a {
  display: table;
  position: relative;
}
.jcarousel img {
  margin: 0;
  padding: 0;
}
.jcarousel-separador {
  background: none repeat scroll 0 0 #141414;
  /*border: 1px solid @gray-dark;*/
  border-top: 0;
  border-bottom: 0;
  /*border-left: 1px solid #202020;*/
  display: table;
  float: left;
  height: 90%;
  margin: 10px 20px 0 0;
  width: 3px;
}
.jcarousel-separador span {
  display: none;
}
.jcarousel-separador {
  display: table-cell;
  float: inherit;
  margin: 0px;
  background: inherit;
  width: 15px;
  padding: 1px;
  /*border-left: 2px solid #202020;*/
  border-right: 0px;
}
.section-recienvisto .jcarousel-separador {
  height: 170px;
}
.jcarousel .fa-chevron-left,
.jcarousel .fa-chevron-right {
  left: 8px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  color: #FFF;
}
.play {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 34, 34, 0.5);
}
.play .fa-play-circle-o {
  color: rgba(255, 255, 255, 0.7);
  font-size: 80px;
  left: 50%;
  margin-left: -35px;
  margin-top: -40px;
  top: 50%;
  position: absolute;
}
.play .grid-channel-icon {
  display: none;
}
.play:hover {
  opacity: 1;
}
.play:hover .grid-channel-icon {
  display: block;
}
.carousel.slide.destacado .play .fa-play-circle-o {
  color: rgba(255, 255, 255, 0.7);
  font-size: 110px;
  left: 50%;
  margin-left: -47px;
  margin-top: -56px;
  top: 50%;
  position: absolute;
}
/*/ VARIABLES carousel
los container son propios de cada carousel
  se definen anchos por contenedor para los items, asi se calcula la cinta.
  el contenedor que pre genera la cinta y las flechas es #ID que llama a la acción
  .smoothDivScroll
*/
.jcarousel.jcarousel-1 {
  width: 100%;
  height: 300px;
  position: relative;
  display: block;
}
.jcarousel.jcarousel-1.horizontal.carousel-vistime {
  height: 196px;
}
.jcarousel.jcarousel-1.horizontal {
  height: 166px;
}
.jcarousel.jcarousel-1.horizontal.mi-lista {
  height: 256px;
}
.jcarousel-1 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 540px;
  display: table;
  margin: 0 5px;
}
.jcarousel-1 .jcarousel-container.jcarousel-container-1 {
  width: 179px;
}
.jcarousel-1 .jcarousel-container.jcarousel-container-1 .image {
  padding-left: 0;
  padding-right: 0;
}
.jcarousel-1 .jcarousel-container.jcarousel-container-1 .jcarousel-item-1 {
  margin: 0;
}
.jcarousel.jcarousel-2 {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.jcarousel.jcarousel-2.horizontal {
  width: 100%;
  position: relative;
  display: block;
}
/*MEP-449 Ajustes scroll horizontal*/
:-ms-fullscreen,
:root .section-porver .vertical.jcarousel-1.jcarousel .scrollwrapper {
  min-height: 320px;
}
:-ms-fullscreen,
:root .section-porver.horizontal .vertical.jcarousel-1.jcarousel .scrollwrapper {
  min-height: 320px;
}
:-ms-fullscreen,
:root .jcarousel.jcarousel-1.vertical .scrollwrapper {
  min-height: 275px;
}
.scrollwrapper {
  scrollbar-3dlight-color: #333333;
  scrollbar-arrow-color: #333333;
  scrollbar-base-color: black;
  scrollbar-darkshadow-color: #333333;
  scrollbar-face-color: #333333;
  scrollbar-highlight-color: black;
  scrollbar-shadow-color: black;
}
/*MEP-449*/
.scrollwrapper {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.scrollwrapper::-webkit-scrollbar {
  -webkit-overflow-scrolling: touch;
  display: none;
}
.jcarousel.jcarousel-1.vertical .scrollwrapper {
  min-height: 280px;
}
.jcarousel-2 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 576px;
  display: table;
  margin: 0 5px;
}
.jcarousel-2 .jcarousel-container.jcarousel-container-1 {
  width: 459px;
}
.jcarousel-2 .jcarousel-container.jcarousel-container-1 .image {
  padding-left: 0;
  padding-right: 0;
}
.jcarousel-2 .jcarousel-container.jcarousel-container-1 .jcarousel-item-1 {
  margin: 0;
}
/*FIN jcarousel-2 vertical
 ---------------------------------------------*/
.jcarousel.jcarousel-3 {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.jcarousel.jcarousel-3 .scrollablearea {
  margin: 0 auto;
}
.jcarousel-3 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 540px;
  display: table;
  margin: 0 10px;
}
.jcarousel-3 .jcarousel-container.jcarousel-container-1 {
  width: 1026px;
}
.jcarousel-3 .jcarousel-container.jcarousel-container-1 .data {
  padding-right: 16px;
  padding-left: 0px;
}
.jcarousel-3.jcarousel .jcarousel-container-2 {
  width: 530px;
}
.jcarousel-3.jcarousel .jcarousel-container-2 img {
  height: 145px;
  width: 346px;
}
.jcarousel-3.jcarousel .jcarousel-container-2 .jcarousel-item-1 {
  margin: 0 0 10px;
}
.jcarousel-3.jcarousel .jcarousel-container-2 .jcarousel-item-2 {
  margin: 0;
}
.jcarousel-3.jcarousel .jcarousel-container-2 .image {
  padding-left: 0;
}
.jcarousel-3.jcarousel .jcarousel-container-2 .data {
  padding-left: 16px;
  padding-right: 20px;
}
/*FIN jcarousel-3 horizontal
 ---------------------------------------------*/
.jcarousel.jcarousel-4 {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.jcarousel-4 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 540px;
  display: table;
  margin: 0 10px;
}
.jcarousel-4 .jcarousel-container.jcarousel-container-1 {
  width: 420px;
}
/*FIN jcarousel-4 vertical
 ---------------------------------------------*/
.jcarousel,
.jcarousel.jcarousel-5 {
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
}
.jcarousel.jcarousel-5 {
  margin-bottom: 20px;
}
.jcarousel.jcarousel-5 .scrollablearea {
  margin: 0 auto;
}
.jcarousel-5 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 540px;
  display: table;
  margin: 0 10px;
}
.jcarousel-5 .jcarousel-container.jcarousel-container-1 {
  width: 1026px;
}
.jcarousel-5.jcarousel .jcarousel-container-2 {
  width: 254px;
}
.jcarousel-5.jcarousel .jcarousel-container-2 img {
  height: 186px;
  width: auto !important;
}
.jcarousel-5.jcarousel .jcarousel-container-2 .jcarousel-item-1 {
  margin: 0 0 10px;
}
.jcarousel-5.jcarousel .jcarousel-container-2 .jcarousel-item-2 {
  margin: 0;
}
.jcarousel-5.jcarousel .jcarousel-container-2 .image {
  padding-left: 0;
}
.jcarousel-5.jcarousel .jcarousel-container-2 .data {
  padding-left: 0;
}
.jcarousel-6 .jcarousel-container {
  display: table-cell;
  float: left;
  width: 580px;
  display: table;
  margin: 0 10px;
}
.jcarousel-6 .item-img {
  clear: none;
  float: left;
}
.jcarousel-6 .item-img > img {
  clear: none;
  float: left;
  height: 200px;
}
.section-0 .carousel-indicators {
  bottom: 0;
}
.section-0 .carousel-indicators li.active {
  background: #EA2F23;
}
.container2 {
  margin: 10px 1%;
}
.jcarousel .lead2 {
  font-size: 13px;
  line-height: 13px;
}
.jcarousel .item-fanbutton {
  margin-top: 10px;
}
.section-porver .jcarousel.jcarousel-1,
.section-porver.horizontal .jcarousel.jcarousel-1 {
  height: 300px;
}
@media (max-width: 767px) {
  .section-porver .jcarousel.jcarousel-1,
  .section-porver.horizontal .jcarousel.jcarousel-1 {
    height: 320px;
  }
}
.section-recommended .jcarousel.jcarousel-1,
.section-recommended.horizontal .jcarousel.jcarousel-1 {
  height: 270px;
}
.section-recommended.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,
.section-recommended.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {
  width: 458px;
}
.section-porver.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,
.section-porver.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {
  width: 458px;
}
.section-porver .item-fanbutton .fa,
.section-porver.horizontal .item-fanbutton .fa {
  margin-left: 5px;
}
.carousel-vistime .item-wrapper {
  padding-bottom: 23px;
}
.carousel-vistime .scrollinghotspotleft,
.carousel-vistime .scrollinghotspotright {
  height: 251px;
}
.carousel-vistime.horizontal .scrollinghotspotleft,
.carousel-vistime.horizontal .scrollinghotspotright {
  height: 163px;
}
.section-especial {
  padding-bottom: 20px;
  padding-top: 166px;
}
.section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 {
  width: 1026px;
}
.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {
  width: 658px;
}
.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {
  height: 186px ;
  width: auto !important;
}
.section-especial .jcarousel-container.jcarousel-container-1 .data,
.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 .data {
  padding-left: 20px;
  padding-right: 20px;
}
.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 {
  width: 810px;
}
.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 .jcarousel-item {
  background-color: #999999;
  margin-bottom: 10px !important;
}
.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 .jcarousel-item-1 .data {
  padding-right: 16px;
  padding-top: 10px;
}
.section-especial03 .jcarousel-3 .jcarousel-container-1,
.section-especial05 .jcarousel-3 .jcarousel-container-1 {
  width: 1026px;
}
.section-especial03 .jcarousel-3 .jcarousel-container-1 .jcarousel-item,
.section-especial05 .jcarousel-3 .jcarousel-container-1 .jcarousel-item {
  background-color: #999999;
}
.section-especial03 .h3-special,
.section-especial05 .h3-special {
  font-size: 24px;
}
.section-especial03 .jcarousel-3 .jcarousel-container-2 {
  width: 658px;
}
.section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item {
  background-color: #999999;
  margin: 0 0 10px !important;
}
.section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item .data {
  padding-right: 16px;
}
.section-especial05 .jcarousel-3.jcarousel .jcarousel-container-2 {
  width: 256px;
}
.section-especial .jcarousel-container-1 b.fa {
  right: 287px;
}
.section-especial .jcarousel-container-2 b.fa {
  right: 240px;
}
.section-especial b.fa {
  color: #999999;
  font-size: 35px;
  position: absolute;
  top: 20px;
}
.section-especial.section-especial03 .jcarousel-container-1 b.fa,
.section-especial.section-especial05 .jcarousel-container-1 b.fa {
  right: 358px;
}
.section-especial.section-especial03 .jcarousel-container-2 h4,
.section-especial.section-especial05 .jcarousel-container-2 h4 {
  min-height: 60px;
}
.section-especial.section-especial03 .jcarousel-container-2 b.fa,
.section-especial.section-especial05 .jcarousel-container-2 b.fa {
  right: 326px !important;
}
.section-especial.section-especial03 .scrollinghotspotleft i,
.section-especial.section-especial05 .scrollinghotspotleft i,
.section-especial.section-especial03 .scrollinghotspotright i,
.section-especial.section-especial05 .scrollinghotspotright i {
  pointer-events: none;
}
/* RESPONSIVE CSS
---------------------------------------------------------------------------- */
@media (max-width: 768px) {
  /* Remove the edge padding needed for mobile */
  body.layout-landing2 .section-1.text-module h2 {
    font-size: 20px;
  }
  body.layout-landing2 .section-0 h2 {
    font-size: 20px;
  }
  body.layout-landing2 .section-0 .carousel-indicators {
    display: none;
  }
  body.layout-landing2 .section-3 {
    padding: 10px 0;
    min-height: 340px;
  }
  body.layout-landing2 .section-0 .carousel.slide.destacado h2 {
    margin-bottom: 0;
    margin-top: 10px;
  }
  body.layout-landing2 .precio .monto {
    font-size: 65px;
  }
  body.layout-landing2 .legal {
    font-size: 11px;
  }
  body.layout-landing2 .section-0 .carousel.slide.destacado .btn-block {
    margin-top: 10px;
  }
  .jcarousel-6 .jcarousel-container {
    width: 310px;
  }
  .section-especial .jcarousel-5 .jcarousel-container.jcarousel-container-1 {
    width: 194px;
  }
  .section-especial .jcarousel-3 .scrollablearea {
    width: 480px !important;
  }
  .section-especial .jcarousel-3 .jcarousel-container-1,
  .section-especial .jcarousel-3 .jcarousel-container-2 {
    display: table-cell;
    float: none;
    padding: 0 10px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {
    width: 258px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {
    height: 146px;
    width: auto !important;
  }
}
@media (min-width: 480px) and (max-width: 768px) {
  .section-especial .section-especial03 .jcarousel-3 .scrollinghotspotleft,
  .section-especial .section-especial03 .jcarousel-3 .scrollinghotspotright {
    display: none;
  }
}
@media (width: 768px) {
  .section-sugest h4 {
    text-align: left !important;
  }
  .section-sugest .item-2,
  .section-sugest .item-wrapper {
    width: auto !important;
  }
  .section-sugest .item-2 img,
  .section-sugest .item-wrapper img {
    height: 200px !important;
  }
  .section-sugest .item-1 {
    padding-bottom: 15px !important;
    width: auto !important;
    min-height: 70px;
  }
  .section-sugest .item-1 img {
    height: 200px !important;
  }
  .section-sugest .jcarousel-6 .jcarousel-container {
    width: 580px;
  }
  .section-especial .jcarousel-5 .jcarousel-container.jcarousel-container-1 {
    width: 194px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {
    width: 258px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {
    height: 146px !important;
    width: auto !important;
  }
}
@media (max-width: 1200px) {
  /* Remove the edge padding needed for mobile */
  .section-1.text-module .center {
    padding: 25px;
  }
}
@media (max-width: 991px) {
  .jcarousel-3 .jcarousel-container .jcarousel-4 .jcarousel-container .jcarousel-5 .jcarousel-container .jcarousel-6 .jcarousel-container {
    margin: 0 5px;
  }
  /* Remove the edge padding needed for mobile */
  .section-1.text-module .center {
    padding: 15px;
  }
  /* tamaños para los contenedores del carousel*/
  .section-5 .jcarousel-item {
    background: none;
    border: none;
  }
  .section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 {
    width: 194px;
  }
  .jcarousel-3 .jcarousel-container.jcarousel-container-2 {
    width: 258px;
  }
  .section-especial01 .jcarousel-3 .jcarousel-container-1,
  .section-especial03 .jcarousel-3 .jcarousel-container-1 {
    width: 192px;
  }
  .section-especial03 .jcarousel-3 .jcarousel-container-2 {
    width: 256px;
  }
  .section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item {
    background: transparent;
    margin: 0 0 10px !important;
  }
  .section-0 .carousel-caption {
    position: relative;
    left: 0;
    right: 0;
    min-height: 100px;
  }
  .section-0 .carousel.slide.destacado h2 {
    margin-top: 20px;
    margin-left: 10px;
  }
  .section-0 .carousel.slide.destacado .btn-block {
    margin-top: 20px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {
    width: 258px;
  }
  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {
    height: 146px;
    width: auto !important;
  }
}
@media (max-width: 1161px) {
  .section-0 .carousel-caption {
    position: relative;
    left: 0;
    right: 0;
    min-height: 100px;
  }
  .section-0 .carousel.slide.destacado h2 {
    margin-top: 20px;
    margin-left: 10px;
  }
  .section-0 .carousel.slide.destacado .btn-block {
    margin-top: 20px;
  }
  .jcarousel-3 .scrollwrapper {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 768px) {
  .layout-landing02 .carousel-caption {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    top: auto;
    /*min-height: 800px;*/
  }
  .layout-landing02 .carousel.slide.destacado h2 {
    margin-top: 20px;
    margin-left: 10px;
  }
  .layout-landing02 .carousel.slide.destacado .btn-block {
    margin-top: 20px;
  }
  .jcarousel-3 .jcarousel-container {
    vertical-align: top;
  }
}
/*estilos temporales 2015*/
.section-superdestacado02 .carousel.slide img {
  height: auto;
  width: auto;
}
.jcarousel-wrapper {
  position: relative;
}
.jcarousel-wrapper2 {
  width: 100%;
}
/*libreriacarrusel05*/
.jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,
.jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {
  width: 302px;
}
.jcarousel-destacado-01,
.jcarousel-destacado-01-xs {
  overflow: hidden;
}
.slideshow,
.slideshow-xs {
  overflow: visible !important;
  margin: 0px;
}
.carousel-destacado .jcarousel-destacado-01 .cycle-slide,
.carousel-destacado .jcarousel-destacado-01-xs .cycle-slide {
  margin: 0 8px;
  margin-right: 8px;
  margin-left: 8px;
}
.carousel-bg-01 .cycle-slide {
  width: 100%;
}
/*fin libreriacarrusel05*/
.carousel-fade .carousel-inner .item {
  transition-property: opacity;
}
.carousel-fade .carousel-inner .item,
.carousel-fade .carousel-inner .active.left,
.carousel-fade .carousel-inner .active.right {
  opacity: 0;
}
.carousel-fade .carousel-inner .active,
.carousel-fade .carousel-inner .next.left,
.carousel-fade .carousel-inner .prev.right {
  opacity: 1;
}
.carousel-fade .carousel-inner .next,
.carousel-fade .carousel-inner .prev,
.carousel-fade .carousel-inner .active.left,
.carousel-fade .carousel-inner .active.right {
  left: 0;
  transform: translate3d(0, 0, 0);
}
.carousel-fade .carousel-control {
  z-index: 2;
}
@media (max-width: 767px) {
  .layout-landing02 .section-destacado {
    margin-top: -660px;
  }
}
@media (min-width: 768px) {
  .section-recommended.horizontal .item-wrapper img {
    width: 446px;
    height: 251px;
  }
}
@media (min-width: 768px) {
  .section-recommended.horizontal .item-wrapper .posterLabel .posterLabel--image img {
    width: fit-content;
    height: unset;
  }
}
@media (max-width: 768px) {
  .jcarousel.jcarousel-1.vertical img {
    height: 250px;
  }
}
.section-bg-full {
  z-index: -999;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.cover2 img {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
}
/*.carousel-bg-01:before, .section-bg-full:before*/
.bg-gradient {
  content: "";
  display: block;
  position: absolute;
  /*background: #232323;*/
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 60%, #000000 100%);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  /*z-index: 999;*/
  /*height: 1100px;*/
  min-height: 100%;
  padding-top: 56.25%;
}
.dirty .section-highlight03 .slideshow li {
  position: static;
  top: 0px;
  left: 0px;
  display: inline-block;
  -webkit-transition: width 12s, height 14s;
  /* Safari */
  transition: all 0.5s;
  transition-timing-function: ease;
}
.dirty ul.slideshow {
  display: block;
  overflow: hidden!important;
  width: 10000px;
  list-style: none;
  -webkit-transition: width 12s, height 14s;
  /* Safari */
  transition: all 0.5s;
  transition-timing-function: ease;
  margin-left: 0!important;
}
.dirty .jcarousel {
  width: 10000000px !important;
  -webkit-transition: width 12s, height 14s;
  /* Safari */
  transition: all 0.5s;
  transition-timing-function: ease;
}
.dirty.main-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
section.section-recomendador-2.section-recomendado.section-doble img {
  height: 200px;
}
section.section-recomendador-2.section-recomendado.section-doble .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1 {
  width: 362px;
}
.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1 {
  height: 225px;
}
/*.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1{
  height: 225px;
}

.section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1{
 width: 139px;
}*/
@media (max-width: 767px) {
  .section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1 {
    width: 139px;
  }
}
.jcarousel.jcarousel-1.vertical.fox img {
  width: 175px;
  height: auto;
}
.jcarousel.jcarousel-2.horizontal.fox img {
  width: 375px;
  height: 125px;
}
.jcarousel.jcarousel-1.vertical.fox .scrollwrapper {
  min-height: 100px;
}
.jcarousel.fox {
  padding-top: 10px;
  height: auto;
}
.fox .item-img:hover img.foxnormal {
  display: none;
}
.fox .item-img:hover img.foxover {
  display: inline!important;
}
/* GLOBAL STYLES
-------------------------------------------------- */
body {
  min-height: 480px;
  min-width: 300px;
}
a {
  text-decoration: underline;
  color: #F2F2F2;
}
a:hover .play {
  visibility: visible;
}
.btn,
.nav a,
.btn-group a {
  text-decoration: none;
}
.stores .row {
  padding-top: 20px;
}
.stores .row div {
  margin-top: 5px;
}
/*VERTICAL ALIGN*/
.text-module .center {
  padding: 35px 0;
}
.non-scroll {
  overflow: hidden;
}
@media (max-width: 767px) {
  .logged-true .autocomplete-containter-ext {
    left: 0 !important;
  }
}
.logged-true.layout-nivelbts h3,
.logged-true.layout-aplicacionbts h3,
.logged-true.layout-nivelbts h2,
.logged-true.layout-aplicacionbts h2 {
  color: #FFF;
}
@media (max-width: 767px) {
  .logged-true.layout-nivelbts h3,
  .logged-true.layout-aplicacionbts h3,
  .logged-true.layout-nivelbts h2,
  .logged-true.layout-aplicacionbts h2 {
    max-width: 100%;
  }
}
.logged-true.layout-nivelbts h3,
.logged-true.layout-aplicacionbts h3 {
  font-size: 23.8px;
}
.menu-principal.dropdown-menu {
  padding-top: 0px;
}
.menu-principal.dropdown-menu .fa-caret-up {
  position: absolute;
  top: -18px;
  left: 45px;
}
.buscar {
  width: 190px;
  height: 30px;
  margin: 0 auto;
}
.buscar input {
  color: #eeeeee;
  background-color: #333333;
  border: 1px solid #555555;
}
.buscar button.btn-default {
  background-color: #333333;
  color: #555555;
  border-top: 1px solid #555555;
  border-right: 1px solid #555555;
  border-bottom: 1px solid #555555;
  border-left: none;
}
.buscar button.btn-default:hover {
  background-color: #222222;
  color: #eeeeee;
}
.buscar button.btn-default i {
  font-size: 1.25em;
}
.btn-search {
  background: none repeat scroll 0 0 rgba(0, 0, 0, 0);
  border: medium none;
  color: #555555;
  margin: 4px 0;
  width: 40px;
}
.btn-search i {
  font-size: 28px;
}
.buscador-xs {
  background: #333333;
  position: absolute;
  width: 100%;
}
.logo {
  margin: 0px;
}
.login .leyenda-claro {
  font-size: 1.17em;
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .login .leyenda-claro {
    margin: 20px auto !important;
  }
}
.login .leyenda-claro span {
  display: block;
}
.login .claro-logo-text,
.login .leyenda-claro .claro-logo-text {
  color: #E51A1A !important;
  display: inline;
}
.login .has-error h5 {
  text-align: left;
}
.login .btn-fb-login {
  background-color: #3B5998;
  border-color: #3B5998;
  margin-bottom: 10px;
}
.login .btn-fb-login h5 {
  margin-top: 0;
}
.login .btn-fb-login .fa-facebook-square {
  padding-left: 15px;
  margin-right: 15px;
}
.captcha-reload {
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0;
  width: 41px;
  height: 41px;
}
.chat-button {
  margin-right: -12px;
  position: absolute;
  top: 20px;
  z-index: 10000;
}
.instrucciones p {
  margin: 0px;
}
.medios-pagos .medios-pagos-tablet .btn-default,
.medios-pagos .medios-pagos-mobile .btn-default {
  background: rgba(0, 0, 0, 0.2);
  border-color: #ffffff;
  color: #eeeeee;
}
.medios-pagos .medios-pagos-tablet .btn-default:focus,
.medios-pagos .medios-pagos-mobile .btn-default:focus,
.medios-pagos .medios-pagos-tablet .btn-default.active,
.medios-pagos .medios-pagos-mobile .btn-default.active {
  background: #FFF;
  color: #222222;
  border-color: #ffffff;
}
@media not all and (pointer: coarse) {
  .medios-pagos .medios-pagos-tablet .btn-default:hover,
  .medios-pagos .medios-pagos-mobile .btn-default:hover,
  .medios-pagos .medios-pagos-tablet .btn-default:active,
  .medios-pagos .medios-pagos-mobile .btn-default:active {
    background: #FFF;
    color: #222222;
    border-color: #ffffff;
  }
}
.medios-pagos .medios-pagos-tablet .btn-default {
  border-radius: 0;
  white-space: normal;
  height: 60px;
}
.medios-pagos input[type="radio"] {
  margin-left: -17px;
}
.medios-pagos i {
  margin-left: 0.2em;
}
.medios-pagos .medios-pagos-mobile .btn-default {
  text-align: left;
}
.medios-pagos .paso-mobile {
  color: #333333;
  float: left;
  margin-bottom: 15px;
}
.medios-pagos .paso-mobile h3 {
  margin-top: 0;
  color: #eeeeee;
}
.medios-pagos .paso-mobile h5 {
  margin-top: 22px;
  color: #eeeeee;
}
.medios-pagos .paso-mobile span.indice {
  border-radius: 20px;
  background: #222222;
  float: left;
  color: #999999;
  margin: 5px 10px 0 0;
  padding: 5px 10px;
}
.fa.fa-lock {
  color: #E9AD10;
  margin-right: 10px;
}
.modal-body.error i,
.modal-body.success i {
  color: #fff;
}
.error i {
  border-radius: 30px;
  width: 42px;
  height: 42px;
  font-size: 50px;
  line-height: 40px;
}
.success i {
  border-radius: 30px;
  width: 42px;
  height: 42px;
  font-size: 42px;
  line-height: 42px;
}
.exclamation i,
.callcenter i {
  color: #FFF;
}
.has-error .control-label {
  color: #FFF;
}
.cargando-seccion,
.cargando-full-screen {
  margin-left: -27px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  left: 50%;
}
.cargando-full-screen {
  width: 375px;
  height: 140px;
  margin-left: -187px;
  margin-top: -70px;
  position: absolute;
  top: 50%;
  left: 50%;
  color: #999999;
}
.cargando-full-screen .logos {
  height: 90px;
}
.renta h3 span {
  color: #FFF;
}
.renta .caret {
  margin-top: 10px;
}
.renta .form-horizontal .form-group {
  margin-left: auto;
  margin-right: auto;
}
.renta .form-container .form-tarjeta img {
  margin-right: auto;
}
.promo-container .dropdown-menu > li > a {
  white-space: normal;
  line-height: 2;
}
.promo-container .btn-group {
  display: block;
  position: inherit;
}
.promo-container .btn-group > .btn {
  float: none;
  white-space: normal;
}
.renta .btn-promo .caret {
  margin-top: -4px;
  position: absolute;
  right: 10px;
  top: 50%;
}
.btn-promo {
  position: relative;
}
.btn-promo span:first-child {
  float: left;
  margin-right: 10px;
  text-align: left;
  white-space: normal;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
.margin-0 {
  margin: 0px;
}
.margin-top-05 {
  margin-top: 5px;
}
.margin-right-1 {
  margin-right: 10px;
}
.margin-left-1 {
  margin-left: 10px;
}
.padding-05 {
  padding: 5px;
}
.padding-1 {
  padding: 10px;
}
.padding-2 {
  padding: 20px;
}
.padding-4 {
  padding: 40px;
}
.padding-top-03 {
  padding-top: 3.33333333px;
}
.padding-top-05 {
  padding-top: 5px;
}
.padding-top-1 {
  padding-top: 10px;
}
.padding-top-2 {
  padding-top: 20px;
}
.padding-bottom-1 {
  padding-bottom: 10px;
}
.padding-right-1 {
  padding-right: 10px;
}
.padding-right-2 {
  padding-right: 20px;
}
.padding-right-left-10 {
  padding-right: 10px;
  padding-left: 10px;
}
.texto-blanco {
  color: #FFF;
}
.full-widht {
  display: bock;
  width: 100%;
}
.texto-negro {
  color: #222222;
}
.texto-brand {
  color: #FFF;
}
.texto-gris {
  color: #999999;
}
.texto-grisc {
  color: #CCC;
}
.txt-inverse {
  color: #000;
}
.border-bottom-dark {
  border-bottom: 1px solid #222222;
}
.border-bottom-gray {
  border-bottom: 1px solid #555555;
}
.border-bottom-lighter {
  border-bottom: 1px solid #eeeeee;
}
.half-width {
  width: 50%;
}
.full-width {
  width: 100%;
}
.decoration-none {
  text-decoration: none;
}
.btn {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}
.btn-ellipsis {
  max-width: 180px;
}
.btn-volver {
  background: #333333;
  border: none;
}
.btn-volver i {
  border-radius: 2px;
  margin: -12px 10px -12px -12px;
  padding: 10px;
}
.item-wrapper {
  display: table;
  position: relative;
}
.item-wrapper a {
  cursor: pointer;
}
.label-hd {
  background: #777;
  color: #FFF;
  border: 1px solid #777;
  padding-top: 3px;
  font-weight: 800;
}
.label-default-hd {
  border-radius: 0;
  background: #777;
  text-transform: uppercase;
}
.item-format--span {
  padding: 0!important;
}
.item-hd {
  color: #FFF;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);
  box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.5);
  display: none !important;
  height: 19px;
  left: 1px;
  padding: 0 2px 1px;
  position: absolute;
  text-align: center;
  font-weight: bolder;
  top: 1px;
  width: 31px;
}
.item-hd-estaspor {
  color: #FFF;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  background: rgba(0, 0, 0, 0.5);
  height: 19px;
  left: 1px;
  padding: 0 2px 1px;
  position: absolute;
  text-align: center;
  font-weight: bolder;
  top: 1px;
  width: 31px;
}
.item-format-epg {
  position: relative;
  top: 0;
  right: 0;
  font-weight: bolder;
  color: #FFF;
  text-align: center;
}
.item-format-epg > div {
  width: 100%;
}
.item-format-epg > div > label {
  width: 100%;
}
.item-format.item-format-right {
  position: absolute;
  top: 0;
  right: 0;
  font-weight: bolder;
  color: #FFF;
  text-align: center;
}
.item-format.item-format-right .item-format-ppe {
  display: block !important;
  padding: 0 5px;
  /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/
  background: rgba(0, 0, 0, 0);
  float: right;
}
.item-format.item-format-right i {
  /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/
  background: rgba(0, 0, 0, 0.5);
  float: right;
  height: 19px;
  padding: 3px 0 16px 1px;
}
.item-format.item-format-right .download {
  padding: 0;
}
.item-format-right {
  margin: 0;
  padding: 0;
}
.vidrierawidgetficha-html {
  display: none;
}
.row-cw {
  margin: 0 auto;
  width: 100%;
}
.section-doble .container-wrapper h2,
.section-bg h2,
.section-doble .container-wrapper h3,
.section-bg h3,
.section-doble .container-wrapper h4,
.section-bg h4,
.section-doble .container-wrapper h5,
.section-bg h5 {
  color: #FFF;
}
.section-doble.section-recienvisto .container-wrapper {
  height: 375px;
}
.section-doble.section-recienvisto.horizontal .container-wrapper {
  height: 245px;
}
.section-doble.section-recomendado .container-wrapper {
  padding-bottom: 20px;
}
.section-doble .container-visto {
  background: none repeat scroll 0 0 #333333;
}
.section-doble .container-recomendado {
  background: none repeat scroll 0 0 #515151;
  z-index: 2;
}
.container-recomendado2 {
  z-index: 2;
}
/*.section-porver { min-height: 382px;}*/
.section-recienvisto {
  margin-top: 30px;
}
.section-doble .row-cw .container-recomendado2 img {
  height: 201px;
}
/*.section-recienvisto {
   min-height: 248px;

}*/
/* Carrouseles
-------------------------------------------------- */
@media (min-width: 769px) {
  .section-doble .row-cw .container-recomendado {
    width: 480px;
  }
  .section-doble.horizontal .row-cw .container-recomendado {
    width: 320px;
  }
  .section-doble .row-cw .container-recomendado2 {
    background: none;
    height: 202px;
    padding: 0;
    width: 155px;
    margin-left: 20px;
  }
  .section-doble .row-cw .container-visto > div {
    margin-left: 495px;
  }
  .section-doble.horizontal .row-cw .container-visto > div {
    margin-left: 332px;
  }
  .container-recomendado3 > div {
    margin-left: 165px;
  }
  .col-cw {
    position: absolute;
    top: 0;
  }
  .section-doble.section-recomendado .container-wrapper.container-recomendado3.col-cw {
    top: 0;
    /* ajuste vertical*/
  }
  .row-cw {
    position: relative;
    margin: 0 auto;
    width: 100%;
  }
}
.section-sugest {
  padding-bottom: 20px;
}
.section-sugest .item-1 {
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  z-index: 2;
}
.section-sugest .item-2 {
  padding: 0 20px 15px;
}
.section-sugest .item-1 {
  background: none repeat scroll 0 0 #333333;
}
.section-sugest .item-2 {
  background: none repeat scroll 0 0 #3F3F3F;
}
.section-sugest b.fa-caret-right {
  color: #333333;
  font-size: 35px;
  margin-top: -17px;
  position: absolute;
  right: -10px;
  top: 50%;
}
.section-sugest b.fa-caret-down {
  bottom: -21px;
  color: #333333;
  font-size: 35px;
  margin-right: -17px;
  position: absolute;
  right: 50%;
  z-index: 2;
}
.item-header h3 {
  margin-right: 5px;
  color: #FFF;
}
.section-scroll {
  position: relative;
}
.select2 {
  position: absolute;
  right: 25px;
  top: 20px;
  z-index: 5;
}
@media (max-width: 410px) {
  .select2 {
    position: relative;
    top: 0;
    left: 10px;
  }
}
.container2.container-scroll {
  margin: 20px auto 0;
}
.section-scroll .container-scroll .image {
  padding-bottom: 20px;
}
.layout-fichabts .section-sugeridos .container {
  background-color: #333333;
  padding: 0 25px 25px 25px;
}
.layout-fichabts .section-sugeridos .container h3 {
  color: #FFF;
}
.bot-descargar {
  height: 45px;
}
.btn-disabled {
  color: #eeeeee;
  background: #b8b8b8;
  border-color: #b8b8b8;
}
.btn-disabled:focus,
.btn-disabled:active,
.btn-disabled:hover {
  color: #eeeeee;
  background: #999999;
  border-color: #999999;
}
/* << Inicio Media Querys >> */
@media (max-width: 990px) {
  .img-captcha {
    text-align: center;
    margin-bottom: 10px;
  }
}
@media (max-width: 1199px) {
  .registro {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .medios-pagos-mobile.padding-2 {
    padding: 0;
  }
  .medios-pagos-mobile .btn-default {
    padding: 10px 15px;
  }
}
@media (max-width: 991px) {
  .col-xs-12 {
    display: table;
  }
  .text-center-sm {
    text-align: center;
    float: none !important;
  }
}
@media (max-width: 1199px) {
  .btn-frecuencias {
    padding: 20px 2px;
    background: #000;
    border-color: #dedede;
    color: #eeeeee;
  }
  .btn-frecuencias:hover,
  .btn-frecuencias:focus,
  .btn-frecuencias:active,
  .btn-frecuencias.active {
    background: #000;
    color: #eeeeee;
    border-color: #bfbfbf;
    border-bottom: 1px solid #FFF;
  }
  .btn-frecuencias-active {
    padding: 20px;
    background: #FFF;
    color: #222222;
    border-bottom: 1px solid #FFF;
  }
  .btn-left {
    padding-right: 0;
  }
  .btn-left .btn {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .btn-center {
    padding-right: 0;
    padding-left: 0;
  }
  .btn-center .btn {
    border-radius: 0;
  }
  .btn-right {
    padding-left: 0;
  }
  .btn-right .btn {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
/* PREFERENCES */
.form-prefs h5 {
  margin: 0 auto;
  line-height: 2.14285714;
  font-size: 15px;
}
.form-prefs .pref-radio {
  display: none;
}
.form-prefs .col-lg-6,
.form-prefs .col-md-6,
.form-prefs .col-lg-2,
.form-prefs .col-md-2 {
  padding-left: 0;
  padding-right: 0;
}
.form-prefs .pref-text {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
  font-weight: normal;
  padding: 1em;
  margin: 0 auto;
  border: 1px solid #eeeeee;
}
.form-prefs .pref-text:hover {
  background: #FFF;
  color: black;
}
.form-prefs .col-xs-12 {
  display: table;
}
.form-prefs .pref-radio:checked + .pref-text {
  background: #FFF;
  color: #000;
}
.form-prefs .prefs-devices label {
  cursor: pointer;
}
.form-prefs .prefs-devices .pref-text {
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 992px) {
  .opt.first .pref-text {
    border-radius: 4px 0 0 4px;
  }
  .opt.last .pref-text {
    border-radius: 0 4px 4px 0;
  }
}
@media screen and (min-width: 992px) {
  .form-prefs .pref-single {
    line-height: 50%;
  }
  .form-prefs .pref-text {
    background: #000;
    padding: 0;
    border-radius: 60px;
    height: 30px;
    width: 30px;
    overflow: hidden;
    color: transparent;
    text-indent: -9999999px;
    transition: all 0.15s ease-in-out;
    box-shadow: 0 0 0 #555555;
  }
  .form-prefs .pref-radio:checked + .pref-text {
    box-shadow: 0 0 0 0.2em #555555;
  }
  .form-prefs .pref-device {
    text-align: center;
  }
}
/* Fin Metodos de Pago*/
/* Cargando */
@media (max-width: 767px) {
  .cargando-full-screen .logos {
    height: 70px;
  }
}
@media (max-width: 768px) {
  .section-sugest .item-2,
  .section-sugest .item-wrapper {
    width: 100%;
  }
  .section-sugest .item-1 {
    padding-bottom: 6px;
    width: 100%;
    min-height: 70px;
    text-align: center;
  }
}
@media (max-width: 768px) {
  .section-scroll .item-wrapper img {
    height: 190px;
  }
  .section-doble .container-wrapper h2,
  .section-bg h2,
  .section-doble .container-wrapper h3,
  .section-bg h3,
  .section-doble .container-wrapper h4,
  .section-bg h4,
  .section-doble .container-wrapper h5,
  .section-bg h5 {
    text-align: center;
    margin-top: 15px;
  }
  .jcarousel-6 .item-img > img {
    height: 160px;
  }
}
@media (max-width: 767px) {
  .section-recomendado .item-title,
  .section-sugest .item-title {
    color: #FFF;
  }
}
/* << Fin Media Querys >> */
/* Cebrado para tablas y listas */
.cebrado > .impar {
  background: #ededed;
}
.cebrado > ul li:nth-child(2n) {
  background: #ededed;
}
@media (min-width: 768px) {
  .mi-cuenta .single-line .col-md-0 {
    width: auto;
  }
}
@media (min-width: 500px) and (max-width: 768px) {
  .mi-cuenta .single-line .padding-top-1 {
    line-height: 50px;
  }
}
.mi-cuenta .single-line .fa-certificate span {
  color: #fff;
  font-size: 20px;
  left: -30px;
  position: relative;
  top: -11px;
}
.mi-cuenta .single-line .fa-certificate {
  color: #ea2f23;
  float: left;
  font-size: 50px;
}
/*estilos rediseño-2015*/
.row-table-cell {
  display: table-row;
}
.row-table-cell > * {
  display: table-cell;
  float: none;
  vertical-align: bottom;
}
@media (max-width: 768px) {
  .row-table-cell {
    display: table;
  }
  .row-table-cell > * {
    display: table;
    float: left;
    vertical-align: top;
  }
}
.no-border {
  border: 0;
}
.landing .carousel.slide.destacado .carousel-inner {
  overflow: visible;
  border: none;
}
.centered {
  margin: 0 auto;
}
@media (max-width: 767px) {
  .centered-xs {
    margin: 0 auto;
  }
}
/*.text-right
.text-left
.text-center*/
@media (max-width: 767px) {
  .text-center-xs {
    text-align: center;
  }
}
.cover {
  height: 200%;
  position: fixed;
  top: -50%;
  width: 200%;
  z-index: -999;
  left: -50%;
}
.cover img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  min-width: 50%;
  min-height: 50%;
}
.form-container {
  min-height: 380px;
}
.dispositivos ul li a {
  display: block;
}
.layout-fichabts .cover img {
  opacity: 0.5;
}
.item-rating {
  background: none;
  border-radius: 0;
  border: 1px solid #f2f2f2;
  color: #F2F2F2 !important;
}
.tooltip-score .fa {
  font-size: 1.5em;
}
.section-ficha .tooltip-score .fa {
  margin: 2px;
}
.label-default {
  color: #0c0c0c;
}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.42857143;
  border-radius: 15px;
}
.btn-circle.btn-lg {
  width: 38px;
  height: 38px;
  padding: 2px 10px;
  font-size: 18px;
  line-height: 1.8;
  border-radius: 25px;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  font-size: 24px;
  line-height: 1.33;
  border-radius: 35px;
}
.btn-circle.btn-lg .fa {
  line-height: 1;
  margin-top: 9px;
  font-size: 14px;
}
.item-btn-wrapper {
  width: 100%;
}
.item-btn-wrapper > * {
  margin: 0 auto;
  display: table;
}
.item-btn {
  display: inline-block;
  cursor: pointer;
}
.item-btn > * {
  float: left;
  clear: both;
}
.item-btn span {
  font-size: 12px;
}
.list-inline.list-float > li {
  float: left;
}
.item-fbkbutton {
  height: 38px;
  padding-top: 10px;
}
/*revisar iframe*/
/*horizontal scrolling tabs*/
.wrapper-tab {
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  padding: 5px 0;
  height: 38px;
  margin-bottom: 10px;
  border-bottom: 1px solid #232323;
}
.wrapper-tab .nav > li > a {
  border-bottom: 3px solid transparent;
  color: #DDDDDD;
}
.wrapper-tab .nav > li > a:hover,
.wrapper-tab .nav > li > a:focus {
  background: none;
  border-bottom: 3px solid #DDDDDD;
  color: #FFF;
}
.wrapper-tab .nav > li > a.active {
  border-bottom: 3px solid #666666;
}
.list {
  position: absolute;
  left: 0px;
  top: 0px;
  min-width: 3000px;
  margin-left: 12px;
  margin-top: 0px;
}
.list li {
  display: table-cell;
  position: relative;
  text-align: center;
  cursor: grab;
  cursor: -webkit-grab;
  color: #efefef;
  vertical-align: middle;
}
.scroller-tab {
  text-align: center;
  cursor: pointer;
  display: none;
  padding: 6px;
  padding-top: 7px;
  white-space: no-wrap;
  vertical-align: middle;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.scroller-tab-right {
  float: right;
}
.scroller-tab-left {
  float: left;
}
.footer_web--footer {
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
}
/*Registro definir flexbox footer*/
.layout-registro .main-wrapper {
  min-height: 750px;
}
.jcarousel .fa.fa-chevron-right,
.jcarousel .fa.fa-chevron-left {
  font-size: 18px;
  margin-top: -9px;
}
.panel-light2,
.panel-gray-light {
  background-color: #232323;
  display: inline-block;
}
.panel,
.panel-gray-lighter {
  background-color: rgba(30, 30, 30, 0.75);
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
/* PRUEBAS img placeholder

img:before, .item-wrapper > a:before {
  content: "";
  display: block;
  position: absolute;
  background: #232323;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}*/
.modal-parental .pin-error {
  line-height: 30px;
}
.section-recienvisto.section-dirty_recienvisto01 .col-cw {
  position: relative !important;
}
.section-recienvisto.section-dirty_recienvisto01 {
  background-color: #333333;
}
/*.modal-body > .fa {
  color: @black;
}*/
section {
  animation: opacity 1.2s;
}
@keyframes opacity {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
.menuhidden {
  opacity: 0;
  -webkit-transition: opacity 0.1s ease-in-out;
  -moz-transition: opacity 0.1s ease-in-out;
  -ms-transition: opacity 0.1s ease-in-out;
  -o-transition: opacity 0.1s ease-in-out;
  transition: opacity 0.1s ease-in-out;
}
.menuvisible {
  opacity: 1;
}
a,
button {
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  -o-transition: all 0.1s linear;
  -ms-transition: all 0.1s linear;
  transition: all 0.1s linear;
}
.play {
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  -o-transition: all 0.1s linear;
  -ms-transition: all 0.1s linear;
  transition: all 0.1s linear;
}
.layer {
  background-color: rgba(34, 34, 34, 0.5);
  opacity: 1;
}
.layer-epg {
  background-color: rgba(34, 34, 34, 0.5);
  opacity: 1;
  position: absolute;
  left: 0;
}
.nav .nav-pills .nav-stacked > li > a {
  position: relative;
  display: block;
  padding: 7px 15px;
}
.nav .nav-pills .nav-stacked > li > a:hover,
.nav .nav-pills .nav-stacked > li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.main-wrapper.dirty .isotope .row {
  /*width: 12000px;*/
  width: 80%;
  margin: 0 auto;
  display: block;
  animation: all 1.2s;
}
.main-wrapper.dirty .isotope .post {
  /*width: 300px;*/
  float: left;
  animation: all 1.2s;
  transition-duration: 400ms;
  transition-delay: 0ms;
}
.main-wrapper.dirty-login section.registro .form-login button {
  opacity: 0.3;
  cursor: default;
  animation: btnloginfade 1.2s;
}
@keyframes btnloginfade {
  from {
    opacity: 0.3;
  }
  to {
    opacity: 1;
  }
}
.isotope .post {
  float: left;
  /*transition-duration: 400ms;*/
  transition-delay: 0ms;
}
.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
  overflow: hidden;
  display: block;
}
.panel-group .panel + .panel {
  margin-top: 5px;
}
.fs-fb {
  font-size: 18px !important;
}
/* HEADER STYLES*/
header.main-header {
  position: relative;
  z-index: 999;
  height: 125px;
  border-bottom: 1px solid #232323;
}
header.main-header .main-logo {
  margin: 25px 20px;
}
header.main-header .logo-claro {
  margin: 20px 10px;
}
header.main-header .ingresa {
  padding-top: 0px;
}
header.main-header .navbar-default {
  background: none;
  border: none;
}
header.main-header .navbar-default .navbar-collapse,
header.main-header .navbar-default .navbar-form {
  border: none;
}
header.main-header .navbar-collapse.in {
  overflow: visible;
}
header.main-header .dropdown-menu {
  border: none;
}
@media (max-width: 767px) {
  header.main-header .dropdown-menu {
    font-size: 19.88px;
    color: #000;
  }
  header.main-header .dropdown-menu li a {
    color: #FFF;
  }
}
@media (min-width: 1330px) {
  header.main-header {
    height: 78px;
  }
}
header.main-header .main-logo {
  margin: 20px 20px 15px 20px;
}
header.main-header .search-container {
  position: relative;
  padding-top: 17px;
}
header.main-header .search-container .buscadorForm:only-child {
  float: right;
}
header.main-header .search-container .buscadorForm,
header.main-header .search-container .chat-button {
  display: inline-block;
  position: relative;
  vertical-align: top;
}
header.main-header .search-container .chat-button {
  top: 8px;
}
@media screen and (max-width: 991px) {
  header.main-header .search-container {
    max-width: 310px;
    padding-top: 25px;
  }
  header.main-header .search-container .buscadorForm {
    margin: 0 auto;
  }
  header.main-header .search-container .buscadorForm,
  header.main-header .search-container .chat-button {
    vertical-align: bottom;
  }
  header.main-header .search-container .chat-button {
    top: 0;
  }
}
@media screen and (max-width: 991px) {
  header.main-header .has-user .search-container {
    padding-top: 35px;
  }
}
@media (max-width: 767px) {
  header.main-header {
    border: none;
    height: 55px;
  }
  header.main-header .main-logo {
    margin: 10px;
  }
  header.main-header .logo-claro {
    margin: 7px 10px;
  }
}
.header-logueado .navbar-main .solapas .caja_menu a {
  font-size: 11.48px;
  padding: 5px;
  border-radius: 0;
  color: #333333;
  display: inline-block;
  line-height: 12px;
  margin-bottom: 0;
}
.header-logueado .navbar-main .solapas .caja_menu a:hover,
.header-logueado .navbar-main .solapas .caja_menu a:focus,
.header-logueado .navbar-main .solapas .caja_menu a:active {
  background-color: #999999;
  border-bottom: 3px solid transparent;
}
.header-logueado .navbar-main .solapas .caja_menu a ul.menu-principal {
  left: 0px !important;
}
.header-logueado .navbar-main .solapas .caja_menu a ul.menu-principal li .active a:hover {
  background: transparent;
}
.header-logueado .navbar-main .solapas .caja_menu li:first-child {
  margin-left: 0;
}
.header-logueado .navbar-main .solapas .caja_menu li {
  padding: 2px 0;
}
.header-logueado .navbar-main .solapas .caja_menu li.active {
  border-bottom: none  !important;
  background-color: #999999;
}
.header-logueado .navbar-main .solapas .caja_menu li.active a {
  color: #FFF;
  font-weight: bold;
}
.header-logueado .navbar-main .solapas .caja_menu li .row .columnas {
  border-right: 1px solid #eeeeee;
  min-height: 370px;
}
.header-logueado .navbar-main .solapas .caja_menu li .row .columnas h5 a {
  font-size: 17.5px;
}
.header-logueado .navbar-main .solapas .caja_menu li .row .columnas h5 a.active {
  color: #FFF;
  background-color: #999999;
  border-bottom: none  !important;
}
.header-logueado .navbar-main .solapas .caja_menu li .row .columnas:last-child {
  border-right: 0;
}
.header-logueado .navbar-main .solapas .caja_menu li.active a {
  color: #FFF;
}
.header-logueado .navbar-main .solapas .columna-destacados {
  background: #eeeeee;
  min-height: 100%;
  position: absolute;
  right: 0;
  padding-top: 36px;
}
.header-logueado .navbar-main .solapas .columna-destacados h5 {
  color: #222222;
  font-size: 17.5px;
}
.header-logueado .navbar-main .solapas .envivo {
  border: 1px solid #FFF;
  border-radius: 2px;
  height: 35px;
}
.header-logueado .navbar-main .solapas .envivo a {
  line-height: 17px;
}
@media (min-width: 768px) {
  .header-logueado .navbar-main .solapas {
    position: absolute;
    left: 0px;
    top: 82px;
  }
  .header-logueado .navbar-main .solapas li {
    margin-right: 5px;
  }
  .header-logueado .navbar-main .solapas li:first-child {
    margin-left: 20px;
  }
  .header-logueado .navbar-main .solapas .last {
    position: absolute;
    right: 30px;
  }
}
.header-logueado .navbar-main .solapas .envivo {
  border: 1px solid #FFF;
  border-radius: 2px;
  height: 35px;
}
.header-logueado .navbar-main .solapas .envivo a {
  line-height: 17px;
}
@media (min-width: 1330px) {
  .header-logueado .navbar-main .solapas {
    position: absolute;
    left: 250px;
    top: 34px;
  }
}
.header-logueado .go_back {
  margin-top: 27px;
}
.header-logueado .go_back_icon {
  margin: 8px 8px 0 5px;
}
@media (min-width: 768px) {
  .header-nologueado .navbar-main .solapas {
    position: absolute;
    left: 20px;
    top: 82px;
  }
  .header-nologueado .navbar-main .solapas li {
    margin-right: 3px;
  }
}
@media (min-width: 1330px) {
  .header-nologueado .navbar-main .solapas {
    position: absolute;
    left: 250px;
    top: 34px;
  }
}
.header-nologueado .navbar-main .solapas .dropdown-user {
  margin-top: 28px;
}
.header-nologueado .go_back {
  margin-top: 27px;
}
.header-nologueado .go_back_icon {
  margin: 8px 8px 0 5px;
}
body.layout-landing2 .header-logueado .navbar-main,
body.layout-landing2 .header-nologueado .navbar-main {
  background-color: #000;
  border: 1px solid #080808;
}
.header-logueado,
.header-nologueado {
  background-color: rgba(0, 0, 0, 0.6);
}
.header-logueado .navbar-main,
.header-nologueado .navbar-main {
  border: none;
}
@media (max-width: 767px) {
  .header-logueado .navbar-main .navbar-nav,
  .header-nologueado .navbar-main .navbar-nav {
    margin-top: 4px;
    border: none;
    font-size: 19.88px;
    margin-bottom: -4px;
  }
  .header-logueado .navbar-main .navbar-nav .open a,
  .header-nologueado .navbar-main .navbar-nav .open a,
  .header-logueado .navbar-main .navbar-nav .open a:hover,
  .header-nologueado .navbar-main .navbar-nav .open a:hover,
  .header-logueado .navbar-main .navbar-nav .open a:focus,
  .header-nologueado .navbar-main .navbar-nav .open a:focus,
  .header-logueado .navbar-main .navbar-nav .open a:active,
  .header-nologueado .navbar-main .navbar-nav .open a:active {
    /*background: @gray-dark;*/
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #222222;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu {
    padding: 0;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li {
    border-bottom: 1px solid #333333;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a,
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:hover,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:hover,
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:focus,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:focus,
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:active,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:active {
    font-size: 18.2px;
    background: #222222;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li h5,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li h5 {
    color: #FFF;
    margin: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 18px;
    border-bottom: 1px solid #222222;
    font-size: 19.88px;
    background-color: #333333;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 {
    padding-left: 5px;
    background: #333333;
  }
  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 a,
  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 a {
    display: block;
    color: #999999;
    padding-left: 35px;
  }
}
@media (max-width: 767px) {
  .header-logueado .navbar-main .navbar-nav.dropdown-user,
  .header-nologueado .navbar-main .navbar-nav.dropdown-user {
    margin-top: 0;
  }
}
@media (min-width: 768px) {
  .header-logueado .navbar-main .solapas li li .row:nth-child(2),
  .header-nologueado .navbar-main .solapas li li .row:nth-child(2) {
    margin-bottom: 15px;
  }
}
@media (min-width: 992px) {
  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal,
  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal {
    left: -80px;
    background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) repeat-y right;
  }
  .header-logueado .navbar-main .solapas li.menu-catalogo i,
  .header-nologueado .navbar-main .solapas li.menu-catalogo i {
    left: 125px;
  }
}
@media (min-width: 1200px) {
  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal,
  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal {
    left: -80px;
    background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) repeat-y right;
  }
  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active,
  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active {
    border-bottom: none;
    background-color: #999999;
  }
  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active a,
  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active a {
    color: #FFF;
    font-weight: bold;
  }
  .header-logueado .navbar-main .solapas li.menu-catalogo i,
  .header-nologueado .navbar-main .solapas li.menu-catalogo i {
    left: 205px;
  }
}
.header-logueado .navbar-main .solapas li .active,
.header-nologueado .navbar-main .solapas li .active {
  border-bottom: 3px solid #666666;
}
@media (max-width: 767px) {
  .header-logueado .navbar-main .solapas li .active,
  .header-nologueado .navbar-main .solapas li .active {
    background-color: #222222;
  }
}
.header-logueado .navbar-main .solapas li .active:hover,
.header-nologueado .navbar-main .solapas li .active:hover,
.header-logueado .navbar-main .solapas li .active:focus,
.header-nologueado .navbar-main .solapas li .active:focus,
.header-logueado .navbar-main .solapas li .active:active,
.header-nologueado .navbar-main .solapas li .active:active {
  border-bottom: 3px solid #121212;
}
.header-logueado .navbar-main .solapas li a,
.header-nologueado .navbar-main .solapas li a {
  background-color: transparent;
  color: #DDDDDD;
  border-bottom: 3px solid transparent;
  padding-top: 10px;
  padding-bottom: 10px;
}
.header-logueado .navbar-main .solapas li a:hover,
.header-nologueado .navbar-main .solapas li a:hover {
  color: #FFF;
  background-color: transparent;
  border-bottom: 3px solid #DDDDDD;
}
.header-logueado .navbar-main .solapas li a:focus,
.header-nologueado .navbar-main .solapas li a:focus,
.header-logueado .navbar-main .solapas li a:active,
.header-nologueado .navbar-main .solapas li a:active {
  background: transparent;
  border-bottom: 3px solid #DDDDDD;
  color: #FFF;
}
.header-logueado .navbar-main .solapas li a.active,
.header-nologueado .navbar-main .solapas li a.active {
  color: #FFF;
}
.header-logueado .navbar-main .solapas li a.active .caret,
.header-nologueado .navbar-main .solapas li a.active .caret {
  border-bottom-color: #FFF;
  border-top-color: #FFF;
}
@media (max-width: 767px) {
  .header-logueado .navbar-main .solapas li,
  .header-nologueado .navbar-main .solapas li {
    background-color: #333333;
  }
  .header-logueado .navbar-main .solapas li:hover,
  .header-nologueado .navbar-main .solapas li:hover,
  .header-logueado .navbar-main .solapas li:focus,
  .header-nologueado .navbar-main .solapas li:focus,
  .header-logueado .navbar-main .solapas li:active,
  .header-nologueado .navbar-main .solapas li:active {
    background-color: #222222;
  }
  .header-logueado .navbar-main .solapas li a,
  .header-nologueado .navbar-main .solapas li a {
    padding-bottom: 15px;
    padding-top: 15px;
    border-bottom: none !important;
  }
}
.header-logueado .navbar-collapse,
.header-nologueado .navbar-collapse {
  box-shadow: none;
}
@media (max-width: 767px) {
  .header-logueado .navbar-collapse,
  .header-nologueado .navbar-collapse {
    padding: 0;
  }
  .header-logueado .dropdown-user,
  .header-nologueado .dropdown-user {
    margin: 0;
  }
}
.layout-landing03 .header-nologueado {
  background-color: transparent;
}
.dropdown-user .dropdown a.dropdown-toggle {
  line-height: 21px;
  padding: 16px 30px 16px 10px;
}
.dropdown-user {
  margin-top: 25px;
}
.dropdown-user .dropdown > .dropdown-toggle:hover,
.dropdown-user .dropdown > .dropdown-toggle:focus,
.dropdown-user .dropdown > .dropdown-toggle:active {
  background-color: transparent;
}
@media (max-width: 767px) {
  .dropdown-user .dropdown > .dropdown-toggle:hover:hover,
  .dropdown-user .dropdown > .dropdown-toggle:focus:hover,
  .dropdown-user .dropdown > .dropdown-toggle:active:hover {
    color: #FFF;
    background-color: #333333;
  }
  .dropdown-user .dropdown > .dropdown-toggle:hover:focus,
  .dropdown-user .dropdown > .dropdown-toggle:focus:focus,
  .dropdown-user .dropdown > .dropdown-toggle:active:focus,
  .dropdown-user .dropdown > .dropdown-toggle:hover:active,
  .dropdown-user .dropdown > .dropdown-toggle:focus:active,
  .dropdown-user .dropdown > .dropdown-toggle:active:active {
    color: #FFF;
    background-color: #222222;
  }
}
.dropdown-user .dropdown-menu li a:hover,
.dropdown-user .dropdown-menu li a:focus,
.dropdown-user .dropdown-menu li a:active {
  color: #FFF;
  background-color: #999999;
}
.dropdown-user .dropdown-menu li.active a {
  color: #FFF;
  background-color: #999999;
}
.dropdown-user li a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 160px;
  word-wrap: break-word;
}
.dropdown-user li a .caret {
  position: absolute;
  right: 10px;
  top: 22px;
}
@media (max-width: 767px) {
  .dropdown-user li a {
    background-color: #222222;
    width: 100%;
    padding-bottom: 15px;
    padding-top: 15px;
  }
  .dropdown-user li a:hover,
  .dropdown-user li a:focus,
  .dropdown-user li a:active {
    background-color: #222222;
  }
}
.header-preferencias {
  display: table;
  padding: 40px 40px 0 40px;
}
@media (max-width: 767px) {
  .header-preferencias {
    padding: 20px;
  }
}
.nav-pills {
  padding: 5px 10px 0px;
  font-weight: bold;
}
.nav-pills .dropdown-menu-tabs {
  font-weight: bold;
}
.main-header2 {
  margin-top: 2px;
}
.main-header2 .nav.navbar-nav {
  margin-top: 13px;
}
.main-header2 .navbar-collapse .navbar-nav > li > a {
  margin: 0 5px;
  padding: 7px 8px !important;
}
.navbar-nav > li > .dropdown-menu {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.main-header2 .navbar-collapse .navbar-nav > li a:hover,
.main-header2 .navbar-collapse .navbar-nav > li a:focus,
.main-header2 .navbar-collapse .navbar-nav > li a:active {
  background: #333333;
  color: #FFF;
}
.main-header2 .navbar-collapse .open > a,
.main-header2 .navbar-collapse .open > a:hover,
.main-header2 .navbar-collapse .open > a:focus {
  background: #333333;
  border-color: #999999;
}
.main-header2 .navbar-collapse .open > a .caret,
.main-header2 .navbar-collapse .open > a:hover .caret,
.main-header2 .navbar-collapse .open > a:focus .caret {
  border-top-color: #737373;
  border-bottom-color: #737373;
}
.main-header2 .navbar-collapse .navbar-nav > li a:hover:hover,
.main-header2 .navbar-collapse .navbar-nav > li a:hover:focus,
.main-header2 .navbar-collapse .navbar-nav > li a:hover:active {
  background: #DDDDDD;
  color: #666666;
}
.main-header2 .dropdown-menu > .active > a,
.main-header2 .dropdown-menu > .active > a:hover,
.main-header2 .dropdown-menu > .active > a:focus {
  color: #666666;
  text-decoration: none;
  outline: 0;
  background-color: #DDDDDD;
}
/*DROPDOWNS customize*/
.dropdown-menu {
  background-color: #FFF;
}
.dropdown-menu > li > a {
  line-height: 40px;
  white-space: nowrap;
  color: #666666;
  font-size: 12px;
}
.dropdown-menu > .active > a,
.dropdown-menu > .active > a:hover,
.dropdown-menu > .active > a:focus {
  color: none;
}
ul.dropdown-menu:after,
ul.dropdown-menu:before {
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  bottom: 100%;
  border: solid transparent;
}
@media screen and (min-width: 768px) {
  ul.dropdown-menu:after {
    border-bottom-color: #fff;
    border-width: 6px;
    left: 33%;
    margin-left: -6px;
  }
}
ul.dropdown-menu:before {
  border-bottom-color: #ddd;
  border-width: 7px;
  left: 33%;
  margin-left: -7px;
}
ul.menu-principal:after,
ul.menu-principal:before {
  display: none;
}
ul.menu-user:after,
ul.menu-user:before {
  display: none;
}
.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li {
  border-bottom: 1px solid #DDDDDD;
}
.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li:last-child {
  border: none;
}
/* wplay-765 */
.dropdown-user .open > a,
.dropdown-user .open > a:hover,
.dropdown-user .open > a:focus {
  background-color: transparent;
  border-color: #999999;
}
@media (max-width: 767px) {
  .dropdown-user .open > a,
  .dropdown-user .open > a:hover,
  .dropdown-user .open > a:focus {
    background-color: #222222;
  }
}
header.error {
  position: relative;
  z-index: 999;
}
header.error .main-logo {
  margin: 25px 20px;
}
header.error .logo-claro {
  margin: 20px 10px;
}
@media (min-width: 1200px) {
  header.error {
    height: 78px;
  }
}
header.error .main-logo {
  margin: 20px 20px 15px 20px;
}
@media (max-width: 767px) {
  header.error {
    border: none;
    height: 55px;
  }
  header.error .main-logo {
    margin: 10px;
  }
  header.error .logo-claro {
    margin: 7px 10px;
  }
  #menuUser .btn-default {
    border: none;
    font-size: 19px;
  }
  #menuUser .btn-default:hover {
    color: gray;
  }
  #menuUser {
    background-color: #222222;
  }
}
.region-brasil .columnas.columna-latinoamerica {
  width: 147px !important;
}
.region-brasil .columnas.columna-deportes {
  width: 120px !important;
}
@media (max-width: 1300px) and (min-width: 1200px) {
  .search-container {
    top: 55px;
  }
  .search-container .chat-button {
    top: 6px;
  }
  #menuUser + .buscadorForm {
    position: relative;
  }
  #menuUser,
  #menu + .nav.nav-pills {
    position: relative;
  }
}
.dropdown-toggle.dropdownUser {
  background-color: transparent!important;
}
@media (max-width: 768px) {
  .btn.btn-default.metricas-event.btn-anonimus.change-class-btn {
    background-color: #222222;
  }
}
/* FOOTERS */
.footer-web {
  color: #F2F2F2;
}
.footer-web ul {
  margin-bottom: 0px !important;
}
.footer-web .siguenos {
  padding-right: 10px;
}
.footer-web .links-footer li {
  font-size: 11.2px;
  padding-left: 0;
  margin-bottom: 0px !important;
}
.social-ico .fa {
  border-radius: 4px;
  color: #F2F2F2;
  font-size: 18.2px;
  padding: 5px;
}
.social-ico .fa-facebook {
  padding-left: 10px;
  padding-right: 10px;
}
.social-ico .fa-youtube img {
  position: relative;
  top: -2px;
  left: -2px;
  height: 28px;
}
.footer-mobile .margin-vertical {
  margin: 20px 0;
}
.footer-mobile .links-footer li {
  border-bottom: 1px solid #414141;
  width: 100%;
}
.footer-mobile .links-footer li a {
  text-decoration: none;
  padding: 2px 4px;
  display: block;
}
.footer-mobile .links-footer li a:active {
  background: #555555;
  text-decoration: none;
  color: #eeeeee;
}
.footer-mobile .links-footer li a:hover {
  text-decoration: none;
}
.footer-mobile .links-footer li a:visited {
  text-decoration: none;
}
.footer-mobile .links-footer li span {
  line-height: 50px;
  font-size: 18.2px;
}
.footer-mobile .links-footer li i {
  margin-top: 4px;
  font-size: 42px;
}
.footer-mobile .links-footer-primero li {
  border-bottom: 1px solid #414141;
  width: 100%;
}
.footer-mobile .links-footer-primero li a {
  text-decoration: none;
  padding: 2px 4px;
  display: block;
  background: #666666;
}
.footer-mobile .links-footer-primero li a:active {
  background: #666666;
  text-decoration: none;
  color: #eeeeee;
}
.footer-mobile .links-footer-primero li a:hover {
  text-decoration: none;
}
.footer-mobile .links-footer-primero li a:visited {
  text-decoration: none;
}
.footer-mobile .links-footer-primero li span {
  line-height: 50px;
  font-size: 18.2px;
}
.footer-mobile .links-footer-primero li i {
  margin-top: 4px;
  font-size: 42px;
}
.footer-mobile .links-footer-segundo li {
  border-bottom: 1px solid #414141;
  width: 100%;
}
.footer-mobile .links-footer-segundo li a {
  text-decoration: none;
  padding: 2px 4px;
  display: block;
}
.footer-mobile .links-footer-segundo li a:active {
  background: #555555;
  text-decoration: none;
  color: #eeeeee;
}
.footer-mobile .links-footer-segundo li a:hover {
  text-decoration: none;
}
.footer-mobile .links-footer-segundo li a:visited {
  text-decoration: none;
}
.footer-mobile .links-footer-segundo li span {
  line-height: 50px;
  font-size: 18.2px;
}
.footer-mobile .links-footer-segundo li i {
  margin-top: 4px;
  font-size: 42px;
}
.footer-mobile .social-ico .fa {
  font-size: 40px;
}
.footer-mobile .social-ico .fa-facebook {
  padding-right: 17px;
  padding-left: 17px;
}
.footer-mobile .social-ico img {
  position: relative;
  top: -8px;
  height: 51px;
}
/* FORM STYLES*/
#formContainer {
  min-height: 300px;
}
.form-container {
  min-height: 280px;
  padding: 40px;
}
.form-container .btn-fb-login h5 {
  margin-bottom: 0;
}
.form-container h3,
.form-container h5 {
  margin-top: 0px;
  color: #eeeeee !important;
}
.form-container form fieldset[disabled] label,
.form-container form fieldset[disabled] p,
.form-container form fieldset[disabled] select {
  color: #999999;
}
.form-container form label,
.form-container form p {
  font-weight: normal;
}
.form-container .form-tarjeta h5,
.form-container .login-captcha h5 {
  margin-bottom: 25px;
}
.form-container .form-tarjeta .control-label,
.form-container .login-captcha .control-label {
  padding-top: 0;
  text-align: left;
}
.form-container .form-tarjeta img,
.form-container .login-captcha img {
  margin-right: 15px;
  vertical-align: top;
}
.form-container .form-sears-sanborns .radio-inline {
  padding-top: 0;
  vertical-align: middle;
}
.form-container .form-sears-sanborns .radio-inline input[type="radio"] {
  margin-top: 0;
}
.form-container .form-sears-sanborns .tarjeta-txt {
  vertical-align: middle;
}
.form-container .form-sears-sanborns img {
  vertical-align: middle;
}
@media (max-width: 991px) {
  .form-container .form-sears-sanborns .form-group {
    margin-left: -10px;
    margin-right: -10px;
  }
  .form-container .form-sears-sanborns img {
    margin-right: 1px;
  }
  .form-container .form-sears-sanborns .radio input[type="radio"],
  .form-container .form-sears-sanborns .radio-inline input[type="radio"],
  .form-container .form-sears-sanborns .checkbox input[type="checkbox"],
  .form-container .form-sears-sanborns .checkbox-inline input[type="checkbox"] {
    margin-left: -13px;
  }
}
.form-container .odd {
  background: #222222;
}
.form-container .dispositivos ul {
  padding: 0px;
}
.form-container .dispositivos .checkbox {
  list-style-type: none;
  display: block;
  padding: 0;
  height: 80px;
  margin: 0;
  width: 100%;
}
.form-container .dispositivos .checkbox label {
  display: inline-block;
  height: 100%;
  padding: 30px 10px 10px 20px;
  width: 100%;
}
.form-container .dispositivos .checkbox label i {
  margin: -10px 10px 5px 0;
}
.form-container .dispositivos .checkbox input[type=checkbox] {
  margin: 4px 6px 0 0;
}
.form-group.has-error .input-group-addon {
  display: table;
  float: right;
  font-size: 20px;
  padding: 5px;
  position: relative;
  top: -32px;
  color: #EA2F23;
  background: rgba(35, 35, 35, 0.8);
  border-radius: 0 4px 4px 0;
  border: none;
  margin-right: 2px;
}
@media (max-width: 767px) {
  .form-container {
    padding: 20px;
  }
}
.form-paso1 .date-birth {
  padding-bottom: 5px;
}
.form-paso1 .date-dd,
.form-paso1 .date-mm,
.form-paso1 .date-yy {
  padding-left: 0px;
}
.form-paso1 .date-dd select,
.form-paso1 .date-mm select,
.form-paso1 .date-yy select {
  padding-left: 2px;
}
@media (max-width: 991px) {
  .form-container h5 {
    text-align: center;
    margin-top: 10px;
  }
}
.form-panel {
  display: table;
  margin: 0 auto;
}
.form-panel .btn-txt {
  float: left;
  height: 26px;
  line-height: 26px;
}
.medios-pagos-web .radio-inline {
  margin-left: 0 !important;
  margin-right: 10px;
  margin-bottom: 10px;
}
/*****************/
.input-append input,
.input-prepend input,
.input-append select,
.input-prepend select,
.input-append .uneditable-input,
.input-prepend .uneditable-input {
  border-radius: 0;
}
.input-mini {
  width: 60px;
  max-width: 100%;
}
.input-small {
  width: 90px;
  max-width: 100%;
}
.input-medium,
.input-md {
  width: 150px;
  max-width: 100%;
}
.input-large {
  width: 210px;
  max-width: 100%;
}
.input-xlarge {
  width: 270px;
  max-width: 100%;
}
.input-xxlarge {
  width: 530px;
  max-width: 100%;
}
input.input-lg {
  font-size: 18px;
}
input[type=checkbox].claro-min,
input[type=radio].claro-min {
  opacity: 0;
  position: absolute;
  z-index: 1;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
label input[type=checkbox].claro-min,
label input[type=radio].claro-min {
  z-index: -100 !important;
  width: 1px!important;
  height: 1px!important;
  clip: rect(1px, 1px, 1px, 1px);
  position: absolute;
}
input[type=checkbox].claro-min:checked,
input[type=radio].claro-min:checked,
input[type=checkbox].claro-min:focus,
input[type=radio].claro-min:focus {
  outline: 0 !important;
}
input[type=checkbox].claro-min + .lbl,
input[type=radio].claro-min + .lbl {
  position: relative;
  display: inline-block;
  margin: 0;
  line-height: 20px;
  min-height: 18px;
  min-width: 18px;
  font-weight: 400;
  cursor: pointer;
}
input[type=checkbox].claro-min + .lbl::before,
input[type=radio].claro-min + .lbl::before {
  cursor: pointer;
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  /* color:#32a3ce;*/
  content: "\\a0";
  background-color: #FAFAFA;
  border: 1px solid #c8c8c8;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 0;
  display: inline-block;
  text-align: center;
  height: 16px;
  line-height: 14px;
  min-width: 16px;
  margin-right: 1px;
  position: relative;
  margin-right: 5px;
  top: -1px;
}
input[type=checkbox].claro-min:checked + .lbl::before,
input[type=radio].claro-min:checked + .lbl::before {
  display: inline-block;
  content: '\\f00c';
  background-color: #F5F8FC;
  border-color: #adb8c0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);
}
input[type=checkbox].claro-min:hover + .lbl::before,
input[type=radio].claro-min:hover + .lbl::before,
input[type=checkbox].claro-min + .lbl:hover::before,
input[type=radio].claro-min + .lbl:hover::before {
  /* border-color:#ff893c;*/
  border-color: #66afe9;
}
input[type=checkbox].claro-min:active + .lbl::before,
input[type=radio].claro-min:active + .lbl::before,
input[type=checkbox].claro-min:checked:active + .lbl::before,
input[type=radio].claro-min:checked:active + .lbl::before {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 3px rgba(0, 0, 0, 0.1);
}
input[type=checkbox].claro-min.claro-min-checkbox-2 + .lbl::before,
input[type=radio].claro-min.claro-min-checkbox-2 + .lbl::before {
  box-shadow: none;
}
input[type=checkbox].claro-min.claro-min-checkbox-2:checked + .lbl::before,
input[type=radio].claro-min.claro-min-checkbox-2:checked + .lbl::before {
  background-color: #f9a021;
  border-color: #f9a021;
  color: #FFF;
}
input[type=checkbox].claro-min:disabled + .lbl::before,
input[type=radio].claro-min:disabled + .lbl::before,
input[type=checkbox].claro-min[disabled] + .lbl::before,
input[type=radio].claro-min[disabled] + .lbl::before,
input[type=checkbox].claro-min.disabled + .lbl::before,
input[type=radio].claro-min.disabled + .lbl::before {
  background-color: #DDD !important;
  border-color: #CCC !important;
  box-shadow: none!important;
  color: #BBB;
}
.checkbox label input[type=checkbox].claro-min + .lbl,
.radio label input[type=radio].claro-min + .lbl {
  margin-left: -10px;
}
input[type=radio].claro-min + .lbl::before {
  border-radius: 100%;
  font-size: 10px;
  font-family: Roboto;
  /*text-shadow:0 0 1px #32a3ce;*/
  padding-left: 1px;
  line-height: 15px;
  height: 17px;
  min-width: 17px;
}
input[type=radio].claro-min:checked + .lbl::before {
  content: "\\f111";
}
input[type=checkbox].claro-min.claro-min-switch {
  width: 55px;
  height: 25px;
}
input[type=checkbox].claro-min.claro-min-switch + .lbl {
  margin: 0 4px;
  min-height: 24px;
}
input[type=checkbox].claro-min.claro-min-switch + .lbl::before {
  font-family: Roboto;
  content: "ON\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0OFF";
  color: #999;
  text-shadow: 0 0 0 #999;
  font-weight: 400;
  font-size: 11px;
  line-height: 17px;
  height: 20px;
  overflow: hidden;
  border-radius: 12px;
  background-color: #F5F5F5;
  -webkit-box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);
  border: 1px solid #CCC;
  text-align: left;
  float: left;
  padding: 0;
  width: 52px;
  text-indent: -21px;
  margin-right: 0;
  -webkit-transition: text-indent 0.3s ease;
  -o-transition: text-indent 0.3s ease;
  transition: text-indent 0.3s ease;
  top: auto;
}
input[type=checkbox].claro-min.claro-min-switch + .lbl::after {
  font-family: Roboto;
  content: 'III';
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  color: #AAA;
  text-shadow: none;
  background-color: #FFF;
  border-radius: 100%;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  position: absolute;
  top: -2px;
  left: -3px;
  -webkit-box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);
  -webkit-transition: left 0.3s ease;
  -o-transition: left 0.3s ease;
  transition: left 0.3s ease;
}
input[type=checkbox].claro-min.claro-min-switch:checked + .lbl::before {
  text-indent: 8px;
  color: #FFF;
  text-shadow: 0 0 0 #FFF;
  background-color: #8ab2c9;
  border-color: #6a8ca8;
}
input[type=checkbox].claro-min.claro-min-switch:checked + .lbl::after {
  left: 34px;
  background-color: #FFF;
  color: #98A0A5;
}
.form-control {
  color: #eeeeee;
  font-style: normal;
}
.form-control:focus {
  border-color: #d5d5d5;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;
}
.buscar .form-control {
  color: #eeeeee;
  font-style: normal;
}
.buscar .form-control:focus {
  border: 1px solid #555555;
  box-shadow: none;
}
.help-block {
  color: #6D6D6D;
}
.select-dropdown {
  margin-bottom: 20px;
}
@media (max-width: 991px) {
  .select-dropdown {
    width: 100%;
  }
}
.select-dropdown .caret {
  float: right;
  margin-top: 9px;
  color: red;
  border-top: 4px solid #eeeeee;
}
.select-dropdown .dropdown-menu {
  margin: 0;
  width: 100%;
  background-color: #232323;
  border: 1px solid #666666;
  border-top: none;
}
.select-dropdown .dropdown-menu > li:last-child > a {
  border-bottom: none;
}
.select-dropdown .dropdown-menu > li > a {
  cursor: pointer;
  border-bottom: 1px solid #373737;
  line-height: 50px;
  white-space: nowrap;
  color: #eeeeee;
}
.select-dropdown .dropdown-menu > li > a:hover,
.select-dropdown .dropdown-menu > li > a:focus {
  background-color: rgba(0, 0, 0, 0.3);
}
.select-dropdown .dropdown-menu:before,
.select-dropdown .dropdown-menu:after {
  display: none;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .form-tarjeta #cboBirthDateMonth,
  .form-tarjeta #cboBirthDateDay,
  .form-tarjeta #cboBirthDateYear {
    padding: 6px 4px;
  }
}
@media (min-width: 1200px) {
  .form-tarjeta #cboBirthDateMonth,
  .form-tarjeta #cboBirthDateDay,
  .form-tarjeta #cboBirthDateYear {
    padding: 6px 6px;
  }
}
/* TOOLTIP */
.dynover-frame.posU .fa-caret-left {
  position: absolute;
  top: 100px;
  left: -13px;
}
.dynover-frame.posD .fa-caret-left {
  position: absolute;
  bottom: 10px;
  left: -13px;
}
.dynover-frame.posU .fa-caret-right {
  position: absolute;
  left: 327px;
  top: 100px;
}
.dynover-frame.posD .fa-caret-right {
  position: absolute;
  left: 327px;
  bottom: 10px;
}
.popover {
  max-width: none;
  padding: 0;
}
.popover-content {
  padding: 0;
}
.tooltip-metadata {
  background: #FFF;
  width: 330px;
}
.tooltip-metadata h4 {
  margin-top: 3px;
  text-decoration: none;
}
.tooltip-metadata .item-serie-titulo-episodio {
  float: left;
  width: 100%;
}
.tooltip-metadata .label-default {
  /*border-radius: 0;
        background: @gray-darker;
        text-transform: uppercase;*/
}
.tooltip-metadata .item-rating {
  /* background: @white;
        color: @gray-darker;
        border: 1px solid @gray;*/
}
.tooltip-metadata .tooltip-score {
  cursor: default;
}
.tooltip-metadata .tooltip-score i {
  cursor: pointer;
}
.tooltip-metadata .tooltip-footer h6 {
  float: left;
}
.tooltip-metadata .tooltip-footer i {
  color: #FFF;
}
.tooltip-metadata .precio-renta h2 {
  color: #FFF;
  margin: 0;
}
.tooltip-metadata .precio-renta h5 {
  margin: 0;
}
.tooltip-score {
  cursor: default;
  display: inline-block;
}
.tooltip-score i {
  cursor: pointer;
}
.tooltip-score .fa-star-o,
.tooltip-score .fa-star,
.tooltip-score .fa-star-half-o {
  color: #EBAE3B;
}
.panel-gray1 {
  background-color: #232323;
}
.tooltip-footer {
  display: table;
}
.dynover-frame > .fa {
  color: #222222;
}
/* Estilos  VisTIME */
.vistime-progress-bar-wrapper {
  padding-top: 5px;
  line-height: 0;
  text-align: left;
  margin: 0;
  padding: 0;
}
.vistime-data-info {
  display: inline-block;
  float: left;
  display: none;
  /*se apaga*/
}
.vistime-data-info label {
  display: inline-block;
  color: #FFF;
  font-size: 10px;
  position: absolute;
  text-align: center;
  top: 9px;
}
.vistime-data-info .vistime-data-time {
  display: none;
}
.vistime-data-info .vistime-data-seconds {
  display: none;
}
.vistime-data-info .vistime-data-minutes {
  display: block;
}
.vistime-data-date {
  display: block;
  float: left;
  font-size: 10px;
  margin-left: 6px;
  width: 137px;
  display: none;
}
.jcarousel-skin-recentlywatched .vistime-data-date {
  display: none;
}
.vistime-bar {
  background-color: #FFF;
  height: 10px;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
}
.vistime-data-duration .vistime-data-time {
  display: none;
}
.vistime-data-duration .vistime-data-seconds {
  display: none;
}
.vistime-data-duration .vistime-data-minutes {
  display: block;
}
.vistime-data-duration {
  display: inline-block;
  color: #000;
  float: right;
  display: none;
  /*se apaga*/
}
.vistime-data-duration label {
  display: inline-block;
  color: #999999;
  font-size: 0.8125em;
  font-size: 10px;
  position: absolute;
  right: 0;
  text-align: center;
  top: 9px;
}
.vistime-progress-last {
  background: none repeat scroll 0 0 none;
  display: inline-block;
  position: absolute;
  height: 10px;
  width: 90%;
  left: 5%;
  bottom: 0;
  padding: 1px;
  margin-top: 3px;
  border-radius: 6px;
  overflow: hidden;
  z-index: 99;
  /*revisar esto*/
  border: 1px solid #FFF;
}
.vistime-progress-last .vistime-data-info label {
  top: 13px;
}
.vistime-progress-last .vistime-data-duration label {
  right: 3px;
  top: 13px;
}
.jcarousel-container .vistime-progress-last .vistime-data-info label,
.jcarousel-container .vistime-progress-last .vistime-data-duration label {
  top: 15px;
}
@media (max-width: 767px) {
  .layout-landing1 .navbar-wrapper-sm {
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 10;
  }
}
@media (min-width: 768px) {
  .layout-landing1 .navbar-wrapper-lg {
    margin-top: 20px;
  }
}
.panel-transp-70 {
  background: rgba(30, 30, 30, 0.7);
}
.que-es .panel-lg h2 {
  color: #FFF;
  font-weight: bold;
}
.que-es .panel-lg p {
  font-size: 17.92px;
}
@media (min-width: 992px) {
  .que-es .panel-lg {
    background: rgba(30, 30, 30, 0);
    box-shadow: none;
  }
}
@media (max-width: 991px) {
  .pull-down {
    margin-top: 40%;
  }
}
@media (max-width: 360px) {
  .pull-down {
    margin-top: 65%;
  }
}
@media (max-width: 1199px) {
  .text-md-dark {
    color: #333333;
  }
  .text-md-light {
    color: #eeeeee;
  }
}
.precio .moneda {
  font-family: Roboto;
  font-size: 32.2px;
  display: block;
  line-height: 2.14285714;
}
.precio .monto {
  font-family: Roboto;
  font-weight: bold;
  font-size: 79.8px;
  line-height: 1;
  letter-spacing: 0px;
}
.precio .asterisco {
  font-family: Roboto;
  font-weight: bold;
  font-size: 19.6px;
  display: block;
  line-height: 1.42857143;
}
.precio .periodo {
  font-family: Roboto;
  font-size: 28px;
  display: block;
  line-height: 0.5;
  margin: 0px 0 0 14px;
}
@media (max-width: 360px) {
  .layout-landing1 .col-xxs-12 {
    width: 100%;
  }
}
.layout-landing1 .precio-container {
  display: table;
  margin: 0 auto;
  float: none;
}
@media (max-width: 360px) {
  .layout-landing1 .precio {
    margin-bottom: 20px;
  }
}
.layout-landing1 .precio .moneda {
  font-family: Roboto;
  font-size: 32.2px;
  display: block;
  line-height: 2.14285714;
}
.layout-landing1 .precio .monto {
  font-family: Roboto;
  font-weight: bold;
  font-size: 70px;
  line-height: 1;
  letter-spacing: 0px;
}
.layout-landing1 .precio .asterisco {
  font-family: Roboto;
  font-weight: bold;
  font-size: 19.6px;
  display: block;
  line-height: 1.42857143;
}
.layout-landing1 .precio .periodo {
  font-family: Roboto;
  font-size: 17.92px;
  display: block;
  line-height: 1;
  float: none;
  clear: both;
  margin: 0px;
}
.layout-landing1 .precio-4-5-cifras .moneda {
  font-size: 23.8px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing1 .precio-4-5-cifras .moneda {
    font-size: 16.8px;
  }
}
.layout-landing1 .precio-4-5-cifras .monto {
  font-size: 53.9px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing1 .precio-4-5-cifras .monto {
    font-size: 40.6px;
  }
}
.layout-landing1 .precio-4-5-cifras .asterisco {
  font-size: 14px;
}
.layout-landing1 .precio-4-5-cifras .periodo {
  font-size: 17.92px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing1 .precio-4-5-cifras .periodo {
    font-size: 15.96px;
  }
}
.layout-landing1 .pasos {
  height: 258px;
  padding-left: 30px;
}
.layout-landing1 .pasos li {
  width: 28%;
  margin: 15px 18px 0 0;
}
.layout-landing1 .pasos p {
  line-height: 1.07142857;
  margin: 0px;
}
.layout-landing1 .pasos .thumb {
  margin-bottom: 10px;
}
.layout-landing1 .pasos h3 {
  font-family: Roboto;
  font-size: 25.9px;
}
.layout-landing1 .pasos h4 {
  font-family: Roboto;
  font-size: 25.9px;
  margin: 15px 10px 0 10px;
}
.layout-landing1 .donde {
  height: 258px;
}
@media (min-width: 320px) and (max-width: 991px) {
  .layout-landing1 .donde {
    height: 200px;
  }
}
.layout-landing1 .donde .dispositivos {
  margin-top: 20px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .layout-landing1 .donde .dispositivos {
    margin-top: 0px;
  }
}
.layout-landing1 .donde .dispositivos ul {
  display: inline-block;
  list-style: none outside none;
  margin: 0;
  padding: 0;
}
@media (min-width: 768px) and (max-width: 1199px) {
  .layout-landing1 .donde .dispositivos ul {
    width: 266px;
  }
}
@media (min-width: 320px) and (max-width: 479px) {
  .layout-landing1 .donde .dispositivos ul {
    width: 266px;
  }
}
.layout-landing1 .donde .dispositivos ul li {
  display: inline-block;
  margin: 5px 0;
}
.layout-landing1 .donde .dispositivos ul li img {
  width: 55px;
}
.layout-landing1 .donde .dispositivos ul li span {
  display: block;
}
@media (min-width: 320px) and (max-width: 991px) {
  .layout-landing1 .donde .dispositivos ul li span {
    display: none;
  }
}
.layout-landing1 .donde .descargas li {
  display: inline-block;
  margin: 5px 0;
}
@media (min-width: 320px) and (max-width: 991px) {
  .layout-landing1 .donde .descargas {
    height: 270px;
  }
}
.layout-landing1 .donde h3 {
  font-family: Roboto;
  font-size: 25.9px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .layout-landing1 .donde h3 {
    font-size: 23.8px;
  }
}
.layout-landing1 .donde strong {
  font-family: Roboto;
  font-weight: bold;
}
.layout-landing1 .registrate p {
  margin-top: 5px;
}
.layout-landing1 .content-banner {
  margin-bottom: 10px;
}
.layout-landing1 .content-banner ul li img {
  max-width: 574px;
  width: 100%;
  margin-bottom: 10px;
}
@media (max-width: 991px) {
  .layout-landing1 .content-banner li.col-xs-12,
  .layout-landing1 .content-banner li.col-sm-12 {
    padding-left: 0px;
  }
}
.layout-landing1 header {
  /* Chat Button */
}
.layout-landing1 header .btn {
  margin: 0px 10px;
}
@media (max-width: 767px) {
  .layout-landing1 header .btn {
    margin-left: 0px;
    padding: 10px;
  }
}
.layout-landing1 header .main-logo {
  margin-bottom: 0;
  margin-top: -8px;
}
.layout-landing1 header .ingresa {
  padding-top: 3px;
}
.layout-landing1 header .brand-right {
  padding: 7px;
}
.layout-landing1 header .navbar-text {
  margin-bottom: 8px;
  margin-top: 8px;
}
.layout-landing1 header .chat-button {
  float: right;
  margin-left: 11px;
  position: relative;
}
.layout-landing1 .publicidad-300 {
  border: none;
  box-shadow: none;
  padding: 4px;
}
@media (max-width: 767px) {
  .layout-landing1 .publicidad-300 {
    background: none;
  }
}
.layout-landing1 .publicidad-300 h3 {
  margin: 0px;
}
@media (max-width: 767px) {
  .layout-landing1 .que-es p {
    margin-bottom: 0;
  }
  .layout-landing1 .panel.padding-2 {
    padding: 10px;
  }
  .layout-landing1 .panel {
    margin-bottom: 10px;
  }
  .layout-landing1 .precio {
    margin-bottom: 10px;
  }
}
@media (min-width: 1200px) {
  .layout-landing1 .pasos {
    width: 525px;
  }
  .layout-landing1 .publicidad-300 {
    border: 4px solid #FFF;
    border-radius: 2px;
    margin-left: 56px;
    padding: 0;
    width: 308px;
  }
}
@media (max-width: 991px) {
  .centro-descarga {
    padding-bottom: 10px;
  }
}
@media (max-width: 1199px) {
  .icono-descarga {
    padding-bottom: 10px;
  }
}
@media (min-width: 1200px) {
  .icono-padding {
    padding-left: 20px;
  }
}
@media (min-width: 1200px) {
  .padd-icono {
    text-align: right;
  }
}
@media (min-width: 1200px) {
  .padd-icono-l {
    text-align: left;
  }
}
body.layout-landing2 {
  padding-bottom: 25px;
  padding-top: 98px;
  color: #5a5a5a;
  /* CUSTOMIZE THE NAVBAR
    -------------------------------------------------- */
  /* Special class on .container surrounding .navbar, used for positioning it into place. */
  /* Flip around the padding for proper display in narrow viewports */
  /* Logo at NAVBAR */
  /* Images */
  /*secciones*/
  /*PRECIO*/
}
body.layout-landing2 .precio .monto {
  letter-spacing: -5px;
}
@media (max-width: 768px) {
  body.layout-landing2 {
    padding-top: 52px;
  }
}
body.layout-landing2 .navbar-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
}
body.layout-landing2 .navbar-wrapper .navbar {
  height: 75px;
  min-width: 480px;
  padding: 15px;
}
body.layout-landing2 .navbar-wrapper .container {
  padding-left: 0;
  padding-right: 0;
}
body.layout-landing2 .navbar-brand {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat scroll left top transparent;
  height: 30px;
  width: 190px;
}
body.layout-landing2 .navbar-brand span {
  display: none;
}
body.layout-landing2 .navbar .brand-2 {
  margin-left: 10px;
}
body.layout-landing2 .navbar .brand-2 span {
  display: none;
}
body.layout-landing2 .chat-button {
  position: relative;
  margin-right: 4px;
  top: -2px;
}
body.layout-landing2 .img-circle,
body.layout-landing2 .img-rounded,
body.layout-landing2 .img-thumbnail {
  margin: 5px;
}
body.layout-landing2 .legal {
  margin: 10px auto 0;
  display: table;
  font-size: 20px;
}
body.layout-landing2 .legal span {
  font-weight: bold;
  color: #8f8f8f;
}
body.layout-landing2 header.main-header {
  height: auto;
  border-bottom: none;
}
body.layout-landing2 .section-1 {
  background: #eeeeee;
}
body.layout-landing2 .section-1.text-module h2 {
  margin: 0;
}
body.layout-landing2 .section-2 {
  background: #666;
  min-height: 152px;
  color: #CCC;
}
body.layout-landing2 .section-3 {
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);
  padding: 20px 0 30px;
  color: #FFF;
}
body.layout-landing2 .section-3 .img-rounded.img-responsivel {
  height: 324px;
  width: 576px;
}
body.layout-landing2 .section-3 .img-rounded.img-responsive2 {
  height: 324px;
  width: 576px;
}
body.layout-landing2 .section-4 {
  background: #eeeeee;
}
body.layout-landing2 .section-5 {
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);
  color: #FFF;
  padding-top: 20px;
}
body.layout-landing2 .section-5 .jcarousel-3 .lead {
  font-size: 14px;
}
body.layout-landing2 .section-5.especial {
  padding: 30px 0;
}
body.layout-landing2 .section-5 .principal,
body.layout-landing2 .section-5 .secundario,
body.layout-landing2 .section-5 .jcarousel-item {
  background-image: -moz-linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);
  background-image: -webkit-gradient(linear, color-stop(0, rgba(0, 0, 0, 0)), color-stop(0.99, rgba(0, 0, 0, 0.8)));
  background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);
  background-image: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);
}
body.layout-landing2 .section-5 .brand-especial {
  margin: 10px;
}
body.layout-landing2 .section-6 {
  background: #000;
  color: #FFF;
}
body.layout-landing2 .section-7 {
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);
  padding: 30px 0;
  color: #FFF;
}
body.layout-landing2 .section-8 {
  background: #eeeeee;
  padding-bottom: 20px;
}
body.layout-landing2 .section-9 {
  background: #232323;
}
body.layout-landing2 .section-9 p {
  color: #FFF;
  font-size: 20px;
}
body.layout-landing2 .btn-block {
  margin-top: 15px;
}
body.layout-landing2 .precio {
  padding: 0 6px;
}
body.layout-landing2 .precio-left,
body.layout-landing2 .precio-right {
  display: block;
  height: 130px;
  width: 30px;
}
body.layout-landing2 .precio > div {
  float: left;
}
body.layout-landing2 .precio-center {
  background: none repeat scroll 0 0 #EA2F23;
  color: #FFF;
  height: 130px;
  padding: 10px;
}
body.layout-landing2 .precio .periodo {
  clear: both;
}
div body.layout-landing2 .precio .periodo {
  float: left;
  clear: both;
}
body.layout-landing2 .section-5 .h4-especial {
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.disable .jcarousel-1.vertical .jcarousel-container-1 img {
  height: 220px;
  width: 147px;
}
.jcarousel-3.horizontal .disable .jcarousel-container-1 img {
  height: 300px;
  width: 200px;
}
.jcarousel-3.horizontal .jcarousel-container-2 img {
  height: 145px;
  width: 256px;
}
body.layout-landing2 .carousel.slide .cliente img {
  width: auto;
}
body.navigator-platform-android section,
body.navigator-platform-iphone section,
body.navigator-platform-ipad section {
  /* background-attachment: scroll !important;
     background-position: center !important;*/
}
.nav-pills > li + li {
  margin-left: 5px;
}
/* RESPONSIVE CSS
-------------------------------------------------- */
@media (max-width: 768px) {
  /* Remove the edge padding needed for mobile */
  body.layout-landing2 .precio .periodo {
    font-size: 23px;
  }
  .text-module h2 {
    margin: 0;
  }
  .section-1.text-module h2 {
    font-size: 20px;
  }
  .section-0 .carousel-caption {
    position: relative;
    left: 0%;
  }
}
@media (max-width: 1200px) {
  /* Remove the edge padding needed for mobile */
  .section-1.text-module .center {
    padding: 25px;
  }
}
@media (max-width: 990px) {
  /* Remove the edge padding needed for mobile */
  .section-1.text-module .center {
    padding: 15px;
  }
}
body.layout-landing2 .nav.nav-pills.navbar-right {
  padding: 30px 10px;
}
.logo-especial {
  padding: 0 20px 20px 0;
}
@media (max-width: 767px) {
  .layout-landing03 .navbar-wrapper-sm {
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 10;
  }
}
@media (min-width: 768px) {
  .layout-landing03 .navbar-wrapper-lg {
    margin-top: 20px;
  }
}
.panel-transp-70 {
  background: rgba(30, 30, 30, 0.7);
}
.que-es .panel-lg h2 {
  color: #FFF;
  font-weight: bold;
}
.que-es .panel-lg p {
  font-size: 17.92px;
}
@media (min-width: 992px) {
  .que-es .panel-lg {
    background: rgba(30, 30, 30, 0);
    box-shadow: none;
  }
}
@media (max-width: 991px) {
  .pull-down {
    margin-top: 40%;
  }
}
@media (max-width: 360px) {
  .pull-down {
    margin-top: 65%;
  }
}
@media (max-width: 1199px) {
  .text-md-dark {
    color: #333333;
  }
  .text-md-light {
    color: #eeeeee;
  }
}
.precio .moneda {
  font-family: Roboto;
  font-size: 32.2px;
  display: block;
  line-height: 2.14285714;
}
.precio .monto {
  font-family: Roboto;
  font-weight: bold;
  font-size: 79.8px;
  line-height: 1;
  letter-spacing: 0px;
}
.precio .asterisco {
  font-family: Roboto;
  font-weight: bold;
  font-size: 19.6px;
  display: block;
  line-height: 1.42857143;
}
.precio .periodo {
  font-family: Roboto;
  font-size: 28px;
  display: block;
  line-height: 0.5;
  margin: 0px 0 0 14px;
}
@media (max-width: 360px) {
  .layout-landing03 .col-xxs-12 {
    width: 100%;
  }
}
.layout-landing03 .precio-container {
  display: table;
  margin: 0 auto;
  float: none;
}
@media (max-width: 360px) {
  .layout-landing03 .precio {
    margin-bottom: 20px;
  }
}
.layout-landing03 .precio .moneda {
  font-family: Roboto;
  font-size: 32.2px;
  display: block;
  line-height: 2.14285714;
}
.layout-landing03 .precio .monto {
  font-family: Roboto;
  font-weight: bold;
  font-size: 70px;
  line-height: 1;
  letter-spacing: 0px;
}
.layout-landing03 .precio .asterisco {
  font-family: Roboto;
  font-weight: bold;
  font-size: 19.6px;
  display: block;
  line-height: 1.42857143;
}
.layout-landing03 .precio .periodo {
  font-family: Roboto;
  font-size: 17.92px;
  display: block;
  line-height: 1;
  float: none;
  clear: both;
  margin: 0px;
}
.layout-landing03 .precio-4-5-cifras .moneda {
  font-size: 23.8px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing03 .precio-4-5-cifras .moneda {
    font-size: 16.8px;
  }
}
.layout-landing03 .precio-4-5-cifras .monto {
  font-size: 53.9px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing03 .precio-4-5-cifras .monto {
    font-size: 40.6px;
  }
}
.layout-landing03 .precio-4-5-cifras .asterisco {
  font-size: 14px;
}
.layout-landing03 .precio-4-5-cifras .periodo {
  font-size: 17.92px;
}
@media (min-width: 361px) and (max-width: 991px) {
  .layout-landing03 .precio-4-5-cifras .periodo {
    font-size: 15.96px;
  }
}
.layout-landing03 .pasos {
  height: 258px;
  padding-left: 30px;
}
.layout-landing03 .pasos li {
  width: 28%;
  margin: 15px 18px 0 0;
}
.layout-landing03 .pasos p {
  line-height: 1.07142857;
  margin: 0px;
}
.layout-landing03 .pasos .thumb {
  margin-bottom: 10px;
}
.layout-landing03 .pasos h3 {
  font-family: Roboto;
  font-size: 25.9px;
}
.layout-landing03 .pasos h4 {
  font-family: Roboto;
  font-size: 25.9px;
  margin: 15px 10px 0 10px;
}
.layout-landing03 .donde {
  height: 140px;
}
@media (min-width: 480px) and (max-width: 991px) {
  .layout-landing03 .donde {
    height: 125px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .layout-landing03 .donde h4 {
    font-size: 13.86px;
  }
}
@media (max-width: 479px) {
  .layout-landing03 .donde h4 {
    font-size: 13.72px;
  }
}
.layout-landing03 .donde .dispositivos {
  margin-top: 20px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .layout-landing03 .donde .dispositivos {
    margin-top: 0px;
  }
}
.layout-landing03 .donde .dispositivos ul {
  display: inline-block;
  list-style: none outside none;
  margin: 0;
  padding: 0;
}
.layout-landing03 .donde .dispositivos ul li {
  display: inline-block;
  margin: 5px 0;
}
.layout-landing03 .donde .dispositivos ul li img {
  width: 55px;
}
@media (min-width: 480px) and (max-width: 991px) {
  .layout-landing03 .donde .dispositivos ul li img {
    width: 45px;
  }
}
@media (max-width: 479px) {
  .layout-landing03 .donde .dispositivos ul li img {
    width: 42px;
  }
}
.layout-landing03 .donde .dispositivos ul li span {
  display: block;
  padding-top: 5px;
}
@media (min-width: 768px) and (max-width: 1199px) {
  .layout-landing03 .donde .dispositivos ul li span {
    font-size: 11.9px;
  }
}
@media (max-width: 991px) {
  .layout-landing03 .donde .dispositivos ul li span {
    display: none;
  }
}
.layout-landing03 .donde .descargas li {
  display: inline-block;
  margin: 5px 0;
}
@media (min-width: 768px) and (max-width: 1199px) {
  .layout-landing03 .donde .descargas .centro-descarga {
    height: 43px;
  }
}
@media (min-width: 480px) and (max-width: 991px) {
  .layout-landing03 .donde .descargas .centro-descarga {
    height: 41px;
  }
}
@media (max-width: 479px) {
  .layout-landing03 .donde .descargas .centro-descarga {
    height: 39px;
  }
}
.layout-landing03 .donde h3 {
  font-family: Roboto;
  font-size: 25.9px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .layout-landing03 .donde h3 {
    font-size: 23.8px;
  }
}
.layout-landing03 .donde strong {
  font-family: Roboto;
  font-weight: bold;
}
.layout-landing03 .registrate p {
  margin-top: 5px;
}
.layout-landing03 .content-banner {
  margin-bottom: 10px;
}
.layout-landing03 .content-banner ul li img {
  max-width: 574px;
  width: 100%;
  margin-bottom: 10px;
}
@media (max-width: 991px) {
  .layout-landing03 .content-banner li.col-xs-12,
  .layout-landing03 .content-banner li.col-sm-12 {
    padding-left: 0px;
  }
}
.layout-landing03 header {
  /* Chat Button */
}
.layout-landing03 header .btn {
  margin: 0px 10px;
}
@media (max-width: 767px) {
  .layout-landing03 header .btn {
    margin-left: 0px;
    padding: 10px;
  }
}
.layout-landing03 header .main-logo {
  margin-bottom: 0;
  margin-top: -8px;
}
.layout-landing03 header .ingresa {
  padding-top: 3px;
}
.layout-landing03 header .brand-right {
  padding: 7px;
}
.layout-landing03 header .navbar-text {
  margin-bottom: 8px;
  margin-top: 8px;
}
.layout-landing03 header .chat-button {
  float: right;
  margin-left: 11px;
  position: relative;
}
.layout-landing03 header .chat-button2 a {
  text-decoration: underline;
}
.layout-landing03 header .chat-button2 a i {
  padding-right: 5px;
}
.layout-landing03 .publicidad-300 {
  border: none;
  box-shadow: none;
  padding: 4px;
}
@media (max-width: 767px) {
  .layout-landing03 .publicidad-300 {
    background: none;
  }
}
.layout-landing03 .publicidad-300 h3 {
  margin: 0px;
}
@media (max-width: 767px) {
  .layout-landing03 .que-es p {
    margin-bottom: 0;
  }
  .layout-landing03 .panel.padding-2 {
    padding: 10px;
  }
  .layout-landing03 .panel {
    margin-bottom: 10px;
  }
  .layout-landing03 .precio {
    margin-bottom: 10px;
  }
}
@media (min-width: 1200px) {
  .layout-landing03 .pasos {
    width: 525px;
  }
  .layout-landing03 .publicidad-300 {
    border: 4px solid #FFF;
    border-radius: 2px;
    margin-left: 56px;
    padding: 0;
    width: 308px;
  }
}
@media (max-width: 991px) {
  .centro-descarga {
    padding-bottom: 10px;
  }
}
@media (max-width: 1199px) {
  .icono-descarga {
    padding-bottom: 10px;
  }
}
@media (min-width: 1200px) {
  .icono-padding {
    padding-left: 20px;
  }
}
@media (min-width: 1200px) {
  .padd-icono {
    text-align: right;
  }
}
@media (min-width: 1200px) {
  .padd-icono-l {
    text-align: left;
  }
}
.layout-landing03 .carousel.slide .carousel-caption img {
  width: auto;
}
.layout-landing03 .txt-promo {
  margin-bottom: -4px;
  float: left;
}
.promo-bajada {
  display: table;
}
.promo-bajada li {
  vertical-align: middle;
  padding: 0;
}
/*XS*/
@media (max-width: 768px) {
  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {
    height: 251px;
  }
}
@media (max-width: 480px) {
  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {
    height: 251px;
    height: auto;
    width: 100%;
  }
}
/* sm */
@media (min-width: 768px) and (max-width: 1919px) {
  /*SM & MD*/
  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {
    height: 163px;
  }
}
@media (min-width: 1200px) {
  /*LG */
  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {
    height: 251px;
  }
}
.layout-landing03 .bg-blur-wrapper {
  position: absolute;
  z-index: -5;
  top: 0;
  left: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.2), #000);
  display: block;
  margin: 0;
  overflow: hidden;
  width: 100%;
}
.layout-landing03 .carousel-indicators {
  bottom: 0px;
}
.layout-landing03 .carousel-caption {
  bottom: 25px;
}
.layout-landing03 header .navbar {
  z-index: 3;
}
.layout-landing03 .bg-blur-wrapper img {
  width: 100%;
  height: auto;
}
.layout-landing03 .bg-blur-wrapper img.blur {
  left: 50%;
  margin-left: -540px;
  position: relative;
  z-index: -1;
  width: auto;
}
@media (max-width: 768px) {
  .layout-landing03 .bg-blur-wrapper img {
    opacity: 0.8;
  }
}
.layout-landing03 .main-wrapper > img {
  height: auto;
  width: 100%;
}
@media (min-width: 768px) {
  .layout-landing03 .main-wrapper {
    margin-top: -105px;
  }
}
@media (min-width: 768px) and (max-width: 1919px) {
  /*SM & MD*/
  .layout-landing03 .carousel.slide .carousel-inner {
    padding-top: calc(100% * 0.562264);
  }
}
@media (min-width: 1200px) {
  /*LG */
  .layout-landing03 .carousel.slide .carousel-inner {
    padding-top: calc(100% * 0.4546875);
  }
}
/*XS*/
/*@media (max-width: @screen-xs) {
    .layout-landing03 .carousel.slide .carousel-inner {}
}*/
/**/
/*mediaquery Xs para landing*/
@media (max-width: 767px) {
  .landing.layout-landing03 .bg-blur-wrapper {
    position: absolute;
  }
  .landing.layout-landing03 .section-destacado {
    min-height: 610px;
  }
  .landing.layout-landing03 .carousel-caption {
    bottom: auto;
  }
}
.layout-landing03 .dispositivos li span {
  font-size: 11.5px;
  color: #DDDDDD;
}
@media (max-width: 767px) {
  .layout-landing03 .bg-blur-wrapper:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, #000000 100%);
  }
}
.layout-landing03 .carousel.slide.destacado h2 {
  font-size: 27px;
}
@media (min-width: 1920px) {
  body.layout-registro,
  body.layout-registro-logout {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (max-width: 1919px) {
  body.layout-registro,
  body.layout-registro-logout {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (min-width: 1920px) {
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (max-width: 1919px) {
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (max-width: 1199px) {
  body.layout-registro,
  body.layout-registro-logout,
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur,
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (max-width: 991px) {
  body.layout-registro,
  body.layout-registro-logout,
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat left bottom #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur,
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat left bottom #000;
    background-size: 100%;
  }
}
@media (max-width: 767px) {
  body.layout-registro,
  body.layout-registro-logout,
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0 34px #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur,
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background-image: none;
    background-color: transparent;
  }
}
@media (max-width: 360px) {
  body.layout-registro,
  body.layout-registro-logout,
  body.layout-registro.region-peru,
  body.layout-registro-logout.region-peru,
  body.layout-registro.region-mexico,
  body.layout-registro-logout.region-mexico {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0 72px #000;
    background-size: 100%;
  }
  body.layout-registro .bg-blur,
  body.layout-registro-logout .bg-blur,
  body.layout-registro.region-peru .bg-blur,
  body.layout-registro-logout.region-peru .bg-blur,
  body.layout-registro.region-mexico .bg-blur,
  body.layout-registro-logout.region-mexico .bg-blur {
    background-image: none;
    background-color: transparent;
  }
}
.registro .promocional,
.renta .promocional {
  display: table;
  min-height: 750px;
  padding: 40px 20px 20px 20px;
}
.registro .promocional .oferta h2,
.renta .promocional .oferta h2,
.registro .promocional .oferta h3,
.renta .promocional .oferta h3,
.registro .promocional .oferta h4,
.renta .promocional .oferta h4 {
  color: #FFF;
}
.registro .promocional .oferta h2,
.renta .promocional .oferta h2 {
  margin-top: 0px;
}
.registro .promocional .oferta h2 strong,
.renta .promocional .oferta h2 strong,
.registro .promocional .oferta h2 span,
.renta .promocional .oferta h2 span {
  color: #FFF;
}
.registro .promocional .oferta h3,
.renta .promocional .oferta h3 {
  font-size: 17.92px;
}
.registro .promocional .oferta h4,
.renta .promocional .oferta h4 {
  font-size: 14.98px;
}
.registro .promocional .oferta h4 small,
.renta .promocional .oferta h4 small {
  display: block;
}
.registro .promocional .oferta h4 .infinitum,
.renta .promocional .oferta h4 .infinitum {
  color: #555555;
  font-weight: bold;
}
@media (max-width: 991px) {
  .registro .promocional .oferta,
  .renta .promocional .oferta {
    width: 330px;
  }
}
.registro .col-form,
.renta .col-form {
  min-height: 750px;
}
.region-mexico .registro .oferta h2,
.region-mexico .registro .oferta h3,
.region-mexico .registro .oferta h4 {
  color: #eeeeee;
}
.region-mexico .registro .userdetectws h2,
.region-mexico .registro .userdetectws h3,
.region-mexico .registro .userdetectws h4 {
  color: #333333;
}
/*
Version: @@ver@@ Timestamp: @@timestamp@@
*/
.select2-container {
  margin: 0;
  position: relative;
  display: inline-block;
  /* inline-block for ie7 */
  zoom: 1;
  *display: inline;
  vertical-align: middle;
}
.select2-container,
.select2-drop,
.select2-search,
.select2-search input {
  /*
    Force border-box so that % widths fit the parent
    container without overlap because of margin/padding.
    More Info : http://www.quirksmode.org/css/box.html
  */
  min-width: 180px;
  -webkit-box-sizing: border-box;
  /* webkit */
  -moz-box-sizing: border-box;
  /* firefox */
  box-sizing: border-box;
  /* css3 */
}
.select2-container .select2-choice {
  display: block;
  height: 30px;
  padding: 0 0 0 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid #666;
  white-space: nowrap;
  line-height: 30px;
  color: #444;
  text-decoration: none;
  border-radius: 2px;
  margin-bottom: 1px;
  background-clip: padding-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #FFF;
  /*background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.5, #fff));
    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 50%);
    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 50%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#ffffff', endColorstr = '#eeeeee', GradientType = 0);
    background-image: linear-gradient(to top, #eee 0%, #fff 50%);*/
}
.select2-container.select2-drop-above .select2-choice {
  border-bottom-color: #666;
  border-radius: 0 0 2px 2px;
  /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.9, #fff));
    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 90%);
    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 90%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#eeeeee', GradientType=0);
    background-image: linear-gradient(to bottom, #eee 0%, #fff 90%);*/
}
.select2-container.select2-allowclear .select2-choice .select2-chosen {
  margin-right: 42px;
}
.select2-container .select2-choice > .select2-chosen {
  margin-right: 26px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  float: none;
  width: auto;
}
.select2-container .select2-choice abbr {
  display: none;
  width: 12px;
  height: 12px;
  position: absolute;
  right: 24px;
  top: 8px;
  font-size: 1px;
  text-decoration: none;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right top no-repeat;
  cursor: pointer;
  outline: 0;
}
.select2-container.select2-allowclear .select2-choice abbr {
  display: inline-block;
}
.select2-container .select2-choice abbr:hover {
  background-position: right -11px;
  cursor: pointer;
}
.select2-drop-mask {
  border: 0;
  margin: 0;
  padding: 0;
  position: fixed;
  left: 0;
  top: 0;
  min-height: 100%;
  min-width: 100%;
  height: auto;
  width: auto;
  opacity: 0;
  z-index: 9998;
  /* styles required for IE to work */
  background-color: #FFF;
  filter: alpha(opacity=0);
}
.select2-drop {
  width: 100%;
  margin-top: -1px;
  position: absolute;
  z-index: 9999;
  top: 100%;
  background: #FFF;
  color: #000;
  border: 1px solid #666;
  border-top: 0;
  border-radius: 0 0 2px 2px;
  -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);
}
.select2-drop.select2-drop-above {
  margin-top: 1px;
  border-top: 1px solid #666;
  border-bottom: 0;
  border-radius: 2px 2px 0 0;
  -webkit-box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.15);
  box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.15);
}
.select2-drop-active {
  border: 1px solid #CCC;
  border-top: none;
}
.select2-drop.select2-drop-above.select2-drop-active {
  border-top: 1px solid #CCC;
}
.select2-drop-auto-width {
  border-top: 1px solid #666;
  width: auto;
}
.select2-drop-auto-width .select2-search {
  padding-top: 4px;
}
.select2-container .select2-choice .select2-arrow {
  display: inline-block;
  width: 18px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  /*border-left: 1px solid @gray6;
    border-radius: 0 2px 2px 0;*/
  background-clip: padding-box;
  /* background: @grayc;
    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #ccc), color-stop(0.6, #eee));
    background-image: -webkit-linear-gradient(center bottom, #ccc 0%, #eee 60%);
    background-image: -moz-linear-gradient(center bottom, #ccc 0%, #eee 60%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#eeeeee', endColorstr = '@grayc', GradientType = 0);
    background-image: linear-gradient(to top, #ccc 0%, #eee 60%);*/
}
.select2-container .select2-choice .select2-arrow b {
  display: block;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 0 1px;
}
.select2-search {
  display: inline-block;
  width: 100%;
  min-height: 26px;
  margin: 0;
  padding-left: 4px;
  padding-right: 4px;
  position: relative;
  z-index: 10000;
  white-space: nowrap;
}
.select2-search input {
  width: 100%;
  height: auto !important;
  min-height: 26px;
  padding: 4px 20px 4px 5px;
  margin: 0;
  outline: 0;
  border: 1px solid #666;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 100% -22px;
  /* background: url("../images/select2.png") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));
    background: url("../images/select2.png") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);
    background: url("../images/select2.png") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);
    background: url("../images/select2.png") no-repeat 100% -22px, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/
}
.select2-drop.select2-drop-above .select2-search input {
  margin-top: 4px;
}
.select2-search input.select2-active {
  background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 100%;
  /* background: url("../images/select2-spinner.gif") no-repeat 100%, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));
    background: url("../images/select2-spinner.gif") no-repeat 100%, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);
    background: url("../images/select2-spinner.gif") no-repeat 100%, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);
    background: url("../images/select2-spinner.gif") no-repeat 100%, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/
}
.select2-container-active .select2-choice,
.select2-container-active .select2-choices {
  border: 1px solid #CCC;
  outline: none;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.select2-dropdown-open .select2-choice {
  border-bottom-color: transparent;
  -webkit-box-shadow: 0 1px 0 #FFF inset;
  box-shadow: 0 1px 0 #FFF inset;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #FFF;
  /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #fff), color-stop(0.5, #eee));
    background-image: -webkit-linear-gradient(center bottom, #fff 0%, #eee 50%);
    background-image: -moz-linear-gradient(center bottom, #fff 0%, #eee 50%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);
    background-image: linear-gradient(to top, #fff 0%, #eee 50%);*/
}
.select2-dropdown-open.select2-drop-above .select2-choice,
.select2-dropdown-open.select2-drop-above .select2-choices {
  border: 1px solid #CCC;
  border-top-color: transparent;
  /* background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(0.5, #eee));
    background-image: -webkit-linear-gradient(center top, #fff 0%, #eee 50%);
    background-image: -moz-linear-gradient(center top, #fff 0%, #eee 50%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);
    background-image: linear-gradient(to bottom, #fff 0%, #eee 50%);*/
}
.select2-dropdown-open .select2-choice .select2-arrow {
  background: transparent;
  border-left: none;
  filter: none;
}
.select2-dropdown-open .select2-choice .select2-arrow b {
  background-position: -18px 1px;
}
.select2-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
/* results */
.select2-results {
  max-height: 200px;
  padding: 0 0 0 0px;
  /* margin: 4px 0px 4px 0;*/
  margin: 0px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.select2-results ul.select2-result-sub {
  margin: 0;
  padding-left: 0;
}
.select2-results li {
  list-style: none;
  display: list-item;
  background-image: none;
  border-top: 1px solid #CCC;
  color: #333333;
}
.select2-results li.select2-result-with-children > .select2-result-label {
  font-weight: bold;
}
.select2-results .select2-result-label {
  padding: 3px 7px 4px;
  margin: 0;
  cursor: pointer;
  min-height: 1em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.select2-results-dept-1 .select2-result-label {
  padding-left: 20px;
}
.select2-results-dept-2 .select2-result-label {
  padding-left: 40px;
}
.select2-results-dept-3 .select2-result-label {
  padding-left: 60px;
}
.select2-results-dept-4 .select2-result-label {
  padding-left: 80px;
}
.select2-results-dept-5 .select2-result-label {
  padding-left: 100px;
}
.select2-results-dept-6 .select2-result-label {
  padding-left: 110px;
}
.select2-results-dept-7 .select2-result-label {
  padding-left: 120px;
}
.select2-results .select2-highlighted {
  background: #999999;
  color: #FFF;
}
.select2-results li em {
  background: #feffde;
  font-style: normal;
}
.select2-results .select2-highlighted em {
  background: transparent;
}
.select2-results .select2-highlighted ul {
  background: #FFF;
  color: #000;
}
.select2-results .select2-no-results,
.select2-results .select2-searching,
.select2-results .select2-selection-limit {
  background: #F4F4F4;
  display: list-item;
  padding-left: 5px;
}
/*
disabled look for disabled choices in the results dropdown
*/
.select2-results .select2-disabled.select2-highlighted {
  color: #666;
  background: #F4F4F4;
  display: list-item;
  cursor: default;
}
.select2-results .select2-disabled {
  background: #F4F4F4;
  display: list-item;
  cursor: default;
}
.select2-results .select2-selected {
  display: none;
}
.select2-more-results.select2-active {
  background: #F4F4F4 url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 100%;
}
.select2-more-results {
  background: #F4F4F4;
  display: list-item;
}
/* disabled styles */
.select2-container.select2-container-disabled .select2-choice {
  background-color: #F4F4F4;
  background-image: none;
  border: 1px solid #DDD;
  cursor: default;
}
.select2-container.select2-container-disabled .select2-choice .select2-arrow {
  background-color: #F4F4F4;
  background-image: none;
  border-left: 0;
}
.select2-container.select2-container-disabled .select2-choice abbr {
  display: none;
}
/* multiselect */
.select2-container-multi .select2-choices {
  height: auto !important;
  height: 1%;
  margin: 0;
  padding: 0 5px 0 0;
  position: relative;
  border: 1px solid #666;
  cursor: text;
  overflow: hidden;
  background-color: red;
  /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(1%, #eee), color-stop(15%, #fff));
    background-image: -webkit-linear-gradient(top, #eee 1%, #fff 15%);
    background-image: -moz-linear-gradient(top, #eee 1%, #fff 15%);
    background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);*/
}
.select2-locked {
  padding: 3px 5px 3px 5px !important;
}
.select2-container-multi .select2-choices {
  min-height: 26px;
}
.select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #CCC;
  outline: none;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.select2-container-multi .select2-choices li {
  float: left;
  list-style: none;
}
html[dir="rtl"] .select2-container-multi .select2-choices li {
  float: right;
}
.select2-container-multi .select2-choices .select2-search-field {
  margin: 0;
  padding: 0;
  white-space: nowrap;
}
.select2-container-multi .select2-choices .select2-search-field input {
  padding: 5px;
  margin: 1px 0;
  font-size: 100%;
  color: #666;
  outline: 0;
  border: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: transparent !important;
}
.select2-container-multi .select2-choices .select2-search-field input.select2-active {
  background: #FFF url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 100% !important;
}
.select2-default {
  color: #999999 !important;
}
.select2-container-multi .select2-choices .select2-search-choice {
  padding: 3px 5px 3px 18px;
  margin: 3px 0 3px 5px;
  position: relative;
  line-height: 13px;
  color: #333333;
  cursor: default;
  border: 1px solid #666;
  border-radius: 2px;
  -webkit-box-shadow: 0 0 2px #FFF inset, 0 1px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 2px #FFF inset, 0 1px 0 rgba(0, 0, 0, 0.05);
  background-clip: padding-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #e4e4e4;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#f4f4f4', GradientType=0);
  /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(20%, #f4f4f4), color-stop(50%, #f0f0f0), color-stop(52%, #e8e8e8), color-stop(100%, #eee));
    background-image: -webkit-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);
    background-image: -moz-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);
    background-image: linear-gradient(to top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);*/
}
html[dir="rtl"] .select2-container-multi .select2-choices .select2-search-choice {
  margin-left: 0;
  margin-right: 5px;
}
.select2-container-multi .select2-choices .select2-search-choice .select2-chosen {
  cursor: default;
}
.select2-container-multi .select2-choices .select2-search-choice-focus {
  background: #d4d4d4;
}
.select2-search-choice-close {
  display: block;
  width: 12px;
  height: 13px;
  position: absolute;
  right: 3px;
  top: 4px;
  font-size: 1px;
  outline: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right top no-repeat;
}
html[dir="rtl"] .select2-search-choice-close {
  right: auto;
  left: 3px;
}
.select2-container-multi .select2-search-choice-close {
  left: 3px;
}
.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover {
  background-position: right -11px;
}
.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close {
  background-position: right -11px;
}
/* disabled styles */
.select2-container-multi.select2-container-disabled .select2-choices {
  background-color: #F4F4F4;
  background-image: none;
  border: 1px solid #DDD;
  cursor: default;
}
.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice {
  padding: 3px 5px 3px 5px;
  border: 1px solid #DDD;
  background-image: none;
  background-color: #F4F4F4;
}
.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close {
  display: none;
  background: none;
}
/* end multiselect */
.select2-result-selectable .select2-match,
.select2-result-unselectable .select2-match {
  text-decoration: underline;
}
.select2-offscreen,
.select2-offscreen:focus {
  clip: rect(0 0 0 0) !important;
  width: 1px !important;
  height: 1px !important;
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  position: absolute !important;
  outline: 0 !important;
  left: 0px !important;
  top: 0px !important;
}
.select2-display-none {
  display: none;
}
.select2-measure-scrollbar {
  position: absolute;
  top: -10000px;
  left: -10000px;
  width: 100px;
  height: 100px;
  overflow: scroll;
}
.form-control .select2-choice {
  border: 0;
  border-radius: 2px;
}
.form-control .select2-choice .select2-arrow {
  border-radius: 0 2px 2px 0;
}
.form-control.select2-container {
  height: auto !important;
  padding: 0;
}
.form-control.select2-container.select2-dropdown-open {
  border-color: #CCC;
  border-radius: 2px 2px 0 0;
}
.form-control .select2-container.select2-dropdown-open .select2-choices {
  border-radius: 2px 2px 0 0;
}
.form-control.select2-container .select2-choices {
  border: 0 !important;
  border-radius: 2px;
}
.control-group.warning .select2-container .select2-choice,
.control-group.warning .select2-container .select2-choices,
.control-group.warning .select2-container-active .select2-choice,
.control-group.warning .select2-container-active .select2-choices,
.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.warning .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #C09853 !important;
}
.control-group.warning .select2-container .select2-choice div {
  border-left: 1px solid #C09853 !important;
  background: #FCF8E3 !important;
}
.control-group.error .select2-container .select2-choice,
.control-group.error .select2-container .select2-choices,
.control-group.error .select2-container-active .select2-choice,
.control-group.error .select2-container-active .select2-choices,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.error .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #B94A48 !important;
}
.control-group.error .select2-container .select2-choice div {
  border-left: 1px solid #B94A48 !important;
  background: #F2DEDE !important;
}
.control-group.info .select2-container .select2-choice,
.control-group.info .select2-container .select2-choices,
.control-group.info .select2-container-active .select2-choice,
.control-group.info .select2-container-active .select2-choices,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.info .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #3A87AD !important;
}
.control-group.info .select2-container .select2-choice div {
  border-left: 1px solid #3A87AD !important;
  background: #D9EDF7 !important;
}
.control-group.success .select2-container .select2-choice,
.control-group.success .select2-container .select2-choices,
.control-group.success .select2-container-active .select2-choice,
.control-group.success .select2-container-active .select2-choices,
.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.success .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #468847 !important;
}
.control-group.success .select2-container .select2-choice div {
  border-left: 1px solid #468847 !important;
  background: #DFF0D8 !important;
}
.form-control .select2-choice {
  border: 0;
  border-radius: 2px;
}
.form-control .select2-choice .select2-arrow {
  border-radius: 0 2px 2px 0;
}
.form-control.select2-container {
  height: auto !important;
  padding: 0;
}
.form-control.select2-container.select2-dropdown-open {
  border-color: #CCC;
  border-radius: 2px 2px 0 0;
}
.form-control .select2-container.select2-dropdown-open .select2-choices {
  border-radius: 2px 2px 0 0;
}
.form-control.select2-container .select2-choices {
  border: 0 !important;
  border-radius: 2px;
}
.control-group.warning .select2-container .select2-choice,
.control-group.warning .select2-container .select2-choices,
.control-group.warning .select2-container-active .select2-choice,
.control-group.warning .select2-container-active .select2-choices,
.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.warning .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #C09853 !important;
}
.control-group.warning .select2-container .select2-choice div {
  border-left: 1px solid #C09853 !important;
  background: #FCF8E3 !important;
}
.control-group.error .select2-container .select2-choice,
.control-group.error .select2-container .select2-choices,
.control-group.error .select2-container-active .select2-choice,
.control-group.error .select2-container-active .select2-choices,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.error .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #B94A48 !important;
}
.control-group.error .select2-container .select2-choice div {
  border-left: 1px solid #B94A48 !important;
  background: #F2DEDE !important;
}
.control-group.info .select2-container .select2-choice,
.control-group.info .select2-container .select2-choices,
.control-group.info .select2-container-active .select2-choice,
.control-group.info .select2-container-active .select2-choices,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.info .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #3A87AD !important;
}
.control-group.info .select2-container .select2-choice div {
  border-left: 1px solid #3A87AD !important;
  background: #D9EDF7 !important;
}
.control-group.success .select2-container .select2-choice,
.control-group.success .select2-container .select2-choices,
.control-group.success .select2-container-active .select2-choice,
.control-group.success .select2-container-active .select2-choices,
.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,
.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,
.control-group.success .select2-container-multi.select2-container-active .select2-choices {
  border: 1px solid #468847 !important;
}
.control-group.success .select2-container .select2-choice div {
  border-left: 1px solid #468847 !important;
  background: #DFF0D8 !important;
}
.section-ficha {
  border-bottom: 1px solid #3F3F3F;
}
@media (min-width: 1200px) {
  .section-ficha .purchaseBtn--view {
    padding-left: 2em;
  }
}
.ficha {
  background: #F4F4F4;
  /* Ficha EST */
}
.ficha .info {
  background-color: #DDD;
}
.ficha .info a {
  color: #555555;
}
.ficha .info a:hover {
  color: #222222;
}
.ficha .info .well {
  background-color: #eeeeee;
}
.ficha .info .well .radio {
  margin-top: 0;
}
.ficha .info .item-wrapper {
  width: 100%;
}
.ficha h3 {
  font-weight: bold;
  color: #333333;
}
.ficha .label-default {
  border-radius: 0;
  background: #eeeeee;
  color: #333333;
  font-weight: normal;
  line-height: 2.14285714;
}
.ficha .item-rating {
  color: #F2F2F2;
  border: 1px solid #F2F2F2;
  border-radius: 0;
  background: none ;
}
.ficha .tooltip-footer h6 {
  float: left;
}
.ficha .tooltip-footer i {
  color: #FFF;
}
.ficha .item-image img {
  width: 100%;
}
.ficha .well .btn {
  text-align: left;
  white-space: normal;
}
.ficha button.costo_promo {
  margin-top: 5px;
}
.ficha button.costo_promo .tiempo {
  font-size: 12px;
  font-weight: normal;
}
.ficha button.costo_promo .texto {
  font-size: 17.1px;
  font-weight: bold;
  margin-bottom: 0px;
  white-space: normal;
}
.ficha .caja_descuento {
  margin-top: -18px;
}
.ficha .caja_descuento .fa-caret-up {
  width: 100%;
  text-align: center;
}
.ficha .caja_descuento .mensaje {
  background-color: #222222;
}
.ficha .caja_descuento .mensaje .signo {
  font-size: 21px;
  text-align: right;
}
.ficha .caja_descuento .mensaje .texto {
  font-size: 12px;
}
@media (max-width: 767px) {
  .ficha .caja_descuento .mensaje .texto {
    font-size: 18px;
  }
}
.ficha .caja_descuento .tit_original,
.ficha .caja_descuento .fecha_tiempo,
.ficha .caja_descuento .director,
.ficha .caja_descuento .actores,
.ficha .caja_descuento .generos {
  font-size: 12px;
}
.ficha .caja_descuento .redes_sociales ul.list-inline li:last-child {
  display: block;
  padding-top: 5px;
  width: 90px;
}
.ficha .series {
  /* .col_temporada ul li:first-child {border-bottom: 2px solid @grayd;}
    .col_datos ul li:first-child {border-bottom: 2px solid @grayd;}*/
}
.ficha .series .tabla {
  display: table;
  width: 100%;
}
.ficha .series .tabla.detalle_compras {
  background: #e6e6e6;
}
.ficha .series .col_temporada ul,
.ficha .series .col_datos ul {
  list-style-type: none;
  display: block;
  padding: 0;
  margin: 0;
}
.ficha .series .col_temporada ul h5,
.ficha .series .col_datos ul h5 {
  margin: 0;
  padding: 8px;
  font-weight: bold;
}
.ficha .series .col_temporada ul li,
.ficha .series .col_datos ul li {
  display: block;
}
.ficha .series .col_temporada ul li a,
.ficha .series .col_datos ul li.estaspor {
  display: block;
  padding: 8px 8px 8px 24px;
  color: #222222;
  text-decoration: none;
}
.ficha .series .col_datos ul li {
  /* border-bottom: 1px solid @grayd;*/
}
.ficha .series .col_datos ul li a {
  color: #F2F2F2;
  text-decoration: none;
  display: block;
  padding: 8px;
  height: 46px;
  line-height: 46px;
  padding: 0 8px;
  width: 100%;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ficha .series .col_datos ul li a:hover {
  background-color: rgba(63, 63, 63, 0.5);
}
.ficha .series .col_datos ul li a.active {
  background-color: rgba(63, 63, 63, 0.5);
}
.ficha .series .col_datos ul li i {
  color: #FFF;
}
.ficha .series .col_datos ul.list-striped li:nth-of-type(2n+1) {
  background: #3F3F3F;
  background: rgba(63, 63, 63, 0.25);
}
.ficha .series .col_datos ul li.episode .btn i {
  color: #FFF;
}
.ficha .series .col_datos .vistime,
.ficha .series .col_datos .calification,
.ficha .series .col_datos .date {
  text-align: center;
}
.ficha .series .col_datos .vistime p,
.ficha .series .col_datos .calification p,
.ficha .series .col_datos .date p {
  text-align: left;
}
.ficha .series .col_datos .vistime,
.ficha .series .col_datos .calification,
.ficha .series .col_datos .date {
  text-align: center;
}
.ficha .series .col_datos .vistime-progress-last {
  position: relative;
  background-color: transparent;
  height: 18px;
}
.ficha .series .col_datos .date {
  font-size: 12px;
}
@media (min-width: 1200px) {
  .ficha .box_data {
    padding-left: 20px;
  }
}
@media (max-width: 767px) {
  .ficha .info.padding-2 {
    padding: 10px;
  }
  .ficha .vistime {
    margin-top: 10px;
  }
  .ficha h2 {
    font-size: 23.8px;
  }
  .ficha .tooltip-score {
    float: none;
    margin: -5px 0 15px 0;
  }
  .ficha .redes_sociales ul.list-inline li {
    padding: 10px 0 0 0;
    float: none;
    display: block;
  }
}
.ficha .twitter-share-button {
  display: inline-block;
  margin-bottom: -5px;
}
.ficha .est-button-disabled {
  background: none;
  color: #999999;
  border: 1px solid #999999;
  cursor: default;
}
.ficha .est-button-disabled i {
  color: #008C00;
}
.ficha .fb_iframe_widget {
  display: inline !important;
  z-index: 100;
}
@media (max-width: 1199px) and (min-width: 992px) {
  .ficha .costo_promo {
    max-width: 200px;
  }
  .ficha .btn_download {
    max-width: 200px;
  }
}
/* Estás por (hay que mover este parche a FORMS-claro.less)*/
.sin-medio-pago .medios-pagos-web.padding-2,
.renta-medio-pago .medios-pagos-web.padding-2 {
  padding: 14px;
}
.sin-medio-pago .form-container,
.renta-medio-pago .form-container {
  padding: 20px;
}
.sin-medio-pago .form-container h5,
.renta-medio-pago .form-container h5 {
  padding-left: 5px;
}
@media (max-width: 767px) {
  .sin-medio-pago .form-container,
  .renta-medio-pago .form-container {
    padding: 0;
  }
}
@media (max-width: 767px) {
  .sin-medio-pago .padding-2,
  .renta-medio-pago .padding-2 {
    padding: 10px;
  }
}
.region-mexico .ficha .caja_descuento {
  margin-top: -20px;
  position: relative;
}
.region-mexico .ficha .caja_descuento .fa-caret-up {
  position: absolute;
  top: -18px;
  left: 50%;
  margin-left: -8px;
  width: 16px;
}
.section-ficha-bg {
  height: 100%;
  /*overflow: hidden;*/
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -999;
}
.section-ficha-bg > img {
  position: relative;
  width: 100%;
}
.wrapper-img {
  overflow: hidden;
  width: 100%;
}
.section-ficha-bg > img.img-responsive {
  opacity: 0.6;
  width: 100%;
}
.img-responsive2 {
  left: 50%;
  margin-left: -640px;
  position: relative;
  opacity: 0.6;
}
/*se setea por el tamaño de la img*/
.section-ficha .item-wrapper {
  /*   display: block;*/
}
.section-ficha .item-wrapper img {
  width: 100%;
}
.ficha {
  background: none;
}
.ficha.temporada {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 14.13%, rgba(0, 0, 0, 0.7) 100%);
  margin: 0;
  width: 100%;
}
.img-responsive3 {
  height: 150%;
  left: 50%;
  margin-left: calc(-25% - 640px);
  opacity: 0.5;
  overflow: hidden;
  position: relative;
}
.section-ficha-bg2 {
  bottom: 0;
  left: 0;
  margin: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: -99;
}
.col_datos.col-sm-12.serie-contents {
  position: relative;
}
.section-ficha .fecha_tiempo ul {
  line-height: 35px;
}
.season-loading {
  position: absolute;
  top: 60px;
  left: 50%;
  margin-left: -25px;
}
/*.season-loading {
animation: seasonfade 0.2s;
}

@keyframes seasonfade {
    from { opacity: 0.2; }
    to   { opacity: 1; }
}*/
.devicetype-mobile.layout-fichabts .section-ficha .play {
  opacity: 1;
  visibility: visible;
}
.card-button-prices {
  background: #0071bd;
  border: #147fef;
  color: white;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.28);
}
.card-button-prices:hover {
  background: #14579f;
  color: white !important;
  box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.6);
}
.box_data {
  position: inherit;
}
.disabled .precio {
  display: none;
}
/* RESULTADO DE BUSQUEDA
-------------------------------------------------- */
@media (min-width: 1920px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat left top #000;
    background-size: 100%;
  }
}
@media (max-width: 1919px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat left top #000;
    background-size: 100%;
  }
}
@media (max-width: 1199px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat left top #000;
    background-size: 100%;
  }
}
@media (max-width: 991px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat left top #000;
    background-size: 100%;
  }
}
@media (max-width: 767px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0 34px #000;
    background-size: 100%;
  }
}
@media (max-width: 360px) {
  body.layout-respuesta-buscador {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0 72px #000;
    background-size: 100%;
  }
}
.resultado-busqueda {
  background-color: #222222;
}
.resultado-busqueda .row-even {
  background-color: #333333;
}
.resultado-busqueda h3 {
  color: #FFF !important;
}
@media (max-width: 767px) {
  .resultado-busqueda .tooltip-score {
    padding-top: 0;
    margin: 0;
  }
  .resultado-busqueda h2 {
    font-size: 10px;
  }
  .resultado-busqueda h3 {
    font-size: 15.4px !important;
  }
}
.resultado-busqueda img {
  height: auto !important;
}
.highlight {
  text-decoration: underline;
}
@media (max-width: 767px) {
  .sugerencia-buscador-respuesta h4 {
    font-size: 13.72px;
  }
}
/* DESTACADO - RESULTADO DE BUSQUEDA
-------------------------------------------------- */
.section-carrousel .carousel.slide.destacado.resultado-busqueda {
  padding-bottom: 20px;
  background: rgba(0, 0, 0, 0.75);
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_box {
  height: 485px;
  overflow: hidden;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .carousel-indicators li {
  box-shadow: 0 1px 2px #000000;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {
  font-size: 25.2px;
  color: #FFF;
  text-shadow: 0 1px 2px #000000;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado {
  position: relative;
  top: 0px;
  left: 0px;
  z-index: 0;
  height: 535px;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado img.blur {
  filter: blur(13px);
  -webkit-filter: blur(13px);
  -moz-filter: blur(13px);
  -o-filter: blur(13px);
  -ms-filter: blur(13px);
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {
  position: absolute;
  top: 15px;
  z-index: 1;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .carousel-inner {
  position: absolute;
  top: 60px;
  left: 0px;
  z-index: 1;
  border: 0;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda a.carousel-control {
  position: absolute;
  z-index: 10;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .section-buscador,
.section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda {
  background: none !important;
}
.section-carrousel .carousel.slide.destacado.resultado-busqueda .section-buscador h3,
.section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda h3 {
  color: #FFF !important;
}
@media (max-width: 1199px) {
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {
    top: 15px;
  }
}
@media (max-width: 991px) {
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado {
    min-width: 1024px;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {
    top: 0px;
  }
}
@media (min-width: 768px) {
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda .box-tit {
    display: block;
    width: 540px;
    height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media (max-width: 767px) {
  .section-carrousel .carousel.slide.destacado.resultado-busqueda {
    height: 440px;
    background-color: #333333;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .box-tit span {
    font-size: 18px;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {
    font-size: 23.8px;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {
    top: 0px;
  }
}
@media (max-width: 479px) {
  .section-carrousel .carousel.slide.destacado.resultado-busqueda {
    height: 295px;
    background-color: #333333;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {
    font-size: 18.2px;
  }
  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {
    top: -5px;
    margin-right: 5px;
  }
}
/* DESTACADO - GENERO
-------------------------------------------------- */
.section-sugerencia-genero {
  background-color: #333333;
}
@media (max-width: 767px) {
  .section-sugerencia-genero h4 {
    font-size: 15.4px;
  }
}
@media (max-width: 768px) {
  .section-sugerencia-genero .item-wrapper img {
    height: auto;
  }
}
/* Listado Busqueda no encontrada
-------------------------------------------------- */
ul.listado {
  color: #999999;
  font-weight: normal;
  margin-left: 0px;
  margin-top: 25px;
  padding-left: 18px;
  font-size: 18px;
}
ul.listado li {
  font-size: 18px;
  font-family: Roboto;
  font-weight: normal;
  color: inherit;
}
@media (min-width: 991px) {
  ul.listado li {
    line-height: 25px;
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  ul.listado li {
    font-size: 15px !important;
    line-height: 16px;
    margin-bottom: 5px;
  }
}
ul.listado li span {
  color: #FFF;
}
.section-buscadorcarrousel {
  padding-bottom: 35px;
  padding-top: 25px;
}
.mi-cuenta {
  background-color: #232323;
  /* Headers Fijos */
  /* Headers Fijos */
  /* HISTORIAL */
  /*--- VISTIME PROGRESS HISTORIAL*/
  /*--- FIN VISTIME PROGRESS HISTORIAL*/
  /* FIN HISTORIAL */
  /* REDES SOCIALES */
  /* FIN REDES SOCIALES */
  /* PROMOCIONES */
  /* FIN PROMOCIONES  */
}
.mi-cuenta .nav-pills > li.active > a,
.mi-cuenta .nav-pills > li.active > a:hover,
.mi-cuenta .nav-pills > li.active > a:focus {
  color: #000;
}
.mi-cuenta .item-rating {
  /*background: @white;
    color: @gray-darker;
    border: 1px solid @gray;*/
}
.mi-cuenta .tooltip-score {
  float: left;
  color: #FFF;
  cursor: default;
}
.mi-cuenta .tooltip-score i {
  cursor: pointer;
  font-size: 1em;
}
.mi-cuenta .box-dispositivos.impar {
  background-color: #333333;
}
.mi-cuenta .box-dispositivos.impar span.deviceName {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mi-cuenta .box-dispositivos img {
  width: 50px;
}
.mi-cuenta h3 {
  font-weight: normal;
  color: #FFF !important;
}
.mi-cuenta .cont-title-fixed.stickOnScroll-on {
  left: 0;
  width: 100%;
  z-index: 5;
}
.mi-cuenta .cont-title-fixed.stickOnScroll-on .container {
  padding: 0;
}
.mi-cuenta .cont-title-fixed.stickOnScroll-on h3.hasStickOnScroll {
  display: block;
  z-index: 2;
  padding: 10px 0px;
  width: 100%;
  background: #232323;
  box-shadow: 0px 4px 9px #000;
  padding-left: 30px;
}
@media (max-width: 767px) {
  .mi-cuenta .cont-title-fixed.stickOnScroll-on h3.hasStickOnScroll {
    background-position: 0 -7px;
  }
}
.mi-cuenta .cont-title-fixed.stickOnScroll-on .hasStickOnScroll {
  display: block;
  z-index: 2;
  width: 100%;
  background-color: #232323;
  box-shadow: 0px 4px 9px #000;
  padding: 0 30px;
  margin: 0px;
}
.mi-cuenta .cont-title-fixed.stickOnScroll-on .hasStickOnScroll h3 {
  margin-top: 12px;
}
.mi-cuenta .box-dispositivos-asociados .impar {
  background-color: #3F3F3F;
}
.mi-cuenta .btn-dispositivos-asociados a {
  text-decoration: none;
  color: #FFF;
}
.mi-cuenta .descarga-silverlight {
  height: 39px;
  position: relative;
}
.mi-cuenta .box-historial.impar {
  background-color: #333333;
}
.mi-cuenta .box-historial .img-horinzontal {
  width: 100%;
}
.mi-cuenta .box-historial .img-vertical {
  width: 100%;
}
.mi-cuenta .box-historial .disabled .img-horinzontal,
.mi-cuenta .box-historial .disabled .img-vertical {
  opacity: 0.5;
}
.mi-cuenta .box-historial .disabled h4 {
  opacity: 0.5;
}
.mi-cuenta .box-historial .disabled .vistime-progress-last {
  opacity: 0.5;
}
.mi-cuenta .box-historial .disabled .label-default-hd {
  opacity: 0.5;
}
.mi-cuenta .box-historial .disabled .tooltip-score {
  opacity: 0.5;
}
.mi-cuenta .box-historial .disabled .datos {
  opacity: 0.5;
}
.mi-cuenta .tit-peli h4 {
  margin: 0px;
  font-weight: bold;
}
.mi-cuenta .label {
  border-radius: 0em;
}
.mi-cuenta.section-micuentahistorial .nav-pills {
  margin-bottom: 10px;
  padding: 5px 0 0;
}
.mi-cuenta h3 .nav-pills {
  margin-top: -8px;
}
.mi-cuenta .vistime-progress-last {
  height: 16px;
  left: 10%;
  margin-top: 3px;
  overflow: hidden;
  position: relative;
  width: 80%;
  z-index: 99;
}
.mi-cuenta .vistime-progress-bar-wrapper {
  padding-top: 5px;
  line-height: 0;
  text-align: left;
  margin: 0;
  padding: 0;
}
.mi-cuenta .vistime-data-info {
  display: inline-block;
  float: left;
  /*display:none*/
}
.mi-cuenta .vistime-data-info label {
  display: inline-block;
  color: #FFF;
  font-size: 10px;
  position: absolute;
  text-align: center;
  top: 9px;
}
.mi-cuenta .vistime-data-info .vistime-data-time {
  display: none;
}
.mi-cuenta .vistime-data-info .vistime-data-seconds {
  display: none;
}
.mi-cuenta .vistime-data-info .vistime-data-minutes {
  display: block;
}
.mi-cuenta .vistime-data-date {
  display: block;
  float: left;
  font-size: 10px;
  margin-left: 6px;
  width: 137px;
}
.mi-cuenta .jcarousel-skin-recentlywatched .vistime-data-date {
  display: none;
}
.mi-cuenta .vistime-progress-bar {
  background-color: #6D6D6D;
  display: inline-block;
  height: 3px;
  overflow: hidden;
  position: absolute;
  width: 100%;
}
.mi-cuenta .vistime-bar {
  background-color: #ED080D;
  height: 3px;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
}
.mi-cuenta .vistime-data-duration .vistime-data-time {
  display: none;
}
.mi-cuenta .vistime-data-duration .vistime-data-seconds {
  display: none;
}
.mi-cuenta .vistime-data-duration .vistime-data-minutes {
  display: block;
}
.mi-cuenta .vistime-data-duration {
  display: inline-block;
  color: #000;
  float: right;
  /*display:none;*/
}
.mi-cuenta .vistime-data-duration label {
  display: inline-block;
  color: #999999;
  font-size: 0.8125em;
  font-size: 10px;
  position: absolute;
  right: 0;
  text-align: center;
  top: 9px;
}
.mi-cuenta .vidrierawidgetficha-html {
  display: none;
}
.mi-cuenta .vistime-data-date {
  display: none !important;
}
.mi-cuenta .vistime-progress-last {
  background: none;
  padding: 1px;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 25px;
  z-index: 2;
}
.mi-cuenta .vistime-progress-last .vistime-progress-bar {
  width: 100%;
}
.mi-cuenta .vistime-progress-last .vistime-data-info label {
  top: 13px;
}
.mi-cuenta .vistime-progress-last .vistime-data-duration label {
  right: 3px;
  top: 13px;
}
.mi-cuenta .btn-fb {
  background-color: #3B5998;
  border-color: #3B5998;
}
.mi-cuenta .thumb-img-fb {
  width: 65px;
  height: 65px;
  background-color: #666;
}
.mi-cuenta .fa-certificate {
  color: #ea2f23;
  float: left;
  font-size: 77px;
}
.mi-cuenta .fa-certificate span {
  color: #FFF;
  font-size: 27px;
  left: -43px;
  position: relative;
  top: -19px;
}
.mi-cuenta .app-img-descarga {
  width: 64px;
  height: auto !important;
}
.mi-cuenta .box-promociones {
  margin-top: 6.66666667px;
}
.mi-cuenta .box-promociones .promo-icon span {
  display: block;
  height: 21px;
  width: 67px;
  color: #FFF;
  font-size: 12px;
  font-weight: bold;
  padding: 3px 0 0 5px;
  text-transform: uppercase;
}
.mi-cuenta .box-promociones .fa-certificate {
  font-size: 40px;
  color: #FFF;
  float: left;
}
.mi-cuenta .box-promociones .fa-certificate span {
  color: #FFF;
  font-size: 22px;
  left: -25px;
  position: relative;
  top: -6px;
}
.mi-cuenta .box-promociones .fa-caret-right {
  color: #222222;
  float: left;
  font-size: 50px;
  position: relative;
  top: 6px;
  left: -7px;
}
.mi-cuenta .box-promociones .fa-caret-down {
  color: #222222;
  font-size: 50px;
}
.mi-cuenta .box-promociones .promo-titulos {
  color: #FFF;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .mi-cuenta .box-promociones span {
    top: 10px;
  }
}
@media (max-width: 767px) {
  .mi-cuenta .box-promociones .fa-certificate {
    padding-top: 0;
  }
}
.mi-cuenta .box-promociones-open {
  margin-bottom: 3.33333333px;
}
@media (min-width: 992px) {
  .mi-cuenta .box-promociones-open img {
    width: 160px;
  }
}
@media (max-width: 991px) {
  .mi-cuenta .box-promociones-open img {
    width: 100%;
  }
  .mi-cuenta .box-promociones-open h4 {
    margin-top: 0;
  }
}
@media (max-width: 767px) {
  .mi-cuenta .box-promociones-open .listado-titulos .impar {
    background-color: #F4F4F4;
  }
}
.mi-cuenta .box-promociones-open button.ver-detalles {
  right: 0;
  top: 0;
}
.mi-cuenta .box-promociones-open .info-promociones-open {
  display: table;
}
.mi-cuenta .box-promociones-open .valor-desc span {
  font-size: 28px;
  font-weight: bold;
  color: #FFF;
}
.mi-cuenta .box-promociones-open .valor-desc .cantidad-desc-titulos {
  padding-top: 15px;
}
.mi-cuenta .box-promociones-open .valor-desc .titulos-disponibles {
  color: #FFF;
}
@media (min-width: 768px) {
  .mi-cuenta .box-promociones-open .valor-desc .titulos-disponibles {
    padding-top: 15px;
  }
}
.mi-cuenta .box-promociones-open .ver-mas-titulos {
  background-color: white;
  display: table;
}
@media (max-width: 991px) {
  .mi-cuenta .vigencia {
    padding-left: 5px;
  }
  .mi-cuenta .input-padding {
    padding-top: 5px;
  }
  .mi-cuenta .dispositivos-asociados {
    text-align: left;
  }
}
@media (max-width: 1199px) and (min-width: 992px) {
  .mi-cuenta .padding-label-0 {
    padding-top: 0px;
  }
}
@media (max-width: 767px) {
  .mi-cuenta h4 {
    font-size: 15.3px;
  }
  .mi-cuenta p {
    font-size: 11.7px;
  }
  .mi-cuenta .app-img-descarga {
    max-width: 100%;
  }
  .mi-cuenta .fa-certificate {
    color: #ea2f23;
    float: left;
    font-size: 56px;
    padding-top: 10px;
  }
  .mi-cuenta .fa-certificate span {
    color: #FFF;
    font-size: 27px;
    left: -36px;
    position: relative;
    top: -12px;
  }
}
.section-micuentacontrolpin .micuenta-title i.success {
  color: #5cb85c;
}
/*@import "slick.less"; en desarrollo*/
.ath-viewport * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ath-viewport {
  position: relative;
  z-index: 2147483641;
  pointer-events: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  text-size-adjust: none;
}
.ath-modal {
  pointer-events: auto !important;
  background: rgba(0, 0, 0, 0.6);
}
.ath-mandatory {
  background: #000;
}
.ath-container {
  pointer-events: auto !important;
  position: absolute;
  z-index: 2147483641;
  padding: 0.7em 0.6em;
  width: 18em;
  background: #eee;
  background-size: 100% auto;
  box-shadow: 0 0.2em 0 #d1d1d1;
  font-family: Roboto;
  font-size: 15px;
  line-height: 1.5em;
  text-align: center;
}
.ath-ios.ath-phone {
  bottom: 1.8em;
  left: 50%;
  margin-left: -9em;
}
.ath-ios7.ath-tablet {
  left: 0.7em;
  top: 1.8em;
}
.ath-ios6.ath-tablet {
  left: 5em;
  top: 1.8em;
}
.ath-android {
  right: 1.5em;
  top: 1.8em;
}
/* close icon */
.ath-container:before {
  content: '';
  position: relative;
  display: block;
  float: right;
  margin: -0.7em -0.6em 0 0.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-color: rgba(255, 255, 255, 0.8);
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 2.7em;
  height: 2.7em;
  text-align: center;
  overflow: hidden;
  color: #a33;
  z-index: 2147483642;
}
.ath-container.ath-icon:before {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  float: none;
}
.ath-mandatory .ath-container:before {
  display: none;
}
.ath-container.ath-android:before {
  float: left;
  margin: -0.7em 0.5em 0 -0.6em;
}
.ath-container.ath-android.ath-icon:before {
  position: absolute;
  right: auto;
  left: 0;
  margin: 0;
  float: none;
}
/* applied only if the application icon is shown */
.ath-action-icon {
  display: inline-block;
  vertical-align: middle;
  background-position: 50%;
  background-repeat: no-repeat;
  text-indent: -9999em;
  overflow: hidden;
}
.ath-android .ath-action-icon {
  width: 1.2em;
  height: 1.8em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: auto 100%;
}
.ath-ios7 .ath-action-icon {
  width: 1.6em;
  height: 1.6em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  margin-top: -0.3em;
  background-size: auto 100%;
}
.ath-ios6 .ath-action-icon {
  width: 1.8em;
  height: 1.8em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  margin-bottom: 0.4em;
  background-size: 100% auto;
}
.ath-container p {
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 2147483642;
  text-shadow: 0 0.1em 0 #fff;
  font-size: 1.1em;
}
.ath-ios.ath-phone:after {
  content: '';
  background: #eee;
  position: absolute;
  width: 2em;
  height: 2em;
  bottom: -0.9em;
  left: 50%;
  margin-left: -1em;
  -webkit-transform: scaleX(0.9) rotate(45deg);
  transform: scaleX(0.9) rotate(45deg);
  box-shadow: 0.2em 0.2em 0 #d1d1d1;
}
.ath-ios.ath-tablet:after {
  content: '';
  background: #eee;
  position: absolute;
  width: 2em;
  height: 2em;
  top: -0.9em;
  left: 50%;
  margin-left: -1em;
  -webkit-transform: scaleX(0.9) rotate(45deg);
  transform: scaleX(0.9) rotate(45deg);
  z-index: 2147483641;
}
.ath-android:after {
  content: '';
  background: #eee;
  background: -webkit-linear-gradient(-45deg, rgba(238, 238, 238, 0) 0%, rgba(238, 238, 238, 0) 50%, #eeeeee 50%, #eeeeee 100%);
  position: absolute;
  width: 2em;
  height: 2em;
  top: -1.5em;
  right: 0;
}
.ath-application-icon {
  position: relative;
  padding: 0;
  border: 0;
  margin: 0 auto 0.2em auto;
  height: 6em;
  width: 6em;
  z-index: 2147483642;
  box-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.3), inset 0 0.07em 0 rgba(255, 255, 255, 0.5);
}
/* OS specific classes */
.ath-container.ath-ios .ath-application-icon {
  border-radius: 1em;
  box-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.3), inset 0 0.07em 0 rgba(255, 255, 255, 0.5);
  margin: 0 auto 0.4em auto;
}
@media only screen and (orientation: landscape) {
  .ath-container.ath-phone {
    width: 24em;
  }
  .ath-ios.ath-phone {
    margin-left: -12em;
  }
  .ath-ios6:after {
    left: 39%;
  }
}
/*!
 *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: FontAwesome;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-fw {
  width: 1.28571429em;
  text-align: center;
}
.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}
.fa-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.85714286em;
}
.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eee;
  border-radius: 0.1em;
}
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
.fa.pull-left {
  margin-right: 0.3em;
}
.fa.pull-right {
  margin-left: 0.3em;
}
.fa-spin {
  -webkit-animation: spin 2s infinite linear;
  -moz-animation: spin 2s infinite linear;
  -o-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear;
}
@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(359deg);
  }
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
  }
}
@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(359deg);
  }
}
@-ms-keyframes spin {
  0% {
    -ms-transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(359deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}
.fa-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.fa-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}
.fa-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  -webkit-transform: scale(-1, 1);
  -moz-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  transform: scale(-1, 1);
}
.fa-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  -webkit-transform: scale(1, -1);
  -moz-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  transform: scale(1, -1);
}
.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}
.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.fa-stack-1x {
  line-height: inherit;
}
.fa-stack-2x {
  font-size: 2em;
}
.fa-inverse {
  color: #fff;
}
/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\\f000";
}
.fa-music:before {
  content: "\\f001";
}
.fa-search:before {
  content: "\\f002";
}
.fa-envelope-o:before {
  content: "\\f003";
}
.fa-hashtag:before {
  content: "\\f292";
}
.fa-heart:before {
  content: "\\f004";
}
.fa-star:before {
  content: "\\f005";
}
.fa-star-o:before {
  content: "\\f006";
}
.fa-user:before {
  content: "\\f007";
}
.fa-user-o:before {
  content: "\\f2c0";
}
.fa-film:before {
  content: "\\f008";
}
.fa-th-large:before {
  content: "\\f009";
}
.fa-th:before {
  content: "\\f00a";
}
.fa-th-list:before {
  content: "\\f00b";
}
.fa-check:before {
  content: "\\f00c";
}
.fa-times:before {
  content: "\\f00d";
}
.fa-search-plus:before {
  content: "\\f00e";
}
.fa-search-minus:before {
  content: "\\f010";
}
.fa-power-off:before {
  content: "\\f011";
}
.fa-signal:before {
  content: "\\f012";
}
.fa-gear:before,
.fa-cog:before {
  content: "\\f013";
}
.fa-trash-o:before {
  content: "\\f014";
}
.fa-home:before {
  content: "\\f015";
}
.fa-file-o:before {
  content: "\\f016";
}
.fa-clock-o:before {
  content: "\\f017";
}
.fa-road:before {
  content: "\\f018";
}
.fa-download:before {
  content: "\\f019";
}
.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}
.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}
.fa-inbox:before {
  content: "\\f01c";
}
.fa-play-circle-o:before {
  content: "\\f01d";
}
.fa-rotate-right:before,
.fa-repeat:before {
  content: "\\f01e";
}
.fa-refresh:before {
  content: "\\f021";
}
.fa-list-alt:before {
  content: "\\f022";
}
.fa-lock:before {
  content: "\\f023";
}
.fa-flag:before {
  content: "\\f024";
}
.fa-headphones:before {
  content: "\\f025";
}
.fa-volume-off:before {
  content: "\\f026";
}
.fa-volume-down:before {
  content: "\\f027";
}
.fa-volume-up:before {
  content: "\\f028";
}
.fa-qrcode:before {
  content: "\\f029";
}
.fa-barcode:before {
  content: "\\f02a";
}
.fa-tag:before {
  content: "\\f02b";
}
.fa-tags:before {
  content: "\\f02c";
}
.fa-book:before {
  content: "\\f02d";
}
.fa-bookmark:before {
  content: "\\f02e";
}
.fa-print:before {
  content: "\\f02f";
}
.fa-camera:before {
  content: "\\f030";
}
.fa-font:before {
  content: "\\f031";
}
.fa-bold:before {
  content: "\\f032";
}
.fa-italic:before {
  content: "\\f033";
}
.fa-text-height:before {
  content: "\\f034";
}
.fa-text-width:before {
  content: "\\f035";
}
.fa-align-left:before {
  content: "\\f036";
}
.fa-align-center:before {
  content: "\\f037";
}
.fa-align-right:before {
  content: "\\f038";
}
.fa-align-justify:before {
  content: "\\f039";
}
.fa-list:before {
  content: "\\f03a";
}
.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}
.fa-indent:before {
  content: "\\f03c";
}
.fa-video-camera:before {
  content: "\\f03d";
}
.fa-picture-o:before {
  content: "\\f03e";
}
.fa-pencil:before {
  content: "\\f040";
}
.fa-map-marker:before {
  content: "\\f041";
}
.fa-adjust:before {
  content: "\\f042";
}
.fa-tint:before {
  content: "\\f043";
}
.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}
.fa-share-square-o:before {
  content: "\\f045";
}
.fa-check-square-o:before {
  content: "\\f046";
}
.fa-arrows:before {
  content: "\\f047";
}
.fa-step-backward:before {
  content: "\\f048";
}
.fa-fast-backward:before {
  content: "\\f049";
}
.fa-backward:before {
  content: "\\f04a";
}
.fa-play:before {
  content: "\\f04b";
}
.fa-pause:before {
  content: "\\f04c";
}
.fa-stop:before {
  content: "\\f04d";
}
.fa-forward:before {
  content: "\\f04e";
}
.fa-fast-forward:before {
  content: "\\f050";
}
.fa-step-forward:before {
  content: "\\f051";
}
.fa-eject:before {
  content: "\\f052";
}
.fa-chevron-left:before {
  content: "\\f053";
}
.fa-chevron-right:before {
  content: "\\f054";
}
.fa-plus-circle:before {
  content: "\\f055";
}
.fa-minus-circle:before {
  content: "\\f056";
}
.fa-times-circle:before {
  content: "\\f057";
}
.fa-check-circle:before {
  content: "\\f058";
}
.fa-question-circle:before {
  content: "\\f059";
}
.fa-info-circle:before {
  content: "\\f05a";
}
.fa-crosshairs:before {
  content: "\\f05b";
}
.fa-times-circle-o:before {
  content: "\\f05c";
}
.fa-check-circle-o:before {
  content: "\\f05d";
}
.fa-ban:before {
  content: "\\f05e";
}
.fa-arrow-left:before {
  content: "\\f060";
}
.fa-arrow-right:before {
  content: "\\f061";
}
.fa-arrow-up:before {
  content: "\\f062";
}
.fa-arrow-down:before {
  content: "\\f063";
}
.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}
.fa-expand:before {
  content: "\\f065";
}
.fa-compress:before {
  content: "\\f066";
}
.fa-plus:before {
  content: "\\f067";
}
.fa-minus:before {
  content: "\\f068";
}
.fa-asterisk:before {
  content: "\\f069";
}
.fa-exclamation-circle:before {
  content: "\\f06a";
}
.fa-gift:before {
  content: "\\f06b";
}
.fa-leaf:before {
  content: "\\f06c";
}
.fa-fire:before {
  content: "\\f06d";
}
.fa-eye:before {
  content: "\\f06e";
}
.fa-eye-slash:before {
  content: "\\f070";
}
.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\\f071";
}
.fa-plane:before {
  content: "\\f072";
}
.fa-calendar:before {
  content: "\\f073";
}
.fa-random:before {
  content: "\\f074";
}
.fa-comment:before {
  content: "\\f075";
}
.fa-magnet:before {
  content: "\\f076";
}
.fa-chevron-up:before {
  content: "\\f077";
}
.fa-chevron-down:before {
  content: "\\f078";
}
.fa-retweet:before {
  content: "\\f079";
}
.fa-shopping-cart:before {
  content: "\\f07a";
}
.fa-folder:before {
  content: "\\f07b";
}
.fa-folder-open:before {
  content: "\\f07c";
}
.fa-arrows-v:before {
  content: "\\f07d";
}
.fa-arrows-h:before {
  content: "\\f07e";
}
.fa-bar-chart-o:before {
  content: "\\f080";
}
.fa-twitter-square:before {
  content: "\\f081";
}
.fa-facebook-square:before {
  content: "\\f082";
}
.fa-facebook-official:before {
  content: "\\f230";
}
.fa-camera-retro:before {
  content: "\\f083";
}
.fa-key:before {
  content: "\\f084";
}
.fa-gears:before,
.fa-cogs:before {
  content: "\\f085";
}
.fa-comments:before {
  content: "\\f086";
}
.fa-thumbs-o-up:before {
  content: "\\f087";
}
.fa-thumbs-o-down:before {
  content: "\\f088";
}
.fa-star-half:before {
  content: "\\f089";
}
.fa-heart-o:before {
  content: "\\f08a";
}
.fa-sign-out:before {
  content: "\\f08b";
}
.fa-linkedin-square:before {
  content: "\\f08c";
}
.fa-thumb-tack:before {
  content: "\\f08d";
}
.fa-external-link:before {
  content: "\\f08e";
}
.fa-sign-in:before {
  content: "\\f090";
}
.fa-trophy:before {
  content: "\\f091";
}
.fa-github-square:before {
  content: "\\f092";
}
.fa-upload:before {
  content: "\\f093";
}
.fa-lemon-o:before {
  content: "\\f094";
}
.fa-phone:before {
  content: "\\f095";
}
.fa-square-o:before {
  content: "\\f096";
}
.fa-bookmark-o:before {
  content: "\\f097";
}
.fa-phone-square:before {
  content: "\\f098";
}
.fa-twitter:before {
  content: "\\f099";
}
.fa-facebook:before {
  content: "\\f09a";
}
.fa-github:before {
  content: "\\f09b";
}
.fa-unlock:before {
  content: "\\f09c";
}
.fa-credit-card:before {
  content: "\\f09d";
}
.fa-rss:before {
  content: "\\f09e";
}
.fa-hdd-o:before {
  content: "\\f0a0";
}
.fa-bullhorn:before {
  content: "\\f0a1";
}
.fa-bell:before {
  content: "\\f0f3";
}
.fa-certificate:before {
  content: "\\f0a3";
}
.fa-hand-o-right:before {
  content: "\\f0a4";
}
.fa-hand-o-left:before {
  content: "\\f0a5";
}
.fa-hand-o-up:before {
  content: "\\f0a6";
}
.fa-hand-o-down:before {
  content: "\\f0a7";
}
.fa-arrow-circle-left:before {
  content: "\\f0a8";
}
.fa-arrow-circle-right:before {
  content: "\\f0a9";
}
.fa-arrow-circle-up:before {
  content: "\\f0aa";
}
.fa-arrow-circle-down:before {
  content: "\\f0ab";
}
.fa-globe:before {
  content: "\\f0ac";
}
.fa-wrench:before {
  content: "\\f0ad";
}
.fa-tasks:before {
  content: "\\f0ae";
}
.fa-filter:before {
  content: "\\f0b0";
}
.fa-briefcase:before {
  content: "\\f0b1";
}
.fa-arrows-alt:before {
  content: "\\f0b2";
}
.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}
.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}
.fa-cloud:before {
  content: "\\f0c2";
}
.fa-flask:before {
  content: "\\f0c3";
}
.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}
.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}
.fa-paperclip:before {
  content: "\\f0c6";
}
.fa-save:before,
.fa-floppy-o:before {
  content: "\\f0c7";
}
.fa-square:before {
  content: "\\f0c8";
}
.fa-bars:before {
  content: "\\f0c9";
}
.fa-list-ul:before {
  content: "\\f0ca";
}
.fa-list-ol:before {
  content: "\\f0cb";
}
.fa-strikethrough:before {
  content: "\\f0cc";
}
.fa-underline:before {
  content: "\\f0cd";
}
.fa-table:before {
  content: "\\f0ce";
}
.fa-magic:before {
  content: "\\f0d0";
}
.fa-truck:before {
  content: "\\f0d1";
}
.fa-pinterest:before {
  content: "\\f0d2";
}
.fa-pinterest-square:before {
  content: "\\f0d3";
}
.fa-google-plus-square:before {
  content: "\\f0d4";
}
.fa-google-plus:before {
  content: "\\f0d5";
}
.fa-money:before {
  content: "\\f0d6";
}
.fa-caret-down:before {
  content: "\\f0d7";
}
.fa-caret-up:before {
  content: "\\f0d8";
}
.fa-caret-left:before {
  content: "\\f0d9";
}
.fa-caret-right:before {
  content: "\\f0da";
}
.fa-columns:before {
  content: "\\f0db";
}
.fa-unsorted:before,
.fa-sort:before {
  content: "\\f0dc";
}
.fa-sort-down:before,
.fa-sort-asc:before {
  content: "\\f0dd";
}
.fa-sort-up:before,
.fa-sort-desc:before {
  content: "\\f0de";
}
.fa-envelope:before {
  content: "\\f0e0";
}
.fa-linkedin:before {
  content: "\\f0e1";
}
.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}
.fa-legal:before,
.fa-gavel:before {
  content: "\\f0e3";
}
.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}
.fa-comment-o:before {
  content: "\\f0e5";
}
.fa-comments-o:before {
  content: "\\f0e6";
}
.fa-flash:before,
.fa-bolt:before {
  content: "\\f0e7";
}
.fa-sitemap:before {
  content: "\\f0e8";
}
.fa-umbrella:before {
  content: "\\f0e9";
}
.fa-paste:before,
.fa-clipboard:before {
  content: "\\f0ea";
}
.fa-lightbulb-o:before {
  content: "\\f0eb";
}
.fa-exchange:before {
  content: "\\f0ec";
}
.fa-cloud-download:before {
  content: "\\f0ed";
}
.fa-cloud-upload:before {
  content: "\\f0ee";
}
.fa-user-md:before {
  content: "\\f0f0";
}
.fa-stethoscope:before {
  content: "\\f0f1";
}
.fa-suitcase:before {
  content: "\\f0f2";
}
.fa-bell-o:before {
  content: "\\f0a2";
}
.fa-coffee:before {
  content: "\\f0f4";
}
.fa-cutlery:before {
  content: "\\f0f5";
}
.fa-file-text-o:before {
  content: "\\f0f6";
}
.fa-building-o:before {
  content: "\\f0f7";
}
.fa-hospital-o:before {
  content: "\\f0f8";
}
.fa-ambulance:before {
  content: "\\f0f9";
}
.fa-medkit:before {
  content: "\\f0fa";
}
.fa-fighter-jet:before {
  content: "\\f0fb";
}
.fa-beer:before {
  content: "\\f0fc";
}
.fa-h-square:before {
  content: "\\f0fd";
}
.fa-plus-square:before {
  content: "\\f0fe";
}
.fa-angle-double-left:before {
  content: "\\f100";
}
.fa-angle-double-right:before {
  content: "\\f101";
}
.fa-angle-double-up:before {
  content: "\\f102";
}
.fa-angle-double-down:before {
  content: "\\f103";
}
.fa-angle-left:before {
  content: "\\f104";
}
.fa-angle-right:before {
  content: "\\f105";
}
.fa-angle-up:before {
  content: "\\f106";
}
.fa-angle-down:before {
  content: "\\f107";
}
.fa-desktop:before {
  content: "\\f108";
}
.fa-laptop:before {
  content: "\\f109";
}
.fa-tablet:before {
  content: "\\f10a";
}
.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}
.fa-circle-o:before {
  content: "\\f10c";
}
.fa-quote-left:before {
  content: "\\f10d";
}
.fa-quote-right:before {
  content: "\\f10e";
}
.fa-spinner:before {
  content: "\\f110";
}
.fa-circle:before {
  content: "\\f111";
}
.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}
.fa-github-alt:before {
  content: "\\f113";
}
.fa-folder-o:before {
  content: "\\f114";
}
.fa-folder-open-o:before {
  content: "\\f115";
}
.fa-smile-o:before {
  content: "\\f118";
}
.fa-frown-o:before {
  content: "\\f119";
}
.fa-meh-o:before {
  content: "\\f11a";
}
.fa-gamepad:before {
  content: "\\f11b";
}
.fa-keyboard-o:before {
  content: "\\f11c";
}
.fa-flag-o:before {
  content: "\\f11d";
}
.fa-flag-checkered:before {
  content: "\\f11e";
}
.fa-terminal:before {
  content: "\\f120";
}
.fa-code:before {
  content: "\\f121";
}
.fa-reply-all:before {
  content: "\\f122";
}
.fa-mail-reply-all:before {
  content: "\\f122";
}
.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}
.fa-location-arrow:before {
  content: "\\f124";
}
.fa-crop:before {
  content: "\\f125";
}
.fa-code-fork:before {
  content: "\\f126";
}
.fa-unlink:before,
.fa-chain-broken:before {
  content: "\\f127";
}
.fa-question:before {
  content: "\\f128";
}
.fa-info:before {
  content: "\\f129";
}
.fa-exclamation:before {
  content: "\\f12a";
}
.fa-superscript:before {
  content: "\\f12b";
}
.fa-subscript:before {
  content: "\\f12c";
}
.fa-eraser:before {
  content: "\\f12d";
}
.fa-puzzle-piece:before {
  content: "\\f12e";
}
.fa-microphone:before {
  content: "\\f130";
}
.fa-microphone-slash:before {
  content: "\\f131";
}
.fa-shield:before {
  content: "\\f132";
}
.fa-calendar-o:before {
  content: "\\f133";
}
.fa-fire-extinguisher:before {
  content: "\\f134";
}
.fa-rocket:before {
  content: "\\f135";
}
.fa-maxcdn:before {
  content: "\\f136";
}
.fa-chevron-circle-left:before {
  content: "\\f137";
}
.fa-chevron-circle-right:before {
  content: "\\f138";
}
.fa-chevron-circle-up:before {
  content: "\\f139";
}
.fa-chevron-circle-down:before {
  content: "\\f13a";
}
.fa-html5:before {
  content: "\\f13b";
}
.fa-css3:before {
  content: "\\f13c";
}
.fa-anchor:before {
  content: "\\f13d";
}
.fa-unlock-alt:before {
  content: "\\f13e";
}
.fa-bullseye:before {
  content: "\\f140";
}
.fa-ellipsis-h:before {
  content: "\\f141";
}
.fa-ellipsis-v:before {
  content: "\\f142";
}
.fa-rss-square:before {
  content: "\\f143";
}
.fa-play-circle:before {
  content: "\\f144";
}
.fa-ticket:before {
  content: "\\f145";
}
.fa-minus-square:before {
  content: "\\f146";
}
.fa-minus-square-o:before {
  content: "\\f147";
}
.fa-level-up:before {
  content: "\\f148";
}
.fa-level-down:before {
  content: "\\f149";
}
.fa-check-square:before {
  content: "\\f14a";
}
.fa-pencil-square:before {
  content: "\\f14b";
}
.fa-external-link-square:before {
  content: "\\f14c";
}
.fa-share-square:before {
  content: "\\f14d";
}
.fa-compass:before {
  content: "\\f14e";
}
.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\\f150";
}
.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\\f151";
}
.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\\f152";
}
.fa-euro:before,
.fa-eur:before {
  content: "\\f153";
}
.fa-gbp:before {
  content: "\\f154";
}
.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}
.fa-rupee:before,
.fa-inr:before {
  content: "\\f156";
}
.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\\f157";
}
.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\\f158";
}
.fa-won:before,
.fa-krw:before {
  content: "\\f159";
}
.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}
.fa-file:before {
  content: "\\f15b";
}
.fa-file-text:before {
  content: "\\f15c";
}
.fa-sort-alpha-asc:before {
  content: "\\f15d";
}
.fa-sort-alpha-desc:before {
  content: "\\f15e";
}
.fa-sort-amount-asc:before {
  content: "\\f160";
}
.fa-sort-amount-desc:before {
  content: "\\f161";
}
.fa-sort-numeric-asc:before {
  content: "\\f162";
}
.fa-sort-numeric-desc:before {
  content: "\\f163";
}
.fa-thumbs-up:before {
  content: "\\f164";
}
.fa-thumbs-down:before {
  content: "\\f165";
}
.fa-youtube-square:before {
  content: "\\f166";
}
.fa-youtube:before {
  content: "\\f167";
}
.fa-xing:before {
  content: "\\f168";
}
.fa-xing-square:before {
  content: "\\f169";
}
.fa-youtube-play:before {
  content: "\\f16a";
}
.fa-dropbox:before {
  content: "\\f16b";
}
.fa-stack-overflow:before {
  content: "\\f16c";
}
.fa-instagram:before {
  content: "\\f16d";
}
.fa-flickr:before {
  content: "\\f16e";
}
.fa-adn:before {
  content: "\\f170";
}
.fa-bitbucket:before {
  content: "\\f171";
}
.fa-bitbucket-square:before {
  content: "\\f172";
}
.fa-tumblr:before {
  content: "\\f173";
}
.fa-tumblr-square:before {
  content: "\\f174";
}
.fa-long-arrow-down:before {
  content: "\\f175";
}
.fa-long-arrow-up:before {
  content: "\\f176";
}
.fa-long-arrow-left:before {
  content: "\\f177";
}
.fa-long-arrow-right:before {
  content: "\\f178";
}
.fa-apple:before {
  content: "\\f179";
}
.fa-windows:before {
  content: "\\f17a";
}
.fa-android:before {
  content: "\\f17b";
}
.fa-linux:before {
  content: "\\f17c";
}
.fa-dribbble:before {
  content: "\\f17d";
}
.fa-skype:before {
  content: "\\f17e";
}
.fa-foursquare:before {
  content: "\\f180";
}
.fa-trello:before {
  content: "\\f181";
}
.fa-female:before {
  content: "\\f182";
}
.fa-male:before {
  content: "\\f183";
}
.fa-gittip:before {
  content: "\\f184";
}
.fa-sun-o:before {
  content: "\\f185";
}
.fa-moon-o:before {
  content: "\\f186";
}
.fa-archive:before {
  content: "\\f187";
}
.fa-bug:before {
  content: "\\f188";
}
.fa-vk:before {
  content: "\\f189";
}
.fa-weibo:before {
  content: "\\f18a";
}
.fa-renren:before {
  content: "\\f18b";
}
.fa-pagelines:before {
  content: "\\f18c";
}
.fa-stack-exchange:before {
  content: "\\f18d";
}
.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}
.fa-arrow-circle-o-left:before {
  content: "\\f190";
}
.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\\f191";
}
.fa-dot-circle-o:before {
  content: "\\f192";
}
.fa-wheelchair:before {
  content: "\\f193";
}
.fa-vimeo-square:before {
  content: "\\f194";
}
.fa-turkish-lira:before,
.fa-try:before {
  content: "\\f195";
}
.fa-plus-square-o:before {
  content: "\\f196";
}
body.android-install-app h3 {
  margin: 0;
}
@media (min-width: 768px) {
  body.android-install-app h3 {
    margin-top: 30px;
  }
}
body.android-install-app .android-pict {
  width: 100%;
  max-width: 308px;
  padding: 30px 10px 0px 10px;
}
@media (max-width: 360px) {
  body.android-install-app .android-pict {
    width: 200px;
    padding-top: 0;
  }
  body.android-install-app h3 {
    margin: 0;
  }
}
@media (max-width: 767px) {
  body.android-install-app h3,
  body.android-install-app p {
    text-align: center;
  }
  body.android-install-app .padding-2 {
    padding: 0px 20px;
  }
}
.margin-top-10-percent {
  margin-top: 10%;
}
@media (max-width: 767px) {
  .margin-top-10-percent {
    margin: 0;
  }
}
@media (max-width: 767px) {
  .poster-mobile-hor.padding-1 {
    padding-top: 0;
  }
}
/*### -multilevel push menu-###*/
.multilevelpushmenu_wrapper {
  position: absolute;
  /* overflow: hidden;*/
  min-width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
  bottom: 16px;
}
.multilevelpushmenu_wrapper h2 {
  background-color: #1a1a1a;
  font-size: 14px;
  font-weight: bold;
  color: #fafafa;
  padding: 3px 20px;
  line-height: 50px;
  margin-top: 0;
  margin-bottom: 0;
}
.multilevelpushmenu_wrapper .levelHolderClass {
  position: absolute;
  overflow: hidden;
  top: 0;
  /*background: #1a1a1a;
    background-color: #2e2e2e;*/
  background-color: rgba(0, 0, 0, 0.75);
  width: auto;
  min-height: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1px solid #232323;
  /*solo cuando se necesite-revisar*/
}
.multilevelpushmenu_wrapper .levelHolderClass {
  overflow-y: auto;
}
.multilevelpushmenu_wrapper .ltr {
  margin-left: -100%;
  left: 0;
}
.multilevelpushmenu_wrapper .rtl {
  margin-right: -100%;
  right: 0;
}
.multilevelpushmenu_wrapper .multilevelpushmenu_inactive {
  /*  background: #2e6196;*/
  overflow-y: hidden;
}
.multilevelpushmenu_wrapper ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.multilevelpushmenu_wrapper li {
  cursor: pointer;
  border-top: 1px solid #424242;
  padding: 3px 15px;
  line-height: 50px;
}
.multilevelpushmenu_wrapper li:last-child {
  /* border-bottom: 1px solid #295685;*/
}
.multilevelpushmenu_wrapper li:hover {
  background-color: #424242;
}
.multilevelpushmenu_wrapper a {
  display: block;
  outline: none;
  overflow: hidden;
  font-size: 14px;
  text-decoration: none;
  color: #fff;
}
.multilevelpushmenu_wrapper a:hover {
  color: #ffe;
}
.multilevelpushmenu_wrapper .backItemClass {
  display: block;
}
.multilevelpushmenu_wrapper .floatRight {
  float: right;
}
.multilevelpushmenu_wrapper .floatLeft {
  float: left;
}
.multilevelpushmenu_wrapper .cursorPointer {
  cursor: pointer;
}
/*ellipsis revisar camellcase claselevelholderclas*/
.chapter-sel .levelholderClass.ltr a span,
.chapter-sel .multilevelpushmenu_wrapper a span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px;
}
.chapter-sel,
.chapter-sel02 {
  position: relative;
}
.chapter-sel > div#menu,
.chapter-sel02 > div#menu {
  bottom: 27px;
  right: -28px;
  height: 365px !important;
  min-height: 365px !important;
  position: absolute;
}
nav.multilevelpushmenu_wrapper {
  height: 343px !important;
  min-height: 343px !important;
}
.chapter-sel > div#menuResponsive,
.chapter-sel02 > div#menuResponsive {
  bottom: 34px;
  right: 0px;
  position: absolute;
}
.chapter-sel3 a span.episode-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px;
}
.levelHolderClass h2 i.fa.pull-left {
  margin-right: 10px;
  line-height: 50px;
}
.levelHolderClass.ltr {
  z-index: 1;
  /*(fix de  error animacion)*/
}
.multilevelpushmenu_wrapper a .fa {
  line-height: 50px;
}
/**/
/*.levelHolderClass.ltr ul li a .fa
{
  display: none !important;
}
*/
/*hover ruedita*/
.multilevelpushmenu_wrapper .levelHolderClass ul li {
  background-color: rgba(35, 35, 35, 0.35);
}
.multilevelpushmenu_wrapper .levelHolderClass ul li.selected {
  background-color: rgba(63, 63, 63, 0.5);
  /*color: #d8d8d8;*/
}
.multilevelpushmenu_wrapper li:hover {
  background-color: rgba(35, 35, 35, 0.9);
}
.multilevelpushmenu_wrapper .levelHolderClass ul li:hover {
  background-color: rgba(35, 35, 35, 0.9);
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,
.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  bottom: 100%;
  border: solid transparent;
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after {
  border-bottom-color: #fff;
  border-width: 6px;
  left: 33%;
  margin-left: -6px;
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {
  border-bottom-color: #ddd;
  border-width: 7px;
  left: 33%;
  margin-left: -7px;
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,
.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {
  top: 100%;
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after {
  border-bottom-color: transparent;
  border-top-color: rgba(35, 35, 35, 0.95);
  border-width: auto;
  left: auto;
  margin-left: auto;
  right: 23%;
  margin-right: -6px;
}
.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {
  border-bottom-color: transparent;
  border-top-color: rgba(35, 35, 35, 0.95);
  border-width: 8px;
  left: auto;
  margin-left: auto;
  right: 23%;
  margin-right: -8px;
}
.chapter-sel2 #menuResponsive {
  bottom: 34px;
  height: 245px !important;
  min-height: 245px !important;
  position: absolute;
  right: -27px;
}
.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper {
  height: 235px !important;
  min-height: 235px !important;
}
.levelHolderClass.ltr .levelHolderClass.ltr {
  opacity: 0;
}
.levelHolderClass.ltr.multilevelpushmenu_inactive h2 {
  display: none;
}
.levelHolderClass.ltr.multilevelpushmenu_inactive .levelHolderClass.ltr {
  opacity: 1;
}
.levelHolderClass.ltr.multilevelpushmenu_inactive .levelHolderClass.ltr h2 {
  display: block;
}
.levelHolderClass.ltr {
  transition: all 0.2s ease;
}
.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu li a,
.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu li a {
  width: 270px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu,
.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu {
  min-width: auto;
  width: 280px;
}
videoph5 button {
  cursor: pointer;
}
videoph5.fullscreen {
  left: 0;
  position: fixed;
  top: 0;
}
videoph5 vph5-media,
.void {
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}
videoph5 video,
.void {
  display: block;
  border: 0 none;
  height: 100%;
  left: 0;
  margin: 0;
  padding: 0;
  top: 0;
  width: 100%;
}
.fullscreen {
  width: 100%;
  height: 100%;
}
videoph5 .vgTimeDisplay {
  display: table-cell;
  font-family: Roboto;
  font-size: 18px;
  width: auto;
}
videoph5 vph5-fullscreen-button,
.void {
  cursor: pointer;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 50px;
}
videoph5 vph5-buffering,
.void {
  position: absolute;
  top: 50%;
  width: 60px;
  height: 60px;
  z-index: 2;
  margin-top: -60px;
  margin-left: -30px;
  left: 50%;
}
videoph5 vph5-buffering {
  /*background-color: rgba(0,0,0,.8);*/
}
videoph5 vph5-controls .btn-default {
  color: #f2f2f2;
  border: none;
  font-size: 16px;
}
videoph5 vph5-controls .btn-default .fa {
  font-size: 22px;
  line-height: 31px;
}
.vph5-player .label.label-player {
  border: 1px solid #ccc;
  display: table;
  float: left;
  font-size: 100%;
  line-height: normal;
  margin: 10px 5px 10px 0;
  padding: 10px;
  position: relative;
}
.vph5-player .item-salir {
  background: transparent;
  /*color: #ccc;*/
  display: table;
  height: 30px;
  left: 10px;
  line-height: 28px;
  padding: 0 10px 0 0;
  position: absolute;
  top: 10px;
  z-index: 3;
}
vph5-container,
.void {
  /* background: pink none repeat scroll 0 0;*/
  display: block;
  height: 100%;
  width: 100%;
  z-index: 1;
  position: relative;
  overflow: hidden;
}
.videoph5-container {
  height: 100%;
  width: 100%;
}
.videoph5-container.full-player {
  display: block;
  height: 100%;
  position: relative;
  transition: all 0.5s ease-out 0s;
  width: 100%;
}
.vph5-player {
  height: 100%;
  position: absolute;
  width: 100%;
}
videoph5.videoph5-cont,
.void {
  display: table;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
/*fix fullscreen*/
videoph5,
.void {
  display: block;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;
}
videoph5 vph5-controls,
.void {
  display: block;
  height: 165px;
  position: absolute;
  top: calc(100% - 165px);
  width: 100%;
  z-index: 3;
  background-image: linear-gradient(rgba(0, 0, 0, 0), #000000);
}
videoph5 vph5-controls .controls-container {
  /* background-color: #000;
    background-color: rgba(0, 0, 0, 0.7);*/
  display: table;
  height: 50px;
  left: 1%;
  position: absolute;
  padding: 0 5px;
  width: 98%;
  bottom: 0;
}
videoph5 vph5-play-pause-button,
.void {
  cursor: pointer;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 50px;
}
videoph5 vph5-play-pause-button .btn {
  width: 40px;
}
videoph5 vph5-time-display,
.void {
  color: #ffffff;
  cursor: default;
  display: table-cell;
  font-family: Roboto;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  width: 75px;
}
vph5-play-pause-button.controls {
  padding-right: 30px;
}
.sub-controls {
  padding-left: 30px;
}
.play-bar {
  background: #272727 none repeat scroll 0 0;
}
.play-bar-wrapper {
  padding: 0 15px;
  text-align: center;
  width: 100%;
}
@media (max-width: 767px) {
  .play-bar-wrapper.is_live {
    visibility: hidden;
  }
}
.vc-seekbar {
  left: 0;
  position: absolute;
  z-index: 999;
}
.vc {
  -moz-user-select: none;
  background-color: #1b1b1b;
  color: #777777;
  height: 28px;
  position: relative;
  width: 100%;
  z-index: 9000;
}
.vc-seeker {
  background-color: #3F3F3F;
  border: 1px solid #3F3F3F;
  cursor: pointer;
  display: inline-block;
  height: 6px;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  border-radius: 6px;
  position: absolute;
  transition: height 0.25s linear 0s, top 0.25s linear 0s;
}
.vc-player > .vc > .vc-seeker {
  background-color: #444444;
  height: 8px;
  top: -5px;
}
.vc-range {
  height: 20px;
  width: 20px;
  line-height: 0;
  margin: -8px 0 0 -5px;
  text-align: center;
  transition: height 0.25s linear 0s, width 0.25s linear 0s, margin 0.25s linear 0s, line-height 0.25s linear 0s;
}
.vc-range-little {
  display: inline-block;
  transition: height 0.25s linear 0s, width 0.25s linear 0s, opacity 0s linear 0.2s;
  vertical-align: middle;
  background-color: #F2F2F2;
  border: 1px solid #F2F2F2;
  border-radius: 100%;
  height: 18px;
  width: 18px;
  margin-top: 1px;
  opacity: 1;
  box-shadow: 0px 0px 8px 2px #f2f2f2;
}
.vc-loadingbar {
  background-color: #DDDDDD;
  display: inline-block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 0;
}
.vc-progressbar {
  background-color: #F2F2F2;
  background-size: 30px 30px !important;
  display: inline-block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 0;
}
.vc-progressbarbuffer {
  background-color: rgba(221, 221, 221, 0.003);
  display: inline-block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
}
.vc-progressbar,
.vc-progressbarbuffer {
  border-radius: 4px 0 0 4px;
}
videoph5 finplayer-plugin {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0 !important;
  display: table !important;
  height: 100%;
  width: 100%;
  z-index: auto !important;
}
videoph5 finplayer-plugin .finplayer-wrapper {
  display: table;
  height: 100%;
  width: 100%;
}
videoph5 vph5-dubsub-selector.vph5-dubsub-selector {
  cursor: pointer;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 50px;
}
.play-bar-wrapper {
  padding: 0 15px;
  width: 100%;
}
.controls-container > * {
  display: table-cell;
  vertical-align: middle;
}
.sub-controls > *,
.controls {
  padding: 0 3px;
}
.controls-container .sub-controls > div,
.controls-container .sub-controls vph5-dropdown {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.controls-container .play-bar {
  border-radius: 4px;
  height: 5px;
  position: relative;
  width: 100%;
}
.controls-container .btn-group .btn .filter-option {
  display: inline-block;
  overflow: hidden;
  text-align: left;
  width: 100%;
}
/*controls container*/
.videoph5-container .dropdown-menu {
  border: medium none;
}
.videoph5-container .dropdown-menu > li > a {
  border-bottom: 1px solid #232323;
  line-height: 50px;
  white-space: nowrap;
}
.videoph5-container .dropdown-menu > li:last-child > a {
  border-bottom: none;
}
.videoph5-container .dropdown-submenu:hover > a::after {
  border-left-color: #fff;
}
.videoph5-container .btn-group .dropdown-menu {
  /*background-color: #2e2e2e;*/
  border: 1px solid #232323;
  box-sizing: border-box;
  min-width: 100%;
  left: 0;
  width: 200px;
  z-index: 1035;
  padding: 0px;
}
.videoph5-container .controls-container .btn-group .dropdown-menu {
  left: auto;
  right: -13px;
}
.videoph5-container .controls-container vph5-quality-selector .btn-group .dropdown-menu {
  right: -4px;
}
.dropdown-wrappper {
  display: none;
}
.open .dropdown-wrappper {
  display: block;
}
.open .dropdown-wrappper > .dropdown-menu {
  display: block;
}
.open .dropdown-wrappper > a {
  outline: 0;
}
.videoph5-container .btn-group .dropdown-menu.inner {
  /* background-color: #2e2e2e;*/
}
.open > .dropdown-toggle.btn-default {
  /* background-color: #393939;
      border-color: #393939;*/
  color: #d8d8d8;
}
.videoph5-container .btn-group .dropdown-menu > li > a:hover,
.videoph5-container .btn-group .dropdown-menu > li > a:focus {
  /* background-color: #424242;
      color: #d8d8d8;*/
}
.videoph5-container .btn-group .dropdown-menu .btn-default.active .videoph5-container .btn-group .dropdown-menu .btn-default.focus .videoph5-container .btn-group .dropdown-menu .btn-default:hover,
.videoph5-container .btn-group .dropdown-menu .btn-default:focus,
.videoph5-container .btn-group .dropdown-menu .btn-default:active {
  /* background-color: #393939;
      border-color: #393939;*/
  color: #d8d8d8;
}
.videoph5-container .controls-container .btn-group .dropdown-menu {
  bottom: 15px;
}
.videoph5-container .controls-container .dropdown-wrappper {
  position: absolute;
  height: 240px;
  /*background: pink;*/
  bottom: 25px;
  right: -10px;
  min-height: 200px;
  width: 200px;
}
/**/
vph5-volume {
  position: relative;
}
videoph5 vph5-volume-bar {
  cursor: pointer;
  height: 80px;
  position: absolute;
  right: 6px;
  text-align: center;
  top: -80px;
  vertical-align: middle;
  width: 30px;
}
@media not all, not all {
  videoph5 vph5-volume-bar {
    opacity: 0.5;
  }
}
.vc-range-little2 {
  background-color: #F2F2F2;
  border: 1px solid #F2F2F2;
  box-shadow: 0px 0px 8px 2px #f2f2f2;
  border-radius: 100%;
  height: 18px;
  width: 18px;
  display: inline-block;
  position: absolute;
  top: -2px;
  left: -7px;
  opacity: 1;
}
videoph5 vph5-volume-bar .verticalVolumeBar {
  height: 80px;
  position: absolute;
  width: 30px;
}
videoph5 vph5-volume-bar .volumeBackground {
  background-color: #3F3F3F;
  /* border: 1px solid @gray2;*/
  height: 80px;
  left: 12px;
  position: absolute;
  top: 0;
  width: 4px;
  border-radius: 4px;
}
videoph5 vph5-volume-bar .volumeValue {
  background-color: #F2F2F2;
  height: 100%;
  position: absolute;
  width: 4px;
  border-radius: 4px;
}
videoph5 vph5-volume-bar .volumeClickArea {
  height: 100%;
  position: absolute;
  width: 40px;
  left: -15px;
}
/*ancho volume-mute*/
vph5-mute-button .btn {
  width: 38px;
}
.vph5-player {
  /*fix selector capitulos fin player -pasar a less*/
}
.vph5-player .dropdown-menu > li > a:hover,
.vph5-player .dropdown-menu > li > a:focus {
  background-color: rgba(35, 35, 35, 0.9);
}
.vph5-player .dropdown-menu li a {
  text-align: left;
}
.vph5-player .dropdown-menu li {
  background-color: rgba(35, 35, 35, 0.35);
}
.vph5-player .dropdown-menu li:first-child {
  /* background-color: fade(@black , 80%); */
}
.vph5-player .dropdown-menu li.selected {
  background-color: rgba(63, 63, 63, 0.5);
  /* color: #d8d8d8;*/
}
.vph5-player vph5-dropdown span.filter-option {
  max-width: 290px;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media (max-width: 990px) {
  .vph5-player vph5-dropdown span.filter-option {
    max-width: 190px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
videoph5 div.scrollablearea {
  position: absolute;
}
.controls-title-wrapper {
  position: absolute;
  bottom: 60px;
}
.ficha-player .box_data .fecha_tiempo .item-year {
  font-weight: bold;
}
videoph5 vph5-pause-plugin {
  display: block;
  position: absolute;
  top: 0;
  z-index: 1;
}
videoph5 vph5-pause-plugin {
  color: inherit !important;
  height: 100%;
  width: 100%;
}
.pausa-wrapper {
  background: rgba(0, 0, 0, 0.8) none repeat scroll 0 0;
  color: #ccc;
  height: 100%;
  padding-top: 50px;
  position: relative;
}
vph5-pause-plugin .section-ficha {
  height: 100%;
  width: 100%;
  border-bottom: none;
}
vph5-pause-plugin .section-ficha.vertical-align {
  display: table-cell;
  vertical-align: middle;
}
vph5-pausemobile-plugin {
  height: 160px;
  width: 100%;
  display: block;
  position: absolute;
  bottom: 0;
  z-index: 1;
  /*PASAR A MIXIN*/
  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);
  /* FF3.6+ */
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(5%, rgba(0, 0, 0, 0.25)), color-stop(26%, rgba(0, 0, 0, 0.75)), color-stop(58%, #000000), color-stop(100%, #000000));
  /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);
  /* Opera 11.10+ */
  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);
  /* IE10+ */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
  /* IE6-9 */
}
vph5-pausemobile-plugin .pausa-mobile-wrapper {
  margin: 20px 10px 0 10px;
  color: #ccc;
  display: block;
}
vph5-pausemobile-plugin .pausa-mobile-wrapper .h2_content_title {
  font-size: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
videoph5 pause-plugin {
  display: block;
  position: absolute;
  top: 0;
  z-index: 0;
}
videoph5 finplayer-plugin {
  color: red;
  display: block;
  position: absolute;
  top: 0;
  z-index: 50;
}
videoph5 pause-plugin {
  color: inherit !important;
  height: 100%;
  min-height: 320px;
  width: 100%;
}
pause-plugin .section-ficha {
  left: 0;
  margin-top: -170px;
  position: absolute;
  top: 50%;
}
.pausa-wrapper .content {
  height: 100%;
  position: relative;
  width: 100%;
}
.pausa-wrapper .content.center-wrapper {
  display: table;
  vertical-align: middle;
}
.pausa-wrapper .h2_content_title {
  color: #fafafa;
  font-size: 42px;
}
.pausa-wrapper .fecha_tiempo {
  margin-left: 10px;
}
.vph5-player .section-7 {
  display: block;
  position: absolute;
  right: 2em;
  top: 0;
  width: 600px;
  z-index: 3;
}
.video-container {
  display: block;
  height: 100%;
  width: 100%;
}
.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
}
.embed-responsive .embed-responsive-item,
.embed-responsive embed,
.embed-responsive iframe,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-16by9 {
  padding-bottom: 56.25%;
}
.embed-responsive-4by3 {
  padding-bottom: 75%;
}
.vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9 {
  background-color: #000000;
}
/**/
.videoph5-container .dropdown-menu {
  background-color: transparent;
  background-color: rgba(0, 0, 0, 0.9);
}
.vph5-player vph5-dropdown span.filter-option {
  padding-right: 10px;
}
.vph5-player .dropup .btn-default .caret {
  margin-left: 10px;
}
.vph5-player .selector-episodio-fin .button-label2.dropdown-toggle::before,
.vph5-player .selector-temporada-fin .button-label2.dropdown-toggle::before {
  content: "";
  border-left: 1px solid #464646;
  height: 100%;
  display: block;
  position: absolute;
  right: 29px;
  top: 0px;
}
.vph5-player .dropdown-menu > li > a {
  color: #F2F2F2;
}
.vph5-player ul.dropdown-menu:after,
.vph5-player ul.dropdown-menu:before {
  top: 100%;
}
.vph5-player ul.dropdown-menu:after {
  border-bottom-color: transparent;
  border-top-color: rgba(35, 35, 35, 0.95);
  border-width: auto;
  left: auto;
  margin-left: auto;
  right: 23%;
  margin-right: -6px;
}
.vph5-player ul.dropdown-menu:before {
  border-bottom-color: transparent;
  border-top-color: rgba(35, 35, 35, 0.95);
  border-width: 8px;
  left: auto;
  margin-left: auto;
  right: 23%;
  margin-right: -8px;
}
:-webkit-full-screen {
  background-color: #000000;
}
.vph5-player ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.vph5-player ::-webkit-scrollbar-button:end:increment,
.vph5-player ::-webkit-scrollbar-button:start:decrement {
  height: 10px;
  display: block;
  background-color: #2b2b2b;
  border-color: #3b3b3b;
  border-radius: 10px;
  -webkit-border-radius: 10px;
}
.vph5-player ::-webkit-scrollbar-track-piece {
  background-color: #3b3b3b;
  border-radius: 6px;
  -webkit-border-radius: 6px;
}
.vph5-player ::-webkit-scrollbar-thumb:vertical {
  height: 40px;
  background-color: #666;
  border: 1px solid #3b3b3b;
  -webkit-border-radius: 6px;
}
.finplayer-wrapper2 .btn-default {
  background-color: rgba(35, 35, 35, 0.85);
  border-color: #232323;
  color: #666666;
}
.recover-pin {
  line-height: 32px;
}
.videoph5-container vph5-channel-selector .btn-group .dropdown-menu {
  width: 240px;
}
.videoph5-container vph5-channel-selector .dropdown-menu > li > a {
  text-overflow: ellipsis;
  overflow: hidden;
}
.brand01,
.on-live {
  padding: 0;
}
.brand01 img,
.on-live span2 {
  margin-bottom: 6px;
}
.on-live span {
  float: left;
  margin-left: 10px;
}
.vph5-player vph5-channel-selector ul.dropdown-menu:after,
.vph5-player vph5-channel-selector ul.dropdown-menu:before {
  right: 18%;
}
.controls-container .disable {
  color: #272727;
}
.vph5-player .controls-container .btn {
  text-overflow: initial;
  height: 45px;
}
.section-fin-series .image.container2 {
  display: block;
  margin: 0;
  padding: 0;
  position: relative;
}
.countdown-container {
  font-size: 20px;
}
.countdown-container .countdown {
  /* color: #ff0000;*/
}
.vph5-player .section-fin-series .item-img {
  display: block;
  float: left;
  height: auto;
  max-width: 100%;
  position: relative;
}
.vph5-player .section-fin-series .item-wrapper2 {
  margin: 0 auto;
  max-width: 675px;
}
.vph5-player .section-fin-series {
  margin-top: 120px;
}
.vph5-player .section-fin-series {
  max-width: 675px;
  /*small-fix problema imagen chica*/
}
.vph5-player .section-fin-series .dropdown-menu {
  height: 285px;
  overflow-x: hidden;
  overflow-y: auto;
}
.vph5-finplayer vph5-exitbutton-plugin .item-salir {
  left: 10px;
  top: 10px;
  display: inherit;
}
.fin-player .image.container2 {
  left: 15px;
  position: absolute;
  top: 0;
}
.fin-player .image.container2 img {
  width: 100%;
}
/*---*/
vph5-container.fin-player {
  display: table;
  height: 100%;
  transition: all 0.4s ease-out 0s;
}
vph5-finplayer-plugin {
  transition: all 0.4s ease-out 0s;
  opacity: 1;
  transition: 1s all;
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
}
.vph5-player .jcarousel.jcarousel-2.horizontal .scrollwrapper {
  min-height: 250px;
}
.vph5-player .jcarousel.jcarousel-1 {
  height: 252px;
}
.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper {
  min-height: 250px;
}
.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper {
  min-height: 250px;
}
.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 {
  width: 440px;
}
.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 img {
  max-width: 440px;
}
.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 {
  width: 170px;
}
.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 img {
  max-width: 170px;
}
vph5-container.fin-player {
  /*  display: table;*/
  /*esto es para fullscreen*/
  height: 100%;
  /*transition: all 1.4s ease-out 0s;*/
}
/*logo fin player*/
vph5-finplayer-fondo .brand,
.brand {
  display: block;
  left: 25px;
  position: absolute;
  top: 10px;
  z-index: 1;
}
/*mas fin*/
.vph5-finplayer vph5-media {
  margin: 180px 0 0;
  padding: 0 24px;
  height: auto;
  position: relative;
  transition: all 0.4s ease-out 0s;
}
.vph5-fin-movie .finplayer-wrapper2 {
  margin-top: 140px;
}
@media (max-width: 767px) {
  .fin-player vph5-media {
    margin-top: 60px;
    padding: 0;
  }
  .vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9 {
    padding-bottom: 75%;
  }
}
/*MISC*/
.vph5-finplayer a,
.videoph5-container .dropdown-menu > li > a {
  cursor: pointer;
}
.vph5-finplayer .item-salir {
  /*left: 30px;
  top: 80px;*/
}
.vph5-player .tooltip-score .fa {
  font-size: 1.8em;
}
.vph5-player .tooltip-score .msg .fa {
  font-size: 1.4em;
  line-height: 1.4em;
}
.vph5-player .tooltip-score .msg span {
  color: #fafafa;
}
.vph5-player .tooltip-score .msg .fa.check {
  color: #008c00;
}
.fa.fa_green {
  color: #08b755;
  margin-top: 4px;
}
/*estrellitas*/
.finplayer-wrapper2,
.fin-player {
  color: #fff;
}
.finplayer-wrapper2 .tooltip-score .fa,
.fin-player .tooltip-score .fa {
  margin: 5px;
}
.finplayer-wrapper2 .tooltip-score .fa.empty,
.fin-player .tooltip-score .fa.empty {
  /* border: 1px solid red;
 border-color: #1c1c1c;*/
}
.finplayer-wrapper2 .tooltip-score.panel-default,
.fin-player .tooltip-score.panel-default {
  background: #3e3e3e none repeat scroll 0 0;
  border: medium none;
  border-radius: 6px;
  padding: 10px;
  min-height: 40px;
}
.finplayer-wrapper2 .panel.panel-primary,
.fin-player .panel.panel-primary {
  background-color: #1a1a1a;
  border-color: #bbbbbb;
  margin-top: 30px;
}
vph5-finplayer-fondo {
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
  width: 100%;
}
.fin-player-bg1 {
  background: rgba(0, 0, 0, 0.8) repeat scroll 0 0;
  height: 100%;
}
.fin-player-bg2 {
  /*background: rgba(0, 0, 0, 0) radial-gradient(ellipse at center center , #1d1d1d 0%, #0f0f0f 100%) repeat scroll 0 0;*/
  height: 100%;
}
/*/*/
/*.vph5-finplayer-fondo > img
{
  z-index: -3;
  height: 100%; 
  position: absolute; 
  top: 0;
  left: 0;
}
*/
.vph5-player .open .dropdown-toggle.btn-default:hover,
.vph5-player .btn-default:hover,
.vph5-player .open .dropdown-toggle.btn-default:focus,
.vph5-player .btn-default:focus,
.vph5-player .open .dropdown-toggle.btn-default:active,
.vph5-player .btn-default:active,
.vph5-player .open .dropdown-toggle.btn-default.active,
.vph5-player .btn-default.active {
  /* background-color: rgba(35, 35, 35, 0.85);
     border-color: #232323;*/
}
.vph5-finplayer .dropup .btn-default:hover,
.vph5-finplayer .dropup .btn-default:focus,
.vph5-finplayer .dropup .btn-default:active,
.vph5-finplayer .dropup .btn-default.active,
.vph5-finplayer .dropup .open .dropdown-toggle.btn-default {
  background-color: rgba(35, 35, 35, 0.85);
  border-color: #232323;
}
.vph5-player .season-sel > * {
  float: left;
  margin-right: 10px;
}
.vph5-player .cargando2-player {
  display: table;
  height: 35px;
  line-height: 35px;
  vertical-align: middle;
  padding-top: 12px;
}
@media (max-width: 991px) {
  .angular-ratings-02 .tooltip-score .fa,
  .finplayer-wrapper2 .angular-ratings-02 .tooltip-score .fa,
  .finplayer .angular-ratings-02 .tooltip-score .fa {
    font-size: 1.5em;
    margin: 2px;
  }
}
@media (min-width: 991px) {
  .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,
  .finplayer-wrapper2 .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,
  .finplayer .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa {
    font-size: 1.5em;
    margin: 2px;
  }
}
/*hack for chrome -hotfix-carrusel*/
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .vph5-player .jcarousel-separador {
    display: table-cell;
    float: inherit;
    margin: 0px;
    background: inherit;
    width: 15px;
    padding: 1px;
    border-left: 2px solid #202020;
    border-right: 0px;
  }
}
/*@import "video-gular.less";*/
`, "",{"version":3,"sources":["webpack://./src/less/mixins.less","webpack://./src/less/bootstrap.less","webpack://./src/less/normalize.less","webpack://./src/less/print.less","webpack://./src/less/scaffolding.less","webpack://./src/less/elements.less","webpack://./src/less/type.less","webpack://./src/less/code.less","webpack://./src/less/grid.less","webpack://./src/less/tables.less","webpack://./src/less/forms.less","webpack://./src/less/buttons.less","webpack://./src/less/website.less","webpack://./src/less/component-animations.less","webpack://./src/less/dropdowns.less","webpack://./src/less/button-groups.less","webpack://./src/less/input-groups.less","webpack://./src/less/navs.less","webpack://./src/less/navbar.less","webpack://./src/less/utilities.less","webpack://./src/fonts/less/bordered-pulled.less","webpack://./src/less/breadcrumbs.less","webpack://./src/less/pagination.less","webpack://./src/less/pager.less","webpack://./src/less/labels.less","webpack://./src/less/badges.less","webpack://./src/less/jumbotron.less","webpack://./src/less/thumbnails.less","webpack://./src/less/alerts.less","webpack://./src/less/progress-bars.less","webpack://./src/less/media.less","webpack://./src/less/list-group.less","webpack://./src/less/panels.less","webpack://./src/less/wells.less","webpack://./src/less/close.less","webpack://./src/less/modals.less","webpack://./src/less/tooltip.less","webpack://./src/less/popovers.less","webpack://./src/less/carousel.less","webpack://./src/less/autocomplete.less","webpack://./src/less/responsive-utilities.less","webpack://./src/less/claro.less","webpack://./src/less/component-carousel.less","webpack://./src/less/header.less","webpack://./src/less/footer.less","webpack://./src/less/form-claro.less","webpack://./src/less/tooltip-claro.less","webpack://./src/less/vistime.less","webpack://./src/less/landing-01.less","webpack://./src/less/landing-02.less","webpack://./src/less/landing-03.less","webpack://./src/less/registro.less","webpack://./src/less/select2.less","webpack://./src/less/ficha.less","webpack://./src/less/resultado-busqueda.less","webpack://./src/less/micuenta.less","webpack://./src/less/webclip.less","webpack://./src/fonts/less/path.less","webpack://./src/fonts/less/core.less","webpack://./src/fonts/less/larger.less","webpack://./src/fonts/less/fixed-width.less","webpack://./src/fonts/less/list.less","webpack://./src/fonts/less/spinning.less","webpack://./src/fonts/less/rotated-flipped.less","webpack://./src/fonts/less/mixins.less","webpack://./src/fonts/less/stacked.less","webpack://./src/fonts/less/icons.less","webpack://./src/less/install-app.less","webpack://./src/less/multilevelpush-menu.less","webpack://./src/less/vph5-player.less","webpack://./src/less/vph5-fin-player.less"],"names":[],"mappings":"AAolBA;EACE,2BAAA;ACnlBF;ADslBA;EAZE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACvkBF;ADWE;;EAEE,YAAA;ECTF,MAAM;EDUJ,cAAA;ECRF,MAAM;AACR;ADSE;EACE,WAAA;ACPJ;ADCE;;EAEE,YAAA;ECCF,MAAM;EDAJ,cAAA;ECEF,MAAM;AACR;ADDE;EACE,WAAA;ACGJ;AACA,2DAA2D;ACrB3D;;EAGE,+BAAA;EACA,wBAAA;EACA,mCAAA;ADsBF;ACdA;;;;;;;;;;;;EAYE,cAAA;ADgBF;ACTA;;;EAGE,qBAAA;ADWF;ACHA;EACE,aAAA;EACA,SAAA;ADKF;ACGA;;EAEE,aAAA;ADDF;ACcA;EACE,mBAAA;EACA,0BAAA;EACA,8BAAA;ADZF;ACmBA;EACE,SAAA;ADjBF;AC4BA;EACE,uBAAA;AD1BF;ACiCA;EACE,oBAAA;AD/BF;ACsCA;;EAEE,UAAA;ADpCF;ACgDA;EACE,cAAA;EACA,gBAAA;AD9CF;ACqDA;EACE,yBAAA;ADnDF;AC0DA;;EAEE,iBAAA;ADxDF;AC+DA;EACE,kBAAA;AD7DF;ACoEA;EACE,4BAAA;EACA,uBAAA;EACA,SAAA;ADlEF;ACyEA;EACE,gBAAA;EACA,WAAA;ADvEF;AC8EA;;;;EAIE,mBAAA;EACA,cAAA;AD5EF;ACmFA;EACE,qBAAA;ADjFF;ACwFA;EACE,uCAAA;ADtFF;AC6FA;EACE,cAAA;AD3FF;ACkGA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADhGF;ACmGA;EACE,WAAA;ADjGF;ACoGA;EACE,eAAA;ADlGF;AC6GA;EACE,SAAA;AD3GF;ACkHA;EACE,gBAAA;ADhHF;AC2HA;EACE,SAAA;ADzHF;ACoIA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;ADlIF;AC0IA;EACE,SAAA;EACA,UAAA;ADxIF;ACiJA;;;;EAIE,mBAAA;EACA,eAAA;EACA,SAAA;AD/IF;ACiJA;EAAW,uBAAA;AD9IX;ACoJA;;EAEE,mBAAA;ADlJF;AC4JA;;EAEE,oBAAA;AD1JF;ACqKA;;;;EAIE,0BAAA;EACA,eAAA;ADnKF;AC0KA;;EAEE,eAAA;ADxKF;ACgLA;;EAEE,sBAAA;EACA,UAAA;AD9KF;ACuLA;EACE,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,uBAAA;ADrLF;AC6LA;;EAEE,wBAAA;AD3LF;ACkMA;;EAEE,SAAA;EACA,UAAA;ADhMF;ACwMA;EACE,cAAA;EACA,mBAAA;ADtMF;ACiNA;EACE,yBAAA;EACA,iBAAA;AD/MF;AE3MA;EAEE;IACE,4BAAA;IACA,sBAAA;IACA,kCAAA;IACA,2BAAA;EF4MF;EEzMA;;IAEE,0BAAA;EF2MF;EExMA;IACE,4BAAA;EF0MF;EEvMA;IACE,6BAAA;EFyMF;EErMA;;IAEE,WAAA;EFuMF;EEpMA;;IAEE,yBAAA;IACA,wBAAA;EFsMF;EEnMA;IACE,2BAAA;EFqMF;EElMA;;IAEE,wBAAA;EFoMF;EEjMA;IACE,0BAAA;EFmMF;EEhMA;IACE,iBAAA;EFkMF;EE/LA;;;IAGE,UAAA;IACA,SAAA;EFiMF;EE9LA;;IAEE,uBAAA;EFgMF;EE3LA;IACE,2BAAA;EF6LF;EEzLA;IACE,aAAA;EF2LF;EEzLA;;IAGI,iCAAA;EF0LJ;EEvLA;;IAGI,iCAAA;EFwLJ;EErLA;IACE,sBAAA;EFuLF;EEpLA;IACE,oCAAA;EFsLF;EEpLA;;IAGI,iCAAA;EFqLJ;AACF;AGnRA;;;EC4FE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;AJ4LF;AGlRA;EACE,gBAAA;EACA,6CAAA;AHoRF;AGjRA;EACE,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AHmRF;AG/QA;;;;EAIE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHiRF;AG3QA;EACE,cAAA;EACA,qBAAA;AH6QF;AG3QE;;EAEE,cAAA;EACA,0BAAA;AH6QJ;AG1QE;EJpBA,4BAAA;EAEA,0CAAA;EACA,oBAAA;ACgSF;AGvQA;EACE,sBAAA;AHyQF;AGrQA;EJmTE,cAAA;EACA,eAAA;EACA,YAAA;AC3CF;AGrQA;EACE,kBAAA;AHuQF;AGjQA;EACE,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EJ6CA,wCAAA;EACQ,gCAAA;EK7CR,qDAAA;EACA,kDAAA;EACA,gDAAA;EACA,6CAAA;EL8RA,qBAAA;EACA,eAAA;EACA,YAAA;ACxBF;AGpQA;EACE,kBAAA;AHsQF;AGhQA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AHkQF;AG1PA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AH4PF;AGxPA;EACE,UAAA;EACA,gBAAA;AH0PF;AGvPA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,+DAAA;EACA,4DAAA;EACA,4DAAA;EACA,2DAAA;AHyPF;AGtPA;EACE,iBAAA;EACA,qBAAA;AHwPF;AGpPA;EACE;IACE,uBAAA;IHsPA,8CAA8C;IGnP9C,mBAAA;IACA,gBAAA;EHqPF;AACF;AKnYA;EACE,gBAAA;ALqYF;AKnYA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ALqYF;AKnYE;EAAA;IACE,eAAA;ELsYF;AACF;AK9XA;;EACU,cAAA;ALiYV;AK9XA;EAAU,kBAAA;ALiYV;AK9XA;EACE,cAAA;ALgYF;AK9XA;EACE,WAAA;ALgYF;AK/XE;EACE,cAAA;ALiYJ;AK9XA;EACE,cAAA;ALgYF;AK/XE;EACE,cAAA;ALiYJ;AK9XA;EACE,cAAA;ALgYF;AK/XE;EACE,cAAA;ALiYJ;AK9XA;EACE,cAAA;ALgYF;AK/XE;EACE,cAAA;ALiYJ;AK9XA;EACE,cAAA;ALgYF;AK/XE;EACE,cAAA;ALiYJ;AK5XA;EAAuB,gBAAA;AL+XvB;AK9XA;EAAuB,iBAAA;ALiYvB;AKhYA;EAAuB,kBAAA;ALmYvB;AK7XA;;;;;;;;;;;;EAEE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ALyYF;AK9YA;;;;;;;;;;;;;;;;;;;;;;;;EASI,mBAAA;EACA,cAAA;EACA,cAAA;AL+ZJ;AK3ZA;;;EAGE,gBAAA;EACA,mBAAA;AL6ZF;AKjaA;;;;;;EAQI,cAAA;ALiaJ;AK9ZA;;;EAGE,gBAAA;EACA,mBAAA;ALgaF;AKpaA;;;;;;EAQI,cAAA;ALoaJ;AKhaA;;EAAU,eAAA;ALoaV;AKnaA;;EAAU,eAAA;ALuaV;AKtaA;;EAAU,eAAA;AL0aV;AKzaA;;EAAU,eAAA;AL6aV;AK5aA;;EAAU,eAAA;ALgbV;AK/aA;;EAAU,eAAA;ALmbV;AK7aA;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;AL+aF;AKtaA;;EAEE,aAAA;EACA,mBAAA;ALwaF;AK3aA;;;;EAMI,gBAAA;AL2aJ;AKpaA;EACE,eAAA;EACA,gBAAA;ALsaF;AKlaA;EALE,eAAA;EACA,gBAAA;AL0aF;AKtaA;EAII,qBAAA;EACA,iBAAA;EACA,kBAAA;ALqaJ;AKnaI;EACE,eAAA;ALqaN;AK/ZA;EACE,mBAAA;ALiaF;AK/ZA;;EAEE,uBAAA;ALiaF;AK/ZA;EACE,iBAAA;ALiaF;AK/ZA;EACE,cAAA;ALiaF;AKzZA;EACE;IAEI,WAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;INpIJ,gBAAA;IACA,uBAAA;IACA,mBAAA;EC+hBA;EKlaA;IASI,kBAAA;EL4ZJ;EDllBA;;IAEE,YAAA;IColBA,MAAM;IDnlBN,cAAA;ICqlBA,MAAM;EACR;EDplBA;IACE,WAAA;ECslBF;ED5lBA;;IAEE,YAAA;IC8lBA,MAAM;ID7lBN,cAAA;IC+lBA,MAAM;EACR;ED9lBA;IACE,WAAA;ECgmBF;AACF;AKvaA;;EAGE,YAAA;EACA,iCAAA;ALwaF;AKtaA;EACE,cAAA;EACA,yBAAA;ALwaF;AKpaA;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;ALsaF;AKzaA;EAKI,iBAAA;EACA,gBAAA;EACA,iBAAA;ALuaJ;AK9aA;EAUI,gBAAA;ALuaJ;AKjbA;EAaI,cAAA;EACA,uBAAA;EACA,cAAA;ALuaJ;AKtaI;EACE,sBAAA;ALwaN;AKnaE;EACE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;ALqaJ;AKzaE;;;EAQI,iBAAA;ALsaN;AKlaM;;EACE,WAAA;ALqaR;AKnaM;;EACE,sBAAA;ALsaR;AK/ZA;;EAEE,WAAA;ALiaF;AK7ZA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AL+ZF;AM9qBA;;;;EAIE,mBAAA;ANgrBF;AM5qBA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AN8qBF;AM1qBA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AN4qBF;AMvrBA;EAeI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;AN2qBJ;AMtqBA;EACE,iBAAA;EACA,kBAAA;ANwqBF;AOttBA;ERukBE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACkJF;AD9sBE;;EAEE,YAAA;ECgtBF,MAAM;ED/sBJ,cAAA;ECitBF,MAAM;AACR;ADhtBE;EACE,WAAA;ACktBJ;ADxtBE;;EAEE,YAAA;EC0tBF,MAAM;EDztBJ,cAAA;EC2tBF,MAAM;AACR;AD1tBE;EACE,WAAA;AC4tBJ;AO3uBA;ERmlBE,iBAAA;EACA,kBAAA;AC2JF;ADtuBE;;EAEE,YAAA;ECwuBF,MAAM;EDvuBJ,cAAA;ECyuBF,MAAM;AACR;ADxuBE;EACE,WAAA;AC0uBJ;ADhvBE;;EAEE,YAAA;ECkvBF,MAAM;EDjvBJ,cAAA;ECmvBF,MAAM;AACR;ADlvBE;EACE,WAAA;ACovBJ;AD3CK;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACC,kBAAA;EAEA,eAAA;EAEA,iBAAA;EACA,kBAAA;AC0FN;AD1EK;;;;;;;;;;;EACC,WAAA;ACsFN;AD/EG;EACC,WAAA;ACiFJ;ADlFG;EACC,mBAAA;ACoFJ;ADrFG;EACC,mBAAA;ACuFJ;ADxFG;EACC,UAAA;AC0FJ;AD3FG;EACC,mBAAA;AC6FJ;AD9FG;EACC,mBAAA;ACgGJ;ADjGG;EACC,UAAA;ACmGJ;ADpGG;EACC,mBAAA;ACsGJ;ADvGG;EACC,mBAAA;ACyGJ;AD1GG;EACC,UAAA;AC4GJ;AD7GG;EACC,mBAAA;AC+GJ;ADhHG;EACC,kBAAA;ACkHJ;ADzGG;EACC,WAAA;AC2GJ;AD5GG;EACC,mBAAA;AC8GJ;AD/GG;EACC,mBAAA;ACiHJ;ADlHG;EACC,UAAA;ACoHJ;ADrHG;EACC,mBAAA;ACuHJ;ADxHG;EACC,mBAAA;AC0HJ;AD3HG;EACC,UAAA;AC6HJ;AD9HG;EACC,mBAAA;ACgIJ;ADjIG;EACC,mBAAA;ACmIJ;ADpIG;EACC,UAAA;ACsIJ;ADvIG;EACC,mBAAA;ACyIJ;AD1IG;EACC,kBAAA;AC4IJ;AD7IG;EACC,SAAA;AC+IJ;ADrJG;EACC,UAAA;ACuJJ;ADxJG;EACC,kBAAA;AC0JJ;AD3JG;EACC,kBAAA;AC6JJ;AD9JG;EACC,SAAA;ACgKJ;ADjKG;EACC,kBAAA;ACmKJ;ADpKG;EACC,kBAAA;ACsKJ;ADvKG;EACC,SAAA;ACyKJ;AD1KG;EACC,kBAAA;AC4KJ;AD7KG;EACC,kBAAA;AC+KJ;ADhLG;EACC,SAAA;ACkLJ;ADnLG;EACC,kBAAA;ACqLJ;ADtLG;EACC,iBAAA;ACwLJ;ADzLG;EACC,QAAA;AC2LJ;ADlLG;EACC,iBAAA;ACoLJ;ADrLG;EACC,yBAAA;ACuLJ;ADxLG;EACC,yBAAA;AC0LJ;AD3LG;EACC,gBAAA;AC6LJ;AD9LG;EACC,yBAAA;ACgMJ;ADjMG;EACC,yBAAA;ACmMJ;ADpMG;EACC,gBAAA;ACsMJ;ADvMG;EACC,yBAAA;ACyMJ;AD1MG;EACC,yBAAA;AC4MJ;AD7MG;EACC,gBAAA;AC+MJ;ADhNG;EACC,yBAAA;ACkNJ;ADnNG;EACC,wBAAA;ACqNJ;ADtNG;EACC,eAAA;ACwNJ;AO/7BA;EACE;IACE,YAAA;EPi8BF;EDpPG;;;;;;;;;;;IACC,WAAA;ECgQJ;EDzPC;IACC,WAAA;EC2PF;ED5PC;IACC,mBAAA;EC8PF;ED/PC;IACC,mBAAA;ECiQF;EDlQC;IACC,UAAA;ECoQF;EDrQC;IACC,mBAAA;ECuQF;EDxQC;IACC,mBAAA;EC0QF;ED3QC;IACC,UAAA;EC6QF;ED9QC;IACC,mBAAA;ECgRF;EDjRC;IACC,mBAAA;ECmRF;EDpRC;IACC,UAAA;ECsRF;EDvRC;IACC,mBAAA;ECyRF;ED1RC;IACC,kBAAA;EC4RF;EDnRC;IACC,WAAA;ECqRF;EDtRC;IACC,mBAAA;ECwRF;EDzRC;IACC,mBAAA;EC2RF;ED5RC;IACC,UAAA;EC8RF;ED/RC;IACC,mBAAA;ECiSF;EDlSC;IACC,mBAAA;ECoSF;EDrSC;IACC,UAAA;ECuSF;EDxSC;IACC,mBAAA;EC0SF;ED3SC;IACC,mBAAA;EC6SF;ED9SC;IACC,UAAA;ECgTF;EDjTC;IACC,mBAAA;ECmTF;EDpTC;IACC,kBAAA;ECsTF;EDvTC;IACC,SAAA;ECyTF;ED/TC;IACC,UAAA;ECiUF;EDlUC;IACC,kBAAA;ECoUF;EDrUC;IACC,kBAAA;ECuUF;EDxUC;IACC,SAAA;EC0UF;ED3UC;IACC,kBAAA;EC6UF;ED9UC;IACC,kBAAA;ECgVF;EDjVC;IACC,SAAA;ECmVF;EDpVC;IACC,kBAAA;ECsVF;EDvVC;IACC,kBAAA;ECyVF;ED1VC;IACC,SAAA;EC4VF;ED7VC;IACC,kBAAA;EC+VF;EDhWC;IACC,iBAAA;ECkWF;EDnWC;IACC,QAAA;ECqWF;ED5VC;IACC,iBAAA;EC8VF;ED/VC;IACC,yBAAA;ECiWF;EDlWC;IACC,yBAAA;ECoWF;EDrWC;IACC,gBAAA;ECuWF;EDxWC;IACC,yBAAA;EC0WF;ED3WC;IACC,yBAAA;EC6WF;ED9WC;IACC,gBAAA;ECgXF;EDjXC;IACC,yBAAA;ECmXF;EDpXC;IACC,yBAAA;ECsXF;EDvXC;IACC,gBAAA;ECyXF;ED1XC;IACC,yBAAA;EC4XF;ED7XC;IACC,wBAAA;EC+XF;EDhYC;IACC,eAAA;ECkYF;AACF;AOtlCA;EACE;IACE,YAAA;EPwlCF;ED/ZG;;;;;;;;;;;IACC,WAAA;EC2aJ;EDpaC;IACC,WAAA;ECsaF;EDvaC;IACC,mBAAA;ECyaF;ED1aC;IACC,mBAAA;EC4aF;ED7aC;IACC,UAAA;EC+aF;EDhbC;IACC,mBAAA;ECkbF;EDnbC;IACC,mBAAA;ECqbF;EDtbC;IACC,UAAA;ECwbF;EDzbC;IACC,mBAAA;EC2bF;ED5bC;IACC,mBAAA;EC8bF;ED/bC;IACC,UAAA;ECicF;EDlcC;IACC,mBAAA;ECocF;EDrcC;IACC,kBAAA;ECucF;ED9bC;IACC,WAAA;ECgcF;EDjcC;IACC,mBAAA;ECmcF;EDpcC;IACC,mBAAA;ECscF;EDvcC;IACC,UAAA;ECycF;ED1cC;IACC,mBAAA;EC4cF;ED7cC;IACC,mBAAA;EC+cF;EDhdC;IACC,UAAA;ECkdF;EDndC;IACC,mBAAA;ECqdF;EDtdC;IACC,mBAAA;ECwdF;EDzdC;IACC,UAAA;EC2dF;ED5dC;IACC,mBAAA;EC8dF;ED/dC;IACC,kBAAA;ECieF;EDleC;IACC,SAAA;ECoeF;ED1eC;IACC,UAAA;EC4eF;ED7eC;IACC,kBAAA;EC+eF;EDhfC;IACC,kBAAA;ECkfF;EDnfC;IACC,SAAA;ECqfF;EDtfC;IACC,kBAAA;ECwfF;EDzfC;IACC,kBAAA;EC2fF;ED5fC;IACC,SAAA;EC8fF;ED/fC;IACC,kBAAA;ECigBF;EDlgBC;IACC,kBAAA;ECogBF;EDrgBC;IACC,SAAA;ECugBF;EDxgBC;IACC,kBAAA;EC0gBF;ED3gBC;IACC,iBAAA;EC6gBF;ED9gBC;IACC,QAAA;ECghBF;EDvgBC;IACC,iBAAA;ECygBF;ED1gBC;IACC,yBAAA;EC4gBF;ED7gBC;IACC,yBAAA;EC+gBF;EDhhBC;IACC,gBAAA;ECkhBF;EDnhBC;IACC,yBAAA;ECqhBF;EDthBC;IACC,yBAAA;ECwhBF;EDzhBC;IACC,gBAAA;EC2hBF;ED5hBC;IACC,yBAAA;EC8hBF;ED/hBC;IACC,yBAAA;ECiiBF;EDliBC;IACC,gBAAA;ECoiBF;EDriBC;IACC,yBAAA;ECuiBF;EDxiBC;IACC,wBAAA;EC0iBF;ED3iBC;IACC,eAAA;EC6iBF;AACF;AO7uCA;EACE;IACE,aAAA;EP+uCF;ED1kBG;;;;;;;;;;;IACC,WAAA;ECslBJ;ED/kBC;IACC,WAAA;ECilBF;EDllBC;IACC,mBAAA;EColBF;EDrlBC;IACC,mBAAA;ECulBF;EDxlBC;IACC,UAAA;EC0lBF;ED3lBC;IACC,mBAAA;EC6lBF;ED9lBC;IACC,mBAAA;ECgmBF;EDjmBC;IACC,UAAA;ECmmBF;EDpmBC;IACC,mBAAA;ECsmBF;EDvmBC;IACC,mBAAA;ECymBF;ED1mBC;IACC,UAAA;EC4mBF;ED7mBC;IACC,mBAAA;EC+mBF;EDhnBC;IACC,kBAAA;ECknBF;EDzmBC;IACC,WAAA;EC2mBF;ED5mBC;IACC,mBAAA;EC8mBF;ED/mBC;IACC,mBAAA;ECinBF;EDlnBC;IACC,UAAA;EConBF;EDrnBC;IACC,mBAAA;ECunBF;EDxnBC;IACC,mBAAA;EC0nBF;ED3nBC;IACC,UAAA;EC6nBF;ED9nBC;IACC,mBAAA;ECgoBF;EDjoBC;IACC,mBAAA;ECmoBF;EDpoBC;IACC,UAAA;ECsoBF;EDvoBC;IACC,mBAAA;ECyoBF;ED1oBC;IACC,kBAAA;EC4oBF;ED7oBC;IACC,SAAA;EC+oBF;EDrpBC;IACC,UAAA;ECupBF;EDxpBC;IACC,kBAAA;EC0pBF;ED3pBC;IACC,kBAAA;EC6pBF;ED9pBC;IACC,SAAA;ECgqBF;EDjqBC;IACC,kBAAA;ECmqBF;EDpqBC;IACC,kBAAA;ECsqBF;EDvqBC;IACC,SAAA;ECyqBF;ED1qBC;IACC,kBAAA;EC4qBF;ED7qBC;IACC,kBAAA;EC+qBF;EDhrBC;IACC,SAAA;ECkrBF;EDnrBC;IACC,kBAAA;ECqrBF;EDtrBC;IACC,iBAAA;ECwrBF;EDzrBC;IACC,QAAA;EC2rBF;EDlrBC;IACC,iBAAA;ECorBF;EDrrBC;IACC,yBAAA;ECurBF;EDxrBC;IACC,yBAAA;EC0rBF;ED3rBC;IACC,gBAAA;EC6rBF;ED9rBC;IACC,yBAAA;ECgsBF;EDjsBC;IACC,yBAAA;ECmsBF;EDpsBC;IACC,gBAAA;ECssBF;EDvsBC;IACC,yBAAA;ECysBF;ED1sBC;IACC,yBAAA;EC4sBF;ED7sBC;IACC,gBAAA;EC+sBF;EDhtBC;IACC,yBAAA;ECktBF;EDntBC;IACC,wBAAA;ECqtBF;EDttBC;IACC,eAAA;ECwtBF;AACF;AQp+CA;EACE,eAAA;EACA,6BAAA;ARs+CF;AQp+CA;EACE,gBAAA;ARs+CF;AQh+CA;EACE,WAAA;EACA,mBAAA;ARk+CF;AQp+CA;;;;;;EAUQ,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;ARk+CR;AQ/+CA;EAmBI,sBAAA;EACA,6BAAA;AR+9CJ;AQn/CA;;;;;;EA6BQ,aAAA;AR89CR;AQ3/CA;EAmCI,0BAAA;AR29CJ;AQ9/CA;EAwCI,yBAAA;ARy9CJ;AQl9CA;;;;;;EAOQ,YAAA;ARm9CR;AQx8CA;EACE,sBAAA;AR08CF;AQ38CA;;;;;;EAQQ,sBAAA;AR28CR;AQn9CA;;EAeM,wBAAA;ARw8CN;AQ97CA;;EAGI,yBAAA;AR+7CJ;AQt7CA;;EAGI,yBAAA;ARu7CJ;AQ96CA;EACE,WAAA;EACA,qBAAA;ARg7CF;AQ36CI;;EACE,WAAA;EACA,mBAAA;AR86CN;AQn6CA;;;;;;;;;;;;EAOI,yBAAA;AR06CJ;ADppCE;;;;;;;;;;;;EAOI,yBAAA;AC2pCN;ADrpCE;;;;EAKI,yBAAA;ACspCN;ADxqCE;;;;;;;;;;;;EAOI,yBAAA;AC+qCN;ADzqCE;;;;EAKI,yBAAA;AC0qCN;AD5rCE;;;;;;;;;;;;EAOI,yBAAA;ACmsCN;AD7rCE;;;;EAKI,yBAAA;AC8rCN;AQt9CA;EACE;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;IACA,iCAAA;ERw9CF;EQ/9CA;IAWI,gBAAA;ERu9CJ;EQl+CA;;;;;;IAoBU,mBAAA;ERs9CV;EQ1+CA;IA4BI,SAAA;ERi9CJ;EQ7+CA;;;;;;IAqCU,cAAA;ERg9CV;EQr/CA;;;;;;IAyCU,eAAA;ERo9CV;EQ7/CA;;;;IAsDU,gBAAA;ER68CV;AACF;ASzqDA;EACE,UAAA;EACA,SAAA;EACA,SAAA;AT2qDF;ASxqDA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,gCAAA;AT0qDF;ASvqDA;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;ATyqDF;ASlqDA;EL8DE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;AJumDF;ASnqDA;;EAEE,eAAA;EACA,kBAAA;ETqqDA,UAAU;ESpqDV,mBAAA;ATsqDF;ASlqDA;EACE,cAAA;AToqDF;AShqDA;;EAEE,YAAA;ATkqDF;AS9pDA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;ATgqDF;AS5pDA;;;EVpCE,4BAAA;EAEA,0CAAA;EACA,oBAAA;ACosDF;ASzpDE;;EAEE,YAAA;AT2pDJ;AStpDA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;ATwpDF;AS9nDA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uCAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;ELnCA,wDAAA;EACA,qDAAA;EACA,gDAAA;EL+BA,8EAAA;EACQ,sEAAA;EK7CR,2FAAA;EACA,wFAAA;EACA,sFAAA;EACA,mFAAA;AJorDF;AD97BE;EACE,qBAAA;EACA,UAAA;ACg8BJ;ADttDE;EAAgC,cAAA;ACytDlC;ADxtDE;EAAgC,cAAA;AC2tDlC;AD1tDE;EAAgC,cAAA;AC6tDlC;AD5tDE;EAAgC,cAAA;AC+tDlC;ASxoDE;;;EAGE,mBAAA;EACA,yBAAA;AT0oDJ;AStoDE;EACE,YAAA;ATwoDJ;AS9nDA;EACE,mBAAA;ATgoDF;ASxnDA;;EAEE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AT0nDF;ASjoDA;;EASI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AT4nDJ;ASznDA;;;;EAIE,WAAA;EACA,kBAAA;AT2nDF;ASznDA;;EAEE,gBAAA;AT2nDF;ASvnDA;;EAEE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;ATynDF;ASvnDA;;EAEE,aAAA;ATynDF;AS5mDE;;;;;;;;;;;;EAEE,mBAAA;ATwnDJ;ASnnDA;EVinBE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ACqgCF;ADngCE;EACE,YAAA;EACA,iBAAA;ACqgCJ;ADlgCE;EACE,YAAA;ACogCJ;AS7nDA;EV6mBE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ACmhCF;ADjhCE;EACE,YAAA;EACA,iBAAA;ACmhCJ;ADhhCE;EACE,YAAA;ACkhCJ;ASjoDA;;;;;;EVkjBI,cAAA;ACulCJ;ASzoDA;EVsjBI,qBAAA;EK/sBF,wDAAA;EACA,qDAAA;EACA,gDAAA;AJsyDF;ADvlCI;EACE,qBAAA;EKltBJ,yEAAA;EACA,sEAAA;EACA,iEAAA;AJ4yDF;ASrpDA;EVgkBI,cAAA;EACA,qBAAA;EACA,yBAAA;ACwlCJ;AStpDA;;;;;;EV8iBI,cAAA;ACgnCJ;AS9pDA;EVkjBI,qBAAA;EK/sBF,wDAAA;EACA,qDAAA;EACA,gDAAA;AJ+zDF;ADhnCI;EACE,qBAAA;EKltBJ,yEAAA;EACA,sEAAA;EACA,iEAAA;AJq0DF;AS1qDA;EV4jBI,cAAA;EACA,qBAAA;EACA,yBAAA;ACinCJ;AS3qDA;;;;;;EV0iBI,cAAA;ACyoCJ;ASnrDA;EV8iBI,qBAAA;EK/sBF,wDAAA;EACA,qDAAA;EACA,gDAAA;AJw1DF;ADzoCI;EACE,qBAAA;EKltBJ,yEAAA;EACA,sEAAA;EACA,iEAAA;AJ81DF;AS/rDA;EVwjBI,cAAA;EACA,qBAAA;EACA,yBAAA;AC0oCJ;AS1rDA;EACE,gBAAA;AT4rDF;ASnrDA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;ATqrDF;ASjqDE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ETkqDJ;ESvqDA;IAUI,qBAAA;ETgqDJ;ES1qDA;;IAkBI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,eAAA;ET4pDJ;ESjrDA;;IAyBI,WAAA;IACA,cAAA;ET4pDJ;AACF;ASlpDA;;;;;EAQI,aAAA;EACA,gBAAA;EACA,gBAAA;ATipDJ;AS3pDA;EV2QE,iBAAA;EACA,kBAAA;ACm5CF;AD99DE;;EAEE,YAAA;ECg+DF,MAAM;ED/9DJ,cAAA;ECi+DF,MAAM;AACR;ADh+DE;EACE,WAAA;ACk+DJ;ADx+DE;;EAEE,YAAA;EC0+DF,MAAM;EDz+DJ,cAAA;EC2+DF,MAAM;AACR;AD1+DE;EACE,WAAA;AC4+DJ;ASnrDA;EAmBI,gBAAA;EAEA,uBAAA;EACA,mBAAA;EACA,gBAAA;ATkqDJ;AS9pDE;EAAA;IAEI,iBAAA;ETgqDJ;AACF;AUvgEA;;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EXgeA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EAhRK,oBAAA;EK5HL,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AJy7DF;AU/gEE;;EXUA,4BAAA;EAEA,0CAAA;EACA,oBAAA;ACwgEF;AUjhEE;;;;EAEE,WAAA;EACA,qBAAA;AVqhEJ;AUlhEE;;;;EAEE,UAAA;EACA,sBAAA;EN2DF,wDAAA;EACA,qDAAA;EACA,gDAAA;AJ49DF;AUrhEE;;;;;;EAGE,mBAAA;EACA,oBAAA;ENYF,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EAEA,+DAAA;EACA,yBAAA;EAiCA,wBAAA;EACA,qBAAA;EACA,gBAAA;EMlDE,sBAAA;AViiEJ;AUzhEA;EC4oCE,WAAA;EACA,6BAAA;EACA,qBAAA;AXg5BF;ADjoDE;;;;;EAKE,WAAA;EACA,kCAAA;EACI,qBAAA;ACmoDR;ADjoDE;;;EAGE,sBAAA;ACmoDJ;AD9nDI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;AC0oDV;AW96BE;;;;;EAKE,WAAA;EACA,kCAAA;EACI,qBAAA;AXg7BR;AUpkEA;ECyoCE,WAAA;EACA,oCAAA;EACA,qBAAA;AX87BF;AD/qDE;;;;;EAKE,WAAA;EACA,oCAAA;EACI,qBAAA;ACirDR;AD/qDE;;;EAGE,sBAAA;ACirDJ;AD5qDI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;ACwrDV;AW59BE;;;;;EAKE,WAAA;EACA,oCAAA;EACI,qBAAA;AX89BR;AU/mEA;ECsoCE,cAAA;EACA,yBAAA;EACA,qBAAA;AX4+BF;AD7tDE;;;;;EAKE,cAAA;EACA,yBAAA;EACI,qBAAA;AC+tDR;AD7tDE;;;EAGE,sBAAA;AC+tDJ;AD1tDI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;ACsuDV;AW1gCE;;;;;EAKE,cAAA;EACA,yBAAA;EACI,qBAAA;AX4gCR;AUzpEA;ECkoCE,WAAA;EACA,yBAAA;EACA,qBAAA;AX0hCF;AD3wDE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AC6wDR;AD3wDE;;;EAGE,sBAAA;AC6wDJ;ADxwDI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;ACoxDV;AWxjCE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AX0jCR;AUnsEA;EC8nCE,WAAA;EACA,sBAAA;EACA,qBAAA;AXwkCF;ADzzDE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AC2zDR;ADzzDE;;;EAGE,sBAAA;AC2zDJ;ADtzDI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;ACk0DV;AWtmCE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AXwmCR;AU7uEA;EC0nCE,WAAA;EACA,sBAAA;EACA,qBAAA;AXsnCF;ADv2DE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;ACy2DR;ADv2DE;;;EAGE,sBAAA;ACy2DJ;ADp2DI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;ACg3DV;AWppCE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AXspCR;AUvxEA;ECsnCE,WAAA;EACA,yBAAA;EACA,qBAAA;AXoqCF;ADr5DE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;ACu5DR;ADr5DE;;;EAGE,sBAAA;ACu5DJ;ADl5DI;;;;;;;;;;;;;;;EAKE,oCAAA;EACI,qBAAA;AC85DV;AWlsCE;;;;;EAKE,WAAA;EACA,yBAAA;EACI,qBAAA;AXosCR;AU5zEA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AV8zEF;AU5zEE;;;;EAIE,6BAAA;ENDF,wBAAA;EACA,qBAAA;EACA,gBAAA;AJg0EF;AU9zEE;;;;EAIE,yBAAA;AVg0EJ;AU9zEE;;EAEE,cAAA;EACA,0BAAA;EACA,6BAAA;AVg0EJ;AU5zEI;;;;EAEE,cAAA;EACA,qBAAA;AVg0EN;AUvzEA;EXsXE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ACo8DF;AUzzEA;;EXkXE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AC28DF;AU3zEA;EACE,gBAAA;AV6zEF;AUtzEA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AVwzEF;AUpzEA;EACE,eAAA;AVszEF;AU/yEE;;;EACE,WAAA;AVmzEJ;AACA,8BAA8B;AU/yE9B;EACE;IACE,uBAAA;EVizEF;EU/yEA;IACE,yBAAA;EVizEF;AACF;AU9yEA;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sHAAA;EAEA,eAAA;AV+yEF;AU9yEE;EACE,yBAAA;EACI,qBAAA;AVgzER;AU9yEE;EACE,YAAA;AVgzEJ;AU9yEE;EACE,cAAA;EACA,WAAA;AVgzEJ;AU7yEE;EACE,8BAAA;EACA,qBAAA;EACA,WAAA;AV+yEJ;AU9yEI;EACE,oCAAA;EACI,qBAAA;AVgzEV;AU5yEE;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,6BAAA;EACA,UAAA;EACA,+BAAA;EACA,4CAAA;AV8yEJ;AU7yEI;;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AV+yEN;AU7yEI;EACE,uCAAA;AV+yEN;AU7yEI;EACE,kCAAA;EACA,mCAAA;EACA,6CAAA;EACA,mBAAA;EACA,mBAAA;EACA,uCAAA;AV+yEN;AU5yEE;;EAEE,eAAA;EACA,wBAAA;EACA,iCAAA;EACA,2BAAA;EACA,+BAAA;AV8yEJ;AU3yEI;EACE,yBAAA;EACA,qBAAA;AV6yEN;AACA;oDACoD;AACpD,mDAAmD;AYziFnD;EACE,UAAA;EbqHA,wCAAA;EACQ,gCAAA;EK7CR,qDAAA;EACA,kDAAA;EACA,gDAAA;EACA,6CAAA;AJq+EF;AY/iFE;EACE,UAAA;AZijFJ;AY7iFA;EACE,aAAA;AZ+iFF;AY9iFE;EACE,cAAA;AZgjFJ;AY7iFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EbqGA,qCAAA;EACQ,6BAAA;EK7CR,kDAAA;EACA,+CAAA;EACA,6CAAA;EACA,0CAAA;AJy/EF;AazkFA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;EAGA,uBAAA;AbykFF;AarkFA;EACE,kBAAA;AbukFF;AankFA;EACE,UAAA;AbqkFF;AajkFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;ETgDA,mDAAA;EACA,gDAAA;EACA,2CAAA;EShDA,4BAAA;AbqkFF;AalkFE;EACE,QAAA;EACA,UAAA;AbokFJ;Aa1lFA;EdkWE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AC2vEF;AahmFA;EAgCI,cAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AbmkFJ;Aa5jFE;;;EAGE,cAAA;EACA,qBAAA;EACA,UAAA;EACA,sBAAA;Ab8jFJ;AarjFE;;;EAGE,cAAA;AbujFJ;AaljFE;;EAEE,qBAAA;EACA,6BAAA;EACA,sBAAA;Ed+OF,mEAAA;Ec7OE,mBAAA;AbojFJ;Aa/iFA;EAGI,cAAA;Ab+iFJ;AaljFA;EAQI,UAAA;Ab6iFJ;AaxiFA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;Ab0iFF;AatiFA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AbwiFF;AapiFA;EACE,QAAA;EACA,UAAA;AbsiFF;Aa9hFA;;EAMI,oBAAA;EACA,6BAAA;EACA,WAAA;Ab4hFJ;AapiFA;;EAYI,SAAA;EACA,YAAA;EACA,kBAAA;Ab4hFJ;AanhFA;EACE;IAjCA,QAAA;IACA,UAAA;EbujFA;AACF;AajhFA;EACE;IACE,YAAA;IACA,UAAA;IACA,cAAA;EbmhFF;AACF;ActsFE;EACE,sBAAA;AdwsFJ;ActsFE;;;;;EAKE,sBAAA;AdwsFJ;AcrsFA;EAEI,yBAAA;AdssFJ;AcxsFA;;;;;EAUM,yBAAA;AdqsFN;Ac/rFA;;EAEE,kBAAA;EACA,qBAAA;EACA,sBAAA;AdisFF;AcrsFA;;EAMI,kBAAA;EACA,WAAA;AdmsFJ;AcjsFI;;;;;;;;EAIE,UAAA;AdusFN;AcrsFI;;EAEE,aAAA;AdusFN;AcjsFA;;;;EAKI,iBAAA;AdksFJ;AD/uFE;;EAEE,YAAA;ECivFF,MAAM;EDhvFJ,cAAA;ECkvFF,MAAM;AACR;ADjvFE;EACE,WAAA;ACmvFJ;ADzvFE;;EAEE,YAAA;EC2vFF,MAAM;ED1vFJ,cAAA;EC4vFF,MAAM;AACR;AD3vFE;EACE,WAAA;AC6vFJ;AcjtFA;EAII,WAAA;AdgtFJ;AcptFA;;;;EAWM,gBAAA;Ad+sFN;Ac1sFA;EACE,gBAAA;Ad4sFF;AcxsFA;EACE,cAAA;Ad0sFF;AczsFE;EfeA,6BAAA;EACG,0BAAA;AC6rFL;AcxsFA;;EfkBE,4BAAA;EACG,yBAAA;AC0rFL;AcvsFA;EACE,WAAA;AdysFF;AcvsFA;EACE,gBAAA;AdysFF;AcvsFA;;EfFE,6BAAA;EACG,0BAAA;AC6sFL;ActsFA;EfAE,4BAAA;EACG,yBAAA;ACysFL;AcrsFA;;EAEE,UAAA;AdusFF;Ac/rFA;EfgXE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EW/WA,gBAAA;AVksFF;AcrsFA;Ef+WE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ACy1EF;Ac1sFA;Ef8WE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AC+1EF;AczsFA;EACE,iBAAA;EACA,kBAAA;Ad2sFF;AczsFA;EACE,kBAAA;EACA,mBAAA;Ad2sFF;ActsFA;EVxDE,wDAAA;EACA,qDAAA;EACA,gDAAA;AJiwFF;AcvsFE;EV5DA,wBAAA;EACA,qBAAA;EACA,gBAAA;AJswFF;AcrsFA;EACE,cAAA;AdusFF;AcpsFA;EACE,uBAAA;EACA,sBAAA;AdssFF;AcnsFA;EACE,uBAAA;AdqsFF;Ac9rFA;;EAGI,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;Ad+rFJ;ADp2FE;;EAEE,YAAA;ECs2FF,MAAM;EDr2FJ,cAAA;ECu2FF,MAAM;AACR;ADt2FE;EACE,WAAA;ACw2FJ;AD92FE;;EAEE,YAAA;ECg3FF,MAAM;ED/2FJ,cAAA;ECi3FF,MAAM;AACR;ADh3FE;EACE,WAAA;ACk3FJ;AcztFA;EAaM,WAAA;Ad+sFN;Ac5tFA;;;;EAqBI,gBAAA;EACA,cAAA;Ad6sFJ;AcxsFE;EACE,gBAAA;Ad0sFJ;AcxsFE;EACE,4BAAA;EflGF,6BAAA;EACC,4BAAA;AC6yFH;AczsFE;EACE,8BAAA;Ef9GF,0BAAA;EACC,yBAAA;AC0zFH;AczsFA;EACE,gBAAA;Ad2sFF;AczsFA;;Ef7GE,6BAAA;EACC,4BAAA;AC0zFH;AcxsFA;Ef3HE,0BAAA;EACC,yBAAA;ACs0FH;AcnsFA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AdqsFF;AczsFA;EAMI,WAAA;EACA,mBAAA;EACA,SAAA;AdssFJ;AchsFA;;EAEE,aAAA;AdksFF;Aev7FA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;Afy7FF;Aet7FE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;Afw7FJ;Aej8FA;EAaI,WAAA;EACA,gBAAA;Afu7FJ;Ae96FA;;;EhB6zBE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ACsnEF;ADpnEE;;;EACE,YAAA;EACA,iBAAA;ACwnEJ;ADrnEE;;;EACE,YAAA;ACynEJ;Ae/7FA;;;EhB0zBE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AC0oEF;ADxoEE;;;EACE,YAAA;EACA,iBAAA;AC4oEJ;ADzoEE;;;EACE,YAAA;AC6oEJ;Ae58FA;;;EAGE,mBAAA;Af88FF;Ae58FE;;;EACE,gBAAA;Afg9FJ;Ae58FA;;EAEE,SAAA;EACA,mBAAA;EACA,sBAAA;Af88FF;Aez8FA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;Af28FF;Aex8FE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;Af08FJ;Aex8FE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;Af08FJ;Ae/9FA;;EA2BI,aAAA;Afw8FJ;Aen8FA;;;;;EhBiBE,6BAAA;EACG,0BAAA;ACy7FL;Aep8FA;EACE,eAAA;Afs8FF;Aep8FA;;;;;EhBeE,4BAAA;EACG,yBAAA;AC47FL;Aer8FA;EACE,cAAA;Afu8FF;Ael8FA;EACE,kBAAA;EACA,mBAAA;Afo8FF;Aej8FE;EACE,kBAAA;Afm8FJ;Aej8FE;EACE,iBAAA;Afm8FJ;Aeh8FA;EACE,kBAAA;Afk8FF;Aen8FA;EAII,iBAAA;Afk8FJ;Ae/7FE;;EAEE,UAAA;Afi8FJ;AgB/jGA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EhBikGA;;;;;;;;;;;;IAYE;AACJ;ADtkGE;;EAEE,YAAA;ECwkGF,MAAM;EDvkGJ,cAAA;ECykGF,MAAM;AACR;ADxkGE;EACE,WAAA;AC0kGJ;ADhlGE;;EAEE,YAAA;ECklGF,MAAM;EDjlGJ,cAAA;ECmlGF,MAAM;AACR;ADllGE;EACE,WAAA;AColGJ;AgBrmGA;EAOI,kBAAA;EACA,cAAA;AhBimGJ;AgBzmGA;EAWM,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AhBimGN;AgBhmGM;;EAEE,qBAAA;EACA,yBAAA;AhBkmGR;AgB7lGI;EACE,cAAA;AhB+lGN;AgB7lGM;;EAEE,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;AhB+lGR;AgBhoGA;EjByXE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AC0wFF;AgBtoGA;EAkEI,eAAA;AhBukGJ;AgB9jGA;EACE,6BAAA;AhBgkGF;AgBjkGA;EAGI,WAAA;EAEA,mBAAA;AhBgkGJ;AgBrkGA;EASM,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;AhB+jGN;AgB9jGM;EACE,kCAAA;AhBgkGR;AgB1jGM;;;EAGE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;AhB4jGR;AgBvjGE;EAmEA,WAAA;EA8BA,gBAAA;AhB09FF;AgB3jGE;EAsEE,WAAA;AhBw/FJ;AgB9jGE;EAwEI,kBAAA;EACA,kBAAA;AhBy/FN;AgBlkGE;EA8EE,SAAA;EACA,UAAA;AhBu/FJ;AgBp/FE;EAAA;IAEI,mBAAA;IACA,SAAA;EhBs/FJ;EgBz/FA;IAKM,gBAAA;EhBu/FN;AACF;AgB/kGE;EAqGE,eAAA;EACA,kBAAA;AhB6+FJ;AgBnlGE;;;EA4GE,sBAAA;AhB4+FJ;AgBz+FE;EAAA;IAEI,6BAAA;IACA,0BAAA;EhB2+FJ;EgB9+FA;;;IAQI,4BAAA;EhB2+FJ;AACF;AgB1lGA;EAEI,WAAA;AhB2lGJ;AgB7lGA;EAMM,kBAAA;EACA,eAAA;AhB0lGN;AgBjmGA;EAUM,gBAAA;AhB0lGN;AgBrlGM;;;EAGE,cAAA;EACA,sBAAA;AhBulGR;AgB3lGM;;;EAOI,yBAAA;EACA,4BAAA;AhBylGV;AgBnlGM;;EhBslGJ,+BAA+B;EAC/B,0BAA0B;AAC5B;AgB7kGA;EAEI,WAAA;AhB8kGJ;AgBhlGA;EAIM,eAAA;EACA,cAAA;AhB+kGN;AgBnkGA;EACE,WAAA;AhBqkGF;AgBtkGA;EAII,WAAA;AhBqkGJ;AgBzkGA;EAMM,kBAAA;EACA,kBAAA;AhBskGN;AgB7kGA;EAYI,SAAA;EACA,UAAA;AhBokGJ;AgBjkGE;EAAA;IAEI,mBAAA;IACA,SAAA;EhBmkGJ;EgBtkGA;IAKM,gBAAA;EhBokGN;AACF;AgB5jGA;EACE,gBAAA;AhB8jGF;AgB/jGA;EAKI,eAAA;EACA,kBAAA;AhB6jGJ;AgBnkGA;;;EAYI,sBAAA;AhB4jGJ;AgBzjGE;EAAA;IAEI,6BAAA;IACA,0BAAA;EhB2jGJ;EgB9jGA;;;IAQI,4BAAA;EhB2jGJ;AACF;AgBljGA;EAEI,aAAA;AhBmjGJ;AgBrjGA;EAKI,cAAA;AhBmjGJ;AgB1iGA;EACE,yBAAA;EACA,4BAAA;AhB4iGF;AgB1iGA;EACE,yBAAA;EACA,4BAAA;AhB4iGF;AgBxiGA;EAEE,gBAAA;EjBvKA,0BAAA;EACC,yBAAA;ACitGH;AgBriGE;EAAA;IACE,wCAAA;EhBwiGF;AACF;AgBriGA;;;EAOE,yBAAA;AhBmiGF;AgBtiGE;EAAA;;;IACE,6BAAA;EhB2iGF;AACF;AgBhiGA;EACI;IACE,uBAAA;EhBkiGJ;AACF;AiBr0GA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;AjBu0GF;ADj0GE;;EAEE,YAAA;ECm0GF,MAAM;EDl0GJ,cAAA;ECo0GF,MAAM;AACR;ADn0GE;EACE,WAAA;ACq0GJ;AD30GE;;EAEE,YAAA;EC60GF,MAAM;ED50GJ,cAAA;EC80GF,MAAM;AACR;AD70GE;EACE,WAAA;AC+0GJ;AiBt1GE;EAAA;IACE,kBAAA;EjBy1GF;AACF;AD11GE;;EAEE,YAAA;EC41GF,MAAM;ED31GJ,cAAA;EC61GF,MAAM;AACR;AD51GE;EACE,WAAA;AC81GJ;ADp2GE;;EAEE,YAAA;ECs2GF,MAAM;EDr2GJ,cAAA;ECu2GF,MAAM;AACR;ADt2GE;EACE,WAAA;ACw2GJ;AiBj2GE;EAAA;IACE,WAAA;EjBo2GF;AACF;AiBt1GA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kDAAA;EAEA,iCAAA;AjBu1GF;AD33GE;;EAEE,YAAA;EC63GF,MAAM;ED53GJ,cAAA;EC83GF,MAAM;AACR;AD73GE;EACE,WAAA;AC+3GJ;ADr4GE;;EAEE,YAAA;ECu4GF,MAAM;EDt4GJ,cAAA;ECw4GF,MAAM;AACR;ADv4GE;EACE,WAAA;ACy4GJ;AiBz2GE;EACE,gBAAA;AjB22GJ;AiBx2GE;EAAA;IACE,WAAA;IACA,aAAA;IACA,gBAAA;EjB22GF;EiBz2GE;IACE,yBAAA;IACA,uBAAA;IACA,iBAAA;IACA,4BAAA;EjB22GJ;EiBx2GE;IACE,gBAAA;EjB02GJ;EiBv3GA;IAkBI,kBAAA;EjBw2GJ;EiB13GA;IAqBI,mBAAA;EjBw2GJ;EiB73GA;IAwBI,eAAA;EjBw2GJ;AACF;AiB/1GA;;EAEE,mBAAA;EACA,kBAAA;AjBi2GF;AiB/1GE;EAAA;;IACE,eAAA;IACA,cAAA;IACA,aAAA;EjBm2GF;AACF;AiBx1GA;EACE,aAAA;EACA,qBAAA;AjB01GF;AiBx1GE;EAAA;IACE,gBAAA;EjB21GF;AACF;AiBv1GA;;EAEE,eAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;AjBy1GF;AiBt1GE;EAAA;;IACE,gBAAA;EjB01GF;AACF;AiBx1GA;EACE,MAAA;EACA,qBAAA;AjB01GF;AiBx1GA;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;AjB01GF;AiBp1GA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AjBs1GF;AiBp1GE;;EAEE,qBAAA;AjBs1GJ;AiBn1GE;EACE;IACE,kBAAA;EjBq1GJ;AACF;AiB30GA;EACI,8BAAA;AjB60GJ;AiBz0GA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;ElB2WA,eAAA;EACA,kBAAA;EkBzWA,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;AjB20GF;AiBp1GA;EAaI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;AjB00GJ;AiB71GA;EAuBI,eAAA;AjBy0GJ;AiBt0GE;EAAA;IACE,aAAA;EjBy0GF;AACF;AiBt0GA;;EACE,qBAAA;AjBy0GF;AiBv0GA;EACE,iBAAA;AjBy0GF;AiBv0GA;EACE,aAAA;AjBy0GF;AiBv0GA;EACE,sBAAA;AjBy0GF;AiBv0GA;EACE,WAAA;AjBy0GF;AiBv0GA;EACE,oBAAA;AjBy0GF;AiBv0GA;EACE,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;AjBy0GF;AiBt0GA;EAAkB,sBAAA;AjBy0GlB;AiBv0GA;EACE,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AjBy0GF;AiBv0GA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AjBy0GF;AiBv0GA;EACE,eAAA;AjBy0GF;AiB7zGA;EACE,yBAAA;AjB+zGF;AiBh0GA;EAII,iBAAA;EACA,oBAAA;EACA,iBAAA;AjB+zGJ;AiBr0GA;EAUI,cAAA;AjB8zGJ;AiB5zGI;EACE,WAAA;AjB8zGN;AiB3zGI;EACE,0CAAA;AjB6zGN;AiB9zGI;EAGI,WAAA;EACA,mBAAA;AjB8zGR;AiBzzGE;EAAA;IAGI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IACA,gBAAA;EjB0zGJ;EiBn0GA;;IAYM,0BAAA;EjB2zGN;EiBv0GA;IAeM,iBAAA;EjB2zGN;EiB1zGM;;IAEE,sBAAA;EjB4zGR;EiB90GA;IAwBI,YAAA;IAEA,gCAAA;EjBwzGJ;EiBrzGE;IACE,wBAAA;EjBuzGJ;AACF;AiBnzGE;EAAA;IACE,WAAA;IACA,SAAA;EjBszGF;EiBxzGA;IAKI,WAAA;EjBszGJ;AACF;AiB1yGA;EACE;ICnUA,sBAAA;ICRW,WAAA;EnBynHX;EiB7yGA;ICvUA,uBAAA;ICNY,YAAA;EnB8nHZ;AACF;AiBzyGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EbtQA,4FAAA;EACA,yFAAA;EACA,oFAAA;ELicA,eAAA;EACA,kBAAA;ACknGF;AiB7yGE;EAAA;IACE,eAAA;IACA,gBAAA;EjBgzGF;AACF;AS72GE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ET82GJ;ESn3GA;IAUI,qBAAA;ET42GJ;ESt3GA;;IAkBI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,eAAA;ETw2GJ;ES73GA;;IAyBI,WAAA;IACA,cAAA;ETw2GJ;AACF;AiBj0GI;EAAA;IACE,kBAAA;EjBo0GJ;AACF;AiB7zGE;EAAA;IACE,WAAA;IACA,SAAA;IACA,cAAA;IACA,eAAA;IACA,cAAA;IACA,iBAAA;IbhSF,wBAAA;IACA,qBAAA;IACA,gBAAA;EJimHA;AACF;AiB3zGA;EACE,aAAA;ElBjSA,0BAAA;EACC,yBAAA;AC+lHH;AiB3zGA;ElB7RE,6BAAA;EACC,4BAAA;AC2lHH;AiB1zGA;;EAEE,UAAA;EACA,QAAA;AjB4zGF;AiBpzGA;ElBqIE,eAAA;EACA,kBAAA;ACkrGF;AiB/yGA;EACE,WAAA;ElB2HA,gBAAA;EACA,mBAAA;ACurGF;AiBhzGE;EAAA;IACE,iBAAA;IACA,kBAAA;EjBmzGF;AACF;AiBjzGA;EACE,WAAA;ElBkHA,gBAAA;EACA,mBAAA;ACksGF;AiBlzGE;EAAA;IACE,iBAAA;IACA,kBAAA;IACA,0BAAA;EjBqzGF;AACF;AiB9yGA;EACE,yBAAA;EACA,qBAAA;AjBgzGF;AiBlzGA;EAKI,WAAA;AjBgzGJ;AiB/yGI;;EAEE,cAAA;EACA,6BAAA;AjBizGN;AiB1zGA;EAcI,WAAA;AjB+yGJ;AiB7zGA;EAmBM,WAAA;AjB6yGN;AiB5yGM;;EAEE,WAAA;EACA,6BAAA;AjB8yGR;AiBzyGM;;;EAGE,WAAA;EACA,yBAAA;AjB2yGR;AiBvyGM;;;EAGE,WAAA;EACA,6BAAA;AjByyGR;AiBj1GA;EA8CI,kBAAA;AjBsyGJ;AiBryGI;;EAEE,sBAAA;AjBuyGN;AiBx1GA;EAoDM,sBAAA;AjBuyGN;AiB31GA;;EA0DI,qBAAA;AjBqyGJ;AiB/1GA;;EAkEM,sBAAA;EACA,yBAAA;AjBiyGN;AiB5xGM;;;EAGE,yBAAA;EACA,WAAA;AjB8xGR;AiBlyGM;;;EAMI,sBAAA;EACA,yBAAA;AjBiyGV;AiBh3GA;EAoFM,sBAAA;EACA,yBAAA;AjB+xGN;AiB3xGI;EAAA;IAIM,WAAA;EjB2xGR;EiB1xGQ;;IAEE,WAAA;IACA,6BAAA;EjB4xGV;EiBxxGQ;;;IAGE,WAAA;IACA,yBAAA;EjB0xGV;EiBtxGQ;;;IAGE,WAAA;IACA,6BAAA;EjBwxGV;AACF;AiB14GA;EA8HI,WAAA;AjB+wGJ;AiB9wGI;EACE,WAAA;AjBgxGN;AiBxwGA;EACE,sBAAA;EACA,qBAAA;AjB0wGF;AiB5wGA;EAKI,cAAA;AjB0wGJ;AiBzwGI;;EAEE,WAAA;EACA,6BAAA;AjB2wGN;AiBpxGA;EAcI,cAAA;AjBywGJ;AiBvxGA;EAmBM,cAAA;AjBuwGN;AiBrwGM;;EAEE,WAAA;EACA,6BAAA;AjBuwGR;AiBnwGM;;;EAGE,WAAA;EACA,yBAAA;AjBqwGR;AiBjwGM;;;EAGE,WAAA;EACA,6BAAA;AjBmwGR;AiB3yGA;EA+CI,kBAAA;AjB+vGJ;AiB9vGI;;EAEE,sBAAA;AjBgwGN;AiBlzGA;EAqDM,sBAAA;AjBgwGN;AiBrzGA;;EA2DI,qBAAA;AjB8vGJ;AiBxvGM;;;EAGE,yBAAA;EACA,WAAA;AjB0vGR;AiB/zGA;EAyEM,sBAAA;EACA,yBAAA;AjByvGN;AiBn0GA;EA6EM,yBAAA;EACA,4BAAA;AjByvGN;AiBtvGM;;;EAII,sBAAA;EACA,yBAAA;AjBuvGV;AiBlvGI;EAAA;IAIM,qBAAA;EjBkvGR;EiBtvGE;IAOM,cAAA;EjBkvGR;EiBjvGQ;;IAEE,WAAA;IACA,6BAAA;EjBmvGV;EiB/uGQ;;;IAGE,WAAA;IACA,yBAAA;EjBivGV;EiB7uGQ;;;IAGE,WAAA;IACA,6BAAA;EjB+uGV;AACF;AiBt2GA;EA8HI,cAAA;AjB2uGJ;AiB1uGI;EACE,WAAA;AjB4uGN;AiBtuGA;EACE,gBAAA;EACA,mBAAA;AjBwuGF;AiBruGA;EACE;IACE,iBAAA;IACA,oBAAA;EjBuuGF;AACF;AiBjuGE;EACE,WAAA;EACA,eAAA;AjBmuGJ;AiBruGE;EAKI,YAAA;EACA,gBAAA;AjBmuGN;AiBjuGM;EACE,gBAAA;EACA,gBAAA;AjBmuGR;AiBhuGM;EACE,iBAAA;AjBkuGR;AiB3tGA;EAEI,gBAAA;EACA,cAAA;AjB4tGJ;AiB/tGA;EAOM,gBAAA;EACA,WAAA;AjB2tGN;AoB78HA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ApB+8HF;AoBp9HA;EAOI,qBAAA;ApBg9HJ;AoBv9HA;EASM,iBAAA;EACA,cAAA;EACA,WAAA;ApBi9HN;AoB59HA;EAeI,cAAA;ApBg9HJ;AqBj+HA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ArBm+HF;AqBv+HA;EAOI,eAAA;ArBm+HJ;AqB1+HA;;EAUM,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;ArBo+HN;AqBl+HI;;EAGI,cAAA;EtB0FN,8BAAA;EACG,2BAAA;AC04HL;AqBj+HI;;EtB8EF,+BAAA;EACG,4BAAA;ACu5HL;AqB59HI;;;;EAEE,yBAAA;ArBg+HN;AqB19HI;;;;;;EAGE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;ArB+9HN;AqBlhIA;;;;;;EA8DM,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;ArB49HN;AqBn9HA;;EtBibM,kBAAA;EACA,eAAA;ACsiHN;ADpiHI;;EA9YF,8BAAA;EACG,2BAAA;ACs7HL;ADniHI;;EA5ZF,+BAAA;EACG,4BAAA;ACm8HL;AqB79HA;;EtB4aM,iBAAA;EACA,eAAA;ACqjHN;ADnjHI;;EA9YF,8BAAA;EACG,2BAAA;ACq8HL;ADljHI;;EA5ZF,+BAAA;EACG,4BAAA;ACk9HL;AsBzjIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AtB2jIF;ADjjIE;;EAEE,YAAA;ECmjIF,MAAM;EDljIJ,cAAA;ECojIF,MAAM;AACR;ADnjIE;EACE,WAAA;ACqjIJ;AD3jIE;;EAEE,YAAA;EC6jIF,MAAM;ED5jIJ,cAAA;EC8jIF,MAAM;AACR;AD7jIE;EACE,WAAA;AC+jIJ;AsBnlIA;EAOI,eAAA;AtB+kIJ;AsBtlIA;;EAUM,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AtBglIN;AsB9lIA;;EAmBM,qBAAA;EACA,yBAAA;AtB+kIN;AsBnmIA;;EA2BM,YAAA;AtB4kIN;AsBvmIA;;EAkCM,WAAA;AtBykIN;AsB3mIA;;;;EA2CM,cAAA;EACA,sBAAA;EACA,mBAAA;AtBskIN;AuBpnIA;EACE,eAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;AvBsnIF;AuBlnII;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AvBonIN;AuB/mIE;EACE,aAAA;AvBinIJ;AuB1mIA;ExBgfE,yBAAA;AC6nHF;AD3nHI;;EAEE,yBAAA;AC6nHN;AuB7mIA;ExB4eE,sBAAA;ACooHF;ADloHI;;EAEE,yBAAA;ACooHN;AuBhnIA;ExBweE,sBAAA;AC2oHF;ADzoHI;;EAEE,yBAAA;AC2oHN;AuBnnIA;ExBoeE,yBAAA;ACkpHF;ADhpHI;;EAEE,yBAAA;ACkpHN;AuBtnIA;ExBgeE,yBAAA;ACypHF;ADvpHI;;EAEE,yBAAA;ACypHN;AuBznIA;ExB4dE,sBAAA;ACgqHF;AD9pHI;;EAEE,yBAAA;ACgqHN;AwBjrIA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AxBmrIF;AwBhrIE;EACE,aAAA;AxBkrIJ;AwB5qIE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AxB8qIJ;AwBzqIA;EACE,kBAAA;EACA,SAAA;AxB2qIF;AwBxqIA;EACI;IACM,SAAA;IACA,gBAAA;IACA,oBAAA;ExB0qIR;AACF;AwBtqIA;;EAEE,cAAA;EACA,sBAAA;AxBwqIF;AwBtqIA;EACE,gBAAA;AxBwqIF;AyB5tIA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AzB8tIF;AyBruIA;EAUI,cAAA;EACA,cAAA;AzB8tIJ;AyBzuIA;EAcI,gBAAA;AzB8tIJ;AyB3tIE;EACE,kBAAA;AzB6tIJ;AyB1tIE;EAAA;IACE,iBAAA;IACA,oBAAA;EzB6tIF;EyB3tIE;IACE,kBAAA;IACA,mBAAA;EzB6tIJ;EyBnuIA;IAUI,eAAA;EzB4tIJ;AACF;A0B3vIA;EvBwEE,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EJ6CA,wCAAA;EACQ,gCAAA;EK7CR,qDAAA;EACA,kDAAA;EACA,gDAAA;EACA,6CAAA;EL8RA,qBAAA;EACA,eAAA;EACA,YAAA;E2B9WA,cAAA;EACA,mBAAA;A1B0wIF;A0B7wIA;E3B8WE,cAAA;EACA,eAAA;EACA,YAAA;E2BzWE,iBAAA;EACA,kBAAA;A1B4wIJ;A0BxwIE;;;EAGE,qBAAA;A1B0wIJ;A0BzxIA;EAoBI,YAAA;EACA,WAAA;A1BwwIJ;A2B3xIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;A3B6xIF;A2BjyIA;EAQI,aAAA;EAEA,cAAA;A3B2xIJ;A2BryIA;EAcI,iBAAA;A3B0xIJ;A2BxyIA;;EAoBI,gBAAA;A3BwxIJ;A2B5yIA;EAuBI,eAAA;A3BwxIJ;A2BhxIA;EACC,mBAAA;A3BkxID;A2BnxIA;EAKI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;A3BixIJ;A2BzwIA;E5B2WE,yBAAA;EACA,qBAAA;EACA,cAAA;ACi6HF;A2B9wIA;E5BgXI,yBAAA;ACi6HJ;A2BjxIA;E5BmXI,cAAA;ACi6HJ;A2BjxIA;E5BwWE,yBAAA;EACA,qBAAA;EACA,cAAA;AC46HF;A2BtxIA;E5B6WI,yBAAA;AC46HJ;A2BzxIA;E5BgXI,cAAA;AC46HJ;A2BzxIA;E5BqWE,yBAAA;EACA,qBAAA;EACA,cAAA;ACu7HF;A2B9xIA;E5B0WI,yBAAA;ACu7HJ;A2BjyIA;E5B6WI,cAAA;ACu7HJ;A2BjyIA;E5BkWE,yBAAA;EACA,qBAAA;EACA,cAAA;ACk8HF;A2BtyIA;E5BuWI,yBAAA;ACk8HJ;A2BzyIA;E5B0WI,cAAA;ACk8HJ;A4Bn2IA;EACE;IAAQ,2BAAA;E5Bs2IR;E4Br2IA;IAAQ,wBAAA;E5Bw2IR;AACF;A4Br2IA;EACE;IAAQ,2BAAA;E5Bw2IR;E4Bv2IA;IAAQ,wBAAA;E5B02IR;AACF;A4Bv2IA;EACE;IAAQ,wBAAA;E5B02IR;E4Bz2IA;IAAQ,2BAAA;E5B42IR;AACF;A4Bz2IA;EACE;IAAQ,2BAAA;E5B42IR;E4B32IA;IAAQ,wBAAA;E5B82IR;AACF;A4Bt2IA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;ExBmDA,sDAAA;EACA,mDAAA;EACA,8CAAA;AJszIF;A4Bt2IA;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;ExBsCA,sDAAA;EACA,mDAAA;EACA,8CAAA;EL+BA,mCAAA;EACQ,2BAAA;EK7CR,gDAAA;EACA,6CAAA;EACA,2CAAA;EACA,wCAAA;AJm1IF;A4B32IA;E7B4QI,6SAAA;EACA,6MAAA;EACA,0MAAA;EACA,qMAAA;E6B7QF,0BAAA;A5Bg3IF;A4B52IA;E7BuIE,0DAAA;EACQ,kDAAA;ACwuIV;A4Bv2IA;E7B2dE,sBAAA;AC+4HF;AD94HE;EA/NE,6SAAA;EACA,6MAAA;EACA,0MAAA;EACA,qMAAA;ACgnIJ;A4B52IA;E7BudE,yBAAA;ACw5HF;ADv5HE;EA/NE,6SAAA;EACA,6MAAA;EACA,0MAAA;EACA,qMAAA;ACynIJ;A4Bj3IA;E7BmdE,yBAAA;ACi6HF;ADh6HE;EA/NE,6SAAA;EACA,6MAAA;EACA,0MAAA;EACA,qMAAA;ACkoIJ;A4Bt3IA;E7B+cE,sBAAA;AC06HF;ADz6HE;EA/NE,6SAAA;EACA,6MAAA;EACA,0MAAA;EACA,qMAAA;AC2oIJ;A6B/8IA;;EAEE,gBAAA;EACA,OAAA;A7Bi9IF;A6B78IA;;EAEE,gBAAA;A7B+8IF;A6B78IA;EACE,aAAA;A7B+8IF;A6B38IA;EACE,cAAA;A7B68IF;A6Bz8IA;EACE,eAAA;A7B28IF;A6Bp8IA;EAEI,kBAAA;A7Bq8IJ;A6Bv8IA;EAKI,iBAAA;A7Bq8IJ;A6B57IA;EACE,eAAA;EACA,gBAAA;A7B87IF;A8B7+IA;EAEE,mBAAA;EACA,eAAA;A9B8+IF;A8Bx+IA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAEA,mBAAA;EACA,sBAAA;EACA,sBAAA;A9By+IF;A8Bt+IE;E/B6EA,4BAAA;EACC,2BAAA;AC45IH;A8Bv+IE;EACE,gBAAA;E/BiFF,+BAAA;EACC,8BAAA;ACy5IH;A8Bz/IA;EAoBI,YAAA;A9Bw+IJ;A8B5/IA;EAuBI,iBAAA;A9Bw+IJ;A8Bn+IA;EACE,WAAA;A9Bq+IF;A8Bt+IA;EAII,WAAA;A9Bq+IJ;A8Bj+IE;;EAEE,qBAAA;EACA,yBAAA;A9Bm+IJ;A8B/9IE;;;EAGE,UAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;A9Bi+IJ;A8Bv+IE;;;EAUI,cAAA;A9Bk+IN;A8B5+IE;;;EAaI,cAAA;A9Bo+IN;A8B59IA;EACE,aAAA;EACA,kBAAA;A9B89IF;A8B59IA;EACE,gBAAA;EACA,gBAAA;A9B89IF;A+B9iJA;EACE,mBAAA;EACA,wCAAA;EACA,6BAAA;EACA,kBAAA;E3BoFA,iDAAA;EACA,8CAAA;EACA,yCAAA;AJ69IF;A+B/iJA;EACE,mBAAA;A/BijJF;A+B1iJA;EACE,mBAAA;A/B4iJF;A+BziJA;EACE,mBAAA;A/B2iJF;A+BxiJA;EACE,mBAAA;A/B0iJF;A+BviJA;EACE,iCAAA;A/ByiJF;A+BviJA;EACE,iCAAA;EACA,qBAAA;A/ByiJF;A+BtiJA;EACE,yBAAA;EACA,qBAAA;A/BwiJF;A+BriJA;EACE,mBAAA;EACA,qBAAA;A/BuiJF;A+BpiJA;EACE,mBAAA;A/BsiJF;A+BliJA;EACE,aAAA;A/BoiJF;AD3kJE;;EAEE,YAAA;EC6kJF,MAAM;ED5kJJ,cAAA;EC8kJF,MAAM;AACR;AD7kJE;EACE,WAAA;AC+kJJ;ADrlJE;;EAEE,YAAA;ECulJF,MAAM;EDtlJJ,cAAA;ECwlJF,MAAM;AACR;ADvlJE;EACE,WAAA;ACylJJ;A+B9iJA;EAEI,gBAAA;A/B+iJJ;A+BjjJA;EAKM,mBAAA;A/B+iJN;A+B5iJM;EhC2BJ,0BAAA;EACC,yBAAA;ACohJH;A+B5iJM;EACE,gBAAA;A/B8iJR;A+BxiJA;EAEI,mBAAA;A/ByiJJ;A+B/hJA;;EAGI,gBAAA;A/BgiJJ;A+BniJA;;EAOI,0BAAA;A/BgiJJ;A+BviJA;;EAWI,SAAA;A/BgiJJ;A+B3iJA;;;;;;;;;;;;EAkBU,cAAA;A/BuiJV;A+BzjJA;;;;;;;;;;;;EAsBU,eAAA;A/BijJV;A+B9iJQ;;;;;;;;;;;;EAEE,gBAAA;A/B0jJV;A+BjjJA;EACE,kBAAA;EACA,oCAAA;EhClCA,4BAAA;EACC,2BAAA;ACslJH;A+BvjJA;EAMI,cAAA;A/BojJJ;A+B/iJA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;A/BijJF;A+BpjJA;EAKI,cAAA;A/BkjJJ;A+B7iJA;EACE,kBAAA;EACA,yBAAA;EACA,6BAAA;EhChDA,+BAAA;EACC,8BAAA;ACgmJH;A+BviJA;EAGI,gBAAA;EACA,kBAAA;EACA,gBAAA;A/BuiJJ;A+B5iJA;EAOM,eAAA;A/BwiJN;A+B/iJA;EAYI,gBAAA;A/BsiJJ;A+BljJA;EAcM,6BAAA;A/BuiJN;A+BrjJA;EAkBI,aAAA;A/BsiJJ;A+BxjJA;EAoBM,gCAAA;A/BuiJN;A+BhiJA;EhCsME,kBAAA;AC61IF;AD31IE;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;AC61IJ;ADh2IE;EAMI,sBAAA;AC61IN;AD31II;EACE,iCAAA;AC61IN;AD11IE;EAEI,yBAAA;AC21IN;A+B9iJA;EhCmME,kBAAA;AC82IF;AD52IE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;AC82IJ;ADj3IE;EAMI,sBAAA;AC82IN;AD52II;EACE,8BAAA;AC82IN;AD32IE;EAEI,yBAAA;AC42IN;A+B5jJA;EhCgME,qBAAA;AC+3IF;AD73IE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AC+3IJ;ADl4IE;EAMI,yBAAA;AC+3IN;AD73II;EACE,iCAAA;AC+3IN;AD53IE;EAEI,4BAAA;AC63IN;A+B1kJA;EhC6LE,qBAAA;ACg5IF;AD94IE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ACg5IJ;ADn5IE;EAMI,yBAAA;ACg5IN;AD94II;EACE,iCAAA;ACg5IN;AD74IE;EAEI,4BAAA;AC84IN;A+BxlJA;EhC0LE,qBAAA;ACi6IF;AD/5IE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ACi6IJ;ADp6IE;EAMI,yBAAA;ACi6IN;AD/5II;EACE,iCAAA;ACi6IN;AD95IE;EAEI,4BAAA;AC+5IN;A+BtmJA;EhCuLE,qBAAA;ACk7IF;ADh7IE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ACk7IJ;ADr7IE;EAMI,yBAAA;ACk7IN;ADh7II;EACE,iCAAA;ACk7IN;AD/6IE;EAEI,4BAAA;ACg7IN;AgCp0JA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;E5BkFA,uDAAA;EACA,oDAAA;EACA,+CAAA;AJqvJF;AgC/0JA;EASI,kBAAA;EACA,iCAAA;AhCy0JJ;AgCp0JA;EACE,aAAA;EACA,kBAAA;AhCs0JF;AgCp0JA;EACE,YAAA;EACA,kBAAA;AhCs0JF;AiC51JA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AjC81JF;AiC31JE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;E7BqCF,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EAEA,+DAAA;EACA,yBAAA;AJwzJF;AiC51JE;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,wBAAA;AjC81JJ;AkCl3JA;EACE,gBAAA;AlCo3JF;AkCh3JA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AlCk3JF;AkC/2JE;E9B2CA,qCAAA;EACA,kCAAA;EACA,gCAAA;EACA,iCAAA;EACA,6BAAA;ELqEA,mDAAA;EACG,6CAAA;EACE,yCAAA;EACG,mCAAA;ACmwJV;AkCt3JE;E9BuCA,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,0BAAA;AJk1JF;AkCz3JA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AlC23JF;AkCv3JA;EACE,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;E9B4CA,gDAAA;EACA,6CAAA;EACA,wCAAA;E8B5CA,4BAAA;EAEA,aAAA;EACA,WAAA;AlC03JF;AkCt3JA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AlCw3JF;AkCt3JE;E9BbA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EAEA,8DAAA;EACA,wBAAA;AJq4JF;AkC73JE;E9BdA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EAEA,+DAAA;EACA,yBAAA;AJ64JF;AkCh4JA;EACE,aAAA;EAEA,yBAAA;AlCi4JF;AkC93JA;EACE,gBAAA;AlCg4JF;AkC53JA;EACE,SAAA;EACA,uBAAA;AlC83JF;AkCz3JA;EACE,kBAAA;EACA,kBAAA;AlC23JF;AkCt3JA;EACE,eAAA;EACA,uBAAA;EACA,iBAAA;AlCw3JF;AD38JE;;EAEE,YAAA;EC68JF,MAAM;ED58JJ,cAAA;EC88JF,MAAM;AACR;AD78JE;EACE,WAAA;AC+8JJ;ADr9JE;;EAEE,YAAA;ECu9JF,MAAM;EDt9JJ,cAAA;ECw9JF,MAAM;AACR;ADv9JE;EACE,WAAA;ACy9JJ;AkC/4JA;EASI,gBAAA;EACA,gBAAA;AlCy4JJ;AkCn5JA;EAcI,iBAAA;AlCw4JJ;AkCt5JA;EAkBI,cAAA;AlCu4JJ;AkCl4JA;EAEE;IACE,YAAA;IACA,iBAAA;IACA,oBAAA;ElCm4JF;EkCj4JA;I9BnCA,iDAAA;IACA,8CAAA;IACA,yCAAA;EJu6JA;AACF;AmCpgKA;EAAgB,cAAA;AnCugKhB;AmCngKA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;E/ByCA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EAEA,8DAAA;EACA,wBAAA;AJ49JF;AmCxgKE;E/BsCA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EAEA,+DAAA;EACA,yBAAA;AJo+JF;AmC/gKE;EAAW,gBAAA;EAAmB,cAAA;AnCmhKhC;AmClhKE;EAAW,gBAAA;EAAmB,cAAA;AnCshKhC;AmCrhKE;EAAW,eAAA;EAAmB,cAAA;AnCyhKhC;AmCxhKE;EAAW,iBAAA;EAAmB,cAAA;AnC4hKhC;AmCxhKA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AnC0hKF;AmCthKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AnCwhKF;AmCrhKE;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;AnCuhKJ;AmCrhKE;EACE,SAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;AnCuhKJ;AmCrhKE;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,sBAAA;AnCuhKJ;AmCrhKE;EACE,QAAA;EACA,OAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA;AnCuhKJ;AmCrhKE;EACE,QAAA;EACA,QAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;AnCuhKJ;AmCrhKE;EACE,MAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AnCuhKJ;AmCrhKE;EACE,MAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;AnCuhKJ;AmCrhKE;EACE,MAAA;EACA,UAAA;EACA,uBAAA;EACA,yBAAA;AnCuhKJ;AoChnKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EhC4EA,iDAAA;EACA,8CAAA;EACA,yCAAA;EgC1EA,mBAAA;ApCknKF;AoC/mKE;EAAY,iBAAA;ApCknKd;AoCjnKE;EAAY,iBAAA;ApConKd;AoCnnKE;EAAY,gBAAA;ApCsnKd;AoCrnKE;EAAY,kBAAA;ApCwnKd;AoCrnKA;EACE,SAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;ApCunKF;AoCpnKA;EACE,iBAAA;ApCsnKF;AoC9mKE;;EAEE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;ApCgnKJ;AoC7mKA;EACE,kBAAA;ApC+mKF;AoC7mKA;EACE,kBAAA;EACA,WAAA;ApC+mKF;AoC3mKE;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qCAAA;EACA,aAAA;ApC6mKJ;AoC5mKI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;ApC8mKN;AoC3mKE;EACE,QAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,uCAAA;ApC6mKJ;AoC5mKI;EACE,YAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,wBAAA;ApC8mKN;AoC3mKE;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,UAAA;ApC6mKJ;AoC5mKI;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;ApC8mKN;AoC1mKE;EACE,QAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sCAAA;ApC4mKJ;AoC3mKI;EACE,YAAA;EACA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;ApC6mKN;AqCvuKA;EACE,kBAAA;ArCyuKF;AqCtuKA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;ArCwuKF;AqC5uKA;EAMI,aAAA;EACA,kBAAA;EtC8GF,yCAAA;EACQ,iCAAA;EK7CR,sDAAA;EACA,mDAAA;EACA,iDAAA;EACA,8CAAA;AJ0qKF;AqCtvKA;;EtC0WE,cAAA;EACA,eAAA;EACA,YAAA;EsC9VI,cAAA;ArC+uKN;AqC7vKA;;;EAoBY,cAAA;ArC8uKZ;AqClwKA;EAuBI,OAAA;ArC8uKJ;AqCrwKA;;EA4BI,kBAAA;EACA,MAAA;EACA,WAAA;ArC6uKJ;AqC3wKA;EAkCI,UAAA;ArC4uKJ;AqC9wKA;EAqCI,WAAA;ArC4uKJ;AqCjxKA;;EAyCI,OAAA;ArC4uKJ;AqCrxKA;EA6CI,WAAA;ArC2uKJ;AqCxxKA;EAgDI,UAAA;ArC2uKJ;AqCnuKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EjChBA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EAEA,+DAAA;EACA,yBAAA;EiCYA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;ArC0uKF;AqCruKE;EtCsME,iHAAA;EACA,0HAAA;EACA,+FAAA;EACA,8FAAA;EACA,2BAAA;EACA,sHAAA;ACkiKJ;AqC1uKE;EACE,UAAA;EACA,QAAA;EtCiMA,iHAAA;EACA,0HAAA;EACA,+FAAA;EACA,8FAAA;EACA,2BAAA;EACA,sHAAA;AC4iKJ;AqC7uKE;;EAEE,WAAA;EACA,qBAAA;EjCvCF,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EAEA,+DAAA;EACA,yBAAA;AJsxKF;AqCjxKA;;;;EAqCI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;ArCkvKJ;AqC1xKA;;EA4CI,SAAA;ArCkvKJ;AqC9xKA;;EAgDI,UAAA;ArCkvKJ;AqClyKA;;EAoDI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ArCkvKJ;AqC9uKI;EACE,gBAAA;ArCgvKN;AqC5uKI;EACE,gBAAA;ArC8uKN;AqCpuKA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ArCsuKF;AqC/uKA;EAYI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EASA,yBAAA;EACA,kCAAA;ArC8tKJ;AqC3vKA;EAgCI,SAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;ArC8tKJ;AqCvtKA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;ArCytKF;AqCxtKE;EACE,iBAAA;ArC0tKJ;AqCptKA;EAGE;;;;IAKI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;ErCmtKJ;EqC9sKA;IACE,SAAA;IACA,UAAA;IACA,oBAAA;ErCgtKF;EqC5sKA;IACE,YAAA;ErC8sKF;AACF;AACA;oDACoD;AsCh7KpD;EtCk7KE,0DAA0D;EsCl7KiB,kBAAA;EAC1E,QAAA;EACA,SAAA;EACC,mBAAA;EtCo7KF,aAAa;GsCn7KI,gBAAA;GAAkB,SAAA;AtCs7KrC;AsCn7KA;EtCq7KE,0BAA0B;EsCn7K5B,WAAA;EACA,6BAAA;EAEA,mBAAA;EACA,eAAA;EACA,gBAAA;EtCo7KE,iBAAiB;EsCj7KnB,cAAA;EACA,kBAAA;EtCm7KE,kBAAkB;GsCj7KpB,aAAA;GACA,SAAA;GACA,kBAAA;EACA,eAAA;AtCm7KA;AsCh7KE;EAAA;IACA,uBAAA;EtCm7KA;AACF;AsCj7KA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;AtCm7KF;AsCj7KA;EtCm7KE,kCAAkC;EsCj7KhC,eAAA;EACA,iBAAA;EACA,yBAAA;AtCm7KJ;AsCh7KA;EACI,cAAA;EAGA,cAAA;AtCg7KJ;AsC96KA;EACE,gCAAA;AtCg7KF;AsC76KA;EACE,cAAA;EACA,uBAAA;AtC+6KF;AsC76KA;EACE,eAAA;AtC+6KF;AsC76KA;EACE,eAAA;EACA,kBAAA;AtC+6KF;AsC76KA;EACI,iBAAA;AtC+6KJ;AsC56KE;EAAA;IAEI,eAAA;EtC86KJ;AACF;ADt+KE;;EAEE,YAAA;ECw+KF,MAAM;EDv+KJ,cAAA;ECy+KF,MAAM;AACR;ADx+KE;EACE,WAAA;AC0+KJ;AkBx/KA;EnB6BE,cAAA;EACA,iBAAA;EACA,kBAAA;AC89KF;AkB1/KA;EACE,uBAAA;AlB4/KF;AkB1/KA;EACE,sBAAA;AlB4/KF;AkBp/KA;EACE,wBAAA;AlBs/KF;AkBp/KA;EACE,yBAAA;AlBs/KF;AkBp/KA;EACE,kBAAA;AlBs/KF;AkBp/KA;EnBsDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;ACi8KF;AkBl/KA;EACE,wBAAA;EACA,6BAAA;AlBo/KF;AkB7+KA;EACE,eAAA;AlB++KF;AuClhLA;EACE,mBAAA;AvCohLF;AD/+JI;;;;EAGI,wBAAA;ACk/JR;AuCnhLE;EAAA;IxCuhBA,yBAAA;ECggKA;ED//JA;IAAM,6BAAA;ECkgKN;EDjgKA;;IACM,8BAAA;ECogKN;AACF;AuC3hLI;EAAA;IxCmhBF,yBAAA;EC4gKA;ED3gKA;IAAM,6BAAA;EC8gKN;ED7gKA;;IACM,8BAAA;ECghKN;AACF;AuCliLI;EAAA;IxC8gBF,yBAAA;ECwhKA;EDvhKA;IAAM,6BAAA;EC0hKN;EDzhKA;;IACM,8BAAA;EC4hKN;AACF;AuCziLI;EAAA;IxCygBF,yBAAA;ECoiKA;EDniKA;IAAM,6BAAA;ECsiKN;EDriKA;;IACM,8BAAA;ECwiKN;AACF;AuChjLI;EAAA;IxCogBF,yBAAA;ECgjKA;ED/iKA;IAAM,6BAAA;ECkjKN;EDjjKA;;IACM,8BAAA;ECojKN;AACF;ADjjKI;;;;EAGI,wBAAA;ACojKR;AuC3jLE;EAAA;IxC6fA,yBAAA;ECkkKA;EDjkKA;IAAM,6BAAA;ECokKN;EDnkKA;;IACM,8BAAA;ECskKN;AACF;AuCnkLI;EAAA;IxCyfF,yBAAA;EC8kKA;ED7kKA;IAAM,6BAAA;ECglKN;ED/kKA;;IACM,8BAAA;ECklKN;AACF;AuC1kLI;EAAA;IxCofF,yBAAA;EC0lKA;EDzlKA;IAAM,6BAAA;EC4lKN;ED3lKA;;IACM,8BAAA;EC8lKN;AACF;AuCjlLI;EAAA;IxC+eF,yBAAA;ECsmKA;EDrmKA;IAAM,6BAAA;ECwmKN;EDvmKA;;IACM,8BAAA;EC0mKN;AACF;AuCxlLI;EAAA;IxC0eF,yBAAA;ECknKA;EDjnKA;IAAM,6BAAA;EConKN;EDnnKA;;IACM,8BAAA;ECsnKN;AACF;ADnnKI;;;;EAGI,wBAAA;ACsnKR;AuClmLI;EAAA;IxCkeF,yBAAA;ECooKA;EDnoKA;IAAM,6BAAA;ECsoKN;EDroKA;;IACM,8BAAA;ECwoKN;AACF;AuCzmLI;EAAA;IxC6dF,yBAAA;ECgpKA;ED/oKA;IAAM,6BAAA;ECkpKN;EDjpKA;;IACM,8BAAA;ECopKN;AACF;AuCjnLE;EAAA;IxCydA,yBAAA;EC4pKA;ED3pKA;IAAM,6BAAA;EC8pKN;ED7pKA;;IACM,8BAAA;ECgqKN;AACF;AuCznLI;EAAA;IxCqdF,yBAAA;ECwqKA;EDvqKA;IAAM,6BAAA;EC0qKN;EDzqKA;;IACM,8BAAA;EC4qKN;AACF;AuChoLI;EAAA;IxCgdF,yBAAA;ECorKA;EDnrKA;IAAM,6BAAA;ECsrKN;EDrrKA;;IACM,8BAAA;ECwrKN;AACF;ADrrKI;;;;EAGI,wBAAA;ACwrKR;AuC1oLI;EAAA;IxCwcF,yBAAA;ECssKA;EDrsKA;IAAM,6BAAA;ECwsKN;EDvsKA;;IACM,8BAAA;EC0sKN;AACF;AuCjpLI;EAAA;IxCmcF,yBAAA;ECktKA;EDjtKA;IAAM,6BAAA;ECotKN;EDntKA;;IACM,8BAAA;ECstKN;AACF;AuCxpLI;EAAA;IxC8bF,yBAAA;EC8tKA;ED7tKA;IAAM,6BAAA;ECguKN;ED/tKA;;IACM,8BAAA;ECkuKN;AACF;AuChqLE;EAAA;IxC0bA,yBAAA;EC0uKA;EDzuKA;IAAM,6BAAA;EC4uKN;ED3uKA;;IACM,8BAAA;EC8uKN;AACF;AuCxqLI;EAAA;IxCsbF,yBAAA;ECsvKA;EDrvKA;IAAM,6BAAA;ECwvKN;EDvvKA;;IACM,8BAAA;EC0vKN;AACF;ADvvKI;;;;EAGI,wBAAA;AC0vKR;AuClrLI;EAAA;IxC8aF,yBAAA;ECwwKA;EDvwKA;IAAM,6BAAA;EC0wKN;EDzwKA;;IACM,8BAAA;EC4wKN;AACF;AuCzrLI;EAAA;IxCyaF,yBAAA;ECoxKA;EDnxKA;IAAM,6BAAA;ECsxKN;EDrxKA;;IACM,8BAAA;ECwxKN;AACF;AuChsLI;EAAA;IxCoaF,yBAAA;ECgyKA;ED/xKA;IAAM,6BAAA;ECkyKN;EDjyKA;;IACM,8BAAA;ECoyKN;AACF;AuCvsLI;EAAA;IxC+ZF,yBAAA;EC4yKA;ED3yKA;IAAM,6BAAA;EC8yKN;ED7yKA;;IACM,8BAAA;ECgzKN;AACF;AuC/sLE;EAAA;IxC2ZA,yBAAA;ECwzKA;EDvzKA;IAAM,6BAAA;EC0zKN;EDzzKA;;IACM,8BAAA;EC4zKN;AACF;AuCttLA;ExCsZE,yBAAA;ACm0KF;ADl0KE;EAAM,6BAAA;ACq0KR;ADp0KE;;EACM,8BAAA;ACu0KR;AuC9tLE;ExC2ZE;;;;IAGI,wBAAA;ECu0KN;AACF;AuCluLI;ExCuZA;;;;IAGI,wBAAA;EC+0KN;AACF;AuCruLI;ExCkZA;;;;IAGI,wBAAA;ECu1KN;AACF;AuCxuLI;ExC6YA;;;;IAGI,wBAAA;EC+1KN;AACF;AuC3uLA;ExCiYE,yBAAA;AC62KF;AD52KE;EAAM,6BAAA;AC+2KR;AD92KE;;EACM,8BAAA;ACi3KR;AuCnvLE;ExCsYE;;;;IAGI,wBAAA;ECi3KN;AACF;AuCvvLI;ExCkYA;;;;IAGI,wBAAA;ECy3KN;AACF;AuC1vLI;ExC6XA;;;;IAGI,wBAAA;ECi4KN;AACF;AuC7vLI;ExCwXA;;;;IAGI,wBAAA;ECy4KN;AACF;AuChwLA;ExCyXE,8BAAA;AC04KF;ADz4KE;EAAM,6BAAA;AC44KR;AD34KE;;EACM,8BAAA;AC84KR;AuCxwLE;ExCiXE;;;;IAGI,wBAAA;EC25KN;AACF;AuC5wLI;ExC6WA;;;;IAGI,wBAAA;ECm6KN;AACF;AuC/wLI;ExCwWA;;;;IAGI,wBAAA;EC26KN;AACF;AuClxLI;ExCmWA;;;;IAGI,wBAAA;ECm7KN;AACF;AuCrxLA;ExCuVE,yBAAA;ACi8KF;ADh8KE;EAAM,6BAAA;ACm8KR;ADl8KE;;EACM,8BAAA;ACq8KR;AuC5xLI;ExC2VA;;;;IAGI,wBAAA;ECq8KN;AACF;AuChyLE;ExCuVE;;;;IAGI,wBAAA;EC68KN;AACF;AuCpyLI;ExCmVA;;;;IAGI,wBAAA;ECq9KN;AACF;AuCvyLI;ExC8UA;;;;IAGI,wBAAA;EC69KN;AACF;AuC1yLA;ExCkUE,yBAAA;AC2+KF;AD1+KE;EAAM,6BAAA;AC6+KR;AD5+KE;;EACM,8BAAA;AC++KR;AuCjzLI;ExCsUA;;;;IAGI,wBAAA;EC++KN;AACF;AuCpzLI;ExCiUA;;;;IAGI,wBAAA;ECu/KN;AACF;AuCxzLE;ExC6TE;;;;IAGI,wBAAA;EC+/KN;AACF;AuC5zLI;ExCyTA;;;;IAGI,wBAAA;ECugLN;AACF;AuC/zLA;ExC6SE,yBAAA;ACqhLF;ADphLE;EAAM,6BAAA;ACuhLR;ADthLE;;EACM,8BAAA;ACyhLR;AuCt0LI;ExCiTA;;;;IAGI,wBAAA;ECyhLN;AACF;AuCz0LI;ExC4SA;;;;IAGI,wBAAA;ECiiLN;AACF;AuC50LI;ExCuSA;;;;IAGI,wBAAA;ECyiLN;AACF;AuCh1LE;ExCmSE;;;;IAGI,wBAAA;ECijLN;AACF;ADrjLI;;;;EAGI,wBAAA;ACwjLR;AuCp1LA;EACE;IxCiRA,yBAAA;ECskLA;EDrkLA;IAAM,6BAAA;ECwkLN;EDvkLA;;IACM,8BAAA;EC0kLN;EDtkLE;;;;IAGI,wBAAA;ECykLN;AACF;AACA;;;;;sDAKsD;AwCtkMtD;EAAiB,gBAAA;AxCykMjB;AwC3hMA;EAAQ,qBAAA;AxC8hMR;AACA;oDACoD;AACpD,YAAY;AyC9oMZ;EACI,WAAA;EACA,YAAA;AzCgpMJ;AACA,wBAAwB;AACxB,iEAAiE;AyC5oMjE;EACE,WAAA;EACA,gBAAA;AzC8oMF;AACA,0DAA0D;AyC5oM1D;EACE,eAAA;EACA,YAAA;EACA,eAAA;AzC8oMF;AyC5oMA;EAAoB,SAAA;AzC+oMpB;AACA;;;;GAIG;AACH,sBAAsB;AyC9oMtB;EAII,kBAAA;EACA,UAAA;AzC6oMJ;AyClpMA;EAQI,UAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AzC6oMJ;AyC1oMA;EzC4oME,uCAAuC;EyC1oMvC,aAAA;EACA,oBAAA;AzC4oMF;AyCpoMA;EACG,WAAA;EACD,YAAA;EACA,kBAAA;EACA,cAAA;AzCsoMF;AyC1oMA;EAME,eAAA;EACA,gBAAA;AzCuoMF;AACA,sBAAsB;AACtB,2BAA2B;AyCpoM3B;EACE,eAAA;EACA,UAAA;EACC,WAAA;EACD,YAAA;EACA,kBAAA;EAEA,OAAA;EACA,sBAAA;EACA,eAAA;EACE,aAAA;EACF,kBAAA;EACA,OAAA;EACA,UAAA;AzCqoMF;AACA,yBAAyB;AyCloMzB;EACE,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;AzCooMF;AACA,4BAA4B;AyCloM5B;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;AzCooMF;AACA,0BAA0B;AyCjoM1B;EACE,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;AzCmoMF;AACA;;CAEC;AyCjoMD;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AzCmoMF;AyCjoMA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AzCmoMF;AyChoMA;EACI,WAAA;EACA,kBAAA;AzCkoMJ;AyChoMA;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AzCkoMJ;AyCjoMI;EAAA;IAEI,YAAA;IACA,YAAA;EzCmoMN;AACF;AyCloMI;EAAA;IAEI,aAAA;IACA,YAAA;EzCooMN;AACF;AyCloMA;EACE,cAAA;EACA,kBAAA;AzCooMF;AyCloMA;EACE,SAAA;EACA,UAAA;AzCooMF;AyCloMA;EACI,0CAAA;EzCooMF,gCAAgC;EyCloM9B,aAAA;EACA,gBAAA;EzCooMF,kCAAkC;EyCloMhC,cAAA;EACA,WAAA;EACA,WAAA;EACF,qBAAA;EACA,UAAA;AzCooMF;AyC9oMA;EAWU,aAAA;AzCsoMV;AyCpoMA;EACI,mBAAA;EACF,cAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EzCsoMA,kCAAkC;EyCpoMlC,iBAAA;AzCsoMF;AyCpoMA;EAA2C,aAAA;AzCuoM3C;AyCtoMA;;EAEI,SAAA;EACA,gBAAA;EACF,kBAAA;EACA,QAAA;EACA,WAAA;AzCwoMF;AyCtoMA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;AzCwoMF;AyChpMA;EAUI,+BAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;AzCyoMJ;AyCzpMA;EAmBI,aAAA;AzCyoMJ;AyCroMA;EACE,UAAA;AzCuoMF;AyCxoMA;EAGI,cAAA;AzCwoMJ;AyCpoMA;EAEI,+BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;AzCqoMJ;AACA;;;;;CAKC;AyChoMD;EACG,WAAA;EACD,aAAA;EACA,kBAAA;EACA,cAAA;AzCkoMF;AyC/nMA;EACE,aAAA;AzCioMF;AyC/nMA;EAAmC,aAAA;AzCkoMnC;AyCjoMA;EAA4C,aAAA;AzCooM5C;AyCnoMA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AzCqoMJ;AyCnoMA;EACE,YAAA;AzCqoMF;AyCtoMA;EAGE,eAAA;EACD,gBAAA;AzCsoMD;AyC1oMA;EAOE,SAAA;AzCsoMF;AyChoMA;EACG,WAAA;EACD,YAAA;EACA,kBAAA;EACA,cAAA;AzCkoMF;AyChoMA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AzCkoMF;AACA,oCAAoC;AyC/nMpC;;EAAwF,iBAAA;AzCmoMxF;AyCloMA;;EAAmG,iBAAA;AzCsoMnG;AyCroMA;;EAAwE,iBAAA;AzCyoMxE;AyCxoMA;EACE,gCAAA;EACA,8BAAA;EACA,2BAAA;EACA,mCAAA;EACA,6BAAA;EACA,gCAAA;EACA,6BAAA;AzC0oMF;AACA,UAAU;AyCxoMV;EACA,wBAAA;EACA,8BAAA;AzC0oMA;AyCtoMA;EACE,iCAAA;EACA,aAAA;AzCwoMF;AyCroMA;EAEI,iBAAA;AzCsoMJ;AyCnoMA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AzCqoMJ;AyCnoMA;EACE,YAAA;AzCqoMF;AyCtoMA;EAGE,eAAA;EACD,gBAAA;AzCsoMD;AyC1oMA;EAOE,SAAA;AzCsoMF;AACA;+CAC+C;AyCjoM/C;EACG,WAAA;EACD,YAAA;EACA,kBAAA;EACA,cAAA;AzCmoMF;AyCvoMA;EAMI,cAAA;AzCooMJ;AyCjoMA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AzCmoMJ;AyCjoMA;EACI,aAAA;AzCmoMJ;AyCpoMA;EAGE,mBAAA;EACC,iBAAA;AzCooMH;AyCjoMA;EACE,YAAA;AzCmoMF;AyCpoMA;EAGI,aAAA;EACA,YAAA;AzCooMJ;AyCxoMA;EAOM,gBAAA;AzCooMN;AyC3oMA;EAUI,SAAA;AzCooMJ;AyC9oMA;EAaE,eAAA;AzCooMF;AyCjpMA;EAgBE,kBAAA;EACA,mBAAA;AzCooMF;AACA;+CAC+C;AyChoM/C;EAEG,WAAA;EACD,YAAA;EACA,kBAAA;EACA,cAAA;AzCioMF;AyC/nMA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AzCioMJ;AyC/nMA;EAA0D,YAAA;AzCkoM1D;AACA;+CAC+C;AyC9nM/C;;EACG,WAAA;EACD,YAAA;EACA,kBAAA;EACA,cAAA;AzCioMF;AyC/nMA;EACE,mBAAA;AzCioMF;AyCloMA;EAGI,cAAA;AzCkoMJ;AyC9nMA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AzCgoMJ;AyC9nMA;EAA0D,aAAA;AzCioM1D;AyC/nMA;EACE,YAAA;AzCioMF;AyCloMA;EAGI,aAAA;EACA,sBAAA;AzCkoMJ;AyCtoMA;EAOM,gBAAA;AzCkoMN;AyCzoMA;EAUE,SAAA;AzCkoMF;AyC5oMA;EAYE,eAAA;AzCmoMF;AyC/oMA;EAeI,eAAA;AzCmoMJ;AyChoMA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AzCkoMF;AyChoMA;EACE,WAAA;EACA,WAAA;AzCkoMF;AyChoMA;EACE,WAAA;EACA,WAAA;EACA,aAAA;AzCkoMF;AyChoMA;EACE,SAAA;AzCkoMF;AyChoMI;EAAS,mBAAA;AzCmoMb;AyC7nMA;EAAc,eAAA;AzCgoMd;AyC9nMA;EACE,eAAA;EACA,iBAAA;AzCgoMF;AyC9nMA;EACE,gBAAA;AzCgoMF;AyC9nMA;;EAGE,aAAA;AzC+nMF;AyC5nMA;EACE;;IAGE,aAAA;EzC6nMF;AACF;AyC1nMA;;EAGE,aAAA;AzC2nMF;AyCznMA;;EAEI,YAAA;AzC2nMJ;AyCznMA;;EAEI,YAAA;AzC2nMJ;AyCznMA;;EAGE,gBAAA;AzC0nMF;AyCvnMA;EACE,oBAAA;AzCynMF;AyCvnMA;;EAEE,aAAA;AzCynMF;AyCvnMA;;EAEE,aAAA;AzCynMF;AyCrnMA;EACE,oBAAA;EACA,kBAAA;AzCunMF;AyCpnMA;EAA4E,aAAA;AzCunM5E;AyCrnMA;EACE,YAAA;AzCunMF;AyCxnMA;EAGI,cAAA;EACA,sBAAA;AzCwnMJ;AyCpnMA;;EAEI,kBAAA;EACA,mBAAA;AzCsnMJ;AyClnMA;EAEI,YAAA;AzCmnMJ;AyCrnMA;EAIM,yBAAA;EACA,8BAAA;AzConMN;AyCznMA;EAQI,mBAAA;EACA,iBAAA;AzConMJ;AyC/mMA;;EAEI,aAAA;AzCinMJ;AyCnnMA;;EAGsB,yBAAA;AzConMtB;AyCvnMA;;EAOI,eAAA;AzConMJ;AyCjnMA;EACE,YAAA;AzCmnMF;AyCpnMA;EAGI,yBAAA;EACA,2BAAA;AzConMJ;AyCxnMA;EAKY,mBAAA;AzCsnMZ;AyClnMA;EAAoE,YAAA;AzCqnMpE;AyCjnMA;EAEW,YAAA;AzCknMX;AyCpnMA;EAKW,YAAA;AzCknMX;AyCvnMA;EAQI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AzCknMJ;AyChnME;;EAEW,YAAA;AzCknMb;AyCpnME;;EAKS,gBAAA;AzCmnMX;AyCxnME;;EAMU,uBAAA;AzCsnMZ;AyC5nME;;;;EAYM,oBAAA;AzCsnMR;AACA;8EAC8E;AyC/mM9E;EzCinME,8CAA8C;EyC/mM9C;IAC8B,eAAA;EzCinM9B;EyClnMA;IAEkB,eAAA;EzCmnMlB;EyCrnMA;IAGoC,aAAA;EzCqnMpC;EyCxnMA;IAKI,eAAA;IACA,iBAAA;EzCsnMJ;EyC5nMA;IASI,gBAAA;IACA,gBAAA;EzCsnMJ;EyChoMA;IAYkB,eAAA;EzCunMlB;EyCnoMA;IAaW,eAAA;EzCynMX;EyCtoMA;IAcoD,gBAAA;EzC2nMpD;EyCznMA;IAAoC,YAAA;EzC4nMpC;EyC1nMA;IACE,YAAA;EzC4nMF;EyCznMA;IAGM,uBAAA;EzCynMN;EyC5nMA;;IAQM,mBAAA;IACA,WAAA;IACA,eAAA;EzCwnMN;EyCpnMA;IACE,YAAA;EzCsnMF;EyCvnMA;IAGI,aAAA;IACA,sBAAA;EzCunMJ;AACF;AyCnnMA;EACE;;IAIM,aAAA;EzCmnMN;AACF;AyC9mMA;EACE;IACM,2BAAA;EzCgnMN;EyCjnMA;;IAGE,sBAAA;EzCknMF;EyCrnMA;;IAIQ,wBAAA;EzCqnMR;EyCznMA;IAOE,+BAAA;IACA,sBAAA;IACA,gBAAA;EzCqnMF;EyC9nMA;IAUQ,wBAAA;EzCunMR;EyCjoMA;IAYoC,YAAA;EzCwnMpC;EyCpnMA;IAA6E,YAAA;EzCunM7E;EyCtnMA;IACE,YAAA;EzCwnMF;EyCznMA;IAGI,wBAAA;IACA,sBAAA;EzCynMJ;AACF;AyCrnMA;EzCunME,8CAA8C;EyCrnM9C;IAAiC,aAAA;EzCwnMjC;AACF;AyCtnMA;EACE;IAIE,aAAA;EzCqnMF;EACA,8CAA8C;EyCnnM9C;IAAiC,aAAA;EzCsnMjC;EACA,8CAA8C;EyCrnM9C;IACE,gBAAA;IACA,YAAA;EzCunMF;EyCrnMA;IAA4E,YAAA;EzCwnM5E;EyCvnMA;IAA0D,YAAA;EzC0nM1D;EyCvnMA;;IAEI,YAAA;EzCynMJ;EyCtnMA;IACE,YAAA;EzCwnMF;EyCznMA;IAEkB,uBAAA;IAChB,2BAAA;EzC0nMF;EyCtnMA;IAEI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,iBAAA;EzCunMJ;EyC5nMA;IAQI,gBAAA;IACA,iBAAA;EzCunMJ;EyChoMA;IAWyC,gBAAA;EzCwnMzC;EyCtnMA;IACE,YAAA;EzCwnMF;EyCznMA;IAGI,aAAA;IACA,sBAAA;EzCynMJ;AACF;AyCrnMA;EACE;IAEI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,iBAAA;EzCsnMJ;EyC3nMA;IAQI,gBAAA;IACA,iBAAA;EzCsnMJ;EyC/nMA;IAWyC,gBAAA;EzCunMzC;EyCpnMA;IACE,kBAAA;IACA,iCAAA;EzCsnMF;AACF;AyCnnMA;EACE;IAEI,kBAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;IzConMF,qBAAqB;EACvB;EyC3nMA;IAUI,gBAAA;IACA,iBAAA;EzConMJ;EyC/nMA;IAayC,gBAAA;EzCqnMzC;EyClnMA;IACE,mBAAA;EzConMF;AACF;AACA,0BAA0B;AyC9mM1B;EACI,YAAA;EACA,WAAA;AzCgnMJ;AyC7mMA;EAEE,kBAAA;AzC8mMF;AyC3mMA;EAEE,WAAA;AzC4mMF;AACA,qBAAqB;AyCxmMrB;;EAEE,YAAA;AzC0mMF;AyCtmMA;;EAEE,gBAAA;AzCwmMF;AyCtmMA;;EACC,4BAAA;EACA,WAAA;AzCymMD;AyCvmMA;;EAEE,aAAA;EACA,iBAAA;EACA,gBAAA;AzCymMF;AyCvmMA;EACE,WAAA;AzCymMF;AACA,yBAAyB;AyCrmMzB;EAGY,4BAAA;AzCqmMZ;AyCxmMA;;;EASY,UAAA;AzComMZ;AyC7mMA;;;EAeY,UAAA;AzCmmMZ;AyClnMA;;;;EAsBY,OAAA;EACA,+BAAA;AzCkmMZ;AyCznMA;EA4BQ,UAAA;AzCgmMR;AyCzlME;EAAA;IACG,kBAAA;EzC4lMH;AACF;AyCxlMC;EACC;IACE,YAAA;IACA,aAAA;EzC0lMF;AACF;AyCxlMA;EACE;IACE,kBAAA;IACA,aAAA;EzC0lMF;AACF;AyCxlMC;EACC;IACE,aAAA;EzC0lMF;AACF;AyCvlMA;EACC,aAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AzCylMD;AyCtlMA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AzCwlMF;AACA,kDAAkD;AyCrlMlD;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EzCulMA,uBAAuB;EyCrlMvB,0HAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EzCulMA,gBAAgB;EAChB,kBAAkB;EyCrlMlB,gBAAA;EACA,mBAAA;AzCulMF;AyCnlMA;EACE,gBAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACC,yCAAA;EzCqlMD,WAAW;EyCplMT,oBAAA;EACA,gCAAA;AzCslMJ;AyCnlMA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACC,yCAAA;EzCqlMD,WAAW;EyCplMT,oBAAA;EACA,gCAAA;EACF,wBAAA;AzCslMF;AyCplMA;EACE,4BAAA;EACC,yCAAA;EzCslMD,WAAW;EyCrlMT,oBAAA;EACA,gCAAA;AzCulMJ;AyCplMA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AzCslMF;AyCllMA;EACE,aAAA;AzColMF;AyCllMA;EAGI,YAAA;AzCklMJ;AyC/kMA;EACE,aAAA;AzCilMF;AACA;;;;;;EAME;AyC9kMF;EACE;IACE,YAAA;EzCglMF;AACF;AyC5kMA;EACI,YAAA;EACA,YAAA;AzC8kMJ;AyC3kMA;EACI,YAAA;EACA,aAAA;AzC6kMJ;AyC1kMA;EACI,iBAAA;AzC4kMJ;AyCzkMA;EACI,iBAAA;EACA,YAAA;AzC2kMJ;AyCvkMA;EACI,aAAA;AzCykMJ;AyCtkMA;EACI,yBAAA;AzCwkMJ;AACA;oDACoD;AWzkOpD;EACE,iBAAA;EACA,gBAAA;AX2kOF;AWrkOA;EAAI,0BAAA;EACA,cAAA;AXwkOJ;AWrkOA;EAAgB,mBAAA;AXwkOhB;AWtkOA;;;EAA6B,qBAAA;AX2kO7B;AWzkOA;EACE,iBAAA;AX2kOF;AW5kOA;EAEQ,eAAA;AX6kOR;AACA,iBAAiB;AW1kOjB;EACY,eAAA;AX4kOZ;AWvkOA;EAAc,gBAAA;AX0kOd;AWvkOE;EAAA;IACgC,kBAAA;EX0kOhC;AACF;AWzkOE;;;;EAEU,WAAA;AX6kOZ;AW5kOI;EAAA;;;;IACU,eAAA;EXklOZ;AACF;AWhlOE;;EACO,iBAAA;AXmlOT;AW/kOA;EACE,gBAAA;AXilOF;AWllOA;EAGQ,kBAAA;EACJ,UAAA;EACA,UAAA;AXklOJ;AW7kOA;EACE,YAAA;EACA,YAAA;EACA,cAAA;AX+kOF;AWllOA;EAKI,cAAA;EACA,yBAAA;EACA,yBAAA;AXglOJ;AWvlOA;EAUI,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,iBAAA;AXglOJ;AW/kOI;EACE,yBAAA;EACA,cAAA;AXilON;AWnmOA;EAqBM,iBAAA;AXilON;AW5kOA;EACE,mDAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AX8kOF;AWnlOA;EAMM,eAAA;AXglON;AW3kOA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;AX6kOF;AW1kOA;EAAQ,WAAA;AX6kOR;AWzkOA;EAEI,iBAAA;EACA,gBAAA;EACA,mBAAA;AX0kOJ;AWzkOI;EAAA;IACE,4BAAA;EX4kOJ;AACF;AWnlOA;EAUI,cAAA;AX4kOJ;AWtlOA;;EAaI,yBAAA;EACA,eAAA;AX6kOJ;AW3lOA;EAgBkB,gBAAA;AX8kOlB;AW9lOA;EAkBI,yBAAA;EACA,qBAAA;EACA,mBAAA;AX+kOJ;AWnmOA;EAqBS,aAAA;AXilOT;AWtmOA;EAuBI,kBAAA;EACA,kBAAA;AXklOJ;AW7kOA;EACI,SAAA;EACD,iEAAA;EACA,WAAA;EACA,YAAA;AX+kOH;AW1kOA;EACE,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AX4kOF;AWxkOA;EAAmB,WAAA;AX2kOnB;AWvkOA;;EAEI,8BAAA;EACA,qBAAA;EACA,cAAA;AXykOJ;AWxkOK;;;;EACG,gBAAA;EACA,cAAA;EACA,qBAAA;AX6kOR;AW3kOM;EACE;;;;IACE,gBAAA;IACA,cAAA;IACA,qBAAA;EXglOR;AACF;AW/lOA;EAmBM,gBAAA;EACA,mBAAA;EACA,YAAA;AX+kON;AWpmOA;EAuBI,kBAAA;AXglOJ;AWvmOA;EAyBM,kBAAA;AXilON;AW1mOA;EA0BuC,gBAAA;AXmlOvC;AW7mOA;EA4BM,cAAA;EACA,WAAA;EACA,mBAAA;AXolON;AWlnOA;EA+BU,aAAA;EAAe,cAAA;AXulOzB;AWtnOA;EAgCU,gBAAA;EAAkB,cAAA;AX0lO5B;AW1nOA;EAkCQ,mBAAA;EACA,mBAAA;EACA,WAAA;EAEA,cAAA;EACA,oBAAA;EACA,iBAAA;AX0lOR;AWrlOA;EACE,cAAA;EACA,kBAAA;AXulOF;AWnlOA;;EAA6C,WAAA;AXulO7C;AWtlOA;EAEI,mBAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AXslOJ;AWnlOA;EAEI,mBAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AXmlOJ;AWhlOA;;EACM,WAAA;AXmlON;AWjlOA;EAA4B,WAAA;AXolO5B;AWjlOA;;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AXolOF;AWllOA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AXolOF;AW5lOA;EASW,YAAA;AXslOX;AWllOA;EAEI,WAAA;AXmlOJ;AWrlOA;EAKI,gBAAA;AXmlOJ;AWxlOA;EASM,iBAAA;EACA,kBAAA;AXklON;AW5lOA;EAgBQ,kBAAA;AX+kOR;AWzkOA;EAEI,mBAAA;EACA,cAAA;AX0kOJ;AW7kOA;EAKI,cAAA;EACA,iBAAA;AX2kOJ;AWjlOA;EAQI,WAAA;EACA,mBAAA;AX4kOJ;AWzkOA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AX2kOF;AWzkOA;EACE,kBAAA;AX2kOF;AW5kOA;EAGI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AX4kOJ;AWvkOA;EAAoB,mBAAA;AX0kOpB;AWzkOA;EAAY,WAAA;AX4kOZ;AW3kOA;EAAiB,eAAA;AX8kOjB;AW7kOA;EAAkB,kBAAA;AXglOlB;AW/kOA;EAAiB,iBAAA;AXklOjB;AWjlOA;EAAc,YAAA;AXolOd;AWnlOA;EAAa,aAAA;AXslOb;AWrlOA;EAAa,aAAA;AXwlOb;AWvlOA;EAAa,aAAA;AX0lOb;AWzlOA;EAAkB,yBAAA;AX4lOlB;AW3lOA;EAAkB,gBAAA;AX8lOlB;AW7lOA;EAAiB,iBAAA;AXgmOjB;AW/lOA;EAAiB,iBAAA;AXkmOjB;AWjmOA;EAAoB,oBAAA;AXomOpB;AWlmOA;EAAmB,mBAAA;AXqmOnB;AWpmOA;EAAmB,mBAAA;AXumOnB;AWtmOA;EAAyB,mBAAA;EAAqB,kBAAA;AX0mO9C;AWzmOA;EAAgB,WAAA;AX4mOhB;AW3mOA;EAAc,aAAA;EAAe,WAAA;AX+mO7B;AW9mOA;EAAe,cAAA;AXinOf;AWhnOA;EAAe,WAAA;AXmnOf;AWlnOA;EAAc,cAAA;AXqnOd;AWpnOA;EAAe,WAAA;AXunOf;AWtnOA;EAAe,WAAA;AXynOf;AWxnOA;EAAsB,gCAAA;AX2nOtB;AW1nOA;EAAsB,gCAAA;AX6nOtB;AW5nOA;EAAyB,gCAAA;AX+nOzB;AW9nOA;EAAc,UAAA;AXioOd;AWhoOA;EAAc,WAAA;AXmoOd;AWloOA;EACE,qBAAA;AXooOF;AWjoOA;EACE,gBAAA;EACA,uBAAA;EACA,qBAAA;AXmoOF;AWhoOA;EAAgB,gBAAA;AXmoOhB;AWjoOA;EACE,mBAAA;EACA,YAAA;AXmoOF;AWroOA;EAII,kBAAA;EACA,8BAAA;EACA,aAAA;AXooOJ;AWhoOA;EACE,cAAA;EACA,kBAAA;AXkoOF;AWpoOA;EAGM,eAAA;AXooON;AWjoOA;EACI,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AXmoOJ;AWhoOA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;AXkoOJ;AW9nOA;EACE,oBAAA;AXgoOF;AW7nOA;EACE,WAAA;EACA,2CAAA;EPrSA,mDAAA;EACA,gDAAA;EACA,2CAAA;EOqSE,8BAAA;EACF,wBAAA;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AXioOJ;AW9nOA;EACE,WAAA;EACA,2CAAA;EACE,8BAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AXgoOJ;AW7nOA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AX+nOF;AWroOA;EAQI,WAAA;AXgoOJ;AWxoOA;EAUM,WAAA;AXioON;AW7nOA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AX+nOF;AWroOA;EAQI,yBAAA;EACA,cAAA;EXgoOF;kDACgD;EW7nO5C,4BAAA;EACA,YAAA;AX+nON;AW7oOA;EX+oOE;kDACgD;EW7nO5C,8BAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AX+nON;AWrpOA;EA0BI,UAAA;AX8nOJ;AWtnOA;EACE,SAAA;EACA,UAAA;AXwnOF;AWpnOA;EAA2B,aAAA;AXunO3B;AWpnOA;EACE,cAAA;EACA,WAAA;AXsnOF;AWnnOA;;;;;;;;EACmB,WAAA;AX4nOnB;AW1nOA;EAAwD,aAAA;AX6nOxD;AW5nOA;EAAmE,aAAA;AX+nOnE;AW9nOA;EAAwD,oBAAA;AXioOxD;AWhoOA;EAAkC,0CAAA;AXmoOlC;AWloOA;EACE,0CAAA;EACA,UAAA;AXooOF;AWloOA;EAA0B,UAAA;AXqoO1B;AACA,wCAAwC;AWpoOxC;EAAuB,gBAAA;AXuoOvB;AWroOA;EACE,aAAA;AXuoOF;AACA;;;EAGE;AACF;oDACoD;AWnoOpD;EACE;IAA+C,YAAA;EXsoO/C;EWroOA;IAA0D,YAAA;EXwoO1D;EWvoOA;IACE,gBAAA;IACA,aAAA;IACA,UAAA;IACA,YAAA;IACA,iBAAA;EXyoOF;EWvoOA;IACE,kBAAA;EXyoOF;EWvoOA;IACE,kBAAA;EXyoOF;EWvoOA;IACE,kBAAA;EXyoOF;EWvoOA;IACE,kBAAA;IACA,MAAA;EXyoOF;EWvoOA;IACE,MAAA;IXyoOA,mBAAmB;EACrB;EWxoOA;IACE,kBAAA;IACA,cAAA;IACA,WAAA;EX0oOF;AACF;AWnoOA;EACE,oBAAA;AXqoOF;AWtoOA;EAGI,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AXsoOJ;AW7oOA;EASY,oBAAA;AXuoOZ;AWhpOA;EAUY,0CAAA;AXyoOZ;AWnpOA;EAWY,0CAAA;AX2oOZ;AWtpOA;EAaI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AX4oOJ;AW9pOA;EAqBI,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AX4oOJ;AWxoOA;EACE,iBAAA;EACA,WAAA;AX0oOF;AWtoOA;EAAkB,kBAAA;AXyoOlB;AWxoOA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AX0oOF;AWxoOE;EAAA;IACE,kBAAA;IACA,MAAA;IACA,UAAA;EX2oOF;AACF;AWzoOA;EAA+B,mBAAA;AX4oO/B;AW1oOA;EACC,oBAAA;AX4oOD;AWzoOA;EACE,yBAAA;EACA,yBAAA;AX2oOF;AW7oOA;EAGO,WAAA;AX6oOP;AWxoOA;EAAiB,YAAA;AX2oOjB;AWzoOA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AX2oOF;AW1oOE;;;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AX8oOJ;AACA,8BAA8B;AW1oO9B;EACE;IACE,kBAAA;IACA,mBAAA;EX4oOF;AACF;AWvoOA;EACE;IAAY,WAAA;EX0oOZ;AACF;AWvoOA;EACE;IAAiC,UAAA;EX0oOjC;EWzoOA;IAAoC,kBAAA;EX4oOpC;AACF;AW3oOA;EACI;IAAa,cAAA;EX8oOf;EW7oOA;IACE,kBAAA;IACA,sBAAA;EX+oOF;AACF;AW5oOA;EACE;IACG,iBAAA;IACA,gBAAA;IACA,qBAAA;IACA,cAAA;EX8oOH;EW7oOG;;;;IACE,gBAAA;IACA,cAAA;IACA,qBAAA;IACA,6BAAA;EXkpOL;EW/oOA;IACG,aAAA;IACA,gBAAA;IACA,cAAA;IACA,6BAAA;EXipOH;EW/oOA;IACE,gBAAA;EXipOF;EWlpOA;IAGI,6BAAA;IACA,0BAAA;EXkpOJ;EW/oOA;IACE,gBAAA;IACA,eAAA;EXipOF;EWnpOA;IAGS,gBAAA;EXmpOT;EWjpOA;IACE,eAAA;EXmpOF;EWppOA;IAGI,4BAAA;IACA,yBAAA;EXopOJ;AACF;AACA,gBAAgB;AWhpOhB;EAEI,cAAA;EACA,uBAAA;EACA,eAAA;AXipOJ;AWrpOA;EAQI,aAAA;AXgpOJ;AWxpOA;;;;EAYI,eAAA;EACA,gBAAA;AXkpOJ;AW/pOA;EAiBI,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AXipOJ;AW/oOI;EACE,gBAAA;EACA,YAAA;AXipON;AW7qOA;EAiCI,cAAA;AX+oOJ;AWhrOA;EAqCI,gBAAA;EACA,WAAA;AX8oOJ;AWprOA;EA2CM,eAAA;AX4oON;AWvrOA;EA+CM,qBAAA;AX2oON;AWtoOA;EAEI;IAEI,0BAAA;EXsoON;EWloOE;IAEI,0BAAA;EXmoON;AACF;AW9nOA;EACE;IACiB,gBAAA;EXgoOjB;EWjoOA;IAII,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,uBAAA;IACA,iCAAA;IACA,yBAAA;EXgoOJ;EW7oOA;IAiBI,+BAAA;EX+nOJ;EWhpOA;IAqBI,kBAAA;EX8nOJ;AACF;AACA,uBAAuB;AACvB,aAAa;AW1nOb;EACE;IACW,YAAA;EX4nOX;AACF;AWtnOA;EACE;;IAC0B,WAAA;EXynO1B;EW1nOA;IAGI,mBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EX0nOJ;AACF;AWnnOA;EACE;IAAoC,aAAA;EXsnOpC;EWrnOA;;;;;;;;IAEI,kBAAA;IACA,gBAAA;EX6nOJ;EW1nOA;IAA+B,aAAA;EX6nO/B;AACF;AW3nOA;EACE;;IAEe,WAAA;EX6nOf;AACF;AACA,2BAA2B;AAC3B,iCAAiC;AWznOjC;EACI,mBAAA;AX2nOJ;AWxnOA;EACI,mBAAA;AX0nOJ;AWrnOE;EAAA;IAII,WAAA;EXqnOJ;AACF;AWnnOE;EAAA;IAGE,iBAAA;EXonOF;AACF;AWjoOA;EAeM,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AXqnON;AWxoOA;EAsBM,cAAA;EACA,WAAA;EACA,eAAA;AXqnON;AACA,wBAAwB;AWhnOxB;EACI,kBAAA;AXknOJ;AWhnOA;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;AXknOF;AW/mOA;EACE;IACI,cAAA;EXinOJ;EW/mOA;IACE,cAAA;IACA,WAAA;IACA,mBAAA;EXinOF;AACF;AWzmOA;EACI,SAAA;AX2mOJ;AWxmOA;EAEE,iBAAA;EACA,YAAA;AXymOF;AW/lOA;EALE,cAAA;AXumOF;AW5lOE;EAAA;IAXA,cAAA;EX2mOA;AACF;AACA;;aAEa;AWplOX;EAAA;IN11BqB,kBAAA;ELk7PrB;AACF;AWnlOA;EACI,YAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AXqlOJ;AWnlOA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AXqlOJ;AWllOA;EACC,iBAAA;AXolOD;AWjlOA;EACI,cAAA;AXmlOJ;AW/kOA;EACC,YAAA;AXilOD;AW9kOA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AXglOF;AW7kOA;EACI,gBAAA;AX+kOJ;AW5kOA;EACE,WAAA;AX8kOF;AW5kOC;EACC,cAAA;AX8kOF;AWxkOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AX0kOF;AWxkOA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AX0kOF;AWxkOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AX0kOF;AWvkOA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AXykOF;AWpkOA;EACI,WAAA;AXskOJ;AWpkOA;EACI,cAAA;EACA,cAAA;AXskOJ;AWpkOA;EACI,qBAAA;EACA,eAAA;AXskOJ;AWpkOA;EACI,WAAA;EACA,WAAA;AXskOJ;AWpkOA;EACI,eAAA;AXskOJ;AWpkOA;EAEE,WAAA;AXqkOF;AWlkOA;EACE,YAAA;EACA,iBAAA;AXokOF;AACA,iBAAiB;AACjB,4BAA4B;AWjkO5B;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AXmkOF;AW1kOA;EASI,oCAAA;EACA,cAAA;AXokOJ;AWnkOI;;EAEE,gBAAA;EACA,gCAAA;EACA,WAAA;AXqkON;AWplOA;EAmBM,gCAAA;AXokON;AWjkOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AXmkOF;AWzkOA;EAQI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;AXokOJ;AWjkOA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,0CAAA;AXmkOF;AWhkOA;EAAsB,YAAA;AXmkOtB;AWlkOA;EAAqB,WAAA;AXqkOrB;AWjkOA;EACE,2BAAA;EACA,+CAAA;AXmkOF;AACA,kCAAkC;AWhkOlC;EACE,iBAAA;AXkkOF;AW9jOC;;EAEC,eAAA;EACA,gBAAA;AXgkOF;AW7jOA;;EACE,yBAAA;EACA,qBAAA;AXgkOF;AW7jOA;;EACE,wCAAA;EP5gCA,iDAAA;EACA,8CAAA;EACA,yCAAA;AJ6kQF;AACA;;;;;;;;;;;;EAYE;AW9jOF;EACE,iBAAA;AXgkOF;AW5jOA;EACE,6BAAA;AX8jOF;AW5jOA;EACE,yBAAA;AX8jOF;AACA;;EAEE;AWxjOF;EACA,uBAAA;AX0jOA;AWvjOA;EACI;IAAO,YAAA;EX0jOT;EWzjOE;IAAO,UAAA;EX4jOT;AACF;AW1jOA;EACE,UAAA;EACA,4CAAA;EACA,yCAAA;EACA,wCAAA;EACA,uCAAA;EACA,oCAAA;AX4jOF;AWzjOA;EACE,UAAA;AX2jOF;AWvjOA;;EACE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AX0jOF;AWvjOA;EACE,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AXyjOF;AWtjOA;EACE,uCAAA;EACA,UAAA;AXwjOF;AWtjOA;EACE,uCAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AXwjOF;AWpiOA;EAKU,kBAAA;EACA,cAAA;EACA,iBAAA;AXkiOV;AWjiOU;;EAEE,qBAAA;EACA,yBAAA;AXmiOZ;AWvhOA;EXyhOE,kBAAkB;EWvhOlB,UAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AXyhOF;AWthOA;EXwhOE,gBAAgB;EWthOhB,WAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;AXwhOF;AWrhOA;EACE,YAAA;EACA,eAAA;EAEA,4BAAA;AXshOF;AWphOA;EACI;IAAO,YAAA;EXuhOT;EWthOE;IAAO,UAAA;EXyhOT;AACF;AWvhOA;EAEE,WAAA;EXwhOA,8BAA8B;EWthO9B,qBAAA;AXwhOF;AWjhOA;EAGI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AXihOJ;AWvhOA;EAQM,eAAA;AXkhON;AW7gOA;EACE,0BAAA;AX+gOF;AACA,iBAAiB;A0CvyQjB;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;A1CyyQD;A0C7yQA;EAME,iBAAA;A1C0yQF;A0ChzQA;EASE,iBAAA;A1C0yQF;A0CnzQA;EAaE,gBAAA;A1CyyQF;A0CtzQA;EAgBE,gBAAA;EACA,YAAA;A1CyyQF;A0C1zQA;;EAqBE,YAAA;A1CyyQF;A0C9zQA;EAwBE,iBAAA;A1CyyQF;A0Cj0QA;EA2BE,YAAA;A1CyyQF;A0CxyQE;EAAA;IACC,kBAAA;IACA,WAAA;E1C2yQD;E0C7yQA;IAIE,WAAA;E1C4yQF;AACF;A0CzyQC;EAAA;IACC,YAAA;E1C4yQA;AACF;A0Cl1QA;EAwCE,2BAAA;A1C6yQF;A0Cr1QA;EA4CI,kBAAA;EAEA,iBAAA;A1C2yQJ;A0Cz1QA;EAiDM,YAAA;A1C2yQN;A0C51QA;;EAqDM,qBAAA;EACA,kBAAA;EACA,mBAAA;A1C2yQN;A0Cl2QA;EA2DM,QAAA;A1C0yQN;A0CvyQI;EAAA;IACE,gBAAA;IACA,iBAAA;E1C0yQJ;E0C5yQE;IAKI,cAAA;E1C0yQN;E0C/yQE;;IASI,sBAAA;E1C0yQN;E0CnzQE;IAaI,MAAA;E1CyyQN;AACF;A0CpyQI;EAAA;IACE,iBAAA;E1CuyQJ;AACF;A0ClyQA;EACC;IACC,YAAA;IACA,YAAA;E1CoyQA;E0CtyQD;IAIE,YAAA;E1CqyQD;E0CzyQD;IAOE,gBAAA;E1CqyQD;AACF;A0CjyQA;EAII,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;A1CgyQJ;A0C/xQI;;;EAGC,yBAAA;EACA,oCAAA;A1CiyQL;A0ChzQA;EAmBK,oBAAA;A1CgyQL;A0CnzQA;EAsBO,uBAAA;A1CgyQP;A0CtzQA;EA4BI,cAAA;A1C6xQJ;A0CzzQA;EA+BI,cAAA;A1C6xQJ;A0C5zQA;EAkCO,+BAAA;EACA,yBAAA;A1C6xQP;A0Ch0QA;EAoCU,WAAA;EACF,iBAAA;A1C+xQR;A0Cp0QA;EA0CI,+BAAA;EACA,iBAAA;A1C6xQJ;A0Cx0QA;EA6CQ,iBAAA;A1C8xQR;A0C30QA;EA8Ce,WAAA;EACT,yBAAA;EACA,+BAAA;A1CgyQN;A0Ch1QA;EAqDI,eAAA;A1C8xQJ;A0Cn1QA;EAwDI,WAAA;A1C8xQJ;A0Ct1QA;EA2DI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A1C8xQJ;A0C71QA;EAiEK,cAAA;EACA,iBAAA;A1C+xQL;A0Cj2QA;EAsEI,sBAAA;EACA,kBAAA;EACA,YAAA;A1C8xQJ;A0Ct2QA;EA0EK,iBAAA;A1C+xQL;A0C5xQG;EAAA;IAOC,kBAAA;IACA,SAAA;IACA,SAAA;E1CyxQF;E0ClyQC;IAEE,iBAAA;E1CmyQH;E0CryQC;IAKE,iBAAA;E1CmyQH;E0CxyQC;IAWE,kBAAA;IACA,WAAA;E1CgyQH;AACF;A0C13QA;EA6FI,sBAAA;EACA,kBAAA;EACA,YAAA;A1CgyQJ;A0C/3QA;EAiGK,iBAAA;A1CiyQL;A0C9xQG;EAAA;IACC,kBAAA;IACA,WAAA;IACA,SAAA;E1CiyQF;AACF;A0Cz4QA;EA4GE,gBAAA;A1CgyQF;A0C54QA;EA+GE,qBAAA;A1CgyQF;A0CzxQG;EAAA;IAIC,kBAAA;IACA,UAAA;IACA,SAAA;E1CyxQF;E0C/xQC;IAEE,iBAAA;E1CgyQH;AACF;A0C3xQG;EAAA;IACC,kBAAA;IACA,WAAA;IACA,SAAA;E1C8xQF;AACF;A0C7yQA;EAiBI,gBAAA;A1C+xQJ;A0ChzQA;EAsBE,gBAAA;A1C6xQF;A0CnzQA;EAyBE,qBAAA;A1C6xQF;A0CzxQA;;EAIG,sBAAA;EACA,yBAAA;A1CyxQH;A0CpxQA;;EAEC,oCAAA;A1CsxQD;A0CxxQA;;EAIE,YAAA;A1CwxQF;A0CtxQG;EAAA;;IACC,eAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;E1C0xQF;E0CvxQI;;;;;;;;I1CgyQF,0BAA0B;I0C3xQvB,iBAAA;IACA,oBAAA;IACA,gCAAA;E1C6xQL;E0C3yQC;;IAkBG,UAAA;E1C6xQJ;E0C/yQC;;IAoBI,gCAAA;E1C+xQL;E0C7xQM;;;;;;;;IAIC,iBAAA;IACA,mBAAA;E1CmyQP;E0C9zQC;;IA+BK,WAAA;IACA,SAAA;IACA,iBAAA;IACA,oBAAA;IACA,kBAAA;IACA,gCAAA;IACA,kBAAA;IACA,yBAAA;E1CmyQN;E0Cz0QC;;IAyCK,iBAAA;IACA,mBAAA;E1CoyQN;E0C90QC;;IA6CK,cAAA;IACA,cAAA;IACA,kBAAA;E1CqyQN;AACF;A0C9xQG;EAAA;;IACC,aAAA;E1CkyQF;AACF;A0C/xQG;EAAA;;IAGG,mBAAA;E1CiyQJ;AACF;A0C9xQG;EAAA;;IAGG,WAAA;IACA,uEAAA;E1CgyQJ;E0CpyQC;;IAOG,WAAA;E1CiyQJ;AACF;A0C9xQG;EAAA;;IAGG,WAAA;IACA,uEAAA;E1CgyQJ;E0CpyQC;;IAMI,mBAAA;IACA,yBAAA;E1CkyQL;E0CzyQC;;IAQO,WAAA;IACF,iBAAA;E1CqyQN;E0C9yQC;;IAcG,WAAA;E1CoyQJ;AACF;A0Cv4QA;;EA2GK,gCAAA;A1CgyQL;A0CnyQK;EAAA;;IACE,yBAAA;E1CuyQL;AACF;A0CryQK;;;;;;EAGC,gCAAA;A1C0yQN;A0Cz5QA;;EAoHK,6BAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,oBAAA;A1CyyQL;A0CxyQK;;EAAS,WAAA;EACR,6BAAA;EACA,gCAAA;A1C4yQN;A0C1yQK;;;;EAEC,uBAAA;EACA,gCAAA;EACA,WAAA;A1C8yQN;A0C/6QA;;EAsIK,WAAA;A1C6yQL;A0Cn7QA;;EAyIK,yBAAA;EACA,sBAAA;A1C8yQL;A0C1yQG;EAAA;;IAEE,yBAAA;E1C6yQH;E0C5yQG;;;;;;IAGC,yBAAA;E1CizQJ;E0CvzQC;;IAUG,oBAAA;IACA,iBAAA;IACA,8BAAA;E1CizQJ;AACF;A0C58QA;;EAkKE,gBAAA;A1C8yQF;A0C5yQC;EAAA;;IAEE,UAAA;E1C+yQD;E0CjzQD;;IAKE,SAAA;E1CgzQD;AACF;A0C1yQA;EACE,6BAAA;A1C4yQF;A0C1yQA;EACC,iBAAA;EACA,4BAAA;A1C4yQD;A0CzyQA;EAYC,gBAAA;A1CgyQD;A0C1yQG;;;EAGC,6BAAA;A1C4yQJ;A0C3yQI;EACG;;;IAAU,WAAA;IAAe,yBAAA;E1CizQ9B;E0ChzQK;;;;;;IAAoB,WAAA;IAAe,yBAAA;E1CyzQxC;AACF;A0CnzQG;;;EAGC,WAAA;EACA,yBAAA;A1CqzQJ;A0Cx0QA;EAuBG,WAAA;EACA,yBAAA;A1CozQH;A0C50QA;EA4BE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;A1CmzQF;A0Cn1QA;EAkCG,kBAAA;EACA,WAAA;EACA,SAAA;A1CozQH;A0ClzQE;EAAA;IACC,yBAAA;IACA,WAAA;IACA,oBAAA;IACA,iBAAA;E1CqzQD;E0CpzQC;;;IAGC,yBAAA;E1CszQF;AACF;A0CjzQA;EACC,cAAA;EACA,yBAAA;A1CmzQD;A0ChzQA;EACC;IACC,aAAA;E1CkzQA;AACF;A0C9yQA;EACC,qBAAA;EACA,iBAAA;A1CgzQD;A0ClzQA;EAIE,iBAAA;A1CizQF;A0C9yQA;EAEC,eAAA;A1C+yQD;A0C7yQA;EACC,gBAAA;A1C+yQD;A0C7yQA;EACC,aAAA;EACA,2BAAA;A1C+yQD;A0C7yQA;EACC,0BAAA;EACA,yBAAA;A1C+yQD;A0C3yQE;;;EAGC,mBAAA;EACA,WAAA;A1C6yQH;A0CxyQC;;;EAGC,mBAAA;EACA,qBAAA;A1C0yQF;A0C9yQC;;;EAME,yBAAA;EACA,4BAAA;A1C6yQH;A0CxyQC;;;EAGC,mBAAA;EACA,cAAA;A1C0yQF;A0CtyQE;;;EAGD,cAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;A1CwyQD;AACA,sBAAsB;A0ClyQtB;EACA,sBAAA;A1CoyQA;A0ChyQA;EACC,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;A1CkyQD;A0C7xQE;;;EAGD,WAAA;A1C+xQD;A0C1xQA;;EAEE,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;A1C4xQF;A0CxxQC;EAAA;IACC,yBAAA;IACA,iBAAA;IACA,SAAA;IACA,iBAAA;E1C2xQA;AACF;A0CxxQA;EACC,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;A1C0xQD;A0CvxQA;;EAEE,aAAA;A1CyxQF;A0CtxQA;;EAEE,aAAA;A1CwxQF;A0CrxQA;EACE,gCAAA;A1CuxQF;A0CrxQA;EACE,YAAA;A1CuxQF;AACA,cAAc;A0ClxQZ;;;EAGE,6BAAA;EACA,qBAAA;A1CoxQJ;A0CnxQI;EAAA;;;IACD,yBAAA;E1CwxQD;AACF;A0ClxQA;EACC,kBAAA;EACA,YAAA;A1CoxQD;A0CtxQA;EAIE,iBAAA;A1CqxQF;A0CzxQA;EAOE,iBAAA;A1CqxQF;A0ClxQC;EAAA;IACC,YAAA;E1CqxQA;AACF;A0CjyQA;EAcE,2BAAA;A1CsxQF;A0CjxQA;EACC;IACC,YAAA;IACA,YAAA;E1CmxQA;E0CrxQD;IAIE,YAAA;E1CoxQD;E0CxxQD;IAOE,gBAAA;E1CoxQD;E0ChxQD;IACC,YAAA;IACA,eAAA;E1CkxQA;E0C9wQD;IACC,WAAA;E1CgxQA;E0C7wQD;IACC,yBAAA;E1C+wQA;AACF;A0CxwQA;EACE,uBAAA;A1C0wQF;A0CvwQA;EACE,uBAAA;A1CywQF;A0CtwQA;EACE;IACE,SAAA;E1CwwQF;E0CzwQA;IAII,QAAA;E1CwwQJ;E0CpwQD;IACC,kBAAA;E1CswQA;E0CnwQD;;IAEC,kBAAA;E1CqwQA;AACF;A0ClwQA;EACC,uCAAA;A1CowQD;A0C7vQA;EACC;IACE,yBAAA;E1C+vQD;AACF;AACA,YAAY;A2Cl+RZ;EAGE,cAAA;A3Ck+RF;A2Cr+RA;EACM,6BAAA;A3Cu+RN;A2Cx+RA;EAIc,mBAAA;A3Cu+Rd;A2C3+RA;EAOM,iBAAA;EACA,eAAA;EACA,6BAAA;A3Cu+RN;A2Cl+RA;EAEI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;A3Cm+RJ;A2Cx+RA;EASI,kBAAA;EACA,mBAAA;A3Ck+RJ;A2C5+RA;EAeG,kBAAA;EACC,SAAA;EACA,UAAA;EACA,YAAA;A3Cg+RJ;A2Cz9RA;EACqB,cAAA;A3C29RrB;A2C59RA;EAIM,gCAAA;EACA,WAAA;A3C29RN;A2Ch+RA;EAOQ,qBAAA;EACA,gBAAA;EACA,cAAA;A3C49RR;A2C39RQ;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;A3C69RV;A2C39RQ;EAAU,qBAAA;A3C89RlB;A2C79RQ;EAAY,qBAAA;A3Cg+RpB;A2Ch/RA;EAmBQ,iBAAA;EACA,iBAAA;A3Cg+RR;A2Cp/RA;EAuBQ,eAAA;EACA,eAAA;A3Cg+RR;A2Cx/RA;EA8BM,gCAAA;EACA,WAAA;A3C69RN;A2C5/RA;EAiCQ,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;A3C89RR;A2C79RQ;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;A3C+9RV;A2C79RQ;EAAU,qBAAA;A3Cg+RlB;A2C/9RQ;EAAY,qBAAA;A3Ck+RpB;A2C7gSA;EA8CQ,iBAAA;EACA,iBAAA;A3Ck+RR;A2CjhSA;EAkDQ,eAAA;EACA,eAAA;A3Ck+RR;A2CrhSA;EAyDM,gCAAA;EACA,WAAA;A3C+9RN;A2CzhSA;EA4DQ,qBAAA;EACA,gBAAA;EACA,cAAA;A3Cg+RR;A2C/9RQ;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;A3Ci+RV;A2C/9RQ;EAAU,qBAAA;A3Ck+RlB;A2Cj+RQ;EAAY,qBAAA;A3Co+RpB;A2CziSA;EAwEQ,iBAAA;EACA,iBAAA;A3Co+RR;A2C7iSA;EA4EQ,eAAA;EACA,eAAA;A3Co+RR;A2CjjSA;EAmFM,eAAA;A3Ci+RN;A2CpjSA;EAsFM,mBAAA;EACA,kBAAA;A3Ci+RN;A2CxjSA;EA0FG,kBAAA;EACC,SAAA;EACD,YAAA;A3Ci+RH;AACA,eAAe;A4CpmSf;EAAiB,iBAAA;A5CumSjB;A4CrmSA;EACE,iBAAA;EAEE,aAAA;A5CsmSJ;A4CzmSA;EAEqB,gBAAA;A5C0mSrB;A4C5mSA;;EAKK,eAAA;EACA,yBAAA;A5C2mSL;A4CjnSA;;;EAU2B,cAAA;A5C4mS3B;A4CtnSA;;EAYiB,mBAAA;A5C8mSjB;A4C1nSA;;EAgBQ,mBAAA;A5C8mSR;A4C9nSA;;EAmBM,cAAA;EACA,gBAAA;A5C+mSN;A4CnoSA;;EAsBY,kBAAA;EAAoB,mBAAA;A5CknShC;A4CxoSA;EA2BQ,cAAA;EACA,sBAAA;A5CgnSR;A4C5oSA;EA8BU,aAAA;A5CinSV;A4C/oSA;EAkCQ,sBAAA;A5CgnSR;A4ClpSA;EAqCQ,sBAAA;A5CgnSR;A4C9mSM;EAAA;IAEI,kBAAA;IACA,mBAAA;E5CgnSR;E4CnnSI;IAMI,iBAAA;E5CgnSR;E4CtnSI;;;;IAYI,kBAAA;E5CgnSR;AACF;A4CpqSA;EAwDS,mBAAA;A5C+mST;A4CvqSA;EA0DS,YAAA;A5CgnST;A4C1qSA;EA4DM,qBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;A5CinSN;A4ClrSA;EAmEQ,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,WAAA;A5CknSR;A4CxrSA;EAwEU,wBAAA;A5CmnSV;A4C3rSA;EA4EQ,mBAAA;A5CknSR;A4C5mSA;EAEI,cAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,iCAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;A5C6mSJ;A4CzmSA;EACE;IAAkB,aAAA;E5C4mSlB;AACF;A4C1mSA;EACgB,mBAAA;A5C4mShB;A4C7mSA;;;EAGI,iBAAA;A5C+mSJ;A4ClnSA;;;EAIa,iBAAA;A5CmnSb;A4C/mSA;EACE;IAAqB,kBAAA;IAAoB,gBAAA;E5CmnSzC;AACF;A4C9mSA;EACE,cAAA;EACA,cAAA;A5CgnSF;A4ClnSA;EAII,WAAA;EACA,YAAA;EACA,iBAAA;A5CinSJ;A4C5mSA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;A5C8mSF;AACA,kBAAkB;A4CrmSlB;;;;;;EAMI,gBAAA;A5CumSJ;A4CpmSA;EACI,WAAA;EACA,eAAA;A5CsmSJ;A4CnmSA;EACI,WAAA;EACA,eAAA;A5CqmSJ;A4ClmSA;;EAEI,YAAA;EACA,eAAA;A5ComSJ;A4CjmSA;EACI,YAAA;EACA,eAAA;A5CmmSJ;A4ChmSA;EACI,YAAA;EACA,eAAA;A5CkmSJ;A4C/lSA;EACI,YAAA;EACA,eAAA;A5CimSJ;A4C9lSA;EACI,eAAA;A5CgmSJ;A4C7lSA;;EAEI,UAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;A5C+lSJ;A4C5lSA;;EAEI,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,kBAAA;A5C8lSJ;A4C3lSA;;;;EAII,qBAAA;A5C6lSJ;A4C1lSA;;EAEI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A5C4lSJ;A4CzlSA;;EAEI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;E5C2lSF,kBAAkB;E4CzlShB,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;A5C2lSJ;A4CxlSA;;EAEI,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uIAAA;A5C0lSJ;A4CrlSA;;;;E5C0lSE,yBAAyB;E4CrlStB,qBAAA;A5CulSL;A4CplSA;;;;EAII,6EAAA;A5CslSJ;A4CllSA;;EAEI,gBAAA;A5ColSJ;A4CjlSA;;EAEI,yBAAA;EACA,qBAAA;EACA,WAAA;A5CmlSJ;A4ChlSA;;;;;;EAMI,iCAAA;EACA,6BAAA;EACA,0BAAA;EACA,WAAA;A5CklSJ;A4C/kSA;;EAEI,kBAAA;A5CilSJ;A4C9kSA;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;E5CglSF,+BAA+B;E4C9kS7B,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;A5CglSJ;A4C7kSA;EACI,gBAAA;A5C+kSJ;A4C5kSA;EACI,WAAA;EACA,YAAA;A5C8kSJ;A4C3kSA;EACI,aAAA;EACA,gBAAA;A5C6kSJ;A4C1kSA;EACI,mBAAA;EACA,2CAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yDAAA;EACA,iDAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;EACA,oCAAA;EACA,iCAAA;EACA,SAAA;A5C4kSJ;A4CzkSA;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oDAAA;EACA,4CAAA;EACA,kCAAA;EACA,6BAAA;EACA,0BAAA;A5C2kSJ;A4CxkSA;EACI,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;A5C0kSJ;A4CvkSA;EACI,UAAA;EACA,sBAAA;EACA,cAAA;A5CykSJ;A4CrkSA;EACE,cAAA;EACA,kBAAA;A5CukSF;A4CrkSI;EACE,qBAAA;ExCxTJ,yEAAA;EACA,sEAAA;EACA,iEAAA;AJg4SF;A4CpkSA;EAEE,cAAA;EACA,kBAAA;A5CqkSF;A4CnkSI;EACE,yBAAA;EACA,gBAAA;A5CqkSN;A4ChkSA;EACE,cAAA;A5CkkSF;A4C9jSA;EAKE,mBAAA;A5C4jSF;A4C/jSG;EAAA;IACC,WAAA;E5CkkSF;AACF;A4CtkSA;EAOE,YAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;A5CkkSF;A4C5kSA;EAcE,SAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;A5CikSF;A4CnlSA;EAoBE,mBAAA;A5CkkSF;A4CtlSA;EAwBI,eAAA;EACA,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;A5CikSJ;A4C/jSI;;EAEA,oCAAA;A5CikSJ;A4C9jSE;;EACE,aAAA;A5CikSJ;A4C1jSE;EAAA;;;IAEI,gBAAA;E5C8jSJ;AACF;A4C3jSE;EAAA;;;IAEI,gBAAA;E5C+jSJ;AACF;AACA,YAAY;A6C7hTZ;EAEQ,kBAAA;EACA,UAAA;EACA,WAAA;A7C8hTR;A6C1hTA;EAEQ,kBAAA;EACA,YAAA;EACA,WAAA;A7C2hTR;A6CvhTA;EAEQ,kBAAA;EACA,WAAA;EACA,UAAA;A7CwhTR;A6CphTA;EAEQ,kBAAA;EACA,WAAA;EACA,YAAA;A7CqhTR;A6CjhTA;EACI,eAAA;EACA,UAAA;A7CmhTJ;A6ChhTA;EACI,UAAA;A7CkhTJ;A6C/gTA;EACI,gBAAA;EACA,YAAA;A7CihTJ;A6CnhTA;EAIQ,eAAA;EACA,qBAAA;A7CkhTR;A6CvhTA;EAQQ,WAAA;EACA,WAAA;A7CkhTR;A6C3hTA;E7C6hTE;;mCAEiC;AACnC;A6ChiTA;E7CkiTE;;iCAE+B;AACjC;A6CriTA;EAsBQ,eAAA;A7CkhTR;A6CxiTA;EAwBY,eAAA;A7CmhTZ;A6C3iTA;EA8BY,WAAA;A7CghTZ;A6C9iTA;EAiCY,WAAA;A7CghTZ;A6CjjTA;EAsCY,WAAA;EACA,SAAA;A7C8gTZ;A6CrjTA;EA0CY,SAAA;A7C8gTZ;A6CxgTA;EACI,eAAA;EACA,qBAAA;A7C0gTJ;A6CzgTI;EACI,eAAA;A7C2gTR;A6C/gTA;;;EAWQ,cAAA;A7CygTR;A6CngTA;EACI,yBAAA;A7CqgTJ;A6ClgTA;EACI,cAAA;A7CogTJ;A6ClgTA;EACE,cAAA;A7CogTF;AACA,qBAAqB;A8CtnTrB;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;A9CwnTF;A8CtnTA;EACE,qBAAA;EACA,WAAA;EAYA,aAAA;E9C6mTA,WAAW;AACb;A8C5nTA;EAII,qBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;A9C2nTJ;A8CpoTA;EAWuB,aAAA;A9C4nTvB;A8CvoTA;EAY0B,aAAA;A9C8nT1B;A8C1oTA;EAa0B,cAAA;A9CgoT1B;A8C5nTA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;A9C8nTF;A8C3nTA;EAAqD,aAAA;A9C8nTrD;A8C3nTA;EACE,sBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;A9C6nTF;A8C1nTA;EAA4C,aAAA;A9C6nT5C;A8C5nTA;EAA+C,aAAA;A9C+nT/C;A8C9nTA;EAA+C,cAAA;A9CioT/C;A8ChoTA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EAWA,aAAA;E9CwnTA,WAAW;AACb;A8CvoTA;EAKI,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;A9CqoTJ;A8C5nTA;EACA,uCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;E9C8nTE,eAAe;E8C7nTjB,sBAAA;A9C+nTA;A8C5oTA;EAe6B,SAAA;A9CgoT7B;A8C/oTA;EAiBI,UAAA;EACA,SAAA;A9CioTJ;A8C7nTA;;EAC2D,SAAA;A9CgoT3D;A+C3tTA;EAEE;IACA,MAAA;IACA,eAAA;IACA,WAAA;IACA,WAAA;E/C4tTA;AACF;A+CxtTA;EAEE;IACA,gBAAA;E/CytTA;AACF;A+CjtTA;EACE,iCAAA;A/CmtTF;A+ChtTA;EAGM,WAAA;EACA,iBAAA;A/CgtTN;A+CptTA;EAOM,kBAAA;A/CgtTN;A+C5sTA;EAEA;IACE,+BAAA;IACA,gBAAA;E/C6sTA;AACF;A+CvsTA;EAEA;IACE,eAAA;E/CwsTA;AACF;A+CtsTA;EAEA;IACE,eAAA;E/CusTA;AACF;A+ClsTA;EACE;IACA,cAAA;E/CosTA;E+ClsTF;IACE,cAAA;E/CosTA;AACF;A+C9rTA;EAEM,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;A/C+rTN;A+CpsTA;EAQM,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;A/C+rTN;A+C3sTA;EAeM,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;A/C+rTN;A+CltTA;EAsBM,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;A/C+rTN;A+CxrTA;EAAA;IAEI,WAAA;E/C0rTF;AACF;A+C/rTA;EAQI,cAAA;EACA,cAAA;EACA,WAAA;A/C0rTJ;A+CtrTI;EAAA;IACI,mBAAA;E/CyrTN;AACF;A+CzsTA;EAkBM,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;A/C0rTN;A+C/sTA;EAwBM,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;A/C0rTN;A+CttTA;EA+BM,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;A/C0rTN;A+C7tTA;EAsCM,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;A/C0rTN;A+CtuTA;EAkDM,iBAAA;A/CurTN;A+CtrTM;EAAA;IACE,iBAAA;E/CyrTN;AACF;A+C9uTA;EAwDM,iBAAA;A/CyrTN;A+CxrTM;EAAA;IACE,iBAAA;E/C2rTN;AACF;A+CtvTA;EA8DM,eAAA;A/C2rTN;A+CzvTA;EAiEM,kBAAA;A/C2rTN;A+C1rTM;EAAA;IACE,kBAAA;E/C6rTN;AACF;A+CjwTA;EAwEI,aAAA;EACA,kBAAA;A/C4rTJ;A+CrwTA;EA2EM,UAAA;EACA,qBAAA;A/C6rTN;A+CzwTA;EA+EQ,uBAAA;EACA,WAAA;A/C6rTR;A+C7wTA;EAmFI,mBAAA;A/C6rTJ;A+ChxTA;EAsFI,mBAAA;EACA,iBAAA;A/C6rTJ;A+CpxTA;EA0FI,mBAAA;EACA,iBAAA;EACA,wBAAA;A/C6rTJ;A+CzxTA;EAmGE,aAAA;A/CyrTF;A+CxrTE;EAAA;IACQ,aAAA;E/C2rTR;AACF;A+CjyTA;EAwGM,gBAAA;A/C4rTN;A+C3rTM;EAAA;IACE,eAAA;E/C8rTN;AACF;A+CzyTA;EA6GQ,qBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;A/C+rTR;A+C9rTU;EAAA;IACA,YAAA;E/CisTR;AACF;A+ChsTU;EAAA;IACA,YAAA;E/CmsTR;AACF;A+CzzTA;EAwHU,qBAAA;EACA,aAAA;A/CosTV;A+C7zTA;EA0He,WAAA;A/CssTf;A+Ch0TA;EA4HY,cAAA;A/CusTZ;A+CtsTY;EAAA;IACE,aAAA;E/CysTZ;AACF;A+Cx0TA;EAsIU,qBAAA;EACA,aAAA;A/CqsTV;A+CpsTM;EAAA;IACI,aAAA;E/CusTR;AACF;A+Cj1TA;EA8II,mBAAA;EACA,iBAAA;A/CssTJ;A+CpsTE;EAAA;IAEM,iBAAA;E/CssTN;AACF;A+C11TA;EAuJQ,mBAAA;EACA,iBAAA;A/CssTR;A+C91TA;EA8JI,eAAA;A/CmsTJ;A+Cj2TA;EAqKE,mBAAA;A/C+rTF;A+Cp2TA;EAuKI,gBAAA;EACA,WAAA;EACA,mBAAA;A/CgsTJ;A+C9rTE;EAAA;;IAEI,iBAAA;E/CisTJ;AACF;A+C/2TA;E/Ci3TE,gBAAgB;AAClB;A+Cl3TA;EAyLI,gBAAA;A/C4rTJ;A+C3rTI;EAAA;IACE,gBAAA;IACA,aAAA;E/C8rTJ;AACF;A+C33TA;EAiMI,gBAAA;EACA,gBAAA;A/C6rTJ;A+C/3TA;EAqMI,gBAAA;A/C6rTJ;A+Cl4TA;EAwMI,YAAA;A/C6rTJ;A+Cr4TA;EA2MI,kBAAA;EACA,eAAA;A/C6rTJ;A+Cz4TA;EAgNM,YAAA;EACA,iBAAA;EACA,kBAAA;A/C4rTN;A+C94TA;EAuNE,YAAA;EACA,gBAAA;EACA,YAAA;A/C0rTF;A+CzrTE;EAAA;IACE,gBAAA;E/C4rTF;AACF;A+Cx5TA;EA8NI,WAAA;A/C6rTJ;A+C1rTA;EAAA;IAGM,gBAAA;E/C2rTJ;E+C9rTF;IAOI,aAAA;E/C0rTF;E+CjsTF;IAUI,mBAAA;E/C0rTF;E+CpsTF;IAaI,mBAAA;E/C0rTF;AACF;A+CxrTA;EAAA;IAEI,YAAA;E/C0rTF;E+C5rTF;IAKI,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,YAAA;E/C0rTF;AACF;A+CtrTA;EACE;IACE,oBAAA;E/CwrTF;AACF;A+CtrTE;EACA;IACE,oBAAA;E/CwrTF;AACF;A+CtrTE;EACA;IACE,kBAAA;E/CwrTF;AACF;A+CtrTC;EACC;IACE,iBAAA;E/CwrTF;AACF;A+CtrTC;EACC;IACE,gBAAA;E/CwrTF;AACF;AgD3jUA;EACC,oBAAA;EACA,iBAAA;EACA,cAAA;EhD6jUC;wDACsD;EACtD,yFAAyF;EACzF,mEAAmE;EACnE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AgDxkUA;EAMI,oBAAA;AhDqkUJ;AgDjkUK;EAAA;IACC,iBAAA;EhDokUJ;AACF;AgDhlUA;EAiBK,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AhDkkUL;AgDvlUA;EAuBM,YAAA;EACA,gBAAA;EACA,aAAA;AhDmkUN;AgD5lUA;EA4BM,eAAA;EACA,gBAAA;AhDmkUN;AgDhmUA;EAmCK,yFAAA;EACA,YAAA;EACA,YAAA;AhDgkUL;AgDrmUA;EAuCM,aAAA;AhDikUN;AgDxmUA;EA2CM,iBAAA;AhDgkUN;AgD3mUA;EA6CO,aAAA;AhDikUP;AgD9mUA;EAkDU,kBAAA;EACA,iBAAA;EACA,SAAA;AhD+jUV;AgDnnUA;;;EA0DM,WAAA;AhD8jUN;AgDxnUA;EA8DM,mBAAA;EACA,cAAA;EACA,eAAA;AhD6jUN;AgD7nUA;EAiEY,iBAAA;EACL,cAAA;AhD+jUP;AgDjoUA;EAsEM,YAAA;EACA,mBAAA;AhD8jUN;AgDroUA;EA+EK,mBAAA;AhDyjUL;AgDxjUK;EAEE,SAAA;AhDyjUP;AgD3oUA;EAwFK,gBAAA;EACA,iBAAA;EACA,WAAA;AhDsjUL;AgDhpUA;EA6FK,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,oBAAA;EAEA,WAAA;AhDqjUL;AgDzpUA;EAsGM,aAAA;EACA,YAAA;AhDsjUN;AgD7pUA;EA0GM,aAAA;EACA,YAAA;AhDsjUN;AgDjqUA;EAiHK,mBAAA;AhDmjUL;AgDpqUA;EAqHK,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,WAAA;EACA,iBAAA;AhDkjUL;AgD7qUA;EA6HM,eAAA;AhDmjUN;AgDljUK;EACC,eAAA;AhDojUN;AgDnrUA;;;EAqIM,mFAAA;EACA,iHAAA;EACA,sFAAA;EACA,8EAAA;AhDmjUN;AgD3rUA;EA6IM,YAAA;AhDijUN;AgD9rUA;EAoJK,gBAAA;EACA,WAAA;AhD6iUL;AgDlsUA;EAyJK,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,WAAA;AhD4iUL;AgD3sUA;EAmKK,mBAAA;EACA,oBAAA;AhD2iUL;AgD/sUA;EAuKK,mBAAA;AhD2iUL;AgDltUA;EAyKM,WAAA;EACA,eAAA;AhD4iUN;AgDttUA;EA+KM,gBAAA;AhD0iUN;AgDztUA;EAiLK,cAAA;AhD2iUL;AgD5tUA;;EAqLK,cAAA;EACA,aAAA;EACA,WAAA;AhD2iUL;AgDluUA;EA0LK,WAAA;AhD2iUL;AgDruUA;EA6LK,0CAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;AhD2iUL;AgD3uUA;EAoMK,WAAA;AhD0iUL;AgDziUK;EACC,WAAA;EACA,WAAA;AhD2iUN;AgDlvUA;EA6MM,gBAAA;EACA,gBAAA;EACA,uBAAA;AhDwiUN;AgDhiUE;EACC,aAAA;EACA,YAAA;AhDkiUH;AgDhiUE;EAGE,aAAA;EACA,YAAA;AhDgiUJ;AgDpiUE;EAQE,aAAA;EACA,YAAA;AhD+hUJ;AgD5hUE;EAEC,WAAA;AhD6hUH;AgDzhUG;;;EhD6hUD;6CAC2C;AAC7C;AgDrhUA;EAGM,gBAAA;AhDqhUN;AACA;oDACoD;AgDhhUpD;EhDkhUE,8CAA8C;EgDhhU9C;IACA,eAAA;EhDkhUA;EgDjhUD;IAGM,SAAA;EhDihUL;EgD9gUD;IAA2B,eAAA;EhDihU1B;EgDhhUD;IACC,kBAAA;IACA,QAAA;EhDkhUA;AACF;AgDjhUC;EhDmhUC,8CAA8C;EgDjhU9C;IAAgC,aAAA;EhDohUhC;AACF;AgDnhUC;EhDqhUC,8CAA8C;EgDnhU9C;IAAgC,aAAA;EhDshUhC;AACF;AgDlhUC;EACG,kBAAA;AhDohUJ;AgDhhUA;EACI,sBAAA;AhDkhUJ;AiDpzUA;EACI;IACI,MAAA;IACA,eAAA;IACA,WAAA;IACA,WAAA;EjDszUN;AACF;AiDnzUA;EACI;IACI,gBAAA;EjDqzUN;AACF;AiDjzUA;EACI,iCAAA;AjDmzUJ;AiDhzUA;EAGY,WAAA;EACA,iBAAA;AjDgzUZ;AiDpzUA;EAOY,kBAAA;AjDgzUZ;AiD3yUA;EACI;IACI,+BAAA;IACA,gBAAA;EjD6yUN;AACF;AiDzyUA;EACI;IACI,eAAA;EjD2yUN;AACF;AiDxyUA;EACI;IACI,eAAA;EjD0yUN;AACF;AiDtyUA;EACI;IACI,cAAA;EjDwyUN;EiDtyUE;IACI,cAAA;EjDwyUN;AACF;AiDpyUA;EAEQ,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AjDqyUR;AiD1yUA;EAQQ,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AjDqyUR;AiDjzUA;EAeQ,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AjDqyUR;AiDxzUA;EAsBQ,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AjDqyUR;AiD7xUI;EAAA;IAEQ,WAAA;EjD+xUV;AACF;AiDryUA;EASQ,cAAA;EACA,cAAA;EACA,WAAA;AjD+xUR;AiD3xUQ;EAAA;IACI,mBAAA;EjD8xUV;AACF;AiD/yUA;EAmBY,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AjD+xUZ;AiDrzUA;EAyBY,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AjD+xUZ;AiD5zUA;EAgCY,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;AjD+xUZ;AiDn0UA;EAuCY,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AjD+xUZ;AiD50UA;EAmDY,iBAAA;AjD4xUZ;AiD3xUY;EAAA;IACI,iBAAA;EjD8xUd;AACF;AiDp1UA;EAyDY,iBAAA;AjD8xUZ;AiD7xUY;EAAA;IACI,iBAAA;EjDgyUd;AACF;AiD51UA;EA+DY,eAAA;AjDgyUZ;AiD/1UA;EAkEY,kBAAA;AjDgyUZ;AiD/xUY;EAAA;IACI,kBAAA;EjDkyUd;AACF;AiDv2UA;EAyEQ,aAAA;EACA,kBAAA;AjDiyUR;AiD32UA;EA4EY,UAAA;EACA,qBAAA;AjDkyUZ;AiD/2UA;EAgFY,uBAAA;EACA,WAAA;AjDkyUZ;AiDn3UA;EAoFY,mBAAA;AjDkyUZ;AiDt3UA;EAuFY,mBAAA;EACA,iBAAA;AjDkyUZ;AiD13UA;EA2FY,mBAAA;EACA,iBAAA;EACA,wBAAA;AjDkyUZ;AiD/3UA;EAkGQ,aAAA;AjDgyUR;AiD/xUQ;EAAA;IACI,aAAA;EjDkyUV;AACF;AiDhyUY;EAAA;IACI,kBAAA;EjDmyUd;AACF;AiDlyUY;EAAA;IACI,kBAAA;EjDqyUd;AACF;AiDj5UA;EA+GY,gBAAA;AjDqyUZ;AiDpyUY;EAAA;IACI,eAAA;EjDuyUd;AACF;AiDz5UA;EAoHgB,qBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AjDwyUhB;AiD/5UA;EAyHoB,qBAAA;EACA,aAAA;AjDyyUpB;AiDn6UA;EA4HwB,WAAA;AjD0yUxB;AiDxyUoB;EAAA;IAEQ,WAAA;EjD0yU1B;AACF;AiDxyUoB;EAAA;IAEQ,WAAA;EjD0yU1B;AACF;AiDh7UA;EAyIwB,cAAA;EACA,gBAAA;AjD0yUxB;AiDzyUwB;EAAA;IACI,iBAAA;EjD4yU1B;AACF;AiD3yUwB;EAAA;IACI,aAAA;EjD8yU1B;AACF;AiD97UA;EAuJgB,qBAAA;EACA,aAAA;AjD0yUhB;AiDxyUY;EAAA;IACsB,YAAA;EjD2yUhC;AACF;AiD1yUY;EAAA;IACsB,YAAA;EjD6yUhC;AACF;AiD5yUY;EAAA;IACsB,YAAA;EjD+yUhC;AACF;AiDj9UA;EAqKY,mBAAA;EACA,iBAAA;AjD+yUZ;AiD7yUQ;EAAA;IAEQ,iBAAA;EjD+yUd;AACF;AiD19UA;EA8KY,mBAAA;EACA,iBAAA;AjD+yUZ;AiD99UA;EAoLY,eAAA;AjD6yUZ;AiDj+UA;EAyLQ,mBAAA;AjD2yUR;AiDp+UA;EA2LY,gBAAA;EACA,WAAA;EACA,mBAAA;AjD4yUZ;AiD1yUQ;EAAA;;IAGQ,iBAAA;EjD4yUd;AACF;AiD/+UA;EjDi/UE,gBAAgB;AAClB;AiDl/UA;EA0MY,gBAAA;AjD2yUZ;AiD1yUY;EAAA;IACI,gBAAA;IACA,aAAA;EjD6yUd;AACF;AiD3/UA;EAkNY,gBAAA;EACA,gBAAA;AjD4yUZ;AiD//UA;EAsNY,gBAAA;AjD4yUZ;AiDlgVA;EAyNY,YAAA;AjD4yUZ;AiDrgVA;EA4NY,kBAAA;EACA,eAAA;AjD4yUZ;AiDzgVA;EAiOY,YAAA;EACA,iBAAA;EACA,kBAAA;AjD2yUZ;AiD9gVA;EAuOgB,0BAAA;AjD0yUhB;AiDjhVA;EAyOoB,kBAAA;AjD2yUpB;AiDphVA;EA+OQ,YAAA;EACA,gBAAA;EACA,YAAA;AjDwyUR;AiDvyUQ;EAAA;IACI,gBAAA;EjD0yUV;AACF;AiD9hVA;EAsPY,WAAA;AjD2yUZ;AiDxyUI;EAAA;IAGY,gBAAA;EjDyyUd;EiD5yUE;IAOQ,aAAA;EjDwyUV;EiD/yUE;IAUQ,mBAAA;EjDwyUV;EiDlzUE;IAaQ,mBAAA;EjDwyUV;AACF;AiDtyUI;EAAA;IAEQ,YAAA;EjDwyUV;EiD1yUE;IAKQ,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,YAAA;EjDwyUV;AACF;AiDryUA;EACI;IACI,oBAAA;EjDuyUN;AACF;AiDpyUA;EACI;IACI,oBAAA;EjDsyUN;AACF;AiDnyUA;EACI;IACI,kBAAA;EjDqyUN;AACF;AiDlyUA;EACI;IACI,iBAAA;EjDoyUN;AACF;AiDjyUA;EACI;IACI,gBAAA;EjDmyUN;AACF;AiD/xUA;EACI,WAAA;AjDiyUJ;AiD/xUA;EACE,mBAAA;EACA,WAAA;AjDiyUF;AiD/xUA;EACI,cAAA;AjDiyUJ;AiD/xUA;EAEI,sBAAA;EACA,UAAA;AjDgyUJ;AACA,KAAK;AiD3xUL;EACI;IACI,aAAA;EjD6xUN;AACF;AiD1xUA;EACI;IACI,aAAA;IACA,YAAA;IACA,WAAA;EjD4xUN;AACF;AACA,OAAO;AiDtxUP;EjDwxUE,UAAU;EiDtxUR;IACI,aAAA;EjDwxUN;AACF;AiDrxUA;EjDuxUE,MAAM;EiDrxUJ;IACI,aAAA;EjDuxUN;AACF;AiDnxUA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EAEA,qDAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AjDoxUJ;AiDjxUA;EACI,WAAA;AjDmxUJ;AiDhxUA;EACI,YAAA;AjDkxUJ;AiD/wUA;EACI,UAAA;AjDixUJ;AiD9wUA;EACI,WAAA;EACA,YAAA;AjDgxUJ;AiD7wUA;EACI,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AjD+wUJ;AiD5wUA;EACI;IACI,YAAA;EjD8wUN;AACF;AiD3wUA;EACI,YAAA;EACA,WAAA;AjD6wUJ;AiD1wUA;EACI;IACI,kBAAA;EjD4wUN;AACF;AiDvwUA;EjDywUE,UAAU;EiDvwUR;IACI,kCAAA;EjDywUN;AACF;AiDtwUA;EjDwwUE,MAAM;EiDtwUJ;IACI,mCAAA;EjDwwUN;AACF;AACA,KAAK;AACL;;EAEE;AACF,GAAG;AACH,6BAA6B;AiD/vU7B;EACE;IACoB,kBAAA;EjDiwUpB;EiDlwUA;IAEsB,iBAAA;EjDmwUtB;EiDrwUA;IAGuB,YAAA;EjDqwUvB;AACF;AiDjwUA;EACE,iBAAA;EACA,cAAA;AjDmwUF;AiD/vUA;EACE;IACE,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,SAAA;IACA,QAAA;IACA,gFAAA;EjDiwUF;AACF;AiD9vUA;EAEI,eAAA;AjD+vUJ;AkDpzVE;EAAA;;IAIE,8EAAA;IACA,qBAAA;ElDqzVF;EkD1zVA;;IAEI,8EAAA;IACA,qBAAA;ElD4zVJ;AACF;AkDxzVE;EAAA;;IAIE,8EAAA;IACA,qBAAA;ElDyzVF;EkD9zVA;;IAEI,8EAAA;IACA,qBAAA;ElDg0VJ;AACF;AkD1zVE;EAAA;;;;IAIE,8EAAA;IACA,qBAAA;ElD6zVF;EkDl0VA;;;;IAEI,8EAAA;IACA,qBAAA;ElDs0VJ;AACF;AkDl0VE;EAAA;;;;IAIE,8EAAA;IACA,qBAAA;ElDq0VF;EkD10VA;;;;IAEI,+EAAA;IACA,qBAAA;ElD80VJ;AACF;AkDv0VE;EAAA;;;;;;IAIE,+EAAA;IACA,qBAAA;ElD40VF;EkDj1VA;;;;;;IAEI,+EAAA;IACA,qBAAA;ElDu1VJ;AACF;AkDn1VE;EAAA;;;;;;IAIE,+EAAA;IACA,qBAAA;ElDw1VF;EkD71VA;;;;;;IAEI,+EAAA;IACA,qBAAA;ElDm2VJ;AACF;AkD/1VE;EAAA;;;;;;IAIE,0EAAA;IACA,qBAAA;ElDo2VF;EkDz2VA;;;;;;IAEI,sBAAA;IACA,6BAAA;ElD+2VJ;AACF;AkD32VE;EAAA;;;;;;IAIE,0EAAA;IACA,qBAAA;ElDg3VF;EkDr3VA;;;;;;IAEI,sBAAA;IACA,6BAAA;ElD23VJ;AACF;AkDp3VA;;EAEI,cAAA;EACE,iBAAA;EACA,4BAAA;AlDs3VN;AkD13VA;;;;;;EAMoB,WAAA;AlD43VpB;AkDl4VA;;EAQc,eAAA;AlD83Vd;AkDt4VA;;;;EASuB,WAAA;AlDm4VvB;AkD54VA;;EAYc,kBAAA;AlDo4Vd;AkDh5VA;;EAec,kBAAA;AlDq4Vd;AkDp5VA;;EAgBgB,cAAA;AlDw4VhB;AkDx5VA;;EAkBoB,cAAA;EACA,iBAAA;AlD04VpB;AkDt4VQ;EAAA;;IACQ,YAAA;ElD04Vd;AACF;AkDn6VA;;EA4BG,iBAAA;AlD24VH;AkDv4VA;;;EAGoB,cAAA;AlDy4VpB;AkD54VA;;;EAMmB,cAAA;AlD24VnB;AACA;;CAEC;AmD7/VD;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EnD+/VF,yBAAyB;EmD7/VvB,OAAA;GACA,eAAA;EACA,sBAAA;AnD+/VJ;AmD5/VA;;;;EnDigWE;;;;GAIC;EmD5/VA,gBAAA;EACD,8BAAA;EnD8/VA,WAAW;EmD7/VR,2BAAA;EnD+/VH,YAAY;EmD9/VJ,sBAAA;EnDggWR,SAAS;AACX;AmD9/VA;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EAEA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EAEA,sBAAA;EnD8/VF;;;;kEAIgE;AAClE;AmD3/VA;EACI,yBAAA;EAEA,0BAAA;EnD4/VF;;;;qEAImE;AACrE;AmDx/VA;EACI,kBAAA;AnD0/VJ;AmDv/VA;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,WAAA;EACA,WAAA;AnDu/VJ;AmDp/VA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EAEA,cAAA;EACA,qBAAA;EAEA,SAAA;EACA,wEAAA;EACA,eAAA;EACA,UAAA;AnDo/VJ;AmDj/VA;EACI,qBAAA;AnDm/VJ;AmDh/VA;EACI,gCAAA;EACA,eAAA;AnDk/VJ;AmD/+VA;EACI,SAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EnDi/VF,mCAAmC;EmD/+VjC,sBAAA;EACA,wBAAA;AnDi/VJ;AmD9+VA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EAEA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EAEA,0BAAA;EAEA,iDAAA;EACQ,yCAAA;AnD6+VZ;AmD1+VA;EACI,eAAA;EACA,0BAAA;EACA,gBAAA;EAEA,0BAAA;EAEA,kDAAA;EACQ,0CAAA;AnD0+VZ;AmDv+VA;EACI,sBAAA;EACA,gBAAA;AnDy+VJ;AmDt+VA;EACI,0BAAA;AnDw+VJ;AmDr+VA;EACI,0BAAA;EACA,WAAA;AnDu+VJ;AmDp+VA;EACI,gBAAA;AnDs+VJ;AmDn+VA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EnDq+VF;gCAC8B;EmDj+V5B,4BAAA;EnDm+VF;;;;;kEAKgE;AAClE;AmD/9VA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,oEAAA;AnDi+VJ;AmD99VA;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,cAAA;EAEA,mBAAA;AnD89VJ;AmD39VA;EACI,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EAEA,UAAA;EAIA,sBAAA;EACA,gBAAA;EAEA,wBAAA;EACQ,gBAAA;EAER,8EAAA;EnDu9VF;;;uHAGqH;AACvH;AmDp9VA;EACI,eAAA;AnDs9VJ;AmDn9VA;EACI,wEAAA;EnDq9VF;;;yHAGuH;AACzH;AmDl9VA;;EAEI,sBAAA;EACA,aAAA;EAEA,8CAAA;EACQ,sCAAA;AnDm9VZ;AmDh9VA;EACI,gCAAA;EACA,sCAAA;EACQ,8BAAA;EAER,4BAAA;EACA,6BAAA;EAEA,sBAAA;EnDg9VF;;;;kEAIgE;AAClE;AmD78VA;;EAEI,sBAAA;EACA,6BAAA;EnD+8VF;;;;qEAImE;AACrE;AmD38VA;EACI,uBAAA;EACA,iBAAA;EACA,YAAA;AnD68VJ;AmD38VA;EACI,8BAAA;AnD68VJ;AmD18VA;EACI,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AnD48VJ;AACA,YAAY;AmDz8VZ;EACI,iBAAA;EACA,kBAAA;EnD28VF,0BAA0B;EmDz8VxB,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AnD28VJ;AmDx8VA;EACI,SAAA;EACA,eAAA;AnD08VJ;AmDv8VA;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACC,0BAAA;EACA,cAAA;AnDy8VL;AmDt8VA;EACI,iBAAA;AnDw8VJ;AmDr8VA;EACI,oBAAA;EACA,SAAA;EACA,eAAA;EAEA,eAAA;EAEA,2BAAA;EACE,yBAAA;EACG,sBAAA;EACC,qBAAA;EACI,iBAAA;AnDq8Vd;AmDl8VA;EAAgD,kBAAA;AnDq8VhD;AmDp8VA;EAAgD,kBAAA;AnDu8VhD;AmDt8VA;EAAgD,kBAAA;AnDy8VhD;AmDx8VA;EAAgD,kBAAA;AnD28VhD;AmD18VA;EAAgD,mBAAA;AnD68VhD;AmD58VA;EAAgD,mBAAA;AnD+8VhD;AmD98VA;EAAgD,mBAAA;AnDi9VhD;AmD/8VA;EACI,mBAAA;EACA,WAAA;AnDi9VJ;AmD98VA;EACI,mBAAA;EACA,kBAAA;AnDg9VJ;AmD78VA;EACI,uBAAA;AnD+8VJ;AmD58VA;EACI,gBAAA;EACA,WAAA;AnD88VJ;AmD18VA;;;EAGI,mBAAA;EACA,kBAAA;EACA,iBAAA;AnD48VJ;AACA;;CAEC;AmDz8VD;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AnD28VJ;AmDz8VA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AnD28VF;AmDx8VA;EACI,aAAA;AnD08VJ;AmDv8VA;EACI,2EAAA;AnDy8VJ;AmDt8VA;EACI,mBAAA;EACA,kBAAA;AnDw8VJ;AACA,oBAAoB;AmDp8VpB;EACI,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AnDs8VJ;AmDn8VA;EACI,yBAAA;EACA,sBAAA;EACA,cAAA;AnDq8VJ;AmDl8VA;EACI,aAAA;AnDo8VJ;AACA,gBAAgB;AmD/7VhB;EACI,uBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EAEA,sBAAA;EACA,YAAA;EACA,gBAAA;EAEA,qBAAA;EnD+7VF;;;qEAGmE;AACrE;AmD57VA;EACE,mCAAA;AnD87VF;AmD37VA;EACI,gBAAA;AnD67VJ;AmD17VA;EACI,sBAAA;EACA,aAAA;EAEA,8CAAA;EACQ,sCAAA;AnD27VZ;AmDz7VA;EACI,WAAA;EACA,gBAAA;AnD27VJ;AmDz7VA;EAEI,YAAA;AnD07VJ;AmDx7VA;EACI,SAAA;EACA,UAAA;EACA,mBAAA;AnD07VJ;AmDv7VA;EACI,YAAA;EACA,aAAA;EAGA,eAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;EACQ,gBAAA;EACR,kCAAA;AnDu7VJ;AmDp7VA;EACI,mFAAA;AnDs7VJ;AmDn7VA;EACI,yBAAA;AnDq7VJ;AmDl7VA;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EAEA,kBAAA;EAEA,mEAAA;EACQ,2DAAA;EAER,4BAAA;EAEA,2BAAA;EACE,yBAAA;EACG,sBAAA;EACC,qBAAA;EACI,iBAAA;EAEV,yBAAA;EACA,kHAAA;EnD86VF;;;iGAG+F;AACjG;AmD56VA;EAEI,cAAA;EACA,iBAAA;AnD66VJ;AmD36VA;EACI,eAAA;AnD66VJ;AmD36VA;EACI,mBAAA;AnD66VJ;AmD16VA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EAEA,cAAA;EACA,aAAA;EACA,wEAAA;AnD26VJ;AmDz6VA;EACI,WAAA;EACA,SAAA;AnD26VJ;AmDx6VA;EACI,SAAA;AnD06VJ;AmDv6VA;EACE,gCAAA;AnDy6VF;AmDv6VA;EACI,gCAAA;AnDy6VJ;AACA,oBAAoB;AmDt6VpB;EACI,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AnDw6VJ;AmDr6VA;EACI,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;AnDu6VJ;AmDp6VA;EAA8H,aAAA;EAC1H,gBAAA;AnDu6VJ;AACA,oBAAoB;AmDn6VpB;;EAEI,0BAAA;AnDq6VJ;AmDl6VA;;EACI,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;AnDq6VJ;AmDl6VA;EACI,aAAA;AnDo6VJ;AmDj6VA;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AnDm6VJ;AmD/5VA;EACI,SAAA;EACA,kBAAA;AnDi6VJ;AmD95VA;EACI,0BAAA;AnDg6VJ;AmD75VA;EACI,uBAAA;EACA,UAAA;AnD+5VJ;AmD55VA;EACI,kBAAA;EACA,0BAAA;AnD85VJ;AmD35VA;EACI,0BAAA;AnD65VJ;AmD15VA;EACI,oBAAA;EACA,kBAAA;AnD45VJ;AmDz5VA;;;;;;;EAOI,oCAAA;AnD25VJ;AmDx5VA;EACI,yCAAA;EACA,8BAAA;AnD05VJ;AmDv5VA;;;;;;;EAOI,oCAAA;AnDy5VJ;AmDt5VA;EACI,yCAAA;EACA,8BAAA;AnDw5VJ;AmDr5VA;;;;;;;EAOI,oCAAA;AnDu5VJ;AmDp5VA;EACI,yCAAA;EACA,8BAAA;AnDs5VJ;AmDn5VA;;;;;;;EAOI,oCAAA;AnDq5VJ;AmDl5VA;EACI,yCAAA;EACA,8BAAA;AnDo5VJ;AmDz4VA;EACI,SAAA;EACA,kBAAA;AnD24VJ;AmDx4VA;EACI,0BAAA;AnD04VJ;AmDv4VA;EACI,uBAAA;EACA,UAAA;AnDy4VJ;AmDt4VA;EACI,kBAAA;EACA,0BAAA;AnDw4VJ;AmDr4VA;EACI,0BAAA;AnDu4VJ;AmDp4VA;EACI,oBAAA;EACA,kBAAA;AnDs4VJ;AmDn4VA;;;;;;;EAOI,oCAAA;AnDq4VJ;AmDl4VA;EACI,yCAAA;EACA,8BAAA;AnDo4VJ;AmDj4VA;;;;;;;EAOI,oCAAA;AnDm4VJ;AmDh4VA;EACI,yCAAA;EACA,8BAAA;AnDk4VJ;AmD/3VA;;;;;;;EAOI,oCAAA;AnDi4VJ;AmD93VA;EACI,yCAAA;EACA,8BAAA;AnDg4VJ;AmD73VA;;;;;;;EAOI,oCAAA;AnD+3VJ;AmD53VA;EACI,yCAAA;EACA,8BAAA;AnD83VJ;AoD3qXA;EACI,gCAAA;ApD6qXJ;AoD3qXE;EAAA;IAEI,iBAAA;EpD6qXJ;AACF;AoDvqXA;EACE,mBAAA;EpDyqXA,cAAc;AAChB;AoD3qXA;EAEU,sBAAA;ApD4qXV;AoD9qXA;EAGO,cAAA;ApD8qXP;AoDjrXA;EAIa,cAAA;ApDgrXb;AoDprXA;EAMM,yBAAA;ApDirXN;AoDvrXA;EAOe,aAAA;ApDmrXf;AoD1rXA;EASoB,WAAA;ApDorXpB;AoD7rXA;EAaI,iBAAA;EACA,cAAA;ApDmrXJ;AoDjsXA;EAkBI,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;ApDkrXJ;AoDxsXA;EA0BI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;ApDirXJ;AoD9sXA;EAiCS,WAAA;ApDgrXT;AoDjtXA;EAkCQ,WAAA;ApDkrXR;AoDptXA;EAsCI,WAAA;ApDirXJ;AoDvtXA;EA6CM,gBAAA;EACA,mBAAA;ApD6qXN;AoD3tXA;EAkDI,eAAA;ApD4qXJ;AoD9tXA;EAoDM,eAAA;EACA,mBAAA;ApD6qXN;AoDluXA;EAwDM,iBAAA;EACA,iBAAA;EAAmB,kBAAA;EACnB,mBAAA;ApD8qXN;AoDxuXA;EA+DI,iBAAA;ApD4qXJ;AoD3uXA;EAiEM,WAAA;EACA,kBAAA;ApD6qXN;AoD/uXA;EAqEM,yBAAA;ApD6qXN;AoDlvXA;EAsEc,eAAA;EAAoC,iBAAA;ApDgrXlD;AoDtvXA;EAuEc,eAAA;ApDkrXd;AoDhrXM;EAAA;IAEI,eAAA;EpDkrXR;AACF;AoD9vXA;;;;;EAgFM,eAAA;ApDqrXN;AoDrwXA;EAmFM,cAAA;EACA,gBAAA;EACA,WAAA;ApDqrXN;AoD1wXA;EpD4wXE;oEACkE;AACpE;AoD9wXA;EA0FM,cAAA;EACA,WAAA;ApDurXN;AoDlxXA;EA8FM,mBAAA;ApDurXN;AoDrxXA;;EAkGM,qBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;ApDurXN;AoD5xXA;;EAuGQ,SAAA;EACA,YAAA;EACA,iBAAA;ApDyrXR;AoDlyXA;;EA4G4C,cAAA;ApD0rX5C;AoDtyXA;;EAkHM,cAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;ApDwrXN;AoD7yXA;EpD+yXE,oCAAoC;AACtC;AoDhzXA;EA4HW,cAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;ApDurXX;AoD7zXA;EAwIgB,uCAAA;ApDwrXhB;AoDh0XA;EAyIiB,uCAAA;ApD0rXjB;AoDn0XA;EA0IU,WAAA;ApD4rXV;AoDt0XA;EA8IQ,mBAAA;EACA,kCAAA;ApD2rXR;AoD10XA;EAoJW,WAAA;ApDyrXX;AoD70XA;;;EAwJI,kBAAA;ApD0rXJ;AoDl1XA;;;EAyJM,gBAAA;ApD8rXN;AoDv1XA;;;EA6JsE,kBAAA;ApD+rXtE;AoD51XA;EA+JM,kBAAA;EACA,6BAAA;EACA,YAAA;ApDgsXN;AoDj2XA;EAkKuB,eAAA;ApDksXvB;AoD/rXE;EAAA;IACc,kBAAA;EpDksXd;AACF;AoDhsXE;EAAA;IAEI,aAAA;EpDksXJ;EoDpsXA;IAIa,gBAAA;EpDmsXb;EoDvsXA;IAKO,iBAAA;EpDqsXP;EoD1sXA;IAOI,WAAA;IACA,qBAAA;EpDssXJ;EoD9sXA;IAWI,mBAAA;IACA,WAAA;IACA,cAAA;EpDssXJ;AACF;AoD73XA;EA0LI,qBAAA;EACA,mBAAA;ApDssXJ;AoDj4XA;EAgMI,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;ApDosXJ;AoDv4XA;EAqMM,cAAA;ApDqsXN;AoD14XA;EAyMI,0BAAA;EACA,YAAA;ApDosXJ;AoDlsXE;EAAA;IAEI,gBAAA;EpDosXJ;EoDtsXA;IAKI,gBAAA;EpDosXJ;AACF;AACA,4DAA4D;AoDhsX5D;;EAEI,aAAA;ApDksXJ;AoDpsXA;;EAKI,aAAA;ApDmsXJ;AoDxsXA;;EAOM,iBAAA;ApDqsXN;AoDnsXI;EAAA;;IACE,UAAA;EpDusXJ;AACF;AoDrsXE;EAAA;;IAEI,aAAA;EpDwsXJ;AACF;AoDnsXA;EAGM,iBAAA;EACA,kBAAA;ApDmsXN;AoDvsXA;EAMQ,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;ApDosXR;AoD1rXA;EACE,YAAA;EpD4rXA,oBAAoB;EoD1rXpB,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;ApD4rXF;AoDzrXA;EACE,kBAAA;EACA,WAAA;ApD2rXF;AoDzrXA;EACE,gBAAA;EACA,WAAA;ApD2rXF;AoDzrXA;EACE,YAAA;EACA,WAAA;ApD2rXF;AoDzrXA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;ApD2rXF;AACA,mCAAmC;AoDxrXnC;EpD0rXE,qBAAqB;AACvB;AoDxrXA;EACC,WAAA;ApD0rXD;AoDxrXA;EACE,gBAAA;ApD0rXF;AoDvrXA;EACE,oHAAA;EACA,SAAA;EACA,WAAA;ApDyrXF;AoDtrXA;EACE,YAAA;EACA,SAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;ApDwrXF;AoDtrXE;EACE,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;ApDwrXJ;AoDrrXA;EACE,kBAAA;ApDurXF;AoDrrXA;EACE,iBAAA;ApDurXF;AoDrrXA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;ApDurXF;AACA;;;;;;;EAOE;AoDlrXF;EACE,UAAA;EACA,mBAAA;ApDorXF;AoDjrXA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;EACA,uCAAA;ApDmrXF;AoDhrXA;EACE,mBAAA;EACA,uBAAA;EACA,2CAAA;ApDkrXF;AoD/qXA;EACE,iBAAA;ApDirXF;AoD9qXA;EACE,aAAA;ApDgrXF;AACA;oDACoD;AqDpiYlD;EAAA;IACE,2EAAA;IACA,qBAAA;ErDuiYF;AACF;AqDriYE;EAAA;IACE,2EAAA;IACA,qBAAA;ErDwiYF;AACF;AqDtiYE;EAAA;IACE,4EAAA;IACA,qBAAA;ErDyiYF;AACF;AqDviYE;EAAA;IACE,4EAAA;IACA,qBAAA;ErD0iYF;AACF;AqDxiYE;EAAA;IACE,0EAAA;IACA,qBAAA;ErD2iYF;AACF;AqDziYE;EAAA;IACE,0EAAA;IACA,qBAAA;ErD4iYF;AACF;AqDziYA;EACE,yBAAA;ArD2iYF;AqD5iYA;EAEa,yBAAA;ArD6iYb;AqD/iYA;EAGM,sBAAA;ArD+iYN;AqD9iYE;EAAA;IACkB,cAAA;IAAgB,SAAA;ErDkjYlC;EqDnjYA;IAEO,eAAA;ErDojYP;EqDtjYA;IAGO,4BAAA;ErDsjYP;AACF;AqD/iYA;EACI,uBAAA;ArDijYJ;AqD/iYA;EACE,0BAAA;ArDijYF;AqD9iYC;EAAA;IACM,kBAAA;ErDijYL;AACF;AACA;oDACoD;AqD5iYpD;EAEI,oBAAA;EACA,+BAAA;ArD6iYJ;AqDhjYA;EAKM,aAAA;EACA,gBAAA;ArD8iYN;AqDpjYA;EAQ6B,6BAAA;ArD+iY7B;AqDvjYA;EAUM,iBAAA;EACA,WAAA;EACA,8BAAA;ArDgjYN;AqD5jYA;EAeQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;ArDgjYR;AqDnkYA;EAqBY,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;ArDijYZ;AqD1kYA;EA6BQ,kBAAA;EACA,SAAA;EACA,UAAA;ArDgjYR;AqD/kYA;EAkCQ,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;ArDgjYR;AqDtlYA;EAyCQ,kBAAA;EACA,WAAA;ArDgjYR;AqD1lYA;;EA6CQ,2BAAA;ArDijYR;AqD9lYA;;EA8CU,sBAAA;ArDojYV;AqDjjYI;EAAA;IAEI,SAAA;ErDmjYN;AACF;AqDhjYI;EAAA;IAEI,iBAAA;ErDkjYN;EqDpjYE;IAKI,QAAA;ErDkjYN;AACF;AqD/iYG;EAAA;IAGI,cAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;ErDgjYL;AACF;AqD5iYI;EAAA;IACE,aAAA;IAAe,yBAAA;ErDgjYnB;EqDjjYE;IAGS,eAAA;ErDijYX;EqDpjYE;IAKM,iBAAA;ErDkjYR;EqDvjYE;IAOI,QAAA;ErDmjYN;AACF;AqDjjYI;EAAA;IACE,aAAA;IAAe,yBAAA;ErDqjYnB;EqDtjYE;IAEM,iBAAA;ErDujYR;EqDzjYE;IAII,SAAA;IACA,iBAAA;ErDwjYN;AACF;AACA;oDACoD;AqDjjYpD;EACE,yBAAA;ArDmjYF;AqDljYE;EAAA;IACM,iBAAA;ErDqjYN;AACF;AqDnjYE;EAAA;IAEI,YAAA;ErDqjYJ;AACF;AACA;oDACoD;AqDhjYpD;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ArDkjYF;AqDxjYA;EAQI,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;ArDmjYJ;AqDljYI;EAAA;IACE,iBAAA;IACA,eAAA;ErDqjYJ;AACF;AqDpjYI;EAAA;IACE,0BAAA;IACA,iBAAA;IACA,kBAAA;ErDujYJ;AACF;AqD3kYA;EAsBM,WAAA;ArDwjYN;AqDpjYA;EACE,oBAAA;EACA,iBAAA;ArDsjYF;AsD3wYA;EAGE,yBAAA;EtD2wYA,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;AsDxxYA;;;EAEsF,WAAA;AtD2xYtF;AsD7xYA;EtD+xYE;;6BAE2B;AAC7B;AsDlyYA;EAUI,WAAA;EACA,WAAA;EACA,eAAA;AtD2xYJ;AsDvyYA;EAeI,eAAA;EACA,cAAA;AtD2xYJ;AsD3yYA;EAmBI,yBAAA;AtD2xYJ;AsD9yYA;EAqBM,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AtD4xYN;AsDpzYA;EA6BM,WAAA;AtD0xYN;AsDvzYA;EAiCI,mBAAA;EACA,sBAAA;AtDyxYJ;AsD3zYA;EAsCI,OAAA;EACA,WAAA;EACA,UAAA;AtDwxYJ;AsDh0YA;EAyCgB,UAAA;AtD0xYhB;AsDn0YA;EA2CM,cAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AtD2xYN;AsD1xYM;EAAA;IACE,2BAAA;EtD6xYN;AACF;AsDj1YA;EAuDM,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,WAAA;AtD6xYN;AsD11YA;EA+DQ,gBAAA;AtD8xYR;AsD71YA;EAsEM,yBAAA;AtD0xYN;AsDh2YA;EA2EI,qBAAA;EACA,WAAA;AtDwxYJ;AsDp2YA;EAgFI,YAAA;EACA,kBAAA;AtDuxYJ;AsDx2YA;EAoFyB,yBAAA;AtDuxYzB;AsD32YA;EAuFM,WAAA;AtDuxYN;AsD92YA;EA0FM,WAAA;AtDuxYN;AsDj3YA;;EA8FQ,YAAA;AtDuxYR;AsDr3YA;EAiGQ,YAAA;AtDuxYR;AsDx3YA;EAoGQ,YAAA;AtDuxYR;AsD33YA;EAuGQ,YAAA;AtDuxYR;AsD93YA;EA0GQ,YAAA;AtDuxYR;AsDj4YA;EA6GQ,YAAA;AtDuxYR;AsDp4YA;EAqHI,WAAA;EACA,iBAAA;AtDkxYJ;AsDx4YA;EAyHI,kBAAA;AtDkxYJ;AsD/wYE;EACE,mBAAA;EACA,gBAAA;AtDixYJ;AsD/4YA;EAiII,gBAAA;AtDixYJ;AsDl5YA;EAwIE,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AtD6wYF;AsD35YA;EAiJE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AtD6wYF;AsDl6YA;EAwJE,qBAAA;EACA,WAAA;EtD6wYA,eAAe;AACjB;AsDv6YA;EA4JI,qBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AtD8wYJ;AsD/6YA;EAmKuB,aAAA;AtD+wYvB;AsDl7YA;EAoK0B,aAAA;AtDixY1B;AsDr7YA;EAqK0B,cAAA;AtDmxY1B;AsDx7YA;EAyKE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AtDkxYF;AsD/7YA;EAgLE,aAAA;AtDkxYF;AsDl8YA;EAmLE,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AtDkxYF;AsD18YA;EA2LE,yBAAA;EACA,WAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;AtDkxYF;AsDl9YA;EAkM4C,aAAA;AtDmxY5C;AsDr9YA;EAmM+C,aAAA;AtDqxY/C;AsDx9YA;EAoM+C,cAAA;AtDuxY/C;AsD39YA;EAsME,qBAAA;EACA,WAAA;EACA,YAAA;EtDwxYA,gBAAgB;AAClB;AsDj+YA;EA6ME,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;AtDuxYF;AsD3+YA;EAuNE,aAAA;AtDuxYF;AsD9+YA;EA0NE,wBAAA;AtDuxYF;AsDj/YA;EA6NE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AtDuxYF;AsD1/YA;EAqOI,WAAA;AtDwxYJ;AsD7/YA;EAwOI,SAAA;AtDwxYJ;AsDhgZA;EA2OI,UAAA;EACA,SAAA;AtDwxYJ;AsDpgZA;EAuPI,yBAAA;EACA,qBAAA;AtDgxYJ;AsDxgZA;EA2PI,WAAA;EACA,YAAA;EACA,sBAAA;AtDgxYJ;AsD7gZA;EAkQI,cAAA;EACA,WAAA;EACA,eAAA;AtD8wYJ;AsDlhZA;EAuQI,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AtD8wYJ;AsDzhZA;EA8QI,WAAA;EACA,uBAAA;AtD8wYJ;AsD7hZA;EAoRI,wBAAA;AtD4wYJ;AsDhiZA;EAuRM,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AtD4wYN;AsD1iZA;EAkSQ,eAAA;EACA,WAAA;EACA,WAAA;AtD2wYR;AsD/iZA;EAsSQ,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AtD4wYR;AsDtjZA;EA8SM,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AtD2wYN;AsD9jZA;EAsTM,cAAA;EACA,eAAA;AtD2wYN;AsDlkZA;EA0TM,WAAA;AtD2wYN;AsDzwYE;EAAA;IAEI,SAAA;EtD2wYJ;AACF;AsDzwYE;EAAA;IAEI,cAAA;EtD2wYJ;AACF;AsD/kZA;EAwUI,2BAAA;AtD0wYJ;AsDzwYI;EAAA;IAEI,YAAA;EtD2wYN;AACF;AsDzwYI;EAAA;IAEI,WAAA;EtD2wYN;EsD7wYE;IAKI,aAAA;EtD2wYN;AACF;AsDzwYI;EAAA;IAGI,yBAAA;EtD0wYN;AACF;AsDpmZA;EA8VM,QAAA;EACA,MAAA;AtDywYN;AsDxmZA;EAkWM,cAAA;AtDywYN;AsD3mZA;EAsWQ,eAAA;EACA,iBAAA;EACA,WAAA;AtDwwYR;AsDhnZA;EA2WM,iBAAA;AtDwwYN;AsDnnZA;EA8WQ,WAAA;AtDwwYR;AsDvwYQ;EAAA;IACE,iBAAA;EtD0wYR;AACF;AsD3nZA;EAqXM,uBAAA;EACA,cAAA;AtDywYN;AsDnwYE;EAAA;IAEI,iBAAA;EtDqwYJ;EsDvwYA;IAKI,gBAAA;EtDqwYJ;EsD1wYA;IAQI,gBAAA;EtDqwYJ;AACF;AsDlwYE;EAAA;IAEI,gBAAA;EtDowYJ;AACF;AsDhwYE;EAAA;IAEI,iBAAA;EtDkwYJ;EsDpwYA;IAKI,iBAAA;EtDkwYJ;EsDvwYA;IAQI,eAAA;EtDkwYJ;EsD1wYA;IAWI,cAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;EtDkwYJ;EsDhxYA;IAiBI,WAAA;IACA,eAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;EtDkwYJ;AACF;AsD9vYA;EAEe,cAAA;AtD+vYf;AACA,sCAAsC;AuD9qZtC;EACC,8BAAA;EACA,2BAAA;EACA,sBAAA;AvDgrZD;AuD7qZA;EACC,kBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,6CAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;AvD8qZD;AuD3qZA;EACC,+BAAA;EACA,8BAAA;AvD6qZD;AuD1qZA;EACC,gBAAA;AvD4qZD;AuDzqZA;EACC,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EAEA,gBAAA;EACA,0BAAA;EAEA,6BAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AvDwqZD;AuDrqZA;EACC,aAAA;EACA,SAAA;EACA,iBAAA;AvDuqZD;AuDpqZA;EACC,WAAA;EACA,UAAA;AvDsqZD;AuDnqZA;EACC,SAAA;EACA,UAAA;AvDqqZD;AuDlqZA;EACC,YAAA;EACA,UAAA;AvDoqZD;AACA,eAAe;AuDjqZf;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,6BAAA;EACA,0DAAA;EACA,0CAAA;EACA,oBAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AvDmqZD;AuDhqZA;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AvDkqZD;AuD/pZA;EACC,aAAA;AvDiqZD;AuD9pZA;EACC,WAAA;EACA,6BAAA;AvDgqZD;AuD7pZA;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AvD+pZD;AACA,kDAAkD;AuDvpZlD;EACC,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;AvDypZD;AuDtpZA;EACC,YAAA;EACA,aAAA;EACA,0DAAA;EACA,0BAAA;AvDwpZD;AuDrpZA;EACC,YAAA;EACA,aAAA;EACA,0DAAA;EACA,kBAAA;EACA,0BAAA;AvDupZD;AuDppZA;EACC,YAAA;EACA,aAAA;EACA,0DAAA;EACA,oBAAA;EACA,0BAAA;AvDspZD;AuDnpZA;EACC,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AvDqpZD;AuDlpZA;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,4CAAA;EACA,oCAAA;EACA,iCAAA;AvDopZD;AuDjpZA;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,4CAAA;EACA,oCAAA;EACA,mBAAA;AvDmpZD;AuDhpZA;EACC,WAAA;EACA,gBAAA;EACA,6HAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;AvDkpZD;AuD/oZA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,uFAAA;AvDipZD;AACA,wBAAwB;AuD7oZxB;EACC,kBAAA;EACA,uFAAA;EAEA,yBAAA;AvD8oZD;AuD3oZA;EACC;IACC,WAAA;EvD6oZA;EuD1oZD;IACC,kBAAA;EvD4oZA;EuDzoZD;IACC,SAAA;EvD2oZA;AACF;AACA;;;EAGE;AACF;+BAC+B;AwDz3Z/B;EACE,wBAAA;EACA,6CAAA;EACA,uPAAA;EAKA,mBAAA;EACA,kBAAA;AxDu3ZF;AyDh4ZC;EACC,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AzDk4ZF;AACA,6DAA6D;A0Dz4Z5D;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;A1D24ZF;A0Dz4ZC;EAAsB,cAAA;A1D44ZvB;A0D34ZC;EAAsB,cAAA;A1D84ZvB;A0D74ZC;EAAsB,cAAA;A1Dg5ZvB;A0D/4ZC;EAAsB,cAAA;A1Dk5ZvB;A2D55ZC;EACC,mBAAA;EACA,kBAAA;A3D85ZF;A4D/5ZC;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;A5Di6ZF;A4Dp6ZC;EAIQ,kBAAA;A5Dm6ZT;A4Dj6ZC;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;A5Dm6ZF;A4Dl6ZG;EACC,mBAAA;A5Do6ZJ;AmBj7ZC;EACC,4BAAA;EACA,yBAAA;EACA,oBAAA;AnBm7ZF;AmBh7ZA;EAAc,YAAA;AnBm7Zd;AmBl7ZA;EAAa,WAAA;AnBq7Zb;AmBl7ZE;EAAc,mBAAA;AnBq7ZhB;AmBp7ZE;EAAe,kBAAA;AnBu7ZjB;A6Dl8ZC;EACC,0CAAA;EACA,uCAAA;EACA,qCAAA;EACA,kCAAA;A7Do8ZF;A6Dj8ZA;EACE;IAAK,4BAAA;E7Do8ZL;E6Dn8ZA;IAAO,8BAAA;E7Ds8ZP;AACF;A6Dr8ZA;EACE;IAAK,+BAAA;E7Dw8ZL;E6Dv8ZA;IAAO,iCAAA;E7D08ZP;AACF;A6Dz8ZA;EACE;IAAK,0BAAA;E7D48ZL;E6D38ZA;IAAO,4BAAA;E7D88ZP;AACF;A6D78ZA;EACE;IAAK,2BAAA;E7Dg9ZL;E6D/8ZA;IAAO,6BAAA;E7Dk9ZP;AACF;A6Dj9ZA;EACE;IAAK,uBAAA;E7Do9ZL;E6Dn9ZA;IAAO,yBAAA;E7Ds9ZP;AACF;A8Dh/ZC;ECCC,gEAAA;EACA,gCAAA;EACG,6BAAA;EACC,4BAAA;EACC,2BAAA;EACG,wBAAA;A/Dk/ZV;A8Dv/ZC;ECAC,gEAAA;EACA,iCAAA;EACG,8BAAA;EACC,6BAAA;EACC,4BAAA;EACG,yBAAA;A/D0/ZV;A8D9/ZC;ECDC,gEAAA;EACA,iCAAA;EACG,8BAAA;EACC,6BAAA;EACC,4BAAA;EACG,yBAAA;A/DkgaV;A8DpgaC;ECMC,0EAAA;EACA,+BAAA;EACG,4BAAA;EACC,2BAAA;EACC,0BAAA;EACG,uBAAA;A/DigaV;A8D3gaC;ECKC,0EAAA;EACA,+BAAA;EACG,4BAAA;EACC,2BAAA;EACC,0BAAA;EACG,uBAAA;A/DygaV;AgExhaC;EACC,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AhE0haF;AgExhaC;;EACC,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AhE2haF;AgEzhaC;EAA4B,oBAAA;AhE4ha7B;AgE3haC;EAA4B,cAAA;AhE8ha7B;AgE7haC;EAA2B,WAAA;AhEgia5B;AACA;mEACmE;AiEljalE;EAAgC,gBAAA;AjEqjajC;AiEpjaC;EAAgC,gBAAA;AjEujajC;AiEtjaC;EAAiC,gBAAA;AjEyjalC;AiExjaC;EAAqC,gBAAA;AjE2jatC;AiE1jaC;EAAkC,gBAAA;AjE6janC;AiE5jaC;EAAgC,gBAAA;AjE+jajC;AiE9jaC;EAA+B,gBAAA;AjEikahC;AiEhkaC;EAAiC,gBAAA;AjEmkalC;AiElkaC;EAA+B,gBAAA;AjEqkahC;AiEpkaC;EAAiC,gBAAA;AjEukalC;AiEtkaC;EAA+B,gBAAA;AjEykahC;AiExkaC;EAAmC,gBAAA;AjE2kapC;AiE1kaC;EAA6B,gBAAA;AjE6ka9B;AiE5kaC;EAAkC,gBAAA;AjE+kanC;AiE9kaC;EAAgC,gBAAA;AjEilajC;AiEhlaC;EAAgC,gBAAA;AjEmlajC;AiEllaC;EAAsC,gBAAA;AjEqlavC;AiEplaC;EAAuC,gBAAA;AjEulaxC;AiEtlaC;EAAoC,gBAAA;AjEylarC;AiExlaC;EAAiC,gBAAA;AjE2lalC;AiE1laC;;EAC8B,gBAAA;AjE6la/B;AiE5laC;EAAkC,gBAAA;AjE+lanC;AiE9laC;EAA+B,gBAAA;AjEimahC;AiEhmaC;EAAiC,gBAAA;AjEmmalC;AiElmaC;EAAkC,gBAAA;AjEqmanC;AiEpmaC;EAA+B,gBAAA;AjEumahC;AiEtmaC;EAAmC,gBAAA;AjEymapC;AiExmaC;EAA8C,gBAAA;AjE2ma/C;AiE1maC;EAA4C,gBAAA;AjE6ma7C;AiE5maC;EAAgC,gBAAA;AjE+majC;AiE9maC;EAAwC,gBAAA;AjEinazC;AiEhnaC;;EACiC,gBAAA;AjEmnalC;AiElnaC;EAAkC,gBAAA;AjEqnanC;AiEpnaC;EAAmC,gBAAA;AjEunapC;AiEtnaC;EAA+B,gBAAA;AjEynahC;AiExnaC;EAA+B,gBAAA;AjE2nahC;AiE1naC;EAAqC,gBAAA;AjE6natC;AiE5naC;EAAqC,gBAAA;AjE+natC;AiE9naC;EAAsC,gBAAA;AjEioavC;AiEhoaC;EAAoC,gBAAA;AjEmoarC;AiEloaC;EAAiC,gBAAA;AjEqoalC;AiEpoaC;EAAkC,gBAAA;AjEuoanC;AiEtoaC;EAA8B,gBAAA;AjEyoa/B;AiExoaC;EAA+B,gBAAA;AjE2oahC;AiE1oaC;EAA+B,gBAAA;AjE6oahC;AiE5oaC;EAAmC,gBAAA;AjE+oapC;AiE9oaC;EAAgC,gBAAA;AjEipajC;AiEhpaC;EAAiC,gBAAA;AjEmpalC;AiElpaC;EAA+B,gBAAA;AjEqpahC;AiEppaC;EAA+B,gBAAA;AjEupahC;AiEtpaC;EAAiC,gBAAA;AjEypalC;AiExpaC;EAAsC,gBAAA;AjE2pavC;AiE1paC;EAAqC,gBAAA;AjE6patC;AiE5paC;EAAqC,gBAAA;AjE+patC;AiE9paC;EAAuC,gBAAA;AjEiqaxC;AiEhqaC;EAAsC,gBAAA;AjEmqavC;AiElqaC;EAAwC,gBAAA;AjEqqazC;AiEpqaC;EAA+B,gBAAA;AjEuqahC;AiEtqaC;;EACkC,gBAAA;AjEyqanC;AiExqaC;EAAiC,gBAAA;AjE2qalC;AiE1qaC;EAAuC,gBAAA;AjE6qaxC;AiE5qaC;EAAoC,gBAAA;AjE+qarC;AiE9qaC;EAAiC,gBAAA;AjEiralC;AiEhraC;EAAqC,gBAAA;AjEmratC;AiElraC;EAAiC,gBAAA;AjEqralC;AiEpraC;EAA+B,gBAAA;AjEurahC;AiEtraC;;EAC0C,gBAAA;AjEyra3C;AiExraC;EAAyC,gBAAA;AjE2ra1C;AiE1raC;EAAyC,gBAAA;AjE6ra1C;AiE5raC;EAAiC,gBAAA;AjE+ralC;AiE9raC;EAAwC,gBAAA;AjEisazC;AiEhsaC;EAAwC,gBAAA;AjEmsazC;AiElsaC;EAAmC,gBAAA;AjEqsapC;AiEpsaC;EAA+B,gBAAA;AjEusahC;AiEtsaC;EAAgC,gBAAA;AjEysajC;AiExsaC;EAA+B,gBAAA;AjE2sahC;AiE1saC;EAAkC,gBAAA;AjE6sanC;AiE5saC;EAAuC,gBAAA;AjE+saxC;AiE9saC;EAAuC,gBAAA;AjEitaxC;AiEhtaC;EAAgC,gBAAA;AjEmtajC;AiEltaC;EAAuC,gBAAA;AjEqtaxC;AiEptaC;EAAwC,gBAAA;AjEutazC;AiEttaC;EAAsC,gBAAA;AjEytavC;AiExtaC;EAAuC,gBAAA;AjE2taxC;AiE1taC;EAAuC,gBAAA;AjE6taxC;AiE5taC;EAAuC,gBAAA;AjE+taxC;AiE9taC;EAA0C,gBAAA;AjEiua3C;AiEhuaC;EAAsC,gBAAA;AjEmuavC;AiEluaC;EAAqC,gBAAA;AjEquatC;AiEpuaC;EAAyC,gBAAA;AjEuua1C;AiEtuaC;EAAyC,gBAAA;AjEyua1C;AiExuaC;EAA8B,gBAAA;AjE2ua/B;AiE1uaC;EAAqC,gBAAA;AjE6uatC;AiE5uaC;EAAsC,gBAAA;AjE+uavC;AiE9uaC;EAAmC,gBAAA;AjEivapC;AiEhvaC;EAAqC,gBAAA;AjEmvatC;AiElvaC;;EACgC,gBAAA;AjEqvajC;AiEpvaC;EAAiC,gBAAA;AjEuvalC;AiEtvaC;EAAmC,gBAAA;AjEyvapC;AiExvaC;EAA+B,gBAAA;AjE2vahC;AiE1vaC;EAAgC,gBAAA;AjE6vajC;AiE5vaC;EAAmC,gBAAA;AjE+vapC;AiE9vaC;EAA6C,gBAAA;AjEiwa9C;AiEhwaC;EAA+B,gBAAA;AjEmwahC;AiElwaC;EAA+B,gBAAA;AjEqwahC;AiEpwaC;EAA+B,gBAAA;AjEuwahC;AiEtwaC;EAA8B,gBAAA;AjEywa/B;AiExwaC;EAAoC,gBAAA;AjE2warC;AiE1waC;;EAC+C,gBAAA;AjE6wahD;AiE5waC;EAAgC,gBAAA;AjE+wajC;AiE9waC;EAAmC,gBAAA;AjEixapC;AiEhxaC;EAAiC,gBAAA;AjEmxalC;AiElxaC;EAAkC,gBAAA;AjEqxanC;AiEpxaC;EAAiC,gBAAA;AjEuxalC;AiEtxaC;EAAqC,gBAAA;AjEyxatC;AiExxaC;EAAuC,gBAAA;AjE2xaxC;AiE1xaC;EAAkC,gBAAA;AjE6xanC;AiE5xaC;EAAwC,gBAAA;AjE+xazC;AiE9xaC;EAAiC,gBAAA;AjEiyalC;AiEhyaC;EAAsC,gBAAA;AjEmyavC;AiElyaC;EAAmC,gBAAA;AjEqyapC;AiEpyaC;EAAmC,gBAAA;AjEuyapC;AiEtyaC;EAAsC,gBAAA;AjEyyavC;AiExyaC;EAAyC,gBAAA;AjE2ya1C;AiE1yaC;EAA0C,gBAAA;AjE6ya3C;AiE5yaC;EAA4C,gBAAA;AjE+ya7C;AiE9yaC;EAAuC,gBAAA;AjEizaxC;AiEhzaC;EAA8B,gBAAA;AjEmza/B;AiElzaC;;EAC+B,gBAAA;AjEqzahC;AiEpzaC;EAAmC,gBAAA;AjEuzapC;AiEtzaC;EAAsC,gBAAA;AjEyzavC;AiExzaC;EAAwC,gBAAA;AjE2zazC;AiE1zaC;EAAoC,gBAAA;AjE6zarC;AiE5zaC;EAAkC,gBAAA;AjE+zanC;AiE9zaC;EAAmC,gBAAA;AjEi0apC;AiEh0aC;EAA0C,gBAAA;AjEm0a3C;AiEl0aC;EAAqC,gBAAA;AjEq0atC;AiEp0aC;EAAwC,gBAAA;AjEu0azC;AiEt0aC;EAAkC,gBAAA;AjEy0anC;AiEx0aC;EAAiC,gBAAA;AjE20alC;AiE10aC;EAAwC,gBAAA;AjE60azC;AiE50aC;EAAiC,gBAAA;AjE+0alC;AiE90aC;EAAkC,gBAAA;AjEi1anC;AiEh1aC;EAAgC,gBAAA;AjEm1ajC;AiEl1aC;EAAmC,gBAAA;AjEq1apC;AiEp1aC;EAAqC,gBAAA;AjEu1atC;AiEt1aC;EAAuC,gBAAA;AjEy1axC;AiEx1aC;EAAkC,gBAAA;AjE21anC;AiE11aC;EAAmC,gBAAA;AjE61apC;AiE51aC;EAAiC,gBAAA;AjE+1alC;AiE91aC;EAAiC,gBAAA;AjEi2alC;AiEh2aC;EAAsC,gBAAA;AjEm2avC;AiEl2aC;EAA8B,gBAAA;AjEq2a/B;AiEp2aC;EAAgC,gBAAA;AjEu2ajC;AiEt2aC;EAAmC,gBAAA;AjEy2apC;AiEx2aC;EAA+B,gBAAA;AjE22ahC;AiE12aC;EAAsC,gBAAA;AjE62avC;AiE52aC;EAAuC,gBAAA;AjE+2axC;AiE92aC;EAAsC,gBAAA;AjEi3avC;AiEh3aC;EAAoC,gBAAA;AjEm3arC;AiEl3aC;EAAsC,gBAAA;AjEq3avC;AiEp3aC;EAA4C,gBAAA;AjEu3a7C;AiEt3aC;EAA6C,gBAAA;AjEy3a9C;AiEx3aC;EAA0C,gBAAA;AjE23a3C;AiE13aC;EAA4C,gBAAA;AjE63a7C;AiE53aC;EAAgC,gBAAA;AjE+3ajC;AiE93aC;EAAiC,gBAAA;AjEi4alC;AiEh4aC;EAAgC,gBAAA;AjEm4ajC;AiEl4aC;EAAiC,gBAAA;AjEq4alC;AiEp4aC;EAAoC,gBAAA;AjEu4arC;AiEt4aC;EAAqC,gBAAA;AjEy4atC;AiEx4aC;;EACgC,gBAAA;AjE24ajC;AiE14aC;;EAC+B,gBAAA;AjE64ahC;AiE54aC;EAAgC,gBAAA;AjE+4ajC;AiE94aC;EAAgC,gBAAA;AjEi5ajC;AiEh5aC;;EACmC,gBAAA;AjEm5apC;AiEl5aC;;EACkC,gBAAA;AjEq5anC;AiEp5aC;EAAoC,gBAAA;AjEu5arC;AiEt5aC;;EACmC,gBAAA;AjEy5apC;AiEx5aC;EAAiC,gBAAA;AjE25alC;AiE15aC;EAA+B,gBAAA;AjE65ahC;AiE55aC;EAAkC,gBAAA;AjE+5anC;AiE95aC;EAAkC,gBAAA;AjEi6anC;AiEh6aC;EAAwC,gBAAA;AjEm6azC;AiEl6aC;EAAoC,gBAAA;AjEq6arC;AiEp6aC;EAAgC,gBAAA;AjEu6ajC;AiEt6aC;EAAgC,gBAAA;AjEy6ajC;AiEx6aC;EAAgC,gBAAA;AjE26ajC;AiE16aC;EAAoC,gBAAA;AjE66arC;AiE56aC;EAA2C,gBAAA;AjE+6a5C;AiE96aC;EAA6C,gBAAA;AjEi7a9C;AiEh7aC;EAAsC,gBAAA;AjEm7avC;AiEl7aC;EAAgC,gBAAA;AjEq7ajC;AiEp7aC;EAAqC,gBAAA;AjEu7atC;AiEt7aC;EAAmC,gBAAA;AjEy7apC;AiEx7aC;EAAqC,gBAAA;AjE27atC;AiE17aC;EAAsC,gBAAA;AjE67avC;AiE57aC;EAAkC,gBAAA;AjE+7anC;AiE97aC;;EAC+B,gBAAA;AjEi8ahC;AiEh8aC;;EACmC,gBAAA;AjEm8apC;AiEl8aC;;EACoC,gBAAA;AjEq8arC;AiEp8aC;EAAmC,gBAAA;AjEu8apC;AiEt8aC;EAAmC,gBAAA;AjEy8apC;AiEx8aC;;EAC+B,gBAAA;AjE28ahC;AiE18aC;;EACgC,gBAAA;AjE68ajC;AiE58aC;;EACqC,gBAAA;AjE+8atC;AiE98aC;EAAoC,gBAAA;AjEi9arC;AiEh9aC;EAAqC,gBAAA;AjEm9atC;AiEl9aC;;EAC+B,gBAAA;AjEq9ahC;AiEp9aC;EAAkC,gBAAA;AjEu9anC;AiEt9aC;EAAmC,gBAAA;AjEy9apC;AiEx9aC;;EACoC,gBAAA;AjE29arC;AiE19aC;EAAsC,gBAAA;AjE69avC;AiE59aC;EAAmC,gBAAA;AjE+9apC;AiE99aC;EAAyC,gBAAA;AjEi+a1C;AiEh+aC;EAAuC,gBAAA;AjEm+axC;AiEl+aC;EAAkC,gBAAA;AjEq+anC;AiEp+aC;EAAsC,gBAAA;AjEu+avC;AiEt+aC;EAAmC,gBAAA;AjEy+apC;AiEx+aC;EAAiC,gBAAA;AjE2+alC;AiE1+aC;EAAiC,gBAAA;AjE6+alC;AiE5+aC;EAAkC,gBAAA;AjE++anC;AiE9+aC;EAAsC,gBAAA;AjEi/avC;AiEh/aC;EAAqC,gBAAA;AjEm/atC;AiEl/aC;EAAqC,gBAAA;AjEq/atC;AiEp/aC;EAAoC,gBAAA;AjEu/arC;AiEt/aC;EAAiC,gBAAA;AjEy/alC;AiEx/aC;EAAsC,gBAAA;AjE2/avC;AiE1/aC;EAA+B,gBAAA;AjE6/ahC;AiE5/aC;EAAmC,gBAAA;AjE+/apC;AiE9/aC;EAAsC,gBAAA;AjEigbvC;AiEhgbC;EAA4C,gBAAA;AjEmgb7C;AiElgbC;EAA6C,gBAAA;AjEqgb9C;AiEpgbC;EAA0C,gBAAA;AjEugb3C;AiEtgbC;EAA4C,gBAAA;AjEygb7C;AiExgbC;EAAqC,gBAAA;AjE2gbtC;AiE1gbC;EAAsC,gBAAA;AjE6gbvC;AiE5gbC;EAAmC,gBAAA;AjE+gbpC;AiE9gbC;EAAqC,gBAAA;AjEihbtC;AiEhhbC;EAAkC,gBAAA;AjEmhbnC;AiElhbC;EAAiC,gBAAA;AjEqhblC;AiEphbC;EAAiC,gBAAA;AjEuhblC;AiEthbC;;EACiC,gBAAA;AjEyhblC;AiExhbC;EAAmC,gBAAA;AjE2hbpC;AiE1hbC;EAAqC,gBAAA;AjE6hbtC;AiE5hbC;EAAsC,gBAAA;AjE+hbvC;AiE9hbC;EAAkC,gBAAA;AjEiibnC;AiEhibC;EAAiC,gBAAA;AjEmiblC;AiElibC;;EACgC,gBAAA;AjEqibjC;AiEpibC;EAAqC,gBAAA;AjEuibtC;AiEtibC;EAAmC,gBAAA;AjEyibpC;AiExibC;EAAwC,gBAAA;AjE2ibzC;AiE1ibC;EAAkC,gBAAA;AjE6ibnC;AiE5ibC;EAAkC,gBAAA;AjE+ibnC;AiE9ibC;EAAgC,gBAAA;AjEijbjC;AiEhjbC;EAAkC,gBAAA;AjEmjbnC;AiEljbC;EAAqC,gBAAA;AjEqjbtC;AiEpjbC;EAAiC,gBAAA;AjEujblC;AiEtjbC;EAAyC,gBAAA;AjEyjb1C;AiExjbC;EAAmC,gBAAA;AjE2jbpC;AiE1jbC;EAA+B,gBAAA;AjE6jbhC;AiE5jbC;EAAoC,gBAAA;AjE+jbrC;AiE9jbC;EAAyC,gBAAA;AjEikb1C;AiEhkbC;;;EAEsC,gBAAA;AjEmkbvC;AiElkbC;EAAyC,gBAAA;AjEqkb1C;AiEpkbC;EAA+B,gBAAA;AjEukbhC;AiEtkbC;EAAoC,gBAAA;AjEykbrC;AiExkbC;;EACuC,gBAAA;AjE2kbxC;AiE1kbC;EAAmC,gBAAA;AjE6kbpC;AiE5kbC;EAA+B,gBAAA;AjE+kbhC;AiE9kbC;EAAsC,gBAAA;AjEilbvC;AiEhlbC;EAAsC,gBAAA;AjEmlbvC;AiEllbC;EAAoC,gBAAA;AjEqlbrC;AiEplbC;EAAiC,gBAAA;AjEulblC;AiEtlbC;EAAuC,gBAAA;AjEylbxC;AiExlbC;EAAqC,gBAAA;AjE2lbtC;AiE1lbC;EAA2C,gBAAA;AjE6lb5C;AiE5lbC;EAAiC,gBAAA;AjE+lblC;AiE9lbC;EAAqC,gBAAA;AjEimbtC;AiEhmbC;EAA4C,gBAAA;AjEmmb7C;AiElmbC;EAAiC,gBAAA;AjEqmblC;AiEpmbC;EAAiC,gBAAA;AjEumblC;AiEtmbC;EAA8C,gBAAA;AjEymb/C;AiExmbC;EAA+C,gBAAA;AjE2mbhD;AiE1mbC;EAA4C,gBAAA;AjE6mb7C;AiE5mbC;EAA8C,gBAAA;AjE+mb/C;AiE9mbC;EAAgC,gBAAA;AjEinbjC;AiEhnbC;EAA+B,gBAAA;AjEmnbhC;AiElnbC;EAAiC,gBAAA;AjEqnblC;AiEpnbC;EAAqC,gBAAA;AjEunbtC;AiEtnbC;EAAmC,gBAAA;AjEynbpC;AiExnbC;EAAqC,gBAAA;AjE2nbtC;AiE1nbC;EAAqC,gBAAA;AjE6nbtC;AiE5nbC;EAAqC,gBAAA;AjE+nbtC;AiE9nbC;EAAsC,gBAAA;AjEiobvC;AiEhobC;EAAiC,gBAAA;AjEmoblC;AiElobC;EAAuC,gBAAA;AjEqobxC;AiEpobC;EAAyC,gBAAA;AjEuob1C;AiEtobC;EAAmC,gBAAA;AjEyobpC;AiExobC;EAAqC,gBAAA;AjE2obtC;AiE1obC;EAAuC,gBAAA;AjE6obxC;AiE5obC;EAAwC,gBAAA;AjE+obzC;AiE9obC;EAA+C,gBAAA;AjEipbhD;AiEhpbC;EAAuC,gBAAA;AjEmpbxC;AiElpbC;EAAkC,gBAAA;AjEqpbnC;AiEppbC;;EAC8C,gBAAA;AjEupb/C;AiEtpbC;;EAC4C,gBAAA;AjEypb7C;AiExpbC;;EAC+C,gBAAA;AjE2pbhD;AiE1pbC;;EAC8B,gBAAA;AjE6pb/B;AiE5pbC;EAA8B,gBAAA;AjE+pb/B;AiE9pbC;;EAC8B,gBAAA;AjEiqb/B;AiEhqbC;;EAC8B,gBAAA;AjEmqb/B;AiElqbC;;;;EAG8B,gBAAA;AjEqqb/B;AiEpqbC;;;EAE8B,gBAAA;AjEuqb/B;AiEtqbC;;EAC8B,gBAAA;AjEyqb/B;AiExqbC;;EAC8B,gBAAA;AjE2qb/B;AiE1qbC;EAA+B,gBAAA;AjE6qbhC;AiE5qbC;EAAoC,gBAAA;AjE+qbrC;AiE9qbC;EAAyC,gBAAA;AjEirb1C;AiEhrbC;EAA0C,gBAAA;AjEmrb3C;AiElrbC;EAA0C,gBAAA;AjEqrb3C;AiEprbC;EAA2C,gBAAA;AjEurb5C;AiEtrbC;EAA2C,gBAAA;AjEyrb5C;AiExrbC;EAA4C,gBAAA;AjE2rb7C;AiE1rbC;EAAoC,gBAAA;AjE6rbrC;AiE5rbC;EAAsC,gBAAA;AjE+rbvC;AiE9rbC;EAAyC,gBAAA;AjEisb1C;AiEhsbC;EAAkC,gBAAA;AjEmsbnC;AiElsbC;EAA+B,gBAAA;AjEqsbhC;AiEpsbC;EAAsC,gBAAA;AjEusbvC;AiEtsbC;EAAuC,gBAAA;AjEysbxC;AiExsbC;EAAkC,gBAAA;AjE2sbnC;AiE1sbC;EAAyC,gBAAA;AjE6sb1C;AiE5sbC;EAAoC,gBAAA;AjE+sbrC;AiE9sbC;EAAiC,gBAAA;AjEitblC;AiEhtbC;EAA8B,gBAAA;AjEmtb/B;AiEltbC;EAAoC,gBAAA;AjEqtbrC;AiEptbC;EAA2C,gBAAA;AjEutb5C;AiEttbC;EAAiC,gBAAA;AjEytblC;AiExtbC;EAAwC,gBAAA;AjE2tbzC;AiE1tbC;EAA0C,gBAAA;AjE6tb3C;AiE5tbC;EAAwC,gBAAA;AjE+tbzC;AiE9tbC;EAA0C,gBAAA;AjEiub3C;AiEhubC;EAA2C,gBAAA;AjEmub5C;AiElubC;EAAgC,gBAAA;AjEqubjC;AiEpubC;EAAkC,gBAAA;AjEuubnC;AiEtubC;EAAkC,gBAAA;AjEyubnC;AiExubC;EAAgC,gBAAA;AjE2ubjC;AiE1ubC;EAAmC,gBAAA;AjE6ubpC;AiE5ubC;EAAgC,gBAAA;AjE+ubjC;AiE9ubC;EAAqC,gBAAA;AjEivbtC;AiEhvbC;EAAiC,gBAAA;AjEmvblC;AiElvbC;EAAiC,gBAAA;AjEqvblC;AiEpvbC;EAA+B,gBAAA;AjEuvbhC;AiEtvbC;EAAiC,gBAAA;AjEyvblC;AiExvbC;EAAgC,gBAAA;AjE2vbjC;AiE1vbC;EAAiC,gBAAA;AjE6vblC;AiE5vbC;EAAkC,gBAAA;AjE+vbnC;AiE9vbC;EAA8B,gBAAA;AjEiwb/B;AiEhwbC;EAA6B,gBAAA;AjEmwb9B;AiElwbC;EAAgC,gBAAA;AjEqwbjC;AiEpwbC;EAAiC,gBAAA;AjEuwblC;AiEtwbC;EAAoC,gBAAA;AjEywbrC;AiExwbC;EAAyC,gBAAA;AjE2wb1C;AiE1wbC;EAA+C,gBAAA;AjE6wbhD;AiE5wbC;EAA8C,gBAAA;AjE+wb/C;AiE9wbC;;EAC8C,gBAAA;AjEixb/C;AiEhxbC;EAAuC,gBAAA;AjEmxbxC;AiElxbC;EAAqC,gBAAA;AjEqxbtC;AiEpxbC;EAAuC,gBAAA;AjEuxbxC;AiEtxbC;;EAC8B,gBAAA;AjEyxb/B;AiExxbC;EAAwC,gBAAA;AjE2xbzC;AkEtrcE;EACO,SAAA;AlEwrcT;AkEvrcO;EAAA;IACC,gBAAA;ElE0rcN;AACF;AkE9rcE;EAOE,WAAA;EACA,gBAAA;EACA,2BAAA;AlE0rcJ;AkExrcE;EAAA;IAEI,YAAA;IACA,cAAA;ElE0rcJ;EkE7rcA;IAMI,SAAA;ElE0rcJ;AACF;AkExrcE;EAAA;;IAEI,kBAAA;ElE2rcJ;EkE7rcA;IAKI,iBAAA;ElE2rcJ;AACF;AkExrcA;EACG,eAAA;AlE0rcH;AkEzrcG;EAAA;IACC,SAAA;ElE4rcF;AACF;AkE1rcE;EACI;IACA,cAAA;ElE4rcJ;AACF;AACA,gCAAgC;AmEluchC;EACI,kBAAA;EnEoucF,qBAAqB;EmElucnB,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AnEoucJ;AmEjucA;EACG,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AnEmucH;AmEhucA;EACI,kBAAA;EACA,gBAAA;EACA,MAAA;EnEkucF;+BAC6B;EmEhuc3B,qCAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACE,yBAAA;EnEkucJ,kCAAkC;AACpC;AmE/tcA;EACK,gBAAA;AnEiucL;AmE9tcA;EACI,kBAAA;EACA,OAAA;AnEgucJ;AmE7tcA;EACI,mBAAA;EACA,QAAA;AnE+tcJ;AmE5tcA;EnE8tcE,yBAAyB;EmE5tcpB,kBAAA;AnE8tcP;AmE3tcA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AnE6tcJ;AmE1tcA;EACI,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;AnE4tcJ;AmEztcA;EnE2tcE,qCAAqC;AACvC;AmExtcA;EACI,yBAAA;AnE0tcJ;AmEvtcA;EACI,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AnEytcJ;AmEttcA;EACI,WAAA;AnEwtcJ;AmErtcA;EACI,cAAA;AnEutcJ;AmEptcA;EACI,YAAA;AnEstcJ;AmEntcA;EACI,WAAA;AnEqtcJ;AmEltcA;EACI,eAAA;AnEotcJ;AACA,mDAAmD;AmE1scnD;;EAGI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AnE2scJ;AmEvscA;;EAEE,kBAAA;AnEyscF;AmExscA;;EAII,YAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;AnEwscJ;AmEtscA;EAEI,wBAAA;EACA,4BAAA;AnEuscJ;AmErscA;;EAGE,YAAA;EACA,UAAA;EACA,kBAAA;AnEsscF;AmEpscA;EAEI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AnEqscJ;AmElscA;EAEI,kBAAA;EACA,iBAAA;AnEmscJ;AmE9rcA;EACI,UAAA;EnEgscF,4BAA4B;AAC9B;AmE9rcA;EACI,iBAAA;AnEgscJ;AACA,GAAG;AACH;;;;CAIC;AACD,gBAAgB;AmExrchB;EACK,wCAAA;AnE0rcL;AmEvrcA;EACI,uCAAA;EnEyrcF,kBAAkB;AACpB;AmEvrcA;EACG,uCAAA;AnEyrcH;AmEvrcA;EACI,uCAAA;AnEyrcJ;AmElrcA;;;;EAIE,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AnEorcF;AmEjrcA;;EAGE,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;AnEkrcF;AmE/qcA;;EAEE,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;AnEircF;AmE1qcA;;;;EAIE,SAAA;AnE4qcF;AmE1qcA;;EAEE,gCAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AnE4qcF;AmEzqcA;;EAEE,gCAAA;EACA,wCAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AnE2qcF;AmExqcA;EACE,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;AnE0qcF;AmExqcA;EACE,wBAAA;EACA,4BAAA;AnE0qcF;AmErqcA;EACE,UAAA;AnEuqcF;AmEnqcA;EACM,aAAA;AnEqqcN;AmElqcA;EACE,UAAA;AnEoqcF;AmErqcA;EAEM,cAAA;AnEsqcN;AmEnqcA;EACE,yBAAA;AnEqqcF;AmEhqcA;;EAEE,YAAA;EACA,gBAAA;EACA,uBAAA;AnEkqcF;AmE/pcA;;EAEE,eAAA;EACA,YAAA;AnEiqcF;AoEr9cA;EACI,eAAA;ApEu9cJ;AoEr9cA;EACI,OAAA;EACA,eAAA;EACA,MAAA;ApEu9cJ;AoEr9cA;;EACI,cAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ApEw9cJ;AoEt9cA;;EACI,cAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,MAAA;EACA,WAAA;ApEy9cJ;AoEt9cA;EACE,WAAA;EACA,YAAA;ApEw9cF;AoEl9cA;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;ApEo9cJ;AoE/8cA;;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ApEk9cJ;AoEh9cA;;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;ApEm9cJ;AoEj9cA;EpEm9cE,oCAAoC;AACtC;AoEh9cA;EACI,cAAA;EACA,YAAA;EACA,eAAA;ApEk9cJ;AoE98cA;EACI,eAAA;EACA,iBAAA;ApEg9cJ;AoE78cA;EACI,sBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;ApE+8cJ;AoE78cA;EACI,uBAAA;EpE+8cF,eAAe;EoE78cb,cAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ApE+8cJ;AoE38cA;;EpE88cE,4CAA4C;EoE58c1C,cAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;ApE88cJ;AoE38cA;EACI,YAAA;EACA,WAAA;ApE68cJ;AoE18cA;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;ApE48cJ;AoEz8cA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;ApE28cJ;AoEx8cA;;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApE28cJ;AACA,iBAAiB;AoEv8cjB;;EACI,cAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ApE08cJ;AoEp8cA;;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,4DAAA;ApEu8cJ;AoEr8cA;EpEu8cE;0CACwC;EoEr8ctC,cAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACD,SAAA;ApEu8cH;AoEr8cA;;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ApEw8cJ;AoEt8cA;EAEK,WAAA;ApEu8cL;AoEr8cA;;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ApEw8cJ;AoEp8cA;EACI,mBAAA;ApEs8cJ;AoEp8cA;EACI,kBAAA;ApEs8cJ;AoEl8cA;EACI,0CAAA;ApEo8cJ;AoEl8cA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;ApEo8cJ;AoEj8cA;EACE;IACE,kBAAA;EpEm8cF;AACF;AoEh8cA;EACI,OAAA;EACA,kBAAA;EACA,YAAA;ApEk8cJ;AoEh8cA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ApEk8cJ;AoE/7cA;EACI,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,uDAAA;ApEi8cJ;AoE/7cA;EACI,yBAAA;EACA,WAAA;EACA,SAAA;ApEi8cJ;AoE/7cA;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,8GAAA;ApEi8cJ;AoE/7cA;EACI,qBAAA;EACA,iFAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,mCAAA;ApEi8cJ;AoE/7cA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;ApEi8cJ;AoE/7cA;EACI,yBAAA;EACA,qCAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;ApEi8cJ;AoE/7cA;EACI,4CAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;ApEi8cJ;AoE97cA;;EACI,0BAAA;ApEi8cJ;AoE97cA;EACI,8DAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;ApEg8cJ;AoE97cA;EACI,cAAA;EACA,YAAA;EACA,WAAA;ApEg8cJ;AoE97cA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ApEg8cJ;AoE97cA;EACI,eAAA;EACA,WAAA;ApEg8cJ;AoE77cA;EACI,mBAAA;EACA,sBAAA;ApE+7cJ;AoE77cA;;EACI,cAAA;ApEg8cJ;AoE97cA;;EACI,mBAAA;EACA,kBAAA;EACA,sBAAA;ApEi8cJ;AoE97cA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;ApEg8cJ;AoE97cA;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ApEg8cJ;AACA,qBAAqB;AoE77crB;EAEI,mBAAA;ApE87cJ;AoE37cA;EACI,gCAAA;EAEA,iBAAA;EACA,mBAAA;ApE47cJ;AoEx7cA;EAEM,mBAAA;ApEy7cN;AoEv7cA;EACI,uBAAA;ApEy7cJ;AoEv7cA;EpEy7cE,6BAA6B;EoEv7c7B,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;ApEy7cF;AoEv7cA;EACI,UAAA;EACA,YAAA;ApEy7cJ;AoEt7cA;EACI,WAAA;ApEw7cJ;AoEr7cA;EACE,aAAA;ApEu7cF;AoEr7cA;EAEE,cAAA;ApEs7cF;AoEx7cA;EAII,cAAA;ApEu7cJ;AoE37cA;EASI,UAAA;ApEq7cJ;AoEh7cA;EpEk7cE,8BAA8B;AAChC;AoEh7cA;EpEk7cE;6BAC2B;EoE/6cvB,cAAA;ApEi7cN;AoE36cM;;EpE86cJ;sBACoB;AACtB;AoEt6cM;;;EpE06cJ;6BAC2B;EoEp6cvB,cAAA;ApEs6cN;AoEj6cA;EACE,YAAA;ApEm6cF;AoEh6cA;EACE,kBAAA;EACA,aAAA;EpEk6cA,oBAAoB;EoEh6cpB,YAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;ApEk6cF;AACA,GAAG;AoE55cH;EACI,kBAAA;ApE85cJ;AoE55cA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;ApE85cJ;AoE55cA;EACI;IACI,YAAA;EpE85cN;AACF;AoE55cA;EACI,yBAAA;EACA,yBAAA;EACC,mCAAA;EACD,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;ApE85cJ;AoE15cA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;ApE45cJ;AoE15cA;EACI,yBAAA;EpE45cF,6BAA6B;EoE15c3B,YAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;ApE45cJ;AoEz5cA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;ApE25cJ;AoEx5cA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;ApE05cJ;AACA,oBAAoB;AoEx5cpB;EACI,WAAA;ApE05cJ;AoEr5cA;EpEu5cE,kDAAkD;AACpD;AoEx5cA;;EAGI,uCAAA;ApEy5cJ;AoE55cA;EAKQ,gBAAA;ApE05cR;AoE/5cA;EAQM,wCAAA;ApE05cN;AoEz5cM;EpE25cJ,0CAA0C;AAC5C;AoEx5cM;EACK,uCAAA;EpE05cT,mBAAmB;AACrB;AoEz6cA;EAoBM,gBAAA;EACA,uBAAA;EACA,gBAAA;ApEw5cN;AoEp5cE;EAAA;IAEQ,gBAAA;IACA,uBAAA;IACA,gBAAA;EpEs5cR;AACF;AoEj5cA;EACI,kBAAA;ApEm5cJ;AoE/4cA;EACI,kBAAA;EACA,YAAA;ApEi5cJ;AoEp4cA;EACI,iBAAA;ApEs4cJ;AoEp4cA;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;ApEs4cJ;AoEp4cA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;ApEs4cJ;AoEp4cA;EACI,qDAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ApEs4cJ;AoEp4cA;EACI,YAAA;EACA,WAAA;EACA,mBAAA;ApEs4cJ;AoEp4cA;EACI,mBAAA;EACA,sBAAA;ApEs4cJ;AoEn4cA;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EpEq4cF,gBAAgB;EoEn4cd,sIAAA;EpEq4cF,WAAW;EoEp4cT,6NAAA;EpEs4cF,oBAAoB;EoEr4clB,yIAAA;EpEu4cF,yBAAyB;EoEt4cvB,oIAAA;EpEw4cF,iBAAiB;EoEv4cf,qIAAA;EpEy4cF,UAAU;EoEx4cR,uIAAA;EAEA,oHAAA;EpEy4cF,UAAU;AACZ;AoEv4cA;EACI,wBAAA;EACA,WAAA;EACA,cAAA;ApEy4cJ;AoEt4cA;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ApEw4cJ;AoEr4cA;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;ApEu4cJ;AoEr4cA;EACI,UAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ApEu4cJ;AoEr4cA;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;ApEu4cJ;AoEr4cA;EACI,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;ApEu4cJ;AoEp4cA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;ApEs4cJ;AoEp4cA;EACI,cAAA;EACA,sBAAA;ApEs4cJ;AoEp4cA;EACI,cAAA;EACA,eAAA;ApEs4cJ;AoEp4cA;EACI,iBAAA;ApEs4cJ;AoEj4cA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;ApEm4cJ;AoE53cA;EACI,cAAA;EACA,YAAA;EACA,WAAA;ApE83cJ;AoE33cA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ApE63cF;AoE13cA;;;;;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;ApEg4cF;AoE73cA;EACE,sBAAA;ApE+3cF;AoE53cA;EACE,mBAAA;ApE83cF;AoE33cA;EACI,yBAAA;ApE63cJ;AACA,GAAG;AoEt3cH;EACI,6BAAA;EACA,oCAAA;ApEw3cJ;AoEr3cA;EAEI,mBAAA;ApEs3cJ;AoEx3cA;EAKI,iBAAA;ApEs3cJ;AoE33cA;;EASI,WAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;ApEs3cJ;AoEr4cA;EAkBK,cAAA;ApEs3cL;AoEx4cA;;EAuBI,SAAA;ApEq3cJ;AoE54cA;EA0BI,gCAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;ApEq3cJ;AoEr5cA;EAoCI,gCAAA;EACA,wCAAA;EAEA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;ApEm3cJ;AoEz2cA;EAEI,yBAAA;ApE02cJ;AoEx2cA;EAEI,WAAA;EACA,YAAA;ApEy2cJ;AoE52cA;;EAOI,YAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;ApEy2cJ;AoEr3cA;EAeI,yBAAA;EACA,kBAAA;EACA,0BAAA;ApEy2cJ;AoE13cA;EAoBI,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;ApEy2cJ;AoEr2cA;EACC,wCAAA;EACG,qBAAA;EACA,cAAA;ApEu2cJ;AoEp2cA;EACE,iBAAA;ApEs2cF;AoEn2cA;EACI,YAAA;ApEq2cJ;AoEl2cA;EACI,uBAAA;EACA,gBAAA;ApEo2cJ;AoEj2cA;;EACI,UAAA;ApEo2cJ;AoEl2cA;;EAEI,kBAAA;ApEo2cJ;AoEj2cA;EACI,WAAA;EACA,iBAAA;ApEm2cJ;AoEh2cA;;EAEE,UAAA;ApEk2cF;AoE/1cA;EACE,cAAA;ApEi2cF;AoE91cA;EACE,sBAAA;EACA,YAAA;ApEg2cF;AqErteA;EACE,cAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;ArEuteF;AqEpteA;EACE,eAAA;ArEsteF;AqEpteA;ErEsteE,mBAAmB;AACrB;AqEpteA;EAGI,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ArEoteJ;AqE3teA;EAWI,cAAA;EACA,gBAAA;ArEmteJ;AqE/teA;EAeI,iBAAA;ArEmteJ;AqElueA;EAmBI,gBAAA;ErEkteF,kCAAkC;AACpC;AqEtueA;EAuBI,aAAA;EACA,kBAAA;EACA,gBAAA;ArEkteJ;AqE/seA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;ArEiteF;AqE9seA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;ArEgteF;AqE9seA;EACE,WAAA;ArEgteF;AACA,MAAM;AqE5seN;EACE,cAAA;EACA,YAAA;EACA,gCAAA;ArE8seF;AqE3seA;EACE,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;ArE6seF;AqExseA;EACE,iBAAA;ArE0seF;AqEvseA;EACE,aAAA;ArEyseF;AqEtseA;EAEE,iBAAA;ArEuseF;AqEpseA;EAEE,iBAAA;ArEqseF;AqEjseA;EACI,YAAA;ArEmseJ;AqEjseA;EACI,gBAAA;ArEmseJ;AqEjseA;EACI,YAAA;ArEmseJ;AqEjseA;EACI,gBAAA;ArEmseJ;AqEjseA;ErEmseE,oBAAoB;EACpB,0BAA0B;EqElse1B,YAAA;ErEoseA,oCAAoC;AACtC;AACA,kBAAkB;AqEhselB;;EAEE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ArEkseF;AACA,UAAU;AqE/reV;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;ArEiseF;AqE/reA;EACI,iBAAA;ArEiseJ;AqE9reA;EACE;IACA,gBAAA;IACA,UAAA;ErEgseA;EqE/reA;IACG,mBAAA;ErEiseH;AACF;AACA,OAAO;AqE7reP;;EAEE,eAAA;ArE+reF;AqE5reA;ErE8reE;aACW;AACb;AqE3reA;EAEI,gBAAA;ArE4reJ;AqE9reA;EAMI,gBAAA;EACA,kBAAA;ArE2reJ;AqElseA;EAWI,cAAA;ArE0reJ;AqErseA;EAeI,cAAA;ArEyreJ;AqErreA;EACE,cAAA;EACA,eAAA;ArEureF;AACA,cAAc;AqEpred;;EAGE,WAAA;ArEqreF;AqEnreA;;EAKE,WAAA;ArEkreF;AqEhreA;;ErEmreE;wBACsB;AACxB;AqE9qeA;;EAGE,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;ArE+qeF;AqE5qeA;;EAGE,yBAAA;EACA,qBAAA;EACA,gBAAA;ArE6qeF;AqExqeA;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;ArE0qeF;AqExqeA;EACE,gDAAA;EACA,YAAA;ArE0qeF;AqExqeA;ErE0qeE,uHAAuH;EqExqevH,YAAA;ArE0qeF;AACA,IAAI;AACJ;;;;;;;;CAQC;AqEhqeG;;;;;;;;ErEyqeF;4BAC0B;AAC5B;AqEjqeA;;;;;EAOO,wCAAA;EACA,qBAAA;ArEiqeP;AqE9peA;EAEI,WAAA;EACA,kBAAA;ArE+peJ;AqElqeA;EAMI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;ArE+peJ;AqE3peA;EACE;;;IAGE,gBAAA;IACA,WAAA;ErE6peF;AACF;AqE3peA;EACE;;;IAGE,gBAAA;IACA,WAAA;ErE6peF;AACF;AACA,mCAAmC;AqE3penC;EACE;IACE,mBAAA;IACA,cAAA;IACA,WAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;IACA,iBAAA;ErE6peF;AACF;AACA,8BAA8B","sourcesContent":["//\n// Mixins\n// --------------------------------------------------\n\n\n// Utilities\n// -------------------------\n\n// Clearfix\n// Source: http://nicolasgallagher.com/micro-clearfix-hack/\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n//    contenteditable attribute is included anywhere else in the document.\n//    Otherwise it causes space to appear at the top and bottom of elements\n//    that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n//    `:before` to contain the top-margins of child elements.\n.clearfix() {\n  &:before,\n  &:after {\n    content: \" \"; /* 1 */\n    display: table; /* 2 */\n  }\n  &:after {\n    clear: both;\n  }\n}\n\n// WebKit-style focus\n.tab-focus() {\n  // Default\n  outline: thin dotted @gray-dark;\n  // WebKit\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\n// Center-align a block level element\n.center-block() {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n// Sizing shortcuts\n.size(@width; @height) {\n  width: @width;\n  height: @height;\n}\n.square(@size) {\n  .size(@size; @size);\n}\n\n// Placeholder text\n.placeholder(@color: @input-color-placeholder) {\n  &:-moz-placeholder            { color: @color; } // Firefox 4-18\n  &::-moz-placeholder           { color: @color; } // Firefox 19+\n  &:-ms-input-placeholder       { color: @color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Text overflow\n// Requires inline-block or block for proper styling\n.text-overflow() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// CSS image replacement\n//\n// Heads up! v3 launched with with only `.hide-text()`, but per our pattern for\n// mixins being reused as classes with the same name, this doesn't hold up. As\n// of v3.0.1 we have added `.text-hide()` and deprecated `.hide-text()`. Note\n// that we cannot chain the mixins together in Less, so they are repeated.\n//\n// Source: https://github.com/h5bp/html5-boilerplate/commit/aa0396eae757\n\n// Deprecated as of v3.0.1 (will be removed in v4)\n.hide-text() {\n  font: ~\"0/0\" a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n// New mixin to use as of v3.0.1\n.text-hide() {\n  font: ~\"0/0\" a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n\n\n// CSS3 PROPERTIES\n// --------------------------------------------------\n\n// Single side border-radius\n.border-top-radius(@radius) {\n  border-top-right-radius: @radius;\n   border-top-left-radius: @radius;\n}\n.border-right-radius(@radius) {\n  border-bottom-right-radius: @radius;\n     border-top-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n  border-bottom-right-radius: @radius;\n   border-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n  border-bottom-left-radius: @radius;\n     border-top-left-radius: @radius;\n}\n\n// Drop shadows\n.box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow; // iOS <4.3 & Android <4.1\n          box-shadow: @shadow;\n}\n\n// Transitions\n.transition(@transition) {\n  -webkit-transition: @transition;\n          transition: @transition;\n}\n.transition-property(@transition-property) {\n  -webkit-transition-property: @transition-property;\n          transition-property: @transition-property;\n}\n.transition-delay(@transition-delay) {\n  -webkit-transition-delay: @transition-delay;\n          transition-delay: @transition-delay;\n}\n.transition-duration(@transition-duration) {\n  -webkit-transition-duration: @transition-duration;\n          transition-duration: @transition-duration;\n}\n.transition-transform(@transition) {\n  -webkit-transition: -webkit-transform @transition;\n     -moz-transition: -moz-transform @transition;\n       -o-transition: -o-transform @transition;\n          transition: transform @transition;\n}\n\n// Transformations\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees); // IE9+\n          transform: rotate(@degrees);\n}\n.scale(@ratio) {\n  -webkit-transform: scale(@ratio);\n      -ms-transform: scale(@ratio); // IE9+\n          transform: scale(@ratio);\n}\n.translate(@x; @y) {\n  -webkit-transform: translate(@x, @y);\n      -ms-transform: translate(@x, @y); // IE9+\n          transform: translate(@x, @y);\n}\n.skew(@x; @y) {\n  -webkit-transform: skew(@x, @y);\n      -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n          transform: skew(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n  -webkit-transform: translate3d(@x, @y, @z);\n          transform: translate3d(@x, @y, @z);\n}\n\n.rotateX(@degrees) {\n  -webkit-transform: rotateX(@degrees);\n      -ms-transform: rotateX(@degrees); // IE9+\n          transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n  -webkit-transform: rotateY(@degrees);\n      -ms-transform: rotateY(@degrees); // IE9+\n          transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n  -webkit-perspective: @perspective;\n     -moz-perspective: @perspective;\n          perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n  -webkit-perspective-origin: @perspective;\n     -moz-perspective-origin: @perspective;\n          perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n  -webkit-transform-origin: @origin;\n     -moz-transform-origin: @origin;\n          transform-origin: @origin;\n}\n\n// Animations\n.animation(@animation) {\n  -webkit-animation: @animation;\n          animation: @animation;\n}\n\n// Backface visibility\n// Prevent browsers from flickering when using CSS 3D transforms.\n// Default value is `visible`, but can be changed to `hidden`\n.backface-visibility(@visibility){\n  -webkit-backface-visibility: @visibility;\n     -moz-backface-visibility: @visibility;\n          backface-visibility: @visibility;\n}\n\n// Box sizing\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n     -moz-box-sizing: @boxmodel;\n          box-sizing: @boxmodel;\n}\n\n// User select\n// For selecting text on the page\n.user-select(@select) {\n  -webkit-user-select: @select;\n     -moz-user-select: @select;\n      -ms-user-select: @select; // IE10+\n       -o-user-select: @select;\n          user-select: @select;\n}\n\n// Resize anything\n.resizable(@direction) {\n  resize: @direction; // Options: horizontal, vertical, both\n  overflow: auto; // Safari fix\n}\n\n// CSS3 Content Columns\n.content-columns(@column-count; @column-gap: @grid-gutter-width) {\n  -webkit-column-count: @column-count;\n     -moz-column-count: @column-count;\n          column-count: @column-count;\n  -webkit-column-gap: @column-gap;\n     -moz-column-gap: @column-gap;\n          column-gap: @column-gap;\n}\n\n// Optional hyphenation\n.hyphens(@mode: auto) {\n  word-wrap: break-word;\n  -webkit-hyphens: @mode;\n     -moz-hyphens: @mode;\n      -ms-hyphens: @mode; // IE10+\n       -o-hyphens: @mode;\n          hyphens: @mode;\n}\n\n// Opacity\n.opacity(@opacity) {\n  opacity: @opacity;\n  // IE8 filter\n  @opacity-ie: (@opacity * 100);\n  filter: ~\"alpha(opacity=@{opacity-ie})\";\n}\n\n\n\n// GRADIENTS\n// --------------------------------------------------\n\n#gradient {\n\n  // Horizontal gradient, from left to right\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .horizontal(@start-color: @gray; @end-color: @gray-dark; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-gradient(linear, @start-percent top, @end-percent top, from(@start-color), to(@end-color)); // Safari 4+, Chrome 2+\n    background-image: -webkit-linear-gradient(left, color-stop(@start-color @start-percent), color-stop(@end-color @end-percent)); // Safari 5.1+, Chrome 10+\n    background-image: -moz-linear-gradient(left, @start-color @start-percent, @end-color @end-percent); // FF 3.6+\n    background-image:  linear-gradient(to right, @start-color @start-percent, @end-color @end-percent); // Standard, IE10\n    background-repeat: repeat-x;\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\",argb(@start-color),argb(@end-color))); // IE9 and down\n  }\n\n  // Vertical gradient, from top to bottom\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .vertical(@start-color: @gray; @end-color: @gray-dark; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-gradient(linear, left @start-percent, left @end-percent, from(@start-color), to(@end-color)); // Safari 4+, Chrome 2+\n    background-image: -webkit-linear-gradient(top, @start-color @start-percent, @end-color @end-percent); // Safari 5.1+, Chrome 10+\n    background-image:  -moz-linear-gradient(top, @start-color @start-percent, @end-color @end-percent); // FF 3.6+\n    background-image: linear-gradient(to bottom, @start-color @start-percent, @end-color @end-percent); // Standard, IE10\n    background-repeat: repeat-x;\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\",argb(@start-color),argb(@end-color))); // IE9 and down\n  }\n\n  .directional(@start-color: @gray; @end-color: @gray-dark; @deg: 45deg) {\n    background-repeat: repeat-x;\n    background-image: -webkit-linear-gradient(@deg, @start-color, @end-color); // Safari 5.1+, Chrome 10+\n    background-image: -moz-linear-gradient(@deg, @start-color, @end-color); // FF 3.6+\n    background-image: linear-gradient(@deg, @start-color, @end-color); // Standard, IE10\n  }\n  .horizontal-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-gradient(left, linear, 0 0, 0 100%, from(@start-color), color-stop(@color-stop, @mid-color), to(@end-color));\n    background-image: -webkit-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: -moz-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(to right, @start-color, @mid-color @color-stop, @end-color);\n    background-repeat: no-repeat;\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\",argb(@start-color),argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n  }\n  .vertical-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(@start-color), color-stop(@color-stop, @mid-color), to(@end-color));\n    background-image: -webkit-linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-image: -moz-linear-gradient(top, @start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-repeat: no-repeat;\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\",argb(@start-color),argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n  }\n  .radial(@inner-color: @gray; @outer-color: @gray-dark) {\n    background-image: -webkit-gradient(radial, center center, 0, center center, 460, from(@inner-color), to(@outer-color));\n    background-image: -webkit-radial-gradient(circle, @inner-color, @outer-color);\n    background-image: -moz-radial-gradient(circle, @inner-color, @outer-color);\n    background-image: radial-gradient(circle, @inner-color, @outer-color);\n    background-repeat: no-repeat;\n  }\n  .striped(@color: rgba(255,255,255,.15); @angle: 45deg) {\n    background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(.25, @color), color-stop(.25, transparent), color-stop(.5, transparent), color-stop(.5, @color), color-stop(.75, @color), color-stop(.75, transparent), to(transparent));\n    background-image: -webkit-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: -moz-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n  }\n}\n\n// Reset filters for IE\n//\n// When you need to remove a gradient background, do not forget to use this to reset\n// the IE filter for IE9 and below.\n.reset-filter() {\n  filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(enabled = false)\"));\n}\n\n\n\n// Retina images\n//\n// Short retina mixin for setting background-image and -size\n\n.img-retina(@file-1x; @file-2x; @width-1x; @height-1x) {\n  background-image: url(\"@{file-1x}\");\n\n  @media\n  only screen and (-webkit-min-device-pixel-ratio: 2),\n  only screen and (   min--moz-device-pixel-ratio: 2),\n  only screen and (     -o-min-device-pixel-ratio: 2/1),\n  only screen and (        min-device-pixel-ratio: 2),\n  only screen and (                min-resolution: 192dpi),\n  only screen and (                min-resolution: 2dppx) {\n    background-image: url(\"@{file-2x}\");\n    background-size: @width-1x @height-1x;\n  }\n}\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n.img-responsive(@display: block;) {\n  display: @display;\n  max-width: 100%; // Part 1: Set a maximum relative to the parent\n  height: auto; // Part 2: Scale the height according to the width, otherwise you get stretching\n}\n\n\n// COMPONENT MIXINS\n// --------------------------------------------------\n\n// Horizontal dividers\n// -------------------------\n// Dividers (basically an hr) within dropdowns and nav lists\n.nav-divider(@color: #e5e5e5) {\n  height: 1px;\n  margin: ((@line-height-computed / 2) - 1) 0;\n  overflow: hidden;\n  background-color: @color;\n}\n\n// Panels\n// -------------------------\n.panel-variant(@border; @heading-text-color; @heading-bg-color; @heading-border;) {\n  border-color: @border;\n\n  & > .panel-heading {\n    color: @heading-text-color;\n    background-color: @heading-bg-color;\n    border-color: @heading-border;\n\n    + .panel-collapse .panel-body {\n      border-top-color: @border;\n    }\n    & > .dropdown .caret {\n      border-color: @heading-text-color transparent;\n    }\n  }\n  & > .panel-footer {\n    + .panel-collapse .panel-body {\n      border-bottom-color: @border;\n    }\n  }\n}\n\n// Alerts\n// -------------------------\n.alert-variant(@background; @border; @text-color) {\n  background-color: @background;\n  border-color: @border;\n  color: @text-color;\n\n  hr {\n    border-top-color: darken(@border, 5%);\n  }\n  .alert-link {\n    color: darken(@text-color, 10%);\n  }\n}\n\n// Tables\n// -------------------------\n.table-row-variant(@state; @background; @border) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table > thead > tr,\n  .table > tbody > tr,\n  .table > tfoot > tr {\n    > td.@{state},\n    > th.@{state},\n    &.@{state} > td,\n    &.@{state} > th {\n      background-color: @background;\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover > tbody > tr {\n    > td.@{state}:hover,\n    > th.@{state}:hover,\n    &.@{state}:hover > td,\n    &.@{state}:hover > th {\n      background-color: darken(@background, 5%);\n    }\n  }\n}\n\n// Button variants\n// -------------------------\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n.button-variant(@color; @background; @border) {\n  color: @color;\n  background-color: @background;\n  border-color: @border;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open .dropdown-toggle& {\n    color: @color;\n    background-color: darken(@background, 8%);\n        border-color: darken(@border, 12%);\n  }\n  &:active,\n  &.active,\n  .open .dropdown-toggle& {\n    background-image: none;\n  }\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: rgba(0,0,0,.2);\n          border-color: #FFFFFF;\n    }\n  }\n}\n\n// Button sizes\n// -------------------------\n.button-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n}\n\n// Pagination\n// -------------------------\n.pagination-size(@padding-vertical; @padding-horizontal; @font-size; @border-radius) {\n  > li {\n    > a,\n    > span {\n      padding: @padding-vertical @padding-horizontal;\n      font-size: @font-size;\n    }\n    &:first-child {\n      > a,\n      > span {\n        .border-left-radius(@border-radius);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius);\n      }\n    }\n  }\n}\n\n// Labels\n// -------------------------\n.label-variant(@color) {\n  background-color: @color;\n  &[href] {\n    &:hover,\n    &:focus {\n      background-color: darken(@color, 10%);\n    }\n  }\n}\n\n// Navbar vertical align\n// -------------------------\n// Vertically center elements in the navbar.\n// Example: an element has a height of 30px, so write out `.navbar-vertical-align(30px);` to calculate the appropriate top margin.\n.navbar-vertical-align(@element-height) {\n  margin-top: ((@navbar-height - @element-height) / 2);\n  margin-bottom: ((@navbar-height - @element-height) / 2);\n}\n\n// Progress bars\n// -------------------------\n.progress-bar-variant(@color) {\n  background-color: @color;\n  .progress-striped & {\n    #gradient > .striped();\n  }\n}\n\n// Responsive utilities\n// -------------------------\n// More easily include all the states for responsive-utilities.less.\n.responsive-visibility() {\n  display: block !important;\n  tr& { display: table-row !important; }\n  th&,\n  td& { display: table-cell !important; }\n}\n\n.responsive-invisibility() {\n    &,\n  tr&,\n  th&,\n  td& { display: none !important; }\n}\n.responsive-visibility2() {\n  display: table-cell !important;\n  tr& { display: table-row !important; }\n  th&,\n  td& { display: table-cell !important; }\n}\n\n\n\n// Grid System\n// -----------\n\n// Centered container element\n.container-fixed() {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left:  (@grid-gutter-width / 2);\n  padding-right: (@grid-gutter-width / 2);\n  .clearfix();\n}\n\n\n.btn-anonimus {\n  margin: 0px 10px !important;\n}\n\n.container2 {\n  .container-fixed()\n}\n// Creates a wrapper for a series of columns\n.make-row(@gutter: @grid-gutter-width) {\n  margin-left:  (@gutter / -2);\n  margin-right: (@gutter / -2);\n  .clearfix();\n}\n\n// Generate the extra small columns\n.make-xs-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  float: left;\n  width: percentage((@columns / @grid-columns));\n  // Prevent columns from collapsing when empty\n  min-height: 1px;\n  // Inner gutter via padding\n  padding-left:  (@gutter / 2);\n  padding-right: (@gutter / 2);\n}\n\n// Generate the small columns\n.make-sm-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  // Prevent columns from collapsing when empty\n  min-height: 1px;\n  // Inner gutter via padding\n  padding-left:  (@gutter / 2);\n  padding-right: (@gutter / 2);\n\n  // Calculate width based on number of columns available\n  @media (min-width: @screen-sm-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the small column offsets\n.make-sm-column-offset(@columns) {\n  @media (min-width: @screen-sm-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-push(@columns) {\n  @media (min-width: @screen-sm-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-pull(@columns) {\n  @media (min-width: @screen-sm-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the medium columns\n.make-md-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  // Prevent columns from collapsing when empty\n  min-height: 1px;\n  // Inner gutter via padding\n  padding-left:  (@gutter / 2);\n  padding-right: (@gutter / 2);\n\n  // Calculate width based on number of columns available\n  @media (min-width: @screen-md-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the medium column offsets\n.make-md-column-offset(@columns) {\n  @media (min-width: @screen-md-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-push(@columns) {\n  @media (min-width: @screen-md) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-pull(@columns) {\n  @media (min-width: @screen-md-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the large columns\n.make-lg-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  // Prevent columns from collapsing when empty\n  min-height: 1px;\n  // Inner gutter via padding\n  padding-left:  (@gutter / 2);\n  padding-right: (@gutter / 2);\n\n  // Calculate width based on number of columns available\n  @media (min-width: @screen-lg-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the large column offsets\n.make-lg-column-offset(@columns) {\n  @media (min-width: @screen-lg-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-push(@columns) {\n  @media (min-width: @screen-lg-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-pull(@columns) {\n  @media (min-width: @screen-lg-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `@grid-columns`.\n\n.make-grid-columns() {\n  // Common styles for all sizes of grid columns, widths 1-12\n  .col(@index) when (@index = 1) { // initial\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col(@index + 1, @item);\n  }\n  .col(@index, @list) when (@index =< @grid-columns) { // general; \"=<\" isn't a typo\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col(@index + 1, ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index > @grid-columns) { // terminal\n    @{list} {\n      position: relative;\n      // Prevent columns from collapsing when empty\n      min-height: 1px;\n      // Inner gutter via padding\n      padding-left:  (@grid-gutter-width / 2);\n      padding-right: (@grid-gutter-width / 2);\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.make-grid-columns-float(@class) {\n  .col(@index) when (@index = 1) { // initial\n    @item: ~\".col-@{class}-@{index}\";\n    .col(@index + 1, @item);\n  }\n  .col(@index, @list) when (@index < @grid-columns) { // general\n    @item: ~\".col-@{class}-@{index}\";\n    .col(@index + 1, ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index = @grid-columns) { // terminal\n    @{list} {\n      float: left;\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.calc-grid(@index, @class, @type) when (@type = width) and (@index > 0) {\n  .col-@{class}-@{index} {\n    width: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid(@index, @class, @type) when (@type = push) {\n  .col-@{class}-push-@{index} {\n    left: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid(@index, @class, @type) when (@type = pull) {\n  .col-@{class}-pull-@{index} {\n    right: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid(@index, @class, @type) when (@type = offset) {\n  .col-@{class}-offset-@{index} {\n    margin-left: percentage((@index / @grid-columns));\n  }\n}\n\n// Basic looping in LESS\n.make-grid(@index, @class, @type) when (@index >= 0) {\n  .calc-grid(@index, @class, @type);\n  // next iteration\n  .make-grid(@index - 1, @class, @type);\n}\n\n\n// Form validation states\n//\n// Used in forms.less to generate the form validation CSS for warnings, errors,\n// and successes.\n\n.form-control-validation(@text-color: @gray; @border-color: @gray6; @background-color: #f5f5f5) {\n  // Color the label and help text\n  .help-block,\n  .control-label,\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline  {\n    color: @text-color;\n  }\n  // Set the border and box shadow on specific inputs to match\n  .form-control {\n    border-color: @border-color;\n    .box-shadow(inset 0 1px 1px rgba(0,0,0,.075)); // Redeclare so transitions work\n    &:focus {\n      border-color: darken(@border-color, 10%);\n      @shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px lighten(@border-color, 20%);\n      .box-shadow(@shadow);\n    }\n  }\n  // Set validation states also for addons\n  .input-group-addon {\n    color: @text-color;\n    border-color: @border-color;\n    background-color: @background-color;\n  }\n}\n\n// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `@input-focus-border` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n\n.form-control-focus(@color: @input-border-focus) {\n  @color-rgba: rgba(red(@color), green(@color), blue(@color), .6);\n  &:focus {\n    border-color: @color;\n    outline: 0;\n    //.box-shadow(~\"inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px @{color-rgba}\");\n  }\n}\n\n// Form control sizing\n//\n// Relative text size, padding, and border-radii changes for form controls. For\n// horizontal sizing, wrap controls in the predefined grid classes. `<select>`\n// element gets special love because it's special, and that's a fact!\n\n.input-size(@input-height; @padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  height: @input-height;\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n\n  select& {\n    height: @input-height;\n    line-height: @input-height;\n  }\n\n  textarea& {\n    height: auto;\n  }\n}",".btn-anonimus {\n  margin: 0px 10px !important;\n}\n.container2 {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.container2:before,\n.container2:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.container2:after {\n  clear: both;\n}\n.container2:before,\n.container2:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.container2:after {\n  clear: both;\n}\n/*! normalize.css v2.1.3 | MIT License | git.io/normalize */\n*:focus,\n*:active {\n  outline: transparent !important;\n  outline: none !important;\n  -moz-outline-style: none !important;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n[hidden],\ntemplate {\n  display: none;\n}\nhtml {\n  font-family: Roboto;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n}\na {\n  background: transparent;\n}\na:focus {\n  outline: thin dotted;\n}\na:active,\na:hover {\n  outline: 0;\n}\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nabbr[title] {\n  border-bottom: 1px dotted;\n}\nb,\nstrong {\n  font-weight: bold;\n}\ndfn {\n  font-style: italic;\n}\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\nmark {\n  background: #ff0;\n  color: #000;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Roboto;\n  font-size: 1em;\n}\npre {\n  white-space: pre-wrap;\n}\nq {\n  quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsup {\n  top: -0.5em;\n}\nsub {\n  bottom: -0.25em;\n}\nimg {\n  border: 0;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\nfigure {\n  margin: 0;\n}\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  border: 0;\n  padding: 0;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: Roboto;\n  font-size: 100%;\n  margin: 0;\n}\ntextarea {\n  resize: none !important;\n}\nbutton,\ninput {\n  line-height: normal;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n}\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\ntextarea {\n  overflow: auto;\n  vertical-align: top;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n@media print {\n  * {\n    text-shadow: none !important;\n    color: #000 !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n  a[href^=\"javascript:\"]:after,\n  a[href^=\"#\"]:after {\n    content: \"\";\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999999;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  img {\n    max-width: 100% !important;\n  }\n  @page {\n    margin: 2cm 0.5cm;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  select {\n    background: #FFF !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .table td,\n  .table th {\n    background-color: #FFF !important;\n  }\n  .btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n  }\n  .label {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #DDD !important;\n  }\n}\n*,\n*:before,\n*:after {\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 62.5%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: Roboto;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #FFF;\n  background-color: #121212;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: Roboto;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #999999;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #737373;\n  text-decoration: underline;\n}\na:focus {\n  outline: thin dotted #333333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nimg {\n  vertical-align: middle;\n}\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.img-rounded {\n  border-radius: 6px;\n}\n.img-thumbnail {\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: #121212;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all all 0.2s ease-in-out ease-out;\n  -moz-transition: all all 0.2s ease-in-out ease-out;\n  -o-transition: all all 0.2s ease-in-out ease-out;\n  transition: all all 0.2s ease-in-out ease-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n.img-circle {\n  border-radius: 50%;\n}\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #232323;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n.item-format {\n  padding: 0;\n  line-height: 1.3;\n}\n.title-fox--div {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background: -webkit-linear-gradient(bottom, black, transparent);\n  background: -moz-linear-gradient(bottom, black, transparent);\n  background: -o-linear-background(bottom, black, transparent);\n  background: -ms-linear-gradient(bottom, black, transparent);\n}\n.title-fox--p {\n  margin-left: 10px;\n  word-wrap: break-word;\n}\n@media (max-width: 768px) {\n  .title-fox--p {\n    text-overflow: ellipsis;\n    /* Required for text-overflow to do anything */\n    white-space: nowrap;\n    overflow: hidden;\n  }\n}\np {\n  margin: 0 0 10px;\n}\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 200;\n  line-height: 1.4;\n}\n@media (min-width: 768px) {\n  .lead {\n    font-size: 21px;\n  }\n}\nsmall,\n.small {\n  font-size: 85%;\n}\ncite {\n  font-style: normal;\n}\n.text-muted {\n  color: #999999;\n}\n.text-primary {\n  color: #FFF;\n}\n.text-primary:hover {\n  color: #e6e6e6;\n}\n.text-warning {\n  color: #c09853;\n}\n.text-warning:hover {\n  color: #a47e3c;\n}\n.text-danger {\n  color: #6D6D6D;\n}\n.text-danger:hover {\n  color: #535353;\n}\n.text-success {\n  color: #468847;\n}\n.text-success:hover {\n  color: #356635;\n}\n.text-info {\n  color: #3a87ad;\n}\n.text-info:hover {\n  color: #2d6987;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.text-center {\n  text-align: center;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: Roboto;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\nh1 small,\nh2 small,\nh3 small,\nh4 small,\nh5 small,\nh6 small,\n.h1 small,\n.h2 small,\n.h3 small,\n.h4 small,\n.h5 small,\n.h6 small,\nh1 .small,\nh2 .small,\nh3 .small,\nh4 .small,\nh5 .small,\nh6 .small,\n.h1 .small,\n.h2 .small,\n.h3 .small,\n.h4 .small,\n.h5 .small,\n.h6 .small {\n  font-weight: normal;\n  line-height: 1;\n  color: #999999;\n}\nh1,\nh2,\nh3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\nh1 small,\nh2 small,\nh3 small,\nh1 .small,\nh2 .small,\nh3 .small {\n  font-size: 65%;\n}\nh4,\nh5,\nh6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\nh4 small,\nh5 small,\nh6 small,\nh4 .small,\nh5 .small,\nh6 .small {\n  font-size: 75%;\n}\nh1,\n.h1 {\n  font-size: 36px;\n}\nh2,\n.h2 {\n  font-size: 30px;\n}\nh3,\n.h3 {\n  font-size: 24px;\n}\nh4,\n.h4 {\n  font-size: 18px;\n}\nh5,\n.h5 {\n  font-size: 14px;\n}\nh6,\n.h6 {\n  font-size: 12px;\n}\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eeeeee;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul ul,\nol ul,\nul ol,\nol ol {\n  margin-bottom: 0;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline > li {\n  display: inline-block;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.list-inline > li:first-child {\n  padding-left: 0;\n}\ndl {\n  margin-bottom: 20px;\n}\ndt,\ndd {\n  line-height: 1.42857143;\n}\ndt {\n  font-weight: bold;\n}\ndd {\n  margin-left: 0;\n}\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .dl-horizontal dd {\n    margin-left: 180px;\n  }\n  .dl-horizontal dd:before,\n  .dl-horizontal dd:after {\n    content: \" \";\n    /* 1 */\n    display: table;\n    /* 2 */\n  }\n  .dl-horizontal dd:after {\n    clear: both;\n  }\n  .dl-horizontal dd:before,\n  .dl-horizontal dd:after {\n    content: \" \";\n    /* 1 */\n    display: table;\n    /* 2 */\n  }\n  .dl-horizontal dd:after {\n    clear: both;\n  }\n}\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted #999999;\n}\nabbr.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  border-left: 5px solid #eeeeee;\n}\nblockquote p {\n  font-size: 17.5px;\n  font-weight: 300;\n  line-height: 1.25;\n}\nblockquote p:last-child {\n  margin-bottom: 0;\n}\nblockquote small {\n  display: block;\n  line-height: 1.42857143;\n  color: #999999;\n}\nblockquote small:before {\n  content: '\\2014 \\00A0';\n}\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  border-right: 5px solid #eeeeee;\n  border-left: 0;\n}\nblockquote.pull-right p,\nblockquote.pull-right small,\nblockquote.pull-right .small {\n  text-align: right;\n}\nblockquote.pull-right small:before,\nblockquote.pull-right .small:before {\n  content: '';\n}\nblockquote.pull-right small:after,\nblockquote.pull-right .small:after {\n  content: '\\00A0 \\2014';\n}\nblockquote:before,\nblockquote:after {\n  content: \"\";\n}\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857143;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: Roboto;\n}\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  white-space: nowrap;\n  border-radius: 4px;\n}\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857143;\n  word-break: break-all;\n  word-wrap: break-word;\n  color: #333333;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\npre code {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.container:before,\n.container:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.container:after {\n  clear: both;\n}\n.container:before,\n.container:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.container:after {\n  clear: both;\n}\n.row {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.row:before,\n.row:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.row:after {\n  clear: both;\n}\n.row:before,\n.row:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.row:after {\n  clear: both;\n}\n.col-xs-1,\n.col-sm-1,\n.col-md-1,\n.col-lg-1,\n.col-xs-2,\n.col-sm-2,\n.col-md-2,\n.col-lg-2,\n.col-xs-3,\n.col-sm-3,\n.col-md-3,\n.col-lg-3,\n.col-xs-4,\n.col-sm-4,\n.col-md-4,\n.col-lg-4,\n.col-xs-5,\n.col-sm-5,\n.col-md-5,\n.col-lg-5,\n.col-xs-6,\n.col-sm-6,\n.col-md-6,\n.col-lg-6,\n.col-xs-7,\n.col-sm-7,\n.col-md-7,\n.col-lg-7,\n.col-xs-8,\n.col-sm-8,\n.col-md-8,\n.col-lg-8,\n.col-xs-9,\n.col-sm-9,\n.col-md-9,\n.col-lg-9,\n.col-xs-10,\n.col-sm-10,\n.col-md-10,\n.col-lg-10,\n.col-xs-11,\n.col-sm-11,\n.col-md-11,\n.col-lg-11,\n.col-xs-12,\n.col-sm-12,\n.col-md-12,\n.col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.col-xs-1,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9,\n.col-xs-10,\n.col-xs-11 {\n  float: left;\n}\n.col-xs-12 {\n  width: 100%;\n}\n.col-xs-11 {\n  width: 91.66666667%;\n}\n.col-xs-10 {\n  width: 83.33333333%;\n}\n.col-xs-9 {\n  width: 75%;\n}\n.col-xs-8 {\n  width: 66.66666667%;\n}\n.col-xs-7 {\n  width: 58.33333333%;\n}\n.col-xs-6 {\n  width: 50%;\n}\n.col-xs-5 {\n  width: 41.66666667%;\n}\n.col-xs-4 {\n  width: 33.33333333%;\n}\n.col-xs-3 {\n  width: 25%;\n}\n.col-xs-2 {\n  width: 16.66666667%;\n}\n.col-xs-1 {\n  width: 8.33333333%;\n}\n.col-xs-pull-12 {\n  right: 100%;\n}\n.col-xs-pull-11 {\n  right: 91.66666667%;\n}\n.col-xs-pull-10 {\n  right: 83.33333333%;\n}\n.col-xs-pull-9 {\n  right: 75%;\n}\n.col-xs-pull-8 {\n  right: 66.66666667%;\n}\n.col-xs-pull-7 {\n  right: 58.33333333%;\n}\n.col-xs-pull-6 {\n  right: 50%;\n}\n.col-xs-pull-5 {\n  right: 41.66666667%;\n}\n.col-xs-pull-4 {\n  right: 33.33333333%;\n}\n.col-xs-pull-3 {\n  right: 25%;\n}\n.col-xs-pull-2 {\n  right: 16.66666667%;\n}\n.col-xs-pull-1 {\n  right: 8.33333333%;\n}\n.col-xs-pull-0 {\n  right: 0%;\n}\n.col-xs-push-12 {\n  left: 100%;\n}\n.col-xs-push-11 {\n  left: 91.66666667%;\n}\n.col-xs-push-10 {\n  left: 83.33333333%;\n}\n.col-xs-push-9 {\n  left: 75%;\n}\n.col-xs-push-8 {\n  left: 66.66666667%;\n}\n.col-xs-push-7 {\n  left: 58.33333333%;\n}\n.col-xs-push-6 {\n  left: 50%;\n}\n.col-xs-push-5 {\n  left: 41.66666667%;\n}\n.col-xs-push-4 {\n  left: 33.33333333%;\n}\n.col-xs-push-3 {\n  left: 25%;\n}\n.col-xs-push-2 {\n  left: 16.66666667%;\n}\n.col-xs-push-1 {\n  left: 8.33333333%;\n}\n.col-xs-push-0 {\n  left: 0%;\n}\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n.col-xs-offset-11 {\n  margin-left: 91.66666667%;\n}\n.col-xs-offset-10 {\n  margin-left: 83.33333333%;\n}\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n.col-xs-offset-8 {\n  margin-left: 66.66666667%;\n}\n.col-xs-offset-7 {\n  margin-left: 58.33333333%;\n}\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n.col-xs-offset-5 {\n  margin-left: 41.66666667%;\n}\n.col-xs-offset-4 {\n  margin-left: 33.33333333%;\n}\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n.col-xs-offset-2 {\n  margin-left: 16.66666667%;\n}\n.col-xs-offset-1 {\n  margin-left: 8.33333333%;\n}\n.col-xs-offset-0 {\n  margin-left: 0%;\n}\n@media (min-width: 768px) {\n  .container {\n    width: 730px;\n  }\n  .col-sm-1,\n  .col-sm-2,\n  .col-sm-3,\n  .col-sm-4,\n  .col-sm-5,\n  .col-sm-6,\n  .col-sm-7,\n  .col-sm-8,\n  .col-sm-9,\n  .col-sm-10,\n  .col-sm-11 {\n    float: left;\n  }\n  .col-sm-12 {\n    width: 100%;\n  }\n  .col-sm-11 {\n    width: 91.66666667%;\n  }\n  .col-sm-10 {\n    width: 83.33333333%;\n  }\n  .col-sm-9 {\n    width: 75%;\n  }\n  .col-sm-8 {\n    width: 66.66666667%;\n  }\n  .col-sm-7 {\n    width: 58.33333333%;\n  }\n  .col-sm-6 {\n    width: 50%;\n  }\n  .col-sm-5 {\n    width: 41.66666667%;\n  }\n  .col-sm-4 {\n    width: 33.33333333%;\n  }\n  .col-sm-3 {\n    width: 25%;\n  }\n  .col-sm-2 {\n    width: 16.66666667%;\n  }\n  .col-sm-1 {\n    width: 8.33333333%;\n  }\n  .col-sm-pull-12 {\n    right: 100%;\n  }\n  .col-sm-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-sm-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-sm-pull-9 {\n    right: 75%;\n  }\n  .col-sm-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-sm-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-sm-pull-6 {\n    right: 50%;\n  }\n  .col-sm-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-sm-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-sm-pull-3 {\n    right: 25%;\n  }\n  .col-sm-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-sm-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-sm-pull-0 {\n    right: 0%;\n  }\n  .col-sm-push-12 {\n    left: 100%;\n  }\n  .col-sm-push-11 {\n    left: 91.66666667%;\n  }\n  .col-sm-push-10 {\n    left: 83.33333333%;\n  }\n  .col-sm-push-9 {\n    left: 75%;\n  }\n  .col-sm-push-8 {\n    left: 66.66666667%;\n  }\n  .col-sm-push-7 {\n    left: 58.33333333%;\n  }\n  .col-sm-push-6 {\n    left: 50%;\n  }\n  .col-sm-push-5 {\n    left: 41.66666667%;\n  }\n  .col-sm-push-4 {\n    left: 33.33333333%;\n  }\n  .col-sm-push-3 {\n    left: 25%;\n  }\n  .col-sm-push-2 {\n    left: 16.66666667%;\n  }\n  .col-sm-push-1 {\n    left: 8.33333333%;\n  }\n  .col-sm-push-0 {\n    left: 0%;\n  }\n  .col-sm-offset-12 {\n    margin-left: 100%;\n  }\n  .col-sm-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-sm-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-sm-offset-9 {\n    margin-left: 75%;\n  }\n  .col-sm-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-sm-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-sm-offset-6 {\n    margin-left: 50%;\n  }\n  .col-sm-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-sm-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-sm-offset-3 {\n    margin-left: 25%;\n  }\n  .col-sm-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-sm-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-sm-offset-0 {\n    margin-left: 0%;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    width: 950px;\n  }\n  .col-md-1,\n  .col-md-2,\n  .col-md-3,\n  .col-md-4,\n  .col-md-5,\n  .col-md-6,\n  .col-md-7,\n  .col-md-8,\n  .col-md-9,\n  .col-md-10,\n  .col-md-11 {\n    float: left;\n  }\n  .col-md-12 {\n    width: 100%;\n  }\n  .col-md-11 {\n    width: 91.66666667%;\n  }\n  .col-md-10 {\n    width: 83.33333333%;\n  }\n  .col-md-9 {\n    width: 75%;\n  }\n  .col-md-8 {\n    width: 66.66666667%;\n  }\n  .col-md-7 {\n    width: 58.33333333%;\n  }\n  .col-md-6 {\n    width: 50%;\n  }\n  .col-md-5 {\n    width: 41.66666667%;\n  }\n  .col-md-4 {\n    width: 33.33333333%;\n  }\n  .col-md-3 {\n    width: 25%;\n  }\n  .col-md-2 {\n    width: 16.66666667%;\n  }\n  .col-md-1 {\n    width: 8.33333333%;\n  }\n  .col-md-pull-12 {\n    right: 100%;\n  }\n  .col-md-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-md-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-md-pull-9 {\n    right: 75%;\n  }\n  .col-md-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-md-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-md-pull-6 {\n    right: 50%;\n  }\n  .col-md-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-md-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-md-pull-3 {\n    right: 25%;\n  }\n  .col-md-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-md-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-md-pull-0 {\n    right: 0%;\n  }\n  .col-md-push-12 {\n    left: 100%;\n  }\n  .col-md-push-11 {\n    left: 91.66666667%;\n  }\n  .col-md-push-10 {\n    left: 83.33333333%;\n  }\n  .col-md-push-9 {\n    left: 75%;\n  }\n  .col-md-push-8 {\n    left: 66.66666667%;\n  }\n  .col-md-push-7 {\n    left: 58.33333333%;\n  }\n  .col-md-push-6 {\n    left: 50%;\n  }\n  .col-md-push-5 {\n    left: 41.66666667%;\n  }\n  .col-md-push-4 {\n    left: 33.33333333%;\n  }\n  .col-md-push-3 {\n    left: 25%;\n  }\n  .col-md-push-2 {\n    left: 16.66666667%;\n  }\n  .col-md-push-1 {\n    left: 8.33333333%;\n  }\n  .col-md-push-0 {\n    left: 0%;\n  }\n  .col-md-offset-12 {\n    margin-left: 100%;\n  }\n  .col-md-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-md-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-md-offset-9 {\n    margin-left: 75%;\n  }\n  .col-md-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-md-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-md-offset-6 {\n    margin-left: 50%;\n  }\n  .col-md-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-md-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-md-offset-3 {\n    margin-left: 25%;\n  }\n  .col-md-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-md-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-md-offset-0 {\n    margin-left: 0%;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    width: 1150px;\n  }\n  .col-lg-1,\n  .col-lg-2,\n  .col-lg-3,\n  .col-lg-4,\n  .col-lg-5,\n  .col-lg-6,\n  .col-lg-7,\n  .col-lg-8,\n  .col-lg-9,\n  .col-lg-10,\n  .col-lg-11 {\n    float: left;\n  }\n  .col-lg-12 {\n    width: 100%;\n  }\n  .col-lg-11 {\n    width: 91.66666667%;\n  }\n  .col-lg-10 {\n    width: 83.33333333%;\n  }\n  .col-lg-9 {\n    width: 75%;\n  }\n  .col-lg-8 {\n    width: 66.66666667%;\n  }\n  .col-lg-7 {\n    width: 58.33333333%;\n  }\n  .col-lg-6 {\n    width: 50%;\n  }\n  .col-lg-5 {\n    width: 41.66666667%;\n  }\n  .col-lg-4 {\n    width: 33.33333333%;\n  }\n  .col-lg-3 {\n    width: 25%;\n  }\n  .col-lg-2 {\n    width: 16.66666667%;\n  }\n  .col-lg-1 {\n    width: 8.33333333%;\n  }\n  .col-lg-pull-12 {\n    right: 100%;\n  }\n  .col-lg-pull-11 {\n    right: 91.66666667%;\n  }\n  .col-lg-pull-10 {\n    right: 83.33333333%;\n  }\n  .col-lg-pull-9 {\n    right: 75%;\n  }\n  .col-lg-pull-8 {\n    right: 66.66666667%;\n  }\n  .col-lg-pull-7 {\n    right: 58.33333333%;\n  }\n  .col-lg-pull-6 {\n    right: 50%;\n  }\n  .col-lg-pull-5 {\n    right: 41.66666667%;\n  }\n  .col-lg-pull-4 {\n    right: 33.33333333%;\n  }\n  .col-lg-pull-3 {\n    right: 25%;\n  }\n  .col-lg-pull-2 {\n    right: 16.66666667%;\n  }\n  .col-lg-pull-1 {\n    right: 8.33333333%;\n  }\n  .col-lg-pull-0 {\n    right: 0%;\n  }\n  .col-lg-push-12 {\n    left: 100%;\n  }\n  .col-lg-push-11 {\n    left: 91.66666667%;\n  }\n  .col-lg-push-10 {\n    left: 83.33333333%;\n  }\n  .col-lg-push-9 {\n    left: 75%;\n  }\n  .col-lg-push-8 {\n    left: 66.66666667%;\n  }\n  .col-lg-push-7 {\n    left: 58.33333333%;\n  }\n  .col-lg-push-6 {\n    left: 50%;\n  }\n  .col-lg-push-5 {\n    left: 41.66666667%;\n  }\n  .col-lg-push-4 {\n    left: 33.33333333%;\n  }\n  .col-lg-push-3 {\n    left: 25%;\n  }\n  .col-lg-push-2 {\n    left: 16.66666667%;\n  }\n  .col-lg-push-1 {\n    left: 8.33333333%;\n  }\n  .col-lg-push-0 {\n    left: 0%;\n  }\n  .col-lg-offset-12 {\n    margin-left: 100%;\n  }\n  .col-lg-offset-11 {\n    margin-left: 91.66666667%;\n  }\n  .col-lg-offset-10 {\n    margin-left: 83.33333333%;\n  }\n  .col-lg-offset-9 {\n    margin-left: 75%;\n  }\n  .col-lg-offset-8 {\n    margin-left: 66.66666667%;\n  }\n  .col-lg-offset-7 {\n    margin-left: 58.33333333%;\n  }\n  .col-lg-offset-6 {\n    margin-left: 50%;\n  }\n  .col-lg-offset-5 {\n    margin-left: 41.66666667%;\n  }\n  .col-lg-offset-4 {\n    margin-left: 33.33333333%;\n  }\n  .col-lg-offset-3 {\n    margin-left: 25%;\n  }\n  .col-lg-offset-2 {\n    margin-left: 16.66666667%;\n  }\n  .col-lg-offset-1 {\n    margin-left: 8.33333333%;\n  }\n  .col-lg-offset-0 {\n    margin-left: 0%;\n  }\n}\ntable {\n  max-width: 100%;\n  background-color: transparent;\n}\nth {\n  text-align: left;\n}\n.table {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n.table > caption + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > th,\n.table > thead:first-child > tr:first-child > th,\n.table > caption + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > td,\n.table > thead:first-child > tr:first-child > td {\n  border-top: 0;\n}\n.table > tbody + tbody {\n  border-top: 2px solid #ddd;\n}\n.table .table {\n  background-color: #121212;\n}\n.table-condensed > thead > tr > th,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > tbody > tr > th,\n.table-bordered > tfoot > tr > th,\n.table-bordered > thead > tr > td,\n.table-bordered > tbody > tr > td,\n.table-bordered > tfoot > tr > td {\n  border: 1px solid #ddd;\n}\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n.table-striped > tbody > tr:nth-child(odd) > td,\n.table-striped > tbody > tr:nth-child(odd) > th {\n  background-color: #f9f9f9;\n}\n.table-hover > tbody > tr:hover > td,\n.table-hover > tbody > tr:hover > th {\n  background-color: #f5f5f5;\n}\ntable col[class*=\"col-\"] {\n  float: none;\n  display: table-column;\n}\ntable td[class*=\"col-\"],\ntable th[class*=\"col-\"] {\n  float: none;\n  display: table-cell;\n}\n.table > thead > tr > td.active,\n.table > tbody > tr > td.active,\n.table > tfoot > tr > td.active,\n.table > thead > tr > th.active,\n.table > tbody > tr > th.active,\n.table > tfoot > tr > th.active,\n.table > thead > tr.active > td,\n.table > tbody > tr.active > td,\n.table > tfoot > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr.active > th,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n.table > thead > tr > td.success,\n.table > tbody > tr > td.success,\n.table > tfoot > tr > td.success,\n.table > thead > tr > th.success,\n.table > tbody > tr > th.success,\n.table > tfoot > tr > th.success,\n.table > thead > tr.success > td,\n.table > tbody > tr.success > td,\n.table > tfoot > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr.success > th,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n.table > thead > tr > td.danger,\n.table > tbody > tr > td.danger,\n.table > tfoot > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > tbody > tr > th.danger,\n.table > tfoot > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > tbody > tr.danger > td,\n.table > tfoot > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n.table > thead > tr > td.warning,\n.table > tbody > tr > td.warning,\n.table > tfoot > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > tbody > tr > th.warning,\n.table > tfoot > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > tbody > tr.warning > td,\n.table > tfoot > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n@media (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    overflow-x: scroll;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive > .table {\n    margin-bottom: 0;\n  }\n  .table-responsive > .table > thead > tr > th,\n  .table-responsive > .table > tbody > tr > th,\n  .table-responsive > .table > tfoot > tr > th,\n  .table-responsive > .table > thead > tr > td,\n  .table-responsive > .table > tbody > tr > td,\n  .table-responsive > .table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n  .table-responsive > .table-bordered {\n    border: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n  }\n  .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n  }\n  .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n  .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n    border-bottom: 0;\n  }\n}\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\ninput[type=\"search\"] {\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  /* IE8-9 */\n  line-height: normal;\n}\ninput[type=\"file\"] {\n  display: block;\n}\nselect[multiple],\nselect[size] {\n  height: auto;\n}\nselect optgroup {\n  font-size: inherit;\n  font-style: inherit;\n  font-family: Roboto;\n}\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: thin dotted #333333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  height: auto;\n}\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #1E1E1E;\n  vertical-align: middle;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #1E1E1E;\n  vertical-align: middle;\n  background-color: rgba(35, 35, 35, 0.8);\n  background-image: none;\n  border: 1px solid #666666;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  -webkit-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;\n  -moz-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;\n  -o-transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;\n  transition: all border-color ease-in-out .15s, box-shadow ease-in-out .15s ease-out;\n}\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n}\n.form-control:-moz-placeholder {\n  color: #6D6D6D;\n}\n.form-control::-moz-placeholder {\n  color: #6D6D6D;\n}\n.form-control:-ms-input-placeholder {\n  color: #6D6D6D;\n}\n.form-control::-webkit-input-placeholder {\n  color: #6D6D6D;\n}\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n  background-color: #333333;\n}\ntextarea.form-control {\n  height: auto;\n}\n.form-group {\n  margin-bottom: 15px;\n}\n.radio,\n.checkbox {\n  display: block;\n  min-height: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-left: 20px;\n  vertical-align: middle;\n}\n.radio label,\n.checkbox label {\n  display: inline;\n  margin-bottom: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  float: left;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n.radio-inline,\n.checkbox-inline {\n  display: inline-block;\n  padding-left: 23px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n}\ninput[type=\"radio\"][disabled],\ninput[type=\"checkbox\"][disabled],\n.radio[disabled],\n.radio-inline[disabled],\n.checkbox[disabled],\n.checkbox-inline[disabled],\nfieldset[disabled] input[type=\"radio\"],\nfieldset[disabled] input[type=\"checkbox\"],\nfieldset[disabled] .radio,\nfieldset[disabled] .radio-inline,\nfieldset[disabled] .checkbox,\nfieldset[disabled] .checkbox-inline {\n  cursor: not-allowed;\n}\n.input-sm {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px;\n}\nselect.input-sm {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-sm {\n  height: auto;\n}\n.input-lg {\n  height: 45px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 6px;\n}\nselect.input-lg {\n  height: 45px;\n  line-height: 45px;\n}\ntextarea.input-lg {\n  height: auto;\n}\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline {\n  color: #c09853;\n}\n.has-warning .form-control {\n  border-color: #fcf8e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-warning .form-control:focus {\n  border-color: #f7ecb5;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n}\n.has-warning .input-group-addon {\n  color: #c09853;\n  border-color: #fcf8e3;\n  background-color: #f5f5f5;\n}\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline {\n  color: #6D6D6D;\n}\n.has-error .form-control {\n  border-color: #f2dede;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-error .form-control:focus {\n  border-color: #e4b9b9;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n}\n.has-error .input-group-addon {\n  color: #6D6D6D;\n  border-color: #f2dede;\n  background-color: #f5f5f5;\n}\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline {\n  color: #468847;\n}\n.has-success .form-control {\n  border-color: #dff0d8;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.has-success .form-control:focus {\n  border-color: #c1e2b3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n}\n.has-success .input-group-addon {\n  color: #468847;\n  border-color: #dff0d8;\n  background-color: #f5f5f5;\n}\n.form-control-static {\n  margin-bottom: 0;\n}\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #ffffff;\n  font-style: italic;\n  font-size: 12px;\n}\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n  }\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0;\n  }\n  .form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    float: none;\n    margin-left: 0;\n  }\n}\n.form-horizontal .control-label,\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 7px;\n}\n.form-horizontal .form-group {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.form-horizontal .form-group:after {\n  clear: both;\n}\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.form-horizontal .form-group:after {\n  clear: both;\n}\n.form-horizontal .form-control-static {\n  padding-top: 7px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    text-align: right;\n  }\n}\n.btn,\n.nav li a.btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  border-radius: 4px;\n  -o-user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.btn:focus,\n.nav li a.btn:focus {\n  outline: thin dotted #333333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n.btn:hover,\n.nav li a.btn:hover,\n.btn:focus,\n.nav li a.btn:focus {\n  color: #FFF;\n  text-decoration: none;\n}\n.btn:active,\n.nav li a.btn:active,\n.btn.active,\n.nav li a.btn.active {\n  outline: 0;\n  background-image: none;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn.disabled,\n.nav li a.btn.disabled,\n.btn[disabled],\n.nav li a.btn[disabled],\nfieldset[disabled] .btn,\nfieldset[disabled] .nav li a.btn {\n  cursor: not-allowed;\n  pointer-events: none;\n  -moz-opacity: 0.65;\n  -khtml-opacity: 0.65;\n  -webkit-opacity: 0.65;\n  opacity: 0.65;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=65);\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  color: white!important;\n}\n.nav li a.btn-default {\n  color: #FFF;\n  background-color: transparent;\n  border-color: #f1f1f1;\n}\n.nav li a.btn-default:hover,\n.nav li a.btn-default:focus,\n.nav li a.btn-default:active,\n.nav li a.btn-default.active,\n.open .dropdown-toggle.nav li a.btn-default {\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #d2d2d2;\n}\n.nav li a.btn-default:active,\n.nav li a.btn-default.active,\n.open .dropdown-toggle.nav li a.btn-default {\n  background-image: none;\n}\n.nav li a.btn-default.disabled,\n.nav li a.btn-default[disabled],\nfieldset[disabled] .nav li a.btn-default,\n.nav li a.btn-default.disabled:hover,\n.nav li a.btn-default[disabled]:hover,\nfieldset[disabled] .nav li a.btn-default:hover,\n.nav li a.btn-default.disabled:focus,\n.nav li a.btn-default[disabled]:focus,\nfieldset[disabled] .nav li a.btn-default:focus,\n.nav li a.btn-default.disabled:active,\n.nav li a.btn-default[disabled]:active,\nfieldset[disabled] .nav li a.btn-default:active,\n.nav li a.btn-default.disabled.active,\n.nav li a.btn-default[disabled].active,\nfieldset[disabled] .nav li a.btn-default.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.nav li a.btn-default:hover,\n.nav li a.btn-default:focus,\n.nav li a.btn-default:active,\n.nav li a.btn-default.active,\n.open .dropdown-toggle.nav li a.btn-default {\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: #989898;\n}\n.btn-default {\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #f1f1f1;\n}\n.btn-default:hover,\n.btn-default:focus,\n.btn-default:active,\n.btn-default.active,\n.open .dropdown-toggle.btn-default {\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #d2d2d2;\n}\n.btn-default:active,\n.btn-default.active,\n.open .dropdown-toggle.btn-default {\n  background-image: none;\n}\n.btn-default.disabled,\n.btn-default[disabled],\nfieldset[disabled] .btn-default,\n.btn-default.disabled:hover,\n.btn-default[disabled]:hover,\nfieldset[disabled] .btn-default:hover,\n.btn-default.disabled:focus,\n.btn-default[disabled]:focus,\nfieldset[disabled] .btn-default:focus,\n.btn-default.disabled:active,\n.btn-default[disabled]:active,\nfieldset[disabled] .btn-default:active,\n.btn-default.disabled.active,\n.btn-default[disabled].active,\nfieldset[disabled] .btn-default.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-default:hover,\n.btn-default:focus,\n.btn-default:active,\n.btn-default.active,\n.open .dropdown-toggle.btn-default {\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #989898;\n}\n.btn-primary {\n  color: #0c0c0c;\n  background-color: #f1f1f1;\n  border-color: #f1f1f1;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  color: #0c0c0c;\n  background-color: #dddddd;\n  border-color: #d2d2d2;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  background-image: none;\n}\n.btn-primary.disabled,\n.btn-primary[disabled],\nfieldset[disabled] .btn-primary,\n.btn-primary.disabled:hover,\n.btn-primary[disabled]:hover,\nfieldset[disabled] .btn-primary:hover,\n.btn-primary.disabled:focus,\n.btn-primary[disabled]:focus,\nfieldset[disabled] .btn-primary:focus,\n.btn-primary.disabled:active,\n.btn-primary[disabled]:active,\nfieldset[disabled] .btn-primary:active,\n.btn-primary.disabled.active,\n.btn-primary[disabled].active,\nfieldset[disabled] .btn-primary.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  color: #0c0c0c;\n  background-color: #a4a4a4;\n  border-color: #989898;\n}\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.open .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #ed9c28;\n  border-color: #d58512;\n}\n.btn-warning:active,\n.btn-warning.active,\n.open .dropdown-toggle.btn-warning {\n  background-image: none;\n}\n.btn-warning.disabled,\n.btn-warning[disabled],\nfieldset[disabled] .btn-warning,\n.btn-warning.disabled:hover,\n.btn-warning[disabled]:hover,\nfieldset[disabled] .btn-warning:hover,\n.btn-warning.disabled:focus,\n.btn-warning[disabled]:focus,\nfieldset[disabled] .btn-warning:focus,\n.btn-warning.disabled:active,\n.btn-warning[disabled]:active,\nfieldset[disabled] .btn-warning:active,\n.btn-warning.disabled.active,\n.btn-warning[disabled].active,\nfieldset[disabled] .btn-warning.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active,\n.open .dropdown-toggle.btn-warning {\n  color: #fff;\n  background-color: #985f0d;\n  border-color: #694109;\n}\n.btn-danger {\n  color: #fff;\n  background-color: #FFF;\n  border-color: #f2f2f2;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #ebebeb;\n  border-color: #d4d4d4;\n}\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  background-image: none;\n}\n.btn-danger.disabled,\n.btn-danger[disabled],\nfieldset[disabled] .btn-danger,\n.btn-danger.disabled:hover,\n.btn-danger[disabled]:hover,\nfieldset[disabled] .btn-danger:hover,\n.btn-danger.disabled:focus,\n.btn-danger[disabled]:focus,\nfieldset[disabled] .btn-danger:focus,\n.btn-danger.disabled:active,\n.btn-danger[disabled]:active,\nfieldset[disabled] .btn-danger:active,\n.btn-danger.disabled.active,\n.btn-danger[disabled].active,\nfieldset[disabled] .btn-danger.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active,\n.open .dropdown-toggle.btn-danger {\n  color: #fff;\n  background-color: #b3b3b3;\n  border-color: #999999;\n}\n.btn-success {\n  color: #fff;\n  background-color: #FFF;\n  border-color: #f2f2f2;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #ebebeb;\n  border-color: #d4d4d4;\n}\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  background-image: none;\n}\n.btn-success.disabled,\n.btn-success[disabled],\nfieldset[disabled] .btn-success,\n.btn-success.disabled:hover,\n.btn-success[disabled]:hover,\nfieldset[disabled] .btn-success:hover,\n.btn-success.disabled:focus,\n.btn-success[disabled]:focus,\nfieldset[disabled] .btn-success:focus,\n.btn-success.disabled:active,\n.btn-success[disabled]:active,\nfieldset[disabled] .btn-success:active,\n.btn-success.disabled.active,\n.btn-success[disabled].active,\nfieldset[disabled] .btn-success.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active,\n.open .dropdown-toggle.btn-success {\n  color: #fff;\n  background-color: #b3b3b3;\n  border-color: #999999;\n}\n.btn-info {\n  color: #fff;\n  background-color: #999999;\n  border-color: #8c8c8c;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #858585;\n  border-color: #6e6e6e;\n}\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  background-image: none;\n}\n.btn-info.disabled,\n.btn-info[disabled],\nfieldset[disabled] .btn-info,\n.btn-info.disabled:hover,\n.btn-info[disabled]:hover,\nfieldset[disabled] .btn-info:hover,\n.btn-info.disabled:focus,\n.btn-info[disabled]:focus,\nfieldset[disabled] .btn-info:focus,\n.btn-info.disabled:active,\n.btn-info[disabled]:active,\nfieldset[disabled] .btn-info:active,\n.btn-info.disabled.active,\n.btn-info[disabled].active,\nfieldset[disabled] .btn-info.active {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #FFFFFF;\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active,\n.open .dropdown-toggle.btn-info {\n  color: #fff;\n  background-color: #4d4d4d;\n  border-color: #333333;\n}\n.btn-link {\n  color: #999999;\n  font-weight: normal;\n  cursor: pointer;\n  border-radius: 0;\n}\n.btn-link,\n.btn-link:active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n.btn-link:hover,\n.btn-link:focus {\n  color: #737373;\n  text-decoration: underline;\n  background-color: transparent;\n}\n.btn-link[disabled]:hover,\nfieldset[disabled] .btn-link:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:focus {\n  color: #999999;\n  text-decoration: none;\n}\n.btn-lg {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 4px;\n}\n.btn-sm,\n.btn-xs {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px;\n}\n.btn-xs {\n  padding: 1px 5px;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n}\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n/* Object Button with states */\n@keyframes button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.o-button {\n  cursor: pointer;\n  display: inline-block;\n  min-height: 1em;\n  outline: none;\n  border: 1px solid #f1f1f1;\n  background: #f1f1f1 none;\n  border-radius: 4px;\n  color: #0c0c0c;\n  font-family: Roboto;\n  margin: 0em 0.25em 0em 0em;\n  padding: 6px 12px;\n  text-transform: none;\n  text-shadow: none;\n  line-height: 1.42857143;\n  font-style: normal;\n  text-align: center;\n  text-decoration: none;\n  user-select: none;\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;\n  will-change: \"\";\n}\n.o-button:hover {\n  background-color: #a4a4a4;\n  border-color: #989898;\n}\n.o-button--right {\n  float: right;\n}\n.o-button--fluid {\n  display: block;\n  width: 100%;\n}\n.o-button--basic {\n  background: rgba(0, 0, 0, 0.2);\n  border-color: #f1f1f1;\n  color: #FFF;\n}\n.o-button--basic:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-color: #989898;\n}\n.o-button--loading {\n  position: relative;\n  cursor: default;\n  text-shadow: none !important;\n  color: transparent !important;\n  opacity: 1;\n  pointer-events: none !important;\n  transition: all 0s linear, opacity 0.1s ease;\n}\n.o-button--loading:before,\n.o-button--loading:after {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -0.64285714em 0em 0em -0.64285714em;\n  width: 1.28571429em;\n  height: 1.28571429em;\n  border-radius: 500rem;\n}\n.o-button--loading:before {\n  border: 0.2em solid rgba(0, 0, 0, 0.15);\n}\n.o-button--loading:after {\n  animation: button-spin 0.6s linear;\n  animation-iteration-count: infinite;\n  border-color: #ffffff transparent transparent;\n  border-style: solid;\n  border-width: 0.2em;\n  box-shadow: 0px 0px 0px 1px transparent;\n}\n.o-button--disabled,\n.o-button--disabled:hover {\n  cursor: default;\n  opacity: 0.75 !important;\n  background-image: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n}\n.o-button--touchable:hover {\n  background-color: #f1f1f1;\n  border-color: #f1f1f1;\n}\n/* GLOBAL STYLES\n-------------------------------------------------- */\n/* Padding below the footer and lighter body text */\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n  -webkit-transition: all opacity 0.15s linear ease-out;\n  -moz-transition: all opacity 0.15s linear ease-out;\n  -o-transition: all opacity 0.15s linear ease-out;\n  transition: all opacity 0.15s linear ease-out;\n}\n.fade.in {\n  opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.in {\n  display: block;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height 0.35s ease;\n  transition: height 0.35s ease;\n  -webkit-transition: all height 0.35s ease ease-out;\n  -moz-transition: all height 0.35s ease ease-out;\n  -o-transition: all height 0.35s ease ease-out;\n  transition: all height 0.35s ease ease-out;\n}\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 10px;\n  vertical-align: middle;\n  border-top: 7px solid #000;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  border-bottom: 0 dotted;\n}\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: -60px;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 0;\n  list-style: none;\n  font-size: 14px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n.dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n.dropdown-menu .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.dropdown-menu > li > a {\n  display: block;\n  padding: 0 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333333;\n  white-space: nowrap;\n}\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: #737373;\n  text-decoration: none;\n  outline: 0;\n  background-color: #FFF;\n}\n.dropdown-menu > .disabled > a,\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  color: #999999;\n}\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n  cursor: not-allowed;\n}\n.open > .dropdown-menu {\n  display: block;\n}\n.open > a {\n  outline: 0;\n}\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #999999;\n}\n.dropdown-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 990;\n}\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  border-top: 0 dotted;\n  border-bottom: 4px solid #000;\n  content: \"\";\n}\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 1px;\n}\n@media (min-width: 768px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n  }\n}\n@media screen and (max-width: 917px) {\n  .dropdown-menu {\n    right: -16px;\n    left: auto;\n    overflow: auto;\n  }\n}\n.btn-default .caret {\n  border-top-color: #FFF;\n}\n.btn-primary .caret,\n.btn-success .caret,\n.btn-warning .caret,\n.btn-danger .caret,\n.btn-info .caret {\n  border-top-color: #fff;\n}\n.dropup .btn-default .caret {\n  border-bottom-color: #FFF;\n}\n.dropup .btn-primary .caret,\n.dropup .btn-success .caret,\n.dropup .btn-warning .caret,\n.dropup .btn-danger .caret,\n.dropup .btn-info .caret {\n  border-bottom-color: #fff;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  float: left;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group-vertical > .btn:focus,\n.btn-group > .btn:active,\n.btn-group-vertical > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn.active {\n  z-index: 2;\n}\n.btn-group > .btn:focus,\n.btn-group-vertical > .btn:focus {\n  outline: none;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n.btn-toolbar:before,\n.btn-toolbar:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.btn-toolbar:after {\n  clear: both;\n}\n.btn-toolbar:before,\n.btn-toolbar:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.btn-toolbar:after {\n  clear: both;\n}\n.btn-toolbar .btn-group {\n  float: left;\n}\n.btn-toolbar > .btn + .btn,\n.btn-toolbar > .btn-group + .btn,\n.btn-toolbar > .btn + .btn-group,\n.btn-toolbar > .btn-group + .btn-group {\n  margin-left: 5px;\n}\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child > .btn:last-child,\n.btn-group > .btn-group:first-child > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.btn-group > .btn-group:last-child > .btn:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n.btn-group-xs > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px;\n  padding: 1px 5px;\n}\n.btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px;\n}\n.btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 4px;\n}\n.btn-group > .btn + .dropdown-toggle {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.open .dropdown-toggle.btn-link {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n}\n.btn .caret {\n  margin-left: 0;\n}\n.btn-lg .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n.dropup .btn-lg .caret {\n  border-width: 0 5px 5px;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.btn-group-vertical > .btn-group:after {\n  clear: both;\n}\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.btn-group-vertical > .btn-group:after {\n  clear: both;\n}\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-bottom-left-radius: 4px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn-group:last-child > .btn:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n.btn-group-justified .btn {\n  float: none;\n  display: table-cell;\n  width: 1%;\n}\n[data-toggle=\"buttons\"] > .btn > input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn > input[type=\"checkbox\"] {\n  display: none;\n}\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n.input-group.col {\n  float: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n.input-group .form-control {\n  width: 100%;\n  margin-bottom: 0;\n}\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 45px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n  border-radius: 6px;\n}\nselect.input-group-lg > .form-control,\nselect.input-group-lg > .input-group-addon,\nselect.input-group-lg > .input-group-btn > .btn {\n  height: 45px;\n  line-height: 45px;\n}\ntextarea.input-group-lg > .form-control,\ntextarea.input-group-lg > .input-group-addon,\ntextarea.input-group-lg > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 2px;\n}\nselect.input-group-sm > .form-control,\nselect.input-group-sm > .input-group-addon,\nselect.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  line-height: 30px;\n}\ntextarea.input-group-sm > .form-control,\ntextarea.input-group-sm > .input-group-addon,\ntextarea.input-group-sm > .input-group-btn > .btn {\n  height: auto;\n}\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n.input-group-addon:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child),\n.input-group .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #1E1E1E;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px solid #666666;\n  border-left: none;\n  border-radius: 4px;\n}\n.input-group-addon.input-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 2px;\n}\n.input-group-addon.input-lg {\n  padding: 10px 16px;\n  font-size: 18px;\n  border-radius: 6px;\n}\n.input-group-addon input[type=\"radio\"],\n.input-group-addon input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n.input-group-btn {\n  position: relative;\n  white-space: nowrap;\n}\n.input-group-btn:first-child > .btn {\n  margin-right: -1px;\n}\n.input-group-btn:last-child > .btn {\n  margin-left: -1px;\n}\n.input-group-btn > .btn {\n  position: relative;\n}\n.input-group-btn > .btn + .btn {\n  margin-left: -4px;\n}\n.input-group-btn > .btn:hover,\n.input-group-btn > .btn:active {\n  z-index: 2;\n}\n.nav {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n  /*.open > a {\n    &,\n    &:hover,\n    &:focus {\n      background-color: @nav-link-hover-bg;\n      border-color: @link-color;\n\n      .caret {\n        border-top-color: @link-hover-color;\n        border-bottom-color: @link-hover-color;\n      }\n    }\n  }*/\n}\n.nav:before,\n.nav:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.nav:after {\n  clear: both;\n}\n.nav:before,\n.nav:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.nav:after {\n  clear: both;\n}\n.nav > li {\n  position: relative;\n  display: block;\n}\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 7px 15px;\n  font-family: \"Roboto\";\n  font-size: 18px;\n  font-weight: lighter;\n}\n.nav > li > a:hover,\n.nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n.nav > li.disabled > a {\n  color: #999999;\n}\n.nav > li.disabled > a:hover,\n.nav > li.disabled > a:focus {\n  color: #999999;\n  text-decoration: none;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n.nav .nav-divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.nav > li > a > img {\n  max-width: none;\n}\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n.nav-tabs > li {\n  float: left;\n  margin-bottom: -1px;\n}\n.nav-tabs > li > a {\n  margin-right: 2px;\n  line-height: 1.42857143;\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n.nav-tabs > li > a:hover {\n  border-color: #eeeeee #eeeeee #ddd;\n}\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n  color: #555555;\n  background-color: #121212;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n  cursor: default;\n}\n.nav-tabs.nav-justified {\n  width: 100%;\n  border-bottom: 0;\n}\n.nav-tabs.nav-justified > li {\n  float: none;\n}\n.nav-tabs.nav-justified > li > a {\n  text-align: center;\n  margin-bottom: 5px;\n}\n.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-tabs.nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs.nav-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs.nav-justified > .active > a,\n.nav-tabs.nav-justified > .active > a:hover,\n.nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs.nav-justified > .active > a,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: #121212;\n  }\n}\n.nav-pills > li {\n  float: left;\n}\n.nav-pills > li > a {\n  border-radius: 4px;\n  font-size: 13px;\n}\n.nav-pills > li + li {\n  margin-left: 2px;\n}\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #737373;\n  background-color: #FFF;\n}\n.nav-pills > li.active > a .caret,\n.nav-pills > li.active > a:hover .caret,\n.nav-pills > li.active > a:focus .caret {\n  border-top-color: #737373;\n  border-bottom-color: #737373;\n}\n.nav-pills > li.active > a.btn:hover,\n.nav-pills > li.active > a.btn:focus {\n  /* background-color: #d01f14; */\n  /* border-color: #be1c12;*/\n}\n.nav-stacked > li {\n  float: none;\n}\n.nav-stacked > li + li {\n  margin-top: 2px;\n  margin-left: 0;\n}\n.nav-justified {\n  width: 100%;\n}\n.nav-justified > li {\n  float: none;\n}\n.nav-justified > li > a {\n  text-align: center;\n  margin-bottom: 5px;\n}\n.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n@media (min-width: 768px) {\n  .nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n  .nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n.nav-tabs-justified {\n  border-bottom: 0;\n}\n.nav-tabs-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n.nav-tabs-justified > .active > a,\n.nav-tabs-justified > .active > a:hover,\n.nav-tabs-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n  .nav-tabs-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus {\n    border-bottom-color: #121212;\n  }\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.nav .caret {\n  border-top-color: #999999;\n  border-bottom-color: #999999;\n}\n.nav a:hover .caret {\n  border-top-color: #737373;\n  border-bottom-color: #737373;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n@media (min-width: 768px) {\n  .nav .open > li > a.menu_user {\n    background-color: transparent !important;\n  }\n}\n.menu_user-on-hover > li > a,\n.menu_user-on-hover > li > a:hover,\n.menu_user-on-hover > li > a:focus {\n  background-color: #333333;\n}\n@media (min-width: 768px) {\n  .menu_user-on-hover > li > a,\n  .menu_user-on-hover > li > a:hover,\n  .menu_user-on-hover > li > a:focus {\n    background-color: transparent;\n  }\n}\n@media (max-width: 821px) {\n  .buscar {\n    width: 185px !important;\n  }\n}\n.navbar {\n  position: relative;\n  min-height: 50px;\n  border: 1px solid transparent;\n}\n.navbar:before,\n.navbar:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar:after {\n  clear: both;\n}\n.navbar:before,\n.navbar:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar:after {\n  clear: both;\n}\n@media (min-width: 768px) {\n  .navbar {\n    border-radius: 6px;\n  }\n}\n.navbar-header:before,\n.navbar-header:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar-header:after {\n  clear: both;\n}\n.navbar-header:before,\n.navbar-header:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar-header:after {\n  clear: both;\n}\n@media (min-width: 768px) {\n  .navbar-header {\n    float: left;\n  }\n}\n.navbar-collapse {\n  overflow-x: visible;\n  padding-right: 15px;\n  padding-left: 15px;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  -webkit-overflow-scrolling: touch;\n}\n.navbar-collapse:before,\n.navbar-collapse:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar-collapse:after {\n  clear: both;\n}\n.navbar-collapse:before,\n.navbar-collapse:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.navbar-collapse:after {\n  clear: both;\n}\n.navbar-collapse.in {\n  overflow-y: auto;\n}\n@media (min-width: 768px) {\n  .navbar-collapse {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n  }\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .navbar-collapse.in {\n    overflow-y: auto;\n  }\n  .navbar-collapse .navbar-nav.navbar-left:first-child {\n    margin-left: -15px;\n  }\n  .navbar-collapse .navbar-nav.navbar-right:last-child {\n    margin-right: -15px;\n  }\n  .navbar-collapse .navbar-text:last-child {\n    margin-right: 0;\n  }\n}\n.container > .navbar-header,\n.container > .navbar-collapse {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  .container > .navbar-header,\n  .container > .navbar-collapse {\n    margin-right: 0;\n    margin-left: 0;\n    display: none;\n  }\n}\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n@media (min-width: 768px) {\n  .navbar-static-top {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n@media (min-width: 768px) {\n  .navbar-fixed-top,\n  .navbar-fixed-bottom {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n.navbar-brand {\n  float: left;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n}\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n@media (min-width: 768px) {\n  .navbar > .container .navbar-brand {\n    margin-left: -15px;\n  }\n}\nbutton#buscadorXsButton {\n  text-overflow: clip !important;\n}\n.navbar-toggle {\n  position: relative;\n  float: right;\n  margin-right: 15px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  top: -5px;\n}\n.navbar-toggle .icon-bar {\n  margin-top: 14px;\n  margin-left: 27px;\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n  background-color: #FFF !important;\n}\n.navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n@media (min-width: 768px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n#menu360.responsive ul li:nth-child(1),\n#menu360.responsive ul li:nth-child(2) {\n  display: inline-block;\n}\n#menu360.responsive ul li:nth-child(2) a {\n  padding-left: 0px;\n}\n#menu360.responsive ul li:not(:nth-child(1)):not(:nth-child(2)) {\n  display: none;\n}\n#menu360.responsive ul li {\n  float: none !important;\n}\n#menu360 .container {\n  width: 100%;\n}\n.navMenu--user {\n  top: auto !important;\n}\n#menu360 {\n  background-color: #303030 !important;\n  vertical-align: middle !important;\n  border: none !important;\n  font-family: Roboto !important;\n  color: #ffffff !important;\n}\n#menu360 ul li a {\n  color: #fff !important;\n}\n#menu360:not(.responsive) ul {\n  margin: 0 auto !important;\n  display: table !important;\n  vertical-align: middle;\n  float: none !important;\n}\n#menu360 ul li:nth-child(2) {\n  display: none;\n  width: 24px !important;\n  height: 24px !important;\n}\n#menu360 ul li:not(:nth-child(1)):not(:nth-child(2)) {\n  margin-top: 5px;\n}\n.navbar-nav {\n  margin: 5px 0px -4px -2px;\n}\n.navbar-nav > li > a {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 20px;\n}\n.navbar-nav .nav-item {\n  color: #cccccc;\n}\n.navbar-nav .nav-item:hover {\n  color: #FFF;\n}\n.navbar-nav .nav-item--active {\n  box-shadow: 0 -3px 0 #FFF inset !important;\n}\n.navbar-nav .nav-item--active > a > span {\n  color: #FFF;\n  font-weight: bolder;\n}\n@media (max-width: 767px) {\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    box-shadow: none;\n  }\n  .navbar-nav .open .dropdown-menu > li > a,\n  .navbar-nav .open .dropdown-menu .dropdown-header {\n    padding: 5px 15px 5px 25px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a {\n    line-height: 20px;\n  }\n  .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-nav .open .dropdown-menu > li > a:focus {\n    background-image: none;\n  }\n  .navbar-nav .nav-item {\n    margin: -1px;\n    border-bottom: 3px solid #333333;\n  }\n  .navbar-nav.menu_user-top-margin.menu-anonymous {\n    margin-top: 0 !important;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n  .navbar-nav > li {\n    float: left;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-left {\n    float: left !important;\n    float: left;\n  }\n  .navbar-right {\n    float: right !important;\n    float: right;\n  }\n}\n.navbar-form {\n  margin-left: -15px;\n  margin-right: -15px;\n  padding: 10px 15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n@media (min-width: 1200px) {\n  .navbar-form {\n    margin-top: 6px;\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n  .navbar-form .form-control {\n    display: inline-block;\n  }\n  .navbar-form .radio,\n  .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0;\n  }\n  .navbar-form .radio input[type=\"radio\"],\n  .navbar-form .checkbox input[type=\"checkbox\"] {\n    float: none;\n    margin-left: 0;\n  }\n}\n@media (max-width: 767px) {\n  .navbar-form .form-group {\n    margin-bottom: 5px;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-form {\n    width: auto;\n    border: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n  }\n}\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.navbar-nav.pull-right > li > .dropdown-menu,\n.navbar-nav > li > .dropdown-menu.pull-right {\n  left: auto;\n  right: 0;\n}\n.navbar-btn {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.navbar-text {\n  float: left;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n  .navbar-text {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n}\n.navbar-text2 {\n  float: left;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n@media (min-width: 768px) {\n  .navbar-text2 {\n    margin-left: 15px;\n    margin-right: 15px;\n    margin-top: 8px !important;\n  }\n}\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-brand {\n  color: #777;\n}\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #5e5e5e;\n  background-color: transparent;\n}\n.navbar-default .navbar-text {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a {\n  color: #777;\n}\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #333;\n  background-color: transparent;\n}\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .disabled > a,\n.navbar-default .navbar-nav > .disabled > a:hover,\n.navbar-default .navbar-nav > .disabled > a:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n.navbar-default .navbar-toggle {\n  border-color: #ddd;\n}\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #ddd;\n}\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #ccc;\n}\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: #e7e7e7;\n}\n.navbar-default .navbar-nav > .dropdown > a:hover .caret,\n.navbar-default .navbar-nav > .dropdown > a:focus .caret {\n  border-top-color: #333;\n  border-bottom-color: #333;\n}\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  background-color: #e7e7e7;\n  color: #555;\n}\n.navbar-default .navbar-nav > .open > a .caret,\n.navbar-default .navbar-nav > .open > a:hover .caret,\n.navbar-default .navbar-nav > .open > a:focus .caret {\n  border-top-color: #555;\n  border-bottom-color: #555;\n}\n.navbar-default .navbar-nav > .dropdown > a .caret {\n  border-top-color: #777;\n  border-bottom-color: #777;\n}\n@media (max-width: 767px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #777;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #333;\n    background-color: transparent;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n.navbar-default .navbar-link {\n  color: #777;\n}\n.navbar-default .navbar-link:hover {\n  color: #333;\n}\n.navbar-inverse {\n  background-color: #222;\n  border-color: #080808;\n}\n.navbar-inverse .navbar-brand {\n  color: #999999;\n}\n.navbar-inverse .navbar-brand:hover,\n.navbar-inverse .navbar-brand:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-text {\n  color: #999999;\n}\n.navbar-inverse .navbar-nav > li > a {\n  color: #999999;\n}\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .navbar-nav > li > a:focus {\n  color: #fff;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a:focus {\n  color: #fff;\n  background-color: #080808;\n}\n.navbar-inverse .navbar-nav > .disabled > a,\n.navbar-inverse .navbar-nav > .disabled > a:hover,\n.navbar-inverse .navbar-nav > .disabled > a:focus {\n  color: #444;\n  background-color: transparent;\n}\n.navbar-inverse .navbar-toggle {\n  border-color: #333;\n}\n.navbar-inverse .navbar-toggle:hover,\n.navbar-inverse .navbar-toggle:focus {\n  background-color: #333;\n}\n.navbar-inverse .navbar-toggle .icon-bar {\n  background-color: #fff;\n}\n.navbar-inverse .navbar-collapse,\n.navbar-inverse .navbar-form {\n  border-color: #101010;\n}\n.navbar-inverse .navbar-nav > .open > a,\n.navbar-inverse .navbar-nav > .open > a:hover,\n.navbar-inverse .navbar-nav > .open > a:focus {\n  background-color: #080808;\n  color: #fff;\n}\n.navbar-inverse .navbar-nav > .dropdown > a:hover .caret {\n  border-top-color: #fff;\n  border-bottom-color: #fff;\n}\n.navbar-inverse .navbar-nav > .dropdown > a .caret {\n  border-top-color: #999999;\n  border-bottom-color: #999999;\n}\n.navbar-inverse .navbar-nav > .open > a .caret,\n.navbar-inverse .navbar-nav > .open > a:hover .caret,\n.navbar-inverse .navbar-nav > .open > a:focus .caret {\n  border-top-color: #fff;\n  border-bottom-color: #fff;\n}\n@media (max-width: 767px) {\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n    border-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n    color: #999999;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #fff;\n    background-color: #080808;\n  }\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n.navbar-inverse .navbar-link {\n  color: #999999;\n}\n.navbar-inverse .navbar-link:hover {\n  color: #fff;\n}\na.dropdown-toggle.dropdownUser {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n@media only screen and (max-width: 768px) {\n  a.dropdown-toggle.dropdownUser {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n.navbar-nav > li.no-highlight > .dropdown-menu {\n  width: auto;\n  min-width: auto;\n}\n.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div {\n  border: none;\n  min-height: auto;\n}\n.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div:last-of-type {\n  background: none;\n  margin-top: -7px;\n}\n.navbar-nav > li.no-highlight > .dropdown-menu .menuItem--div > li {\n  padding: 12px 0px;\n}\n.navbar-nav span.nav-image {\n  margin-top: -5px;\n  display: block;\n}\n.navbar-nav .section-nav img.nav-icon {\n  padding: 0px 5px;\n  width: 30px;\n}\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n.breadcrumb > li {\n  display: inline-block;\n}\n.breadcrumb > li + li:before {\n  content: \"/\\00a0\";\n  padding: 0 5px;\n  color: #ccc;\n}\n.breadcrumb > .active {\n  color: #999999;\n}\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n.pagination > li {\n  display: inline;\n}\n.pagination > li > a,\n.pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  line-height: 1.42857143;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  margin-left: -1px;\n}\n.pagination > li:first-child > a,\n.pagination > li:first-child > span {\n  margin-left: 0;\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n.pagination > li:last-child > a,\n.pagination > li:last-child > span {\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.pagination > li > a:hover,\n.pagination > li > span:hover,\n.pagination > li > a:focus,\n.pagination > li > span:focus {\n  background-color: #eeeeee;\n}\n.pagination > .active > a,\n.pagination > .active > span,\n.pagination > .active > a:hover,\n.pagination > .active > span:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #FFF;\n  border-color: #FFF;\n  cursor: default;\n}\n.pagination > .disabled > span,\n.pagination > .disabled > span:hover,\n.pagination > .disabled > span:focus,\n.pagination > .disabled > a,\n.pagination > .disabled > a:hover,\n.pagination > .disabled > a:focus {\n  color: #999999;\n  background-color: #fff;\n  border-color: #ddd;\n  cursor: not-allowed;\n}\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px;\n}\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-bottom-left-radius: 6px;\n  border-top-left-radius: 6px;\n}\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-bottom-right-radius: 6px;\n  border-top-right-radius: 6px;\n}\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n}\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n}\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n}\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  list-style: none;\n  text-align: center;\n}\n.pager:before,\n.pager:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.pager:after {\n  clear: both;\n}\n.pager:before,\n.pager:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.pager:after {\n  clear: both;\n}\n.pager li {\n  display: inline;\n}\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n.pager li > a:hover,\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n.pager .next > a,\n.pager .next > span {\n  float: right;\n}\n.pager .previous > a,\n.pager .previous > span {\n  float: left;\n}\n.pager .disabled > a,\n.pager .disabled > a:hover,\n.pager .disabled > a:focus,\n.pager .disabled > span {\n  color: #999999;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.label {\n  display: inline;\n  padding: 0.2em 0.6em 0.3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25em;\n}\n.label[href]:hover,\n.label[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.label:empty {\n  display: none;\n}\n.label-default {\n  background-color: #F2F2F2;\n}\n.label-default[href]:hover,\n.label-default[href]:focus {\n  background-color: #d9d9d9;\n}\n.label-primary {\n  background-color: #FFF;\n}\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n  background-color: #e6e6e6;\n}\n.label-success {\n  background-color: #FFF;\n}\n.label-success[href]:hover,\n.label-success[href]:focus {\n  background-color: #e6e6e6;\n}\n.label-info {\n  background-color: #999999;\n}\n.label-info[href]:hover,\n.label-info[href]:focus {\n  background-color: #808080;\n}\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:hover,\n.label-warning[href]:focus {\n  background-color: #ec971f;\n}\n.label-danger {\n  background-color: #FFF;\n}\n.label-danger[href]:hover,\n.label-danger[href]:focus {\n  background-color: #e6e6e6;\n}\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 1;\n  vertical-align: baseline;\n  white-space: nowrap;\n  text-align: center;\n  background-color: #555555;\n  border-radius: 10px;\n}\n.badge:empty {\n  display: none;\n}\na.badge:hover,\na.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n@-moz-document url-prefix() {\n  .btn .badge {\n    top: -1px;\n    margin-left: 4px;\n    right: 0px!important;\n  }\n}\na.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: #999999;\n  background-color: #fff;\n}\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n.jumbotron {\n  padding: 30px;\n  margin-bottom: 30px;\n  font-size: 21px;\n  font-weight: 200;\n  line-height: 2.14285714;\n  color: inherit;\n  background-color: #eeeeee;\n}\n.jumbotron h1 {\n  line-height: 1;\n  color: inherit;\n}\n.jumbotron p {\n  line-height: 1.4;\n}\n.container .jumbotron {\n  border-radius: 6px;\n}\n@media screen and (min-width: 768px) {\n  .jumbotron {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n  .container .jumbotron {\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n  .jumbotron h1 {\n    font-size: 63px;\n  }\n}\n.thumbnail {\n  padding: 4px;\n  line-height: 1.42857143;\n  background-color: #121212;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all all 0.2s ease-in-out ease-out;\n  -moz-transition: all all 0.2s ease-in-out ease-out;\n  -o-transition: all all 0.2s ease-in-out ease-out;\n  transition: all all 0.2s ease-in-out ease-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin-bottom: 20px;\n}\n.thumbnail > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #999999;\n}\n.thumbnail .caption {\n  padding: 9px;\n  color: #FFF;\n}\n.alert {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.alert h4 {\n  margin-top: 0;\n  color: inherit;\n}\n.alert .alert-link {\n  font-weight: bold;\n}\n.alert > p,\n.alert > ul {\n  margin-bottom: 0;\n}\n.alert > p + p {\n  margin-top: 5px;\n}\n.alert-dismissable {\n  padding-right: 35px;\n}\n.alert-dismissable .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n.alert-success {\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  color: #468847;\n}\n.alert-success hr {\n  border-top-color: #c9e2b3;\n}\n.alert-success .alert-link {\n  color: #356635;\n}\n.alert-info {\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n  color: #3a87ad;\n}\n.alert-info hr {\n  border-top-color: #a6e1ec;\n}\n.alert-info .alert-link {\n  color: #2d6987;\n}\n.alert-warning {\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  color: #c09853;\n}\n.alert-warning hr {\n  border-top-color: #f7e1b5;\n}\n.alert-warning .alert-link {\n  color: #a47e3c;\n}\n.alert-danger {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #6D6D6D;\n}\n.alert-danger hr {\n  border-top-color: #e4b9c0;\n}\n.alert-danger .alert-link {\n  color: #535353;\n}\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@-moz-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n@-o-keyframes progress-bar-stripes {\n  from {\n    background-position: 0 0;\n  }\n  to {\n    background-position: 40px 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  overflow: hidden;\n  height: 20px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #FFF;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n  -webkit-transition: all width 0.6s ease ease-out;\n  -moz-transition: all width 0.6s ease ease-out;\n  -o-transition: all width 0.6s ease ease-out;\n  transition: all width 0.6s ease ease-out;\n}\n.progress-striped .progress-bar {\n  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n}\n.progress.active .progress-bar {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n  animation: progress-bar-stripes 2s linear infinite;\n}\n.progress-bar-success {\n  background-color: #FFF;\n}\n.progress-striped .progress-bar-success {\n  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-info {\n  background-color: #999999;\n}\n.progress-striped .progress-bar-info {\n  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n.progress-striped .progress-bar-warning {\n  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.progress-bar-danger {\n  background-color: #FFF;\n}\n.progress-striped .progress-bar-danger {\n  background-image: -webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n.media,\n.media .media {\n  margin-top: 15px;\n}\n.media:first-child {\n  margin-top: 0;\n}\n.media-object {\n  display: block;\n}\n.media-heading {\n  margin: 0 0 5px;\n}\n.media > .pull-left {\n  margin-right: 10px;\n}\n.media > .pull-right {\n  margin-left: 10px;\n}\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n.list-group {\n  margin-bottom: 20px;\n  padding-left: 0;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n.list-group-item:first-child {\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.list-group-item > .badge {\n  float: right;\n}\n.list-group-item > .badge + .badge {\n  margin-right: 5px;\n}\na.list-group-item {\n  color: #555;\n}\na.list-group-item .list-group-item-heading {\n  color: #333;\n}\na.list-group-item:hover,\na.list-group-item:focus {\n  text-decoration: none;\n  background-color: #f5f5f5;\n}\na.list-group-item.active,\na.list-group-item.active:hover,\na.list-group-item.active:focus {\n  z-index: 2;\n  color: #737373;\n  background-color: #FFF;\n  border-color: #FFF;\n}\na.list-group-item.active .list-group-item-heading,\na.list-group-item.active:hover .list-group-item-heading,\na.list-group-item.active:focus .list-group-item-heading {\n  color: inherit;\n}\na.list-group-item.active .list-group-item-text,\na.list-group-item.active:hover .list-group-item-text,\na.list-group-item.active:focus .list-group-item-text {\n  color: #ffffff;\n}\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n.panel {\n  margin-bottom: 20px;\n  background-color: rgba(30, 30, 30, 0.75);\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.panel-light {\n  background: #3f3f3f;\n}\n.panel-gray {\n  background: #555555;\n}\n.panel-graydark {\n  background: #3f3f3f;\n}\n.panel-dark {\n  background: #222222;\n}\n.panel-transp-50 {\n  background: rgba(30, 30, 30, 0.5);\n}\n.panel-dark-70 {\n  background: rgba(30, 30, 30, 0.7);\n  display: inline-block;\n}\n.panel-gray-light {\n  background-color: #c7c7c7;\n  display: inline-block;\n}\n.panel-gray-lighter {\n  background: #e6e6e6;\n  display: inline-block;\n}\n.panel-transp-100 {\n  background: #1e1e1e;\n}\n.panel-body {\n  padding: 15px;\n}\n.panel-body:before,\n.panel-body:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.panel-body:after {\n  clear: both;\n}\n.panel-body:before,\n.panel-body:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.panel-body:after {\n  clear: both;\n}\n.panel > .list-group {\n  margin-bottom: 0;\n}\n.panel > .list-group .list-group-item {\n  border-width: 1px 0;\n}\n.panel > .list-group .list-group-item:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.panel > .list-group .list-group-item:last-child {\n  border-bottom: 0;\n}\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n.panel > .table,\n.panel > .table-responsive {\n  margin-bottom: 0;\n}\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive {\n  border-top: 1px solid #ddd;\n}\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n.panel > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-bordered > thead > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > tfoot > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n  border-left: 0;\n}\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n.panel > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-bordered > thead > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > tfoot > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n  border-right: 0;\n}\n.panel > .table-bordered > thead > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > thead > tr:last-child > th,\n.panel > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-bordered > thead > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > thead > tr:last-child > td,\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n  border-bottom: 0;\n}\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n.panel-heading > .dropdown .dropdown-toggle {\n  color: inherit;\n}\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n}\n.panel-title > a {\n  color: inherit;\n}\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #232323;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n.panel-group .panel-heading {\n  border-bottom: 0;\n}\n.panel-group .panel-heading + .panel-collapse .panel-body {\n  border-top: 1px solid #232323;\n}\n.panel-group .panel-footer {\n  border-top: 0;\n}\n.panel-group .panel-footer + .panel-collapse .panel-body {\n  border-bottom: 1px solid #232323;\n}\n.panel-default {\n  border-color: #ddd;\n}\n.panel-default > .panel-heading {\n  color: #333333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n.panel-default > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #ddd;\n}\n.panel-default > .panel-heading > .dropdown .caret {\n  border-color: #333333 transparent;\n}\n.panel-default > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #ddd;\n}\n.panel-primary {\n  border-color: #FFF;\n}\n.panel-primary > .panel-heading {\n  color: #fff;\n  background-color: #FFF;\n  border-color: #FFF;\n}\n.panel-primary > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #FFF;\n}\n.panel-primary > .panel-heading > .dropdown .caret {\n  border-color: #fff transparent;\n}\n.panel-primary > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #FFF;\n}\n.panel-success {\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading {\n  color: #468847;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n.panel-success > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #d6e9c6;\n}\n.panel-success > .panel-heading > .dropdown .caret {\n  border-color: #468847 transparent;\n}\n.panel-success > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #d6e9c6;\n}\n.panel-warning {\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading {\n  color: #c09853;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n.panel-warning > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #faebcc;\n}\n.panel-warning > .panel-heading > .dropdown .caret {\n  border-color: #c09853 transparent;\n}\n.panel-warning > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #faebcc;\n}\n.panel-danger {\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading {\n  color: #6D6D6D;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n.panel-danger > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #ebccd1;\n}\n.panel-danger > .panel-heading > .dropdown .caret {\n  border-color: #6D6D6D transparent;\n}\n.panel-danger > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #ebccd1;\n}\n.panel-info {\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading {\n  color: #3a87ad;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n.panel-info > .panel-heading + .panel-collapse .panel-body {\n  border-top-color: #bce8f1;\n}\n.panel-info > .panel-heading > .dropdown .caret {\n  border-color: #3a87ad transparent;\n}\n.panel-info > .panel-footer + .panel-collapse .panel-body {\n  border-bottom-color: #bce8f1;\n}\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n.well blockquote {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.well-lg {\n  padding: 24px;\n  border-radius: 6px;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: 2px;\n}\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #FFF;\n  text-shadow: 0 1px 0 #fff;\n}\n.close:hover,\n.close:focus {\n  color: #FFF;\n  text-decoration: none;\n  cursor: pointer;\n  -moz-opacity: 0.5;\n  -khtml-opacity: 0.5;\n  -webkit-opacity: 0.5;\n  opacity: 0.5;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n  filter: alpha(opacity=50);\n}\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  display: none;\n  overflow: auto;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n}\n.modal.fade .modal-dialog {\n  -webkit-transform: translate(0, -25%);\n  -moz-transform: translate(0, -25%);\n  -o-transform: translate(0, -25%);\n  -ms-transform: translate(0, -25%);\n  transform: translate(0, -25%);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n  -moz-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n.modal-dialog {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  padding: 10px;\n  z-index: 1050;\n}\n.modal-content {\n  position: relative;\n  background-color: #000;\n  border: 1px solid #999;\n  border: 1px solid #555555;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  background-clip: padding-box;\n  outline: none;\n  color: #FFF;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  -moz-opacity: 0;\n  -khtml-opacity: 0;\n  -webkit-opacity: 0;\n  opacity: 0;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n  filter: alpha(opacity=0);\n}\n.modal-backdrop.in {\n  -moz-opacity: 0.5;\n  -khtml-opacity: 0.5;\n  -webkit-opacity: 0.5;\n  opacity: 0.5;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n  filter: alpha(opacity=50);\n}\n.modal-header {\n  padding: 15px;\n  min-height: 16.42857143px;\n}\n.modal-header .close {\n  margin-top: -2px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143;\n}\n.modal-body {\n  position: relative;\n  padding: 20px 40px;\n}\n.modal-footer {\n  margin-top: 0px;\n  padding: 19px 20px 20px;\n  text-align: right;\n}\n.modal-footer:before,\n.modal-footer:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.modal-footer:after {\n  clear: both;\n}\n.modal-footer:before,\n.modal-footer:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.modal-footer:after {\n  clear: both;\n}\n.modal-footer .btn + .btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n@media screen and (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  }\n}\n.dynover-frame {\n  z-index: 99999;\n}\n.tooltip {\n  position: absolute;\n  z-index: 1030;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.4;\n  -moz-opacity: 0;\n  -khtml-opacity: 0;\n  -webkit-opacity: 0;\n  opacity: 0;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n  filter: alpha(opacity=0);\n}\n.tooltip.in {\n  -moz-opacity: 0.9;\n  -khtml-opacity: 0.9;\n  -webkit-opacity: 0.9;\n  opacity: 0.9;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=90);\n  filter: alpha(opacity=90);\n}\n.tooltip.top {\n  margin-top: -3px;\n  padding: 5px 0;\n}\n.tooltip.right {\n  margin-left: 3px;\n  padding: 0 5px;\n}\n.tooltip.bottom {\n  margin-top: 3px;\n  padding: 5px 0;\n}\n.tooltip.left {\n  margin-left: -3px;\n  padding: 0 5px;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #000;\n  border-radius: 4px;\n}\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-left .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  right: 5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1010;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  text-align: left;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  white-space: normal;\n}\n.popover.top {\n  margin-top: -10px;\n}\n.popover.right {\n  margin-left: 10px;\n}\n.popover.bottom {\n  margin-top: 10px;\n}\n.popover.left {\n  margin-left: -10px;\n}\n.popover-title {\n  margin: 0;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 18px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n.popover-content {\n  padding: 9px 14px;\n}\n.popover .arrow,\n.popover .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.popover .arrow {\n  border-width: 11px;\n}\n.popover .arrow:after {\n  border-width: 10px;\n  content: \"\";\n}\n.popover.top .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-bottom-width: 0;\n  border-top-color: #999;\n  border-top-color: rgba(0, 0, 0, 0.25);\n  bottom: -11px;\n}\n.popover.top .arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -10px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n.popover.right .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-left-width: 0;\n  border-right-color: #999;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n.popover.right .arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -10px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n.popover.bottom .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n  top: -11px;\n}\n.popover.bottom .arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -10px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n.popover.left .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n.popover.left .arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -10px;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  border-bottom: 1px solid #222222;\n}\n.carousel-inner > .item {\n  display: none;\n  position: relative;\n  -webkit-transition: 0.6s ease-in-out left;\n  transition: 0.6s ease-in-out left;\n  -webkit-transition: all 0.6s ease-in-out left ease-out;\n  -moz-transition: all 0.6s ease-in-out left ease-out;\n  -o-transition: all 0.6s ease-in-out left ease-out;\n  transition: all 0.6s ease-in-out left ease-out;\n}\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  line-height: 1;\n}\n.carousel-inner > .active,\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  display: block;\n}\n.carousel-inner > .active {\n  left: 0;\n}\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.carousel-inner > .next {\n  left: 100%;\n}\n.carousel-inner > .prev {\n  left: -100%;\n}\n.carousel-inner > .next.left,\n.carousel-inner > .prev.right {\n  left: 0;\n}\n.carousel-inner > .active.left {\n  left: -100%;\n}\n.carousel-inner > .active.right {\n  left: 100%;\n}\n.carousel-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 15%;\n  -moz-opacity: 0.5;\n  -khtml-opacity: 0.5;\n  -webkit-opacity: 0.5;\n  opacity: 0.5;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n  filter: alpha(opacity=50);\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n.carousel-control.left {\n  background-image: -webkit-gradient(linear, 0% top, 100% top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0.0001)));\n  background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.5) 0%), color-stop(rgba(0, 0, 0, 0.0001) 100%));\n  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\n}\n.carousel-control.right {\n  left: auto;\n  right: 0;\n  background-image: -webkit-gradient(linear, 0% top, 100% top, from(rgba(0, 0, 0, 0.0001)), to(rgba(0, 0, 0, 0.5)));\n  background-image: -webkit-linear-gradient(left, color-stop(rgba(0, 0, 0, 0.0001) 0%), color-stop(rgba(0, 0, 0, 0.5) 100%));\n  background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\n}\n.carousel-control:hover,\n.carousel-control:focus {\n  color: #fff;\n  text-decoration: none;\n  -moz-opacity: 0.9;\n  -khtml-opacity: 0.9;\n  -webkit-opacity: 0.9;\n  opacity: 0.9;\n  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=90);\n  filter: alpha(opacity=90);\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-left,\n.carousel-control .glyphicon-chevron-right {\n  position: absolute;\n  top: 50%;\n  z-index: 5;\n  display: inline-block;\n}\n.carousel-control .icon-prev,\n.carousel-control .glyphicon-chevron-left {\n  left: 50%;\n}\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-right {\n  right: 50%;\n}\n.carousel-control .icon-prev,\n.carousel-control .icon-next {\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  margin-left: -10px;\n  font-family: Roboto;\n}\n.carousel-control .icon-prev:before {\n  content: '\\2039';\n}\n.carousel-control .icon-next:before {\n  content: '\\203a';\n}\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  margin-left: -30%;\n  padding-left: 0;\n  list-style: none;\n  text-align: center;\n}\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n}\n.carousel-indicators .active {\n  margin: 0;\n  width: 12px;\n  height: 12px;\n  background-color: #FFF !important;\n  border-color: #FFF;\n}\n.carousel-caption {\n  position: absolute;\n  left: 15%;\n  right: 15%;\n  bottom: 20px;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n.carousel-caption .btn {\n  text-shadow: none;\n}\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicons-chevron-left,\n  .carousel-control .glyphicons-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -15px;\n    margin-left: -15px;\n    font-size: 30px;\n  }\n  .carousel-caption {\n    left: 20%;\n    right: 20%;\n    padding-bottom: 30px;\n  }\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n/* BUSCADOR COMBO PREDICTIVO\n-------------------------------------------------- */\n.autocomplete-w1 {\n  /* background:url(img/shadow.png) no-repeat bottom right;*/\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  margin: 8px 0 0 6px;\n  /* IE6 fix: */\n  _background: none;\n  _margin: 0;\n}\n.autocomplete {\n  /*width:207px !important;*/\n  color: #000;\n  border-top: 1px solid #1E1E1E;\n  background: #FFFFFF;\n  cursor: default;\n  text-align: left;\n  /*overflow:auto;*/\n  overflow: auto;\n  margin: 0 0 0 -6px;\n  /* IE6 specific: */\n  _height: 350px;\n  _margin: 0;\n  _overflow-x: hidden;\n  padding: 0 10px;\n}\n@media (min-width: 768px) {\n  .autocompleteContainter {\n    width: 240px !important;\n  }\n}\n.autocomplete .selected {\n  background: #E0E0E0;\n  border-radius: 2px;\n  color: #222222;\n}\n.autocomplete div {\n  /*border-top: 1px dotted #E0E0E0;*/\n  font-size: 13px;\n  line-height: 15px;\n  padding: 6px 0 !important;\n}\n.autocomplete-category {\n  color: #333333;\n  margin-left: 0;\n}\n.autocomplete-category-suggest {\n  border-bottom: 1px solid #DADADA;\n}\n.autocomplete a {\n  color: #333333;\n  padding: 5px !important;\n}\n.autocomplete img {\n  padding-left: 0;\n}\n.autocomplete h5 {\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n.autocomplete li:first-child {\n  padding-left: 5px;\n}\n@media (max-width: 767px) {\n  .resultado-busqueda h2 {\n    font-size: 10px;\n  }\n}\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  /* 1 */\n  display: table;\n  /* 2 */\n}\n.clearfix:after {\n  clear: both;\n}\n.center-block {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.hidden {\n  display: none !important;\n  visibility: hidden !important;\n}\n.affix {\n  position: fixed;\n}\n@-ms-viewport {\n  width: device-width;\n}\n.visible-xxs,\ntr.visible-xxs,\nth.visible-xxs,\ntd.visible-xxs {\n  display: none !important;\n}\n@media (max-width: 479px) {\n  .visible-xxs {\n    display: block !important;\n  }\n  tr.visible-xxs {\n    display: table-row !important;\n  }\n  th.visible-xxs,\n  td.visible-xxs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 480px) and (max-width: 767px) {\n  .visible-xxs.visible-xs {\n    display: block !important;\n  }\n  tr.visible-xxs.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-xxs.visible-xs,\n  td.visible-xxs.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-xxs.visible-sm {\n    display: block !important;\n  }\n  tr.visible-xxs.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-xxs.visible-sm,\n  td.visible-xxs.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-xxs.visible-md {\n    display: block !important;\n  }\n  tr.visible-xxs.visible-md {\n    display: table-row !important;\n  }\n  th.visible-xxs.visible-md,\n  td.visible-xxs.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-xxs.visible-lg {\n    display: block !important;\n  }\n  tr.visible-xxs.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-xxs.visible-lg,\n  td.visible-xxs.visible-lg {\n    display: table-cell !important;\n  }\n}\n.visible-xs,\ntr.visible-xs,\nth.visible-xs,\ntd.visible-xs {\n  display: none !important;\n}\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important;\n  }\n  tr.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 320px) and (max-width: 479px) {\n  .visible-xs.visible-xss {\n    display: block !important;\n  }\n  tr.visible-xs.visible-xss {\n    display: table-row !important;\n  }\n  th.visible-xs.visible-xss,\n  td.visible-xs.visible-xss {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-xs.visible-sm {\n    display: block !important;\n  }\n  tr.visible-xs.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-xs.visible-sm,\n  td.visible-xs.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-xs.visible-md {\n    display: block !important;\n  }\n  tr.visible-xs.visible-md {\n    display: table-row !important;\n  }\n  th.visible-xs.visible-md,\n  td.visible-xs.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-xs.visible-lg {\n    display: block !important;\n  }\n  tr.visible-xs.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-xs.visible-lg,\n  td.visible-xs.visible-lg {\n    display: table-cell !important;\n  }\n}\n.visible-sm,\ntr.visible-sm,\nth.visible-sm,\ntd.visible-sm {\n  display: none !important;\n}\n@media (min-width: 320px) and (max-width: 479px) {\n  .visible-sm.visible-xss {\n    display: block !important;\n  }\n  tr.visible-sm.visible-xss {\n    display: table-row !important;\n  }\n  th.visible-sm.visible-xss,\n  td.visible-sm.visible-xss {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-sm.visible-xs {\n    display: block !important;\n  }\n  tr.visible-sm.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-sm.visible-xs,\n  td.visible-sm.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important;\n  }\n  tr.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-sm.visible-md {\n    display: block !important;\n  }\n  tr.visible-sm.visible-md {\n    display: table-row !important;\n  }\n  th.visible-sm.visible-md,\n  td.visible-sm.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-sm.visible-lg {\n    display: block !important;\n  }\n  tr.visible-sm.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-sm.visible-lg,\n  td.visible-sm.visible-lg {\n    display: table-cell !important;\n  }\n}\n.visible-md,\ntr.visible-md,\nth.visible-md,\ntd.visible-md {\n  display: none !important;\n}\n@media (min-width: 320px) and (max-width: 479px) {\n  .visible-md.visible-xss {\n    display: block !important;\n  }\n  tr.visible-md.visible-xss {\n    display: table-row !important;\n  }\n  th.visible-md.visible-xss,\n  td.visible-md.visible-xss {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-md.visible-xs {\n    display: block !important;\n  }\n  tr.visible-md.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-md.visible-xs,\n  td.visible-md.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-md.visible-sm {\n    display: block !important;\n  }\n  tr.visible-md.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-md.visible-sm,\n  td.visible-md.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important;\n  }\n  tr.visible-md {\n    display: table-row !important;\n  }\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-md.visible-lg {\n    display: block !important;\n  }\n  tr.visible-md.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-md.visible-lg,\n  td.visible-md.visible-lg {\n    display: table-cell !important;\n  }\n}\n.visible-lg,\ntr.visible-lg,\nth.visible-lg,\ntd.visible-lg {\n  display: none !important;\n}\n@media (min-width: 320px) and (max-width: 479px) {\n  .visible-lg.visible-xss {\n    display: block !important;\n  }\n  tr.visible-lg.visible-xss {\n    display: table-row !important;\n  }\n  th.visible-lg.visible-xss,\n  td.visible-lg.visible-xss {\n    display: table-cell !important;\n  }\n}\n@media (max-width: 767px) {\n  .visible-lg.visible-xs {\n    display: block !important;\n  }\n  tr.visible-lg.visible-xs {\n    display: table-row !important;\n  }\n  th.visible-lg.visible-xs,\n  td.visible-lg.visible-xs {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-lg.visible-sm {\n    display: block !important;\n  }\n  tr.visible-lg.visible-sm {\n    display: table-row !important;\n  }\n  th.visible-lg.visible-sm,\n  td.visible-lg.visible-sm {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-lg.visible-md {\n    display: block !important;\n  }\n  tr.visible-lg.visible-md {\n    display: table-row !important;\n  }\n  th.visible-lg.visible-md,\n  td.visible-lg.visible-md {\n    display: table-cell !important;\n  }\n}\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important;\n  }\n  tr.visible-lg {\n    display: table-row !important;\n  }\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n  }\n}\n.hidden-xxs {\n  display: block !important;\n}\ntr.hidden-xxs {\n  display: table-row !important;\n}\nth.hidden-xxs,\ntd.hidden-xxs {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden-xxs,\n  tr.hidden-xxs,\n  th.hidden-xxs,\n  td.hidden-xxs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-xxs.hidden-sm,\n  tr.hidden-xxs.hidden-sm,\n  th.hidden-xxs.hidden-sm,\n  td.hidden-xxs.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-xxs.hidden-md,\n  tr.hidden-xxs.hidden-md,\n  th.hidden-xxs.hidden-md,\n  td.hidden-xxs.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-xxs.hidden-lg,\n  tr.hidden-xxs.hidden-lg,\n  th.hidden-xxs.hidden-lg,\n  td.hidden-xxs.hidden-lg {\n    display: none !important;\n  }\n}\n.hidden-xs {\n  display: block !important;\n}\ntr.hidden-xs {\n  display: table-row !important;\n}\nth.hidden-xs,\ntd.hidden-xs {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden-xs,\n  tr.hidden-xs,\n  th.hidden-xs,\n  td.hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-xs.hidden-sm,\n  tr.hidden-xs.hidden-sm,\n  th.hidden-xs.hidden-sm,\n  td.hidden-xs.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-xs.hidden-md,\n  tr.hidden-xs.hidden-md,\n  th.hidden-xs.hidden-md,\n  td.hidden-xs.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-xs.hidden-lg,\n  tr.hidden-xs.hidden-lg,\n  th.hidden-xs.hidden-lg,\n  td.hidden-xs.hidden-lg {\n    display: none !important;\n  }\n}\n.hidden2-xs {\n  display: table-cell !important;\n}\ntr.hidden2-xs {\n  display: table-row !important;\n}\nth.hidden2-xs,\ntd.hidden2-xs {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden2-xs,\n  tr.hidden2-xs,\n  th.hidden2-xs,\n  td.hidden2-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden2-xs.hidden-sm,\n  tr.hidden2-xs.hidden-sm,\n  th.hidden2-xs.hidden-sm,\n  td.hidden2-xs.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden2-xs.hidden-md,\n  tr.hidden2-xs.hidden-md,\n  th.hidden2-xs.hidden-md,\n  td.hidden2-xs.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden2-xs.hidden-lg,\n  tr.hidden2-xs.hidden-lg,\n  th.hidden2-xs.hidden-lg,\n  td.hidden2-xs.hidden-lg {\n    display: none !important;\n  }\n}\n.hidden-sm {\n  display: block !important;\n}\ntr.hidden-sm {\n  display: table-row !important;\n}\nth.hidden-sm,\ntd.hidden-sm {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden-sm.hidden-xs,\n  tr.hidden-sm.hidden-xs,\n  th.hidden-sm.hidden-xs,\n  td.hidden-sm.hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm,\n  tr.hidden-sm,\n  th.hidden-sm,\n  td.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-sm.hidden-md,\n  tr.hidden-sm.hidden-md,\n  th.hidden-sm.hidden-md,\n  td.hidden-sm.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-sm.hidden-lg,\n  tr.hidden-sm.hidden-lg,\n  th.hidden-sm.hidden-lg,\n  td.hidden-sm.hidden-lg {\n    display: none !important;\n  }\n}\n.hidden-md {\n  display: block !important;\n}\ntr.hidden-md {\n  display: table-row !important;\n}\nth.hidden-md,\ntd.hidden-md {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden-md.hidden-xs,\n  tr.hidden-md.hidden-xs,\n  th.hidden-md.hidden-xs,\n  td.hidden-md.hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-md.hidden-sm,\n  tr.hidden-md.hidden-sm,\n  th.hidden-md.hidden-sm,\n  td.hidden-md.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md,\n  tr.hidden-md,\n  th.hidden-md,\n  td.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-md.hidden-lg,\n  tr.hidden-md.hidden-lg,\n  th.hidden-md.hidden-lg,\n  td.hidden-md.hidden-lg {\n    display: none !important;\n  }\n}\n.hidden-lg {\n  display: block !important;\n}\ntr.hidden-lg {\n  display: table-row !important;\n}\nth.hidden-lg,\ntd.hidden-lg {\n  display: table-cell !important;\n}\n@media (max-width: 767px) {\n  .hidden-lg.hidden-xs,\n  tr.hidden-lg.hidden-xs,\n  th.hidden-lg.hidden-xs,\n  td.hidden-lg.hidden-xs {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-lg.hidden-sm,\n  tr.hidden-lg.hidden-sm,\n  th.hidden-lg.hidden-sm,\n  td.hidden-lg.hidden-sm {\n    display: none !important;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-lg.hidden-md,\n  tr.hidden-lg.hidden-md,\n  th.hidden-lg.hidden-md,\n  td.hidden-lg.hidden-md {\n    display: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .hidden-lg,\n  tr.hidden-lg,\n  th.hidden-lg,\n  td.hidden-lg {\n    display: none !important;\n  }\n}\n.visible-print,\ntr.visible-print,\nth.visible-print,\ntd.visible-print {\n  display: none !important;\n}\n@media print {\n  .visible-print {\n    display: block !important;\n  }\n  tr.visible-print {\n    display: table-row !important;\n  }\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n  }\n  .hidden-print,\n  tr.hidden-print,\n  th.hidden-print,\n  td.hidden-print {\n    display: none !important;\n  }\n}\n/*---------------------------------------------------\n    LESS Elements 0.9\n  ---------------------------------------------------\n    A set of useful LESS mixins\n    More info at: http://lesselements.com\n  ---------------------------------------------------*/\n.navbar-inverse {\n  background: #000;\n}\n.panel {\n  display: inline-block;\n}\n/* CUSTOMIZE THE CAROUSEL\n-------------------------------------------------- */\n/*carousel */\n.carousel.slide img {\n  width: 100%;\n  height: auto;\n}\n/* Carousel base class */\n/* Since positioning the image, we need to help out the caption */\n.carousel.destacado .carousel-caption {\n  z-index: 10;\n  text-align: left;\n}\n/* Declare heights because of positioning of img element */\n.carousel.destacado .carousel-inner > .item > img {\n  min-width: 100%;\n  height: auto;\n  cursor: pointer;\n}\n.carousel-control {\n  width: 5%;\n}\n/* .carousel-caption {\n  left:10%;\n  right:10%;\n  padding-bottom: 0;\n} */\n/*deprecado v1.0 2016*/\n.landing.layout-landing03 .container-false.container {\n  position: relative;\n  padding: 0;\n}\n.landing.layout-landing03 .carousel-caption {\n  left: auto;\n  right: auto;\n  padding-bottom: 0;\n  width: 100%;\n}\n.carousel.slide.destacado h2 {\n  /*font-size: (@font-size-base * 1.25);*/\n  margin-top: 0;\n  padding-bottom: 10px;\n}\n.jcarousel {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel .image {\n  padding-left: 0;\n  padding-right: 0;\n}\n/* Smooth Div Scroll */\n/* Invisible left hotspot */\ndiv.scrollinghotspotleft {\n  min-width: 40px;\n  width: 10%;\n  width: 40px;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  background-color: #000;\n  cursor: pointer;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n  z-index: 1;\n}\n/* Visible left hotspot */\ndiv.scrollinghotspotleftvisible {\n  background-color: #000;\n  background-repeat: no-repeat;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n}\n/* Invisible right hotspot */\ndiv.scrollinghotspotright {\n  min-width: 40px;\n  width: 10%;\n  width: 40px;\n  height: 100%;\n  background-color: #000;\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n  z-index: 1;\n}\n/* Visible right hotspot */\ndiv.scrollinghotspotrightvisible {\n  background-color: #000;\n  background-repeat: no-repeat;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n}\n/* The scroll wrapper is always the same width and height as the containing element (div).\n   Overflow is hidden because you don't want to show all of the scrollable area.\n*/\ndiv.scrollwrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\ndiv.scrollablearea {\n  position: relative;\n  width: auto;\n  height: 100%;\n  display: table;\n}\n.jcarousel-item {\n  clear: both;\n  position: relative;\n}\n.blabla .item-wrapper .item-img {\n  display: table;\n  position: relative;\n  overflow: hidden;\n}\n@media (max-width: 767px) {\n  .blabla .item-wrapper .item-img {\n    height: 90px;\n    width: 270px;\n  }\n}\n@media (min-width: 768px) {\n  .blabla .item-wrapper .item-img {\n    height: 125px;\n    width: 375px;\n  }\n}\n.jcarousel .item-wrapper a {\n  display: table;\n  position: relative;\n}\n.jcarousel img {\n  margin: 0;\n  padding: 0;\n}\n.jcarousel-separador {\n  background: none repeat scroll 0 0 #141414;\n  /*border: 1px solid @gray-dark;*/\n  border-top: 0;\n  border-bottom: 0;\n  /*border-left: 1px solid #202020;*/\n  display: table;\n  float: left;\n  height: 90%;\n  margin: 10px 20px 0 0;\n  width: 3px;\n}\n.jcarousel-separador span {\n  display: none;\n}\n.jcarousel-separador {\n  display: table-cell;\n  float: inherit;\n  margin: 0px;\n  background: inherit;\n  width: 15px;\n  padding: 1px;\n  /*border-left: 2px solid #202020;*/\n  border-right: 0px;\n}\n.section-recienvisto .jcarousel-separador {\n  height: 170px;\n}\n.jcarousel .fa-chevron-left,\n.jcarousel .fa-chevron-right {\n  left: 8px;\n  margin-top: -5px;\n  position: absolute;\n  top: 50%;\n  color: #FFF;\n}\n.play {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(34, 34, 34, 0.5);\n}\n.play .fa-play-circle-o {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 80px;\n  left: 50%;\n  margin-left: -35px;\n  margin-top: -40px;\n  top: 50%;\n  position: absolute;\n}\n.play .grid-channel-icon {\n  display: none;\n}\n.play:hover {\n  opacity: 1;\n}\n.play:hover .grid-channel-icon {\n  display: block;\n}\n.carousel.slide.destacado .play .fa-play-circle-o {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 110px;\n  left: 50%;\n  margin-left: -47px;\n  margin-top: -56px;\n  top: 50%;\n  position: absolute;\n}\n/*/ VARIABLES carousel\nlos container son propios de cada carousel\n  se definen anchos por contenedor para los items, asi se calcula la cinta.\n  el contenedor que pre genera la cinta y las flechas es #ID que llama a la acción\n  .smoothDivScroll\n*/\n.jcarousel.jcarousel-1 {\n  width: 100%;\n  height: 300px;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-1.horizontal.carousel-vistime {\n  height: 196px;\n}\n.jcarousel.jcarousel-1.horizontal {\n  height: 166px;\n}\n.jcarousel.jcarousel-1.horizontal.mi-lista {\n  height: 256px;\n}\n.jcarousel-1 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 540px;\n  display: table;\n  margin: 0 5px;\n}\n.jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n  width: 179px;\n}\n.jcarousel-1 .jcarousel-container.jcarousel-container-1 .image {\n  padding-left: 0;\n  padding-right: 0;\n}\n.jcarousel-1 .jcarousel-container.jcarousel-container-1 .jcarousel-item-1 {\n  margin: 0;\n}\n.jcarousel.jcarousel-2 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-2.horizontal {\n  width: 100%;\n  position: relative;\n  display: block;\n}\n/*MEP-449 Ajustes scroll horizontal*/\n:-ms-fullscreen,\n:root .section-porver .vertical.jcarousel-1.jcarousel .scrollwrapper {\n  min-height: 320px;\n}\n:-ms-fullscreen,\n:root .section-porver.horizontal .vertical.jcarousel-1.jcarousel .scrollwrapper {\n  min-height: 320px;\n}\n:-ms-fullscreen,\n:root .jcarousel.jcarousel-1.vertical .scrollwrapper {\n  min-height: 275px;\n}\n.scrollwrapper {\n  scrollbar-3dlight-color: #333333;\n  scrollbar-arrow-color: #333333;\n  scrollbar-base-color: black;\n  scrollbar-darkshadow-color: #333333;\n  scrollbar-face-color: #333333;\n  scrollbar-highlight-color: black;\n  scrollbar-shadow-color: black;\n}\n/*MEP-449*/\n.scrollwrapper {\n  -ms-overflow-style: none;\n  overflow: -moz-scrollbars-none;\n}\n.scrollwrapper::-webkit-scrollbar {\n  -webkit-overflow-scrolling: touch;\n  display: none;\n}\n.jcarousel.jcarousel-1.vertical .scrollwrapper {\n  min-height: 280px;\n}\n.jcarousel-2 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 576px;\n  display: table;\n  margin: 0 5px;\n}\n.jcarousel-2 .jcarousel-container.jcarousel-container-1 {\n  width: 459px;\n}\n.jcarousel-2 .jcarousel-container.jcarousel-container-1 .image {\n  padding-left: 0;\n  padding-right: 0;\n}\n.jcarousel-2 .jcarousel-container.jcarousel-container-1 .jcarousel-item-1 {\n  margin: 0;\n}\n/*FIN jcarousel-2 vertical\n ---------------------------------------------*/\n.jcarousel.jcarousel-3 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-3 .scrollablearea {\n  margin: 0 auto;\n}\n.jcarousel-3 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 540px;\n  display: table;\n  margin: 0 10px;\n}\n.jcarousel-3 .jcarousel-container.jcarousel-container-1 {\n  width: 1026px;\n}\n.jcarousel-3 .jcarousel-container.jcarousel-container-1 .data {\n  padding-right: 16px;\n  padding-left: 0px;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 {\n  width: 530px;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 img {\n  height: 145px;\n  width: 346px;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 .jcarousel-item-1 {\n  margin: 0 0 10px;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 .jcarousel-item-2 {\n  margin: 0;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 .image {\n  padding-left: 0;\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 .data {\n  padding-left: 16px;\n  padding-right: 20px;\n}\n/*FIN jcarousel-3 horizontal\n ---------------------------------------------*/\n.jcarousel.jcarousel-4 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel-4 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 540px;\n  display: table;\n  margin: 0 10px;\n}\n.jcarousel-4 .jcarousel-container.jcarousel-container-1 {\n  width: 420px;\n}\n/*FIN jcarousel-4 vertical\n ---------------------------------------------*/\n.jcarousel,\n.jcarousel.jcarousel-5 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-5 {\n  margin-bottom: 20px;\n}\n.jcarousel.jcarousel-5 .scrollablearea {\n  margin: 0 auto;\n}\n.jcarousel-5 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 540px;\n  display: table;\n  margin: 0 10px;\n}\n.jcarousel-5 .jcarousel-container.jcarousel-container-1 {\n  width: 1026px;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 {\n  width: 254px;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 img {\n  height: 186px;\n  width: auto !important;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 .jcarousel-item-1 {\n  margin: 0 0 10px;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 .jcarousel-item-2 {\n  margin: 0;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 .image {\n  padding-left: 0;\n}\n.jcarousel-5.jcarousel .jcarousel-container-2 .data {\n  padding-left: 0;\n}\n.jcarousel-6 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 580px;\n  display: table;\n  margin: 0 10px;\n}\n.jcarousel-6 .item-img {\n  clear: none;\n  float: left;\n}\n.jcarousel-6 .item-img > img {\n  clear: none;\n  float: left;\n  height: 200px;\n}\n.section-0 .carousel-indicators {\n  bottom: 0;\n}\n.section-0 .carousel-indicators li.active {\n  background: #EA2F23;\n}\n.container2 {\n  margin: 10px 1%;\n}\n.jcarousel .lead2 {\n  font-size: 13px;\n  line-height: 13px;\n}\n.jcarousel .item-fanbutton {\n  margin-top: 10px;\n}\n.section-porver .jcarousel.jcarousel-1,\n.section-porver.horizontal .jcarousel.jcarousel-1 {\n  height: 300px;\n}\n@media (max-width: 767px) {\n  .section-porver .jcarousel.jcarousel-1,\n  .section-porver.horizontal .jcarousel.jcarousel-1 {\n    height: 320px;\n  }\n}\n.section-recommended .jcarousel.jcarousel-1,\n.section-recommended.horizontal .jcarousel.jcarousel-1 {\n  height: 270px;\n}\n.section-recommended.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.section-recommended.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n  width: 458px;\n}\n.section-porver.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.section-porver.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n  width: 458px;\n}\n.section-porver .item-fanbutton .fa,\n.section-porver.horizontal .item-fanbutton .fa {\n  margin-left: 5px;\n}\n.carousel-vistime .item-wrapper {\n  padding-bottom: 23px;\n}\n.carousel-vistime .scrollinghotspotleft,\n.carousel-vistime .scrollinghotspotright {\n  height: 251px;\n}\n.carousel-vistime.horizontal .scrollinghotspotleft,\n.carousel-vistime.horizontal .scrollinghotspotright {\n  height: 163px;\n}\n.section-especial {\n  padding-bottom: 20px;\n  padding-top: 166px;\n}\n.section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 {\n  width: 1026px;\n}\n.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n  width: 658px;\n}\n.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {\n  height: 186px ;\n  width: auto !important;\n}\n.section-especial .jcarousel-container.jcarousel-container-1 .data,\n.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 .data {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 {\n  width: 810px;\n}\n.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 .jcarousel-item {\n  background-color: #999999;\n  margin-bottom: 10px !important;\n}\n.section-especial.section-especial01 .jcarousel-3 .jcarousel-container-1 .jcarousel-item-1 .data {\n  padding-right: 16px;\n  padding-top: 10px;\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-1,\n.section-especial05 .jcarousel-3 .jcarousel-container-1 {\n  width: 1026px;\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-1 .jcarousel-item,\n.section-especial05 .jcarousel-3 .jcarousel-container-1 .jcarousel-item {\n  background-color: #999999;\n}\n.section-especial03 .h3-special,\n.section-especial05 .h3-special {\n  font-size: 24px;\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-2 {\n  width: 658px;\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item {\n  background-color: #999999;\n  margin: 0 0 10px !important;\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item .data {\n  padding-right: 16px;\n}\n.section-especial05 .jcarousel-3.jcarousel .jcarousel-container-2 {\n  width: 256px;\n}\n.section-especial .jcarousel-container-1 b.fa {\n  right: 287px;\n}\n.section-especial .jcarousel-container-2 b.fa {\n  right: 240px;\n}\n.section-especial b.fa {\n  color: #999999;\n  font-size: 35px;\n  position: absolute;\n  top: 20px;\n}\n.section-especial.section-especial03 .jcarousel-container-1 b.fa,\n.section-especial.section-especial05 .jcarousel-container-1 b.fa {\n  right: 358px;\n}\n.section-especial.section-especial03 .jcarousel-container-2 h4,\n.section-especial.section-especial05 .jcarousel-container-2 h4 {\n  min-height: 60px;\n}\n.section-especial.section-especial03 .jcarousel-container-2 b.fa,\n.section-especial.section-especial05 .jcarousel-container-2 b.fa {\n  right: 326px !important;\n}\n.section-especial.section-especial03 .scrollinghotspotleft i,\n.section-especial.section-especial05 .scrollinghotspotleft i,\n.section-especial.section-especial03 .scrollinghotspotright i,\n.section-especial.section-especial05 .scrollinghotspotright i {\n  pointer-events: none;\n}\n/* RESPONSIVE CSS\n---------------------------------------------------------------------------- */\n@media (max-width: 768px) {\n  /* Remove the edge padding needed for mobile */\n  body.layout-landing2 .section-1.text-module h2 {\n    font-size: 20px;\n  }\n  body.layout-landing2 .section-0 h2 {\n    font-size: 20px;\n  }\n  body.layout-landing2 .section-0 .carousel-indicators {\n    display: none;\n  }\n  body.layout-landing2 .section-3 {\n    padding: 10px 0;\n    min-height: 340px;\n  }\n  body.layout-landing2 .section-0 .carousel.slide.destacado h2 {\n    margin-bottom: 0;\n    margin-top: 10px;\n  }\n  body.layout-landing2 .precio .monto {\n    font-size: 65px;\n  }\n  body.layout-landing2 .legal {\n    font-size: 11px;\n  }\n  body.layout-landing2 .section-0 .carousel.slide.destacado .btn-block {\n    margin-top: 10px;\n  }\n  .jcarousel-6 .jcarousel-container {\n    width: 310px;\n  }\n  .section-especial .jcarousel-5 .jcarousel-container.jcarousel-container-1 {\n    width: 194px;\n  }\n  .section-especial .jcarousel-3 .scrollablearea {\n    width: 480px !important;\n  }\n  .section-especial .jcarousel-3 .jcarousel-container-1,\n  .section-especial .jcarousel-3 .jcarousel-container-2 {\n    display: table-cell;\n    float: none;\n    padding: 0 10px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {\n    height: 146px;\n    width: auto !important;\n  }\n}\n@media (min-width: 480px) and (max-width: 768px) {\n  .section-especial .section-especial03 .jcarousel-3 .scrollinghotspotleft,\n  .section-especial .section-especial03 .jcarousel-3 .scrollinghotspotright {\n    display: none;\n  }\n}\n@media (width: 768px) {\n  .section-sugest h4 {\n    text-align: left !important;\n  }\n  .section-sugest .item-2,\n  .section-sugest .item-wrapper {\n    width: auto !important;\n  }\n  .section-sugest .item-2 img,\n  .section-sugest .item-wrapper img {\n    height: 200px !important;\n  }\n  .section-sugest .item-1 {\n    padding-bottom: 15px !important;\n    width: auto !important;\n    min-height: 70px;\n  }\n  .section-sugest .item-1 img {\n    height: 200px !important;\n  }\n  .section-sugest .jcarousel-6 .jcarousel-container {\n    width: 580px;\n  }\n  .section-especial .jcarousel-5 .jcarousel-container.jcarousel-container-1 {\n    width: 194px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {\n    height: 146px !important;\n    width: auto !important;\n  }\n}\n@media (max-width: 1200px) {\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center {\n    padding: 25px;\n  }\n}\n@media (max-width: 991px) {\n  .jcarousel-3 .jcarousel-container .jcarousel-4 .jcarousel-container .jcarousel-5 .jcarousel-container .jcarousel-6 .jcarousel-container {\n    margin: 0 5px;\n  }\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center {\n    padding: 15px;\n  }\n  /* tamaños para los contenedores del carousel*/\n  .section-5 .jcarousel-item {\n    background: none;\n    border: none;\n  }\n  .section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 {\n    width: 194px;\n  }\n  .jcarousel-3 .jcarousel-container.jcarousel-container-2 {\n    width: 258px;\n  }\n  .section-especial01 .jcarousel-3 .jcarousel-container-1,\n  .section-especial03 .jcarousel-3 .jcarousel-container-1 {\n    width: 192px;\n  }\n  .section-especial03 .jcarousel-3 .jcarousel-container-2 {\n    width: 256px;\n  }\n  .section-especial03 .jcarousel-3 .jcarousel-container-2 .jcarousel-item {\n    background: transparent;\n    margin: 0 0 10px !important;\n  }\n  .section-0 .carousel-caption {\n    position: relative;\n    left: 0;\n    right: 0;\n    min-height: 100px;\n  }\n  .section-0 .carousel.slide.destacado h2 {\n    margin-top: 20px;\n    margin-left: 10px;\n  }\n  .section-0 .carousel.slide.destacado .btn-block {\n    margin-top: 20px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 img {\n    height: 146px;\n    width: auto !important;\n  }\n}\n@media (max-width: 1161px) {\n  .section-0 .carousel-caption {\n    position: relative;\n    left: 0;\n    right: 0;\n    min-height: 100px;\n  }\n  .section-0 .carousel.slide.destacado h2 {\n    margin-top: 20px;\n    margin-left: 10px;\n  }\n  .section-0 .carousel.slide.destacado .btn-block {\n    margin-top: 20px;\n  }\n  .jcarousel-3 .scrollwrapper {\n    overflow-x: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 768px) {\n  .layout-landing02 .carousel-caption {\n    position: relative;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    top: auto;\n    /*min-height: 800px;*/\n  }\n  .layout-landing02 .carousel.slide.destacado h2 {\n    margin-top: 20px;\n    margin-left: 10px;\n  }\n  .layout-landing02 .carousel.slide.destacado .btn-block {\n    margin-top: 20px;\n  }\n  .jcarousel-3 .jcarousel-container {\n    vertical-align: top;\n  }\n}\n/*estilos temporales 2015*/\n.section-superdestacado02 .carousel.slide img {\n  height: auto;\n  width: auto;\n}\n.jcarousel-wrapper {\n  position: relative;\n}\n.jcarousel-wrapper2 {\n  width: 100%;\n}\n/*libreriacarrusel05*/\n.jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n  width: 302px;\n}\n.jcarousel-destacado-01,\n.jcarousel-destacado-01-xs {\n  overflow: hidden;\n}\n.slideshow,\n.slideshow-xs {\n  overflow: visible !important;\n  margin: 0px;\n}\n.carousel-destacado .jcarousel-destacado-01 .cycle-slide,\n.carousel-destacado .jcarousel-destacado-01-xs .cycle-slide {\n  margin: 0 8px;\n  margin-right: 8px;\n  margin-left: 8px;\n}\n.carousel-bg-01 .cycle-slide {\n  width: 100%;\n}\n/*fin libreriacarrusel05*/\n.carousel-fade .carousel-inner .item {\n  transition-property: opacity;\n}\n.carousel-fade .carousel-inner .item,\n.carousel-fade .carousel-inner .active.left,\n.carousel-fade .carousel-inner .active.right {\n  opacity: 0;\n}\n.carousel-fade .carousel-inner .active,\n.carousel-fade .carousel-inner .next.left,\n.carousel-fade .carousel-inner .prev.right {\n  opacity: 1;\n}\n.carousel-fade .carousel-inner .next,\n.carousel-fade .carousel-inner .prev,\n.carousel-fade .carousel-inner .active.left,\n.carousel-fade .carousel-inner .active.right {\n  left: 0;\n  transform: translate3d(0, 0, 0);\n}\n.carousel-fade .carousel-control {\n  z-index: 2;\n}\n@media (max-width: 767px) {\n  .layout-landing02 .section-destacado {\n    margin-top: -660px;\n  }\n}\n@media (min-width: 768px) {\n  .section-recommended.horizontal .item-wrapper img {\n    width: 446px;\n    height: 251px;\n  }\n}\n@media (min-width: 768px) {\n  .section-recommended.horizontal .item-wrapper .posterLabel .posterLabel--image img {\n    width: fit-content;\n    height: unset;\n  }\n}\n@media (max-width: 768px) {\n  .jcarousel.jcarousel-1.vertical img {\n    height: 250px;\n  }\n}\n.section-bg-full {\n  z-index: -999;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.cover2 img {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 100%;\n}\n/*.carousel-bg-01:before, .section-bg-full:before*/\n.bg-gradient {\n  content: \"\";\n  display: block;\n  position: absolute;\n  /*background: #232323;*/\n  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 60%, #000000 100%);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100;\n  /*z-index: 999;*/\n  /*height: 1100px;*/\n  min-height: 100%;\n  padding-top: 56.25%;\n}\n.dirty .section-highlight03 .slideshow li {\n  position: static;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n  -webkit-transition: width 12s, height 14s;\n  /* Safari */\n  transition: all 0.5s;\n  transition-timing-function: ease;\n}\n.dirty ul.slideshow {\n  display: block;\n  overflow: hidden!important;\n  width: 10000px;\n  list-style: none;\n  -webkit-transition: width 12s, height 14s;\n  /* Safari */\n  transition: all 0.5s;\n  transition-timing-function: ease;\n  margin-left: 0!important;\n}\n.dirty .jcarousel {\n  width: 10000000px !important;\n  -webkit-transition: width 12s, height 14s;\n  /* Safari */\n  transition: all 0.5s;\n  transition-timing-function: ease;\n}\n.dirty.main-wrapper {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\nsection.section-recomendador-2.section-recomendado.section-doble img {\n  height: 200px;\n}\nsection.section-recomendador-2.section-recomendado.section-doble .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1 {\n  width: 362px;\n}\n.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1 {\n  height: 225px;\n}\n/*.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1{\n  height: 225px;\n}\n\n.section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1{\n width: 139px;\n}*/\n@media (max-width: 767px) {\n  .section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n    width: 139px;\n  }\n}\n.jcarousel.jcarousel-1.vertical.fox img {\n  width: 175px;\n  height: auto;\n}\n.jcarousel.jcarousel-2.horizontal.fox img {\n  width: 375px;\n  height: 125px;\n}\n.jcarousel.jcarousel-1.vertical.fox .scrollwrapper {\n  min-height: 100px;\n}\n.jcarousel.fox {\n  padding-top: 10px;\n  height: auto;\n}\n.fox .item-img:hover img.foxnormal {\n  display: none;\n}\n.fox .item-img:hover img.foxover {\n  display: inline!important;\n}\n/* GLOBAL STYLES\n-------------------------------------------------- */\nbody {\n  min-height: 480px;\n  min-width: 300px;\n}\na {\n  text-decoration: underline;\n  color: #F2F2F2;\n}\na:hover .play {\n  visibility: visible;\n}\n.btn,\n.nav a,\n.btn-group a {\n  text-decoration: none;\n}\n.stores .row {\n  padding-top: 20px;\n}\n.stores .row div {\n  margin-top: 5px;\n}\n/*VERTICAL ALIGN*/\n.text-module .center {\n  padding: 35px 0;\n}\n.non-scroll {\n  overflow: hidden;\n}\n@media (max-width: 767px) {\n  .logged-true .autocomplete-containter-ext {\n    left: 0 !important;\n  }\n}\n.logged-true.layout-nivelbts h3,\n.logged-true.layout-aplicacionbts h3,\n.logged-true.layout-nivelbts h2,\n.logged-true.layout-aplicacionbts h2 {\n  color: #FFF;\n}\n@media (max-width: 767px) {\n  .logged-true.layout-nivelbts h3,\n  .logged-true.layout-aplicacionbts h3,\n  .logged-true.layout-nivelbts h2,\n  .logged-true.layout-aplicacionbts h2 {\n    max-width: 100%;\n  }\n}\n.logged-true.layout-nivelbts h3,\n.logged-true.layout-aplicacionbts h3 {\n  font-size: 23.8px;\n}\n.menu-principal.dropdown-menu {\n  padding-top: 0px;\n}\n.menu-principal.dropdown-menu .fa-caret-up {\n  position: absolute;\n  top: -18px;\n  left: 45px;\n}\n.buscar {\n  width: 190px;\n  height: 30px;\n  margin: 0 auto;\n}\n.buscar input {\n  color: #eeeeee;\n  background-color: #333333;\n  border: 1px solid #555555;\n}\n.buscar button.btn-default {\n  background-color: #333333;\n  color: #555555;\n  border-top: 1px solid #555555;\n  border-right: 1px solid #555555;\n  border-bottom: 1px solid #555555;\n  border-left: none;\n}\n.buscar button.btn-default:hover {\n  background-color: #222222;\n  color: #eeeeee;\n}\n.buscar button.btn-default i {\n  font-size: 1.25em;\n}\n.btn-search {\n  background: none repeat scroll 0 0 rgba(0, 0, 0, 0);\n  border: medium none;\n  color: #555555;\n  margin: 4px 0;\n  width: 40px;\n}\n.btn-search i {\n  font-size: 28px;\n}\n.buscador-xs {\n  background: #333333;\n  position: absolute;\n  width: 100%;\n}\n.logo {\n  margin: 0px;\n}\n.login .leyenda-claro {\n  font-size: 1.17em;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n@media (max-width: 767px) {\n  .login .leyenda-claro {\n    margin: 20px auto !important;\n  }\n}\n.login .leyenda-claro span {\n  display: block;\n}\n.login .claro-logo-text,\n.login .leyenda-claro .claro-logo-text {\n  color: #E51A1A !important;\n  display: inline;\n}\n.login .has-error h5 {\n  text-align: left;\n}\n.login .btn-fb-login {\n  background-color: #3B5998;\n  border-color: #3B5998;\n  margin-bottom: 10px;\n}\n.login .btn-fb-login h5 {\n  margin-top: 0;\n}\n.login .btn-fb-login .fa-facebook-square {\n  padding-left: 15px;\n  margin-right: 15px;\n}\n.captcha-reload {\n  border: 0;\n  background: url(../images/captcha-reload.png) no-repeat 0 0;\n  width: 41px;\n  height: 41px;\n}\n.chat-button {\n  margin-right: -12px;\n  position: absolute;\n  top: 20px;\n  z-index: 10000;\n}\n.instrucciones p {\n  margin: 0px;\n}\n.medios-pagos .medios-pagos-tablet .btn-default,\n.medios-pagos .medios-pagos-mobile .btn-default {\n  background: rgba(0, 0, 0, 0.2);\n  border-color: #ffffff;\n  color: #eeeeee;\n}\n.medios-pagos .medios-pagos-tablet .btn-default:focus,\n.medios-pagos .medios-pagos-mobile .btn-default:focus,\n.medios-pagos .medios-pagos-tablet .btn-default.active,\n.medios-pagos .medios-pagos-mobile .btn-default.active {\n  background: #FFF;\n  color: #222222;\n  border-color: #ffffff;\n}\n@media not all and (pointer: coarse) {\n  .medios-pagos .medios-pagos-tablet .btn-default:hover,\n  .medios-pagos .medios-pagos-mobile .btn-default:hover,\n  .medios-pagos .medios-pagos-tablet .btn-default:active,\n  .medios-pagos .medios-pagos-mobile .btn-default:active {\n    background: #FFF;\n    color: #222222;\n    border-color: #ffffff;\n  }\n}\n.medios-pagos .medios-pagos-tablet .btn-default {\n  border-radius: 0;\n  white-space: normal;\n  height: 60px;\n}\n.medios-pagos input[type=\"radio\"] {\n  margin-left: -17px;\n}\n.medios-pagos i {\n  margin-left: 0.2em;\n}\n.medios-pagos .medios-pagos-mobile .btn-default {\n  text-align: left;\n}\n.medios-pagos .paso-mobile {\n  color: #333333;\n  float: left;\n  margin-bottom: 15px;\n}\n.medios-pagos .paso-mobile h3 {\n  margin-top: 0;\n  color: #eeeeee;\n}\n.medios-pagos .paso-mobile h5 {\n  margin-top: 22px;\n  color: #eeeeee;\n}\n.medios-pagos .paso-mobile span.indice {\n  border-radius: 20px;\n  background: #222222;\n  float: left;\n  color: #999999;\n  margin: 5px 10px 0 0;\n  padding: 5px 10px;\n}\n.fa.fa-lock {\n  color: #E9AD10;\n  margin-right: 10px;\n}\n.modal-body.error i,\n.modal-body.success i {\n  color: #fff;\n}\n.error i {\n  border-radius: 30px;\n  width: 42px;\n  height: 42px;\n  font-size: 50px;\n  line-height: 40px;\n}\n.success i {\n  border-radius: 30px;\n  width: 42px;\n  height: 42px;\n  font-size: 42px;\n  line-height: 42px;\n}\n.exclamation i,\n.callcenter i {\n  color: #FFF;\n}\n.has-error .control-label {\n  color: #FFF;\n}\n.cargando-seccion,\n.cargando-full-screen {\n  margin-left: -27px;\n  margin-top: -5px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.cargando-full-screen {\n  width: 375px;\n  height: 140px;\n  margin-left: -187px;\n  margin-top: -70px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: #999999;\n}\n.cargando-full-screen .logos {\n  height: 90px;\n}\n.renta h3 span {\n  color: #FFF;\n}\n.renta .caret {\n  margin-top: 10px;\n}\n.renta .form-horizontal .form-group {\n  margin-left: auto;\n  margin-right: auto;\n}\n.renta .form-container .form-tarjeta img {\n  margin-right: auto;\n}\n.promo-container .dropdown-menu > li > a {\n  white-space: normal;\n  line-height: 2;\n}\n.promo-container .btn-group {\n  display: block;\n  position: inherit;\n}\n.promo-container .btn-group > .btn {\n  float: none;\n  white-space: normal;\n}\n.renta .btn-promo .caret {\n  margin-top: -4px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n}\n.btn-promo {\n  position: relative;\n}\n.btn-promo span:first-child {\n  float: left;\n  margin-right: 10px;\n  text-align: left;\n  white-space: normal;\n}\n.margin-bottom-20 {\n  margin-bottom: 20px;\n}\n.margin-0 {\n  margin: 0px;\n}\n.margin-top-05 {\n  margin-top: 5px;\n}\n.margin-right-1 {\n  margin-right: 10px;\n}\n.margin-left-1 {\n  margin-left: 10px;\n}\n.padding-05 {\n  padding: 5px;\n}\n.padding-1 {\n  padding: 10px;\n}\n.padding-2 {\n  padding: 20px;\n}\n.padding-4 {\n  padding: 40px;\n}\n.padding-top-03 {\n  padding-top: 3.33333333px;\n}\n.padding-top-05 {\n  padding-top: 5px;\n}\n.padding-top-1 {\n  padding-top: 10px;\n}\n.padding-top-2 {\n  padding-top: 20px;\n}\n.padding-bottom-1 {\n  padding-bottom: 10px;\n}\n.padding-right-1 {\n  padding-right: 10px;\n}\n.padding-right-2 {\n  padding-right: 20px;\n}\n.padding-right-left-10 {\n  padding-right: 10px;\n  padding-left: 10px;\n}\n.texto-blanco {\n  color: #FFF;\n}\n.full-widht {\n  display: bock;\n  width: 100%;\n}\n.texto-negro {\n  color: #222222;\n}\n.texto-brand {\n  color: #FFF;\n}\n.texto-gris {\n  color: #999999;\n}\n.texto-grisc {\n  color: #CCC;\n}\n.txt-inverse {\n  color: #000;\n}\n.border-bottom-dark {\n  border-bottom: 1px solid #222222;\n}\n.border-bottom-gray {\n  border-bottom: 1px solid #555555;\n}\n.border-bottom-lighter {\n  border-bottom: 1px solid #eeeeee;\n}\n.half-width {\n  width: 50%;\n}\n.full-width {\n  width: 100%;\n}\n.decoration-none {\n  text-decoration: none;\n}\n.btn {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n}\n.btn-ellipsis {\n  max-width: 180px;\n}\n.btn-volver {\n  background: #333333;\n  border: none;\n}\n.btn-volver i {\n  border-radius: 2px;\n  margin: -12px 10px -12px -12px;\n  padding: 10px;\n}\n.item-wrapper {\n  display: table;\n  position: relative;\n}\n.item-wrapper a {\n  cursor: pointer;\n}\n.label-hd {\n  background: #777;\n  color: #FFF;\n  border: 1px solid #777;\n  padding-top: 3px;\n  font-weight: 800;\n}\n.label-default-hd {\n  border-radius: 0;\n  background: #777;\n  text-transform: uppercase;\n}\n.item-format--span {\n  padding: 0!important;\n}\n.item-hd {\n  color: #FFF;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n  -webkit-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);\n  box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);\n  background: rgba(0, 0, 0, 0.5);\n  display: none !important;\n  height: 19px;\n  left: 1px;\n  padding: 0 2px 1px;\n  position: absolute;\n  text-align: center;\n  font-weight: bolder;\n  top: 1px;\n  width: 31px;\n}\n.item-hd-estaspor {\n  color: #FFF;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n  background: rgba(0, 0, 0, 0.5);\n  height: 19px;\n  left: 1px;\n  padding: 0 2px 1px;\n  position: absolute;\n  text-align: center;\n  font-weight: bolder;\n  top: 1px;\n  width: 31px;\n}\n.item-format-epg {\n  position: relative;\n  top: 0;\n  right: 0;\n  font-weight: bolder;\n  color: #FFF;\n  text-align: center;\n}\n.item-format-epg > div {\n  width: 100%;\n}\n.item-format-epg > div > label {\n  width: 100%;\n}\n.item-format.item-format-right {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-weight: bolder;\n  color: #FFF;\n  text-align: center;\n}\n.item-format.item-format-right .item-format-ppe {\n  display: block !important;\n  padding: 0 5px;\n  /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/\n  background: rgba(0, 0, 0, 0);\n  float: right;\n}\n.item-format.item-format-right i {\n  /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/\n  background: rgba(0, 0, 0, 0.5);\n  float: right;\n  height: 19px;\n  padding: 3px 0 16px 1px;\n}\n.item-format.item-format-right .download {\n  padding: 0;\n}\n.item-format-right {\n  margin: 0;\n  padding: 0;\n}\n.vidrierawidgetficha-html {\n  display: none;\n}\n.row-cw {\n  margin: 0 auto;\n  width: 100%;\n}\n.section-doble .container-wrapper h2,\n.section-bg h2,\n.section-doble .container-wrapper h3,\n.section-bg h3,\n.section-doble .container-wrapper h4,\n.section-bg h4,\n.section-doble .container-wrapper h5,\n.section-bg h5 {\n  color: #FFF;\n}\n.section-doble.section-recienvisto .container-wrapper {\n  height: 375px;\n}\n.section-doble.section-recienvisto.horizontal .container-wrapper {\n  height: 245px;\n}\n.section-doble.section-recomendado .container-wrapper {\n  padding-bottom: 20px;\n}\n.section-doble .container-visto {\n  background: none repeat scroll 0 0 #333333;\n}\n.section-doble .container-recomendado {\n  background: none repeat scroll 0 0 #515151;\n  z-index: 2;\n}\n.container-recomendado2 {\n  z-index: 2;\n}\n/*.section-porver { min-height: 382px;}*/\n.section-recienvisto {\n  margin-top: 30px;\n}\n.section-doble .row-cw .container-recomendado2 img {\n  height: 201px;\n}\n/*.section-recienvisto {\n   min-height: 248px;\n\n}*/\n/* Carrouseles\n-------------------------------------------------- */\n@media (min-width: 769px) {\n  .section-doble .row-cw .container-recomendado {\n    width: 480px;\n  }\n  .section-doble.horizontal .row-cw .container-recomendado {\n    width: 320px;\n  }\n  .section-doble .row-cw .container-recomendado2 {\n    background: none;\n    height: 202px;\n    padding: 0;\n    width: 155px;\n    margin-left: 20px;\n  }\n  .section-doble .row-cw .container-visto > div {\n    margin-left: 495px;\n  }\n  .section-doble.horizontal .row-cw .container-visto > div {\n    margin-left: 332px;\n  }\n  .container-recomendado3 > div {\n    margin-left: 165px;\n  }\n  .col-cw {\n    position: absolute;\n    top: 0;\n  }\n  .section-doble.section-recomendado .container-wrapper.container-recomendado3.col-cw {\n    top: 0;\n    /* ajuste vertical*/\n  }\n  .row-cw {\n    position: relative;\n    margin: 0 auto;\n    width: 100%;\n  }\n}\n.section-sugest {\n  padding-bottom: 20px;\n}\n.section-sugest .item-1 {\n  padding-bottom: 15px;\n  padding-left: 20px;\n  padding-right: 20px;\n  position: relative;\n  z-index: 2;\n}\n.section-sugest .item-2 {\n  padding: 0 20px 15px;\n}\n.section-sugest .item-1 {\n  background: none repeat scroll 0 0 #333333;\n}\n.section-sugest .item-2 {\n  background: none repeat scroll 0 0 #3F3F3F;\n}\n.section-sugest b.fa-caret-right {\n  color: #333333;\n  font-size: 35px;\n  margin-top: -17px;\n  position: absolute;\n  right: -10px;\n  top: 50%;\n}\n.section-sugest b.fa-caret-down {\n  bottom: -21px;\n  color: #333333;\n  font-size: 35px;\n  margin-right: -17px;\n  position: absolute;\n  right: 50%;\n  z-index: 2;\n}\n.item-header h3 {\n  margin-right: 5px;\n  color: #FFF;\n}\n.section-scroll {\n  position: relative;\n}\n.select2 {\n  position: absolute;\n  right: 25px;\n  top: 20px;\n  z-index: 5;\n}\n@media (max-width: 410px) {\n  .select2 {\n    position: relative;\n    top: 0;\n    left: 10px;\n  }\n}\n.container2.container-scroll {\n  margin: 20px auto 0;\n}\n.section-scroll .container-scroll .image {\n  padding-bottom: 20px;\n}\n.layout-fichabts .section-sugeridos .container {\n  background-color: #333333;\n  padding: 0 25px 25px 25px;\n}\n.layout-fichabts .section-sugeridos .container h3 {\n  color: #FFF;\n}\n.bot-descargar {\n  height: 45px;\n}\n.btn-disabled {\n  color: #eeeeee;\n  background: #b8b8b8;\n  border-color: #b8b8b8;\n}\n.btn-disabled:focus,\n.btn-disabled:active,\n.btn-disabled:hover {\n  color: #eeeeee;\n  background: #999999;\n  border-color: #999999;\n}\n/* << Inicio Media Querys >> */\n@media (max-width: 990px) {\n  .img-captcha {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n}\n@media (max-width: 1199px) {\n  .registro {\n    width: 100%;\n  }\n}\n@media (max-width: 767px) {\n  .medios-pagos-mobile.padding-2 {\n    padding: 0;\n  }\n  .medios-pagos-mobile .btn-default {\n    padding: 10px 15px;\n  }\n}\n@media (max-width: 991px) {\n  .col-xs-12 {\n    display: table;\n  }\n  .text-center-sm {\n    text-align: center;\n    float: none !important;\n  }\n}\n@media (max-width: 1199px) {\n  .btn-frecuencias {\n    padding: 20px 2px;\n    background: #000;\n    border-color: #dedede;\n    color: #eeeeee;\n  }\n  .btn-frecuencias:hover,\n  .btn-frecuencias:focus,\n  .btn-frecuencias:active,\n  .btn-frecuencias.active {\n    background: #000;\n    color: #eeeeee;\n    border-color: #bfbfbf;\n    border-bottom: 1px solid #FFF;\n  }\n  .btn-frecuencias-active {\n    padding: 20px;\n    background: #FFF;\n    color: #222222;\n    border-bottom: 1px solid #FFF;\n  }\n  .btn-left {\n    padding-right: 0;\n  }\n  .btn-left .btn {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .btn-center {\n    padding-right: 0;\n    padding-left: 0;\n  }\n  .btn-center .btn {\n    border-radius: 0;\n  }\n  .btn-right {\n    padding-left: 0;\n  }\n  .btn-right .btn {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n}\n/* PREFERENCES */\n.form-prefs h5 {\n  margin: 0 auto;\n  line-height: 2.14285714;\n  font-size: 15px;\n}\n.form-prefs .pref-radio {\n  display: none;\n}\n.form-prefs .col-lg-6,\n.form-prefs .col-md-6,\n.form-prefs .col-lg-2,\n.form-prefs .col-md-2 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.form-prefs .pref-text {\n  width: 100%;\n  height: 100%;\n  display: block;\n  cursor: pointer;\n  font-weight: normal;\n  padding: 1em;\n  margin: 0 auto;\n  border: 1px solid #eeeeee;\n}\n.form-prefs .pref-text:hover {\n  background: #FFF;\n  color: black;\n}\n.form-prefs .col-xs-12 {\n  display: table;\n}\n.form-prefs .pref-radio:checked + .pref-text {\n  background: #FFF;\n  color: #000;\n}\n.form-prefs .prefs-devices label {\n  cursor: pointer;\n}\n.form-prefs .prefs-devices .pref-text {\n  margin-bottom: 0.5rem;\n}\n@media screen and (max-width: 992px) {\n  .opt.first .pref-text {\n    border-radius: 4px 0 0 4px;\n  }\n  .opt.last .pref-text {\n    border-radius: 0 4px 4px 0;\n  }\n}\n@media screen and (min-width: 992px) {\n  .form-prefs .pref-single {\n    line-height: 50%;\n  }\n  .form-prefs .pref-text {\n    background: #000;\n    padding: 0;\n    border-radius: 60px;\n    height: 30px;\n    width: 30px;\n    overflow: hidden;\n    color: transparent;\n    text-indent: -9999999px;\n    transition: all 0.15s ease-in-out;\n    box-shadow: 0 0 0 #555555;\n  }\n  .form-prefs .pref-radio:checked + .pref-text {\n    box-shadow: 0 0 0 0.2em #555555;\n  }\n  .form-prefs .pref-device {\n    text-align: center;\n  }\n}\n/* Fin Metodos de Pago*/\n/* Cargando */\n@media (max-width: 767px) {\n  .cargando-full-screen .logos {\n    height: 70px;\n  }\n}\n@media (max-width: 768px) {\n  .section-sugest .item-2,\n  .section-sugest .item-wrapper {\n    width: 100%;\n  }\n  .section-sugest .item-1 {\n    padding-bottom: 6px;\n    width: 100%;\n    min-height: 70px;\n    text-align: center;\n  }\n}\n@media (max-width: 768px) {\n  .section-scroll .item-wrapper img {\n    height: 190px;\n  }\n  .section-doble .container-wrapper h2,\n  .section-bg h2,\n  .section-doble .container-wrapper h3,\n  .section-bg h3,\n  .section-doble .container-wrapper h4,\n  .section-bg h4,\n  .section-doble .container-wrapper h5,\n  .section-bg h5 {\n    text-align: center;\n    margin-top: 15px;\n  }\n  .jcarousel-6 .item-img > img {\n    height: 160px;\n  }\n}\n@media (max-width: 767px) {\n  .section-recomendado .item-title,\n  .section-sugest .item-title {\n    color: #FFF;\n  }\n}\n/* << Fin Media Querys >> */\n/* Cebrado para tablas y listas */\n.cebrado > .impar {\n  background: #ededed;\n}\n.cebrado > ul li:nth-child(2n) {\n  background: #ededed;\n}\n@media (min-width: 768px) {\n  .mi-cuenta .single-line .col-md-0 {\n    width: auto;\n  }\n}\n@media (min-width: 500px) and (max-width: 768px) {\n  .mi-cuenta .single-line .padding-top-1 {\n    line-height: 50px;\n  }\n}\n.mi-cuenta .single-line .fa-certificate span {\n  color: #fff;\n  font-size: 20px;\n  left: -30px;\n  position: relative;\n  top: -11px;\n}\n.mi-cuenta .single-line .fa-certificate {\n  color: #ea2f23;\n  float: left;\n  font-size: 50px;\n}\n/*estilos rediseño-2015*/\n.row-table-cell {\n  display: table-row;\n}\n.row-table-cell > * {\n  display: table-cell;\n  float: none;\n  vertical-align: bottom;\n}\n@media (max-width: 768px) {\n  .row-table-cell {\n    display: table;\n  }\n  .row-table-cell > * {\n    display: table;\n    float: left;\n    vertical-align: top;\n  }\n}\n.no-border {\n  border: 0;\n}\n.landing .carousel.slide.destacado .carousel-inner {\n  overflow: visible;\n  border: none;\n}\n.centered {\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .centered-xs {\n    margin: 0 auto;\n  }\n}\n/*.text-right\n.text-left\n.text-center*/\n@media (max-width: 767px) {\n  .text-center-xs {\n    text-align: center;\n  }\n}\n.cover {\n  height: 200%;\n  position: fixed;\n  top: -50%;\n  width: 200%;\n  z-index: -999;\n  left: -50%;\n}\n.cover img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  min-width: 50%;\n  min-height: 50%;\n}\n.form-container {\n  min-height: 380px;\n}\n.dispositivos ul li a {\n  display: block;\n}\n.layout-fichabts .cover img {\n  opacity: 0.5;\n}\n.item-rating {\n  background: none;\n  border-radius: 0;\n  border: 1px solid #f2f2f2;\n  color: #F2F2F2 !important;\n}\n.tooltip-score .fa {\n  font-size: 1.5em;\n}\n.section-ficha .tooltip-score .fa {\n  margin: 2px;\n}\n.label-default {\n  color: #0c0c0c;\n}\n.btn-circle {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  padding: 6px 0;\n  font-size: 12px;\n  line-height: 1.42857143;\n  border-radius: 15px;\n}\n.btn-circle.btn-lg {\n  width: 38px;\n  height: 38px;\n  padding: 2px 10px;\n  font-size: 18px;\n  line-height: 1.8;\n  border-radius: 25px;\n}\n.btn-circle.btn-xl {\n  width: 70px;\n  height: 70px;\n  padding: 10px 16px;\n  font-size: 24px;\n  line-height: 1.33;\n  border-radius: 35px;\n}\n.btn-circle.btn-lg .fa {\n  line-height: 1;\n  margin-top: 9px;\n  font-size: 14px;\n}\n.item-btn-wrapper {\n  width: 100%;\n}\n.item-btn-wrapper > * {\n  margin: 0 auto;\n  display: table;\n}\n.item-btn {\n  display: inline-block;\n  cursor: pointer;\n}\n.item-btn > * {\n  float: left;\n  clear: both;\n}\n.item-btn span {\n  font-size: 12px;\n}\n.list-inline.list-float > li {\n  float: left;\n}\n.item-fbkbutton {\n  height: 38px;\n  padding-top: 10px;\n}\n/*revisar iframe*/\n/*horizontal scrolling tabs*/\n.wrapper-tab {\n  position: relative;\n  margin: 0 auto;\n  overflow: hidden;\n  padding: 5px 0;\n  height: 38px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #232323;\n}\n.wrapper-tab .nav > li > a {\n  border-bottom: 3px solid transparent;\n  color: #DDDDDD;\n}\n.wrapper-tab .nav > li > a:hover,\n.wrapper-tab .nav > li > a:focus {\n  background: none;\n  border-bottom: 3px solid #DDDDDD;\n  color: #FFF;\n}\n.wrapper-tab .nav > li > a.active {\n  border-bottom: 3px solid #666666;\n}\n.list {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  min-width: 3000px;\n  margin-left: 12px;\n  margin-top: 0px;\n}\n.list li {\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  cursor: grab;\n  cursor: -webkit-grab;\n  color: #efefef;\n  vertical-align: middle;\n}\n.scroller-tab {\n  text-align: center;\n  cursor: pointer;\n  display: none;\n  padding: 6px;\n  padding-top: 7px;\n  white-space: no-wrap;\n  vertical-align: middle;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n.scroller-tab-right {\n  float: right;\n}\n.scroller-tab-left {\n  float: left;\n}\n.footer_web--footer {\n  border-radius: 0 !important;\n  background-color: rgba(0, 0, 0, 0.7) !important;\n}\n/*Registro definir flexbox footer*/\n.layout-registro .main-wrapper {\n  min-height: 750px;\n}\n.jcarousel .fa.fa-chevron-right,\n.jcarousel .fa.fa-chevron-left {\n  font-size: 18px;\n  margin-top: -9px;\n}\n.panel-light2,\n.panel-gray-light {\n  background-color: #232323;\n  display: inline-block;\n}\n.panel,\n.panel-gray-lighter {\n  background-color: rgba(30, 30, 30, 0.75);\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n/* PRUEBAS img placeholder\n\nimg:before, .item-wrapper > a:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background: #232323;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}*/\n.modal-parental .pin-error {\n  line-height: 30px;\n}\n.section-recienvisto.section-dirty_recienvisto01 .col-cw {\n  position: relative !important;\n}\n.section-recienvisto.section-dirty_recienvisto01 {\n  background-color: #333333;\n}\n/*.modal-body > .fa {\n  color: @black;\n}*/\nsection {\n  animation: opacity 1.2s;\n}\n@keyframes opacity {\n  from {\n    opacity: 0.2;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.menuhidden {\n  opacity: 0;\n  -webkit-transition: opacity 0.1s ease-in-out;\n  -moz-transition: opacity 0.1s ease-in-out;\n  -ms-transition: opacity 0.1s ease-in-out;\n  -o-transition: opacity 0.1s ease-in-out;\n  transition: opacity 0.1s ease-in-out;\n}\n.menuvisible {\n  opacity: 1;\n}\na,\nbutton {\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -o-transition: all 0.1s linear;\n  -ms-transition: all 0.1s linear;\n  transition: all 0.1s linear;\n}\n.play {\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -o-transition: all 0.1s linear;\n  -ms-transition: all 0.1s linear;\n  transition: all 0.1s linear;\n}\n.layer {\n  background-color: rgba(34, 34, 34, 0.5);\n  opacity: 1;\n}\n.layer-epg {\n  background-color: rgba(34, 34, 34, 0.5);\n  opacity: 1;\n  position: absolute;\n  left: 0;\n}\n.nav .nav-pills .nav-stacked > li > a {\n  position: relative;\n  display: block;\n  padding: 7px 15px;\n}\n.nav .nav-pills .nav-stacked > li > a:hover,\n.nav .nav-pills .nav-stacked > li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n.main-wrapper.dirty .isotope .row {\n  /*width: 12000px;*/\n  width: 80%;\n  margin: 0 auto;\n  display: block;\n  animation: all 1.2s;\n}\n.main-wrapper.dirty .isotope .post {\n  /*width: 300px;*/\n  float: left;\n  animation: all 1.2s;\n  transition-duration: 400ms;\n  transition-delay: 0ms;\n}\n.main-wrapper.dirty-login section.registro .form-login button {\n  opacity: 0.3;\n  cursor: default;\n  animation: btnloginfade 1.2s;\n}\n@keyframes btnloginfade {\n  from {\n    opacity: 0.3;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.isotope .post {\n  float: left;\n  /*transition-duration: 400ms;*/\n  transition-delay: 0ms;\n}\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  display: block;\n}\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n.fs-fb {\n  font-size: 18px !important;\n}\n/* HEADER STYLES*/\nheader.main-header {\n  position: relative;\n  z-index: 999;\n  height: 125px;\n  border-bottom: 1px solid #232323;\n}\nheader.main-header .main-logo {\n  margin: 25px 20px;\n}\nheader.main-header .logo-claro {\n  margin: 20px 10px;\n}\nheader.main-header .ingresa {\n  padding-top: 0px;\n}\nheader.main-header .navbar-default {\n  background: none;\n  border: none;\n}\nheader.main-header .navbar-default .navbar-collapse,\nheader.main-header .navbar-default .navbar-form {\n  border: none;\n}\nheader.main-header .navbar-collapse.in {\n  overflow: visible;\n}\nheader.main-header .dropdown-menu {\n  border: none;\n}\n@media (max-width: 767px) {\n  header.main-header .dropdown-menu {\n    font-size: 19.88px;\n    color: #000;\n  }\n  header.main-header .dropdown-menu li a {\n    color: #FFF;\n  }\n}\n@media (min-width: 1330px) {\n  header.main-header {\n    height: 78px;\n  }\n}\nheader.main-header .main-logo {\n  margin: 20px 20px 15px 20px;\n}\nheader.main-header .search-container {\n  position: relative;\n  padding-top: 17px;\n}\nheader.main-header .search-container .buscadorForm:only-child {\n  float: right;\n}\nheader.main-header .search-container .buscadorForm,\nheader.main-header .search-container .chat-button {\n  display: inline-block;\n  position: relative;\n  vertical-align: top;\n}\nheader.main-header .search-container .chat-button {\n  top: 8px;\n}\n@media screen and (max-width: 991px) {\n  header.main-header .search-container {\n    max-width: 310px;\n    padding-top: 25px;\n  }\n  header.main-header .search-container .buscadorForm {\n    margin: 0 auto;\n  }\n  header.main-header .search-container .buscadorForm,\n  header.main-header .search-container .chat-button {\n    vertical-align: bottom;\n  }\n  header.main-header .search-container .chat-button {\n    top: 0;\n  }\n}\n@media screen and (max-width: 991px) {\n  header.main-header .has-user .search-container {\n    padding-top: 35px;\n  }\n}\n@media (max-width: 767px) {\n  header.main-header {\n    border: none;\n    height: 55px;\n  }\n  header.main-header .main-logo {\n    margin: 10px;\n  }\n  header.main-header .logo-claro {\n    margin: 7px 10px;\n  }\n}\n.header-logueado .navbar-main .solapas .caja_menu a {\n  font-size: 11.48px;\n  padding: 5px;\n  border-radius: 0;\n  color: #333333;\n  display: inline-block;\n  line-height: 12px;\n  margin-bottom: 0;\n}\n.header-logueado .navbar-main .solapas .caja_menu a:hover,\n.header-logueado .navbar-main .solapas .caja_menu a:focus,\n.header-logueado .navbar-main .solapas .caja_menu a:active {\n  background-color: #999999;\n  border-bottom: 3px solid transparent;\n}\n.header-logueado .navbar-main .solapas .caja_menu a ul.menu-principal {\n  left: 0px !important;\n}\n.header-logueado .navbar-main .solapas .caja_menu a ul.menu-principal li .active a:hover {\n  background: transparent;\n}\n.header-logueado .navbar-main .solapas .caja_menu li:first-child {\n  margin-left: 0;\n}\n.header-logueado .navbar-main .solapas .caja_menu li {\n  padding: 2px 0;\n}\n.header-logueado .navbar-main .solapas .caja_menu li.active {\n  border-bottom: none  !important;\n  background-color: #999999;\n}\n.header-logueado .navbar-main .solapas .caja_menu li.active a {\n  color: #FFF;\n  font-weight: bold;\n}\n.header-logueado .navbar-main .solapas .caja_menu li .row .columnas {\n  border-right: 1px solid #eeeeee;\n  min-height: 370px;\n}\n.header-logueado .navbar-main .solapas .caja_menu li .row .columnas h5 a {\n  font-size: 17.5px;\n}\n.header-logueado .navbar-main .solapas .caja_menu li .row .columnas h5 a.active {\n  color: #FFF;\n  background-color: #999999;\n  border-bottom: none  !important;\n}\n.header-logueado .navbar-main .solapas .caja_menu li .row .columnas:last-child {\n  border-right: 0;\n}\n.header-logueado .navbar-main .solapas .caja_menu li.active a {\n  color: #FFF;\n}\n.header-logueado .navbar-main .solapas .columna-destacados {\n  background: #eeeeee;\n  min-height: 100%;\n  position: absolute;\n  right: 0;\n  padding-top: 36px;\n}\n.header-logueado .navbar-main .solapas .columna-destacados h5 {\n  color: #222222;\n  font-size: 17.5px;\n}\n.header-logueado .navbar-main .solapas .envivo {\n  border: 1px solid #FFF;\n  border-radius: 2px;\n  height: 35px;\n}\n.header-logueado .navbar-main .solapas .envivo a {\n  line-height: 17px;\n}\n@media (min-width: 768px) {\n  .header-logueado .navbar-main .solapas {\n    position: absolute;\n    left: 0px;\n    top: 82px;\n  }\n  .header-logueado .navbar-main .solapas li {\n    margin-right: 5px;\n  }\n  .header-logueado .navbar-main .solapas li:first-child {\n    margin-left: 20px;\n  }\n  .header-logueado .navbar-main .solapas .last {\n    position: absolute;\n    right: 30px;\n  }\n}\n.header-logueado .navbar-main .solapas .envivo {\n  border: 1px solid #FFF;\n  border-radius: 2px;\n  height: 35px;\n}\n.header-logueado .navbar-main .solapas .envivo a {\n  line-height: 17px;\n}\n@media (min-width: 1330px) {\n  .header-logueado .navbar-main .solapas {\n    position: absolute;\n    left: 250px;\n    top: 34px;\n  }\n}\n.header-logueado .go_back {\n  margin-top: 27px;\n}\n.header-logueado .go_back_icon {\n  margin: 8px 8px 0 5px;\n}\n@media (min-width: 768px) {\n  .header-nologueado .navbar-main .solapas {\n    position: absolute;\n    left: 20px;\n    top: 82px;\n  }\n  .header-nologueado .navbar-main .solapas li {\n    margin-right: 3px;\n  }\n}\n@media (min-width: 1330px) {\n  .header-nologueado .navbar-main .solapas {\n    position: absolute;\n    left: 250px;\n    top: 34px;\n  }\n}\n.header-nologueado .navbar-main .solapas .dropdown-user {\n  margin-top: 28px;\n}\n.header-nologueado .go_back {\n  margin-top: 27px;\n}\n.header-nologueado .go_back_icon {\n  margin: 8px 8px 0 5px;\n}\nbody.layout-landing2 .header-logueado .navbar-main,\nbody.layout-landing2 .header-nologueado .navbar-main {\n  background-color: #000;\n  border: 1px solid #080808;\n}\n.header-logueado,\n.header-nologueado {\n  background-color: rgba(0, 0, 0, 0.6);\n}\n.header-logueado .navbar-main,\n.header-nologueado .navbar-main {\n  border: none;\n}\n@media (max-width: 767px) {\n  .header-logueado .navbar-main .navbar-nav,\n  .header-nologueado .navbar-main .navbar-nav {\n    margin-top: 4px;\n    border: none;\n    font-size: 19.88px;\n    margin-bottom: -4px;\n  }\n  .header-logueado .navbar-main .navbar-nav .open a,\n  .header-nologueado .navbar-main .navbar-nav .open a,\n  .header-logueado .navbar-main .navbar-nav .open a:hover,\n  .header-nologueado .navbar-main .navbar-nav .open a:hover,\n  .header-logueado .navbar-main .navbar-nav .open a:focus,\n  .header-nologueado .navbar-main .navbar-nav .open a:focus,\n  .header-logueado .navbar-main .navbar-nav .open a:active,\n  .header-nologueado .navbar-main .navbar-nav .open a:active {\n    /*background: @gray-dark;*/\n    padding-top: 15px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #222222;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu {\n    padding: 0;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li {\n    border-bottom: 1px solid #333333;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a,\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:hover,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:hover,\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:focus,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:focus,\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li a:active,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li a:active {\n    font-size: 18.2px;\n    background: #222222;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li h5,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li h5 {\n    color: #FFF;\n    margin: 0;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    padding-left: 18px;\n    border-bottom: 1px solid #222222;\n    font-size: 19.88px;\n    background-color: #333333;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 {\n    padding-left: 5px;\n    background: #333333;\n  }\n  .header-logueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 a,\n  .header-nologueado .navbar-main .navbar-nav .open .dropdown-menu li ul.lavel-2 a {\n    display: block;\n    color: #999999;\n    padding-left: 35px;\n  }\n}\n@media (max-width: 767px) {\n  .header-logueado .navbar-main .navbar-nav.dropdown-user,\n  .header-nologueado .navbar-main .navbar-nav.dropdown-user {\n    margin-top: 0;\n  }\n}\n@media (min-width: 768px) {\n  .header-logueado .navbar-main .solapas li li .row:nth-child(2),\n  .header-nologueado .navbar-main .solapas li li .row:nth-child(2) {\n    margin-bottom: 15px;\n  }\n}\n@media (min-width: 992px) {\n  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal {\n    left: -80px;\n    background: #FFF url(../images/bg-nav-dropdown.gif) repeat-y right;\n  }\n  .header-logueado .navbar-main .solapas li.menu-catalogo i,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo i {\n    left: 125px;\n  }\n}\n@media (min-width: 1200px) {\n  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal {\n    left: -80px;\n    background: #FFF url(../images/bg-nav-dropdown.gif) repeat-y right;\n  }\n  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active {\n    border-bottom: none;\n    background-color: #999999;\n  }\n  .header-logueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active a,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo ul.menu-principal li.active a {\n    color: #FFF;\n    font-weight: bold;\n  }\n  .header-logueado .navbar-main .solapas li.menu-catalogo i,\n  .header-nologueado .navbar-main .solapas li.menu-catalogo i {\n    left: 205px;\n  }\n}\n.header-logueado .navbar-main .solapas li .active,\n.header-nologueado .navbar-main .solapas li .active {\n  border-bottom: 3px solid #666666;\n}\n@media (max-width: 767px) {\n  .header-logueado .navbar-main .solapas li .active,\n  .header-nologueado .navbar-main .solapas li .active {\n    background-color: #222222;\n  }\n}\n.header-logueado .navbar-main .solapas li .active:hover,\n.header-nologueado .navbar-main .solapas li .active:hover,\n.header-logueado .navbar-main .solapas li .active:focus,\n.header-nologueado .navbar-main .solapas li .active:focus,\n.header-logueado .navbar-main .solapas li .active:active,\n.header-nologueado .navbar-main .solapas li .active:active {\n  border-bottom: 3px solid #121212;\n}\n.header-logueado .navbar-main .solapas li a,\n.header-nologueado .navbar-main .solapas li a {\n  background-color: transparent;\n  color: #DDDDDD;\n  border-bottom: 3px solid transparent;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.header-logueado .navbar-main .solapas li a:hover,\n.header-nologueado .navbar-main .solapas li a:hover {\n  color: #FFF;\n  background-color: transparent;\n  border-bottom: 3px solid #DDDDDD;\n}\n.header-logueado .navbar-main .solapas li a:focus,\n.header-nologueado .navbar-main .solapas li a:focus,\n.header-logueado .navbar-main .solapas li a:active,\n.header-nologueado .navbar-main .solapas li a:active {\n  background: transparent;\n  border-bottom: 3px solid #DDDDDD;\n  color: #FFF;\n}\n.header-logueado .navbar-main .solapas li a.active,\n.header-nologueado .navbar-main .solapas li a.active {\n  color: #FFF;\n}\n.header-logueado .navbar-main .solapas li a.active .caret,\n.header-nologueado .navbar-main .solapas li a.active .caret {\n  border-bottom-color: #FFF;\n  border-top-color: #FFF;\n}\n@media (max-width: 767px) {\n  .header-logueado .navbar-main .solapas li,\n  .header-nologueado .navbar-main .solapas li {\n    background-color: #333333;\n  }\n  .header-logueado .navbar-main .solapas li:hover,\n  .header-nologueado .navbar-main .solapas li:hover,\n  .header-logueado .navbar-main .solapas li:focus,\n  .header-nologueado .navbar-main .solapas li:focus,\n  .header-logueado .navbar-main .solapas li:active,\n  .header-nologueado .navbar-main .solapas li:active {\n    background-color: #222222;\n  }\n  .header-logueado .navbar-main .solapas li a,\n  .header-nologueado .navbar-main .solapas li a {\n    padding-bottom: 15px;\n    padding-top: 15px;\n    border-bottom: none !important;\n  }\n}\n.header-logueado .navbar-collapse,\n.header-nologueado .navbar-collapse {\n  box-shadow: none;\n}\n@media (max-width: 767px) {\n  .header-logueado .navbar-collapse,\n  .header-nologueado .navbar-collapse {\n    padding: 0;\n  }\n  .header-logueado .dropdown-user,\n  .header-nologueado .dropdown-user {\n    margin: 0;\n  }\n}\n.layout-landing03 .header-nologueado {\n  background-color: transparent;\n}\n.dropdown-user .dropdown a.dropdown-toggle {\n  line-height: 21px;\n  padding: 16px 30px 16px 10px;\n}\n.dropdown-user {\n  margin-top: 25px;\n}\n.dropdown-user .dropdown > .dropdown-toggle:hover,\n.dropdown-user .dropdown > .dropdown-toggle:focus,\n.dropdown-user .dropdown > .dropdown-toggle:active {\n  background-color: transparent;\n}\n@media (max-width: 767px) {\n  .dropdown-user .dropdown > .dropdown-toggle:hover:hover,\n  .dropdown-user .dropdown > .dropdown-toggle:focus:hover,\n  .dropdown-user .dropdown > .dropdown-toggle:active:hover {\n    color: #FFF;\n    background-color: #333333;\n  }\n  .dropdown-user .dropdown > .dropdown-toggle:hover:focus,\n  .dropdown-user .dropdown > .dropdown-toggle:focus:focus,\n  .dropdown-user .dropdown > .dropdown-toggle:active:focus,\n  .dropdown-user .dropdown > .dropdown-toggle:hover:active,\n  .dropdown-user .dropdown > .dropdown-toggle:focus:active,\n  .dropdown-user .dropdown > .dropdown-toggle:active:active {\n    color: #FFF;\n    background-color: #222222;\n  }\n}\n.dropdown-user .dropdown-menu li a:hover,\n.dropdown-user .dropdown-menu li a:focus,\n.dropdown-user .dropdown-menu li a:active {\n  color: #FFF;\n  background-color: #999999;\n}\n.dropdown-user .dropdown-menu li.active a {\n  color: #FFF;\n  background-color: #999999;\n}\n.dropdown-user li a {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 160px;\n  word-wrap: break-word;\n}\n.dropdown-user li a .caret {\n  position: absolute;\n  right: 10px;\n  top: 22px;\n}\n@media (max-width: 767px) {\n  .dropdown-user li a {\n    background-color: #222222;\n    width: 100%;\n    padding-bottom: 15px;\n    padding-top: 15px;\n  }\n  .dropdown-user li a:hover,\n  .dropdown-user li a:focus,\n  .dropdown-user li a:active {\n    background-color: #222222;\n  }\n}\n.header-preferencias {\n  display: table;\n  padding: 40px 40px 0 40px;\n}\n@media (max-width: 767px) {\n  .header-preferencias {\n    padding: 20px;\n  }\n}\n.nav-pills {\n  padding: 5px 10px 0px;\n  font-weight: bold;\n}\n.nav-pills .dropdown-menu-tabs {\n  font-weight: bold;\n}\n.main-header2 {\n  margin-top: 2px;\n}\n.main-header2 .nav.navbar-nav {\n  margin-top: 13px;\n}\n.main-header2 .navbar-collapse .navbar-nav > li > a {\n  margin: 0 5px;\n  padding: 7px 8px !important;\n}\n.navbar-nav > li > .dropdown-menu {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n.main-header2 .navbar-collapse .navbar-nav > li a:hover,\n.main-header2 .navbar-collapse .navbar-nav > li a:focus,\n.main-header2 .navbar-collapse .navbar-nav > li a:active {\n  background: #333333;\n  color: #FFF;\n}\n.main-header2 .navbar-collapse .open > a,\n.main-header2 .navbar-collapse .open > a:hover,\n.main-header2 .navbar-collapse .open > a:focus {\n  background: #333333;\n  border-color: #999999;\n}\n.main-header2 .navbar-collapse .open > a .caret,\n.main-header2 .navbar-collapse .open > a:hover .caret,\n.main-header2 .navbar-collapse .open > a:focus .caret {\n  border-top-color: #737373;\n  border-bottom-color: #737373;\n}\n.main-header2 .navbar-collapse .navbar-nav > li a:hover:hover,\n.main-header2 .navbar-collapse .navbar-nav > li a:hover:focus,\n.main-header2 .navbar-collapse .navbar-nav > li a:hover:active {\n  background: #DDDDDD;\n  color: #666666;\n}\n.main-header2 .dropdown-menu > .active > a,\n.main-header2 .dropdown-menu > .active > a:hover,\n.main-header2 .dropdown-menu > .active > a:focus {\n  color: #666666;\n  text-decoration: none;\n  outline: 0;\n  background-color: #DDDDDD;\n}\n/*DROPDOWNS customize*/\n.dropdown-menu {\n  background-color: #FFF;\n}\n.dropdown-menu > li > a {\n  line-height: 40px;\n  white-space: nowrap;\n  color: #666666;\n  font-size: 12px;\n}\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: none;\n}\nul.dropdown-menu:after,\nul.dropdown-menu:before {\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  bottom: 100%;\n  border: solid transparent;\n}\n@media screen and (min-width: 768px) {\n  ul.dropdown-menu:after {\n    border-bottom-color: #fff;\n    border-width: 6px;\n    left: 33%;\n    margin-left: -6px;\n  }\n}\nul.dropdown-menu:before {\n  border-bottom-color: #ddd;\n  border-width: 7px;\n  left: 33%;\n  margin-left: -7px;\n}\nul.menu-principal:after,\nul.menu-principal:before {\n  display: none;\n}\nul.menu-user:after,\nul.menu-user:before {\n  display: none;\n}\n.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li {\n  border-bottom: 1px solid #DDDDDD;\n}\n.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li:last-child {\n  border: none;\n}\n/* wplay-765 */\n.dropdown-user .open > a,\n.dropdown-user .open > a:hover,\n.dropdown-user .open > a:focus {\n  background-color: transparent;\n  border-color: #999999;\n}\n@media (max-width: 767px) {\n  .dropdown-user .open > a,\n  .dropdown-user .open > a:hover,\n  .dropdown-user .open > a:focus {\n    background-color: #222222;\n  }\n}\nheader.error {\n  position: relative;\n  z-index: 999;\n}\nheader.error .main-logo {\n  margin: 25px 20px;\n}\nheader.error .logo-claro {\n  margin: 20px 10px;\n}\n@media (min-width: 1200px) {\n  header.error {\n    height: 78px;\n  }\n}\nheader.error .main-logo {\n  margin: 20px 20px 15px 20px;\n}\n@media (max-width: 767px) {\n  header.error {\n    border: none;\n    height: 55px;\n  }\n  header.error .main-logo {\n    margin: 10px;\n  }\n  header.error .logo-claro {\n    margin: 7px 10px;\n  }\n  #menuUser .btn-default {\n    border: none;\n    font-size: 19px;\n  }\n  #menuUser .btn-default:hover {\n    color: gray;\n  }\n  #menuUser {\n    background-color: #222222;\n  }\n}\n.region-brasil .columnas.columna-latinoamerica {\n  width: 147px !important;\n}\n.region-brasil .columnas.columna-deportes {\n  width: 120px !important;\n}\n@media (max-width: 1300px) and (min-width: 1200px) {\n  .search-container {\n    top: 55px;\n  }\n  .search-container .chat-button {\n    top: 6px;\n  }\n  #menuUser + .buscadorForm {\n    position: relative;\n  }\n  #menuUser,\n  #menu + .nav.nav-pills {\n    position: relative;\n  }\n}\n.dropdown-toggle.dropdownUser {\n  background-color: transparent!important;\n}\n@media (max-width: 768px) {\n  .btn.btn-default.metricas-event.btn-anonimus.change-class-btn {\n    background-color: #222222;\n  }\n}\n/* FOOTERS */\n.footer-web {\n  color: #F2F2F2;\n}\n.footer-web ul {\n  margin-bottom: 0px !important;\n}\n.footer-web .siguenos {\n  padding-right: 10px;\n}\n.footer-web .links-footer li {\n  font-size: 11.2px;\n  padding-left: 0;\n  margin-bottom: 0px !important;\n}\n.social-ico .fa {\n  border-radius: 4px;\n  color: #F2F2F2;\n  font-size: 18.2px;\n  padding: 5px;\n}\n.social-ico .fa-facebook {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.social-ico .fa-youtube img {\n  position: relative;\n  top: -2px;\n  left: -2px;\n  height: 28px;\n}\n.footer-mobile .margin-vertical {\n  margin: 20px 0;\n}\n.footer-mobile .links-footer li {\n  border-bottom: 1px solid #414141;\n  width: 100%;\n}\n.footer-mobile .links-footer li a {\n  text-decoration: none;\n  padding: 2px 4px;\n  display: block;\n}\n.footer-mobile .links-footer li a:active {\n  background: #555555;\n  text-decoration: none;\n  color: #eeeeee;\n}\n.footer-mobile .links-footer li a:hover {\n  text-decoration: none;\n}\n.footer-mobile .links-footer li a:visited {\n  text-decoration: none;\n}\n.footer-mobile .links-footer li span {\n  line-height: 50px;\n  font-size: 18.2px;\n}\n.footer-mobile .links-footer li i {\n  margin-top: 4px;\n  font-size: 42px;\n}\n.footer-mobile .links-footer-primero li {\n  border-bottom: 1px solid #414141;\n  width: 100%;\n}\n.footer-mobile .links-footer-primero li a {\n  text-decoration: none;\n  padding: 2px 4px;\n  display: block;\n  background: #666666;\n}\n.footer-mobile .links-footer-primero li a:active {\n  background: #666666;\n  text-decoration: none;\n  color: #eeeeee;\n}\n.footer-mobile .links-footer-primero li a:hover {\n  text-decoration: none;\n}\n.footer-mobile .links-footer-primero li a:visited {\n  text-decoration: none;\n}\n.footer-mobile .links-footer-primero li span {\n  line-height: 50px;\n  font-size: 18.2px;\n}\n.footer-mobile .links-footer-primero li i {\n  margin-top: 4px;\n  font-size: 42px;\n}\n.footer-mobile .links-footer-segundo li {\n  border-bottom: 1px solid #414141;\n  width: 100%;\n}\n.footer-mobile .links-footer-segundo li a {\n  text-decoration: none;\n  padding: 2px 4px;\n  display: block;\n}\n.footer-mobile .links-footer-segundo li a:active {\n  background: #555555;\n  text-decoration: none;\n  color: #eeeeee;\n}\n.footer-mobile .links-footer-segundo li a:hover {\n  text-decoration: none;\n}\n.footer-mobile .links-footer-segundo li a:visited {\n  text-decoration: none;\n}\n.footer-mobile .links-footer-segundo li span {\n  line-height: 50px;\n  font-size: 18.2px;\n}\n.footer-mobile .links-footer-segundo li i {\n  margin-top: 4px;\n  font-size: 42px;\n}\n.footer-mobile .social-ico .fa {\n  font-size: 40px;\n}\n.footer-mobile .social-ico .fa-facebook {\n  padding-right: 17px;\n  padding-left: 17px;\n}\n.footer-mobile .social-ico img {\n  position: relative;\n  top: -8px;\n  height: 51px;\n}\n/* FORM STYLES*/\n#formContainer {\n  min-height: 300px;\n}\n.form-container {\n  min-height: 280px;\n  padding: 40px;\n}\n.form-container .btn-fb-login h5 {\n  margin-bottom: 0;\n}\n.form-container h3,\n.form-container h5 {\n  margin-top: 0px;\n  color: #eeeeee !important;\n}\n.form-container form fieldset[disabled] label,\n.form-container form fieldset[disabled] p,\n.form-container form fieldset[disabled] select {\n  color: #999999;\n}\n.form-container form label,\n.form-container form p {\n  font-weight: normal;\n}\n.form-container .form-tarjeta h5,\n.form-container .login-captcha h5 {\n  margin-bottom: 25px;\n}\n.form-container .form-tarjeta .control-label,\n.form-container .login-captcha .control-label {\n  padding-top: 0;\n  text-align: left;\n}\n.form-container .form-tarjeta img,\n.form-container .login-captcha img {\n  margin-right: 15px;\n  vertical-align: top;\n}\n.form-container .form-sears-sanborns .radio-inline {\n  padding-top: 0;\n  vertical-align: middle;\n}\n.form-container .form-sears-sanborns .radio-inline input[type=\"radio\"] {\n  margin-top: 0;\n}\n.form-container .form-sears-sanborns .tarjeta-txt {\n  vertical-align: middle;\n}\n.form-container .form-sears-sanborns img {\n  vertical-align: middle;\n}\n@media (max-width: 991px) {\n  .form-container .form-sears-sanborns .form-group {\n    margin-left: -10px;\n    margin-right: -10px;\n  }\n  .form-container .form-sears-sanborns img {\n    margin-right: 1px;\n  }\n  .form-container .form-sears-sanborns .radio input[type=\"radio\"],\n  .form-container .form-sears-sanborns .radio-inline input[type=\"radio\"],\n  .form-container .form-sears-sanborns .checkbox input[type=\"checkbox\"],\n  .form-container .form-sears-sanborns .checkbox-inline input[type=\"checkbox\"] {\n    margin-left: -13px;\n  }\n}\n.form-container .odd {\n  background: #222222;\n}\n.form-container .dispositivos ul {\n  padding: 0px;\n}\n.form-container .dispositivos .checkbox {\n  list-style-type: none;\n  display: block;\n  padding: 0;\n  height: 80px;\n  margin: 0;\n  width: 100%;\n}\n.form-container .dispositivos .checkbox label {\n  display: inline-block;\n  height: 100%;\n  padding: 30px 10px 10px 20px;\n  width: 100%;\n}\n.form-container .dispositivos .checkbox label i {\n  margin: -10px 10px 5px 0;\n}\n.form-container .dispositivos .checkbox input[type=checkbox] {\n  margin: 4px 6px 0 0;\n}\n.form-group.has-error .input-group-addon {\n  display: table;\n  float: right;\n  font-size: 20px;\n  padding: 5px;\n  position: relative;\n  top: -32px;\n  color: #EA2F23;\n  background: rgba(35, 35, 35, 0.8);\n  border-radius: 0 4px 4px 0;\n  border: none;\n  margin-right: 2px;\n}\n@media (max-width: 767px) {\n  .form-container {\n    padding: 20px;\n  }\n}\n.form-paso1 .date-birth {\n  padding-bottom: 5px;\n}\n.form-paso1 .date-dd,\n.form-paso1 .date-mm,\n.form-paso1 .date-yy {\n  padding-left: 0px;\n}\n.form-paso1 .date-dd select,\n.form-paso1 .date-mm select,\n.form-paso1 .date-yy select {\n  padding-left: 2px;\n}\n@media (max-width: 991px) {\n  .form-container h5 {\n    text-align: center;\n    margin-top: 10px;\n  }\n}\n.form-panel {\n  display: table;\n  margin: 0 auto;\n}\n.form-panel .btn-txt {\n  float: left;\n  height: 26px;\n  line-height: 26px;\n}\n.medios-pagos-web .radio-inline {\n  margin-left: 0 !important;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n/*****************/\n.input-append input,\n.input-prepend input,\n.input-append select,\n.input-prepend select,\n.input-append .uneditable-input,\n.input-prepend .uneditable-input {\n  border-radius: 0;\n}\n.input-mini {\n  width: 60px;\n  max-width: 100%;\n}\n.input-small {\n  width: 90px;\n  max-width: 100%;\n}\n.input-medium,\n.input-md {\n  width: 150px;\n  max-width: 100%;\n}\n.input-large {\n  width: 210px;\n  max-width: 100%;\n}\n.input-xlarge {\n  width: 270px;\n  max-width: 100%;\n}\n.input-xxlarge {\n  width: 530px;\n  max-width: 100%;\n}\ninput.input-lg {\n  font-size: 18px;\n}\ninput[type=checkbox].claro-min,\ninput[type=radio].claro-min {\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\nlabel input[type=checkbox].claro-min,\nlabel input[type=radio].claro-min {\n  z-index: -100 !important;\n  width: 1px!important;\n  height: 1px!important;\n  clip: rect(1px, 1px, 1px, 1px);\n  position: absolute;\n}\ninput[type=checkbox].claro-min:checked,\ninput[type=radio].claro-min:checked,\ninput[type=checkbox].claro-min:focus,\ninput[type=radio].claro-min:focus {\n  outline: 0 !important;\n}\ninput[type=checkbox].claro-min + .lbl,\ninput[type=radio].claro-min + .lbl {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  line-height: 20px;\n  min-height: 18px;\n  min-width: 18px;\n  font-weight: 400;\n  cursor: pointer;\n}\ninput[type=checkbox].claro-min + .lbl::before,\ninput[type=radio].claro-min + .lbl::before {\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 12px;\n  /* color:#32a3ce;*/\n  content: \"\\a0\";\n  background-color: #FAFAFA;\n  border: 1px solid #c8c8c8;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 0;\n  display: inline-block;\n  text-align: center;\n  height: 16px;\n  line-height: 14px;\n  min-width: 16px;\n  margin-right: 1px;\n  position: relative;\n  margin-right: 5px;\n  top: -1px;\n}\ninput[type=checkbox].claro-min:checked + .lbl::before,\ninput[type=radio].claro-min:checked + .lbl::before {\n  display: inline-block;\n  content: '\\f00c';\n  background-color: #F5F8FC;\n  border-color: #adb8c0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);\n}\ninput[type=checkbox].claro-min:hover + .lbl::before,\ninput[type=radio].claro-min:hover + .lbl::before,\ninput[type=checkbox].claro-min + .lbl:hover::before,\ninput[type=radio].claro-min + .lbl:hover::before {\n  /* border-color:#ff893c;*/\n  border-color: #66afe9;\n}\ninput[type=checkbox].claro-min:active + .lbl::before,\ninput[type=radio].claro-min:active + .lbl::before,\ninput[type=checkbox].claro-min:checked:active + .lbl::before,\ninput[type=radio].claro-min:checked:active + .lbl::before {\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\ninput[type=checkbox].claro-min.claro-min-checkbox-2 + .lbl::before,\ninput[type=radio].claro-min.claro-min-checkbox-2 + .lbl::before {\n  box-shadow: none;\n}\ninput[type=checkbox].claro-min.claro-min-checkbox-2:checked + .lbl::before,\ninput[type=radio].claro-min.claro-min-checkbox-2:checked + .lbl::before {\n  background-color: #f9a021;\n  border-color: #f9a021;\n  color: #FFF;\n}\ninput[type=checkbox].claro-min:disabled + .lbl::before,\ninput[type=radio].claro-min:disabled + .lbl::before,\ninput[type=checkbox].claro-min[disabled] + .lbl::before,\ninput[type=radio].claro-min[disabled] + .lbl::before,\ninput[type=checkbox].claro-min.disabled + .lbl::before,\ninput[type=radio].claro-min.disabled + .lbl::before {\n  background-color: #DDD !important;\n  border-color: #CCC !important;\n  box-shadow: none!important;\n  color: #BBB;\n}\n.checkbox label input[type=checkbox].claro-min + .lbl,\n.radio label input[type=radio].claro-min + .lbl {\n  margin-left: -10px;\n}\ninput[type=radio].claro-min + .lbl::before {\n  border-radius: 100%;\n  font-size: 10px;\n  font-family: Roboto;\n  /*text-shadow:0 0 1px #32a3ce;*/\n  padding-left: 1px;\n  line-height: 15px;\n  height: 17px;\n  min-width: 17px;\n}\ninput[type=radio].claro-min:checked + .lbl::before {\n  content: \"\\f111\";\n}\ninput[type=checkbox].claro-min.claro-min-switch {\n  width: 55px;\n  height: 25px;\n}\ninput[type=checkbox].claro-min.claro-min-switch + .lbl {\n  margin: 0 4px;\n  min-height: 24px;\n}\ninput[type=checkbox].claro-min.claro-min-switch + .lbl::before {\n  font-family: Roboto;\n  content: \"ON\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0OFF\";\n  color: #999;\n  text-shadow: 0 0 0 #999;\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 17px;\n  height: 20px;\n  overflow: hidden;\n  border-radius: 12px;\n  background-color: #F5F5F5;\n  -webkit-box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.15);\n  border: 1px solid #CCC;\n  text-align: left;\n  float: left;\n  padding: 0;\n  width: 52px;\n  text-indent: -21px;\n  margin-right: 0;\n  -webkit-transition: text-indent 0.3s ease;\n  -o-transition: text-indent 0.3s ease;\n  transition: text-indent 0.3s ease;\n  top: auto;\n}\ninput[type=checkbox].claro-min.claro-min-switch + .lbl::after {\n  font-family: Roboto;\n  content: 'III';\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #AAA;\n  text-shadow: none;\n  background-color: #FFF;\n  border-radius: 100%;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  text-align: center;\n  position: absolute;\n  top: -2px;\n  left: -3px;\n  -webkit-box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.3);\n  -webkit-transition: left 0.3s ease;\n  -o-transition: left 0.3s ease;\n  transition: left 0.3s ease;\n}\ninput[type=checkbox].claro-min.claro-min-switch:checked + .lbl::before {\n  text-indent: 8px;\n  color: #FFF;\n  text-shadow: 0 0 0 #FFF;\n  background-color: #8ab2c9;\n  border-color: #6a8ca8;\n}\ninput[type=checkbox].claro-min.claro-min-switch:checked + .lbl::after {\n  left: 34px;\n  background-color: #FFF;\n  color: #98A0A5;\n}\n.form-control {\n  color: #eeeeee;\n  font-style: normal;\n}\n.form-control:focus {\n  border-color: #d5d5d5;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ffffff;\n}\n.buscar .form-control {\n  color: #eeeeee;\n  font-style: normal;\n}\n.buscar .form-control:focus {\n  border: 1px solid #555555;\n  box-shadow: none;\n}\n.help-block {\n  color: #6D6D6D;\n}\n.select-dropdown {\n  margin-bottom: 20px;\n}\n@media (max-width: 991px) {\n  .select-dropdown {\n    width: 100%;\n  }\n}\n.select-dropdown .caret {\n  float: right;\n  margin-top: 9px;\n  color: red;\n  border-top: 4px solid #eeeeee;\n}\n.select-dropdown .dropdown-menu {\n  margin: 0;\n  width: 100%;\n  background-color: #232323;\n  border: 1px solid #666666;\n  border-top: none;\n}\n.select-dropdown .dropdown-menu > li:last-child > a {\n  border-bottom: none;\n}\n.select-dropdown .dropdown-menu > li > a {\n  cursor: pointer;\n  border-bottom: 1px solid #373737;\n  line-height: 50px;\n  white-space: nowrap;\n  color: #eeeeee;\n}\n.select-dropdown .dropdown-menu > li > a:hover,\n.select-dropdown .dropdown-menu > li > a:focus {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.select-dropdown .dropdown-menu:before,\n.select-dropdown .dropdown-menu:after {\n  display: none;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .form-tarjeta #cboBirthDateMonth,\n  .form-tarjeta #cboBirthDateDay,\n  .form-tarjeta #cboBirthDateYear {\n    padding: 6px 4px;\n  }\n}\n@media (min-width: 1200px) {\n  .form-tarjeta #cboBirthDateMonth,\n  .form-tarjeta #cboBirthDateDay,\n  .form-tarjeta #cboBirthDateYear {\n    padding: 6px 6px;\n  }\n}\n/* TOOLTIP */\n.dynover-frame.posU .fa-caret-left {\n  position: absolute;\n  top: 100px;\n  left: -13px;\n}\n.dynover-frame.posD .fa-caret-left {\n  position: absolute;\n  bottom: 10px;\n  left: -13px;\n}\n.dynover-frame.posU .fa-caret-right {\n  position: absolute;\n  left: 327px;\n  top: 100px;\n}\n.dynover-frame.posD .fa-caret-right {\n  position: absolute;\n  left: 327px;\n  bottom: 10px;\n}\n.popover {\n  max-width: none;\n  padding: 0;\n}\n.popover-content {\n  padding: 0;\n}\n.tooltip-metadata {\n  background: #FFF;\n  width: 330px;\n}\n.tooltip-metadata h4 {\n  margin-top: 3px;\n  text-decoration: none;\n}\n.tooltip-metadata .item-serie-titulo-episodio {\n  float: left;\n  width: 100%;\n}\n.tooltip-metadata .label-default {\n  /*border-radius: 0;\n        background: @gray-darker;\n        text-transform: uppercase;*/\n}\n.tooltip-metadata .item-rating {\n  /* background: @white;\n        color: @gray-darker;\n        border: 1px solid @gray;*/\n}\n.tooltip-metadata .tooltip-score {\n  cursor: default;\n}\n.tooltip-metadata .tooltip-score i {\n  cursor: pointer;\n}\n.tooltip-metadata .tooltip-footer h6 {\n  float: left;\n}\n.tooltip-metadata .tooltip-footer i {\n  color: #FFF;\n}\n.tooltip-metadata .precio-renta h2 {\n  color: #FFF;\n  margin: 0;\n}\n.tooltip-metadata .precio-renta h5 {\n  margin: 0;\n}\n.tooltip-score {\n  cursor: default;\n  display: inline-block;\n}\n.tooltip-score i {\n  cursor: pointer;\n}\n.tooltip-score .fa-star-o,\n.tooltip-score .fa-star,\n.tooltip-score .fa-star-half-o {\n  color: #EBAE3B;\n}\n.panel-gray1 {\n  background-color: #232323;\n}\n.tooltip-footer {\n  display: table;\n}\n.dynover-frame > .fa {\n  color: #222222;\n}\n/* Estilos  VisTIME */\n.vistime-progress-bar-wrapper {\n  padding-top: 5px;\n  line-height: 0;\n  text-align: left;\n  margin: 0;\n  padding: 0;\n}\n.vistime-data-info {\n  display: inline-block;\n  float: left;\n  display: none;\n  /*se apaga*/\n}\n.vistime-data-info label {\n  display: inline-block;\n  color: #FFF;\n  font-size: 10px;\n  position: absolute;\n  text-align: center;\n  top: 9px;\n}\n.vistime-data-info .vistime-data-time {\n  display: none;\n}\n.vistime-data-info .vistime-data-seconds {\n  display: none;\n}\n.vistime-data-info .vistime-data-minutes {\n  display: block;\n}\n.vistime-data-date {\n  display: block;\n  float: left;\n  font-size: 10px;\n  margin-left: 6px;\n  width: 137px;\n  display: none;\n}\n.jcarousel-skin-recentlywatched .vistime-data-date {\n  display: none;\n}\n.vistime-bar {\n  background-color: #FFF;\n  height: 10px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n}\n.vistime-data-duration .vistime-data-time {\n  display: none;\n}\n.vistime-data-duration .vistime-data-seconds {\n  display: none;\n}\n.vistime-data-duration .vistime-data-minutes {\n  display: block;\n}\n.vistime-data-duration {\n  display: inline-block;\n  color: #000;\n  float: right;\n  display: none;\n  /*se apaga*/\n}\n.vistime-data-duration label {\n  display: inline-block;\n  color: #999999;\n  font-size: 0.8125em;\n  font-size: 10px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 9px;\n}\n.vistime-progress-last {\n  background: none repeat scroll 0 0 none;\n  display: inline-block;\n  position: absolute;\n  height: 10px;\n  width: 90%;\n  left: 5%;\n  bottom: 0;\n  padding: 1px;\n  margin-top: 3px;\n  border-radius: 6px;\n  overflow: hidden;\n  z-index: 99;\n  /*revisar esto*/\n  border: 1px solid #FFF;\n}\n.vistime-progress-last .vistime-data-info label {\n  top: 13px;\n}\n.vistime-progress-last .vistime-data-duration label {\n  right: 3px;\n  top: 13px;\n}\n.jcarousel-container .vistime-progress-last .vistime-data-info label,\n.jcarousel-container .vistime-progress-last .vistime-data-duration label {\n  top: 15px;\n}\n@media (max-width: 767px) {\n  .layout-landing1 .navbar-wrapper-sm {\n    top: 0;\n    position: fixed;\n    width: 100%;\n    z-index: 10;\n  }\n}\n@media (min-width: 768px) {\n  .layout-landing1 .navbar-wrapper-lg {\n    margin-top: 20px;\n  }\n}\n.panel-transp-70 {\n  background: rgba(30, 30, 30, 0.7);\n}\n.que-es .panel-lg h2 {\n  color: #FFF;\n  font-weight: bold;\n}\n.que-es .panel-lg p {\n  font-size: 17.92px;\n}\n@media (min-width: 992px) {\n  .que-es .panel-lg {\n    background: rgba(30, 30, 30, 0);\n    box-shadow: none;\n  }\n}\n@media (max-width: 991px) {\n  .pull-down {\n    margin-top: 40%;\n  }\n}\n@media (max-width: 360px) {\n  .pull-down {\n    margin-top: 65%;\n  }\n}\n@media (max-width: 1199px) {\n  .text-md-dark {\n    color: #333333;\n  }\n  .text-md-light {\n    color: #eeeeee;\n  }\n}\n.precio .moneda {\n  font-family: Roboto;\n  font-size: 32.2px;\n  display: block;\n  line-height: 2.14285714;\n}\n.precio .monto {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 79.8px;\n  line-height: 1;\n  letter-spacing: 0px;\n}\n.precio .asterisco {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 19.6px;\n  display: block;\n  line-height: 1.42857143;\n}\n.precio .periodo {\n  font-family: Roboto;\n  font-size: 28px;\n  display: block;\n  line-height: 0.5;\n  margin: 0px 0 0 14px;\n}\n@media (max-width: 360px) {\n  .layout-landing1 .col-xxs-12 {\n    width: 100%;\n  }\n}\n.layout-landing1 .precio-container {\n  display: table;\n  margin: 0 auto;\n  float: none;\n}\n@media (max-width: 360px) {\n  .layout-landing1 .precio {\n    margin-bottom: 20px;\n  }\n}\n.layout-landing1 .precio .moneda {\n  font-family: Roboto;\n  font-size: 32.2px;\n  display: block;\n  line-height: 2.14285714;\n}\n.layout-landing1 .precio .monto {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 70px;\n  line-height: 1;\n  letter-spacing: 0px;\n}\n.layout-landing1 .precio .asterisco {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 19.6px;\n  display: block;\n  line-height: 1.42857143;\n}\n.layout-landing1 .precio .periodo {\n  font-family: Roboto;\n  font-size: 17.92px;\n  display: block;\n  line-height: 1;\n  float: none;\n  clear: both;\n  margin: 0px;\n}\n.layout-landing1 .precio-4-5-cifras .moneda {\n  font-size: 23.8px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing1 .precio-4-5-cifras .moneda {\n    font-size: 16.8px;\n  }\n}\n.layout-landing1 .precio-4-5-cifras .monto {\n  font-size: 53.9px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing1 .precio-4-5-cifras .monto {\n    font-size: 40.6px;\n  }\n}\n.layout-landing1 .precio-4-5-cifras .asterisco {\n  font-size: 14px;\n}\n.layout-landing1 .precio-4-5-cifras .periodo {\n  font-size: 17.92px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing1 .precio-4-5-cifras .periodo {\n    font-size: 15.96px;\n  }\n}\n.layout-landing1 .pasos {\n  height: 258px;\n  padding-left: 30px;\n}\n.layout-landing1 .pasos li {\n  width: 28%;\n  margin: 15px 18px 0 0;\n}\n.layout-landing1 .pasos p {\n  line-height: 1.07142857;\n  margin: 0px;\n}\n.layout-landing1 .pasos .thumb {\n  margin-bottom: 10px;\n}\n.layout-landing1 .pasos h3 {\n  font-family: Roboto;\n  font-size: 25.9px;\n}\n.layout-landing1 .pasos h4 {\n  font-family: Roboto;\n  font-size: 25.9px;\n  margin: 15px 10px 0 10px;\n}\n.layout-landing1 .donde {\n  height: 258px;\n}\n@media (min-width: 320px) and (max-width: 991px) {\n  .layout-landing1 .donde {\n    height: 200px;\n  }\n}\n.layout-landing1 .donde .dispositivos {\n  margin-top: 20px;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .layout-landing1 .donde .dispositivos {\n    margin-top: 0px;\n  }\n}\n.layout-landing1 .donde .dispositivos ul {\n  display: inline-block;\n  list-style: none outside none;\n  margin: 0;\n  padding: 0;\n}\n@media (min-width: 768px) and (max-width: 1199px) {\n  .layout-landing1 .donde .dispositivos ul {\n    width: 266px;\n  }\n}\n@media (min-width: 320px) and (max-width: 479px) {\n  .layout-landing1 .donde .dispositivos ul {\n    width: 266px;\n  }\n}\n.layout-landing1 .donde .dispositivos ul li {\n  display: inline-block;\n  margin: 5px 0;\n}\n.layout-landing1 .donde .dispositivos ul li img {\n  width: 55px;\n}\n.layout-landing1 .donde .dispositivos ul li span {\n  display: block;\n}\n@media (min-width: 320px) and (max-width: 991px) {\n  .layout-landing1 .donde .dispositivos ul li span {\n    display: none;\n  }\n}\n.layout-landing1 .donde .descargas li {\n  display: inline-block;\n  margin: 5px 0;\n}\n@media (min-width: 320px) and (max-width: 991px) {\n  .layout-landing1 .donde .descargas {\n    height: 270px;\n  }\n}\n.layout-landing1 .donde h3 {\n  font-family: Roboto;\n  font-size: 25.9px;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .layout-landing1 .donde h3 {\n    font-size: 23.8px;\n  }\n}\n.layout-landing1 .donde strong {\n  font-family: Roboto;\n  font-weight: bold;\n}\n.layout-landing1 .registrate p {\n  margin-top: 5px;\n}\n.layout-landing1 .content-banner {\n  margin-bottom: 10px;\n}\n.layout-landing1 .content-banner ul li img {\n  max-width: 574px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n@media (max-width: 991px) {\n  .layout-landing1 .content-banner li.col-xs-12,\n  .layout-landing1 .content-banner li.col-sm-12 {\n    padding-left: 0px;\n  }\n}\n.layout-landing1 header {\n  /* Chat Button */\n}\n.layout-landing1 header .btn {\n  margin: 0px 10px;\n}\n@media (max-width: 767px) {\n  .layout-landing1 header .btn {\n    margin-left: 0px;\n    padding: 10px;\n  }\n}\n.layout-landing1 header .main-logo {\n  margin-bottom: 0;\n  margin-top: -8px;\n}\n.layout-landing1 header .ingresa {\n  padding-top: 3px;\n}\n.layout-landing1 header .brand-right {\n  padding: 7px;\n}\n.layout-landing1 header .navbar-text {\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n.layout-landing1 header .chat-button {\n  float: right;\n  margin-left: 11px;\n  position: relative;\n}\n.layout-landing1 .publicidad-300 {\n  border: none;\n  box-shadow: none;\n  padding: 4px;\n}\n@media (max-width: 767px) {\n  .layout-landing1 .publicidad-300 {\n    background: none;\n  }\n}\n.layout-landing1 .publicidad-300 h3 {\n  margin: 0px;\n}\n@media (max-width: 767px) {\n  .layout-landing1 .que-es p {\n    margin-bottom: 0;\n  }\n  .layout-landing1 .panel.padding-2 {\n    padding: 10px;\n  }\n  .layout-landing1 .panel {\n    margin-bottom: 10px;\n  }\n  .layout-landing1 .precio {\n    margin-bottom: 10px;\n  }\n}\n@media (min-width: 1200px) {\n  .layout-landing1 .pasos {\n    width: 525px;\n  }\n  .layout-landing1 .publicidad-300 {\n    border: 4px solid #FFF;\n    border-radius: 2px;\n    margin-left: 56px;\n    padding: 0;\n    width: 308px;\n  }\n}\n@media (max-width: 991px) {\n  .centro-descarga {\n    padding-bottom: 10px;\n  }\n}\n@media (max-width: 1199px) {\n  .icono-descarga {\n    padding-bottom: 10px;\n  }\n}\n@media (min-width: 1200px) {\n  .icono-padding {\n    padding-left: 20px;\n  }\n}\n@media (min-width: 1200px) {\n  .padd-icono {\n    text-align: right;\n  }\n}\n@media (min-width: 1200px) {\n  .padd-icono-l {\n    text-align: left;\n  }\n}\nbody.layout-landing2 {\n  padding-bottom: 25px;\n  padding-top: 98px;\n  color: #5a5a5a;\n  /* CUSTOMIZE THE NAVBAR\n    -------------------------------------------------- */\n  /* Special class on .container surrounding .navbar, used for positioning it into place. */\n  /* Flip around the padding for proper display in narrow viewports */\n  /* Logo at NAVBAR */\n  /* Images */\n  /*secciones*/\n  /*PRECIO*/\n}\nbody.layout-landing2 .precio .monto {\n  letter-spacing: -5px;\n}\n@media (max-width: 768px) {\n  body.layout-landing2 {\n    padding-top: 52px;\n  }\n}\nbody.layout-landing2 .navbar-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n}\nbody.layout-landing2 .navbar-wrapper .navbar {\n  height: 75px;\n  min-width: 480px;\n  padding: 15px;\n}\nbody.layout-landing2 .navbar-wrapper .container {\n  padding-left: 0;\n  padding-right: 0;\n}\nbody.layout-landing2 .navbar-brand {\n  background: url(\"../images/clarovideo-logo.png\") no-repeat scroll left top transparent;\n  height: 30px;\n  width: 190px;\n}\nbody.layout-landing2 .navbar-brand span {\n  display: none;\n}\nbody.layout-landing2 .navbar .brand-2 {\n  margin-left: 10px;\n}\nbody.layout-landing2 .navbar .brand-2 span {\n  display: none;\n}\nbody.layout-landing2 .chat-button {\n  position: relative;\n  margin-right: 4px;\n  top: -2px;\n}\nbody.layout-landing2 .img-circle,\nbody.layout-landing2 .img-rounded,\nbody.layout-landing2 .img-thumbnail {\n  margin: 5px;\n}\nbody.layout-landing2 .legal {\n  margin: 10px auto 0;\n  display: table;\n  font-size: 20px;\n}\nbody.layout-landing2 .legal span {\n  font-weight: bold;\n  color: #8f8f8f;\n}\nbody.layout-landing2 header.main-header {\n  height: auto;\n  border-bottom: none;\n}\nbody.layout-landing2 .section-1 {\n  background: #eeeeee;\n}\nbody.layout-landing2 .section-1.text-module h2 {\n  margin: 0;\n}\nbody.layout-landing2 .section-2 {\n  background: #666;\n  min-height: 152px;\n  color: #CCC;\n}\nbody.layout-landing2 .section-3 {\n  height: auto;\n  margin: 0 auto;\n  width: 100%;\n  position: relative;\n  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);\n  padding: 20px 0 30px;\n  color: #FFF;\n}\nbody.layout-landing2 .section-3 .img-rounded.img-responsivel {\n  height: 324px;\n  width: 576px;\n}\nbody.layout-landing2 .section-3 .img-rounded.img-responsive2 {\n  height: 324px;\n  width: 576px;\n}\nbody.layout-landing2 .section-4 {\n  background: #eeeeee;\n}\nbody.layout-landing2 .section-5 {\n  height: auto;\n  margin: 0 auto;\n  width: 100%;\n  position: relative;\n  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);\n  color: #FFF;\n  padding-top: 20px;\n}\nbody.layout-landing2 .section-5 .jcarousel-3 .lead {\n  font-size: 14px;\n}\nbody.layout-landing2 .section-5.especial {\n  padding: 30px 0;\n}\nbody.layout-landing2 .section-5 .principal,\nbody.layout-landing2 .section-5 .secundario,\nbody.layout-landing2 .section-5 .jcarousel-item {\n  background-image: -moz-linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);\n  background-image: -webkit-gradient(linear, color-stop(0, rgba(0, 0, 0, 0)), color-stop(0.99, rgba(0, 0, 0, 0.8)));\n  background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);\n  background-image: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 99%);\n}\nbody.layout-landing2 .section-5 .brand-especial {\n  margin: 10px;\n}\nbody.layout-landing2 .section-6 {\n  background: #000;\n  color: #FFF;\n}\nbody.layout-landing2 .section-7 {\n  height: auto;\n  margin: 0 auto;\n  width: 100%;\n  position: relative;\n  box-shadow: 0 0 50px rgba(0, 0, 0, 0.8);\n  padding: 30px 0;\n  color: #FFF;\n}\nbody.layout-landing2 .section-8 {\n  background: #eeeeee;\n  padding-bottom: 20px;\n}\nbody.layout-landing2 .section-9 {\n  background: #232323;\n}\nbody.layout-landing2 .section-9 p {\n  color: #FFF;\n  font-size: 20px;\n}\nbody.layout-landing2 .btn-block {\n  margin-top: 15px;\n}\nbody.layout-landing2 .precio {\n  padding: 0 6px;\n}\nbody.layout-landing2 .precio-left,\nbody.layout-landing2 .precio-right {\n  display: block;\n  height: 130px;\n  width: 30px;\n}\nbody.layout-landing2 .precio > div {\n  float: left;\n}\nbody.layout-landing2 .precio-center {\n  background: none repeat scroll 0 0 #EA2F23;\n  color: #FFF;\n  height: 130px;\n  padding: 10px;\n}\nbody.layout-landing2 .precio .periodo {\n  clear: both;\n}\ndiv body.layout-landing2 .precio .periodo {\n  float: left;\n  clear: both;\n}\nbody.layout-landing2 .section-5 .h4-especial {\n  max-height: 40px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.disable .jcarousel-1.vertical .jcarousel-container-1 img {\n  height: 220px;\n  width: 147px;\n}\n.jcarousel-3.horizontal .disable .jcarousel-container-1 img {\n  height: 300px;\n  width: 200px;\n}\n.jcarousel-3.horizontal .jcarousel-container-2 img {\n  height: 145px;\n  width: 256px;\n}\nbody.layout-landing2 .carousel.slide .cliente img {\n  width: auto;\n}\nbody.navigator-platform-android section,\nbody.navigator-platform-iphone section,\nbody.navigator-platform-ipad section {\n  /* background-attachment: scroll !important;\n     background-position: center !important;*/\n}\n.nav-pills > li + li {\n  margin-left: 5px;\n}\n/* RESPONSIVE CSS\n-------------------------------------------------- */\n@media (max-width: 768px) {\n  /* Remove the edge padding needed for mobile */\n  body.layout-landing2 .precio .periodo {\n    font-size: 23px;\n  }\n  .text-module h2 {\n    margin: 0;\n  }\n  .section-1.text-module h2 {\n    font-size: 20px;\n  }\n  .section-0 .carousel-caption {\n    position: relative;\n    left: 0%;\n  }\n}\n@media (max-width: 1200px) {\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center {\n    padding: 25px;\n  }\n}\n@media (max-width: 990px) {\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center {\n    padding: 15px;\n  }\n}\nbody.layout-landing2 .nav.nav-pills.navbar-right {\n  padding: 30px 10px;\n}\n.logo-especial {\n  padding: 0 20px 20px 0;\n}\n@media (max-width: 767px) {\n  .layout-landing03 .navbar-wrapper-sm {\n    top: 0;\n    position: fixed;\n    width: 100%;\n    z-index: 10;\n  }\n}\n@media (min-width: 768px) {\n  .layout-landing03 .navbar-wrapper-lg {\n    margin-top: 20px;\n  }\n}\n.panel-transp-70 {\n  background: rgba(30, 30, 30, 0.7);\n}\n.que-es .panel-lg h2 {\n  color: #FFF;\n  font-weight: bold;\n}\n.que-es .panel-lg p {\n  font-size: 17.92px;\n}\n@media (min-width: 992px) {\n  .que-es .panel-lg {\n    background: rgba(30, 30, 30, 0);\n    box-shadow: none;\n  }\n}\n@media (max-width: 991px) {\n  .pull-down {\n    margin-top: 40%;\n  }\n}\n@media (max-width: 360px) {\n  .pull-down {\n    margin-top: 65%;\n  }\n}\n@media (max-width: 1199px) {\n  .text-md-dark {\n    color: #333333;\n  }\n  .text-md-light {\n    color: #eeeeee;\n  }\n}\n.precio .moneda {\n  font-family: Roboto;\n  font-size: 32.2px;\n  display: block;\n  line-height: 2.14285714;\n}\n.precio .monto {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 79.8px;\n  line-height: 1;\n  letter-spacing: 0px;\n}\n.precio .asterisco {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 19.6px;\n  display: block;\n  line-height: 1.42857143;\n}\n.precio .periodo {\n  font-family: Roboto;\n  font-size: 28px;\n  display: block;\n  line-height: 0.5;\n  margin: 0px 0 0 14px;\n}\n@media (max-width: 360px) {\n  .layout-landing03 .col-xxs-12 {\n    width: 100%;\n  }\n}\n.layout-landing03 .precio-container {\n  display: table;\n  margin: 0 auto;\n  float: none;\n}\n@media (max-width: 360px) {\n  .layout-landing03 .precio {\n    margin-bottom: 20px;\n  }\n}\n.layout-landing03 .precio .moneda {\n  font-family: Roboto;\n  font-size: 32.2px;\n  display: block;\n  line-height: 2.14285714;\n}\n.layout-landing03 .precio .monto {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 70px;\n  line-height: 1;\n  letter-spacing: 0px;\n}\n.layout-landing03 .precio .asterisco {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 19.6px;\n  display: block;\n  line-height: 1.42857143;\n}\n.layout-landing03 .precio .periodo {\n  font-family: Roboto;\n  font-size: 17.92px;\n  display: block;\n  line-height: 1;\n  float: none;\n  clear: both;\n  margin: 0px;\n}\n.layout-landing03 .precio-4-5-cifras .moneda {\n  font-size: 23.8px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing03 .precio-4-5-cifras .moneda {\n    font-size: 16.8px;\n  }\n}\n.layout-landing03 .precio-4-5-cifras .monto {\n  font-size: 53.9px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing03 .precio-4-5-cifras .monto {\n    font-size: 40.6px;\n  }\n}\n.layout-landing03 .precio-4-5-cifras .asterisco {\n  font-size: 14px;\n}\n.layout-landing03 .precio-4-5-cifras .periodo {\n  font-size: 17.92px;\n}\n@media (min-width: 361px) and (max-width: 991px) {\n  .layout-landing03 .precio-4-5-cifras .periodo {\n    font-size: 15.96px;\n  }\n}\n.layout-landing03 .pasos {\n  height: 258px;\n  padding-left: 30px;\n}\n.layout-landing03 .pasos li {\n  width: 28%;\n  margin: 15px 18px 0 0;\n}\n.layout-landing03 .pasos p {\n  line-height: 1.07142857;\n  margin: 0px;\n}\n.layout-landing03 .pasos .thumb {\n  margin-bottom: 10px;\n}\n.layout-landing03 .pasos h3 {\n  font-family: Roboto;\n  font-size: 25.9px;\n}\n.layout-landing03 .pasos h4 {\n  font-family: Roboto;\n  font-size: 25.9px;\n  margin: 15px 10px 0 10px;\n}\n.layout-landing03 .donde {\n  height: 140px;\n}\n@media (min-width: 480px) and (max-width: 991px) {\n  .layout-landing03 .donde {\n    height: 125px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .layout-landing03 .donde h4 {\n    font-size: 13.86px;\n  }\n}\n@media (max-width: 479px) {\n  .layout-landing03 .donde h4 {\n    font-size: 13.72px;\n  }\n}\n.layout-landing03 .donde .dispositivos {\n  margin-top: 20px;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .layout-landing03 .donde .dispositivos {\n    margin-top: 0px;\n  }\n}\n.layout-landing03 .donde .dispositivos ul {\n  display: inline-block;\n  list-style: none outside none;\n  margin: 0;\n  padding: 0;\n}\n.layout-landing03 .donde .dispositivos ul li {\n  display: inline-block;\n  margin: 5px 0;\n}\n.layout-landing03 .donde .dispositivos ul li img {\n  width: 55px;\n}\n@media (min-width: 480px) and (max-width: 991px) {\n  .layout-landing03 .donde .dispositivos ul li img {\n    width: 45px;\n  }\n}\n@media (max-width: 479px) {\n  .layout-landing03 .donde .dispositivos ul li img {\n    width: 42px;\n  }\n}\n.layout-landing03 .donde .dispositivos ul li span {\n  display: block;\n  padding-top: 5px;\n}\n@media (min-width: 768px) and (max-width: 1199px) {\n  .layout-landing03 .donde .dispositivos ul li span {\n    font-size: 11.9px;\n  }\n}\n@media (max-width: 991px) {\n  .layout-landing03 .donde .dispositivos ul li span {\n    display: none;\n  }\n}\n.layout-landing03 .donde .descargas li {\n  display: inline-block;\n  margin: 5px 0;\n}\n@media (min-width: 768px) and (max-width: 1199px) {\n  .layout-landing03 .donde .descargas .centro-descarga {\n    height: 43px;\n  }\n}\n@media (min-width: 480px) and (max-width: 991px) {\n  .layout-landing03 .donde .descargas .centro-descarga {\n    height: 41px;\n  }\n}\n@media (max-width: 479px) {\n  .layout-landing03 .donde .descargas .centro-descarga {\n    height: 39px;\n  }\n}\n.layout-landing03 .donde h3 {\n  font-family: Roboto;\n  font-size: 25.9px;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .layout-landing03 .donde h3 {\n    font-size: 23.8px;\n  }\n}\n.layout-landing03 .donde strong {\n  font-family: Roboto;\n  font-weight: bold;\n}\n.layout-landing03 .registrate p {\n  margin-top: 5px;\n}\n.layout-landing03 .content-banner {\n  margin-bottom: 10px;\n}\n.layout-landing03 .content-banner ul li img {\n  max-width: 574px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n@media (max-width: 991px) {\n  .layout-landing03 .content-banner li.col-xs-12,\n  .layout-landing03 .content-banner li.col-sm-12 {\n    padding-left: 0px;\n  }\n}\n.layout-landing03 header {\n  /* Chat Button */\n}\n.layout-landing03 header .btn {\n  margin: 0px 10px;\n}\n@media (max-width: 767px) {\n  .layout-landing03 header .btn {\n    margin-left: 0px;\n    padding: 10px;\n  }\n}\n.layout-landing03 header .main-logo {\n  margin-bottom: 0;\n  margin-top: -8px;\n}\n.layout-landing03 header .ingresa {\n  padding-top: 3px;\n}\n.layout-landing03 header .brand-right {\n  padding: 7px;\n}\n.layout-landing03 header .navbar-text {\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n.layout-landing03 header .chat-button {\n  float: right;\n  margin-left: 11px;\n  position: relative;\n}\n.layout-landing03 header .chat-button2 a {\n  text-decoration: underline;\n}\n.layout-landing03 header .chat-button2 a i {\n  padding-right: 5px;\n}\n.layout-landing03 .publicidad-300 {\n  border: none;\n  box-shadow: none;\n  padding: 4px;\n}\n@media (max-width: 767px) {\n  .layout-landing03 .publicidad-300 {\n    background: none;\n  }\n}\n.layout-landing03 .publicidad-300 h3 {\n  margin: 0px;\n}\n@media (max-width: 767px) {\n  .layout-landing03 .que-es p {\n    margin-bottom: 0;\n  }\n  .layout-landing03 .panel.padding-2 {\n    padding: 10px;\n  }\n  .layout-landing03 .panel {\n    margin-bottom: 10px;\n  }\n  .layout-landing03 .precio {\n    margin-bottom: 10px;\n  }\n}\n@media (min-width: 1200px) {\n  .layout-landing03 .pasos {\n    width: 525px;\n  }\n  .layout-landing03 .publicidad-300 {\n    border: 4px solid #FFF;\n    border-radius: 2px;\n    margin-left: 56px;\n    padding: 0;\n    width: 308px;\n  }\n}\n@media (max-width: 991px) {\n  .centro-descarga {\n    padding-bottom: 10px;\n  }\n}\n@media (max-width: 1199px) {\n  .icono-descarga {\n    padding-bottom: 10px;\n  }\n}\n@media (min-width: 1200px) {\n  .icono-padding {\n    padding-left: 20px;\n  }\n}\n@media (min-width: 1200px) {\n  .padd-icono {\n    text-align: right;\n  }\n}\n@media (min-width: 1200px) {\n  .padd-icono-l {\n    text-align: left;\n  }\n}\n.layout-landing03 .carousel.slide .carousel-caption img {\n  width: auto;\n}\n.layout-landing03 .txt-promo {\n  margin-bottom: -4px;\n  float: left;\n}\n.promo-bajada {\n  display: table;\n}\n.promo-bajada li {\n  vertical-align: middle;\n  padding: 0;\n}\n/*XS*/\n@media (max-width: 768px) {\n  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n    height: 251px;\n  }\n}\n@media (max-width: 480px) {\n  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n    height: 251px;\n    height: auto;\n    width: 100%;\n  }\n}\n/* sm */\n@media (min-width: 768px) and (max-width: 1919px) {\n  /*SM & MD*/\n  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n    height: 163px;\n  }\n}\n@media (min-width: 1200px) {\n  /*LG */\n  .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n    height: 251px;\n  }\n}\n.layout-landing03 .bg-blur-wrapper {\n  position: absolute;\n  z-index: -5;\n  top: 0;\n  left: 0;\n  background: linear-gradient(rgba(0, 0, 0, 0.2), #000);\n  display: block;\n  margin: 0;\n  overflow: hidden;\n  width: 100%;\n}\n.layout-landing03 .carousel-indicators {\n  bottom: 0px;\n}\n.layout-landing03 .carousel-caption {\n  bottom: 25px;\n}\n.layout-landing03 header .navbar {\n  z-index: 3;\n}\n.layout-landing03 .bg-blur-wrapper img {\n  width: 100%;\n  height: auto;\n}\n.layout-landing03 .bg-blur-wrapper img.blur {\n  left: 50%;\n  margin-left: -540px;\n  position: relative;\n  z-index: -1;\n  width: auto;\n}\n@media (max-width: 768px) {\n  .layout-landing03 .bg-blur-wrapper img {\n    opacity: 0.8;\n  }\n}\n.layout-landing03 .main-wrapper > img {\n  height: auto;\n  width: 100%;\n}\n@media (min-width: 768px) {\n  .layout-landing03 .main-wrapper {\n    margin-top: -105px;\n  }\n}\n@media (min-width: 768px) and (max-width: 1919px) {\n  /*SM & MD*/\n  .layout-landing03 .carousel.slide .carousel-inner {\n    padding-top: calc(100% * 0.562264);\n  }\n}\n@media (min-width: 1200px) {\n  /*LG */\n  .layout-landing03 .carousel.slide .carousel-inner {\n    padding-top: calc(100% * 0.4546875);\n  }\n}\n/*XS*/\n/*@media (max-width: @screen-xs) {\n    .layout-landing03 .carousel.slide .carousel-inner {}\n}*/\n/**/\n/*mediaquery Xs para landing*/\n@media (max-width: 767px) {\n  .landing.layout-landing03 .bg-blur-wrapper {\n    position: absolute;\n  }\n  .landing.layout-landing03 .section-destacado {\n    min-height: 610px;\n  }\n  .landing.layout-landing03 .carousel-caption {\n    bottom: auto;\n  }\n}\n.layout-landing03 .dispositivos li span {\n  font-size: 11.5px;\n  color: #DDDDDD;\n}\n@media (max-width: 767px) {\n  .layout-landing03 .bg-blur-wrapper:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, #000000 100%);\n  }\n}\n.layout-landing03 .carousel.slide.destacado h2 {\n  font-size: 27px;\n}\n@media (min-width: 1920px) {\n  body.layout-registro,\n  body.layout-registro-logout {\n    background: url(../images/bg-registro-xl.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur {\n    background: url(../images/bg-registro-xl_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 1919px) {\n  body.layout-registro,\n  body.layout-registro-logout {\n    background: url(../images/bg-registro-lg.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur {\n    background: url(../images/bg-registro-lg_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (min-width: 1920px) {\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-xl-peru.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background: url(../images/bg-registro-xl-peru_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 1919px) {\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-lg-peru.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background: url(../images/bg-registro-lg-peru_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 1199px) {\n  body.layout-registro,\n  body.layout-registro-logout,\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-md.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur,\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background: url(../images/bg-registro-md_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 991px) {\n  body.layout-registro,\n  body.layout-registro-logout,\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-sm.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur,\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background: url(../images/bg-registro-sm_blur.jpg) no-repeat left bottom #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 767px) {\n  body.layout-registro,\n  body.layout-registro-logout,\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 34px #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur,\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background-image: none;\n    background-color: transparent;\n  }\n}\n@media (max-width: 360px) {\n  body.layout-registro,\n  body.layout-registro-logout,\n  body.layout-registro.region-peru,\n  body.layout-registro-logout.region-peru,\n  body.layout-registro.region-mexico,\n  body.layout-registro-logout.region-mexico {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 72px #000;\n    background-size: 100%;\n  }\n  body.layout-registro .bg-blur,\n  body.layout-registro-logout .bg-blur,\n  body.layout-registro.region-peru .bg-blur,\n  body.layout-registro-logout.region-peru .bg-blur,\n  body.layout-registro.region-mexico .bg-blur,\n  body.layout-registro-logout.region-mexico .bg-blur {\n    background-image: none;\n    background-color: transparent;\n  }\n}\n.registro .promocional,\n.renta .promocional {\n  display: table;\n  min-height: 750px;\n  padding: 40px 20px 20px 20px;\n}\n.registro .promocional .oferta h2,\n.renta .promocional .oferta h2,\n.registro .promocional .oferta h3,\n.renta .promocional .oferta h3,\n.registro .promocional .oferta h4,\n.renta .promocional .oferta h4 {\n  color: #FFF;\n}\n.registro .promocional .oferta h2,\n.renta .promocional .oferta h2 {\n  margin-top: 0px;\n}\n.registro .promocional .oferta h2 strong,\n.renta .promocional .oferta h2 strong,\n.registro .promocional .oferta h2 span,\n.renta .promocional .oferta h2 span {\n  color: #FFF;\n}\n.registro .promocional .oferta h3,\n.renta .promocional .oferta h3 {\n  font-size: 17.92px;\n}\n.registro .promocional .oferta h4,\n.renta .promocional .oferta h4 {\n  font-size: 14.98px;\n}\n.registro .promocional .oferta h4 small,\n.renta .promocional .oferta h4 small {\n  display: block;\n}\n.registro .promocional .oferta h4 .infinitum,\n.renta .promocional .oferta h4 .infinitum {\n  color: #555555;\n  font-weight: bold;\n}\n@media (max-width: 991px) {\n  .registro .promocional .oferta,\n  .renta .promocional .oferta {\n    width: 330px;\n  }\n}\n.registro .col-form,\n.renta .col-form {\n  min-height: 750px;\n}\n.region-mexico .registro .oferta h2,\n.region-mexico .registro .oferta h3,\n.region-mexico .registro .oferta h4 {\n  color: #eeeeee;\n}\n.region-mexico .registro .userdetectws h2,\n.region-mexico .registro .userdetectws h3,\n.region-mexico .registro .userdetectws h4 {\n  color: #333333;\n}\n/*\nVersion: @@ver@@ Timestamp: @@timestamp@@\n*/\n.select2-container {\n  margin: 0;\n  position: relative;\n  display: inline-block;\n  /* inline-block for ie7 */\n  zoom: 1;\n  *display: inline;\n  vertical-align: middle;\n}\n.select2-container,\n.select2-drop,\n.select2-search,\n.select2-search input {\n  /*\n    Force border-box so that % widths fit the parent\n    container without overlap because of margin/padding.\n    More Info : http://www.quirksmode.org/css/box.html\n  */\n  min-width: 180px;\n  -webkit-box-sizing: border-box;\n  /* webkit */\n  -moz-box-sizing: border-box;\n  /* firefox */\n  box-sizing: border-box;\n  /* css3 */\n}\n.select2-container .select2-choice {\n  display: block;\n  height: 30px;\n  padding: 0 0 0 8px;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid #666;\n  white-space: nowrap;\n  line-height: 30px;\n  color: #444;\n  text-decoration: none;\n  border-radius: 2px;\n  margin-bottom: 1px;\n  background-clip: padding-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #FFF;\n  /*background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.5, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#ffffff', endColorstr = '#eeeeee', GradientType = 0);\n    background-image: linear-gradient(to top, #eee 0%, #fff 50%);*/\n}\n.select2-container.select2-drop-above .select2-choice {\n  border-bottom-color: #666;\n  border-radius: 0 0 2px 2px;\n  /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.9, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#eeeeee', GradientType=0);\n    background-image: linear-gradient(to bottom, #eee 0%, #fff 90%);*/\n}\n.select2-container.select2-allowclear .select2-choice .select2-chosen {\n  margin-right: 42px;\n}\n.select2-container .select2-choice > .select2-chosen {\n  margin-right: 26px;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  float: none;\n  width: auto;\n}\n.select2-container .select2-choice abbr {\n  display: none;\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  right: 24px;\n  top: 8px;\n  font-size: 1px;\n  text-decoration: none;\n  border: 0;\n  background: url(\"../images/select2.png\") right top no-repeat;\n  cursor: pointer;\n  outline: 0;\n}\n.select2-container.select2-allowclear .select2-choice abbr {\n  display: inline-block;\n}\n.select2-container .select2-choice abbr:hover {\n  background-position: right -11px;\n  cursor: pointer;\n}\n.select2-drop-mask {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  position: fixed;\n  left: 0;\n  top: 0;\n  min-height: 100%;\n  min-width: 100%;\n  height: auto;\n  width: auto;\n  opacity: 0;\n  z-index: 9998;\n  /* styles required for IE to work */\n  background-color: #FFF;\n  filter: alpha(opacity=0);\n}\n.select2-drop {\n  width: 100%;\n  margin-top: -1px;\n  position: absolute;\n  z-index: 9999;\n  top: 100%;\n  background: #FFF;\n  color: #000;\n  border: 1px solid #666;\n  border-top: 0;\n  border-radius: 0 0 2px 2px;\n  -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);\n}\n.select2-drop.select2-drop-above {\n  margin-top: 1px;\n  border-top: 1px solid #666;\n  border-bottom: 0;\n  border-radius: 2px 2px 0 0;\n  -webkit-box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.15);\n}\n.select2-drop-active {\n  border: 1px solid #CCC;\n  border-top: none;\n}\n.select2-drop.select2-drop-above.select2-drop-active {\n  border-top: 1px solid #CCC;\n}\n.select2-drop-auto-width {\n  border-top: 1px solid #666;\n  width: auto;\n}\n.select2-drop-auto-width .select2-search {\n  padding-top: 4px;\n}\n.select2-container .select2-choice .select2-arrow {\n  display: inline-block;\n  width: 18px;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  /*border-left: 1px solid @gray6;\n    border-radius: 0 2px 2px 0;*/\n  background-clip: padding-box;\n  /* background: @grayc;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #ccc), color-stop(0.6, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    background-image: -moz-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#eeeeee', endColorstr = '@grayc', GradientType = 0);\n    background-image: linear-gradient(to top, #ccc 0%, #eee 60%);*/\n}\n.select2-container .select2-choice .select2-arrow b {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: url(\"../images/select2.png\") no-repeat 0 1px;\n}\n.select2-search {\n  display: inline-block;\n  width: 100%;\n  min-height: 26px;\n  margin: 0;\n  padding-left: 4px;\n  padding-right: 4px;\n  position: relative;\n  z-index: 10000;\n  white-space: nowrap;\n}\n.select2-search input {\n  width: 100%;\n  height: auto !important;\n  min-height: 26px;\n  padding: 4px 20px 4px 5px;\n  margin: 0;\n  outline: 0;\n  border: 1px solid #666;\n  border-radius: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background: #FFF url(\"../images/select2.png\") no-repeat 100% -22px;\n  /* background: url(\"../images/select2.png\") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/\n}\n.select2-drop.select2-drop-above .select2-search input {\n  margin-top: 4px;\n}\n.select2-search input.select2-active {\n  background: #FFF url(\"../images/select2-spinner.gif\") no-repeat 100%;\n  /* background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/\n}\n.select2-container-active .select2-choice,\n.select2-container-active .select2-choices {\n  border: 1px solid #CCC;\n  outline: none;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n}\n.select2-dropdown-open .select2-choice {\n  border-bottom-color: transparent;\n  -webkit-box-shadow: 0 1px 0 #FFF inset;\n  box-shadow: 0 1px 0 #FFF inset;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: #FFF;\n  /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(to top, #fff 0%, #eee 50%);*/\n}\n.select2-dropdown-open.select2-drop-above .select2-choice,\n.select2-dropdown-open.select2-drop-above .select2-choices {\n  border: 1px solid #CCC;\n  border-top-color: transparent;\n  /* background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center top, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center top, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(to bottom, #fff 0%, #eee 50%);*/\n}\n.select2-dropdown-open .select2-choice .select2-arrow {\n  background: transparent;\n  border-left: none;\n  filter: none;\n}\n.select2-dropdown-open .select2-choice .select2-arrow b {\n  background-position: -18px 1px;\n}\n.select2-hidden-accessible {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n/* results */\n.select2-results {\n  max-height: 200px;\n  padding: 0 0 0 0px;\n  /* margin: 4px 0px 4px 0;*/\n  margin: 0px;\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.select2-results ul.select2-result-sub {\n  margin: 0;\n  padding-left: 0;\n}\n.select2-results li {\n  list-style: none;\n  display: list-item;\n  background-image: none;\n  border-top: 1px solid #CCC;\n  color: #333333;\n}\n.select2-results li.select2-result-with-children > .select2-result-label {\n  font-weight: bold;\n}\n.select2-results .select2-result-label {\n  padding: 3px 7px 4px;\n  margin: 0;\n  cursor: pointer;\n  min-height: 1em;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.select2-results-dept-1 .select2-result-label {\n  padding-left: 20px;\n}\n.select2-results-dept-2 .select2-result-label {\n  padding-left: 40px;\n}\n.select2-results-dept-3 .select2-result-label {\n  padding-left: 60px;\n}\n.select2-results-dept-4 .select2-result-label {\n  padding-left: 80px;\n}\n.select2-results-dept-5 .select2-result-label {\n  padding-left: 100px;\n}\n.select2-results-dept-6 .select2-result-label {\n  padding-left: 110px;\n}\n.select2-results-dept-7 .select2-result-label {\n  padding-left: 120px;\n}\n.select2-results .select2-highlighted {\n  background: #999999;\n  color: #FFF;\n}\n.select2-results li em {\n  background: #feffde;\n  font-style: normal;\n}\n.select2-results .select2-highlighted em {\n  background: transparent;\n}\n.select2-results .select2-highlighted ul {\n  background: #FFF;\n  color: #000;\n}\n.select2-results .select2-no-results,\n.select2-results .select2-searching,\n.select2-results .select2-selection-limit {\n  background: #F4F4F4;\n  display: list-item;\n  padding-left: 5px;\n}\n/*\ndisabled look for disabled choices in the results dropdown\n*/\n.select2-results .select2-disabled.select2-highlighted {\n  color: #666;\n  background: #F4F4F4;\n  display: list-item;\n  cursor: default;\n}\n.select2-results .select2-disabled {\n  background: #F4F4F4;\n  display: list-item;\n  cursor: default;\n}\n.select2-results .select2-selected {\n  display: none;\n}\n.select2-more-results.select2-active {\n  background: #F4F4F4 url(\"../images/select2-spinner.gif\") no-repeat 100%;\n}\n.select2-more-results {\n  background: #F4F4F4;\n  display: list-item;\n}\n/* disabled styles */\n.select2-container.select2-container-disabled .select2-choice {\n  background-color: #F4F4F4;\n  background-image: none;\n  border: 1px solid #DDD;\n  cursor: default;\n}\n.select2-container.select2-container-disabled .select2-choice .select2-arrow {\n  background-color: #F4F4F4;\n  background-image: none;\n  border-left: 0;\n}\n.select2-container.select2-container-disabled .select2-choice abbr {\n  display: none;\n}\n/* multiselect */\n.select2-container-multi .select2-choices {\n  height: auto !important;\n  height: 1%;\n  margin: 0;\n  padding: 0 5px 0 0;\n  position: relative;\n  border: 1px solid #666;\n  cursor: text;\n  overflow: hidden;\n  background-color: red;\n  /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(1%, #eee), color-stop(15%, #fff));\n    background-image: -webkit-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: -moz-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);*/\n}\n.select2-locked {\n  padding: 3px 5px 3px 5px !important;\n}\n.select2-container-multi .select2-choices {\n  min-height: 26px;\n}\n.select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #CCC;\n  outline: none;\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n}\n.select2-container-multi .select2-choices li {\n  float: left;\n  list-style: none;\n}\nhtml[dir=\"rtl\"] .select2-container-multi .select2-choices li {\n  float: right;\n}\n.select2-container-multi .select2-choices .select2-search-field {\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n.select2-container-multi .select2-choices .select2-search-field input {\n  padding: 5px;\n  margin: 1px 0;\n  font-size: 100%;\n  color: #666;\n  outline: 0;\n  border: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background: transparent !important;\n}\n.select2-container-multi .select2-choices .select2-search-field input.select2-active {\n  background: #FFF url(\"../images/select2-spinner.gif\") no-repeat 100% !important;\n}\n.select2-default {\n  color: #999999 !important;\n}\n.select2-container-multi .select2-choices .select2-search-choice {\n  padding: 3px 5px 3px 18px;\n  margin: 3px 0 3px 5px;\n  position: relative;\n  line-height: 13px;\n  color: #333333;\n  cursor: default;\n  border: 1px solid #666;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 0 2px #FFF inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0 2px #FFF inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n  background-clip: padding-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #e4e4e4;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#f4f4f4', GradientType=0);\n  /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(20%, #f4f4f4), color-stop(50%, #f0f0f0), color-stop(52%, #e8e8e8), color-stop(100%, #eee));\n    background-image: -webkit-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: -moz-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: linear-gradient(to top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);*/\n}\nhtml[dir=\"rtl\"] .select2-container-multi .select2-choices .select2-search-choice {\n  margin-left: 0;\n  margin-right: 5px;\n}\n.select2-container-multi .select2-choices .select2-search-choice .select2-chosen {\n  cursor: default;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus {\n  background: #d4d4d4;\n}\n.select2-search-choice-close {\n  display: block;\n  width: 12px;\n  height: 13px;\n  position: absolute;\n  right: 3px;\n  top: 4px;\n  font-size: 1px;\n  outline: none;\n  background: url(\"../images/select2.png\") right top no-repeat;\n}\nhtml[dir=\"rtl\"] .select2-search-choice-close {\n  right: auto;\n  left: 3px;\n}\n.select2-container-multi .select2-search-choice-close {\n  left: 3px;\n}\n.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover {\n  background-position: right -11px;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close {\n  background-position: right -11px;\n}\n/* disabled styles */\n.select2-container-multi.select2-container-disabled .select2-choices {\n  background-color: #F4F4F4;\n  background-image: none;\n  border: 1px solid #DDD;\n  cursor: default;\n}\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice {\n  padding: 3px 5px 3px 5px;\n  border: 1px solid #DDD;\n  background-image: none;\n  background-color: #F4F4F4;\n}\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close {\n  display: none;\n  background: none;\n}\n/* end multiselect */\n.select2-result-selectable .select2-match,\n.select2-result-unselectable .select2-match {\n  text-decoration: underline;\n}\n.select2-offscreen,\n.select2-offscreen:focus {\n  clip: rect(0 0 0 0) !important;\n  width: 1px !important;\n  height: 1px !important;\n  border: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  position: absolute !important;\n  outline: 0 !important;\n  left: 0px !important;\n  top: 0px !important;\n}\n.select2-display-none {\n  display: none;\n}\n.select2-measure-scrollbar {\n  position: absolute;\n  top: -10000px;\n  left: -10000px;\n  width: 100px;\n  height: 100px;\n  overflow: scroll;\n}\n.form-control .select2-choice {\n  border: 0;\n  border-radius: 2px;\n}\n.form-control .select2-choice .select2-arrow {\n  border-radius: 0 2px 2px 0;\n}\n.form-control.select2-container {\n  height: auto !important;\n  padding: 0;\n}\n.form-control.select2-container.select2-dropdown-open {\n  border-color: #CCC;\n  border-radius: 2px 2px 0 0;\n}\n.form-control .select2-container.select2-dropdown-open .select2-choices {\n  border-radius: 2px 2px 0 0;\n}\n.form-control.select2-container .select2-choices {\n  border: 0 !important;\n  border-radius: 2px;\n}\n.control-group.warning .select2-container .select2-choice,\n.control-group.warning .select2-container .select2-choices,\n.control-group.warning .select2-container-active .select2-choice,\n.control-group.warning .select2-container-active .select2-choices,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.warning .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #C09853 !important;\n}\n.control-group.warning .select2-container .select2-choice div {\n  border-left: 1px solid #C09853 !important;\n  background: #FCF8E3 !important;\n}\n.control-group.error .select2-container .select2-choice,\n.control-group.error .select2-container .select2-choices,\n.control-group.error .select2-container-active .select2-choice,\n.control-group.error .select2-container-active .select2-choices,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.error .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #B94A48 !important;\n}\n.control-group.error .select2-container .select2-choice div {\n  border-left: 1px solid #B94A48 !important;\n  background: #F2DEDE !important;\n}\n.control-group.info .select2-container .select2-choice,\n.control-group.info .select2-container .select2-choices,\n.control-group.info .select2-container-active .select2-choice,\n.control-group.info .select2-container-active .select2-choices,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.info .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #3A87AD !important;\n}\n.control-group.info .select2-container .select2-choice div {\n  border-left: 1px solid #3A87AD !important;\n  background: #D9EDF7 !important;\n}\n.control-group.success .select2-container .select2-choice,\n.control-group.success .select2-container .select2-choices,\n.control-group.success .select2-container-active .select2-choice,\n.control-group.success .select2-container-active .select2-choices,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.success .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #468847 !important;\n}\n.control-group.success .select2-container .select2-choice div {\n  border-left: 1px solid #468847 !important;\n  background: #DFF0D8 !important;\n}\n.form-control .select2-choice {\n  border: 0;\n  border-radius: 2px;\n}\n.form-control .select2-choice .select2-arrow {\n  border-radius: 0 2px 2px 0;\n}\n.form-control.select2-container {\n  height: auto !important;\n  padding: 0;\n}\n.form-control.select2-container.select2-dropdown-open {\n  border-color: #CCC;\n  border-radius: 2px 2px 0 0;\n}\n.form-control .select2-container.select2-dropdown-open .select2-choices {\n  border-radius: 2px 2px 0 0;\n}\n.form-control.select2-container .select2-choices {\n  border: 0 !important;\n  border-radius: 2px;\n}\n.control-group.warning .select2-container .select2-choice,\n.control-group.warning .select2-container .select2-choices,\n.control-group.warning .select2-container-active .select2-choice,\n.control-group.warning .select2-container-active .select2-choices,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.warning .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #C09853 !important;\n}\n.control-group.warning .select2-container .select2-choice div {\n  border-left: 1px solid #C09853 !important;\n  background: #FCF8E3 !important;\n}\n.control-group.error .select2-container .select2-choice,\n.control-group.error .select2-container .select2-choices,\n.control-group.error .select2-container-active .select2-choice,\n.control-group.error .select2-container-active .select2-choices,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.error .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #B94A48 !important;\n}\n.control-group.error .select2-container .select2-choice div {\n  border-left: 1px solid #B94A48 !important;\n  background: #F2DEDE !important;\n}\n.control-group.info .select2-container .select2-choice,\n.control-group.info .select2-container .select2-choices,\n.control-group.info .select2-container-active .select2-choice,\n.control-group.info .select2-container-active .select2-choices,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.info .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #3A87AD !important;\n}\n.control-group.info .select2-container .select2-choice div {\n  border-left: 1px solid #3A87AD !important;\n  background: #D9EDF7 !important;\n}\n.control-group.success .select2-container .select2-choice,\n.control-group.success .select2-container .select2-choices,\n.control-group.success .select2-container-active .select2-choice,\n.control-group.success .select2-container-active .select2-choices,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.success .select2-container-multi.select2-container-active .select2-choices {\n  border: 1px solid #468847 !important;\n}\n.control-group.success .select2-container .select2-choice div {\n  border-left: 1px solid #468847 !important;\n  background: #DFF0D8 !important;\n}\n.section-ficha {\n  border-bottom: 1px solid #3F3F3F;\n}\n@media (min-width: 1200px) {\n  .section-ficha .purchaseBtn--view {\n    padding-left: 2em;\n  }\n}\n.ficha {\n  background: #F4F4F4;\n  /* Ficha EST */\n}\n.ficha .info {\n  background-color: #DDD;\n}\n.ficha .info a {\n  color: #555555;\n}\n.ficha .info a:hover {\n  color: #222222;\n}\n.ficha .info .well {\n  background-color: #eeeeee;\n}\n.ficha .info .well .radio {\n  margin-top: 0;\n}\n.ficha .info .item-wrapper {\n  width: 100%;\n}\n.ficha h3 {\n  font-weight: bold;\n  color: #333333;\n}\n.ficha .label-default {\n  border-radius: 0;\n  background: #eeeeee;\n  color: #333333;\n  font-weight: normal;\n  line-height: 2.14285714;\n}\n.ficha .item-rating {\n  color: #F2F2F2;\n  border: 1px solid #F2F2F2;\n  border-radius: 0;\n  background: none ;\n}\n.ficha .tooltip-footer h6 {\n  float: left;\n}\n.ficha .tooltip-footer i {\n  color: #FFF;\n}\n.ficha .item-image img {\n  width: 100%;\n}\n.ficha .well .btn {\n  text-align: left;\n  white-space: normal;\n}\n.ficha button.costo_promo {\n  margin-top: 5px;\n}\n.ficha button.costo_promo .tiempo {\n  font-size: 12px;\n  font-weight: normal;\n}\n.ficha button.costo_promo .texto {\n  font-size: 17.1px;\n  font-weight: bold;\n  margin-bottom: 0px;\n  white-space: normal;\n}\n.ficha .caja_descuento {\n  margin-top: -18px;\n}\n.ficha .caja_descuento .fa-caret-up {\n  width: 100%;\n  text-align: center;\n}\n.ficha .caja_descuento .mensaje {\n  background-color: #222222;\n}\n.ficha .caja_descuento .mensaje .signo {\n  font-size: 21px;\n  text-align: right;\n}\n.ficha .caja_descuento .mensaje .texto {\n  font-size: 12px;\n}\n@media (max-width: 767px) {\n  .ficha .caja_descuento .mensaje .texto {\n    font-size: 18px;\n  }\n}\n.ficha .caja_descuento .tit_original,\n.ficha .caja_descuento .fecha_tiempo,\n.ficha .caja_descuento .director,\n.ficha .caja_descuento .actores,\n.ficha .caja_descuento .generos {\n  font-size: 12px;\n}\n.ficha .caja_descuento .redes_sociales ul.list-inline li:last-child {\n  display: block;\n  padding-top: 5px;\n  width: 90px;\n}\n.ficha .series {\n  /* .col_temporada ul li:first-child {border-bottom: 2px solid @grayd;}\n    .col_datos ul li:first-child {border-bottom: 2px solid @grayd;}*/\n}\n.ficha .series .tabla {\n  display: table;\n  width: 100%;\n}\n.ficha .series .tabla.detalle_compras {\n  background: #e6e6e6;\n}\n.ficha .series .col_temporada ul,\n.ficha .series .col_datos ul {\n  list-style-type: none;\n  display: block;\n  padding: 0;\n  margin: 0;\n}\n.ficha .series .col_temporada ul h5,\n.ficha .series .col_datos ul h5 {\n  margin: 0;\n  padding: 8px;\n  font-weight: bold;\n}\n.ficha .series .col_temporada ul li,\n.ficha .series .col_datos ul li {\n  display: block;\n}\n.ficha .series .col_temporada ul li a,\n.ficha .series .col_datos ul li.estaspor {\n  display: block;\n  padding: 8px 8px 8px 24px;\n  color: #222222;\n  text-decoration: none;\n}\n.ficha .series .col_datos ul li {\n  /* border-bottom: 1px solid @grayd;*/\n}\n.ficha .series .col_datos ul li a {\n  color: #F2F2F2;\n  text-decoration: none;\n  display: block;\n  padding: 8px;\n  height: 46px;\n  line-height: 46px;\n  padding: 0 8px;\n  width: 100%;\n  word-wrap: break-word;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ficha .series .col_datos ul li a:hover {\n  background-color: rgba(63, 63, 63, 0.5);\n}\n.ficha .series .col_datos ul li a.active {\n  background-color: rgba(63, 63, 63, 0.5);\n}\n.ficha .series .col_datos ul li i {\n  color: #FFF;\n}\n.ficha .series .col_datos ul.list-striped li:nth-of-type(2n+1) {\n  background: #3F3F3F;\n  background: rgba(63, 63, 63, 0.25);\n}\n.ficha .series .col_datos ul li.episode .btn i {\n  color: #FFF;\n}\n.ficha .series .col_datos .vistime,\n.ficha .series .col_datos .calification,\n.ficha .series .col_datos .date {\n  text-align: center;\n}\n.ficha .series .col_datos .vistime p,\n.ficha .series .col_datos .calification p,\n.ficha .series .col_datos .date p {\n  text-align: left;\n}\n.ficha .series .col_datos .vistime,\n.ficha .series .col_datos .calification,\n.ficha .series .col_datos .date {\n  text-align: center;\n}\n.ficha .series .col_datos .vistime-progress-last {\n  position: relative;\n  background-color: transparent;\n  height: 18px;\n}\n.ficha .series .col_datos .date {\n  font-size: 12px;\n}\n@media (min-width: 1200px) {\n  .ficha .box_data {\n    padding-left: 20px;\n  }\n}\n@media (max-width: 767px) {\n  .ficha .info.padding-2 {\n    padding: 10px;\n  }\n  .ficha .vistime {\n    margin-top: 10px;\n  }\n  .ficha h2 {\n    font-size: 23.8px;\n  }\n  .ficha .tooltip-score {\n    float: none;\n    margin: -5px 0 15px 0;\n  }\n  .ficha .redes_sociales ul.list-inline li {\n    padding: 10px 0 0 0;\n    float: none;\n    display: block;\n  }\n}\n.ficha .twitter-share-button {\n  display: inline-block;\n  margin-bottom: -5px;\n}\n.ficha .est-button-disabled {\n  background: none;\n  color: #999999;\n  border: 1px solid #999999;\n  cursor: default;\n}\n.ficha .est-button-disabled i {\n  color: #008C00;\n}\n.ficha .fb_iframe_widget {\n  display: inline !important;\n  z-index: 100;\n}\n@media (max-width: 1199px) and (min-width: 992px) {\n  .ficha .costo_promo {\n    max-width: 200px;\n  }\n  .ficha .btn_download {\n    max-width: 200px;\n  }\n}\n/* Estás por (hay que mover este parche a FORMS-claro.less)*/\n.sin-medio-pago .medios-pagos-web.padding-2,\n.renta-medio-pago .medios-pagos-web.padding-2 {\n  padding: 14px;\n}\n.sin-medio-pago .form-container,\n.renta-medio-pago .form-container {\n  padding: 20px;\n}\n.sin-medio-pago .form-container h5,\n.renta-medio-pago .form-container h5 {\n  padding-left: 5px;\n}\n@media (max-width: 767px) {\n  .sin-medio-pago .form-container,\n  .renta-medio-pago .form-container {\n    padding: 0;\n  }\n}\n@media (max-width: 767px) {\n  .sin-medio-pago .padding-2,\n  .renta-medio-pago .padding-2 {\n    padding: 10px;\n  }\n}\n.region-mexico .ficha .caja_descuento {\n  margin-top: -20px;\n  position: relative;\n}\n.region-mexico .ficha .caja_descuento .fa-caret-up {\n  position: absolute;\n  top: -18px;\n  left: 50%;\n  margin-left: -8px;\n  width: 16px;\n}\n.section-ficha-bg {\n  height: 100%;\n  /*overflow: hidden;*/\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -999;\n}\n.section-ficha-bg > img {\n  position: relative;\n  width: 100%;\n}\n.wrapper-img {\n  overflow: hidden;\n  width: 100%;\n}\n.section-ficha-bg > img.img-responsive {\n  opacity: 0.6;\n  width: 100%;\n}\n.img-responsive2 {\n  left: 50%;\n  margin-left: -640px;\n  position: relative;\n  opacity: 0.6;\n}\n/*se setea por el tamaño de la img*/\n.section-ficha .item-wrapper {\n  /*   display: block;*/\n}\n.section-ficha .item-wrapper img {\n  width: 100%;\n}\n.ficha {\n  background: none;\n}\n.ficha.temporada {\n  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 14.13%, rgba(0, 0, 0, 0.7) 100%);\n  margin: 0;\n  width: 100%;\n}\n.img-responsive3 {\n  height: 150%;\n  left: 50%;\n  margin-left: calc(-25% - 640px);\n  opacity: 0.5;\n  overflow: hidden;\n  position: relative;\n}\n.section-ficha-bg2 {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: -99;\n}\n.col_datos.col-sm-12.serie-contents {\n  position: relative;\n}\n.section-ficha .fecha_tiempo ul {\n  line-height: 35px;\n}\n.season-loading {\n  position: absolute;\n  top: 60px;\n  left: 50%;\n  margin-left: -25px;\n}\n/*.season-loading {\nanimation: seasonfade 0.2s;\n}\n\n@keyframes seasonfade {\n    from { opacity: 0.2; }\n    to   { opacity: 1; }\n}*/\n.devicetype-mobile.layout-fichabts .section-ficha .play {\n  opacity: 1;\n  visibility: visible;\n}\n.card-button-prices {\n  background: #0071bd;\n  border: #147fef;\n  color: white;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.28);\n}\n.card-button-prices:hover {\n  background: #14579f;\n  color: white !important;\n  box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.6);\n}\n.box_data {\n  position: inherit;\n}\n.disabled .precio {\n  display: none;\n}\n/* RESULTADO DE BUSQUEDA\n-------------------------------------------------- */\n@media (min-width: 1920px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-xl_blur.jpg) no-repeat left top #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 1919px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-lg_blur.jpg) no-repeat left top #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 1199px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-md_blur.jpg) no-repeat left top #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 991px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-sm_blur.jpg) no-repeat left top #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 767px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 34px #000;\n    background-size: 100%;\n  }\n}\n@media (max-width: 360px) {\n  body.layout-respuesta-buscador {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 72px #000;\n    background-size: 100%;\n  }\n}\n.resultado-busqueda {\n  background-color: #222222;\n}\n.resultado-busqueda .row-even {\n  background-color: #333333;\n}\n.resultado-busqueda h3 {\n  color: #FFF !important;\n}\n@media (max-width: 767px) {\n  .resultado-busqueda .tooltip-score {\n    padding-top: 0;\n    margin: 0;\n  }\n  .resultado-busqueda h2 {\n    font-size: 10px;\n  }\n  .resultado-busqueda h3 {\n    font-size: 15.4px !important;\n  }\n}\n.resultado-busqueda img {\n  height: auto !important;\n}\n.highlight {\n  text-decoration: underline;\n}\n@media (max-width: 767px) {\n  .sugerencia-buscador-respuesta h4 {\n    font-size: 13.72px;\n  }\n}\n/* DESTACADO - RESULTADO DE BUSQUEDA\n-------------------------------------------------- */\n.section-carrousel .carousel.slide.destacado.resultado-busqueda {\n  padding-bottom: 20px;\n  background: rgba(0, 0, 0, 0.75);\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_box {\n  height: 485px;\n  overflow: hidden;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .carousel-indicators li {\n  box-shadow: 0 1px 2px #000000;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {\n  font-size: 25.2px;\n  color: #FFF;\n  text-shadow: 0 1px 2px #000000;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado {\n  position: relative;\n  top: 0px;\n  left: 0px;\n  z-index: 0;\n  height: 535px;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado img.blur {\n  filter: blur(13px);\n  -webkit-filter: blur(13px);\n  -moz-filter: blur(13px);\n  -o-filter: blur(13px);\n  -ms-filter: blur(13px);\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {\n  position: absolute;\n  top: 15px;\n  z-index: 1;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .carousel-inner {\n  position: absolute;\n  top: 60px;\n  left: 0px;\n  z-index: 1;\n  border: 0;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda a.carousel-control {\n  position: absolute;\n  z-index: 10;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .section-buscador,\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda {\n  background: none !important;\n}\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .section-buscador h3,\n.section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda h3 {\n  color: #FFF !important;\n}\n@media (max-width: 1199px) {\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {\n    top: 15px;\n  }\n}\n@media (max-width: 991px) {\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .bkg_destacado {\n    min-width: 1024px;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {\n    top: 0px;\n  }\n}\n@media (min-width: 768px) {\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .ficha.resultado-busqueda .box-tit {\n    display: block;\n    width: 540px;\n    height: 30px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n@media (max-width: 767px) {\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda {\n    height: 440px;\n    background-color: #333333;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .box-tit span {\n    font-size: 18px;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {\n    font-size: 23.8px;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {\n    top: 0px;\n  }\n}\n@media (max-width: 479px) {\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda {\n    height: 295px;\n    background-color: #333333;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda h2 {\n    font-size: 18.2px;\n  }\n  .section-carrousel .carousel.slide.destacado.resultado-busqueda .titulo-buscado {\n    top: -5px;\n    margin-right: 5px;\n  }\n}\n/* DESTACADO - GENERO\n-------------------------------------------------- */\n.section-sugerencia-genero {\n  background-color: #333333;\n}\n@media (max-width: 767px) {\n  .section-sugerencia-genero h4 {\n    font-size: 15.4px;\n  }\n}\n@media (max-width: 768px) {\n  .section-sugerencia-genero .item-wrapper img {\n    height: auto;\n  }\n}\n/* Listado Busqueda no encontrada\n-------------------------------------------------- */\nul.listado {\n  color: #999999;\n  font-weight: normal;\n  margin-left: 0px;\n  margin-top: 25px;\n  padding-left: 18px;\n  font-size: 18px;\n}\nul.listado li {\n  font-size: 18px;\n  font-family: Roboto;\n  font-weight: normal;\n  color: inherit;\n}\n@media (min-width: 991px) {\n  ul.listado li {\n    line-height: 25px;\n    font-size: 18px;\n  }\n}\n@media (max-width: 991px) {\n  ul.listado li {\n    font-size: 15px !important;\n    line-height: 16px;\n    margin-bottom: 5px;\n  }\n}\nul.listado li span {\n  color: #FFF;\n}\n.section-buscadorcarrousel {\n  padding-bottom: 35px;\n  padding-top: 25px;\n}\n.mi-cuenta {\n  background-color: #232323;\n  /* Headers Fijos */\n  /* Headers Fijos */\n  /* HISTORIAL */\n  /*--- VISTIME PROGRESS HISTORIAL*/\n  /*--- FIN VISTIME PROGRESS HISTORIAL*/\n  /* FIN HISTORIAL */\n  /* REDES SOCIALES */\n  /* FIN REDES SOCIALES */\n  /* PROMOCIONES */\n  /* FIN PROMOCIONES  */\n}\n.mi-cuenta .nav-pills > li.active > a,\n.mi-cuenta .nav-pills > li.active > a:hover,\n.mi-cuenta .nav-pills > li.active > a:focus {\n  color: #000;\n}\n.mi-cuenta .item-rating {\n  /*background: @white;\n    color: @gray-darker;\n    border: 1px solid @gray;*/\n}\n.mi-cuenta .tooltip-score {\n  float: left;\n  color: #FFF;\n  cursor: default;\n}\n.mi-cuenta .tooltip-score i {\n  cursor: pointer;\n  font-size: 1em;\n}\n.mi-cuenta .box-dispositivos.impar {\n  background-color: #333333;\n}\n.mi-cuenta .box-dispositivos.impar span.deviceName {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mi-cuenta .box-dispositivos img {\n  width: 50px;\n}\n.mi-cuenta h3 {\n  font-weight: normal;\n  color: #FFF !important;\n}\n.mi-cuenta .cont-title-fixed.stickOnScroll-on {\n  left: 0;\n  width: 100%;\n  z-index: 5;\n}\n.mi-cuenta .cont-title-fixed.stickOnScroll-on .container {\n  padding: 0;\n}\n.mi-cuenta .cont-title-fixed.stickOnScroll-on h3.hasStickOnScroll {\n  display: block;\n  z-index: 2;\n  padding: 10px 0px;\n  width: 100%;\n  background: #232323;\n  box-shadow: 0px 4px 9px #000;\n  padding-left: 30px;\n}\n@media (max-width: 767px) {\n  .mi-cuenta .cont-title-fixed.stickOnScroll-on h3.hasStickOnScroll {\n    background-position: 0 -7px;\n  }\n}\n.mi-cuenta .cont-title-fixed.stickOnScroll-on .hasStickOnScroll {\n  display: block;\n  z-index: 2;\n  width: 100%;\n  background-color: #232323;\n  box-shadow: 0px 4px 9px #000;\n  padding: 0 30px;\n  margin: 0px;\n}\n.mi-cuenta .cont-title-fixed.stickOnScroll-on .hasStickOnScroll h3 {\n  margin-top: 12px;\n}\n.mi-cuenta .box-dispositivos-asociados .impar {\n  background-color: #3F3F3F;\n}\n.mi-cuenta .btn-dispositivos-asociados a {\n  text-decoration: none;\n  color: #FFF;\n}\n.mi-cuenta .descarga-silverlight {\n  height: 39px;\n  position: relative;\n}\n.mi-cuenta .box-historial.impar {\n  background-color: #333333;\n}\n.mi-cuenta .box-historial .img-horinzontal {\n  width: 100%;\n}\n.mi-cuenta .box-historial .img-vertical {\n  width: 100%;\n}\n.mi-cuenta .box-historial .disabled .img-horinzontal,\n.mi-cuenta .box-historial .disabled .img-vertical {\n  opacity: 0.5;\n}\n.mi-cuenta .box-historial .disabled h4 {\n  opacity: 0.5;\n}\n.mi-cuenta .box-historial .disabled .vistime-progress-last {\n  opacity: 0.5;\n}\n.mi-cuenta .box-historial .disabled .label-default-hd {\n  opacity: 0.5;\n}\n.mi-cuenta .box-historial .disabled .tooltip-score {\n  opacity: 0.5;\n}\n.mi-cuenta .box-historial .disabled .datos {\n  opacity: 0.5;\n}\n.mi-cuenta .tit-peli h4 {\n  margin: 0px;\n  font-weight: bold;\n}\n.mi-cuenta .label {\n  border-radius: 0em;\n}\n.mi-cuenta.section-micuentahistorial .nav-pills {\n  margin-bottom: 10px;\n  padding: 5px 0 0;\n}\n.mi-cuenta h3 .nav-pills {\n  margin-top: -8px;\n}\n.mi-cuenta .vistime-progress-last {\n  height: 16px;\n  left: 10%;\n  margin-top: 3px;\n  overflow: hidden;\n  position: relative;\n  width: 80%;\n  z-index: 99;\n}\n.mi-cuenta .vistime-progress-bar-wrapper {\n  padding-top: 5px;\n  line-height: 0;\n  text-align: left;\n  margin: 0;\n  padding: 0;\n}\n.mi-cuenta .vistime-data-info {\n  display: inline-block;\n  float: left;\n  /*display:none*/\n}\n.mi-cuenta .vistime-data-info label {\n  display: inline-block;\n  color: #FFF;\n  font-size: 10px;\n  position: absolute;\n  text-align: center;\n  top: 9px;\n}\n.mi-cuenta .vistime-data-info .vistime-data-time {\n  display: none;\n}\n.mi-cuenta .vistime-data-info .vistime-data-seconds {\n  display: none;\n}\n.mi-cuenta .vistime-data-info .vistime-data-minutes {\n  display: block;\n}\n.mi-cuenta .vistime-data-date {\n  display: block;\n  float: left;\n  font-size: 10px;\n  margin-left: 6px;\n  width: 137px;\n}\n.mi-cuenta .jcarousel-skin-recentlywatched .vistime-data-date {\n  display: none;\n}\n.mi-cuenta .vistime-progress-bar {\n  background-color: #6D6D6D;\n  display: inline-block;\n  height: 3px;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n}\n.mi-cuenta .vistime-bar {\n  background-color: #ED080D;\n  height: 3px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n}\n.mi-cuenta .vistime-data-duration .vistime-data-time {\n  display: none;\n}\n.mi-cuenta .vistime-data-duration .vistime-data-seconds {\n  display: none;\n}\n.mi-cuenta .vistime-data-duration .vistime-data-minutes {\n  display: block;\n}\n.mi-cuenta .vistime-data-duration {\n  display: inline-block;\n  color: #000;\n  float: right;\n  /*display:none;*/\n}\n.mi-cuenta .vistime-data-duration label {\n  display: inline-block;\n  color: #999999;\n  font-size: 0.8125em;\n  font-size: 10px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 9px;\n}\n.mi-cuenta .vidrierawidgetficha-html {\n  display: none;\n}\n.mi-cuenta .vistime-data-date {\n  display: none !important;\n}\n.mi-cuenta .vistime-progress-last {\n  background: none;\n  padding: 1px;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  height: 25px;\n  z-index: 2;\n}\n.mi-cuenta .vistime-progress-last .vistime-progress-bar {\n  width: 100%;\n}\n.mi-cuenta .vistime-progress-last .vistime-data-info label {\n  top: 13px;\n}\n.mi-cuenta .vistime-progress-last .vistime-data-duration label {\n  right: 3px;\n  top: 13px;\n}\n.mi-cuenta .btn-fb {\n  background-color: #3B5998;\n  border-color: #3B5998;\n}\n.mi-cuenta .thumb-img-fb {\n  width: 65px;\n  height: 65px;\n  background-color: #666;\n}\n.mi-cuenta .fa-certificate {\n  color: #ea2f23;\n  float: left;\n  font-size: 77px;\n}\n.mi-cuenta .fa-certificate span {\n  color: #FFF;\n  font-size: 27px;\n  left: -43px;\n  position: relative;\n  top: -19px;\n}\n.mi-cuenta .app-img-descarga {\n  width: 64px;\n  height: auto !important;\n}\n.mi-cuenta .box-promociones {\n  margin-top: 6.66666667px;\n}\n.mi-cuenta .box-promociones .promo-icon span {\n  display: block;\n  height: 21px;\n  width: 67px;\n  color: #FFF;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 3px 0 0 5px;\n  text-transform: uppercase;\n}\n.mi-cuenta .box-promociones .fa-certificate {\n  font-size: 40px;\n  color: #FFF;\n  float: left;\n}\n.mi-cuenta .box-promociones .fa-certificate span {\n  color: #FFF;\n  font-size: 22px;\n  left: -25px;\n  position: relative;\n  top: -6px;\n}\n.mi-cuenta .box-promociones .fa-caret-right {\n  color: #222222;\n  float: left;\n  font-size: 50px;\n  position: relative;\n  top: 6px;\n  left: -7px;\n}\n.mi-cuenta .box-promociones .fa-caret-down {\n  color: #222222;\n  font-size: 50px;\n}\n.mi-cuenta .box-promociones .promo-titulos {\n  color: #FFF;\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .mi-cuenta .box-promociones span {\n    top: 10px;\n  }\n}\n@media (max-width: 767px) {\n  .mi-cuenta .box-promociones .fa-certificate {\n    padding-top: 0;\n  }\n}\n.mi-cuenta .box-promociones-open {\n  margin-bottom: 3.33333333px;\n}\n@media (min-width: 992px) {\n  .mi-cuenta .box-promociones-open img {\n    width: 160px;\n  }\n}\n@media (max-width: 991px) {\n  .mi-cuenta .box-promociones-open img {\n    width: 100%;\n  }\n  .mi-cuenta .box-promociones-open h4 {\n    margin-top: 0;\n  }\n}\n@media (max-width: 767px) {\n  .mi-cuenta .box-promociones-open .listado-titulos .impar {\n    background-color: #F4F4F4;\n  }\n}\n.mi-cuenta .box-promociones-open button.ver-detalles {\n  right: 0;\n  top: 0;\n}\n.mi-cuenta .box-promociones-open .info-promociones-open {\n  display: table;\n}\n.mi-cuenta .box-promociones-open .valor-desc span {\n  font-size: 28px;\n  font-weight: bold;\n  color: #FFF;\n}\n.mi-cuenta .box-promociones-open .valor-desc .cantidad-desc-titulos {\n  padding-top: 15px;\n}\n.mi-cuenta .box-promociones-open .valor-desc .titulos-disponibles {\n  color: #FFF;\n}\n@media (min-width: 768px) {\n  .mi-cuenta .box-promociones-open .valor-desc .titulos-disponibles {\n    padding-top: 15px;\n  }\n}\n.mi-cuenta .box-promociones-open .ver-mas-titulos {\n  background-color: white;\n  display: table;\n}\n@media (max-width: 991px) {\n  .mi-cuenta .vigencia {\n    padding-left: 5px;\n  }\n  .mi-cuenta .input-padding {\n    padding-top: 5px;\n  }\n  .mi-cuenta .dispositivos-asociados {\n    text-align: left;\n  }\n}\n@media (max-width: 1199px) and (min-width: 992px) {\n  .mi-cuenta .padding-label-0 {\n    padding-top: 0px;\n  }\n}\n@media (max-width: 767px) {\n  .mi-cuenta h4 {\n    font-size: 15.3px;\n  }\n  .mi-cuenta p {\n    font-size: 11.7px;\n  }\n  .mi-cuenta .app-img-descarga {\n    max-width: 100%;\n  }\n  .mi-cuenta .fa-certificate {\n    color: #ea2f23;\n    float: left;\n    font-size: 56px;\n    padding-top: 10px;\n  }\n  .mi-cuenta .fa-certificate span {\n    color: #FFF;\n    font-size: 27px;\n    left: -36px;\n    position: relative;\n    top: -12px;\n  }\n}\n.section-micuentacontrolpin .micuenta-title i.success {\n  color: #5cb85c;\n}\n/*@import \"slick.less\"; en desarrollo*/\n.ath-viewport * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.ath-viewport {\n  position: relative;\n  z-index: 2147483641;\n  pointer-events: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-text-size-adjust: none;\n  -moz-text-size-adjust: none;\n  -ms-text-size-adjust: none;\n  -o-text-size-adjust: none;\n  text-size-adjust: none;\n}\n.ath-modal {\n  pointer-events: auto !important;\n  background: rgba(0, 0, 0, 0.6);\n}\n.ath-mandatory {\n  background: #000;\n}\n.ath-container {\n  pointer-events: auto !important;\n  position: absolute;\n  z-index: 2147483641;\n  padding: 0.7em 0.6em;\n  width: 18em;\n  background: #eee;\n  background-size: 100% auto;\n  box-shadow: 0 0.2em 0 #d1d1d1;\n  font-family: Roboto;\n  font-size: 15px;\n  line-height: 1.5em;\n  text-align: center;\n}\n.ath-ios.ath-phone {\n  bottom: 1.8em;\n  left: 50%;\n  margin-left: -9em;\n}\n.ath-ios7.ath-tablet {\n  left: 0.7em;\n  top: 1.8em;\n}\n.ath-ios6.ath-tablet {\n  left: 5em;\n  top: 1.8em;\n}\n.ath-android {\n  right: 1.5em;\n  top: 1.8em;\n}\n/* close icon */\n.ath-container:before {\n  content: '';\n  position: relative;\n  display: block;\n  float: right;\n  margin: -0.7em -0.6em 0 0.5em;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAMAAABmmnOVAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAeHAAAHhwFd+hRDAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAHVQTFRFAAAAOTk5MzMzOzs7Nzc3QUFBQEBAPz8/Pj4+QUFBQEBAPz8/Pj4+QUFBQEBAPz8/QUFBPj4+Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pj4+Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/QEBAPz8/n3QmjwAAACZ0Uk5TAAkKDQ4zODk6OzxBQkNERUusrbG0tba7vL3Excbu8fL19fb3+PgucqJgAAACqklEQVR42sXc23LCIBAGYKy2pgft0WpP2vTA+z9i0+goCZAs7O7P3oWZTL5ZYAh7sca0MXmYG3jM7yfu4/TV1jdow01tX6cdg4UrGoN1FNM3a+GK1nBSzPYGrOJgsPZt1hrerYUrjoa9wjHgFI7B2veZWVk3tpCdWm07H30y8+4AIhedPFj7cW7wioABrggawIqIAaroGbYXzlGCUvQNnc0IUgwaQIoRA0QxagAoCAZ1BcmgrCAaVBVkg6IiwaCmSDIoKRINKopkg4IiwyCuyDIIKzINoopsg6CCYRBTsAxCCqZBRLGo2RcrtkLAwFaIGJgKIQNLIWZgKAQN2QpRg1dKoCmEDVkKcUOGQsGQrFAxJCqUDEkKNUOCQtFAVqgaiAplg69YFDAQFADDqAJiGFGADI1iF1XADAOKvqHSLApHFFBDRAE2BBVwQ0BRwOApfn8LGDxFEcOQAmeIK5CGmAJrCCvQBq8A8r9Zrw08qp6irvAGs/zpIr4XBQxf3nQsyhvwipABrQgbsIqYAamIG3CKnqH+LKDoGXbVwD84zDB4E4AZ4IqgAayIGKCKqMGYS5RiwOArlgUMnuJrWcAAUYwaAAqCQV1BMigriAZVBdmgqEgwqCmSDEqKRIOKItmgoMgwiCv6hkvaa6KKTIOoItsgqGAYxBQsg5CCaRBRsA0CCgEDWyFiYCqEDCyFmIGhEDRkK0QNmQphQ5ZC3JChUDAkK1QMiQolQ5JCzZCguNUzkBV3P4oGokLZQFKoGwgKgGFUATGMKECGQQXMYMxVTAE0RBVQQ0QBNgQVcENI8QwoBo8cUiszWYPz4OVi3bQ9cBQoQ0exblsvTDZwg6PYHNo/tE0XmvVwa4BxWBentgtnL+A8HHPxcnYaaBRoQ6twDY3iEW5oFI8Hwx/QxSE448b+MwAAAABJRU5ErkJggg==);\n  background-color: rgba(255, 255, 255, 0.8);\n  background-size: 50%;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  width: 2.7em;\n  height: 2.7em;\n  text-align: center;\n  overflow: hidden;\n  color: #a33;\n  z-index: 2147483642;\n}\n.ath-container.ath-icon:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  float: none;\n}\n.ath-mandatory .ath-container:before {\n  display: none;\n}\n.ath-container.ath-android:before {\n  float: left;\n  margin: -0.7em 0.5em 0 -0.6em;\n}\n.ath-container.ath-android.ath-icon:before {\n  position: absolute;\n  right: auto;\n  left: 0;\n  margin: 0;\n  float: none;\n}\n/* applied only if the application icon is shown */\n.ath-action-icon {\n  display: inline-block;\n  vertical-align: middle;\n  background-position: 50%;\n  background-repeat: no-repeat;\n  text-indent: -9999em;\n  overflow: hidden;\n}\n.ath-android .ath-action-icon {\n  width: 1.2em;\n  height: 1.8em;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAADcBAMAAAAig/QJAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAFtDAABbQwH5xg68AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAB5QTFRFAAAA////cXFxaWlp////ZmZmnJycoaGhpqam////1D9b6wAAAAV0Uk5TAAgJERExZxYzAAAAYklEQVRYw+3WoQ2AUBAE0SsBOiBUQEIDCArA4FFoHBaJxNItFYz/x5+xz282VmwJTdM0rRzbsS1e7Pm9zdgUVn491rkFmqZpSezEjqo/Sos1HoAEjdjgFmiapiWxG7tq/igfnYteFlnOWZEAAAAASUVORK5CYII=);\n  background-size: auto 100%;\n}\n.ath-ios7 .ath-action-icon {\n  width: 1.6em;\n  height: 1.6em;\n  background-image: url(data:image/png;base64,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);\n  margin-top: -0.3em;\n  background-size: auto 100%;\n}\n.ath-ios6 .ath-action-icon {\n  width: 1.8em;\n  height: 1.8em;\n  background-image: url(data:image/png;base64,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);\n  margin-bottom: 0.4em;\n  background-size: 100% auto;\n}\n.ath-container p {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  z-index: 2147483642;\n  text-shadow: 0 0.1em 0 #fff;\n  font-size: 1.1em;\n}\n.ath-ios.ath-phone:after {\n  content: '';\n  background: #eee;\n  position: absolute;\n  width: 2em;\n  height: 2em;\n  bottom: -0.9em;\n  left: 50%;\n  margin-left: -1em;\n  -webkit-transform: scaleX(0.9) rotate(45deg);\n  transform: scaleX(0.9) rotate(45deg);\n  box-shadow: 0.2em 0.2em 0 #d1d1d1;\n}\n.ath-ios.ath-tablet:after {\n  content: '';\n  background: #eee;\n  position: absolute;\n  width: 2em;\n  height: 2em;\n  top: -0.9em;\n  left: 50%;\n  margin-left: -1em;\n  -webkit-transform: scaleX(0.9) rotate(45deg);\n  transform: scaleX(0.9) rotate(45deg);\n  z-index: 2147483641;\n}\n.ath-android:after {\n  content: '';\n  background: #eee;\n  background: -webkit-linear-gradient(-45deg, rgba(238, 238, 238, 0) 0%, rgba(238, 238, 238, 0) 50%, #eeeeee 50%, #eeeeee 100%);\n  position: absolute;\n  width: 2em;\n  height: 2em;\n  top: -1.5em;\n  right: 0;\n}\n.ath-application-icon {\n  position: relative;\n  padding: 0;\n  border: 0;\n  margin: 0 auto 0.2em auto;\n  height: 6em;\n  width: 6em;\n  z-index: 2147483642;\n  box-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.3), inset 0 0.07em 0 rgba(255, 255, 255, 0.5);\n}\n/* OS specific classes */\n.ath-container.ath-ios .ath-application-icon {\n  border-radius: 1em;\n  box-shadow: 0 0.2em 0.4em rgba(0, 0, 0, 0.3), inset 0 0.07em 0 rgba(255, 255, 255, 0.5);\n  margin: 0 auto 0.4em auto;\n}\n@media only screen and (orientation: landscape) {\n  .ath-container.ath-phone {\n    width: 24em;\n  }\n  .ath-ios.ath-phone {\n    margin-left: -12em;\n  }\n  .ath-ios6:after {\n    left: 39%;\n  }\n}\n/*!\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: FontAwesome;\n  src: url('../fonts/fonts/fontawesome-webfont.eot?v=4.0.3');\n  src: url('../fonts/fonts/fontawesome-webfont.eot?#iefix&v=4.0.3') format('embedded-opentype'), url('../fonts/fonts/fontawesome-webfont.woff?v=4.0.3') format('woff'), url('../fonts/fonts/fontawesome-webfont.ttf?v=4.0.3') format('truetype'), url('../fonts/fonts/fontawesome-webfont.svg?v=4.0.3#fontawesomeregular') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n.fa {\n  display: inline-block;\n  font-family: FontAwesome;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.fa-2x {\n  font-size: 2em;\n}\n.fa-3x {\n  font-size: 3em;\n}\n.fa-4x {\n  font-size: 4em;\n}\n.fa-5x {\n  font-size: 5em;\n}\n.fa-fw {\n  width: 1.28571429em;\n  text-align: center;\n}\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.fa-ul > li {\n  position: relative;\n}\n.fa-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.fa-li.fa-lg {\n  left: -1.85714286em;\n}\n.fa-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n}\n.pull-right {\n  float: right;\n}\n.pull-left {\n  float: left;\n}\n.fa.pull-left {\n  margin-right: 0.3em;\n}\n.fa.pull-right {\n  margin-left: 0.3em;\n}\n.fa-spin {\n  -webkit-animation: spin 2s infinite linear;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(359deg);\n  }\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg);\n  }\n  100% {\n    -o-transform: rotate(359deg);\n  }\n}\n@-ms-keyframes spin {\n  0% {\n    -ms-transform: rotate(0deg);\n  }\n  100% {\n    -ms-transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.fa-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.fa-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.fa-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.fa-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.fa-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.fa-stack-1x,\n.fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.fa-stack-1x {\n  line-height: inherit;\n}\n.fa-stack-2x {\n  font-size: 2em;\n}\n.fa-inverse {\n  color: #fff;\n}\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\f000\";\n}\n.fa-music:before {\n  content: \"\\f001\";\n}\n.fa-search:before {\n  content: \"\\f002\";\n}\n.fa-envelope-o:before {\n  content: \"\\f003\";\n}\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n.fa-heart:before {\n  content: \"\\f004\";\n}\n.fa-star:before {\n  content: \"\\f005\";\n}\n.fa-star-o:before {\n  content: \"\\f006\";\n}\n.fa-user:before {\n  content: \"\\f007\";\n}\n.fa-user-o:before {\n  content: \"\\f2c0\";\n}\n.fa-film:before {\n  content: \"\\f008\";\n}\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n.fa-th:before {\n  content: \"\\f00a\";\n}\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n.fa-check:before {\n  content: \"\\f00c\";\n}\n.fa-times:before {\n  content: \"\\f00d\";\n}\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n.fa-signal:before {\n  content: \"\\f012\";\n}\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\f013\";\n}\n.fa-trash-o:before {\n  content: \"\\f014\";\n}\n.fa-home:before {\n  content: \"\\f015\";\n}\n.fa-file-o:before {\n  content: \"\\f016\";\n}\n.fa-clock-o:before {\n  content: \"\\f017\";\n}\n.fa-road:before {\n  content: \"\\f018\";\n}\n.fa-download:before {\n  content: \"\\f019\";\n}\n.fa-arrow-circle-o-down:before {\n  content: \"\\f01a\";\n}\n.fa-arrow-circle-o-up:before {\n  content: \"\\f01b\";\n}\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n.fa-play-circle-o:before {\n  content: \"\\f01d\";\n}\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\f01e\";\n}\n.fa-refresh:before {\n  content: \"\\f021\";\n}\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n.fa-lock:before {\n  content: \"\\f023\";\n}\n.fa-flag:before {\n  content: \"\\f024\";\n}\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n.fa-book:before {\n  content: \"\\f02d\";\n}\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n.fa-print:before {\n  content: \"\\f02f\";\n}\n.fa-camera:before {\n  content: \"\\f030\";\n}\n.fa-font:before {\n  content: \"\\f031\";\n}\n.fa-bold:before {\n  content: \"\\f032\";\n}\n.fa-italic:before {\n  content: \"\\f033\";\n}\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n.fa-list:before {\n  content: \"\\f03a\";\n}\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n.fa-video-camera:before {\n  content: \"\\f03d\";\n}\n.fa-picture-o:before {\n  content: \"\\f03e\";\n}\n.fa-pencil:before {\n  content: \"\\f040\";\n}\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n.fa-tint:before {\n  content: \"\\f043\";\n}\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\f044\";\n}\n.fa-share-square-o:before {\n  content: \"\\f045\";\n}\n.fa-check-square-o:before {\n  content: \"\\f046\";\n}\n.fa-arrows:before {\n  content: \"\\f047\";\n}\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n.fa-play:before {\n  content: \"\\f04b\";\n}\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n.fa-eject:before {\n  content: \"\\f052\";\n}\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n.fa-times-circle-o:before {\n  content: \"\\f05c\";\n}\n.fa-check-circle-o:before {\n  content: \"\\f05d\";\n}\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\f064\";\n}\n.fa-expand:before {\n  content: \"\\f065\";\n}\n.fa-compress:before {\n  content: \"\\f066\";\n}\n.fa-plus:before {\n  content: \"\\f067\";\n}\n.fa-minus:before {\n  content: \"\\f068\";\n}\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n.fa-plane:before {\n  content: \"\\f072\";\n}\n.fa-calendar:before {\n  content: \"\\f073\";\n}\n.fa-random:before {\n  content: \"\\f074\";\n}\n.fa-comment:before {\n  content: \"\\f075\";\n}\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n.fa-arrows-v:before {\n  content: \"\\f07d\";\n}\n.fa-arrows-h:before {\n  content: \"\\f07e\";\n}\n.fa-bar-chart-o:before {\n  content: \"\\f080\";\n}\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n.fa-facebook-official:before {\n  content: \"\\f230\";\n}\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n.fa-key:before {\n  content: \"\\f084\";\n}\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n.fa-comments:before {\n  content: \"\\f086\";\n}\n.fa-thumbs-o-up:before {\n  content: \"\\f087\";\n}\n.fa-thumbs-o-down:before {\n  content: \"\\f088\";\n}\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n.fa-heart-o:before {\n  content: \"\\f08a\";\n}\n.fa-sign-out:before {\n  content: \"\\f08b\";\n}\n.fa-linkedin-square:before {\n  content: \"\\f08c\";\n}\n.fa-thumb-tack:before {\n  content: \"\\f08d\";\n}\n.fa-external-link:before {\n  content: \"\\f08e\";\n}\n.fa-sign-in:before {\n  content: \"\\f090\";\n}\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n.fa-upload:before {\n  content: \"\\f093\";\n}\n.fa-lemon-o:before {\n  content: \"\\f094\";\n}\n.fa-phone:before {\n  content: \"\\f095\";\n}\n.fa-square-o:before {\n  content: \"\\f096\";\n}\n.fa-bookmark-o:before {\n  content: \"\\f097\";\n}\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n.fa-github:before {\n  content: \"\\f09b\";\n}\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n.fa-hdd-o:before {\n  content: \"\\f0a0\";\n}\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n.fa-hand-o-right:before {\n  content: \"\\f0a4\";\n}\n.fa-hand-o-left:before {\n  content: \"\\f0a5\";\n}\n.fa-hand-o-up:before {\n  content: \"\\f0a6\";\n}\n.fa-hand-o-down:before {\n  content: \"\\f0a7\";\n}\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n.fa-group:before,\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\f0c4\";\n}\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\f0c5\";\n}\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\f0c7\";\n}\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n.fa-google-plus:before {\n  content: \"\\f0d5\";\n}\n.fa-money:before {\n  content: \"\\f0d6\";\n}\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n.fa-sort-down:before,\n.fa-sort-asc:before {\n  content: \"\\f0dd\";\n}\n.fa-sort-up:before,\n.fa-sort-desc:before {\n  content: \"\\f0de\";\n}\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n.fa-linkedin:before {\n  content: \"\\f0e1\";\n}\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\f0e4\";\n}\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n.fa-comments-o:before {\n  content: \"\\f0e6\";\n}\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\f0ea\";\n}\n.fa-lightbulb-o:before {\n  content: \"\\f0eb\";\n}\n.fa-exchange:before {\n  content: \"\\f0ec\";\n}\n.fa-cloud-download:before {\n  content: \"\\f0ed\";\n}\n.fa-cloud-upload:before {\n  content: \"\\f0ee\";\n}\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n.fa-bell-o:before {\n  content: \"\\f0a2\";\n}\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n.fa-cutlery:before {\n  content: \"\\f0f5\";\n}\n.fa-file-text-o:before {\n  content: \"\\f0f6\";\n}\n.fa-building-o:before {\n  content: \"\\f0f7\";\n}\n.fa-hospital-o:before {\n  content: \"\\f0f8\";\n}\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n.fa-circle-o:before {\n  content: \"\\f10c\";\n}\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n.fa-circle:before {\n  content: \"\\f111\";\n}\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\f112\";\n}\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n.fa-folder-o:before {\n  content: \"\\f114\";\n}\n.fa-folder-open-o:before {\n  content: \"\\f115\";\n}\n.fa-smile-o:before {\n  content: \"\\f118\";\n}\n.fa-frown-o:before {\n  content: \"\\f119\";\n}\n.fa-meh-o:before {\n  content: \"\\f11a\";\n}\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n.fa-keyboard-o:before {\n  content: \"\\f11c\";\n}\n.fa-flag-o:before {\n  content: \"\\f11d\";\n}\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n.fa-code:before {\n  content: \"\\f121\";\n}\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n.fa-mail-reply-all:before {\n  content: \"\\f122\";\n}\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\f123\";\n}\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n.fa-crop:before {\n  content: \"\\f125\";\n}\n.fa-code-fork:before {\n  content: \"\\f126\";\n}\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\f127\";\n}\n.fa-question:before {\n  content: \"\\f128\";\n}\n.fa-info:before {\n  content: \"\\f129\";\n}\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n.fa-shield:before {\n  content: \"\\f132\";\n}\n.fa-calendar-o:before {\n  content: \"\\f133\";\n}\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n.fa-ticket:before {\n  content: \"\\f145\";\n}\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n.fa-minus-square-o:before {\n  content: \"\\f147\";\n}\n.fa-level-up:before {\n  content: \"\\f148\";\n}\n.fa-level-down:before {\n  content: \"\\f149\";\n}\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n.fa-pencil-square:before {\n  content: \"\\f14b\";\n}\n.fa-external-link-square:before {\n  content: \"\\f14c\";\n}\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\f150\";\n}\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\f151\";\n}\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\f152\";\n}\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\f153\";\n}\n.fa-gbp:before {\n  content: \"\\f154\";\n}\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\f155\";\n}\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\f156\";\n}\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\f157\";\n}\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\f158\";\n}\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\f159\";\n}\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n.fa-file:before {\n  content: \"\\f15b\";\n}\n.fa-file-text:before {\n  content: \"\\f15c\";\n}\n.fa-sort-alpha-asc:before {\n  content: \"\\f15d\";\n}\n.fa-sort-alpha-desc:before {\n  content: \"\\f15e\";\n}\n.fa-sort-amount-asc:before {\n  content: \"\\f160\";\n}\n.fa-sort-amount-desc:before {\n  content: \"\\f161\";\n}\n.fa-sort-numeric-asc:before {\n  content: \"\\f162\";\n}\n.fa-sort-numeric-desc:before {\n  content: \"\\f163\";\n}\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n.fa-youtube-square:before {\n  content: \"\\f166\";\n}\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n.fa-xing:before {\n  content: \"\\f168\";\n}\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n.fa-youtube-play:before {\n  content: \"\\f16a\";\n}\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n.fa-adn:before {\n  content: \"\\f170\";\n}\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n.fa-bitbucket-square:before {\n  content: \"\\f172\";\n}\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n.fa-long-arrow-down:before {\n  content: \"\\f175\";\n}\n.fa-long-arrow-up:before {\n  content: \"\\f176\";\n}\n.fa-long-arrow-left:before {\n  content: \"\\f177\";\n}\n.fa-long-arrow-right:before {\n  content: \"\\f178\";\n}\n.fa-apple:before {\n  content: \"\\f179\";\n}\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n.fa-android:before {\n  content: \"\\f17b\";\n}\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n.fa-trello:before {\n  content: \"\\f181\";\n}\n.fa-female:before {\n  content: \"\\f182\";\n}\n.fa-male:before {\n  content: \"\\f183\";\n}\n.fa-gittip:before {\n  content: \"\\f184\";\n}\n.fa-sun-o:before {\n  content: \"\\f185\";\n}\n.fa-moon-o:before {\n  content: \"\\f186\";\n}\n.fa-archive:before {\n  content: \"\\f187\";\n}\n.fa-bug:before {\n  content: \"\\f188\";\n}\n.fa-vk:before {\n  content: \"\\f189\";\n}\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n.fa-arrow-circle-o-right:before {\n  content: \"\\f18e\";\n}\n.fa-arrow-circle-o-left:before {\n  content: \"\\f190\";\n}\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\f191\";\n}\n.fa-dot-circle-o:before {\n  content: \"\\f192\";\n}\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\f195\";\n}\n.fa-plus-square-o:before {\n  content: \"\\f196\";\n}\nbody.android-install-app h3 {\n  margin: 0;\n}\n@media (min-width: 768px) {\n  body.android-install-app h3 {\n    margin-top: 30px;\n  }\n}\nbody.android-install-app .android-pict {\n  width: 100%;\n  max-width: 308px;\n  padding: 30px 10px 0px 10px;\n}\n@media (max-width: 360px) {\n  body.android-install-app .android-pict {\n    width: 200px;\n    padding-top: 0;\n  }\n  body.android-install-app h3 {\n    margin: 0;\n  }\n}\n@media (max-width: 767px) {\n  body.android-install-app h3,\n  body.android-install-app p {\n    text-align: center;\n  }\n  body.android-install-app .padding-2 {\n    padding: 0px 20px;\n  }\n}\n.margin-top-10-percent {\n  margin-top: 10%;\n}\n@media (max-width: 767px) {\n  .margin-top-10-percent {\n    margin: 0;\n  }\n}\n@media (max-width: 767px) {\n  .poster-mobile-hor.padding-1 {\n    padding-top: 0;\n  }\n}\n/*### -multilevel push menu-###*/\n.multilevelpushmenu_wrapper {\n  position: absolute;\n  /* overflow: hidden;*/\n  min-width: 100%;\n  min-height: 100%;\n  margin: 0;\n  padding: 0;\n  bottom: 16px;\n}\n.multilevelpushmenu_wrapper h2 {\n  background-color: #1a1a1a;\n  font-size: 14px;\n  font-weight: bold;\n  color: #fafafa;\n  padding: 3px 20px;\n  line-height: 50px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.multilevelpushmenu_wrapper .levelHolderClass {\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  /*background: #1a1a1a;\n    background-color: #2e2e2e;*/\n  background-color: rgba(0, 0, 0, 0.75);\n  width: auto;\n  min-height: 100%;\n  height: 100%;\n  border-radius: 4px;\n  border: 1px solid #232323;\n  /*solo cuando se necesite-revisar*/\n}\n.multilevelpushmenu_wrapper .levelHolderClass {\n  overflow-y: auto;\n}\n.multilevelpushmenu_wrapper .ltr {\n  margin-left: -100%;\n  left: 0;\n}\n.multilevelpushmenu_wrapper .rtl {\n  margin-right: -100%;\n  right: 0;\n}\n.multilevelpushmenu_wrapper .multilevelpushmenu_inactive {\n  /*  background: #2e6196;*/\n  overflow-y: hidden;\n}\n.multilevelpushmenu_wrapper ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.multilevelpushmenu_wrapper li {\n  cursor: pointer;\n  border-top: 1px solid #424242;\n  padding: 3px 15px;\n  line-height: 50px;\n}\n.multilevelpushmenu_wrapper li:last-child {\n  /* border-bottom: 1px solid #295685;*/\n}\n.multilevelpushmenu_wrapper li:hover {\n  background-color: #424242;\n}\n.multilevelpushmenu_wrapper a {\n  display: block;\n  outline: none;\n  overflow: hidden;\n  font-size: 14px;\n  text-decoration: none;\n  color: #fff;\n}\n.multilevelpushmenu_wrapper a:hover {\n  color: #ffe;\n}\n.multilevelpushmenu_wrapper .backItemClass {\n  display: block;\n}\n.multilevelpushmenu_wrapper .floatRight {\n  float: right;\n}\n.multilevelpushmenu_wrapper .floatLeft {\n  float: left;\n}\n.multilevelpushmenu_wrapper .cursorPointer {\n  cursor: pointer;\n}\n/*ellipsis revisar camellcase claselevelholderclas*/\n.chapter-sel .levelholderClass.ltr a span,\n.chapter-sel .multilevelpushmenu_wrapper a span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 160px;\n}\n.chapter-sel,\n.chapter-sel02 {\n  position: relative;\n}\n.chapter-sel > div#menu,\n.chapter-sel02 > div#menu {\n  bottom: 27px;\n  right: -28px;\n  height: 365px !important;\n  min-height: 365px !important;\n  position: absolute;\n}\nnav.multilevelpushmenu_wrapper {\n  height: 343px !important;\n  min-height: 343px !important;\n}\n.chapter-sel > div#menuResponsive,\n.chapter-sel02 > div#menuResponsive {\n  bottom: 34px;\n  right: 0px;\n  position: absolute;\n}\n.chapter-sel3 a span.episode-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 160px;\n}\n.levelHolderClass h2 i.fa.pull-left {\n  margin-right: 10px;\n  line-height: 50px;\n}\n.levelHolderClass.ltr {\n  z-index: 1;\n  /*(fix de  error animacion)*/\n}\n.multilevelpushmenu_wrapper a .fa {\n  line-height: 50px;\n}\n/**/\n/*.levelHolderClass.ltr ul li a .fa\n{\n  display: none !important;\n}\n*/\n/*hover ruedita*/\n.multilevelpushmenu_wrapper .levelHolderClass ul li {\n  background-color: rgba(35, 35, 35, 0.35);\n}\n.multilevelpushmenu_wrapper .levelHolderClass ul li.selected {\n  background-color: rgba(63, 63, 63, 0.5);\n  /*color: #d8d8d8;*/\n}\n.multilevelpushmenu_wrapper li:hover {\n  background-color: rgba(35, 35, 35, 0.9);\n}\n.multilevelpushmenu_wrapper .levelHolderClass ul li:hover {\n  background-color: rgba(35, 35, 35, 0.9);\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  bottom: 100%;\n  border: solid transparent;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after {\n  border-bottom-color: #fff;\n  border-width: 6px;\n  left: 33%;\n  margin-left: -6px;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  border-bottom-color: #ddd;\n  border-width: 7px;\n  left: 33%;\n  margin-left: -7px;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  top: 100%;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after {\n  border-bottom-color: transparent;\n  border-top-color: rgba(35, 35, 35, 0.95);\n  border-width: auto;\n  left: auto;\n  margin-left: auto;\n  right: 23%;\n  margin-right: -6px;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  border-bottom-color: transparent;\n  border-top-color: rgba(35, 35, 35, 0.95);\n  border-width: 8px;\n  left: auto;\n  margin-left: auto;\n  right: 23%;\n  margin-right: -8px;\n}\n.chapter-sel2 #menuResponsive {\n  bottom: 34px;\n  height: 245px !important;\n  min-height: 245px !important;\n  position: absolute;\n  right: -27px;\n}\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper {\n  height: 235px !important;\n  min-height: 235px !important;\n}\n.levelHolderClass.ltr .levelHolderClass.ltr {\n  opacity: 0;\n}\n.levelHolderClass.ltr.multilevelpushmenu_inactive h2 {\n  display: none;\n}\n.levelHolderClass.ltr.multilevelpushmenu_inactive .levelHolderClass.ltr {\n  opacity: 1;\n}\n.levelHolderClass.ltr.multilevelpushmenu_inactive .levelHolderClass.ltr h2 {\n  display: block;\n}\n.levelHolderClass.ltr {\n  transition: all 0.2s ease;\n}\n.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu li a,\n.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu li a {\n  width: 270px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu,\n.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu {\n  min-width: auto;\n  width: 280px;\n}\nvideoph5 button {\n  cursor: pointer;\n}\nvideoph5.fullscreen {\n  left: 0;\n  position: fixed;\n  top: 0;\n}\nvideoph5 vph5-media,\n.void {\n  display: block;\n  height: 100%;\n  left: 0;\n  top: 0;\n  width: 100%;\n}\nvideoph5 video,\n.void {\n  display: block;\n  border: 0 none;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  top: 0;\n  width: 100%;\n}\n.fullscreen {\n  width: 100%;\n  height: 100%;\n}\nvideoph5 .vgTimeDisplay {\n  display: table-cell;\n  font-family: Roboto;\n  font-size: 18px;\n  width: auto;\n}\nvideoph5 vph5-fullscreen-button,\n.void {\n  cursor: pointer;\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  width: 50px;\n}\nvideoph5 vph5-buffering,\n.void {\n  position: absolute;\n  top: 50%;\n  width: 60px;\n  height: 60px;\n  z-index: 2;\n  margin-top: -60px;\n  margin-left: -30px;\n  left: 50%;\n}\nvideoph5 vph5-buffering {\n  /*background-color: rgba(0,0,0,.8);*/\n}\nvideoph5 vph5-controls .btn-default {\n  color: #f2f2f2;\n  border: none;\n  font-size: 16px;\n}\nvideoph5 vph5-controls .btn-default .fa {\n  font-size: 22px;\n  line-height: 31px;\n}\n.vph5-player .label.label-player {\n  border: 1px solid #ccc;\n  display: table;\n  float: left;\n  font-size: 100%;\n  line-height: normal;\n  margin: 10px 5px 10px 0;\n  padding: 10px;\n  position: relative;\n}\n.vph5-player .item-salir {\n  background: transparent;\n  /*color: #ccc;*/\n  display: table;\n  height: 30px;\n  left: 10px;\n  line-height: 28px;\n  padding: 0 10px 0 0;\n  position: absolute;\n  top: 10px;\n  z-index: 3;\n}\nvph5-container,\n.void {\n  /* background: pink none repeat scroll 0 0;*/\n  display: block;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n  position: relative;\n  overflow: hidden;\n}\n.videoph5-container {\n  height: 100%;\n  width: 100%;\n}\n.videoph5-container.full-player {\n  display: block;\n  height: 100%;\n  position: relative;\n  transition: all 0.5s ease-out 0s;\n  width: 100%;\n}\n.vph5-player {\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\nvideoph5.videoph5-cont,\n.void {\n  display: table;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n/*fix fullscreen*/\nvideoph5,\n.void {\n  display: block;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\nvideoph5 vph5-controls,\n.void {\n  display: block;\n  height: 165px;\n  position: absolute;\n  top: calc(100% - 165px);\n  width: 100%;\n  z-index: 3;\n  background-image: linear-gradient(rgba(0, 0, 0, 0), #000000);\n}\nvideoph5 vph5-controls .controls-container {\n  /* background-color: #000;\n    background-color: rgba(0, 0, 0, 0.7);*/\n  display: table;\n  height: 50px;\n  left: 1%;\n  position: absolute;\n  padding: 0 5px;\n  width: 98%;\n  bottom: 0;\n}\nvideoph5 vph5-play-pause-button,\n.void {\n  cursor: pointer;\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  width: 50px;\n}\nvideoph5 vph5-play-pause-button .btn {\n  width: 40px;\n}\nvideoph5 vph5-time-display,\n.void {\n  color: #ffffff;\n  cursor: default;\n  display: table-cell;\n  font-family: Roboto;\n  font-size: 16px;\n  text-align: center;\n  vertical-align: middle;\n  width: 75px;\n}\nvph5-play-pause-button.controls {\n  padding-right: 30px;\n}\n.sub-controls {\n  padding-left: 30px;\n}\n.play-bar {\n  background: #272727 none repeat scroll 0 0;\n}\n.play-bar-wrapper {\n  padding: 0 15px;\n  text-align: center;\n  width: 100%;\n}\n@media (max-width: 767px) {\n  .play-bar-wrapper.is_live {\n    visibility: hidden;\n  }\n}\n.vc-seekbar {\n  left: 0;\n  position: absolute;\n  z-index: 999;\n}\n.vc {\n  -moz-user-select: none;\n  background-color: #1b1b1b;\n  color: #777777;\n  height: 28px;\n  position: relative;\n  width: 100%;\n  z-index: 9000;\n}\n.vc-seeker {\n  background-color: #3F3F3F;\n  border: 1px solid #3F3F3F;\n  cursor: pointer;\n  display: inline-block;\n  height: 6px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  margin: 0;\n  border-radius: 6px;\n  position: absolute;\n  transition: height 0.25s linear 0s, top 0.25s linear 0s;\n}\n.vc-player > .vc > .vc-seeker {\n  background-color: #444444;\n  height: 8px;\n  top: -5px;\n}\n.vc-range {\n  height: 20px;\n  width: 20px;\n  line-height: 0;\n  margin: -8px 0 0 -5px;\n  text-align: center;\n  transition: height 0.25s linear 0s, width 0.25s linear 0s, margin 0.25s linear 0s, line-height 0.25s linear 0s;\n}\n.vc-range-little {\n  display: inline-block;\n  transition: height 0.25s linear 0s, width 0.25s linear 0s, opacity 0s linear 0.2s;\n  vertical-align: middle;\n  background-color: #F2F2F2;\n  border: 1px solid #F2F2F2;\n  border-radius: 100%;\n  height: 18px;\n  width: 18px;\n  margin-top: 1px;\n  opacity: 1;\n  box-shadow: 0px 0px 8px 2px #f2f2f2;\n}\n.vc-loadingbar {\n  background-color: #DDDDDD;\n  display: inline-block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 0;\n}\n.vc-progressbar {\n  background-color: #F2F2F2;\n  background-size: 30px 30px !important;\n  display: inline-block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 0;\n}\n.vc-progressbarbuffer {\n  background-color: rgba(221, 221, 221, 0.003);\n  display: inline-block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.vc-progressbar,\n.vc-progressbarbuffer {\n  border-radius: 4px 0 0 4px;\n}\nvideoph5 finplayer-plugin {\n  background: rgba(0, 0, 0, 0) none repeat scroll 0 0 !important;\n  display: table !important;\n  height: 100%;\n  width: 100%;\n  z-index: auto !important;\n}\nvideoph5 finplayer-plugin .finplayer-wrapper {\n  display: table;\n  height: 100%;\n  width: 100%;\n}\nvideoph5 vph5-dubsub-selector.vph5-dubsub-selector {\n  cursor: pointer;\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  width: 50px;\n}\n.play-bar-wrapper {\n  padding: 0 15px;\n  width: 100%;\n}\n.controls-container > * {\n  display: table-cell;\n  vertical-align: middle;\n}\n.sub-controls > *,\n.controls {\n  padding: 0 3px;\n}\n.controls-container .sub-controls > div,\n.controls-container .sub-controls vph5-dropdown {\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n}\n.controls-container .play-bar {\n  border-radius: 4px;\n  height: 5px;\n  position: relative;\n  width: 100%;\n}\n.controls-container .btn-group .btn .filter-option {\n  display: inline-block;\n  overflow: hidden;\n  text-align: left;\n  width: 100%;\n}\n/*controls container*/\n.videoph5-container .dropdown-menu {\n  border: medium none;\n}\n.videoph5-container .dropdown-menu > li > a {\n  border-bottom: 1px solid #232323;\n  line-height: 50px;\n  white-space: nowrap;\n}\n.videoph5-container .dropdown-menu > li:last-child > a {\n  border-bottom: none;\n}\n.videoph5-container .dropdown-submenu:hover > a::after {\n  border-left-color: #fff;\n}\n.videoph5-container .btn-group .dropdown-menu {\n  /*background-color: #2e2e2e;*/\n  border: 1px solid #232323;\n  box-sizing: border-box;\n  min-width: 100%;\n  left: 0;\n  width: 200px;\n  z-index: 1035;\n  padding: 0px;\n}\n.videoph5-container .controls-container .btn-group .dropdown-menu {\n  left: auto;\n  right: -13px;\n}\n.videoph5-container .controls-container vph5-quality-selector .btn-group .dropdown-menu {\n  right: -4px;\n}\n.dropdown-wrappper {\n  display: none;\n}\n.open .dropdown-wrappper {\n  display: block;\n}\n.open .dropdown-wrappper > .dropdown-menu {\n  display: block;\n}\n.open .dropdown-wrappper > a {\n  outline: 0;\n}\n.videoph5-container .btn-group .dropdown-menu.inner {\n  /* background-color: #2e2e2e;*/\n}\n.open > .dropdown-toggle.btn-default {\n  /* background-color: #393939;\n      border-color: #393939;*/\n  color: #d8d8d8;\n}\n.videoph5-container .btn-group .dropdown-menu > li > a:hover,\n.videoph5-container .btn-group .dropdown-menu > li > a:focus {\n  /* background-color: #424242;\n      color: #d8d8d8;*/\n}\n.videoph5-container .btn-group .dropdown-menu .btn-default.active .videoph5-container .btn-group .dropdown-menu .btn-default.focus .videoph5-container .btn-group .dropdown-menu .btn-default:hover,\n.videoph5-container .btn-group .dropdown-menu .btn-default:focus,\n.videoph5-container .btn-group .dropdown-menu .btn-default:active {\n  /* background-color: #393939;\n      border-color: #393939;*/\n  color: #d8d8d8;\n}\n.videoph5-container .controls-container .btn-group .dropdown-menu {\n  bottom: 15px;\n}\n.videoph5-container .controls-container .dropdown-wrappper {\n  position: absolute;\n  height: 240px;\n  /*background: pink;*/\n  bottom: 25px;\n  right: -10px;\n  min-height: 200px;\n  width: 200px;\n}\n/**/\nvph5-volume {\n  position: relative;\n}\nvideoph5 vph5-volume-bar {\n  cursor: pointer;\n  height: 80px;\n  position: absolute;\n  right: 6px;\n  text-align: center;\n  top: -80px;\n  vertical-align: middle;\n  width: 30px;\n}\n@media not all, not all {\n  videoph5 vph5-volume-bar {\n    opacity: 0.5;\n  }\n}\n.vc-range-little2 {\n  background-color: #F2F2F2;\n  border: 1px solid #F2F2F2;\n  box-shadow: 0px 0px 8px 2px #f2f2f2;\n  border-radius: 100%;\n  height: 18px;\n  width: 18px;\n  display: inline-block;\n  position: absolute;\n  top: -2px;\n  left: -7px;\n  opacity: 1;\n}\nvideoph5 vph5-volume-bar .verticalVolumeBar {\n  height: 80px;\n  position: absolute;\n  width: 30px;\n}\nvideoph5 vph5-volume-bar .volumeBackground {\n  background-color: #3F3F3F;\n  /* border: 1px solid @gray2;*/\n  height: 80px;\n  left: 12px;\n  position: absolute;\n  top: 0;\n  width: 4px;\n  border-radius: 4px;\n}\nvideoph5 vph5-volume-bar .volumeValue {\n  background-color: #F2F2F2;\n  height: 100%;\n  position: absolute;\n  width: 4px;\n  border-radius: 4px;\n}\nvideoph5 vph5-volume-bar .volumeClickArea {\n  height: 100%;\n  position: absolute;\n  width: 40px;\n  left: -15px;\n}\n/*ancho volume-mute*/\nvph5-mute-button .btn {\n  width: 38px;\n}\n.vph5-player {\n  /*fix selector capitulos fin player -pasar a less*/\n}\n.vph5-player .dropdown-menu > li > a:hover,\n.vph5-player .dropdown-menu > li > a:focus {\n  background-color: rgba(35, 35, 35, 0.9);\n}\n.vph5-player .dropdown-menu li a {\n  text-align: left;\n}\n.vph5-player .dropdown-menu li {\n  background-color: rgba(35, 35, 35, 0.35);\n}\n.vph5-player .dropdown-menu li:first-child {\n  /* background-color: fade(@black , 80%); */\n}\n.vph5-player .dropdown-menu li.selected {\n  background-color: rgba(63, 63, 63, 0.5);\n  /* color: #d8d8d8;*/\n}\n.vph5-player vph5-dropdown span.filter-option {\n  max-width: 290px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n@media (max-width: 990px) {\n  .vph5-player vph5-dropdown span.filter-option {\n    max-width: 190px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n}\nvideoph5 div.scrollablearea {\n  position: absolute;\n}\n.controls-title-wrapper {\n  position: absolute;\n  bottom: 60px;\n}\n.ficha-player .box_data .fecha_tiempo .item-year {\n  font-weight: bold;\n}\nvideoph5 vph5-pause-plugin {\n  display: block;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\nvideoph5 vph5-pause-plugin {\n  color: inherit !important;\n  height: 100%;\n  width: 100%;\n}\n.pausa-wrapper {\n  background: rgba(0, 0, 0, 0.8) none repeat scroll 0 0;\n  color: #ccc;\n  height: 100%;\n  padding-top: 50px;\n  position: relative;\n}\nvph5-pause-plugin .section-ficha {\n  height: 100%;\n  width: 100%;\n  border-bottom: none;\n}\nvph5-pause-plugin .section-ficha.vertical-align {\n  display: table-cell;\n  vertical-align: middle;\n}\nvph5-pausemobile-plugin {\n  height: 160px;\n  width: 100%;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n  /*PASAR A MIXIN*/\n  background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);\n  /* FF3.6+ */\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(5%, rgba(0, 0, 0, 0.25)), color-stop(26%, rgba(0, 0, 0, 0.75)), color-stop(58%, #000000), color-stop(100%, #000000));\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);\n  /* IE10+ */\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 5%, rgba(0, 0, 0, 0.75) 26%, #000000 58%, #000000 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);\n  /* IE6-9 */\n}\nvph5-pausemobile-plugin .pausa-mobile-wrapper {\n  margin: 20px 10px 0 10px;\n  color: #ccc;\n  display: block;\n}\nvph5-pausemobile-plugin .pausa-mobile-wrapper .h2_content_title {\n  font-size: 30px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\nvideoph5 pause-plugin {\n  display: block;\n  position: absolute;\n  top: 0;\n  z-index: 0;\n}\nvideoph5 finplayer-plugin {\n  color: red;\n  display: block;\n  position: absolute;\n  top: 0;\n  z-index: 50;\n}\nvideoph5 pause-plugin {\n  color: inherit !important;\n  height: 100%;\n  min-height: 320px;\n  width: 100%;\n}\npause-plugin .section-ficha {\n  left: 0;\n  margin-top: -170px;\n  position: absolute;\n  top: 50%;\n}\n.pausa-wrapper .content {\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.pausa-wrapper .content.center-wrapper {\n  display: table;\n  vertical-align: middle;\n}\n.pausa-wrapper .h2_content_title {\n  color: #fafafa;\n  font-size: 42px;\n}\n.pausa-wrapper .fecha_tiempo {\n  margin-left: 10px;\n}\n.vph5-player .section-7 {\n  display: block;\n  position: absolute;\n  right: 2em;\n  top: 0;\n  width: 600px;\n  z-index: 3;\n}\n.video-container {\n  display: block;\n  height: 100%;\n  width: 100%;\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive embed,\n.embed-responsive iframe,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n.vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9 {\n  background-color: #000000;\n}\n/**/\n.videoph5-container .dropdown-menu {\n  background-color: transparent;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n.vph5-player vph5-dropdown span.filter-option {\n  padding-right: 10px;\n}\n.vph5-player .dropup .btn-default .caret {\n  margin-left: 10px;\n}\n.vph5-player .selector-episodio-fin .button-label2.dropdown-toggle::before,\n.vph5-player .selector-temporada-fin .button-label2.dropdown-toggle::before {\n  content: \"\";\n  border-left: 1px solid #464646;\n  height: 100%;\n  display: block;\n  position: absolute;\n  right: 29px;\n  top: 0px;\n}\n.vph5-player .dropdown-menu > li > a {\n  color: #F2F2F2;\n}\n.vph5-player ul.dropdown-menu:after,\n.vph5-player ul.dropdown-menu:before {\n  top: 100%;\n}\n.vph5-player ul.dropdown-menu:after {\n  border-bottom-color: transparent;\n  border-top-color: rgba(35, 35, 35, 0.95);\n  border-width: auto;\n  left: auto;\n  margin-left: auto;\n  right: 23%;\n  margin-right: -6px;\n}\n.vph5-player ul.dropdown-menu:before {\n  border-bottom-color: transparent;\n  border-top-color: rgba(35, 35, 35, 0.95);\n  border-width: 8px;\n  left: auto;\n  margin-left: auto;\n  right: 23%;\n  margin-right: -8px;\n}\n:-webkit-full-screen {\n  background-color: #000000;\n}\n.vph5-player ::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n.vph5-player ::-webkit-scrollbar-button:end:increment,\n.vph5-player ::-webkit-scrollbar-button:start:decrement {\n  height: 10px;\n  display: block;\n  background-color: #2b2b2b;\n  border-color: #3b3b3b;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n}\n.vph5-player ::-webkit-scrollbar-track-piece {\n  background-color: #3b3b3b;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n}\n.vph5-player ::-webkit-scrollbar-thumb:vertical {\n  height: 40px;\n  background-color: #666;\n  border: 1px solid #3b3b3b;\n  -webkit-border-radius: 6px;\n}\n.finplayer-wrapper2 .btn-default {\n  background-color: rgba(35, 35, 35, 0.85);\n  border-color: #232323;\n  color: #666666;\n}\n.recover-pin {\n  line-height: 32px;\n}\n.videoph5-container vph5-channel-selector .btn-group .dropdown-menu {\n  width: 240px;\n}\n.videoph5-container vph5-channel-selector .dropdown-menu > li > a {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.brand01,\n.on-live {\n  padding: 0;\n}\n.brand01 img,\n.on-live span2 {\n  margin-bottom: 6px;\n}\n.on-live span {\n  float: left;\n  margin-left: 10px;\n}\n.vph5-player vph5-channel-selector ul.dropdown-menu:after,\n.vph5-player vph5-channel-selector ul.dropdown-menu:before {\n  right: 18%;\n}\n.controls-container .disable {\n  color: #272727;\n}\n.vph5-player .controls-container .btn {\n  text-overflow: initial;\n  height: 45px;\n}\n.section-fin-series .image.container2 {\n  display: block;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.countdown-container {\n  font-size: 20px;\n}\n.countdown-container .countdown {\n  /* color: #ff0000;*/\n}\n.vph5-player .section-fin-series .item-img {\n  display: block;\n  float: left;\n  height: auto;\n  max-width: 100%;\n  position: relative;\n}\n.vph5-player .section-fin-series .item-wrapper2 {\n  margin: 0 auto;\n  max-width: 675px;\n}\n.vph5-player .section-fin-series {\n  margin-top: 120px;\n}\n.vph5-player .section-fin-series {\n  max-width: 675px;\n  /*small-fix problema imagen chica*/\n}\n.vph5-player .section-fin-series .dropdown-menu {\n  height: 285px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.vph5-finplayer vph5-exitbutton-plugin .item-salir {\n  left: 10px;\n  top: 10px;\n  display: inherit;\n}\n.fin-player .image.container2 {\n  left: 15px;\n  position: absolute;\n  top: 0;\n}\n.fin-player .image.container2 img {\n  width: 100%;\n}\n/*---*/\nvph5-container.fin-player {\n  display: table;\n  height: 100%;\n  transition: all 0.4s ease-out 0s;\n}\nvph5-finplayer-plugin {\n  transition: all 0.4s ease-out 0s;\n  opacity: 1;\n  transition: 1s all;\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n}\n.vph5-player .jcarousel.jcarousel-2.horizontal .scrollwrapper {\n  min-height: 250px;\n}\n.vph5-player .jcarousel.jcarousel-1 {\n  height: 252px;\n}\n.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper {\n  min-height: 250px;\n}\n.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper {\n  min-height: 250px;\n}\n.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 {\n  width: 440px;\n}\n.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 img {\n  max-width: 440px;\n}\n.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n  width: 170px;\n}\n.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 img {\n  max-width: 170px;\n}\nvph5-container.fin-player {\n  /*  display: table;*/\n  /*esto es para fullscreen*/\n  height: 100%;\n  /*transition: all 1.4s ease-out 0s;*/\n}\n/*logo fin player*/\nvph5-finplayer-fondo .brand,\n.brand {\n  display: block;\n  left: 25px;\n  position: absolute;\n  top: 10px;\n  z-index: 1;\n}\n/*mas fin*/\n.vph5-finplayer vph5-media {\n  margin: 180px 0 0;\n  padding: 0 24px;\n  height: auto;\n  position: relative;\n  transition: all 0.4s ease-out 0s;\n}\n.vph5-fin-movie .finplayer-wrapper2 {\n  margin-top: 140px;\n}\n@media (max-width: 767px) {\n  .fin-player vph5-media {\n    margin-top: 60px;\n    padding: 0;\n  }\n  .vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9 {\n    padding-bottom: 75%;\n  }\n}\n/*MISC*/\n.vph5-finplayer a,\n.videoph5-container .dropdown-menu > li > a {\n  cursor: pointer;\n}\n.vph5-finplayer .item-salir {\n  /*left: 30px;\n  top: 80px;*/\n}\n.vph5-player .tooltip-score .fa {\n  font-size: 1.8em;\n}\n.vph5-player .tooltip-score .msg .fa {\n  font-size: 1.4em;\n  line-height: 1.4em;\n}\n.vph5-player .tooltip-score .msg span {\n  color: #fafafa;\n}\n.vph5-player .tooltip-score .msg .fa.check {\n  color: #008c00;\n}\n.fa.fa_green {\n  color: #08b755;\n  margin-top: 4px;\n}\n/*estrellitas*/\n.finplayer-wrapper2,\n.fin-player {\n  color: #fff;\n}\n.finplayer-wrapper2 .tooltip-score .fa,\n.fin-player .tooltip-score .fa {\n  margin: 5px;\n}\n.finplayer-wrapper2 .tooltip-score .fa.empty,\n.fin-player .tooltip-score .fa.empty {\n  /* border: 1px solid red;\n border-color: #1c1c1c;*/\n}\n.finplayer-wrapper2 .tooltip-score.panel-default,\n.fin-player .tooltip-score.panel-default {\n  background: #3e3e3e none repeat scroll 0 0;\n  border: medium none;\n  border-radius: 6px;\n  padding: 10px;\n  min-height: 40px;\n}\n.finplayer-wrapper2 .panel.panel-primary,\n.fin-player .panel.panel-primary {\n  background-color: #1a1a1a;\n  border-color: #bbbbbb;\n  margin-top: 30px;\n}\nvph5-finplayer-fondo {\n  display: block;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n  width: 100%;\n}\n.fin-player-bg1 {\n  background: rgba(0, 0, 0, 0.8) repeat scroll 0 0;\n  height: 100%;\n}\n.fin-player-bg2 {\n  /*background: rgba(0, 0, 0, 0) radial-gradient(ellipse at center center , #1d1d1d 0%, #0f0f0f 100%) repeat scroll 0 0;*/\n  height: 100%;\n}\n/*/*/\n/*.vph5-finplayer-fondo > img\n{\n  z-index: -3;\n  height: 100%; \n  position: absolute; \n  top: 0;\n  left: 0;\n}\n*/\n.vph5-player .open .dropdown-toggle.btn-default:hover,\n.vph5-player .btn-default:hover,\n.vph5-player .open .dropdown-toggle.btn-default:focus,\n.vph5-player .btn-default:focus,\n.vph5-player .open .dropdown-toggle.btn-default:active,\n.vph5-player .btn-default:active,\n.vph5-player .open .dropdown-toggle.btn-default.active,\n.vph5-player .btn-default.active {\n  /* background-color: rgba(35, 35, 35, 0.85);\n     border-color: #232323;*/\n}\n.vph5-finplayer .dropup .btn-default:hover,\n.vph5-finplayer .dropup .btn-default:focus,\n.vph5-finplayer .dropup .btn-default:active,\n.vph5-finplayer .dropup .btn-default.active,\n.vph5-finplayer .dropup .open .dropdown-toggle.btn-default {\n  background-color: rgba(35, 35, 35, 0.85);\n  border-color: #232323;\n}\n.vph5-player .season-sel > * {\n  float: left;\n  margin-right: 10px;\n}\n.vph5-player .cargando2-player {\n  display: table;\n  height: 35px;\n  line-height: 35px;\n  vertical-align: middle;\n  padding-top: 12px;\n}\n@media (max-width: 991px) {\n  .angular-ratings-02 .tooltip-score .fa,\n  .finplayer-wrapper2 .angular-ratings-02 .tooltip-score .fa,\n  .finplayer .angular-ratings-02 .tooltip-score .fa {\n    font-size: 1.5em;\n    margin: 2px;\n  }\n}\n@media (min-width: 991px) {\n  .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,\n  .finplayer-wrapper2 .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,\n  .finplayer .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa {\n    font-size: 1.5em;\n    margin: 2px;\n  }\n}\n/*hack for chrome -hotfix-carrusel*/\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .vph5-player .jcarousel-separador {\n    display: table-cell;\n    float: inherit;\n    margin: 0px;\n    background: inherit;\n    width: 15px;\n    padding: 1px;\n    border-left: 2px solid #202020;\n    border-right: 0px;\n  }\n}\n/*@import \"video-gular.less\";*/\n","/*! normalize.css v2.1.3 | MIT License | git.io/normalize */\n\n// ==========================================================================\n// HTML5 display definitions\n// ==========================================================================\n\n\n\n*:focus,\n*:active\n{\n  outline:transparent !important;\n  outline: none !important;\n  -moz-outline-style: none !important;\n}\n\n\n//\n// Correct `block` display not defined in IE 8/9.\n//\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n//\n// Correct `inline-block` display not defined in IE 8/9.\n//\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n}\n\n//\n// Prevent modern browsers from displaying `audio` without controls.\n// Remove excess height in iOS 5 devices.\n//\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n//\n// Address `[hidden]` styling not present in IE 8/9.\n// Hide the `template` element in IE, Safari, and Firefox < 22.\n//\n\n[hidden],\ntemplate {\n  display: none;\n}\n\n// ==========================================================================\n// Base\n// ==========================================================================\n\n//\n// 1. Set default font family to sans-serif.\n// 2. Prevent iOS text size adjust after orientation change, without disabling\n//    user zoom.\n//\n\nhtml {\n  font-family: Roboto; // 1\n  -ms-text-size-adjust: 100%; // 2\n  -webkit-text-size-adjust: 100%; // 2\n}\n\n//\n// Remove default margin.\n//\n\nbody {\n  margin: 0;\n}\n\n// ==========================================================================\n// Links\n// ==========================================================================\n\n//\n// Remove the gray background color from active links in IE 10.\n//\n\na {\n  background: transparent;\n}\n\n//\n// Address `outline` inconsistency between Chrome and other browsers.\n//\n\na:focus {\n  outline: thin dotted;\n}\n\n//\n// Improve readability when focused and also mouse hovered in all browsers.\n//\n\na:active,\na:hover {\n  outline: 0;\n}\n\n// ==========================================================================\n// Typography\n// ==========================================================================\n\n//\n// Address variable `h1` font-size and margin within `section` and `article`\n// contexts in Firefox 4+, Safari 5, and Chrome.\n//\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n//\n// Address styling not present in IE 8/9, Safari 5, and Chrome.\n//\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\n//\n// Address style set to `bolder` in Firefox 4+, Safari 5, and Chrome.\n//\n\nb,\nstrong {\n  font-weight: bold;\n}\n\n//\n// Address styling not present in Safari 5 and Chrome.\n//\n\ndfn {\n  font-style: italic;\n}\n\n//\n// Address differences between Firefox and other browsers.\n//\n\nhr {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  height: 0;\n}\n\n//\n// Address styling not present in IE 8/9.\n//\n\nmark {\n  background: #ff0;\n  color: @black;\n}\n\n//\n// Correct font family set oddly in Safari 5 and Chrome.\n//\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: Roboto;\n  font-size: 1em;\n}\n\n//\n// Improve readability of pre-formatted text in all browsers.\n//\n\npre {\n  white-space: pre-wrap;\n}\n\n//\n// Set consistent quote types.\n//\n\nq {\n  quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n}\n\n//\n// Address inconsistent and variable font size in all browsers.\n//\n\nsmall {\n  font-size: 80%;\n}\n\n//\n// Prevent `sub` and `sup` affecting `line-height` in all browsers.\n//\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n// ==========================================================================\n// Embedded content\n// ==========================================================================\n\n//\n// Remove border when inside `a` element in IE 8/9.\n//\n\nimg {\n  border: 0;\n}\n\n//\n// Correct overflow displayed oddly in IE 9.\n//\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n// ==========================================================================\n// Figures\n// ==========================================================================\n\n//\n// Address margin not present in IE 8/9 and Safari 5.\n//\n\nfigure {\n  margin: 0;\n}\n\n// ==========================================================================\n// Forms\n// ==========================================================================\n\n//\n// Define consistent border, margin, and padding.\n//\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n//\n// 1. Correct `color` not being inherited in IE 8/9.\n// 2. Remove padding so people aren't caught out if they zero out fieldsets.\n//\n\nlegend {\n  border: 0; // 1\n  padding: 0; // 2\n}\n\n//\n// 1. Correct font family not being inherited in all browsers.\n// 2. Correct font size not being inherited in all browsers.\n// 3. Address margins set differently in Firefox 4+, Safari 5, and Chrome.\n//\n\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: Roboto; // 1\n  font-size: 100%; // 2\n  margin: 0; // 3\n}\ntextarea { resize:none !important; }\n//\n// Address Firefox 4+ setting `line-height` on `input` using `!important` in\n// the UA stylesheet.\n//\n\nbutton,\ninput {\n  line-height: normal;\n}\n\n//\n// Address inconsistent `text-transform` inheritance for `button` and `select`.\n// All other form control elements do not inherit `text-transform` values.\n// Correct `button` style inheritance in Chrome, Safari 5+, and IE 8+.\n// Correct `select` style inheritance in Firefox 4+ and Opera.\n//\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n//\n// 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n//    and `video` controls.\n// 2. Correct inability to style clickable `input` types in iOS.\n// 3. Improve usability and consistency of cursor style between image-type\n//    `input` and others.\n//\n\nbutton,\nhtml input[type=\"button\"], // 1\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n  cursor: pointer; // 3\n}\n\n//\n// Re-set default cursor for disabled elements.\n//\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n//\n// 1. Address box sizing set to `content-box` in IE 8/9/10.\n// 2. Remove excess padding in IE 8/9/10.\n//\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; // 1\n  padding: 0; // 2\n}\n\n//\n// 1. Address `appearance` set to `searchfield` in Safari 5 and Chrome.\n// 2. Address `box-sizing` set to `border-box` in Safari 5 and Chrome\n//    (include `-moz` to future-proof).\n//\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  -moz-box-sizing: content-box;\n  -webkit-box-sizing: content-box; // 2\n  box-sizing: content-box;\n}\n\n//\n// Remove inner padding and search cancel button in Safari 5 and Chrome\n// on OS X.\n//\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// Remove inner padding and border in Firefox 4+.\n//\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n//\n// 1. Remove default vertical scrollbar in IE 8/9.\n// 2. Improve readability and alignment in all browsers.\n//\n\ntextarea {\n  overflow: auto; // 1\n  vertical-align: top; // 2\n}\n\n// ==========================================================================\n// Tables\n// ==========================================================================\n\n//\n// Remove most spacing between table cells.\n//\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n","//\n// Basic print styles\n// --------------------------------------------------\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/css/main.css\n\n@media print {\n\n  * {\n    text-shadow: none !important;\n    color: @black !important; // Black prints faster: h5bp.com/s\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  // Don't show links for images, or javascript/internal links\n  a[href^=\"javascript:\"]:after,\n  a[href^=\"#\"]:after {\n    content: \"\";\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid @gray-light;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group; // h5bp.com/t\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  img {\n    max-width: 100% !important;\n  }\n\n  @page {\n    margin: 2cm .5cm;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  // Chrome (OSX) fix for https://github.com/twbs/bootstrap/issues/11245\n  // Once fixed, we can just straight up remove this.\n  select {\n    background: @white !important;\n  }\n\n  // Bootstrap components\n  .navbar {\n    display: none;\n  }\n  .table {\n    td,\n    th {\n      background-color: @white !important;\n    }\n  }\n  .btn,\n  .dropup > .btn {\n    > .caret {\n      border-top-color: @black !important;\n    }\n  }\n  .label {\n    border: 1px solid @black;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table-bordered {\n    th,\n    td {\n      border: 1px solid @grayd !important;\n    }\n  }\n\n}\n","//\n// Scaffolding\n// --------------------------------------------------\n\n\n// Reset the box-sizing\n\n*,\n*:before,\n*:after {\n  .box-sizing(border-box);\n}\n\n\n// Body reset\n\nhtml {\n  font-size: 62.5%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n\nbody {\n  font-family: Roboto;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @text-color;\n  background-color: @body-bg;\n}\n\n// Reset fonts for relevant elements\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: Roboto;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n\n// Links\n\na {\n  color: @link-color;\n  text-decoration: none;\n\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: underline;\n  }\n\n  &:focus {\n    .tab-focus();\n  }\n}\n\n\n// Images\n\nimg {\n  vertical-align: middle;\n}\n\n// Responsive images (ensure images don't scale beyond their parents)\n.img-responsive {\n  .img-responsive();\n}\n\n// Rounded corners\n.img-rounded {\n  border-radius: @border-radius-large;\n}\n\n// Image thumbnails\n//\n// Heads up! This is mixin-ed into thumbnails.less for `.thumbnail`.\n.img-thumbnail {\n  padding: @thumbnail-padding;\n  line-height: @line-height-base;\n  background-color: @thumbnail-bg;\n  border: 1px solid @thumbnail-border;\n  border-radius: @thumbnail-border-radius;\n  .transition(all .2s ease-in-out);\n\n  // Keep them at most 100% wide\n  .img-responsive(inline-block);\n}\n\n// Perfect circle\n.img-circle {\n  border-radius: 50%; // set radius in percents\n}\n\n\n// Horizontal rules\n\nhr {\n  margin-top:    @line-height-computed;\n  margin-bottom: @line-height-computed;\n  border: 0;\n  border-top: 1px solid @hr-border;\n}\n\n\n// Only display content to screen readers\n//\n// See: http://a11yproject.com/posts/how-to-hide-content/\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n\n.item-format {\n  padding: 0;\n  line-height: 1.3;\n}\n\n.title-fox--div {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background: -webkit-linear-gradient(bottom, black, transparent);\n  background: -moz-linear-gradient(bottom, black, transparent);\n  background: -o-linear-background(bottom, black, transparent);\n  background: -ms-linear-gradient(bottom, black, transparent);\n}\n\n.title-fox--p {\n  margin-left: 10px;\n  word-wrap: break-word;\n}\n\n\n@media (max-width: 768px) {\n  .title-fox--p {\n    text-overflow: ellipsis;\n\n    /* Required for text-overflow to do anything */\n    white-space: nowrap;\n    overflow: hidden;\n  }\n}\n","/*---------------------------------------------------\n    LESS Elements 0.9\n  ---------------------------------------------------\n    A set of useful LESS mixins\n    More info at: http://lesselements.com\n  ---------------------------------------------------*/\n\n.gradient(@color: #F5F5F5, @start: #EEE, @stop: @white) {\n  background: @color;\n  background: -webkit-gradient(linear, left bottom, left top, color-stop(0, @start), color-stop(1, @stop));\n  background: -ms-linear-gradient(bottom, @start, @stop);\n  background: -moz-linear-gradient(center bottom, @start 0%, @stop 100%);\n  background: -o-linear-gradient(@stop, @start);\n  filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\",@stop,@start));\n}\n.bw-gradient(@color: #F5F5F5, @start: 0, @stop: 255) {\n  background: @color;\n  background: -webkit-gradient(linear, left bottom, left top, color-stop(0, rgb(@start,@start,@start)), color-stop(1, rgb(@stop,@stop,@stop)));\n  background: -ms-linear-gradient(bottom, rgb(@start,@start,@start) 0%, rgb(@stop,@stop,@stop) 100%);\n  background: -moz-linear-gradient(center bottom, rgb(@start,@start,@start) 0%, rgb(@stop,@stop,@stop) 100%);\n  background: -o-linear-gradient(rgb(@stop,@stop,@stop), rgb(@start,@start,@start));\n  filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\",rgb(@stop,@stop,@stop),rgb(@start,@start,@start)));\n}\n.bordered(@top-color: #EEE, @right-color: #EEE, @bottom-color: #EEE, @left-color: #EEE) {\n  border-top: solid 1px @top-color;\n  border-left: solid 1px @left-color;\n  border-right: solid 1px @right-color;\n  border-bottom: solid 1px @bottom-color;\n}\n.drop-shadow(@x-axis: 0, @y-axis: 1px, @blur: 2px, @alpha: 0.1) {\n  -webkit-box-shadow: @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);\n  -moz-box-shadow: @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);\n  box-shadow: @x-axis @y-axis @blur rgba(0, 0, 0, @alpha);\n}\n.rounded(@radius: 2px) {\n  -webkit-border-radius: @radius;\n  -moz-border-radius: @radius;\n  border-radius: @radius;\n}\n.border-radius(@topright: 0, @bottomright: 0, @bottomleft: 0, @topleft: 0) {\n  -webkit-border-top-right-radius: @topright;\n  -webkit-border-bottom-right-radius: @bottomright;\n  -webkit-border-bottom-left-radius: @bottomleft;\n  -webkit-border-top-left-radius: @topleft;\n  -moz-border-radius-topright: @topright;\n  -moz-border-radius-bottomright: @bottomright;\n  -moz-border-radius-bottomleft: @bottomleft;\n  -moz-border-radius-topleft: @topleft;\n  border-top-right-radius: @topright;\n  border-bottom-right-radius: @bottomright;\n  border-bottom-left-radius: @bottomleft;\n  border-top-left-radius: @topleft;\n  .background-clip(padding-box);\n}\n.opacity(@opacity: 0.5) {\n  -moz-opacity: @opacity;\n  -khtml-opacity: @opacity;\n  -webkit-opacity: @opacity;\n  opacity: @opacity;\n  @opperc: @opacity * 100;\n  -ms-filter: ~\"progid:DXImageTransform.Microsoft.Alpha(opacity=@{opperc})\";\n  filter: ~\"alpha(opacity=@{opperc})\";\n}\n.transition-duration(@duration: 0.2s) {\n  -moz-transition-duration: @duration;\n  -webkit-transition-duration: @duration;\n  -o-transition-duration: @duration;\n  transition-duration: @duration;\n}\n.transform(...) {\n  -webkit-transform: @arguments;\n  -moz-transform: @arguments;\n  -o-transform: @arguments;\n  -ms-transform: @arguments;\n  transform: @arguments;\n}\n.rotation(@deg:5deg){\n  .transform(rotate(@deg));\n}\n.scale(@ratio:1.5){\n  .transform(scale(@ratio));\n}\n.transition(@duration:0.2s, @ease:ease-out) {\n  -webkit-transition: all @duration @ease;\n  -moz-transition: all @duration @ease;\n  -o-transition: all @duration @ease;\n  transition: all @duration @ease;\n}\n.inner-shadow(@horizontal:0, @vertical:1px, @blur:2px, @alpha: 0.4) {\n  -webkit-box-shadow: inset @horizontal @vertical @blur rgba(0, 0, 0, @alpha);\n  -moz-box-shadow: inset @horizontal @vertical @blur rgba(0, 0, 0, @alpha);\n  box-shadow: inset @horizontal @vertical @blur rgba(0, 0, 0, @alpha);\n}\n.box-shadow(@arguments) {\n  -webkit-box-shadow: @arguments;\n  -moz-box-shadow: @arguments;\n  box-shadow: @arguments;\n}\n.box-sizing(@sizing: border-box) {\n  -ms-box-sizing: @sizing;\n  -moz-box-sizing: @sizing;\n  -webkit-box-sizing: @sizing;\n  box-sizing: @sizing;\n}\n.user-select(@argument: none) {\n  -webkit-user-select: @argument;\n  -moz-user-select: @argument;\n  -ms-user-select: @argument;\n  user-select: @argument;\n}\n.columns(@colwidth: 250px, @colcount: 0, @colgap: 50px, @columnRuleColor: #EEE, @columnRuleStyle: solid, @columnRuleWidth: 1px) {\n  -moz-column-width: @colwidth;\n  -moz-column-count: @colcount;\n  -moz-column-gap: @colgap;\n  -moz-column-rule-color: @columnRuleColor;\n  -moz-column-rule-style: @columnRuleStyle;\n  -moz-column-rule-width: @columnRuleWidth;\n  -webkit-column-width: @colwidth;\n  -webkit-column-count: @colcount;\n  -webkit-column-gap: @colgap;\n  -webkit-column-rule-color: @columnRuleColor;\n  -webkit-column-rule-style: @columnRuleStyle;\n  -webkit-column-rule-width: @columnRuleWidth;\n  column-width: @colwidth;\n  column-count: @colcount;\n  column-gap: @colgap;\n  column-rule-color: @columnRuleColor;\n  column-rule-style: @columnRuleStyle;\n  column-rule-width: @columnRuleWidth;\n}\n.translate(@x:0, @y:0) {\n  .transform(translate(@x, @y));\n}\n.background-clip(@argument: padding-box) {\n  -moz-background-clip: @argument;\n  -webkit-background-clip: @argument;\n  background-clip: @argument;\n}","//\n// Typography\n// --------------------------------------------------\n\n\n// Body text\n// -------------------------\n\np {\n  margin: 0 0 (@line-height-computed / 2);\n}\n.lead {\n  margin-bottom: @line-height-computed;\n  font-size: floor(@font-size-base * 1.15);\n  font-weight: 200;\n  line-height: 1.4;\n\n  @media (min-width: @screen-sm-min) {\n    font-size: (@font-size-base * 1.5);\n  }\n}\n\n\n// Emphasis & misc\n// -------------------------\n\n// Ex: 14px base font * 85% = about 12px\nsmall,\n.small  { font-size: 85%; }\n\n// Undo browser default styling\ncite    { font-style: normal; }\n\n// Contextual emphasis\n.text-muted {\n  color: @text-muted;\n}\n.text-primary {\n  color: @brand-primary;\n  &:hover {\n    color: darken(@brand-primary, 10%);\n  }\n}\n.text-warning {\n  color: @state-warning-text;\n  &:hover {\n    color: darken(@state-warning-text, 10%);\n  }\n}\n.text-danger {\n  color: @state-danger-text;\n  &:hover {\n    color: darken(@state-danger-text, 10%);\n  }\n}\n.text-success {\n  color: @state-success-text;\n  &:hover {\n    color: darken(@state-success-text, 10%);\n  }\n}\n.text-info {\n  color: @state-info-text;\n  &:hover {\n    color: darken(@state-info-text, 10%);\n  }\n}\n\n// Alignment\n.text-left           { text-align: left; }\n.text-right          { text-align: right; }\n.text-center         { text-align: center; }\n\n\n// Headings\n// -------------------------\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: Roboto;\n  font-weight: @headings-font-weight;\n  line-height: @headings-line-height;\n  color: @headings-color;\n\n  small,\n  .small {\n    font-weight: normal;\n    line-height: 1;\n    color: @headings-small-color;\n  }\n}\n\nh1,\nh2,\nh3 {\n  margin-top: @line-height-computed;\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 65%;\n  }\n}\nh4,\nh5,\nh6 {\n  margin-top: (@line-height-computed / 2);\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 75%;\n  }\n}\n\nh1, .h1 { font-size: @font-size-h1; }\nh2, .h2 { font-size: @font-size-h2; }\nh3, .h3 { font-size: @font-size-h3; }\nh4, .h4 { font-size: @font-size-h4; }\nh5, .h5 { font-size: @font-size-h5; }\nh6, .h6 { font-size: @font-size-h6; }\n\n\n// Page header\n// -------------------------\n\n.page-header {\n  padding-bottom: ((@line-height-computed / 2) - 1);\n  margin: (@line-height-computed * 2) 0 @line-height-computed;\n  border-bottom: 1px solid @page-header-border-color;\n}\n\n\n\n// Lists\n// --------------------------------------------------\n\n// Unordered and Ordered lists\nul,\nol {\n  margin-top: 0;\n  margin-bottom: (@line-height-computed / 2);\n  ul,\n  ol {\n    margin-bottom: 0;\n  }\n}\n\n// List options\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  .list-unstyled();\n\n  > li {\n    display: inline-block;\n    padding-left: 5px;\n    padding-right: 5px;\n\n    &:first-child {\n      padding-left: 0;\n    }\n  }\n}\n\n// Description Lists\ndl {\n  margin-bottom: @line-height-computed;\n}\ndt,\ndd {\n  line-height: @line-height-base;\n}\ndt {\n  font-weight: bold;\n}\ndd {\n  margin-left: 0; // Undo browser default\n}\n\n// Horizontal description lists\n//\n// Defaults to being stacked without any of the below styles applied, until the\n// grid breakpoint is reached (default of ~768px).\n\n@media (min-width: @grid-float-breakpoint) {\n  .dl-horizontal {\n    dt {\n      float: left;\n      width: (@component-offset-horizontal - 20);\n      clear: left;\n      text-align: right;\n      .text-overflow();\n    }\n    dd {\n      margin-left: @component-offset-horizontal;\n      .clearfix(); // Clear the floated `dt` if an empty `dd` is present\n    }\n  }\n}\n\n// MISC\n// ----\n\n// Abbreviations and acronyms\nabbr[title],\n// Add data-* attribute to help out our tooltip plugin, per https://github.com/twbs/bootstrap/issues/5257\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted @abbr-border-color;\n}\nabbr.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n// Blockquotes\nblockquote {\n  padding: (@line-height-computed / 2) @line-height-computed;\n  margin: 0 0 @line-height-computed;\n  border-left: 5px solid @blockquote-border-color;\n  p {\n    font-size: (@font-size-base * 1.25);\n    font-weight: 300;\n    line-height: 1.25;\n  }\n  p:last-child {\n    margin-bottom: 0;\n  }\n  small {\n    display: block;\n    line-height: @line-height-base;\n    color: @blockquote-small-color;\n    &:before {\n      content: '\\2014 \\00A0'; // EM DASH, NBSP\n    }\n  }\n\n  // Float right with text-align: right\n  &.pull-right {\n    padding-right: 15px;\n    padding-left: 0;\n    border-right: 5px solid @blockquote-border-color;\n    border-left: 0;\n    p,\n    small,\n    .small {\n      text-align: right;\n    }\n    small,\n    .small {\n      &:before {\n        content: '';\n      }\n      &:after {\n        content: '\\00A0 \\2014'; // NBSP, EM DASH\n      }\n    }\n  }\n}\n\n// Quotes\nblockquote:before,\nblockquote:after {\n  content: \"\";\n}\n\n// Addresses\naddress {\n  margin-bottom: @line-height-computed;\n  font-style: normal;\n  line-height: @line-height-base;\n}\n","//\n// Code (inline and block)\n// --------------------------------------------------\n\n\n// Inline and block code styles\ncode,\nkbd,\npre,\nsamp {\n  font-family: Roboto;\n}\n\n// Inline code\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: @code-color;\n  background-color: @code-bg;\n  white-space: nowrap;\n  border-radius: @border-radius-base;\n}\n\n// Blocks of code\npre {\n  display: block;\n  padding: ((@line-height-computed - 1) / 2);\n  margin: 0 0 (@line-height-computed / 2);\n  font-size: (@font-size-base - 1); // 14px to 13px\n  line-height: @line-height-base;\n  word-break: break-all;\n  word-wrap: break-word;\n  color: @pre-color;\n  background-color: @pre-bg;\n  border: 1px solid @pre-border-color;\n  border-radius: @border-radius-base;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: @pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","//\n// Grid system\n// --------------------------------------------------\n\n// Set the container width, and override it for fixed navbars in media queries\n.container {\n  .container-fixed();\n}\n\n// mobile first defaults\n.row {\n  .make-row();\n}\n\n// Common styles for small and large grid columns\n.make-grid-columns();\n\n\n// Extra small grid\n//\n// Grid classes for extra small devices like smartphones. No offset, push, or\n// pull classes are present here due to the size of the target.\n//\n// Note that `.col-xs-12` doesn't get floated on purpose--there's no need since\n// it's full-width.\n\n.make-grid-columns-float(xs);\n.make-grid(@grid-columns, xs, width);\n.make-grid(@grid-columns, xs, pull);\n.make-grid(@grid-columns, xs, push);\n.make-grid(@grid-columns, xs, offset);\n\n\n// Small grid\n//\n// Columns, offsets, pushes, and pulls for the small device range, from phones\n// to tablets.\n//\n// Note that `.col-sm-12` doesn't get floated on purpose--there's no need since\n// it's full-width.\n\n@media (min-width: @screen-sm-min) {\n  .container {\n    width: @container-sm;\n  }\n\n  .make-grid-columns-float(sm);\n  .make-grid(@grid-columns, sm, width);\n  .make-grid(@grid-columns, sm, pull);\n  .make-grid(@grid-columns, sm, push);\n  .make-grid(@grid-columns, sm, offset);\n}\n\n\n// Medium grid\n//\n// Columns, offsets, pushes, and pulls for the desktop device range.\n//\n// Note that `.col-md-12` doesn't get floated on purpose--there's no need since\n// it's full-width.\n\n@media (min-width: @screen-md-min) {\n  .container {\n    width: @container-md;\n  }\n\n  .make-grid-columns-float(md);\n  .make-grid(@grid-columns, md, width);\n  .make-grid(@grid-columns, md, pull);\n  .make-grid(@grid-columns, md, push);\n  .make-grid(@grid-columns, md, offset);\n}\n\n\n// Large grid\n//\n// Columns, offsets, pushes, and pulls for the large desktop device range.\n//\n// Note that `.col-lg-12` doesn't get floated on purpose--there's no need since\n// it's full-width.\n\n@media (min-width: @screen-lg-min) {\n  .container {\n    width: @container-lg;\n  }\n\n  .make-grid-columns-float(lg);\n  .make-grid(@grid-columns, lg, width);\n  .make-grid(@grid-columns, lg, pull);\n  .make-grid(@grid-columns, lg, push);\n  .make-grid(@grid-columns, lg, offset);\n}\n\n","//\n// Tables\n// --------------------------------------------------\n\n\ntable {\n  max-width: 100%;\n  background-color: @table-bg;\n}\nth {\n  text-align: left;\n}\n\n\n// Baseline styles\n\n.table {\n  width: 100%;\n  margin-bottom: @line-height-computed;\n  // Cells\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-cell-padding;\n        line-height: @line-height-base;\n        vertical-align: top;\n        border-top: 1px solid @table-border-color;\n      }\n    }\n  }\n  // Bottom align for column headings\n  > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid @table-border-color;\n  }\n  // Remove top border from thead by default\n  > caption + thead,\n  > colgroup + thead,\n  > thead:first-child {\n    > tr:first-child {\n      > th,\n      > td {\n        border-top: 0;\n      }\n    }\n  }\n  // Account for multiple tbody instances\n  > tbody + tbody {\n    border-top: 2px solid @table-border-color;\n  }\n\n  // Nesting\n  .table {\n    background-color: @body-bg;\n  }\n}\n\n\n// Condensed table w/ half padding\n\n.table-condensed {\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-condensed-cell-padding;\n      }\n    }\n  }\n}\n\n\n// Bordered version\n//\n// Add borders all around the table and between all the columns.\n\n.table-bordered {\n  border: 1px solid @table-border-color;\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        border: 1px solid @table-border-color;\n      }\n    }\n  }\n  > thead > tr {\n    > th,\n    > td {\n      border-bottom-width: 2px;\n    }\n  }\n}\n\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped > tbody > tr:nth-child(odd) {\n  > td,\n  > th {\n    background-color: @table-bg-accent;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover > tbody > tr:hover {\n  > td,\n  > th {\n    background-color: @table-bg-hover;\n  }\n}\n\n\n// Table cell sizing\n//\n// Reset default table behavior\n\ntable col[class*=\"col-\"] {\n  float: none;\n  display: table-column;\n}\ntable {\n  td,\n  th {\n    &[class*=\"col-\"] {\n      float: none;\n      display: table-cell;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n.table > thead > tr,\n.table > tbody > tr,\n.table > tfoot > tr {\n  > td.active,\n  > th.active,\n  &.active > td,\n  &.active > th  {\n    background-color: @table-bg-active;\n  }\n}\n\n// Generate the contextual variants\n.table-row-variant(success; @state-success-bg; @state-success-border);\n.table-row-variant(danger; @state-danger-bg; @state-danger-border);\n.table-row-variant(warning; @state-warning-bg; @state-warning-border);\n\n\n// Responsive tables\n//\n// Wrap your tables in `.table-responsive` and we'll make them mobile friendly\n// by enabling horizontal scrolling. Only applies <768px. Everything above that\n// will display normally.\n\n@media (max-width: @screen-xs-max) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: (@line-height-computed * 0.75);\n    overflow-y: hidden;\n    overflow-x: scroll;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid @table-border-color;\n    -webkit-overflow-scrolling: touch;\n\n    // Tighten up spacing\n    > .table {\n      margin-bottom: 0;\n\n      // Ensure the content doesn't wrap\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th,\n          > td {\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n\n    // Special overrides for the bordered tables\n    > .table-bordered {\n      border: 0;\n\n      // Nuke the appropriate borders so that the parent can handle them\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th:first-child,\n          > td:first-child {\n            border-left: 0;\n          }\n          > th:last-child,\n          > td:last-child {\n            border-right: 0;\n          }\n        }\n      }\n\n      // Only nuke the last row's bottom-border in `tbody` and `tfoot` since\n      // chances are there will be only one `tr` in a `thead` and that would\n      // remove the border altogether.\n      > tbody,\n      > tfoot {\n        > tr:last-child {\n          > th,\n          > td {\n            border-bottom: 0;\n          }\n        }\n      }\n\n    }\n  }\n}\n","//\n// Forms\n// --------------------------------------------------\n\n\n// Normalize non-controls\n//\n// Restyle and baseline non-control form elements.\n\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: @line-height-computed;\n  font-size: (@font-size-base * 1.5);\n  line-height: inherit;\n  color: @legend-color;\n  border: 0;\n  border-bottom: 1px solid @legend-border-color;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n\n// Normalize form controls\n\n// Override content-box in Normalize (* isn't specific enough)\ninput[type=\"search\"] {\n  .box-sizing(border-box);\n}\n\n// Position radios and checkboxes better\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9; /* IE8-9 */\n  line-height: normal;\n}\n\n// Set the height of select and file controls to match text inputs\ninput[type=\"file\"] {\n  display: block;\n}\n\n// Make multiple select elements height not fixed\nselect[multiple],\nselect[size] {\n  height: auto;\n}\n\n// Fix optgroup Firefox bug per https://github.com/twbs/bootstrap/issues/7611\nselect optgroup {\n  font-size: inherit;\n  font-style: inherit;\n  font-family: Roboto;\n}\n\n// Focus for select, file, radio, and checkbox\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  .tab-focus();\n}\n\n// Fix for Chrome number input\n// Setting certain font-sizes causes the `I` bar to appear on hover of the bottom increment button.\n// See https://github.com/twbs/bootstrap/issues/8350 for more.\ninput[type=\"number\"] {\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    height: auto;\n  }\n}\n\n// Adjust output element\noutput {\n  display: block;\n  padding-top: (@padding-base-vertical + 1);\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n  vertical-align: middle;\n}\n\n\n// Common form controls\n//\n// Shared size and type resets for form controls. Apply `.form-control` to any\n// of the following form controls:\n//\n// select\n// textarea\n// input[type=\"text\"]\n// input[type=\"password\"]\n// input[type=\"datetime\"]\n// input[type=\"datetime-local\"]\n// input[type=\"date\"]\n// input[type=\"month\"]\n// input[type=\"time\"]\n// input[type=\"week\"]\n// input[type=\"number\"]\n// input[type=\"email\"]\n// input[type=\"url\"]\n// input[type=\"search\"]\n// input[type=\"tel\"]\n// input[type=\"color\"]\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: @input-height-base; // Make inputs at least the height of their button counterpart (base line-height + padding + border)\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n  vertical-align: middle;\n  background-color: @input-bg;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid @input-border;\n  border-radius: @input-border-radius;\n  .box-shadow(inset 0 1px 1px rgba(0,0,0,.075));\n  .transition(~\"border-color ease-in-out .15s, box-shadow ease-in-out .15s\");\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  .form-control-focus();\n\n  // Placeholder\n  //\n  // Placeholder text gets special styles because when browsers invalidate entire\n  // lines if it doesn't understand a selector/\n  .placeholder();\n\n  // Disabled and read-only inputs\n  // Note: HTML5 says that controls under a fieldset > legend:first-child won't\n  // be disabled if the fieldset is disabled. Due to implementation difficulty,\n  // we don't honor that edge case; we style them as disabled anyway.\n  &[disabled],\n  &[readonly],\n  fieldset[disabled] & {\n    cursor: not-allowed;\n    background-color: @input-bg-disabled;\n  }\n\n  // Reset height for `textarea`s\n  textarea& {\n    height: auto;\n  }\n}\n\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.radio,\n.checkbox {\n  display: block;\n  min-height: @line-height-computed; // clear the floating input if there is no label text\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-left: 20px;\n  vertical-align: middle;\n  label {\n    display: inline;\n    margin-bottom: 0;\n    font-weight: normal;\n    cursor: pointer;\n  }\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  float: left;\n  margin-left: -20px;\n}\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px; // Move up sibling radios or checkboxes for tighter spacing\n}\n\n// Radios and checkboxes on same line\n.radio-inline,\n.checkbox-inline {\n  display: inline-block;\n  padding-left: 23px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer;\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n // margin-left: 10px; // space out consecutive inline controls\n}\n\n// Apply same disabled cursor tweak as for inputs\n//\n// Note: Neither radios nor checkboxes can be readonly.\ninput[type=\"radio\"],\ninput[type=\"checkbox\"],\n.radio,\n.radio-inline,\n.checkbox,\n.checkbox-inline {\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: not-allowed;\n  }\n}\n\n// Form control sizing\n.input-sm {\n  .input-size(@input-height-small; @padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @border-radius-small);\n}\n\n.input-lg {\n  .input-size(@input-height-large; @padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @border-radius-large);\n}\n\n\n// Form control feedback states\n//\n// Apply contextual and semantic states to individual form controls.\n\n// Warning\n.has-warning {\n  .form-control-validation(@state-warning-text; @state-warning-bg);\n}\n// Error\n.has-error {\n  .form-control-validation(@state-danger-text; @state-danger-bg);\n}\n// Success\n.has-success {\n  .form-control-validation(@state-success-text; @state-success-bg);\n}\n\n\n// Static form control text\n//\n// Apply class to a `p` element to make any string of text align with labels in\n// a horizontal form layout.\n\n.form-control-static {\n  margin-bottom: 0; // Remove default margin from `p`\n}\n\n\n// Help text\n//\n// Apply to any element you wish to create light text for placement immediately\n// below a form control. Use for general help, formatting, or instructional text.\n\n.help-block {\n  display: block; // account for any element using help-block\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: lighten(@text-color, 25%);\n  font-style: italic;\n  font-size:@font-size-h6;\n  //color: lighten(@text-color, 25%); // lighten the text some for contrast\n}\n\n\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n//\n// Heads up! This is mixin-ed into `.navbar-form` in navbars.less.\n\n.form-inline {\n\n  // Kick in the inline\n  @media (min-width: @screen-sm) {\n    // Inline-block all the things for \"inline\"\n    .form-group  {\n      display: inline-block;\n      margin-bottom: 0;\n      vertical-align: middle;\n    }\n\n    // In navbar-form, allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match (which also avoids\n    // a bug in WebKit: https://github.com/twbs/bootstrap/issues/1969).\n    .radio,\n    .checkbox {\n      display: inline-block;\n      margin-top: 0;\n      margin-bottom: 0;\n      padding-left: 0;\n    }\n    .radio input[type=\"radio\"],\n    .checkbox input[type=\"checkbox\"] {\n      float: none;\n      margin-left: 0;\n    }\n  }\n}\n\n\n// Horizontal forms\n//\n// Horizontal forms are built on grid classes and allow you to create forms with\n// labels on the left and inputs on the right.\n\n.form-horizontal {\n\n  // Consistent vertical alignment of labels, radios, and checkboxes\n  .control-label,\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: (@padding-base-vertical + 1); // Default padding plus a border\n  }\n\n  // Make form groups behave like rows\n  .form-group {\n    .make-row();\n  }\n\n  .form-control-static {\n    padding-top: (@padding-base-vertical + 1);\n    // Show dots (...) on overflow text\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  // Only right align form labels here when the columns stop stacking\n  @media (min-width: @screen-sm-min) {\n    .control-label {\n      text-align: right;\n    }\n  }\n}\n","//\n// Buttons\n// --------------------------------------------------\n\n\n// Base styles\n// --------------------------------------------------\n\n// Core styles\n.btn, .nav li a.btn {\n  display: inline-block;\n  margin-bottom: 0; // For input.btn\n  font-weight: @btn-font-weight;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid transparent;\n  white-space: nowrap;\n  .button-size(@padding-base-vertical; @padding-base-horizontal; @font-size-base; @line-height-base; @border-radius-base);\n  .user-select(none);\n\n  &:focus {\n    .tab-focus();\n  }\n\n  &:hover,\n  &:focus {\n    color: @btn-default-color;\n    text-decoration: none;\n  }\n\n  &:active,\n  &.active {\n    outline: 0;\n    background-image: none;\n    .box-shadow(inset 0 3px 5px rgba(0,0,0,.125));\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: not-allowed;\n    pointer-events: none; // Future-proof disabling of clicks\n    .opacity(.65);\n    .box-shadow(none);\n    color:white!important;\n  }\n\n}\n\n\n// Alternate buttons\n// --------------------------------------------------\n.nav li a.btn-default {\n  .button-variant(@btn-default-color; @btn-default-bg; @btn-default-border);\n}\n.btn-default {\n  .button-variant(@btn-default-color; rgba(0,0,0,0.2); @btn-default-border);\n}\n.btn-primary {\n  .button-variant(@btn-primary-color; @btn-primary-bg; @btn-primary-border);\n}\n// Warning appears as orange\n.btn-warning {\n  .button-variant(@btn-warning-color; @btn-warning-bg; @btn-warning-border);\n}\n// Danger and error appear as red\n.btn-danger {\n  .button-variant(@btn-danger-color; @btn-danger-bg; @btn-danger-border);\n}\n// Success appears as green\n.btn-success {\n  .button-variant(@btn-success-color; @btn-success-bg; @btn-success-border);\n}\n// Info appears as blue-green\n.btn-info {\n  .button-variant(@btn-info-color; @btn-info-bg; @btn-info-border);\n}\n\n\n// Link buttons\n// -------------------------\n\n// Make a button look and behave like a link\n.btn-link {\n  color: @link-color;\n  font-weight: normal;\n  cursor: pointer;\n  border-radius: 0;\n\n  &,\n  &:active,\n  &[disabled],\n  fieldset[disabled] & {\n    background-color: transparent;\n    .box-shadow(none);\n  }\n  &,\n  &:hover,\n  &:focus,\n  &:active {\n    border-color: transparent;\n  }\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: underline;\n    background-color: transparent;\n  }\n  &[disabled],\n  fieldset[disabled] & {\n    &:hover,\n    &:focus {\n      color: @btn-link-disabled-color;\n      text-decoration: none;\n    }\n  }\n}\n\n\n// Button Sizes\n// --------------------------------------------------\n\n.btn-lg {\n  // line-height: ensure even-numbered height of button next to large input\n  .button-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @border-radius-base);\n}\n.btn-sm,\n.btn-xs {\n  // line-height: ensure proper height of button next to small input\n  .button-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @border-radius-small);\n}\n.btn-xs {\n  padding: 1px 5px;\n}\n\n\n// Block button\n// --------------------------------------------------\n\n.btn-block {\n  display: block;\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n// Vertically space out multiple block buttons\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n\n/* Object Button with states */\n@keyframes button-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.o-button {\n  cursor: pointer;\n  display: inline-block;\n  min-height: 1em;\n  outline: none;\n  border: 1px solid @btn-primary-border;\n  background: @btn-primary-bg none;\n  border-radius: 4px;\n  color: @btn-primary-color;\n  font-family: Roboto;\n  margin: 0em 0.25em 0em 0em;\n  padding: 6px 12px;\n  text-transform: none;\n  text-shadow: none;\n  line-height: 1.42857143;\n  font-style: normal;\n  text-align: center;\n  text-decoration: none;\n  user-select: none;\n  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,\n    box-shadow 0.1s ease, background 0.1s ease;\n  will-change: \"\";\n  &:hover {\n    background-color: darken(@btn-primary-bg, 30%);\n        border-color: darken(@btn-primary-border, 35%);\n  }\n  &--right {\n    float: right;\n  }\n  &--fluid {\n    display: block;\n    width: 100%;\n  }\n\n  &--basic {\n    background:rgba(0,0,0,0.2);\n    border-color: @btn-default-border;\n    color: @btn-default-color;\n    &:hover {\n      background-color: darken(rgba(0,0,0,0.2), 30%);\n          border-color: darken(@btn-default-border, 35%);\n    }\n  }\n\n  &--loading {\n    position: relative;\n    cursor: default;\n    text-shadow: none !important;\n    color: transparent !important;\n    opacity: 1;\n    pointer-events: none !important;\n    transition: all 0s linear, opacity 0.1s ease;\n    &:before,\n    &:after {\n      position: absolute;\n      content: \"\";\n      top: 50%;\n      left: 50%;\n      margin: -0.64285714em 0em 0em -0.64285714em;\n      width: 1.28571429em;\n      height: 1.28571429em;\n      border-radius: 500rem;\n    }\n    &:before {\n      border: 0.2em solid rgba(0, 0, 0, 0.15);\n    }\n    &:after {\n      animation: button-spin 0.6s linear;\n      animation-iteration-count: infinite;\n      border-color: #ffffff transparent transparent;\n      border-style: solid;\n      border-width: 0.2em;\n      box-shadow: 0px 0px 0px 1px transparent;\n    }\n  }\n  &--disabled,\n  &--disabled:hover {\n    cursor: default;\n    opacity: 0.75 !important;\n    background-image: none !important;\n    box-shadow: none !important;\n    pointer-events: none !important;\n  }\n  &--touchable {\n    &:hover {\n      background-color: @btn-primary-bg;\n      border-color: @btn-primary-border;\n    }\n  }\n}\n","@import \"bootstrap.less\";\n/* GLOBAL STYLES\n-------------------------------------------------- */\n\n//Nuevas variables\n\nbody{\n  min-height: 480px;\n  min-width: 300px;\n  //se definen el alto y ancho minimos para la página\n}\n@layout: rgba(34, 34, 34, 0.5);\n@pasos-height: 750px;\n\na { text-decoration: underline;\n    color: @gray5;\n}\n\na:hover .play { visibility: visible;}\n\n.btn, .nav a, .btn-group a { text-decoration: none;}\n\n.stores .row {\n  padding-top: 20px;\n  div { margin-top: 5px;}\n}\n\n/*VERTICAL ALIGN*/\n.text-module{\n  .center { padding: 35px 0;}\n}\n\n//Elimina scroll\n\n.non-scroll { overflow: hidden; }\n\n.logged-true {\n  @media (max-width: @screen-xs-max) {\n    .autocomplete-containter-ext {left: 0 !important;}\n  }\n  &.layout-nivelbts,\n  &.layout-aplicacionbts {\n    h3,h2 { color: @white;}\n    @media (max-width: @screen-xs-max) {\n      h3,h2 { max-width: 100%;}\n    }\n  }\n  &.layout-nivelbts, &.layout-aplicacionbts {\n    h3 { font-size: (@font-size-base * 1.7);}\n  }\n}\n\n.menu-principal.dropdown-menu {\n  padding-top: 0px;\n  .fa-caret-up {\n        position: absolute;\n    top: -18px;\n    left: 45px;\n  }\n}\n\n// Buscador\n.buscar {\n  width:190px;\n  height:30px;\n  margin: 0 auto;\n  input {\n    color:@gray-lighter;\n    background-color: @gray-dark;\n    border: 1px solid @gray;\n  }\n  button.btn-default {\n    background-color: @gray-dark;\n    color: @gray;\n    border-top: 1px solid @gray;\n    border-right: 1px solid @gray;\n    border-bottom: 1px solid @gray;\n    border-left: none;\n    &:hover {\n      background-color: @gray-darker;\n      color: @gray-lighter;\n    }\n    i {\n      font-size: 1.25em;\n    }\n  }\n}\n\n.btn-search {\n  background: none repeat scroll 0 0 rgba(0, 0, 0, 0);\n  border: medium none;\n  color: @gray;\n  margin: 4px 0;\n  width: 40px;\n  i { font-size: (@font-size-base * 2);}\n}\n\n//Dropdown\n\n.buscador-xs {\n  background: @gray-dark;\n  position: absolute;\n  width: 100%;\n}\n\n.logo { margin: 0px;}\n\n// Login\n\n.login {\n  .leyenda-claro {\n    font-size: 1.17em;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    @media (max-width: 767px) {\n      margin: 20px auto !important;\n    }\n  }\n  .leyenda-claro span {\n    display: block;\n  }\n  .claro-logo-text, .leyenda-claro .claro-logo-text {\n    color: #E51A1A !important;\n    display: inline;\n  }\n  .has-error h5 { text-align: left; }\n  .btn-fb-login {\n    background-color: @fb-color;\n    border-color: @fb-color;\n    margin-bottom: 10px;\n    h5 { margin-top:0; }\n    .fa-facebook-square {\n    padding-left: 15px;\n    margin-right: 15px;\n    }\n  }\n\n}\n.captcha-reload {\n    border: 0;\n   background: url(../images/captcha-reload.png) no-repeat 0 0;\n   width: 41px;\n   height: 41px;\n  }\n\n\n// CHAT BUTTON\n.chat-button {\n  margin-right: -12px;\n  position: absolute;\n  top: 20px;\n  z-index: 10000;\n}\n\n//??\n.instrucciones p { margin:0px;}\n\n\n//Medios de Pago\n.medios-pagos {\n  .medios-pagos-tablet .btn-default, .medios-pagos-mobile .btn-default {\n    background: rgba(0,0,0,.2);\n    border-color: #ffffff;\n    color: @gray-lighter;\n     &:focus, &.active {\n        background: @white;\n        color: @gray-darker;\n        border-color: #ffffff;\n      }\n      @media not all and (pointer: coarse) {\n        &:hover, &:active {\n          background: @white;\n          color: @gray-darker;\n          border-color: #ffffff;\n        }\n      }\n    }\n    .medios-pagos-tablet .btn-default {\n      border-radius: 0;\n      white-space: normal;\n      height: 60px;}\n    input[type=\"radio\"] {\n    margin-left: -17px;\n  }\n  i { margin-left: 0.2em; }\n    .medios-pagos-mobile .btn-default {text-align: left;}\n    .paso-mobile {\n      color: @gray-dark;\n      float: left;\n      margin-bottom: 15px;\n      h3 {margin-top: 0; color: @gray-lighter;}\n      h5 {margin-top: 22px; color: @gray-lighter;}\n      span.indice {\n        border-radius: 20px;\n        background: @gray-darker;\n        float: left;\n        padding:5px 10px;\n        color: @gray-light;\n        margin: 5px 10px 0 0;\n        padding: 5px 10px;\n      }\n    }\n}\n\n.fa.fa-lock {\n  color: #E9AD10;\n  margin-right: 10px;\n}\n\n//Alertas\n.modal-body.error i, .modal-body.success i { color: #fff;}\n.error {\n  i {\n    border-radius:30px;\n    // background: @brand-danger;\n    width:42px;\n    height: 42px;\n    font-size: 50px;\n    line-height: 40px;\n  }\n}\n.success {\n  i {\n    border-radius:30px;\n    // background: red;\n    width:42px;\n    height: 42px;\n    font-size: 42px;\n    line-height: 42px;\n  }\n}\n.exclamation, .callcenter {\n  i { color:@white;}\n}\n.has-error .control-label { color: @white;}\n\n//Cargando\n.cargando-seccion, .cargando-full-screen {\n  margin-left: -27px;\n  margin-top: -5px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n.cargando-full-screen {\n  width: 375px;\n  height: 140px;\n  margin-left: -187px;\n  margin-top: -70px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: @gray-light;\n  .logos { height: 90px;}\n}\n\n// RENTA / estas por\n.renta {\n  h3 span {\n    color: @brand-claro;\n  }\n  .caret {\n    margin-top: 10px;\n  }\n  .form-horizontal {\n    .form-group {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n  .form-container {\n    .form-tarjeta {\n      img {\n        margin-right: auto;\n      }\n    }\n  }\n}\n// Ficha promo\n.promo-container{\n  .dropdown-menu > li > a {\n    white-space: normal;\n    line-height: 2;}\n .btn-group {\n    display: block;\n    position: inherit;}\n .btn-group > .btn {\n    float: none;\n    white-space: normal;\n  }\n}\n.renta .btn-promo .caret {\n  margin-top: -4px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n}\n.btn-promo {\n  position: relative;\n  span:first-child {\n    float: left;\n    margin-right: 10px;\n    text-align: left;\n    white-space: normal;\n  }\n}\n//??\n// Generales\n.margin-bottom-20 { margin-bottom: 20px; }\n.margin-0 { margin: 0px; }\n.margin-top-05 { margin-top: (@grid-gutter-width / 2); }\n.margin-right-1 { margin-right: @grid-gutter-width; }\n.margin-left-1 { margin-left: @grid-gutter-width; }\n.padding-05 { padding: (@grid-gutter-width / 2); }\n.padding-1 { padding: @grid-gutter-width; }\n.padding-2 { padding: (@grid-gutter-width * 2); }\n.padding-4 { padding: (@grid-gutter-width * 4); }\n.padding-top-03 { padding-top: (@grid-gutter-width / 3); }\n.padding-top-05 { padding-top: (@grid-gutter-width / 2); }\n.padding-top-1 { padding-top: @grid-gutter-width; }\n.padding-top-2 { padding-top: (@grid-gutter-width * 2); }\n.padding-bottom-1 { padding-bottom: @grid-gutter-width; }\n// .padding-bottom-2 { padding-bottom: (@grid-gutter-width * 2); }\n.padding-right-1 { padding-right: (@grid-gutter-width); }\n.padding-right-2 { padding-right: (@grid-gutter-width * 2); }\n.padding-right-left-10 { padding-right: 10px; padding-left: 10px; }\n.texto-blanco { color: @white; }\n.full-widht { display: bock; width: 100%; }\n.texto-negro { color: @gray-darker; }\n.texto-brand { color: @brand-primary; }\n.texto-gris { color: @gray-light; }\n.texto-grisc { color: @grayc; }\n.txt-inverse { color: @text-inverse; }\n.border-bottom-dark { border-bottom: 1px solid @gray-darker; }\n.border-bottom-gray { border-bottom: 1px solid @gray; }\n.border-bottom-lighter { border-bottom: 1px solid @gray-lighter; }\n.half-width { width: 50%; }\n.full-width { width: 100%; }\n.decoration-none {\n  text-decoration: none;\n}\n// text overflow para los Call to action(CTA)\n.btn {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n}\n//??\n.btn-ellipsis { max-width: 180px;}\n//Botón Volver en Player\n.btn-volver {\n  background: @gray-dark;\n  border: none;\n  i {\n    border-radius: 2px;\n    margin: -12px 10px -12px -12px;\n    padding: 10px;\n  }\n}\n//contenedor de los item HD y PPE\n.item-wrapper {\n  display: table;\n  position: relative;\n  a { cursor: pointer;}\n}\n\n.label-hd {\n    background: @gray7;\n    color: @white;\n    border: 1px solid @gray7;\n    padding-top: 3px;\n    font-weight: 800;\n  }\n\n.label-default-hd {\n    border-radius: 0;\n    background: @gray7;\n    text-transform: uppercase;\n  }\n\n\n.item-format--span {\n  padding: 0!important;\n}\n\n.item-hd {\n  color: @white;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n  .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));\n    background: rgba(0, 0, 0, 0.5);\n  display: none !important;\n    height: 19px;\n    left: 1px;\n    padding: 0 2px 1px;\n    position: absolute;\n    text-align: center;\n    font-weight: bolder;\n    top: 1px;\n    width: 31px;\n}\n//cambio flor mangian//\n.item-hd-estaspor {\n  color: @white;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n    background: rgba(0, 0, 0, 0.5);\n    height: 19px;\n    left: 1px;\n    padding: 0 2px 1px;\n    position: absolute;\n    text-align: center;\n    font-weight: bolder;\n    top: 1px;\n    width: 31px;\n}\n//fin cambio flor mangian//\n.item-format-epg{\n  position: relative;\n  top: 0;\n  right: 0;\n  font-weight: bolder;\n  color:@white;\n  text-align: center;\n  > div{\n    width: 100%;\n    > label{\n      width: 100%;\n    }\n  }\n}\n.item-format.item-format-right {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-weight: bolder;\n  color:@white;\n  text-align: center;\n  .item-format-ppe {\n    display: block !important;\n    padding: 0 5px;\n\n    /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/\n      background: rgba(0, 0, 0, 0);\n      float: right;\n  }\n  i {\n    /*text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n    .box-shadow(-1px 1px 1px rgba(0, 0, 0, 0.5));*/\n      background: rgba(0, 0, 0, 0.5);\n      float: right;\n      height: 19px;\n      padding: 3px 0 16px 1px;\n  }\n\n  .download {\n    padding: 0;\n  }\n}\n\n.item-format {\n\n}\n\n.item-format-right {\n  margin: 0;\n  padding: 0;\n}\n\n//FIN contenedor de los item HD y PPE\n.vidrierawidgetficha-html{ display:none;}\n\n// Inicio estilos Carrousel\n.row-cw {\n  margin:0 auto;\n  width: 100%;\n  }\n\n.section-doble .container-wrapper, .section-bg  {\n  h2, h3, h4, h5 { color: @white;}\n}\n.section-doble.section-recienvisto .container-wrapper { height: 375px;}\n.section-doble.section-recienvisto.horizontal .container-wrapper { height: 245px;}\n.section-doble.section-recomendado .container-wrapper { padding-bottom: 20px;}\n.section-doble .container-visto { background: none repeat scroll 0 0 @gray-dark;}\n.section-doble .container-recomendado {\n  background: none repeat scroll 0 0 #515151;\n  z-index: 2;\n}\n.container-recomendado2 { z-index: 2;}\n/*.section-porver { min-height: 382px;}*/\n.section-recienvisto { margin-top: 30px; }\n\n.section-doble .row-cw .container-recomendado2 img {\n  height: 201px;\n}\n\n//hack para carrusel roto\n/*.section-recienvisto {\n   min-height: 248px;\n\n}*/\n/* Carrouseles\n-------------------------------------------------- */\n@media (min-width: 769px) {\n  .section-doble .row-cw .container-recomendado {width: 480px;}\n  .section-doble.horizontal .row-cw .container-recomendado {width: 320px;}\n  .section-doble .row-cw .container-recomendado2 {\n    background: none;\n    height: 202px;\n    padding: 0;\n    width: 155px;\n    margin-left:20px;\n  }\n  .section-doble .row-cw .container-visto > div {\n    margin-left: 495px;\n  }\n  .section-doble.horizontal .row-cw .container-visto > div {\n    margin-left: 332px;\n  }\n  .container-recomendado3 > div {\n    margin-left: 165px;\n  }\n  .col-cw {\n    position: absolute;\n    top: 0;\n  }\n  .section-doble.section-recomendado .container-wrapper.container-recomendado3.col-cw {\n    top: 0;/* ajuste vertical*/\n  }\n  .row-cw{\n    position: relative;\n    margin:0 auto;\n    width: 100%;\n  }\n}\n\n\n// Fin estilos Carrousel\n\n// Seccion Sugerencias\n.section-sugest {\n  padding-bottom: 20px;\n  .item-1 {\n    padding-bottom: 15px;\n    padding-left: 20px;\n    padding-right: 20px;\n    position: relative;\n    z-index: 2;\n  }\n  .item-2 { padding: 0 20px 15px;}\n  .item-1 { background: none repeat scroll 0 0 @gray-dark;}\n  .item-2 { background: none repeat scroll 0 0 #3F3F3F;}\n  b.fa-caret-right {\n    color: @gray-dark;\n    font-size: 35px;\n    margin-top: -17px;\n    position: absolute;\n    right: -10px;\n    top: 50%;\n  }\n  b.fa-caret-down {\n    bottom: -21px;\n    color: @gray-dark;\n    font-size: 35px;\n    margin-right: -17px;\n    position: absolute;\n    right: 50%;\n    z-index: 2;\n  }\n}\n\n.item-header h3 {\n  margin-right: 5px;\n  color: @white;\n}\n\n// scroll-infinito\n.section-scroll { position: relative;}\n.select2 {\n  position: absolute;\n  right: 25px;\n  top: 20px;\n  z-index: 5;\n\n  @media (max-width: 410px) {\n    position: relative;\n    top: 0;\n    left: 10px;\n  }\n}\n.container2.container-scroll { margin: 20px auto 0;}\n\n.section-scroll .container-scroll .image {\n padding-bottom: 20px;\n}\n\n.layout-fichabts .section-sugeridos .container {\n  background-color: @gray-dark;\n  padding: 0 25px 25px 25px;\n  h3 { color: @white;}\n}\n// Fin scroll-infinito\n//Pre-descarga\n//Alto fijo para columna - botón silverlight\n.bot-descargar { height: 45px;}\n//EST boton telcel desactivado\n.btn-disabled {\n  color: @gray-lighter;\n  background: (@gray-light *1.2);\n  border-color: (@gray-light *1.2);\n  &:focus, &:active, &:hover {\n    color: (@gray-lighter);\n    background: (@gray-light);\n    border-color: (@gray-light);\n  }\n}\n/* << Inicio Media Querys >> */\n// Login\n@media (max-width: 990px) {\n  .img-captcha {\n    text-align: center;\n    margin-bottom: 10px;\n  }\n}\n\n// Resgistro - Renta\n// A unificar\n@media (max-width: @screen-md-max) {\n  .registro { width:100%;}\n}\n\n//Medios de Pago\n@media (max-width: @screen-xs-max) {\n  .medios-pagos-mobile.padding-2 { padding: 0;}\n  .medios-pagos-mobile .btn-default { padding:10px 15px;}\n    }\n@media (max-width: @screen-sm-max) {\n    .col-xs-12 { display: table; }\n  .text-center-sm {\n    text-align: center;\n    float:none !important;\n  }\n}\n\n@media (max-width: @screen-md-max) {\n  .btn-frecuencias {\n     padding: (@grid-gutter-width * 2) (@grid-gutter-width / 5);\n     background: #000;\n     border-color: (@gray-light * 1.45);\n     color: @gray-lighter;\n     &:hover, &:focus, &:active, &.active {\n       background: #000;\n       color: @gray-lighter;\n       border-color: (@gray-light * 1.25);\n       border-bottom: 1px solid @white;\n    }\n  }\n  .btn-frecuencias-active {\n     padding: (@grid-gutter-width * 2);\n     background: @white;\n     color: @gray-darker;\n     border-bottom: 1px solid @white;\n  }\n  .btn-left {\n    padding-right: 0;\n    .btn {\n      border-bottom-right-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n  .btn-center {\n    padding-right: 0;\n    padding-left: 0;\n    .btn { border-radius: 0;}\n  }\n  .btn-right {\n    padding-left: 0;\n    .btn {\n      border-bottom-left-radius: 0;\n      border-top-left-radius: 0;\n    }\n  }\n}\n\n/* PREFERENCES */\n.form-prefs {\n  h5 {\n    margin: 0 auto;\n    line-height: (@line-height-base * 1.5);\n    font-size: 15px;\n  }\n\n  .pref-radio {\n    display: none;\n  }\n\n  .col-lg-6, .col-md-6, .col-lg-2, .col-md-2 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .pref-text {\n    width: 100%;\n    height: 100%;\n    display: block;\n    cursor: pointer;\n    font-weight: normal;\n    padding: 1em;\n    margin: 0 auto;\n    border: 1px solid @gray-lighter;\n\n    &:hover {\n      background: @white;\n      color: black;\n    }\n  }\n\n  .col-xs-12 {\n    display: table;\n  }\n\n  .pref-radio:checked + .pref-text {\n    background: @white;\n    color: @black;\n  }\n\n  .prefs-devices {\n    label {\n      cursor: pointer;\n    }\n\n    .pref-text {\n      margin-bottom: .5rem;\n    }\n  }\n}\n\n@media screen and (max-width: @screen-md-min ) {\n  .opt {\n    &.first {\n      .pref-text {\n        border-radius: @border-radius-base 0 0 @border-radius-base;\n      }\n    }\n\n    &.last {\n      .pref-text {\n        border-radius: 0 @border-radius-base @border-radius-base 0;\n      }\n    }\n  }\n}\n\n@media screen and (min-width: @screen-md-min ) {\n  .form-prefs {\n    .pref-single { line-height: 50%; }\n\n    .pref-text {\n      background: @black;\n      padding: 0;\n      border-radius: (@border-radius-base * 15);\n      height: 30px;\n      width: 30px;\n      overflow: hidden;\n      color: transparent;\n      text-indent: -9999999px;\n      transition: all .15s ease-in-out;\n      box-shadow: 0 0 0 @gray;\n    }\n\n    .pref-radio:checked + .pref-text {\n      box-shadow: 0 0 0 .2em @gray;\n    }\n\n    .pref-device {\n      text-align: center;\n    }\n  }\n}\n/* Fin Metodos de Pago*/\n\n/* Cargando */\n@media (max-width: @screen-xs-max) {\n  .cargando-full-screen {\n    .logos { height:70px;}\n  }\n}\n\n\n// Seccion Sugerencias\n\n@media (max-width: 768px) {\n  .section-sugest{\n    .item-2, .item-wrapper {width:100%}\n    .item-1{\n      padding-bottom: 6px;\n      width: 100%;\n      min-height: 70px;\n      text-align: center;\n    }\n  }\n}\n\n\n// scroll-infinito\n\n@media (max-width: 768px) {\n  .section-scroll .item-wrapper img { height: 190px;}\n  .section-doble .container-wrapper, .section-bg  {\n    h2, h3, h4, h5 {\n      text-align: center;\n      margin-top: 15px;\n    }\n  }\n  .jcarousel-6 .item-img > img { height: 160px;}\n}\n\n@media (max-width: @screen-xs-max) {\n  .section-recomendado,\n  .section-sugest {\n    .item-title {color: @brand-primary;}\n  }\n}\n// Fin scroll-infinito\n/* << Fin Media Querys >> */\n\n/* Cebrado para tablas y listas */\n.cebrado > .impar{\n    background: (@gray-light * 1.55);\n}\n\n.cebrado > ul li:nth-child(2n){\n    background: (@gray-light * 1.55);\n}\n\n.mi-cuenta  .single-line\n{\n  @media (min-width: 768px)\n  {\n    .col-md-0\n    {\n      width: auto;\n    }\n    }\n  @media (min-width: 500px ) and (max-width: 768px )\n  {\n    .padding-top-1 {\n    line-height: 50px;}\n  }\n  .fa-certificate span {\n      color: #fff;\n      font-size: 20px;\n      left: -30px;\n      position: relative;\n      top: -11px;\n  }\n  .fa-certificate {\n      color: #ea2f23;\n      float: left;\n      font-size: 50px;\n  }\n}\n\n\n/*estilos rediseño-2015*/\n.row-table-cell {\n    display: table-row;\n}\n.row-table-cell > * {\n  display: table-cell;\n  float: none;\n  vertical-align: bottom;\n}\n\n@media (max-width: 768px) {\n  .row-table-cell {\n      display: table;\n  }\n  .row-table-cell > * {\n    display: table;\n    float: left;\n    vertical-align: top;\n  }\n\n  .carousel-caption{\n\n  }\n}\n\n\n.no-border{\n    border: 0;\n}\n\n.landing .carousel.slide.destacado .carousel-inner\n{\n  overflow: visible;\n  border: none;\n}\n\n// mixins centrado\n.responsive-centered() {\n  margin:0 auto;\n}\n.responsive-uncentered() {\n  margin: auto;\n}\n.centered\n{\n.responsive-centered()\n}\n\n.centered-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-centered();\n  }\n}\n\n//mixins text-center\n\n/*.text-right\n.text-left\n.text-center*/\n\n.responsive-text-center() {\n  .text-center;\n}\n\n.text-center-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-text-center();\n  }\n}\n\n//bg 100% cover\n.cover {\n    height: 200%;\n    position: fixed;\n    top: -50%;\n    width: 200%;\n    z-index: -999;\n    left: -50%;\n}\n.cover img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    min-width: 50%;\n    min-height: 50%;\n}\n\n.form-container {\n min-height: 380px;\n}\n\n.dispositivos ul li a {\n    display: block;\n}\n\n//ficha\n.layout-fichabts .cover img {\n opacity: 0.5;\n}\n\n.item-rating {\n  background: none;\n  border-radius: 0;\n  border:1px solid #f2f2f2;\n  color: @gray5 !important;\n}\n\n.tooltip-score .fa {\n    font-size: 1.5em;\n}\n\n.section-ficha .tooltip-score .fa {\n  margin: 2px;\n}\n .label-default {\n  color: #0c0c0c;\n}\n\n\n//pasar a mixin circles\n\n.btn-circle {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  padding: 6px 0;\n  font-size: 12px;\n  line-height: 1.428571429;\n  border-radius: 15px;\n}\n.btn-circle.btn-lg {\n  width: 38px;\n  height: 38px;\n  padding: 2px 10px;\n  font-size: 18px;\n  line-height: 1.8;\n  border-radius: 25px;\n}\n.btn-circle.btn-xl {\n  width: 70px;\n  height: 70px;\n  padding: 10px 16px;\n  font-size: 24px;\n  line-height: 1.33;\n  border-radius: 35px;\n}\n\n.btn-circle.btn-lg .fa {\n  line-height: 1;\n  margin-top: 9px;\n  font-size: 14px;\n}\n\n\n//item btn\n.item-btn-wrapper {\n    width: 100%;\n}\n.item-btn-wrapper > * {\n    margin: 0 auto;\n    display: table;\n}\n.item-btn {\n    display: inline-block;\n    cursor: pointer;\n}\n.item-btn > * {\n    float: left;\n    clear: both;\n}\n.item-btn span {\n    font-size: 12px;\n}\n.list-inline.list-float > li\n{\n  float:left;\n}\n\n.item-fbkbutton {\n  height: 38px;\n  padding-top: 10px;\n} /*revisar iframe*/\n\n/*horizontal scrolling tabs*/\n\n.wrapper-tab {\n  position:relative;\n  margin:0 auto;\n  overflow:hidden;\n  padding:5px 0;\n  height:38px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid @gray1;\n  .nav > li > a {\n    border-bottom:3px solid transparent;\n    color:@gray4;\n    &:hover,\n    &:focus{\n      background: none;\n      border-bottom:3px solid @gray4;\n      color: @white;\n    }\n  }\n  .nav > li > a.active {\n      border-bottom:3px solid @gray3;\n  }\n}\n.list {\n  position:absolute;\n  left:0px;\n  top:0px;\n  min-width:3000px;\n  margin-left:12px;\n  margin-top:0px;\n  li{\n    display:table-cell;\n    position:relative;\n    text-align:center;\n    cursor:grab;\n    cursor:-webkit-grab;\n    color:#efefef;\n    vertical-align:middle;\n  }\n}\n.scroller-tab {\n  text-align:center;\n  cursor:pointer;\n  display:none;\n  padding:6px;\n  padding-top:7px;\n  white-space:no-wrap;\n  vertical-align:middle;\n  border: 1px solid rgba(255,255,255,0.3);\n}\n\n.scroller-tab-right { float: right; }\n.scroller-tab-left { float: left; }\n\n\n//*footer hardcode(nav-estilos)*/\n.footer_web--footer {\n  border-radius: 0 !important;\n  background-color: fade(@black,70) !important;\n}\n\n/*Registro definir flexbox footer*/\n.layout-registro .main-wrapper {\n  min-height: @pasos-height;\n}\n\n.jcarousel .fa {\n &.fa-chevron-right,\n &.fa-chevron-left{\n  font-size: 18px;\n  margin-top: -9px;}\n}\n\n.panel-light2, .panel-gray-light {\n  background-color: @gray1;\n  display:inline-block;\n}\n\n.panel, .panel-gray-lighter {\n  background-color: @panel-bg;\n  .box-shadow(0 1px 1px rgba(0,0,0,.05));\n}\n\n/* PRUEBAS img placeholder\n\nimg:before, .item-wrapper > a:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background: #232323;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}*/\n\n.modal-parental .pin-error {\n  line-height: 30px;\n}\n\n//hack section vistime01 cuando no tiene compradas\n.section-recienvisto.section-dirty_recienvisto01 .col-cw {\n  position: relative !important;\n}\n.section-recienvisto.section-dirty_recienvisto01{\n  background-color: #333333\n}\n\n/*.modal-body > .fa {\n  color: @black;\n}*/\n\n\n//transicion\nsection {\nanimation: opacity 1.2s;\n}\n\n@keyframes opacity {\n    from { opacity: 0.2; }\n    to   { opacity: 1; }\n}\n\n.menuhidden {\n  opacity: 0;\n  -webkit-transition: opacity 0.1s ease-in-out;\n  -moz-transition: opacity 0.1s ease-in-out;\n  -ms-transition: opacity 0.1s ease-in-out;\n  -o-transition: opacity 0.1s ease-in-out;\n  transition: opacity 0.1s ease-in-out;\n}\n\n.menuvisible{\n  opacity: 1;\n}\n\n//transicion links y botones\na, button {\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -o-transition: all 0.1s linear;\n  -ms-transition: all 0.1s linear;\n  transition: all 0.1s linear;\n}\n\n.play {\n  -webkit-transition: all 0.1s linear;\n  -moz-transition: all 0.1s linear;\n  -o-transition: all 0.1s linear;\n  -ms-transition: all 0.1s linear;\n  transition: all 0.1s linear;\n}\n\n.layer{\n  background-color: @layout;\n  opacity: 1;\n}\n.layer-epg{\n  background-color: @layout;\n  opacity: 1;\n  position: absolute;\n  left: 0;\n}\n// Buttons\n// -------------------------\n.button-variant(@color; @background; @border) {\n  color: @color;\n  background-color: @background;\n  border-color: @border;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open .dropdown-toggle& {\n    color: @color;\n    background-color: darken(@background, 30%);\n        border-color: darken(@border, 35%);\n  }\n}\n\n.nav {\n  .nav-pills{\n    .nav-stacked {\n      > li {\n        > a {\n          position: relative;\n          display: block;\n          padding: @nav-link-padding;\n          &:hover,\n          &:focus {\n            text-decoration: none;\n            background-color: #eeeeee;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n\n/// DIRTY\n\n.main-wrapper.dirty .isotope .row {\n  /*width: 12000px;*/\n  width: 80%;\n  margin: 0 auto;\n  display: block;\n  animation: all 1.2s;\n}\n\n.main-wrapper.dirty .isotope .post {\n  /*width: 300px;*/\n  float: left;\n  animation: all 1.2s;\n  transition-duration: 400ms;\n  transition-delay: 0ms;\n}\n//hotfix LOGIN\n.main-wrapper.dirty-login section.registro .form-login button{\n  opacity: 0.3;\n  cursor: default;\n  //background: red;\n  animation: btnloginfade 1.2s;\n}\n@keyframes btnloginfade {\n    from { opacity: 0.3; }\n    to   { opacity: 1; }\n}\n\n.isotope .post\n{\n  float: left;\n  /*transition-duration: 400ms;*/\n  transition-delay: 0ms;\n}\n\n// Collapsable panels (aka, accordion)\n//\n// Wrap a series of panels in `.panel-group` to turn them into an accordion with\n// the help of our collapse JavaScript plugin.\n.panel-group {\n  // Tighten up margin so it's only between panels\n  .panel {\n    margin-bottom: 0;\n    border-radius: @panel-border-radius;\n    overflow: hidden; // crop contents when collapsed\n    display: block;\n    + .panel {\n      margin-top: 5px;\n    }\n  }\n}\n\n.fs-fb{\n  font-size: 18px !important;\n}\n","//\n// Component animations\n// --------------------------------------------------\n\n// Heads up!\n//\n// We don't use the `.opacity()` mixin here since it causes a bug with text\n// fields in IE7-8. Source: https://github.com/twitter/bootstrap/pull/3552.\n\n.fade {\n  opacity: 0;\n  .transition(opacity .15s linear);\n  &.in {\n    opacity: 1;\n  }\n}\n\n.collapse {\n  display: none;\n  &.in {\n    display: block;\n  }\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  .transition(height .35s ease);\n}\n","//\n// Dropdown menus\n// --------------------------------------------------\n\n\n// Dropdown arrow/caret\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 10px;\n  vertical-align: middle;\n  border-top:   7px solid @dropdown-caret-color;\n  border-right: @caret-width-large solid transparent;\n  border-left:  @caret-width-large solid transparent;\n  // Firefox fix for https://github.com/twbs/bootstrap/issues/9538. Once fixed,\n  // we can just straight up remove this.\n  border-bottom: 0 dotted;\n}\n\n// The dropdown wrapper (div)\n.dropdown {\n  position: relative;\n}\n\n// Prevent the focus on the dropdown toggle when closing dropdowns\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n// The dropdown menu (ul)\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: -60px;\n  z-index: @zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 0; // override default ul\n  list-style: none;\n  font-size: @font-size-base;\n  background-color: @dropdown-bg;\n  border: 1px solid @dropdown-fallback-border; // IE8 fallback\n  border: 1px solid @dropdown-border;\n  border-radius: @border-radius-small;\n  .box-shadow(0 6px 12px rgba(0,0,0,.175));\n  background-clip: padding-box;\n\n  // Aligns the dropdown menu to right\n  &.pull-right {\n    right: 0;\n    left: auto;\n  }\n\n  // Dividers (basically an hr) within the dropdown\n  .divider {\n    .nav-divider(@dropdown-divider-bg);\n  }\n\n  // Links within the dropdown menu\n  > li > a {\n    display: block;\n    padding: 0 20px;\n    clear: both;\n    font-weight: normal;\n    line-height: @line-height-base;\n    color: @dropdown-link-color;\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\n  }\n}\n\n\n// Active state\n.dropdown-menu > .active > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-active-color;\n    text-decoration: none;\n    outline: 0;\n    background-color: @dropdown-link-active-bg;\n  }\n}\n\n// Disabled state\n//\n// Gray out text and ensure the hover/focus state remains gray\n\n.dropdown-menu > .disabled > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-disabled-color;\n  }\n}\n// Nuke hover/focus effects\n.dropdown-menu > .disabled > a {\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    background-color: transparent;\n    background-image: none; // Remove CSS gradient\n    .reset-filter();\n    cursor: not-allowed;\n  }\n}\n\n// Open state for the dropdown\n.open {\n  // Show the menu\n  > .dropdown-menu {\n    display: block;\n  }\n\n  // Remove the outline when :focus is triggered\n  > a {\n    outline: 0;\n  }\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: @font-size-small;\n  line-height: @line-height-base;\n  color: @dropdown-header-color;\n}\n\n// Backdrop to catch body clicks on mobile, etc.\n.dropdown-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: @zindex-dropdown - 10;\n}\n\n// Right aligned dropdowns\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n//\n// Just add .dropup after the standard .dropdown class and you're set, bro.\n// TODO: abstract this so that the navbar fixed styles are not placed here?\n\n.dropup,\n.navbar-fixed-bottom .dropdown {\n  // Reverse the caret\n  .caret {\n    // Firefox fix for https://github.com/twbs/bootstrap/issues/9538. Once this\n    // gets fixed, restore `border-top: 0;`.\n    border-top: 0 dotted;\n    border-bottom: @caret-width-base solid @dropdown-caret-color;\n    content: \"\";\n  }\n  // Different positioning for bottom up menu\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-bottom: 1px;\n  }\n}\n\n\n// Component alignment\n//\n// Reiterate per navbar.less and the modified component alignment there.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-right {\n    .dropdown-menu {\n      .pull-right > .dropdown-menu();\n    }\n  }\n}\n\n@media screen and (max-width: 917px) {\n  .dropdown-menu {\n    right: -16px;\n    left: auto;\n    overflow: auto;\n  }\n}\n","//\n// Button groups\n// --------------------------------------------------\n\n// Button carets\n//\n// Match the button text color to the arrow/caret for indicating dropdown-ness.\n\n.caret {\n  .btn-default & {\n    border-top-color: @btn-default-color;\n  }\n  .btn-primary &,\n  .btn-success &,\n  .btn-warning &,\n  .btn-danger &,\n  .btn-info & {\n    border-top-color: #fff;\n  }\n}\n.dropup {\n  .btn-default .caret {\n    border-bottom-color: @btn-default-color;\n  }\n  .btn-primary,\n  .btn-success,\n  .btn-warning,\n  .btn-danger,\n  .btn-info {\n   .caret {\n      border-bottom-color: #fff;\n    }\n  }\n}\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n  > .btn {\n    position: relative;\n    float: left;\n    // Bring the \"active\" button to the front\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 2;\n    }\n    &:focus {\n      // Remove focus outline when dropdown JS adds it after closing the menu\n      outline: none;\n    }\n  }\n}\n\n// Prevent double borders when buttons are next to each other\n.btn-group {\n  .btn + .btn,\n  .btn + .btn-group,\n  .btn-group + .btn,\n  .btn-group + .btn-group {\n    margin-left: -1px;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  .clearfix();\n\n  .btn-group {\n    float: left;\n  }\n  // Space out series of button groups\n  > .btn,\n  > .btn-group {\n    + .btn,\n    + .btn-group {\n      margin-left: 5px;\n    }\n  }\n}\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n\n// Set corners individual because sometimes a single button can be in a .btn-group and we need :first-child and :last-child to both match\n.btn-group > .btn:first-child {\n  margin-left: 0;\n  &:not(:last-child):not(.dropdown-toggle) {\n    .border-right-radius(0);\n  }\n}\n// Need .dropdown-toggle since :last-child doesn't apply given a .dropdown-menu immediately after it\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  .border-left-radius(0);\n}\n\n// Custom edits for including btn-groups within btn-groups (useful for including dropdown buttons within a btn-group)\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-right-radius(0);\n  }\n}\n.btn-group > .btn-group:last-child > .btn:first-child {\n  .border-left-radius(0);\n}\n\n// On active and open, don't show outline\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-xs > .btn { .btn-xs(); }\n.btn-group-sm > .btn { .btn-sm(); }\n.btn-group-lg > .btn { .btn-lg(); }\n\n\n// Split button dropdowns\n// ----------------------\n\n// Give the line between buttons some depth\n.btn-group > .btn + .dropdown-toggle {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n// The clickable button for toggling the menu\n// Remove the gradient and set the same inset shadow as the :active state\n.btn-group.open .dropdown-toggle {\n  .box-shadow(inset 0 3px 5px rgba(0,0,0,.125));\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    .box-shadow(none);\n  }\n}\n\n\n// Reposition the caret\n.btn .caret {\n  margin-left: 0;\n}\n// Carets in other button sizes\n.btn-lg .caret {\n  border-width: @caret-width-large @caret-width-large 0;\n  border-bottom-width: 0;\n}\n// Upside down carets for .dropup\n.dropup .btn-lg .caret {\n  border-width: 0 @caret-width-large @caret-width-large;\n}\n\n\n// Vertical button groups\n// ----------------------\n\n.btn-group-vertical {\n  > .btn,\n  > .btn-group {\n    display: block;\n    float: none;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  // Clear floats so dropdown menus can be properly placed\n  > .btn-group {\n    .clearfix();\n    > .btn {\n      float: none;\n    }\n  }\n\n  > .btn + .btn,\n  > .btn + .btn-group,\n  > .btn-group + .btn,\n  > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n  }\n}\n\n.btn-group-vertical > .btn {\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  &:first-child:not(:last-child) {\n    border-top-right-radius: @border-radius-base;\n    .border-bottom-radius(0);\n  }\n  &:last-child:not(:first-child) {\n    border-bottom-left-radius: @border-radius-base;\n    .border-top-radius(0);\n  }\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-bottom-radius(0);\n  }\n}\n.btn-group-vertical > .btn-group:last-child > .btn:first-child {\n  .border-top-radius(0);\n}\n\n\n\n// Justified button groups\n// ----------------------\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  .btn {\n    float: none;\n    display: table-cell;\n    width: 1%;\n  }\n}\n\n\n// Checkbox and radio options\n[data-toggle=\"buttons\"] > .btn > input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn > input[type=\"checkbox\"] {\n  display: none;\n}\n","//\n// Input groups\n// --------------------------------------------------\n\n// Base styles\n// -------------------------\n.input-group {\n  position: relative; // For dropdowns\n  display: table;\n  border-collapse: separate; // prevent input groups from inheriting border styles from table cells when placed within a table\n\n  // Undo padding and float of grid classes\n  &.col {\n    float: none;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .form-control {\n    width: 100%;\n    margin-bottom: 0;\n  }\n}\n\n// Sizing options\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn { .input-lg(); }\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn { .input-sm(); }\n\n\n// Display as table-cell\n// -------------------------\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n}\n// Addon and addon wrapper for buttons\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle; // Match the inputs\n}\n\n// Text input groups\n// -------------------------\n.input-group-addon {\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  font-weight: normal;\n  line-height: 1;\n  color: @input-color;\n  text-align: center;\n  background-color: @input-group-addon-bg;\n  border: 1px solid @input-group-addon-border-color;\n  border-left: none;\n  border-radius: @border-radius-base;\n\n  // Sizing\n  &.input-sm {\n    padding: @padding-small-vertical @padding-small-horizontal;\n    font-size: @font-size-small;\n    border-radius: @border-radius-small;\n  }\n  &.input-lg {\n    padding: @padding-large-vertical @padding-large-horizontal;\n    font-size: @font-size-large;\n    border-radius: @border-radius-large;\n  }\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n// Reset rounded corners\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n  .border-right-radius(0);\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n  .border-left-radius(0);\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n\n// Button input groups\n// -------------------------\n.input-group-btn {\n  position: relative;\n  white-space: nowrap;\n\n  // Negative margin to only have a 1px border between the two\n  &:first-child > .btn {\n    margin-right: -1px;\n  }\n  &:last-child > .btn {\n    margin-left: -1px;\n  }\n}\n.input-group-btn > .btn {\n  position: relative;\n  // Jankily prevent input button groups from wrapping\n  + .btn {\n    margin-left: -4px;\n  }\n  // Bring the \"active\" button to the front\n  &:hover,\n  &:active {\n    z-index: 2;\n  }\n}\n","//\n// Navs\n// --------------------------------------------------\n\n\n// Base class\n// --------------------------------------------------\n\n.nav {\n  margin-bottom: 0;\n  padding-left: 0; // Override default ul/ol\n  list-style: none;\n  .clearfix();\n\n  > li {\n    position: relative;\n    display: block;\n\n    > a {\n      position: relative;\n      display: block;\n      padding: @nav-link-padding;\n      font-family: \"Roboto\";\n      font-size: 18px;\n      font-weight: lighter;\n      &:hover,\n      &:focus {\n        text-decoration: none;\n        background-color: @nav-link-hover-bg;\n      }\n    }\n\n    // Disabled state sets text to gray and nukes hover/tab effects\n    &.disabled > a {\n      color: @nav-disabled-link-color;\n\n      &:hover,\n      &:focus {\n        color: @nav-disabled-link-hover-color;\n        text-decoration: none;\n        background-color: transparent;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  // Open dropdowns\n  /*.open > a {\n    &,\n    &:hover,\n    &:focus {\n      background-color: @nav-link-hover-bg;\n      border-color: @link-color;\n\n      .caret {\n        border-top-color: @link-hover-color;\n        border-bottom-color: @link-hover-color;\n      }\n    }\n  }*/\n\n  // Nav dividers (deprecated with v3.0.1)\n  //\n  // This should have been removed in v3 with the dropping of `.nav-list`, but\n  // we missed it. We don't currently support this anywhere, but in the interest\n  // of maintaining backward compatibility in case you use it, it's deprecated.\n  .nav-divider {\n    .nav-divider();\n  }\n\n  // Prevent IE8 from misplacing imgs\n  //\n  // See https://github.com/h5bp/html5-boilerplate/issues/984#issuecomment-3985989\n  > li > a > img {\n    max-width: none;\n  }\n}\n\n\n// Tabs\n// -------------------------\n\n// Give the tabs something to sit on\n.nav-tabs {\n  border-bottom: 1px solid @nav-tabs-border-color;\n  > li {\n    float: left;\n    // Make the list-items overlay the bottom border\n    margin-bottom: -1px;\n\n    // Actual tabs (as links)\n    > a {\n      margin-right: 2px;\n      line-height: @line-height-base;\n      border: 1px solid transparent;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n      &:hover {\n        border-color: @nav-tabs-link-hover-border-color @nav-tabs-link-hover-border-color @nav-tabs-border-color;\n      }\n    }\n\n    // Active state, and it's :hover to override normal :hover\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-tabs-active-link-hover-color;\n        background-color: @nav-tabs-active-link-hover-bg;\n        border: 1px solid @nav-tabs-active-link-hover-border-color;\n        border-bottom-color: transparent;\n        cursor: default;\n      }\n    }\n  }\n  // pulling this in mainly for less shorthand\n  &.nav-justified {\n    .nav-justified();\n    .nav-tabs-justified();\n  }\n}\n\n\n// Pills\n// -------------------------\n.nav-pills {\n  > li {\n    float: left;\n\n    // Links rendered as pills\n    > a {\n      border-radius: @nav-pills-border-radius;\n      font-size: 13px;\n    }\n    + li {\n      margin-left: 2px;\n    }\n\n    // Active state\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-pills-active-link-hover-color;\n        background-color: @nav-pills-active-link-hover-bg;\n\n        .caret {\n          border-top-color: @nav-pills-active-link-hover-color;\n          border-bottom-color: @nav-pills-active-link-hover-color;\n        }\n      }\n    }\n        // Active state\n    &.active > a.btn {\n      &:hover,\n      &:focus {\n       /* background-color: #d01f14; */ //revisar los mixins\n       /* border-color: #be1c12;*/\n      }\n    }\n  }\n}\n\n\n// Stacked pills\n.nav-stacked {\n  > li {\n    float: none;\n    + li {\n      margin-top: 2px;\n      margin-left: 0; // no need for this gap between nav items\n    }\n  }\n}\n\n\n// Nav variations\n// --------------------------------------------------\n\n// Justified nav links\n// -------------------------\n\n.nav-justified {\n  width: 100%;\n\n  > li {\n    float: none;\n     > a {\n      text-align: center;\n      margin-bottom: 5px;\n    }\n  }\n\n  > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li {\n      display: table-cell;\n      width: 1%;\n      > a {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n// Move borders to anchors instead of bottom of list\n//\n// Mixin for adding on top the shared `.nav-justified` styles for our tabs\n.nav-tabs-justified {\n  border-bottom: 0;\n\n  > li > a {\n    // Override margin from .nav-tabs\n    margin-right: 0;\n    border-radius: @border-radius-base;\n  }\n\n  > .active > a,\n  > .active > a:hover,\n  > .active > a:focus {\n    border: 1px solid @nav-tabs-justified-link-border-color;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li > a {\n      border-bottom: 1px solid @nav-tabs-justified-link-border-color;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n    }\n    > .active > a,\n    > .active > a:hover,\n    > .active > a:focus {\n      border-bottom-color: @nav-tabs-justified-active-link-border-color;\n    }\n  }\n}\n\n\n// Tabbable tabs\n// -------------------------\n\n// Hide tabbable panes to start, show them when `.active`\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n\n\n// Dropdowns\n// -------------------------\n\n// Make dropdown carets use link color in navs\n.nav .caret {\n  border-top-color: @link-color;\n  border-bottom-color: @link-color;\n}\n.nav a:hover .caret {\n  border-top-color: @link-hover-color;\n  border-bottom-color: @link-hover-color;\n}\n\n// Specific dropdowns\n.nav-tabs .dropdown-menu {\n  // make dropdown border overlap tab border\n  margin-top: -1px;\n  // Remove the top rounded corners here since there is a hard edge above the menu\n  .border-top-radius(0);\n}\n\n.nav .open > li  > a.menu_user  {\n  @media (min-width: @screen-sm-min) {\n    background-color: transparent !important;\n  }\n}\n\n.menu_user-on-hover > li > a,\n.menu_user-on-hover > li > a:hover,\n.menu_user-on-hover > li > a:focus {\n\n  @media (min-width: @screen-sm-min) {\n    background-color: transparent;\n  }\n  background-color: #333333;\n}\n\n// .menu_user-top-margin {\n//   @media (max-width: @screen-sm-min) {\n//     margin-top: 0px !important;\n//     background-color: #333333;\n//   }\n// }\n\n@media (max-width: 821px) {\n    .buscar {\n      width: 185px !important;\n    }\n  }","//\n// Navbars\n// --------------------------------------------------\n\n\n// Wrapper and base class\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  min-height: @navbar-height; // Ensure a navbar always shows (e.g., without a .navbar-brand in collapsed mode)\n  border: 1px solid transparent;\n\n  // Prevent floats from breaking the navbar\n  .clearfix();\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: @navbar-border-radius;\n  }\n}\n\n\n// Navbar heading\n//\n// Groups `.navbar-brand` and `.navbar-toggle` into a single component for easy\n// styling of responsive aspects.\n\n.navbar-header {\n  .clearfix();\n\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n  }\n}\n\n\n// Navbar collapse (body)\n//\n// Group your navbar content into this for easy collapsing and expanding across\n// various device sizes. By default, this content is collapsed when <768px, but\n// will expand past that for a horizontal display.\n//\n// To start (on mobile devices) the navbar links, forms, and buttons are stacked\n// vertically and include a `max-height` to overflow in case you have too much\n// content for the user's viewport.\n\n.navbar-collapse {\n  overflow-x: visible;\n  padding-right: @navbar-padding-horizontal;\n  padding-left:  @navbar-padding-horizontal;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255,255,255,.1);\n  .clearfix();\n  -webkit-overflow-scrolling: touch;\n\n  &.in {\n    overflow-y: auto;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n\n    &.collapse {\n      display: block !important;\n      height: auto !important;\n      padding-bottom: 0; // Override default setting\n      overflow: visible !important;\n    }\n\n    &.in {\n      overflow-y: auto;\n    }\n\n    // Account for first and last children spacing\n    .navbar-nav.navbar-left:first-child {\n      margin-left: -@navbar-padding-horizontal;\n    }\n    .navbar-nav.navbar-right:last-child {\n      margin-right: -@navbar-padding-horizontal;\n    }\n    .navbar-text:last-child {\n      margin-right: 0;\n    }\n  }\n}\n\n\n// Both navbar header and collapse\n//\n// When a container is present, change the behavior of the header and collapse.\n\n.container > .navbar-header,\n.container > .navbar-collapse {\n  margin-right: -@navbar-padding-horizontal;\n  margin-left:  -@navbar-padding-horizontal;\n\n  @media (min-width: @grid-float-breakpoint) {\n    margin-right: 0;\n    margin-left:  0;\n    display: none;\n  }\n}\n\n\n//\n// Navbar alignment options\n//\n// Display the navbar across the entirety of the page or fixed it to the top or\n// bottom of the page.\n\n// Static top (unfixed, but 100% wide) navbar\n.navbar-static-top {\n  z-index: @zindex-navbar;\n  border-width: 0 0 1px;\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n\n// Fix the top/bottom navbars when screen real estate supports it\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: @zindex-navbar-fixed;\n\n  // Undo the rounded corners\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0; // override .navbar defaults\n  border-width: 1px 0 0;\n}\n\n\n// Brand/project name\n\n.navbar-brand {\n  float: left;\n  padding: @navbar-padding-vertical @navbar-padding-horizontal;\n  font-size: @font-size-large;\n  line-height: @line-height-computed;\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    .navbar > .container & {\n      margin-left: -@navbar-padding-horizontal;\n    }\n  }\n}\n\n\n// Navbar toggle\n//\n// Custom button for toggling the `.navbar-collapse`, powered by the collapse\n// JavaScript plugin.\n\nbutton#buscadorXsButton {\n    text-overflow: clip !important;\n}\n\n\n.navbar-toggle {\n  position: relative;\n  float: right;\n  margin-right: @navbar-padding-horizontal;\n  // padding: 9px 10px;\n  .navbar-vertical-align(34px);\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: @border-radius-base;\n  top: -5px;\n\n  // Bars\n  .icon-bar {\n    margin-top: 14px;\n    margin-left: 27px;\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px;\n    background-color: @white !important;\n\n  }\n  .icon-bar + .icon-bar {\n    margin-top: 4px;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    display: none;\n  }\n}\n\n#menu360.responsive ul li:nth-child(1), #menu360.responsive ul li:nth-child(2) {\n  display: inline-block;\n}\n#menu360.responsive ul li:nth-child(2) a {\n  padding-left: 0px;\n}\n#menu360.responsive ul li:not(:nth-child(1)):not(:nth-child(2)) {\n  display: none;\n}\n#menu360.responsive ul li {\n  float: none !important;\n}\n#menu360 .container {\n  width: 100%;\n}\n.navMenu--user {\n  top: auto !important;\n}\n#menu360 {\n  background-color: #303030 !important;\n  vertical-align: middle !important;\n  border: none !important;\n  font-family: Roboto !important;\n  color: #ffffff !important;\n\n}\n#menu360 ul li a {color: #fff !important;\n}\n#menu360:not(.responsive) ul {\n  margin: 0 auto !important;\n  display: table !important;\n  vertical-align: middle;\n  float: none !important;\n}\n#menu360 ul li:nth-child(2) {\n  display: none;\n  width: 24px !important;\n  height: 24px !important;\n}\n#menu360 ul li:not(:nth-child(1)):not(:nth-child(2)) {\n  margin-top: 5px;\n}\n\n\n// Navbar nav links\n//\n// Builds on top of the `.nav` components with it's own modifier class to make\n// the nav the full height of the horizontal nav (above 768px).\n\n@primary-color: #FFF;\n@secondary-color: darken(@primary-color, 20%);\n\n.navbar-nav {\n  margin: 5px 0px -4px -2px;\n\n  > li > a {\n    padding-top:    10px;\n    padding-bottom: 10px;\n    line-height: @line-height-computed;\n  }\n\n  .nav-item {\n    color: @secondary-color;\n\n    &:hover{\n      color: @primary-color;\n    }\n\n    &--active {\n      box-shadow: 0 -3px 0 #FFF inset !important;\n      > a > span{\n        color: @primary-color;\n        font-weight: bolder;\n      }\n    }\n  }\n\n  @media (max-width: @screen-xs-max) {\n    // Dropdowns get custom display when collapsed\n    .open .dropdown-menu {\n      position: static;\n      float: none;\n      width: auto;\n      margin-top: 0;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none;\n      > li > a,\n      .dropdown-header {\n        padding: 5px 15px 5px 25px;\n      }\n      > li > a {\n        line-height: @line-height-computed;\n        &:hover,\n        &:focus {\n          background-image: none;\n        }\n      }\n    }\n\n    .nav-item {\n      margin: -1px;\n      \n      border-bottom: 3px solid @gray-dark;\n    }\n\n    &.menu_user-top-margin.menu-anonymous {\n      margin-top: 0 !important;\n    }\n  }\n\n  // Uncollapse the nav\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n    margin: 0;\n\n    > li {\n      float: left;\n    }\n  }\n\n}\n\n\n// Component alignment\n//\n// Repurpose the pull utilities as their own navbar utilities to avoid specificity\n// issues with parents and chaining. Only do this when the navbar is uncollapsed\n// though so that navbar contents properly stack and align in mobile.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-left  { .pull-left(); }\n  .navbar-right { .pull-right(); }\n}\n\n\n// Navbar form\n//\n// Extension of the `.form-inline` with some extra flavor for optimum display in\n// our navbars.\n\n.navbar-form {\n  margin-left: -@navbar-padding-horizontal;\n  margin-right: -@navbar-padding-horizontal;\n  padding: 10px @navbar-padding-horizontal;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  @shadow: inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.1);\n  .box-shadow(@shadow);\n  @media (min-width: @screen-lg-min) {\n    margin-top: 6px;\n    margin-bottom: 0;\n  }\n  // Mixin behavior for optimum display\n  .form-inline();\n\n  .form-group {\n    @media (max-width: @screen-xs-max) {\n      margin-bottom: 5px;\n    }\n  }\n\n  // Vertically center in expanded, horizontal navbar\n  .navbar-vertical-align(@input-height-base);\n\n  // Undo 100% width for pull classes\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    border: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    .box-shadow(none);\n  }\n}\n\n\n// Dropdown menus\n\n// Menu position and menu carets\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  .border-top-radius(0);\n}\n// Menu position and menu caret support for dropups via extra dropup class\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  .border-bottom-radius(0);\n}\n\n// Right aligned menus need alt position\n.navbar-nav.pull-right > li > .dropdown-menu,\n.navbar-nav > li > .dropdown-menu.pull-right {\n  left: auto;\n  right: 0;\n}\n\n\n// Buttons in navbars\n//\n// Vertically center a button within a navbar (when *not* in a form).\n\n.navbar-btn {\n  .navbar-vertical-align(@input-height-base);\n}\n\n\n// Text in navbars\n//\n// Add a class to make any element properly align itself vertically within the navbars.\n\n.navbar-text {\n  float: left;\n  .navbar-vertical-align(@line-height-computed);\n\n  @media (min-width: @grid-float-breakpoint) {\n    margin-left: @navbar-padding-horizontal;\n    margin-right: @navbar-padding-horizontal;\n  }\n}\n.navbar-text2 {\n  float: left;\n  .navbar-vertical-align(@line-height-computed);\n\n  @media (min-width: @grid-float-breakpoint) {\n    margin-left: @navbar-padding-horizontal;\n    margin-right: 15px;\n    margin-top: 8px !important;\n  }\n}\n\n// Alternate navbars\n// --------------------------------------------------\n\n// Default navbar\n.navbar-default {\n  background-color: @navbar-default-bg;\n  border-color: @navbar-default-border;\n\n  .navbar-brand {\n    color: @navbar-default-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-default-brand-hover-color;\n      background-color: @navbar-default-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-default-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-default-link-color;\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-hover-color;\n        background-color: @navbar-default-link-hover-bg;\n\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-active-color;\n        background-color: @navbar-default-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-disabled-color;\n        background-color: @navbar-default-link-disabled-bg;\n      }\n    }\n  }\n\n  .navbar-toggle {\n    border-color: @navbar-default-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-default-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-default-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: @navbar-default-border;\n  }\n\n  // Dropdown menu items and carets\n  .navbar-nav {\n    // Caret should match text color on hover\n    > .dropdown > a:hover .caret,\n    > .dropdown > a:focus .caret {\n      border-top-color: @navbar-default-link-hover-color;\n      border-bottom-color: @navbar-default-link-hover-color;\n    }\n\n    // Remove background color from open dropdown\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        background-color: @navbar-default-link-active-bg;\n        color: @navbar-default-link-active-color;\n        .caret {\n          border-top-color: @navbar-default-link-active-color;\n          border-bottom-color: @navbar-default-link-active-color;\n        }\n      }\n    }\n    > .dropdown > a .caret {\n      border-top-color: @navbar-default-link-color;\n      border-bottom-color: @navbar-default-link-color;\n    }\n\n\n    @media (max-width: @screen-xs-max) {\n      // Dropdowns get custom display when collapsed\n      .open .dropdown-menu {\n        > li > a {\n          color: @navbar-default-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-hover-color;\n            background-color: @navbar-default-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-active-color;\n            background-color: @navbar-default-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-disabled-color;\n            background-color: @navbar-default-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n\n  // Links in navbars\n  //\n  // Add a class to ensure links outside the navbar nav are colored correctly.\n\n  .navbar-link {\n    color: @navbar-default-link-color;\n    &:hover {\n      color: @navbar-default-link-hover-color;\n    }\n  }\n\n}\n\n// Inverse navbar\n\n.navbar-inverse {\n  background-color: @navbar-inverse-bg;\n  border-color: @navbar-inverse-border;\n\n  .navbar-brand {\n    color: @navbar-inverse-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-inverse-brand-hover-color;\n      background-color: @navbar-inverse-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-inverse-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-inverse-link-color;\n\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-hover-color;\n        background-color: @navbar-inverse-link-hover-bg;\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-active-color;\n        background-color: @navbar-inverse-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-disabled-color;\n        background-color: @navbar-inverse-link-disabled-bg;\n      }\n    }\n  }\n\n  // Darken the responsive nav toggle\n  .navbar-toggle {\n    border-color: @navbar-inverse-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-inverse-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-inverse-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: darken(@navbar-inverse-bg, 7%);\n  }\n\n  // Dropdowns\n  .navbar-nav {\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        background-color: @navbar-inverse-link-active-bg;\n        color: @navbar-inverse-link-active-color;\n      }\n    }\n    > .dropdown > a:hover .caret {\n      border-top-color: @navbar-inverse-link-hover-color;\n      border-bottom-color: @navbar-inverse-link-hover-color;\n    }\n    > .dropdown > a .caret {\n      border-top-color: @navbar-inverse-link-color;\n      border-bottom-color: @navbar-inverse-link-color;\n    }\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        .caret {\n          border-top-color: @navbar-inverse-link-active-color;\n          border-bottom-color: @navbar-inverse-link-active-color;\n        }\n      }\n    }\n\n    @media (max-width: @screen-xs-max) {\n      // Dropdowns get custom display\n      .open .dropdown-menu {\n        > .dropdown-header {\n          border-color: @navbar-inverse-border;\n        }\n        > li > a {\n          color: @navbar-inverse-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-hover-color;\n            background-color: @navbar-inverse-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-active-color;\n            background-color: @navbar-inverse-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-disabled-color;\n            background-color: @navbar-inverse-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n  .navbar-link {\n    color: @navbar-inverse-link-color;\n    &:hover {\n      color: @navbar-inverse-link-hover-color;\n    }\n  }\n\n}\n\na.dropdown-toggle.dropdownUser {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n@media only screen and (max-width: 768px) {\n  a.dropdown-toggle.dropdownUser {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n\n\n// When no-highlight is present as class name on li element\n.navbar-nav > li.no-highlight {\n  & > .dropdown-menu {\n    width: auto;\n    min-width: auto;\n\n    .menuItem--div {\n      border: none;\n      min-height: auto;\n\n      &:last-of-type {\n        background: none;\n        margin-top: -7px;\n      }\n\n      & > li {\n        padding: 12px 0px;\n      }\n    }\n  }\n}\n\n// WHen the first child has image\n.navbar-nav {\n  span.nav-image {\n    margin-top: -5px;\n    display: block;\n  }\n  .section-nav{\n    img.nav-icon {\n      padding: 0px 5px;\n      width: 30px;\n    }\n  }\n}\n","//\n// Utility classes\n// --------------------------------------------------\n\n\n// Floats\n// -------------------------\n\n.clearfix {\n  .clearfix();\n}\n.center-block {\n  .center-block();\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n\n\n// Toggling content\n// -------------------------\n\n// Note: Deprecated .hide in favor of .hidden or .sr-only (as appropriate) in v3.0.1\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  .text-hide();\n}\n\n\n// Hide from screenreaders and browsers\n//\n// Credit: HTML5 Boilerplate\n\n.hidden {\n  display: none !important;\n  visibility: hidden !important;\n}\n\n\n// For Affix plugin\n// -------------------------\n\n.affix {\n  position: fixed;\n}\n","// Bordered & Pulled\n// -------------------------\n\n.@{fa-css-prefix}-border {\n  padding: .2em .25em .15em;\n  border: solid .08em @fa-border-color;\n  border-radius: .1em;\n}\n\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n.@{fa-css-prefix} {\n  &.pull-left { margin-right: .3em; }\n  &.pull-right { margin-left: .3em; }\n}\n","//\n// Breadcrumbs\n// --------------------------------------------------\n\n\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: @line-height-computed;\n  list-style: none;\n  background-color: @breadcrumb-bg;\n  border-radius: @border-radius-base;\n  > li {\n    display: inline-block;\n    + li:before {\n      content: \"@{breadcrumb-separator}\\00a0\"; // Unicode space added since inline-block means non-collapsing white-space\n      padding: 0 5px;\n      color: @breadcrumb-color;\n    }\n  }\n  > .active {\n    color: @breadcrumb-active-color;\n  }\n}\n","//\n// Pagination (multiple pages)\n// --------------------------------------------------\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  border-radius: @border-radius-base;\n\n  > li {\n    display: inline; // Remove list-style and block-level defaults\n    > a,\n    > span {\n      position: relative;\n      float: left; // Collapse white-space\n      padding: @padding-base-vertical @padding-base-horizontal;\n      line-height: @line-height-base;\n      text-decoration: none;\n      background-color: @pagination-bg;\n      border: 1px solid @pagination-border;\n      margin-left: -1px;\n    }\n    &:first-child {\n      > a,\n      > span {\n        margin-left: 0;\n        .border-left-radius(@border-radius-base);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius-base);\n      }\n    }\n  }\n\n  > li > a,\n  > li > span {\n    &:hover,\n    &:focus {\n      background-color: @pagination-hover-bg;\n    }\n  }\n\n  > .active > a,\n  > .active > span {\n    &,\n    &:hover,\n    &:focus {\n      z-index: 2;\n      color: @pagination-active-color;\n      background-color: @pagination-active-bg;\n      border-color: @pagination-active-bg;\n      cursor: default;\n    }\n  }\n\n  > .disabled {\n    > span,\n    > span:hover,\n    > span:focus,\n    > a,\n    > a:hover,\n    > a:focus {\n      color: @pagination-disabled-color;\n      background-color: @pagination-bg;\n      border-color: @pagination-border;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Sizing\n// --------------------------------------------------\n\n// Large\n.pagination-lg {\n  .pagination-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @border-radius-large);\n}\n\n// Small\n.pagination-sm {\n  .pagination-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @border-radius-small);\n}\n","//\n// Pager pagination\n// --------------------------------------------------\n\n\n.pager {\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  list-style: none;\n  text-align: center;\n  .clearfix();\n  li {\n    display: inline;\n    > a,\n    > span {\n      display: inline-block;\n      padding: 5px 14px;\n      background-color: @pagination-bg;\n      border: 1px solid @pagination-border;\n      border-radius: @pager-border-radius;\n    }\n\n    > a:hover,\n    > a:focus {\n      text-decoration: none;\n      background-color: @pagination-hover-bg;\n    }\n  }\n\n  .next {\n    > a,\n    > span {\n      float: right;\n    }\n  }\n\n  .previous {\n    > a,\n    > span {\n      float: left;\n    }\n  }\n\n  .disabled {\n    > a,\n    > a:hover,\n    > a:focus,\n    > span {\n      color: @pager-disabled-color;\n      background-color: @pagination-bg;\n      cursor: not-allowed;\n    }\n  }\n\n}\n","//\n// Labels\n// --------------------------------------------------\n\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: @label-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n\n  // Add hover effects, but only for links\n  &[href] {\n    &:hover,\n    &:focus {\n      color: @label-link-hover-color;\n      text-decoration: none;\n      cursor: pointer;\n    }\n  }\n\n  // Empty labels collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n}\n\n// Colors\n// Contextual variations (linked labels get darker on :hover)\n\n.label-default {\n  .label-variant(@label-default-bg);\n}\n\n.label-primary {\n  .label-variant(@label-primary-bg);\n}\n\n.label-success {\n  .label-variant(@label-success-bg);\n}\n\n.label-info {\n  .label-variant(@label-info-bg);\n}\n\n.label-warning {\n  .label-variant(@label-warning-bg);\n}\n\n.label-danger {\n  .label-variant(@label-danger-bg);\n}\n","//\n// Badges\n// --------------------------------------------------\n\n\n// Base classes\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: @font-size-small;\n  font-weight: @badge-font-weight;\n  color: @badge-color;\n  line-height: @badge-line-height;\n  vertical-align: baseline;\n  white-space: nowrap;\n  text-align: center;\n  background-color: @badge-bg;\n  border-radius: @badge-border-radius;\n\n  // Empty badges collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n}\n\n// Hover state, but only for links\na.badge {\n  &:hover,\n  &:focus {\n    color: @badge-link-hover-color;\n    text-decoration: none;\n    cursor: pointer;\n  }\n}\n\n// Quick fix for labels/badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n@-moz-document url-prefix() {\n    .btn .badge {\n          top: -1px;\n          margin-left: 4px;\n          right: 0px!important;\n    }\n}\n\n// Account for counters in navs\na.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: @badge-active-color;\n  background-color: @badge-active-bg;\n}\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n","//\n// Jumbotron\n// --------------------------------------------------\n\n\n.jumbotron {\n  padding: @jumbotron-padding;\n  margin-bottom: @jumbotron-padding;\n  font-size: @jumbotron-font-size;\n  font-weight: 200;\n  line-height: (@line-height-base * 1.5);\n  color: @jumbotron-color;\n  background-color: @jumbotron-bg;\n\n  h1 {\n    line-height: 1;\n    color: @jumbotron-heading-color;\n  }\n  p {\n    line-height: 1.4;\n  }\n\n  .container & {\n    border-radius: @border-radius-large; // Only round corners at higher resolutions if contained in a container\n  }\n\n  @media screen and (min-width: @screen-sm-min) {\n    padding-top:    (@jumbotron-padding * 1.6);\n    padding-bottom: (@jumbotron-padding * 1.6);\n\n    .container & {\n      padding-left:  (@jumbotron-padding * 2);\n      padding-right: (@jumbotron-padding * 2);\n    }\n\n    h1 {\n      font-size: (@font-size-base * 4.5);\n    }\n  }\n}\n","//\n// Thumbnails\n// --------------------------------------------------\n\n\n// Mixin and adjust the regular image class\n.thumbnail {\n  .img-thumbnail();\n  display: block; // Override the inline-block from `.img-thumbnail`\n  margin-bottom: @line-height-computed;\n\n  > img {\n    .img-responsive();\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  // Add a hover state for linked versions only\n  a&:hover,\n  a&:focus,\n  a&.active {\n    border-color: @link-color;\n  }\n\n  // Image captions\n  .caption {\n    padding: @thumbnail-caption-padding;\n    color: @thumbnail-caption-color;\n  }\n}\n","//\n// Alerts\n// --------------------------------------------------\n\n\n// Base styles\n// -------------------------\n\n.alert {\n  padding: @alert-padding;\n  margin-bottom: @line-height-computed;\n  border: 1px solid transparent;\n  border-radius: @alert-border-radius;\n\n  // Headings for larger alerts\n  h4 {\n    margin-top: 0;\n    // Specified for the h4 to prevent conflicts of changing @headings-color\n    color: inherit;\n  }\n  // Provide class for links that match alerts\n  .alert-link {\n    font-weight: @alert-link-font-weight;\n  }\n\n  // Improve alignment and spacing of inner content\n  > p,\n  > ul {\n    margin-bottom: 0;\n  }\n  > p + p {\n    margin-top: 5px;\n  }\n}\n\n// Dismissable alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissable {\n padding-right: (@alert-padding + 20);\n\n  // Adjust close link position\n  .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit;\n  }\n}\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n.alert-success {\n  .alert-variant(@alert-success-bg; @alert-success-border; @alert-success-text);\n}\n.alert-info {\n  .alert-variant(@alert-info-bg; @alert-info-border; @alert-info-text);\n}\n.alert-warning {\n  .alert-variant(@alert-warning-bg; @alert-warning-border; @alert-warning-text);\n}\n.alert-danger {\n  .alert-variant(@alert-danger-bg; @alert-danger-border; @alert-danger-text);\n}\n","//\n// Progress bars\n// --------------------------------------------------\n\n\n// Bar animations\n// -------------------------\n\n// WebKit\n@-webkit-keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n// Firefox\n@-moz-keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n// Opera\n@-o-keyframes progress-bar-stripes {\n  from  { background-position: 0 0; }\n  to    { background-position: 40px 0; }\n}\n\n// Spec and IE10+\n@keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n\n\n// Bar itself\n// -------------------------\n\n// Outer container\n.progress {\n  overflow: hidden;\n  height: @line-height-computed;\n  margin-bottom: @line-height-computed;\n  background-color: @progress-bg;\n  border-radius: @border-radius-base;\n  .box-shadow(inset 0 1px 2px rgba(0,0,0,.1));\n}\n\n// Bar of progress\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: @font-size-small;\n  line-height: @line-height-computed;\n  color: @progress-bar-color;\n  text-align: center;\n  background-color: @progress-bar-bg;\n  .box-shadow(inset 0 -1px 0 rgba(0,0,0,.15));\n  .transition(width .6s ease);\n}\n\n// Striped bars\n.progress-striped .progress-bar {\n  #gradient > .striped();\n  background-size: 40px 40px;\n}\n\n// Call animation for the active one\n.progress.active .progress-bar {\n  .animation(progress-bar-stripes 2s linear infinite);\n}\n\n\n\n// Variations\n// -------------------------\n\n.progress-bar-success {\n  .progress-bar-variant(@progress-bar-success-bg);\n}\n\n.progress-bar-info {\n  .progress-bar-variant(@progress-bar-info-bg);\n}\n\n.progress-bar-warning {\n  .progress-bar-variant(@progress-bar-warning-bg);\n}\n\n.progress-bar-danger {\n  .progress-bar-variant(@progress-bar-danger-bg);\n}\n","// Media objects\n// Source: http://stubbornella.org/content/?p=497\n// --------------------------------------------------\n\n\n// Common styles\n// -------------------------\n\n// Clear the floats\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n\n// Proper spacing between instances of .media\n.media,\n.media .media {\n  margin-top: 15px;\n}\n.media:first-child {\n  margin-top: 0;\n}\n\n// For images and videos, set to block\n.media-object {\n  display: block;\n}\n\n// Reset margins on headings for tighter default spacing\n.media-heading {\n  margin: 0 0 5px;\n}\n\n\n// Media image alignment\n// -------------------------\n\n.media {\n  > .pull-left {\n    margin-right: 10px;\n  }\n  > .pull-right {\n    margin-left: 10px;\n  }\n}\n\n\n// Media list variation\n// -------------------------\n\n// Undo default ul/ol styles\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n","//\n// List groups\n// --------------------------------------------------\n\n// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n.list-group {\n  // No need to set list-style: none; since .list-group-item is block level\n  margin-bottom: 20px;\n  padding-left: 0; // reset padding because ul and ol\n}\n\n// Individual list items\n// -------------------------\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  // Place the border on the list items and negative margin up for better styling\n  margin-bottom: -1px;\n  background-color: @list-group-bg;\n  border: 1px solid @list-group-border;\n\n  // Round the first and last items\n  &:first-child {\n    .border-top-radius(@list-group-border-radius);\n  }\n  &:last-child {\n    margin-bottom: 0;\n    .border-bottom-radius(@list-group-border-radius);\n  }\n\n  // Align badges within list items\n  > .badge {\n    float: right;\n  }\n  > .badge + .badge {\n    margin-right: 5px;\n  }\n}\n\n// Linked list items\na.list-group-item {\n  color: @list-group-link-color;\n\n  .list-group-item-heading {\n    color: @list-group-link-heading-color;\n  }\n\n  // Hover state\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    background-color: @list-group-hover-bg;\n  }\n\n  // Active class on item itself, not parent\n  &.active,\n  &.active:hover,\n  &.active:focus {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: @list-group-active-color;\n    background-color: @list-group-active-bg;\n    border-color: @list-group-active-border;\n\n    // Force color to inherit for custom content\n    .list-group-item-heading {\n      color: inherit;\n    }\n    .list-group-item-text {\n      color: lighten(@list-group-active-bg, 40%);\n    }\n  }\n}\n\n// Custom content options\n// -------------------------\n\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n","//\n// Panels\n// --------------------------------------------------\n\n\n// Base class\n.panel {\n  margin-bottom: @line-height-computed;\n  background-color: @panel-bg;\n  border: 1px solid transparent;\n  border-radius: @panel-border-radius;\n  .box-shadow(0 1px 1px rgba(0,0,0,.05));\n}\n\n.panel-light {\n  background: @gray3f;\n}\n\n////.panel-light {\n  ////background: @white;\n////}\n\n.panel-gray { \n  background: @gray;\n}\n\n.panel-graydark {\n  background: @gray3f;\n}\n\n.panel-dark {\n  background: @gray-darker;\n}\n\n.panel-transp-50 {\n  background: fade(@panel-bg, 50%);\n}\n.panel-dark-70 {\n  background: fade(color(@panel-bg), 70%);\n  display:inline-block;\n}\n\n.panel-gray-light {\n  background-color: (@gray-light * 1.3);\n  display:inline-block;\n}\n\n.panel-gray-lighter {\n  background: (@gray-light * 1.5);\n  display:inline-block;\n}\n\n.panel-transp-100 {\n  background: fade(@panel-bg, 100%);\n}\n\n// Panel contents\n.panel-body {\n  padding: 15px;\n  .clearfix();\n}\n\n\n// List groups in panels\n//\n// By default, space out list group content from panel headings to account for\n// any kind of custom content between the two.\n\n.panel {\n  > .list-group {\n    margin-bottom: 0;\n\n    .list-group-item {\n      border-width: 1px 0;\n\n      // Remove border radius for top one\n      &:first-child {\n        .border-top-radius(0);\n      }\n      // But keep it for the last one\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n// Collapse space between when there's no additional content.\n.panel-heading + .list-group {\n  .list-group-item:first-child {\n    border-top-width: 0;\n  }\n}\n\n\n// Tables in panels\n//\n// Place a non-bordered `.table` within a panel (not within a `.panel-body`) and\n// watch it go full width.\n\n.panel {\n  > .table,\n  > .table-responsive {\n    margin-bottom: 0;\n  }\n  > .panel-body + .table,\n  > .panel-body + .table-responsive {\n    border-top: 1px solid @table-border-color;\n  }\n  > .table-bordered,\n  > .table-responsive > .table-bordered {\n    border: 0;\n    > thead,\n    > tbody,\n    > tfoot {\n      > tr {\n        > th:first-child,\n        > td:first-child {\n          border-left: 0;\n        }\n        > th:last-child,\n        > td:last-child {\n          border-right: 0;\n        }\n\n        &:last-child > th,\n        &:last-child > td {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n\n// Optional heading\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  .border-top-radius(@panel-border-radius - 1);\n\n  > .dropdown .dropdown-toggle {\n    color: inherit;\n  }\n}\n\n// Within heading, strip any `h*` tag of it's default margins for spacing.\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: ceil((@font-size-base * 1.125));\n  > a {\n    color: inherit;\n  }\n}\n\n// Optional footer (stays gray in every modifier class)\n.panel-footer {\n  padding: 10px 15px;\n  background-color: @panel-footer-bg;\n  border-top: 1px solid @panel-inner-border;\n  .border-bottom-radius(@panel-border-radius - 1);\n}\n\n\n// Collapsable panels (aka, accordion)\n//\n// Wrap a series of panels in `.panel-group` to turn them into an accordion with\n// the help of our collapse JavaScript plugin.\n\n.panel-group {\n  // Tighten up margin so it's only between panels\n  .panel {\n    margin-bottom: 0;\n    border-radius: @panel-border-radius;\n    overflow: hidden; // crop contents when collapsed\n    + .panel {\n      margin-top: 5px;\n    }\n  }\n\n  .panel-heading {\n    border-bottom: 0;\n    + .panel-collapse .panel-body {\n      border-top: 1px solid @panel-inner-border;\n    }\n  }\n  .panel-footer {\n    border-top: 0;\n    + .panel-collapse .panel-body {\n      border-bottom: 1px solid @panel-inner-border;\n    }\n  }\n}\n\n\n// Contextual variations\n.panel-default {\n  .panel-variant(@panel-default-border; @panel-default-text; @panel-default-heading-bg; @panel-default-border);\n}\n.panel-primary {\n  .panel-variant(@panel-primary-border; @panel-primary-text; @panel-primary-heading-bg; @panel-primary-border);\n}\n.panel-success {\n  .panel-variant(@panel-success-border; @panel-success-text; @panel-success-heading-bg; @panel-success-border);\n}\n.panel-warning {\n  .panel-variant(@panel-warning-border; @panel-warning-text; @panel-warning-heading-bg; @panel-warning-border);\n}\n.panel-danger {\n  .panel-variant(@panel-danger-border; @panel-danger-text; @panel-danger-heading-bg; @panel-danger-border);\n}\n.panel-info {\n  .panel-variant(@panel-info-border; @panel-info-text; @panel-info-heading-bg; @panel-info-border);\n}","//\n// Wells\n// --------------------------------------------------\n\n\n// Base class\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: @well-bg;\n  border: 1px solid darken(@well-bg, 7%);\n  border-radius: @border-radius-base;\n  .box-shadow(inset 0 1px 1px rgba(0,0,0,.05));\n  blockquote {\n    border-color: #ddd;\n    border-color: rgba(0,0,0,.15);\n  }\n}\n\n// Sizes\n.well-lg {\n  padding: 24px;\n  border-radius: @border-radius-large;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: @border-radius-small;\n}\n","//\n// Close icons\n// --------------------------------------------------\n\n\n.close {\n  float: right;\n  font-size: (@font-size-base * 1.5);\n  font-weight: @close-font-weight;\n  line-height: 1;\n  color: @close-color;\n  text-shadow: @close-text-shadow;\n  // .opacity(.2);\n\n  &:hover,\n  &:focus {\n    color: @close-color;\n    text-decoration: none;\n    cursor: pointer;\n    .opacity(.5);\n  }\n\n  // Additional properties for button version\n  // iOS requires the button element instead of an anchor tag.\n  // If you want the anchor version, it requires `href=\"#\"`.\n  button& {\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n  }\n}\n","//\n// Modals\n// --------------------------------------------------\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and shit\n\n// Kill the scroll on the body\n.modal-open {\n  overflow: hidden;\n}\n\n// Container that the modal scrolls within\n.modal {\n  display: none;\n  overflow: auto;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: @zindex-modal-background;\n\n  // When fading in the modal, animate it to slide down\n  &.fade .modal-dialog {\n    .translate(0, -25%);\n    .transition-transform(~\"0.3s ease-out\");\n  }\n  &.in .modal-dialog { .translate(0, 0)}\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  padding: 10px;\n  z-index: (@zindex-modal-background + 10);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  background-color: @modal-content-bg;\n  border: 1px solid @modal-content-fallback-border-color; //old browsers fallback (ie8 etc)\n  border: 1px solid @modal-content-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 3px 9px rgba(0,0,0,.5));\n  background-clip: padding-box;\n  // Remove focus outline from opened modal\n  outline: none;\n  color:@white;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: (@zindex-modal-background - 10);\n  background-color: @modal-backdrop-bg;\n  // Fade for backdrop\n  &.fade { .opacity(0); }\n  &.in { .opacity(.5); }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  padding: @modal-title-padding;\n  //border-bottom: 1px solid @modal-header-border-color;\n  min-height: (@modal-title-padding + @modal-title-line-height);\n}\n// Close icon\n.modal-header .close {\n  margin-top: -2px;\n}\n\n// Title text within header\n.modal-title {\n  margin: 0;\n  line-height: @modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  padding: 20px 40px;\n  //background: (@gray-lighter / 1.1);\n}\n\n// Footer (for actions)\n.modal-footer {\n  margin-top: 0px;\n  padding: (@modal-inner-padding - 1) @modal-inner-padding @modal-inner-padding;\n  text-align: right; // right align buttons\n  //border-top: 1px solid @modal-footer-border-color;\n  .clearfix(); // clear it in case folks use .pull-* classes on buttons\n\n  // Properly space out buttons\n  .btn + .btn {\n    margin-left: 5px;\n    margin-bottom: 0; // account for input[type=\"submit\"] which gets the bottom margin like all other inputs\n  }\n  // but override that for button groups\n  .btn-group .btn + .btn {\n    margin-left: -1px;\n  }\n  // and override it for block buttons as well\n  .btn-block + .btn-block {\n    margin-left: 0;\n  }\n}\n\n// Scale up the modal\n@media screen and (min-width: @screen-sm-min) {\n\n  .modal-dialog {\n    width: 600px;\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n  .modal-content {\n    .box-shadow(0 5px 15px rgba(0,0,0,.5));\n  }\n\n}\n","//\n// Tooltips\n// --------------------------------------------------\n\n.dynover-frame {z-index:99999}\n\n\n// Base class\n.tooltip {\n  position: absolute;\n  z-index: @zindex-tooltip;\n  display: block;\n  visibility: visible;\n  font-size: @font-size-small;\n  line-height: 1.4;\n  .opacity(0);\n\n  &.in     { .opacity(.9); }\n  &.top    { margin-top:  -3px; padding: @tooltip-arrow-width 0; }\n  &.right  { margin-left:  3px; padding: 0 @tooltip-arrow-width; }\n  &.bottom { margin-top:   3px; padding: @tooltip-arrow-width 0; }\n  &.left   { margin-left: -3px; padding: 0 @tooltip-arrow-width; }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: @tooltip-max-width;\n  padding: 3px 8px;\n  color: @tooltip-color;\n  text-align: center;\n  text-decoration: none;\n  background-color: @tooltip-bg;\n  border-radius: @border-radius-base;\n}\n\n// Arrows\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.tooltip {\n  &.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-left .tooltip-arrow {\n    bottom: 0;\n    left: @tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-right .tooltip-arrow {\n    bottom: 0;\n    right: @tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-right-color: @tooltip-arrow-color;\n  }\n  &.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-left-color: @tooltip-arrow-color;\n  }\n  &.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-left .tooltip-arrow {\n    top: 0;\n    left: @tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-right .tooltip-arrow {\n    top: 0;\n    right: @tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n}","//\n// Popovers\n// --------------------------------------------------\n\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: @zindex-popover;\n  display: none;\n  max-width: @popover-max-width;\n  padding: 1px;\n  text-align: left; // Reset given new insertion method\n  background-color: @popover-bg;\n  background-clip: padding-box;\n  border: 1px solid @popover-fallback-border-color;\n  border: 1px solid @popover-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 5px 10px rgba(0,0,0,.2));\n\n  // Overrides for proper insertion\n  white-space: normal;\n\n  // Offset the popover to account for the popover arrow\n  &.top     { margin-top: -10px; }\n  &.right   { margin-left: 10px; }\n  &.bottom  { margin-top: 10px; }\n  &.left    { margin-left: -10px; }\n}\n\n.popover-title {\n  margin: 0; // reset heading margin\n  padding: 8px 14px;\n  font-size: @font-size-base;\n  font-weight: normal;\n  line-height: 18px;\n  background-color: @popover-title-bg;\n  border-bottom: 1px solid darken(@popover-title-bg, 5%);\n  border-radius: 5px 5px 0 0;\n}\n\n.popover-content {\n  padding: 9px 14px;\n}\n\n// Arrows\n//\n// .arrow is outer, .arrow:after is inner\n\n.popover .arrow {\n  &,\n  &:after {\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n  }\n}\n.popover .arrow {\n  border-width: @popover-arrow-outer-width;\n}\n.popover .arrow:after {\n  border-width: @popover-arrow-width;\n  content: \"\";\n}\n\n.popover {\n  &.top .arrow {\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-bottom-width: 0;\n    border-top-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-top-color: @popover-arrow-outer-color;\n    bottom: -@popover-arrow-outer-width;\n    &:after {\n      content: \" \";\n      bottom: 1px;\n      margin-left: -@popover-arrow-width;\n      border-bottom-width: 0;\n      border-top-color: @popover-arrow-color;\n    }\n  }\n  &.right .arrow {\n    top: 50%;\n    left: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-left-width: 0;\n    border-right-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-right-color: @popover-arrow-outer-color;\n    &:after {\n      content: \" \";\n      left: 1px;\n      bottom: -@popover-arrow-width;\n      border-left-width: 0;\n      border-right-color: @popover-arrow-color;\n    }\n  }\n  &.bottom .arrow {\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-top-width: 0;\n    border-bottom-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-bottom-color: @popover-arrow-outer-color;\n    top: -@popover-arrow-outer-width;\n    &:after {\n      content: \" \";\n      top: 1px;\n      margin-left: -@popover-arrow-width;\n      border-top-width: 0;\n      border-bottom-color: @popover-arrow-color;\n    }\n  }\n\n  &.left .arrow {\n    top: 50%;\n    right: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-right-width: 0;\n    border-left-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-left-color: @popover-arrow-outer-color;\n    &:after {\n      content: \" \";\n      right: 1px;\n      border-right-width: 0;\n      border-left-color: @popover-arrow-color;\n      bottom: -@popover-arrow-width;\n    }\n  }\n\n}\n","//\n// Carousel\n// --------------------------------------------------\n\n\n// Wrapper for the slide container and indicators\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  border-bottom: 1px solid #222222;\n  > .item {\n    display: none;\n    position: relative;\n    .transition(.6s ease-in-out left);\n\n    // Account for jankitude on images\n    > img,\n    > a > img {\n      .img-responsive();\n      line-height: 1;\n    }\n  }\n\n  > .active,\n  > .next,\n  > .prev { display: block; }\n\n  > .active {\n    left: 0;\n  }\n\n  > .next,\n  > .prev {\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  > .next {\n    left: 100%;\n  }\n  > .prev {\n    left: -100%;\n  }\n  > .next.left,\n  > .prev.right {\n    left: 0;\n  }\n\n  > .active.left {\n    left: -100%;\n  }\n  > .active.right {\n    left: 100%;\n  }\n\n}\n\n// Left/right controls for nav\n// ---------------------------\n\n.carousel-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: @carousel-control-width;\n  .opacity(@carousel-control-opacity);\n  font-size: @carousel-control-font-size;\n  color: @carousel-control-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n  // We can't have this transition here because WebKit cancels the carousel\n  // animation if you trip this while in the middle of another animation.\n\n  // Set gradients for backgrounds\n  &.left {\n    #gradient > .horizontal(@start-color: rgba(0,0,0,.5); @end-color: rgba(0,0,0,.0001));\n  }\n  &.right {\n    left: auto;\n    right: 0;\n    #gradient > .horizontal(@start-color: rgba(0,0,0,.0001); @end-color: rgba(0,0,0,.5));\n  }\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: @carousel-control-color;\n    text-decoration: none;\n    .opacity(.9);\n  }\n\n  // Toggles\n  .icon-prev,\n  .icon-next,\n  .glyphicon-chevron-left,\n  .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    z-index: 5;\n    display: inline-block;\n  }\n  .icon-prev,\n  .glyphicon-chevron-left {\n    left: 50%;\n  }\n  .icon-next,\n  .glyphicon-chevron-right {\n    right: 50%;\n  }\n  .icon-prev,\n  .icon-next {\n    width:  20px;\n    height: 20px;\n    margin-top: -10px;\n    margin-left: -10px;\n    font-family: Roboto;\n  }\n\n  .icon-prev {\n    &:before {\n      content: '\\2039';// SINGLE LEFT-POINTING ANGLE QUOTATION MARK (U+2039)\n    }\n  }\n  .icon-next {\n    &:before {\n      content: '\\203a';// SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (U+203A)\n    }\n  }\n}\n\n// Optional indicator pips\n//\n// Add an unordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  margin-left: -30%;\n  padding-left: 0;\n  list-style: none;\n  text-align: center;\n\n  li {\n    display: inline-block;\n    width:  10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    border: 1px solid @carousel-indicator-border-color;\n    border-radius: 10px;\n    cursor: pointer;\n    // IE8-9 hack for event handling\n    //\n    // Internet Explorer 8-9 does not support clicks on elements without a set\n    // `background-color`. We cannot use `filter` since that's not viewed as a\n    // background color by the browser. Thus, a hack is needed.\n    //\n    // For IE8, we set solid black as it doesn't support `rgba()`. For IE9, we\n    // set alpha transparency for the best results possible.\n    background-color: #000 \\9; // IE8\n    background-color: rgba(0,0,0,0); // IE9\n  }\n  .active {\n    margin: 0;\n    width:  12px;\n    height: 12px;\n    background-color: @carousel-indicator-active-bg !important;\n    border-color: @carousel-indicator-active-bg;\n  }\n}\n\n// Optional captions\n// -----------------------------\n// Hidden by default for smaller viewports\n.carousel-caption {\n  position: absolute;\n  left: 15%;\n  right: 15%;\n  bottom: 20px;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: @carousel-caption-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n  & .btn {\n    text-shadow: none; // No shadow for button elements in carousel-caption\n  }\n}\n\n\n// Scale up controls for tablets and up\n@media screen and (min-width: @screen-sm-min) {\n\n  // Scale up the controls a smidge\n  .carousel-control {\n    .glyphicons-chevron-left,\n    .glyphicons-chevron-right,\n    .icon-prev,\n    .icon-next {\n      width: 30px;\n      height: 30px;\n      margin-top: -15px;\n      margin-left: -15px;\n      font-size: 30px;\n    }\n  }\n\n  // Show and left align the captions\n  .carousel-caption {\n    left: 20%;\n    right: 20%;\n    padding-bottom: 30px;\n  }\n\n  // Move up the indicators\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n","@import \"bootstrap.less\";\n\n/* BUSCADOR COMBO PREDICTIVO\n-------------------------------------------------- */\n\n.autocomplete-w1 {/* background:url(img/shadow.png) no-repeat bottom right;*/position:absolute;\n   top:0px;\n   left:0px;\n    margin:8px 0 0 6px;\n    /* IE6 fix: */ _background:none; _margin:0;\n}\n\n.autocomplete {\n/*width:207px !important;*/\ncolor:#000;\nborder-top:1px solid #1E1E1E;\n// border:1px solid #DADADA;\nbackground:#FFFFFF;\ncursor:default;\ntext-align:left;\n//max-height:350px;\n/*overflow:auto;*/\noverflow: auto;\nmargin: 0 0 0 -6px;\n/* IE6 specific: */\n_height:350px;\n_margin:0;\n_overflow-x:hidden;\npadding:0 10px;\n}\n.autocompleteContainter {\n  @media (min-width: @screen-sm-min) {\n  width: 240px !important;\n  }\n}\n.autocomplete .selected {\n  background:#E0E0E0;\n  border-radius: 2px;\n  color: @gray-darker;\n}\n.autocomplete div {\n    /*border-top: 1px dotted #E0E0E0;*/\n    font-size: 13px;\n    line-height: 15px;\n    padding: 6px 0 !important;\n  }\n\n.autocomplete-category {\n    color: @gray-dark;\n    //font-size: 12px !important;\n   // font-weight: bold;   \n    margin-left: 0;\n}\n.autocomplete-category-suggest {\n  border-bottom: 1px solid #DADADA;\n}\n\n.autocomplete a {\n  color: @gray-dark;\n  padding: 5px !important;\n}\n.autocomplete img {\n  padding-left: 0;\n}\n.autocomplete h5 {\n  margin-top: 6px;\n  margin-bottom: 6px;\n}\n.autocomplete li:first-child {\n    padding-left: 5px;\n}\n.resultado-busqueda {\n  @media (max-width: @screen-xs-max) {\n    h2 {\n      font-size: 10px;\n    }\n  }\n}","//\n// Responsive: Utility classes\n// --------------------------------------------------\n\n\n// IE10 in Windows (Phone) 8\n//\n// Support for responsive views via media queries is kind of borked in IE10, for\n// Surface/desktop in split view and for Windows Phone 8. This particular fix\n// must be accompanied by a snippet of JavaScript to sniff the user agent and\n// apply some conditional CSS to *only* the Surface/desktop Windows 8. Look at\n// our Getting Started page for more information on this bug.\n//\n// For more information, see the following:\n//\n// Issue: https://github.com/twbs/bootstrap/issues/10497\n// Docs: http://getbootstrap.com/getting-started/#browsers\n// Source: http://timkadlec.com/2012/10/ie10-snap-mode-and-responsive-design/\n\n@-ms-viewport {\n  width: device-width;\n}\n\n\n// Visibility utilities\n.visible-xxs {\n  .responsive-invisibility();\n  @media (max-width: @screen-xxs-max) {\n    .responsive-visibility();\n  }\n  &.visible-xs {\n    @media (min-width: @screen-xs-min) and (max-width: @screen-xs-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-visibility();\n    }\n  }\n}\n.visible-xs {\n  .responsive-invisibility();\n  @media (max-width: @screen-xs-max) {\n    .responsive-visibility();\n  }\n  &.visible-xss {\n    @media (min-width: @screen-xxs-min) and (max-width: @screen-xxs-max) {\n      .responsive-visibility();\n    }\n  }  \n  &.visible-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-visibility();\n    }\n  }\n}\n.visible-sm {\n  .responsive-invisibility();\n  &.visible-xss {\n    @media (min-width: @screen-xxs-min) and (max-width: @screen-xxs-max) {\n      .responsive-visibility();\n    }\n  }  \n  &.visible-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-visibility();\n    }\n  }\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-visibility();\n  }\n  &.visible-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-visibility();\n    }\n  }\n}\n.visible-md {\n  .responsive-invisibility();\n    &.visible-xss {\n    @media (min-width: @screen-xxs-min) and (max-width: @screen-xxs-max) {\n      .responsive-visibility();\n    }\n  }  \n  &.visible-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-visibility();\n    }\n  }\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-visibility();\n  }\n  &.visible-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-visibility();\n    }\n  }\n}\n.visible-lg {\n  .responsive-invisibility();\n    &.visible-xss {\n    @media (min-width: @screen-xxs-min) and (max-width: @screen-xxs-max) {\n      .responsive-visibility();\n    }\n  }  \n  &.visible-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-visibility();\n    }\n  }\n  &.visible-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-visibility();\n    }\n  }\n  @media (min-width: @screen-lg-min) {\n    .responsive-visibility();\n  }\n}\n//hidden\n.hidden-xxs {\n  .responsive-visibility();\n  @media (max-width: @screen-xs-max) {\n    .responsive-invisibility();\n  }\n  &.hidden-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-invisibility();\n    }\n  }\n}\n.hidden-xs {\n  .responsive-visibility();\n  @media (max-width: @screen-xs-max) {\n    .responsive-invisibility();\n  }\n  &.hidden-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-invisibility();\n    }\n  }\n}\n.hidden2-xs {\n  .responsive-visibility2();\n  @media (max-width: @screen-xs-max) {\n    .responsive-invisibility();\n  }\n  &.hidden-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-invisibility();\n    }\n  }\n}\n.hidden-sm {\n  .responsive-visibility();\n  &.hidden-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-invisibility();\n    }\n  }\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-invisibility();\n  }\n  &.hidden-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-invisibility();\n    }\n  }\n}\n.hidden-md {\n  .responsive-visibility();\n  &.hidden-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-invisibility();\n    }\n  }\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-invisibility();\n  }\n  &.hidden-lg {\n    @media (min-width: @screen-lg-min) {\n      .responsive-invisibility();\n    }\n  }\n}\n.hidden-lg {\n  .responsive-visibility();\n  &.hidden-xs {\n    @media (max-width: @screen-xs-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-sm {\n    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n      .responsive-invisibility();\n    }\n  }\n  &.hidden-md {\n    @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n      .responsive-invisibility();\n    }\n  }\n  @media (min-width: @screen-lg-min) {\n    .responsive-invisibility();\n  }\n}\n\n// Print utilities\n.visible-print {\n  .responsive-invisibility();\n}\n\n@media print {\n  .visible-print {\n    .responsive-visibility();\n  }\n  .hidden-print {\n    .responsive-invisibility();\n  }\n}","// Personalización variables.less\n\n@white:                 (#FFF);\n@black:                 (#000);\n@brand-claro:           @white;\n@brand-primary:         @brand-claro;\n@brand-info:            @gray-light;\n\n@fb-color:              #3B5998;\n@body-bg:               #121212;\n@text-color:            @white;\n\n@text-inverse:          spin(@text-color, 180);\n@text-inverse:          @black;\n\n@link-color:            @gray-light;\n@badge-bg:              @gray;\n@white2:                 (#FAFAFA);\n@gray-dark4:            #444;\n@gray6:                 #666;  \n@gray7:                 #777; \n@grayf4:                #F4F4F4;\n@grayef:                #EFEFEF;\n@grayd:                 #DDD;\n@gray6d:                #6D6D6D;\n@grayc:                 #CCC;\n@gray23:                #232323;\n@gray3f:                #3f3f3f;\n\n//assets colores 2016\n@gray1: #232323;\n@gray2: #3F3F3F;\n@gray3: #666666;\n@gray4: #DDDDDD;\n@gray5: #F2F2F2;\n@green01 : #68B75C; \n@yellow01 : #EBAE3B;\n@red01 : #C93328;\n\n@background-size:       100%;\n@headersm:              @white;\n@brown:                 #C09853;\n@red-light:             #B94A48;\n\n@DIN-Regular:   \"DIN.Regular\", Arial, sans-serif;\n@DIN-Light:     \"DIN.Light\", Arial, sans-serif;\n@DIN-Bold:      \"DIN.Bold\", Arial, sans-serif;\n@DIN-Medium:    \"DIN.Medium\", Arial, sans-serif;\n\n\n@border-radius-base:             4px;\n@border-radius-large:            6px;\n@border-radius-small:            2px;\n@btn-default-color:              @white;\n@btn-default-bg:                 transparent;\n@btn-default-border:             #f1f1f1;\n@btn-primary-bg:                 #f1f1f1;\n@btn-primary-color:              #0c0c0c;\n@btn-primary-border:             #f1f1f1;\n\n// XLarge screen / full HD\n// Note: Creada para resolución HD 1920x1080\n@screen-xl:                     1920px;\n@screen-xl-min:                 @screen-xl;\n@screen-xl-desktop:             @screen-xl-min;\n\n@screen-lg-max:                 (@screen-xl-min - 1);\n\n@grid-gutter-width:             10px;\n@navbar-border-radius:          @border-radius-large;\n.navbar-inverse{ background: @black;}\n@nav-link-padding:              7px 15px;\n@carousel-indicator-active-bg:  @brand-claro;\n\n@hr-border:                   @gray1;\n\n// Forms\n// -------------------------\n\n@input-bg:                  rgba(35, 35, 35, 0.8);\n@input-bg-disabled:         @gray-dark;\n@input-color:               #1E1E1E; \n@input-border:              #666666;\n@input-border-focus:        #66afe9;\n@input-color-placeholder:   #6D6D6D;\n\n// Form states and alerts\n// -------------------------\n@state-danger-text:         #6D6D6D;\n@state-danger-icon:         #EA2F23;\n\n// Close\n// ------------------------\n@close-font-weight:           bold;\n@close-color:                 @white;\n@close-text-shadow:           0 1px 0 #fff;\n\n// Modals\n// -------------------------\n@modal-content-bg:                             #000;\n@modal-content-border-color:                   @gray;\n@modal-content-fallback-border-color:          #999;\n\n// Brand colors\n// -------------------------\n@brand-success:         @white;\n@brand-danger:          @white;\n\n// Labels\n// -------------------------\n@label-default-bg:      @gray5;\n\n// Panels\n// -------------------------\n@panel-bg:                    rgba(30,30,30,.75);\n@panel-inner-border:          #232323;\n.panel {display: inline-block;}\n\n// Footer\n// -------------------------\n@footer-font-color:         #F2F2F2;\n\n// Nav\n// -------------------------\n\n@nav-link-hover-bg:          #eeeeee;\n\n// Pills\n// -------------------------\n\n@component-active-color:         #737373;","// Core variables and mixins\n@import \"bootstrap.less\";\n//Carousel destacado\n//\n/* CUSTOMIZE THE CAROUSEL\n-------------------------------------------------- */\n/*carousel */\n.carousel.slide img {\n    width:100%;\n    height:auto;\n}\n\n/* Carousel base class */\n\n/* Since positioning the image, we need to help out the caption */\n.carousel.destacado .carousel-caption {\n  z-index: 10;\n  text-align: left;\n}\n/* Declare heights because of positioning of img element */\n.carousel.destacado .carousel-inner > .item > img {\n  min-width: 100%;\n  height: auto;\n  cursor: pointer;\n}\n.carousel-control { width: 5%;}\n\n/* .carousel-caption {\n  left:10%;\n  right:10%;\n  padding-bottom: 0;\n} */ /*deprecado v1.0 2016*/\n.landing.layout-landing03 {\n  \n  .container-false.container\n  { \n    position: relative;\n    padding: 0;\n  }\n  .carousel-caption {\n    left:auto;\n    right:auto;\n    padding-bottom: 0;\n    width:100%;\n  }\n}\n.carousel.slide.destacado h2 {\n  /*font-size: (@font-size-base * 1.25);*/\n  margin-top: 0;\n  padding-bottom:10px;\n}\n//\n// Carousel\n// --------------------------------------------------\n\n// carousel principal tapas\n//llama a .smoothDivScroll\n.jcarousel {\n   width:100%;\n  height: 100%;\n  position: relative;\n  display: block;\n    .image {\n  padding-left: 0;\n  padding-right: 0;\n  }\n}\n/* Smooth Div Scroll */\n/* Invisible left hotspot */\ndiv.scrollinghotspotleft {\n  min-width: 40px;\n  width: 10%;\n   width: 40px;\n  height: 100%;\n  position: absolute;\n  // z-index: 10;\n  left: 0;\n  background-color: @black;\n  cursor: pointer;\n    opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n  z-index: 1;\n   //ver IE\n}\n/* Visible left hotspot */\ndiv.scrollinghotspotleftvisible {\n  background-color: @black;\n  background-repeat: no-repeat;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n}\n/* Invisible right hotspot */\ndiv.scrollinghotspotright {\n  min-width: 40px;\n  width: 10%;\n  width: 40px;\n  height: 100%;\n  background-color:  @black;\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: pointer;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n  z-index: 1;\n//ver IE\n}\n/* Visible right hotspot */\ndiv.scrollinghotspotrightvisible {\n  background-color: @black;\n  background-repeat: no-repeat;\n  opacity: 0.35;\n  -moz-opacity: 0.35;\n  zoom: 1;\n}\n/* The scroll wrapper is always the same width and height as the containing element (div).\n   Overflow is hidden because you don't want to show all of the scrollable area.\n*/\ndiv.scrollwrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\ndiv.scrollablearea {\n  position: relative;\n  width: auto;\n  height: 100%;\n  display: table;\n}\n//////////////////////////////////////////////////////////////////////////////////\n.jcarousel-item {\n    clear: both;\n    position: relative;\n}\n.blabla .item-wrapper .item-img {\n    display: table;\n    position: relative;\n    overflow: hidden;\n    @media (max-width: 767px)\n    {\n        height: 90px;\n        width: 270px;\n    }\n    @media (min-width: 768px)\n    {\n        height: 125px;\n        width: 375px;\n    }\n}\n.jcarousel .item-wrapper a {\n  display: table;\n  position: relative;\n}\n.jcarousel img {\n  margin: 0;\n  padding: 0;\n}\n.jcarousel-separador {\n    background: none repeat scroll 0 0 #141414;\n    /*border: 1px solid @gray-dark;*/\n    border-top: 0;\n    border-bottom: 0;\n    /*border-left: 1px solid #202020;*/\n    display: table;\n    float: left;\n    height: 90%;\n  margin: 10px 20px 0 0;\n  width: 3px;\n    span{ display: none;}\n}\n.jcarousel-separador{\n    display: table-cell;\n  float: inherit;\n  margin: 0px;\n  background: inherit;\n  width: 15px;\n  padding: 1px;\n  /*border-left: 2px solid #202020;*/\n  border-right: 0px;\n}\n.section-recienvisto .jcarousel-separador{ height: 170px;}\n.jcarousel .fa-chevron-left,\n.jcarousel .fa-chevron-right {\n    left: 8px;\n    margin-top: -5px;\n  position: absolute;\n  top: 50%;\n  color: @white;\n}\n.play {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  background-color: fade(@gray-darker, 50%);\n  .fa-play-circle-o {\n    color: fade(@white, 70%);\n    font-size: 80px;\n    left: 50%;\n    margin-left: -35px;\n    margin-top: -40px;\n    top: 50%;\n    position: absolute;\n  }\n  .grid-channel-icon{\n    display: none;\n  }\n}\n\n.play:hover {\n  opacity:1;\n  .grid-channel-icon{\n    display: block;\n  }\n}\n\n.carousel.slide.destacado .play {\n  .fa-play-circle-o {\n    color: fade(@white, 70%);\n    font-size: 110px;\n    left: 50%;\n    margin-left: -47px;\n    margin-top: -56px;\n    top: 50%;\n    position: absolute;\n  }\n}\n/*/ VARIABLES carousel\nlos container son propios de cada carousel\n  se definen anchos por contenedor para los items, asi se calcula la cinta.\n  el contenedor que pre genera la cinta y las flechas es #ID que llama a la acción\n  .smoothDivScroll\n*/\n//jcarousel-1 vertical\n//llama a .smoothDivScroll\n.jcarousel.jcarousel-1 {\n   width:100%;\n  height: 300px;\n  position: relative;\n  display: block;  \n}\n\n.jcarousel.jcarousel-1.horizontal.carousel-vistime {\n  height: 196px;\n}\n.jcarousel.jcarousel-1.horizontal{ height: 166px;}\n.jcarousel.jcarousel-1.horizontal.mi-lista{ height: 256px;}\n.jcarousel-1 .jcarousel-container {\n    display: table-cell;\n    float: left;\n    width: 540px;\n    display: table;\n    margin: 0 5px;\n}\n.jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n  width: 179px;\n  .image {\n  padding-left: 0;\n padding-right: 0;\n  }\n  .jcarousel-item-1 {\n  margin: 0;\n  }\n}\n// fin jcarousel-1\n//jcarousel-2 vertical\n//llama a .smoothDivScroll\n.jcarousel.jcarousel-2 {\n   width:100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-2.horizontal {\n  width:100%;\n  position: relative;\n  display: block;\n}\n\n/*MEP-449 Ajustes scroll horizontal*/\n:-ms-fullscreen, :root .section-porver .vertical.jcarousel-1.jcarousel .scrollwrapper { min-height:320px; }\n:-ms-fullscreen, :root .section-porver.horizontal .vertical.jcarousel-1.jcarousel .scrollwrapper { min-height:320px; }\n:-ms-fullscreen, :root .jcarousel.jcarousel-1.vertical .scrollwrapper { min-height:275px; }\n.scrollwrapper {\n  scrollbar-3dlight-color:#333333;\n  scrollbar-arrow-color:#333333;\n  scrollbar-base-color:black;\n  scrollbar-darkshadow-color:#333333;\n  scrollbar-face-color:#333333;\n  scrollbar-highlight-color:black;\n  scrollbar-shadow-color:black;\n}\n/*MEP-449*/\n.scrollwrapper{\n-ms-overflow-style: none;\noverflow: -moz-scrollbars-none;\n\n}\n\n.scrollwrapper::-webkit-scrollbar {\n  -webkit-overflow-scrolling: touch;\n  display: none;\n}\n\n.jcarousel.jcarousel-1.vertical {\n  .scrollwrapper {\n    min-height:280px;\n  }\n}\n.jcarousel-2 .jcarousel-container {\n    display: table-cell;\n    float: left;\n    width: 576px;\n    display: table;\n    margin: 0 5px;\n}\n.jcarousel-2 .jcarousel-container.jcarousel-container-1 {\n  width: 459px;\n  .image {\n  padding-left: 0;\n padding-right: 0;\n  }\n  .jcarousel-item-1 {\n  margin: 0;\n  }\n}\n/*FIN jcarousel-2 vertical\n ---------------------------------------------*/\n//jcarousel-3 especial3-\"horizontal\"\n//llama a .smoothDivScroll\n.jcarousel.jcarousel-3 {\n   width:100%;\n  height: 100%;\n  position: relative;\n  display: block;\n  .scrollablearea {\n    margin: 0 auto;\n  }\n}\n.jcarousel-3 .jcarousel-container {\n    display: table-cell;\n    float: left;\n    width: 540px;\n    display: table;\n    margin: 0 10px;\n}\n.jcarousel-3 .jcarousel-container.jcarousel-container-1 {\n    width: 1026px;\n  .data {\n  padding-right: 16px;\n   padding-left: 0px;\n  }\n}\n.jcarousel-3.jcarousel .jcarousel-container-2 {\n  width: 530px;\n  img {\n    height: 145px;\n    width: 346px;\n  }\n  .jcarousel-item-1 {\n      margin: 0 0 10px;\n  }\n  .jcarousel-item-2{\n    margin: 0\n  }\n  .image {\n  padding-left: 0;\n  }\n  .data {\n  padding-left: 16px;\n  padding-right: 20px;\n  }\n}\n/*FIN jcarousel-3 horizontal\n ---------------------------------------------*/\n//jcarousel-4 especial-2\n.jcarousel.jcarousel-4 //llama a .smoothDivScroll\n{\n   width:100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel-4 .jcarousel-container {\n    display: table-cell;\n    float: left;\n    width: 540px;\n    display: table;\n    margin: 0 10px;\n}\n.jcarousel-4 .jcarousel-container.jcarousel-container-1 { width: 420px;}\n\n/*FIN jcarousel-4 vertical\n ---------------------------------------------*/\n//jcarousel-5\n//llama a .smoothDivScroll\n.jcarousel, .jcarousel.jcarousel-5 {\n   width:100%;\n  height: 100%;\n  position: relative;\n  display: block;\n}\n.jcarousel.jcarousel-5 { \n  margin-bottom: 20px;  \n  .scrollablearea {\n    margin: 0 auto;\n  }\n}\n\n.jcarousel-5 .jcarousel-container {\n    display: table-cell;\n    float: left;\n    width: 540px;\n    display: table;\n    margin: 0 10px;\n}\n.jcarousel-5 .jcarousel-container.jcarousel-container-1 { width: 1026px;}\n\n.jcarousel-5.jcarousel .jcarousel-container-2 {\n  width: 254px;\n  img {\n    height: 186px;\n    width: auto !important;\n  }\n  .jcarousel-item-1 {\n      margin: 0 0 10px;\n  }\n  .jcarousel-item-2{\n  margin: 0}\n  .image {\n  padding-left: 0;\n  }\n  .data {\n    padding-left: 0;\n  }\n}\n.jcarousel-6 .jcarousel-container {\n  display: table-cell;\n  float: left;\n  width: 580px;\n  display: table;\n  margin: 0 10px;\n  }\n.jcarousel-6 .item-img {\n  clear: none;\n  float: left;\n}\n.jcarousel-6 .item-img > img {\n  clear: none;\n  float: left;\n  height: 200px;\n}\n.section-0 .carousel-indicators {\n  bottom: 0;\n  li{\n    &.active{background:#EA2F23;}\n  }\n}\n\n//container2 carousel 100% pag\n\n.container2 { margin:10px 1%;}\n\n.jcarousel .lead2 {\n  font-size: 13px;\n  line-height: 13px;\n}\n.jcarousel .item-fanbutton {\n  margin-top: 10px;\n}\n.section-porver .jcarousel.jcarousel-1,\n.section-porver.horizontal .jcarousel.jcarousel-1\n{\n  height: 300px;\n}\n\n@media (max-width: @screen-xs-max) {\n  .section-porver .jcarousel.jcarousel-1,\n  .section-porver.horizontal .jcarousel.jcarousel-1\n  {\n    height: 320px;\n  }\n}\n\n.section-recommended .jcarousel.jcarousel-1,\n.section-recommended.horizontal  .jcarousel.jcarousel-1\n{\n  height: 270px;\n}\n.section-recommended.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.section-recommended.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n    width: 458px;\n}\n.section-porver.horizontal .jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.section-porver.horizontal .jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n    width: 458px;\n}\n.section-porver .item-fanbutton .fa,\n.section-porver.horizontal .item-fanbutton .fa\n{\n  margin-left: 5px;\n}\n//vistime alturas\n.carousel-vistime .item-wrapper{\n  padding-bottom:23px;\n}\n.carousel-vistime .scrollinghotspotleft, \n.carousel-vistime .scrollinghotspotright {\n  height: 251px;\n}\n.carousel-vistime.horizontal .scrollinghotspotleft, \n.carousel-vistime.horizontal .scrollinghotspotright {\n  height: 163px;\n}\n// seccion especiales\n\n.section-especial {\n  padding-bottom: 20px;\n  padding-top: 166px;\n}\n\n.section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 { width: 1026px;}\n\n.section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n  width: 658px;\n  img {\n    height: 186px ;\n    width: auto !important;\n  }\n}\n\n.section-especial .jcarousel-container.jcarousel-container-1, .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n  .data {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n.section-especial.section-especial01 {\n  .jcarousel-3 .jcarousel-container-1 {\n    width: 810px;\n    .jcarousel-item {\n      background-color: @gray-light;\n      margin-bottom: 10px !important;\n    }\n    .jcarousel-item-1 .data {\n    padding-right: 16px;\n    padding-top: 10px;\n    }\n  }\n}\n\n.section-especial03, .section-especial05{\n  .jcarousel-3 .jcarousel-container-1 {\n    width: 1026px;\n    .jcarousel-item { background-color: @gray-light;}\n  }\n\n  .h3-special {\n    font-size: 24px;\n  }\n}\n.section-especial03 .jcarousel-3 .jcarousel-container-2 {\n  width: 658px;\n  .jcarousel-item {\n    background-color: @gray-light;\n    margin: 0 0 10px !important;\n    .data { padding-right: 16px;}\n  }\n}\n\n.section-especial05 .jcarousel-3.jcarousel .jcarousel-container-2 { width: 256px;}\n\n//caret seccion especial\n\n.section-especial {\n  .jcarousel-container-1 {\n    b.fa { right: 287px;}\n  }\n  .jcarousel-container-2 {\n    b.fa { right: 240px;}\n  }\n  b.fa {\n    color: @gray-light;\n    font-size: 35px;\n    position: absolute;\n    top: 20px;\n  }\n  &.section-especial03, &.section-especial05 {\n    .jcarousel-container-1 {\n      b.fa { right: 358px;}\n    }\n    .jcarousel-container-2 {\n      h4 { min-height: 60px;}\n      b.fa{ right: 326px !important;}\n    }\n\n    .scrollinghotspotleft,\n    .scrollinghotspotright {\n      i {\n        pointer-events: none; //don't hijack click\n      }\n    }\n  }\n}\n//fin especiales\n\n/* RESPONSIVE CSS\n---------------------------------------------------------------------------- */\n@media (max-width: 768px) {\n/* Remove the edge padding needed for mobile */\n  body.layout-landing2 {\n    .section-1.text-module h2 { font-size: 20px;}\n    .section-0 h2 { font-size: 20px;}\n    .section-0 .carousel-indicators { display: none;}\n    .section-3 {\n      padding:10px 0;\n      min-height: 340px;\n    }\n    .section-0 .carousel.slide.destacado h2 {\n      margin-bottom: 0;\n      margin-top: 10px;\n    }\n    .precio .monto {font-size: 65px;}\n    .legal { font-size: 11px;}\n    .section-0 .carousel.slide.destacado .btn-block { margin-top: 10px;}\n  }\n  .jcarousel-6 .jcarousel-container { width: 310px;}  \n  //especiales\n  .section-especial .jcarousel-5  .jcarousel-container.jcarousel-container-1 {\n    width: 194px;\n  } \n\n  .section-especial {\n    .jcarousel-3 {\n      .scrollablearea {\n        width: 480px !important;\n      }\n\n      .jcarousel-container-1,\n      .jcarousel-container-2 {\n        display: table-cell;\n        float: none;\n        padding: 0 10px;\n      }\n    }\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n    img {\n      height: 146px;\n      width: auto !important;\n    }\n  } \n}\n\n@media (min-width: 480px) and (max-width: 768px) {\n  .section-especial .section-especial03 {\n    .jcarousel-3 {\n      .scrollinghotspotleft,\n      .scrollinghotspotright {\n        display: none;\n      }\n    }\n  }\n}\n\n@media (width: 768px) {\n  .section-sugest{\n    h4 {text-align: left !important;}\n  .item-2, .item-wrapper {\n    width: auto !important;\n    img { height: 200px !important;}\n  }\n  .item-1 { \n    padding-bottom: 15px !important;\n    width: auto !important;\n    min-height: 70px;\n    img { height: 200px !important;}\n  }\n  .jcarousel-6 .jcarousel-container { width: 580px;}\n  }\n\n  // especiales\n  .section-especial .jcarousel-5  .jcarousel-container.jcarousel-container-1 { width: 194px;} \n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n    img {\n      height: 146px !important;\n      width: auto !important;\n    }\n  } \n}\n\n@media (max-width: 1200px) {\n/* Remove the edge padding needed for mobile */\n  .section-1.text-module .center { padding: 25px;}\n}\n\n@media (max-width: 991px) {\n  .jcarousel-3 .jcarousel-container\n  .jcarousel-4 .jcarousel-container\n  .jcarousel-5 .jcarousel-container\n  .jcarousel-6 .jcarousel-container {\n    margin:0 5px;\n  }\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center { padding: 15px;}\n  /* tamaños para los contenedores del carousel*/\n  .section-5 .jcarousel-item{\n    background:none;\n    border:none;\n  }\n  .section-especial .jcarousel-3 .jcarousel-container.jcarousel-container-1 { width: 194px;}\n  .jcarousel-3 .jcarousel-container.jcarousel-container-2 { width: 258px;}\n  \n  //especiales\n  .section-especial01, .section-especial03 {\n    .jcarousel-3 .jcarousel-container-1 {\n      width: 192px;\n    }\n  }\n  .section-especial03 .jcarousel-3 .jcarousel-container-2 {\n    width: 256px;\n    .jcarousel-item{background: transparent;\n    margin: 0 0 10px !important;}\n  }\n  //fin especiales\n\n  .section-0 {\n    .carousel-caption {\n      position: relative;\n      left: 0;\n      right: 0;\n      min-height: 100px;\n    }\n    .carousel.slide.destacado h2{\n      margin-top: 20px;\n      margin-left: 10px;\n    }\n    .carousel.slide.destacado .btn-block { margin-top: 20px;}\n  }\n  .section-especial .jcarousel-3.jcarousel .jcarousel-container-2 {\n    width: 258px;\n    img {\n      height: 146px;\n      width: auto !important;\n      }\n    }\n}\n\n@media (max-width: 1161px) {\n  .section-0 {\n    .carousel-caption {\n      position: relative;\n      left: 0;\n      right: 0;\n      min-height: 100px;\n    }\n    .carousel.slide.destacado h2{\n      margin-top: 20px;\n      margin-left: 10px;\n    }\n    .carousel.slide.destacado .btn-block { margin-top: 20px;}\n  }\n\n  .jcarousel-3 .scrollwrapper {\n    overflow-x: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout-landing02 {\n    .carousel-caption {\n      position: relative;\n      left: auto;\n      right: auto;\n      bottom: auto;\n      top: auto;\n        /*min-height: 800px;*/\n    }\n    .carousel.slide.destacado h2{\n      margin-top: 20px;\n      margin-left: 10px;\n    }\n    .carousel.slide.destacado .btn-block { margin-top: 20px;}\n  }\n\n  .jcarousel-3 .jcarousel-container {\n    vertical-align: top;\n  }\n}\n\n\n\n/*estilos temporales 2015*/\n\n.section-superdestacado02 .carousel.slide img {\n    height: auto;\n    width: auto;\n}\n\n.jcarousel-wrapper{\n\n  position: relative;\n}\n\n.jcarousel-wrapper2\n{\n  width: 100%;\n}\n\n\n/*libreriacarrusel05*/\n.jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1,\n.jcarousel-1.horizontal .jcarousel-container.jcarousel-container-1 {\n  width: 302px;\n}\n\n\n.jcarousel-destacado-01,\n.jcarousel-destacado-01-xs{\n  overflow: hidden;\n}\n.slideshow, .slideshow-xs {\n overflow: visible !important;\n margin:0px;\n}\n.carousel-destacado .jcarousel-destacado-01 .cycle-slide,\n.carousel-destacado .jcarousel-destacado-01-xs .cycle-slide {\n  margin: 0 8px;\n  margin-right: 8px;\n  margin-left: 8px;\n}\n.carousel-bg-01 .cycle-slide{\n  width: 100%;\n}\n\n/*fin libreriacarrusel05*/\n\n.carousel-fade {\n    .carousel-inner {\n        .item {\n            transition-property: opacity;\n        }\n        \n        .item,\n        .active.left,\n        .active.right {\n            opacity: 0;\n        }\n\n        .active,\n        .next.left,\n        .prev.right {\n            opacity: 1;\n        }\n\n        .next,\n        .prev,\n        .active.left,\n        .active.right {\n            left: 0;\n            transform: translate3d(0, 0, 0);\n        }\n    }\n\n    .carousel-control {\n        z-index: 2;\n    }\n}\n\n\n\n.layout-landing02 .section-destacado {\n  @media (max-width: @screen-xs-max) {\n     margin-top: -660px;\n   }\n}\n\n// hardcore img size carruseles\n @media (min-width: 768px) {\n  .section-recommended.horizontal .item-wrapper img {\n    width: 446px;\n    height: 251px;\n  }\n}\n@media (min-width: 768px) {\n  .section-recommended.horizontal .item-wrapper .posterLabel .posterLabel--image img {\n    width: fit-content;\n    height: unset;\n  }\n}\n @media (max-width: 768px) {\n  .jcarousel.jcarousel-1.vertical img {\n    height: 250px;\n  }\n}\n\n.section-bg-full{\n z-index: -999;\n height: 100%;\n left: 0;\n position: absolute;\n top: 0;\n width: 100%;\n}\n\n.cover2 img {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 100%;\n}\n\n/*.carousel-bg-01:before, .section-bg-full:before*/\n.bg-gradient{\n  content: \"\";\n  display: block;\n  position: absolute;\n  /*background: #232323;*/\n  background-image:  linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, rgba(0,0 , 0, 0.5) 60%, #000000 100%);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100;\n  /*z-index: 999;*/\n  /*height: 1100px;*/\n  min-height: 100%;\n  padding-top: 56.25%;  // es igual a la razon de la img de background 1280x720\n}\n\n\n.dirty .section-highlight03 .slideshow li {\n  position: static;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n   -webkit-transition: width 12s, height 14s; /* Safari */\n    transition: all 0.5s;\n    transition-timing-function: ease;\n\n}\n.dirty ul.slideshow {\n  display: block;\n  overflow: hidden!important;\n  width: 10000px;\n  list-style:none;\n   -webkit-transition: width 12s, height 14s; /* Safari */\n    transition: all 0.5s;\n    transition-timing-function: ease;\n  margin-left: 0!important;\n}\n.dirty .jcarousel {\n  width: 10000000px !important;\n   -webkit-transition: width 12s, height 14s; /* Safari */\n    transition: all 0.5s;\n    transition-timing-function: ease;\n \n}\n.dirty.main-wrapper {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n\nsection.section-recomendador-2.section-recomendado.section-doble img {\n  height: 200px;\n}\nsection.section-recomendador-2.section-recomendado.section-doble\n.jcarousel-2.horizontal .jcarousel-container.jcarousel-container-1\n{\n    width: 362px;\n}\n\n.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1{\n  height: 225px;\n}\n\n/*.section-recomendador-2.section-recomendado.section-doble .jcarousel.jcarousel-1{\n  height: 225px;\n}\n\n.section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1{\n width: 139px;\n}*/\n@media (max-width: @screen-xs-max) {\n  .section-recomendador-2.section-recomendado.section-doble .jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n    width: 139px;\n  }\n}\n\n\n.jcarousel.jcarousel-1.vertical.fox img{\n    width:175px; \n    height: auto;\n}\n\n.jcarousel.jcarousel-2.horizontal.fox img{\n    width:375px; \n    height: 125px;\n}\n\n.jcarousel.jcarousel-1.vertical.fox .scrollwrapper {\n    min-height: 100px;\n}\n\n.jcarousel.fox{\n    padding-top:10px;\n    height: auto;\n}\n\n\n.fox .item-img:hover img.foxnormal{\n    display:none;\n}\n\n.fox .item-img:hover img.foxover{\n    display:inline!important;\n}\n\n\n","@import \"bootstrap.less\";\n\n/* HEADER STYLES*/\n\n//Header 1024\nheader.main-header {\n\tposition: relative;\n\tz-index: 999;\n\theight: 125px;\n\tborder-bottom: 1px solid @gray1;\n\t.main-logo {\n\t\tmargin: 25px 20px;\n\t}\n\t.logo-claro {\n\t\tmargin: 20px 10px;\n\t}\n\t//Fix Chrome\n\t.ingresa {\n\t\tpadding-top: 0px;\n\t}\n\t.navbar-default {\n\t\tbackground: none;\n\t\tborder: none;\n\t}\n\t.navbar-default .navbar-collapse,\n\t.navbar-default .navbar-form {\n\t\tborder: none;\n\t}\n\t.navbar-collapse.in {\n\t\toverflow: visible;\n\t}\n\t.dropdown-menu {\n\t\tborder: none;\n\t\t@media (max-width: @screen-xs-max) {\n\t\t\tfont-size: (@font-size-base * 1.42);\n\t\t\tcolor: @black;\n\t\t\tli a {\n\t\t\t\tcolor: @white;\n\t\t\t}\n\t\t}\n\t}\n\t@media (min-width:1330px) {\n\t\theight: 78px;\n\t}\n\t.main-logo {\n\t\tmargin: 20px 20px 15px 20px;\n\t}\n\n  .search-container {\n    position:  relative;\n    // width: 365px;\n    padding-top: 17px;\n\n    .buscadorForm:only-child {\n      float: right;\n    }\n\n    .buscadorForm, .chat-button {\n      display: inline-block;\n      position: relative;\n      vertical-align: top;\n    }\n\n    .chat-button {\n      top: 8px;\n    }\n\n    @media screen and (max-width: @screen-sm-max) {\n      max-width: 310px;\n      padding-top: 25px;\n\n      .buscadorForm {\n        margin: 0 auto;\n      }\n\n      .buscadorForm, .chat-button {\n        vertical-align: bottom;\n      }\n\n      .chat-button {\n        top: 0;\n      }\n    }\n  }\n\n  .has-user .search-container {\n    @media screen and (max-width: @screen-sm-max) {\n      padding-top: 35px;\n    }\n  }\n}\n\n//Header -XS\n@media (max-width: @screen-xs-max) {\n\theader.main-header {\n\t\tborder: none;\n\t\theight: 55px;\n\t\t.main-logo {\n\t\t\tmargin: 10px;\n\t\t}\n\t\t.logo-claro {\n\t\t\tmargin: 7px 10px;\n\t\t}\n\t}\n}\n\n.header-logueado {\n\t.navbar-main {\n\t\t.solapas {\n\t\t\t.caja_menu a {\n\t\t\t\tfont-size: (@font-size-base * 0.82);\n\t\t\t\tpadding: 5px;\n\t\t\t\tborder-radius: 0;\n\t\t\t\tcolor: @gray-dark;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tline-height: 12px;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&:active {\n\t\t\t\t\tbackground-color: @gray-light;\n\t\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\t}\n\n\t\t\t\tul.menu-principal {\n\t\t\t\t\tleft: 0px !important;\n\t\t\t\t\tli .active {\n\t\t\t\t\t\ta:hover {\n\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.caja_menu li:first-child {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t\t.caja_menu li {\n\t\t\t\tpadding: 2px 0;\n\t\t\t}\n\t\t\t.caja_menu li.active {\n\t\t\t\t\t\t\tborder-bottom: none  !important;\n\t\t\t\t\t\t\tbackground-color: @gray-light;\n\t\t\t\t\t\t\ta {color: @white;\n\t\t\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t.caja_menu li .row .columnas {\n\t\t\t\tborder-right: 1px solid @gray-lighter;\n\t\t\t\tmin-height: 370px;\n\t\t\t\th5 {\n\t\t\t\t\ta {font-size: (@font-size-base * 1.25);}\n\t\t\t\t\ta.active {color: @white;\n\t\t\t\t\t\tbackground-color: @gray-light;\n\t\t\t\t\t\tborder-bottom: none  !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.caja_menu li .row .columnas:last-child {\n\t\t\t\tborder-right: 0\n\t\t\t}\n\t\t\t.caja_menu li.active a {\n\t\t\t\tcolor: @white;\n\t\t\t}\n\t\t\t.columna-destacados {\n\t\t\t\tbackground: @gray-lighter;\n\t\t\t\tmin-height: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: 0;\n\t\t\t\tpadding-top: 36px;\n\t\t\t\th5 {\n\t\t\t\t\tcolor: @gray-darker;\n\t\t\t\t\tfont-size: (@font-size-base * 1.25);\n\t\t\t\t}\n\t\t\t}\n\t\t\t.envivo {\n\t\t\t\tborder: 1px solid @brand-claro;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\theight: 35px;\n\t\t\t\ta {\n\t\t\t\t\tline-height: 17px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t@media (min-width: @screen-sm-min) {\n\t\t\t\tli {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\t\t\t\tli:first-child {\n\t\t\t\t\tmargin-left: 20px\n\t\t\t\t}\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0px;\n\t\t\t\ttop: 82px;\n\t\t\t\t.last {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 30px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.envivo {\n\t\t\t\tborder: 1px solid @brand-claro;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\theight: 35px;\n\t\t\t\ta {\n\t\t\t\t\tline-height: 17px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t@media (min-width: 1330px) {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 250px;\n\t\t\t\ttop: 34px;\n\t\t\t}\n\t\t}\n\t}\n\t.go_back {\n\t\tmargin-top: 27px;\n\t}\n\t.go_back_icon {\n\t\tmargin: 8px 8px 0 5px;\n\t}\n}\n\n.header-nologueado {\n\t.navbar-main {\n\t\t.solapas {\n\t\t\t@media (min-width: @screen-sm-min) {\n\t\t\t\tli {\n\t\t\t\t\tmargin-right: 3px;\n\t\t\t\t}\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 20px;\n\t\t\t\ttop: 82px;\n\t\t\t}\n\t\t\t@media (min-width:1330px) {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 250px;\n\t\t\t\ttop: 34px;\n\t\t\t}\n\t\t\t.dropdown-user {\n\t\t\t\tmargin-top: 28px;\n\t\t\t}\n\t\t}\n\t}\n\t.go_back {\n\t\tmargin-top: 27px;\n\t}\n\t.go_back_icon {\n\t\tmargin: 8px 8px 0 5px;\n\t}\n}\n\nbody.layout-landing2 {\n\t.header-logueado,\n\t.header-nologueado {\n\t\t.navbar-main {\n\t\t\tbackground-color: @black;\n\t\t\tborder: 1px solid #080808;\n\t\t}\n\t}\n}\n\n.header-logueado,\n.header-nologueado {\n\tbackground-color: rgba(0,0,0,0.6);\n\t.navbar-main {\n\t\tborder: none;\n\t\t.navbar-nav {\n\t\t\t@media (max-width: @screen-xs-max) {\n\t\t\t\tmargin-top: 4px;\n\t\t\t\tborder: none;\n\t\t\t\tfont-size: (@font-size-base * 1.42);\n\t\t\t\tmargin-bottom: -4px;\n\t\t\t\t.open {\n\t\t\t\t\ta {\n\t\t\t\t\t\t&,\n\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t&:focus,\n\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\t/*background: @gray-dark;*/\n\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\tpadding-bottom: 15px;\n\t\t\t\t\t\t\tborder-bottom: 1px solid @gray-darker;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.dropdown-menu {\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tborder-bottom: 1px solid @gray-dark;\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t&,\n\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t&:focus,\n\t\t\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\t\t\tfont-size: (@font-size-base * 1.30);\n\t\t\t\t\t\t\t\t\tbackground: @gray-darker;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\th5 {\n\t\t\t\t\t\t\t\tcolor: @white;\n\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\t\t\tpadding-bottom: 15px;\n\t\t\t\t\t\t\t\tpadding-left: 18px;\n\t\t\t\t\t\t\t\tborder-bottom: 1px solid @gray-darker;\n\t\t\t\t\t\t\t\tfont-size: (@font-size-base * 1.42);\n\t\t\t\t\t\t\t\tbackground-color: @gray-dark;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tul.lavel-2 {\n\t\t\t\t\t\t\t\tpadding-left: 5px;\n\t\t\t\t\t\t\t\tbackground: @gray-dark;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tul.lavel-2 a {\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\tcolor: @gray-light;\n\t\t\t\t\t\t\t\tpadding-left: 35px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.navbar-nav.dropdown-user {\n\t\t\t@media (max-width: @screen-xs-max) {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\t\t.solapas {\n\t\t\t@media (min-width: @screen-sm-min) {\n\t\t\t\tli {\n\t\t\t\t\tli .row:nth-child(2) {\n\t\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t@media (min-width: @screen-md-min) {\n\t\t\t\tli.menu-catalogo {\n\t\t\t\t\tul.menu-principal {\n\t\t\t\t\t\tleft: -80px;\n\t\t\t\t\t\tbackground: @white url(../images/bg-nav-dropdown.gif) repeat-y right;\n\t\t\t\t\t}\n\t\t\t\t\ti {\n\t\t\t\t\t\tleft: 125px\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t@media (min-width: @screen-lg-min) {\n\t\t\t\tli.menu-catalogo {\n\t\t\t\t\tul.menu-principal {\n\t\t\t\t\t\tleft: -80px;\n\t\t\t\t\t\tbackground: @white url(../images/bg-nav-dropdown.gif) repeat-y right;\n\t\t\t\t\t\tli.active {\n\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\tbackground-color: @gray-light;\n\t\t\t\t\t\t\ta {color: @white;\n\t\t\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\ti {\n\t\t\t\t\t\tleft: 205px\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tli {\n\t\t\t\t.active {\n\t\t\t\t\t@media (max-width: @screen-xs-max) {\n\t\t\t\t\t\t background-color: @gray-darker;\n\t\t\t\t\t}\n\t\t\t\t\tborder-bottom: 3px solid @gray3;\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tborder-bottom: 3px solid @body-bg;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\ta {\n\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\tcolor: @gray4;\n\t\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t&:hover {color: @white;\n\t\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\t\tborder-bottom: 3px solid @gray4;\n\t\t\t\t\t}\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\tborder-bottom: 3px solid @gray4;\n\t\t\t\t\t\tcolor: @white;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t\ta.active {\n\t\t\t\t\tcolor: @white;\n\t\t\t\t}\n\t\t\t\ta.active .caret {\n\t\t\t\t\tborder-bottom-color: @white;\n\t\t\t\t\tborder-top-color: @white;\n\t\t\t\t}\n\t\t\t}\n\t\t\t//fin sub nodos\n\t\t\t@media (max-width: @screen-xs-max) {\n\t\t\t\tli {\n\t\t\t\t\tbackground-color: @gray-dark;\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tbackground-color: @gray-darker;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\ta {\n\t\t\t\t\t\tpadding-bottom: 15px;\n\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\tborder-bottom: none !important;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.navbar-collapse {\n\t\tbox-shadow: none;\n\t}\n\t@media (max-width: @screen-xs-max) {\n\t\t.navbar-collapse {\n\t\t\tpadding: 0;\n\t\t}\n\t\t.dropdown-user {\n\t\t\tmargin: 0;\n\t\t}\n\t}\n}\n\n\n\n.layout-landing03 .header-nologueado {\n\t background-color: transparent;\n}\n.dropdown-user .dropdown a.dropdown-toggle {\n\tline-height: 21px;\n\tpadding: 16px 30px 16px 10px;\n}\n\n.dropdown-user {\n\t.dropdown > .dropdown-toggle {\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:active {\n\t\t\t\tbackground-color: transparent;\n\t\t\t\t@media (max-width: @screen-xs-max) {\n\t\t\t\t   &:hover { color: @white; background-color: @gray-dark;}\n\t\t\t\t   &:focus, &:active { color: @white; background-color: @gray-darker;}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\tmargin-top: 25px;\n\t.dropdown-menu {\n\t\tli a {\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:active {\n\t\t\t\tcolor: @white;\n\t\t\t\tbackground-color: @gray-light;\n\t\t\t}\n\t\t}\n\t\tli.active a {\n\t\t\tcolor: @white;\n\t\t\tbackground-color: @gray-light;\n\t\t}\n\t}\n\tli a {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t\tmin-width: 160px;\n\t\tword-wrap: break-word;\n\t\t.caret {\n\t\t\tposition: absolute;\n\t\t\tright: 10px;\n\t\t\ttop: 22px;\n\t\t}\n\t\t@media (max-width: @screen-xs-max) {\n\t\t\tbackground-color: @gray-darker;\n\t\t\twidth: 100%;\n\t\t\tpadding-bottom: 15px;\n\t\t\tpadding-top: 15px;\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:active {\n\t\t\t\tbackground-color: @gray-darker;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.header-preferencias {\n\tdisplay: table;\n\tpadding: 40px 40px 0 40px;\n}\n\n@media (max-width: @screen-xs-max) {\n\t.header-preferencias {\n\t\tpadding: (@grid-gutter-width * 2);\n\t}\n}\n\n// Tabs menu\n.nav-pills {\n\tpadding: 5px 10px 0px;\n\tfont-weight: bold;\n\t.dropdown-menu-tabs {\n\t\tfont-weight: bold;\n\t}\n}\n.main-header2 {\n\n\tmargin-top: 2px;\n}\n.main-header2 .nav.navbar-nav {\n\tmargin-top: 13px;\n}\n.main-header2 .navbar-collapse .navbar-nav > li > a {\n\tmargin: 0 5px;\n\tpadding: 7px 8px !important;\n}\n.navbar-nav > li > .dropdown-menu{\n\tborder-top-right-radius: 0;\n\tborder-top-left-radius: 0;\n}\n.main-header2 .navbar-collapse .navbar-nav > li {\n\ta {\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: @gray-dark;\n\t\t\tcolor: @white;\n\t\t}\n\t}\n}\n.main-header2 .navbar-collapse .open > a {\n\t&,\n\t&:hover,\n\t&:focus {\n\t\tbackground: @gray-dark;\n\t\tborder-color: @link-color;\n\t\t.caret {\n\t\t\tborder-top-color: @link-hover-color;\n\t\t\tborder-bottom-color: @link-hover-color;\n\t\t}\n\t}\n}\n.main-header2 .navbar-collapse .navbar-nav > li a:hover{\n\t&:hover,\n\t&:focus,\n\t&:active {\n\t\tbackground: @gray4;\n\t\tcolor: @gray3;\n\t}\n}\n.main-header2 .dropdown-menu > .active > a {\n  &,\n  &:hover,\n  &:focus {\n\tcolor: #666666;\n\ttext-decoration: none;\n\toutline: 0;\n\tbackground-color:#DDDDDD;\n  }\n}\n\n\n\n/*DROPDOWNS customize*/\n.dropdown-menu{\nbackground-color: @white;\n}\n\n//solo para nav\n.dropdown-menu > li > a {\n\tline-height: 40px;\n\twhite-space: nowrap;\n\tcolor: @gray3;\n\tfont-size: @font-size-small;\n}\n\n// Active state en el segundo nivel del nav\n.dropdown-menu > .active > a {\n  &,\n  &:hover,\n  &:focus {\n\tcolor: none;\n  }\n}\n\n// piquito\nul.dropdown-menu:after,\nul.dropdown-menu:before {\n  content:\"\";\n  height:0;\n  width:0;\n  position:absolute;\n  bottom:100%;\n  border:solid transparent;\n}\n\nul.dropdown-menu:after {\n\t@media screen and (min-width: 768px) {\n\t\tborder-bottom-color:#fff;\n\t\tborder-width:6px;\n\t\tleft:33%;\n\t\tmargin-left:-6px;\n\t}\n}\n\nul.dropdown-menu:before {\n\tborder-bottom-color:#ddd;\n\tborder-width:7px;\n\tleft:33%;\n\tmargin-left:-7px;\n}\n\nul.menu-principal:after,\nul.menu-principal:before {\n  display:none;\n}\n\nul.menu-user:after,\nul.menu-user:before {\n  display:none;\n}\n\n.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li{\n  border-bottom: 1px solid @gray4;\n}\n.main-header2 .navbar-collapse .navbar-nav .dropdown-menu > li:last-child {\n  border: none;\n}\n\n/* wplay-765 */\n.dropdown-user {\n\t.open > a {\n\t\t&,\n\t\t&:hover,\n\t\t&:focus {\n\t\t  background-color: transparent;\n\t\t  border-color: @link-color;\n\t\t  @media (max-width: @screen-xs-max) {\n\t\t\tbackground-color: @gray-darker;\n\t\t\t}\n\t\t}\n\t}\n}\n\n//Header ERROR 404\nheader.error {\n\tposition: relative;\n\tz-index: 999;\n\t.main-logo {\n\t\tmargin: 25px 20px;\n\t}\n\t.logo-claro {\n\t\tmargin: 20px 10px;\n\t}\n\n\t@media (min-width: @screen-lg-min) {\n\t\theight: 78px;\n\t}\n\t.main-logo {\n\t\tmargin: 20px 20px 15px 20px;\n\t}\n}\n\n//Header -XS\n@media (max-width: @screen-xs-max) {\n\theader.error {\n\t\tborder: none;\n\t\theight: 55px;\n\t\t.main-logo {\n\t\t\tmargin: 10px;\n\t\t}\n\t\t.logo-claro {\n\t\t\tmargin: 7px 10px;\n\t\t}\n\t}\n\n\t#menuUser .btn-default{\n\t\tborder: none;\n\t\tfont-size: 19px;\n\n\t}\n\n\t#menuUser .btn-default:hover{\n\t\tcolor:gray\n\n\t}\n\t#menuUser{\n\t\tbackground-color:rgb(34,34,34)\n\n\t}\n}\n\n\n//FIX BRASIL nodo America Latina\n\n.region-brasil .columnas.columna-latinoamerica {\n  width: 147px !important;\n}\n\n.region-brasil .columnas.columna-deportes {\n  width: 120px !important;\n}\n\n@media (max-width: 1300px) and (min-width: 1200px) {\n  .search-container {\n    top: 55px;\n\n    .chat-button {\n      top: 6px;\n    }\n  }\n\n\t#menuUser+.buscadorForm{\n\t\tposition:relative;\n\t}\n\n\t#menuUser,#menu+.nav.nav-pills\n\t{\n\t\tposition:relative;\n\t}\n}\n\n.dropdown-toggle.dropdownUser{\n\tbackground-color:transparent!important;\n}\n\n\n\n//\n\n@media (max-width: 768px) {\n\t.btn.btn-default.metricas-event.btn-anonimus.change-class-btn {\n\t\t\tbackground-color: #222222;\n\t}\n}\n\n\t","@import \"bootstrap.less\";\n\n/* FOOTERS */\n// Footer web\n\n.footer-web {\n  ul {margin-bottom: 0px !important;\n    }\n  color: @footer-font-color;\n  .siguenos { padding-right: 10px; }\n  .links-footer {\n  \tli {  \n      font-size: (@font-size-base * 0.80);\n      padding-left: 0;\n      margin-bottom: 0px !important;\n  \t}\n   }\n}\n\n.social-ico {\n  .fa {\n    border-radius: @border-radius-base;\n    color: @footer-font-color;\n    font-size: (@font-size-base * 1.3);\n    padding: (@grid-gutter-width / 2);\n  }\n  //.fa-twitter { background-color: #289CC9; }\n  .fa-facebook {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  //.fa-google-plus { background-color: #CB3825; }\n  .fa-youtube \n  img {\n  \tposition: relative;\n    top: -2px;\n    left: -2px;\n    height: 28px;\n  }\n}\n\n\n// Footer mobile\n\n.footer-mobile {\n  .margin-vertical { margin: (@grid-gutter-width * 2) 0; }\n  .links-footer {\n    li {\n      border-bottom: 1px solid #414141;\n      width: 100%;\n      a {\n        text-decoration: none;\n        padding: 2px 4px;\n        display: block;\n        &:active { \n          background: @gray; \n          text-decoration:none; \n          color:@gray-lighter; \n        }\n        &:hover { text-decoration:none;}\n        &:visited { text-decoration:none;}\n      }\n      span {\n        line-height: 50px;\n        font-size: (@font-size-base * 1.3); \n      }\n      i { \n        margin-top: 4px;\n        font-size: 42px;\n      }\n    }\n  }\n  .links-footer-primero {\n    li {\n      border-bottom: 1px solid #414141;\n      width: 100%;\n      a {\n        text-decoration: none;\n        padding: 2px 4px;\n        display: block;\n        background: #666666; \n        &:active { \n          background: #666666; \n          text-decoration:none; \n          color:@gray-lighter; \n        }\n        &:hover { text-decoration:none;}\n        &:visited { text-decoration:none;}\n      }\n      span {\n        line-height: 50px;\n        font-size: (@font-size-base * 1.3); \n      }\n      i { \n        margin-top: 4px;\n        font-size: 42px;\n      }\n    }\n  }\n  .links-footer-segundo {\n    li {\n      border-bottom: 1px solid #414141;\n      width: 100%;\n      a {\n        text-decoration: none;\n        padding: 2px 4px;\n        display: block;\n        &:active { \n          background: @gray; \n          text-decoration:none; \n          color:@gray-lighter; \n        }\n        &:hover { text-decoration:none;}\n        &:visited { text-decoration:none;}\n      }\n      span {\n        line-height: 50px;\n        font-size: (@font-size-base * 1.3); \n      }\n      i { \n        margin-top: 4px;\n        font-size: 42px;\n      }\n    }\n  }\n  .social-ico {\n    .fa {\n      font-size: 40px;\n    }\n    .fa-facebook {\n      padding-right: 17px;\n      padding-left: 17px;\n    }\n  img {\n  \tposition: relative;\n    top: -8px;\n  \theight: 51px;\n  }\n }\n}","@import \"bootstrap.less\";\n\n/* FORM STYLES*/\n\n//Form\n//<no debe haber ID>\n#formContainer { min-height: 300px;}\n\n.form-container {\n  min-height: 280px;\n  .btn-fb-login h5 { margin-bottom: 0; }\n    padding: (@grid-gutter-width * 4);\n    h3, h5 {\n    \tmargin-top: 0px; \n    \tcolor: @gray-lighter !important; \n    }\n    form {\n      fieldset[disabled] {\n        label, p, select { color:@gray-light;}\n      }\n      label, p { font-weight: normal; }\n    }\n  .form-tarjeta, .login-captcha {\n      h5 {\n        margin-bottom: 25px;\n      }\n      .control-label {\n      padding-top: 0;\n      text-align: left;\n      }\n      img { margin-right: 15px; vertical-align: top; }\n  }\n    // Inicio Excepción para medio de pago Sears-Sanborns\n          .form-sears-sanborns {\n      .radio-inline {\n        padding-top: 0;\n        vertical-align: middle;\n        input[type=\"radio\"] {\n          margin-top: 0;\n        }\n      }\n      .tarjeta-txt {\n        vertical-align: middle;\n      }\n      img {\n        vertical-align: middle;\n      }\n      @media (max-width: @screen-sm-max) {\n        .form-group {\n          margin-left: -10px;\n          margin-right: -10px;\n        }\n        img {\n          margin-right: 1px;\n        }\n        .radio input[type=\"radio\"],\n        .radio-inline input[type=\"radio\"],\n        .checkbox input[type=\"checkbox\"],\n        .checkbox-inline input[type=\"checkbox\"] {\n          margin-left: -13px;\n        }\n      }\n    }\n    // Fin Excepción para medio de pago Sears-Sanborns\n  .odd { background: @gray-darker;}\n  .dispositivos {\n    ul { padding: 0px;}\n    .checkbox {\n      list-style-type: none;\n      display: block;\n      padding:0;\n      height:80px;\n      margin:0;\n      width: 100%;\n      label {\n        display: inline-block;\n        height: 100%;\n        padding: 30px 10px 10px 20px;\n        width: 100%;\n        i {\n          margin: -10px 10px 5px 0;\n        }\n      }\n      input[type=checkbox] {\n        margin: 4px 6px 0 0;\n      }\n    }\n  }\n}\n\n.form-group.has-error {\n  .input-group-addon {\n    display: table;\n    float: right;\n    font-size: 20px;\n    padding: 5px;\n    position: relative;\n    top: -32px;\n    color:@state-danger-icon;\n    background: @input-bg;\n    border-radius: 0 (@border-radius-base) (@border-radius-base) 0;\n    border:none;\n    margin-right: 2px;\n  }\n}\n\n@media (max-width: @screen-xs-max) {\n  .form-container { padding: (@grid-gutter-width * 2);}\n}\n\n.form-paso1 {\n  .date-birth { padding-bottom: (@grid-gutter-width / 2); }\n  .date-dd, .date-mm, .date-yy {\n    padding-left: 0px;\n    select { padding-left: 2px; }\n  }\n}\n\n@media (max-width: @screen-sm-max) {\n  .form-container h5 { text-align: center; margin-top: 10px; }\n}\n\n\n// Alinear favicon dentro de un boton o container\n\n.form-panel {\n  display: table;\n  margin:0 auto;\n  .btn-txt {\n    float: left;\n    height: 26px;\n    line-height: 26px;\n  }\n}\n\n// Fix button Radios Medio de Pago\n.medios-pagos-web .radio-inline {\n  margin-left: 0 !important;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n  \n// Exepciones android\n\n/*****************/\n\n\n\n\n.input-append input,\n.input-prepend input,\n.input-append select,\n.input-prepend select,\n.input-append .uneditable-input,\n.input-prepend .uneditable-input{\n    border-radius:0\n}\n\n.input-mini{\n    width:60px;\n    max-width:100%\n}\n\n.input-small{\n    width:90px;\n    max-width:100%\n}\n\n.input-medium,\n.input-md{\n    width:150px;\n    max-width:100%\n}\n\n.input-large{\n    width:210px;\n    max-width:100%\n}\n\n.input-xlarge{\n    width:270px;\n    max-width:100%\n}\n\n.input-xxlarge{\n    width:530px;\n    max-width:100%\n}\n\ninput.input-lg{\n    font-size:18px\n}\n\ninput[type=checkbox].claro-min,\ninput[type=radio].claro-min{\n    opacity:0;\n    position:absolute;\n    z-index:1;\n    width:18px;\n    height:18px;\n    cursor:pointer\n}\n\nlabel input[type=checkbox].claro-min,\nlabel input[type=radio].claro-min{\n    z-index:-100!important;\n    width:1px!important;\n    height:1px!important;\n    clip:rect(1px,1px,1px,1px);\n    position:absolute\n}\n\ninput[type=checkbox].claro-min:checked,\ninput[type=radio].claro-min:checked,\ninput[type=checkbox].claro-min:focus,\ninput[type=radio].claro-min:focus{\n    outline:0!important\n}\n\ninput[type=checkbox].claro-min+.lbl,\ninput[type=radio].claro-min+.lbl{\n    position:relative;\n    display:inline-block;\n    margin:0;\n    line-height:20px;\n    min-height:18px;\n    min-width:18px;\n    font-weight:400;\n    cursor:pointer\n}\n\ninput[type=checkbox].claro-min+.lbl::before,\ninput[type=radio].claro-min+.lbl::before{\n    cursor:pointer;\n    font-family:Roboto;\n    font-weight:400;\n    font-size:12px;\n   /* color:#32a3ce;*/\n    content:\"\\a0\";\n    background-color:#FAFAFA;\n    border:1px solid #c8c8c8;\n    box-shadow:0 1px 2px rgba(0,0,0,0.05);\n    border-radius:0;\n    display:inline-block;\n    text-align:center;\n    height:16px;\n    line-height:14px;\n    min-width:16px;\n    margin-right:1px;\n    position:relative;\n    margin-right: 5px;\n    top:-1px\n}\n\ninput[type=checkbox].claro-min:checked+.lbl::before,\ninput[type=radio].claro-min:checked+.lbl::before{\n    display:inline-block;\n    content:'\\f00c';\n    background-color:#F5F8FC;\n    border-color:#adb8c0;\n    box-shadow:0 1px 2px rgba(0,0,0,0.05),\n    inset 0 -15px 10px -12px rgba(0,0,0,0.05),\n    inset 15px 10px -12px rgba(255,255,255,0.1)\n}\n\ninput[type=checkbox].claro-min:hover+.lbl::before,\ninput[type=radio].claro-min:hover+.lbl::before,\ninput[type=checkbox].claro-min+.lbl:hover::before,\ninput[type=radio].claro-min+.lbl:hover::before{\n   /* border-color:#ff893c;*/\n     border-color:#66afe9;\n}\n\ninput[type=checkbox].claro-min:active+.lbl::before,\ninput[type=radio].claro-min:active+.lbl::before,\ninput[type=checkbox].claro-min:checked:active+.lbl::before,\ninput[type=radio].claro-min:checked:active+.lbl::before{\n    box-shadow:0 1px 2px rgba(0,0,0,0.05),\n    inset 0 1px 3px rgba(0,0,0,0.1)\n}\n\ninput[type=checkbox].claro-min.claro-min-checkbox-2+.lbl::before,\ninput[type=radio].claro-min.claro-min-checkbox-2+.lbl::before{\n    box-shadow:none\n}\n\ninput[type=checkbox].claro-min.claro-min-checkbox-2:checked+.lbl::before,\ninput[type=radio].claro-min.claro-min-checkbox-2:checked+.lbl::before{\n    background-color:#f9a021;\n    border-color:#f9a021;\n    color:#FFF\n}\n\ninput[type=checkbox].claro-min:disabled+.lbl::before,\ninput[type=radio].claro-min:disabled+.lbl::before,\ninput[type=checkbox].claro-min[disabled]+.lbl::before,\ninput[type=radio].claro-min[disabled]+.lbl::before,\ninput[type=checkbox].claro-min.disabled+.lbl::before,\ninput[type=radio].claro-min.disabled+.lbl::before{\n    background-color:#DDD!important;\n    border-color:#CCC!important;\n    box-shadow:none!important;\n    color:#BBB\n}\n\n.checkbox label input[type=checkbox].claro-min+.lbl,\n.radio label input[type=radio].claro-min+.lbl{\n    margin-left:-10px\n}\n\ninput[type=radio].claro-min+.lbl::before{\n    border-radius:100%;\n    font-size:10px;\n    font-family:Roboto;\n    /*text-shadow:0 0 1px #32a3ce;*/\n    padding-left: 1px;\n    line-height:15px;\n    height:17px;\n    min-width:17px\n}\n\ninput[type=radio].claro-min:checked+.lbl::before{\n    content:\"\\f111\"\n}\n\ninput[type=checkbox].claro-min.claro-min-switch{\n    width:55px;\n    height:25px\n}\n\ninput[type=checkbox].claro-min.claro-min-switch+.lbl{\n    margin:0 4px;\n    min-height:24px\n}\n\ninput[type=checkbox].claro-min.claro-min-switch+.lbl::before{\n    font-family:Roboto;\n    content:\"ON\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0\\a0OFF\";\n    color:#999;\n    text-shadow:0 0 0 #999;\n    font-weight:400;\n    font-size:11px;\n    line-height:17px;\n    height:20px;\n    overflow:hidden;\n    border-radius:12px;\n    background-color:#F5F5F5;\n    -webkit-box-shadow:inset 0 1px 1px 0 rgba(0,0,0,.15);\n    box-shadow:inset 0 1px 1px 0 rgba(0,0,0,.15);\n    border:1px solid #CCC;\n    text-align:left;\n    float:left;\n    padding:0;\n    width:52px;\n    text-indent:-21px;\n    margin-right:0;\n    -webkit-transition:text-indent .3s ease;\n    -o-transition:text-indent .3s ease;\n    transition:text-indent .3s ease;\n    top:auto\n}\n\ninput[type=checkbox].claro-min.claro-min-switch+.lbl::after{\n    font-family:Roboto;\n    content:'III';\n    font-size:12px;\n    font-weight:400;\n    letter-spacing:0;\n    color:#AAA;\n    text-shadow:none;\n    background-color:#FFF;\n    border-radius:100%;\n    width:22px;\n    height:22px;\n    line-height:22px;\n    text-align:center;\n    position:absolute;\n    top:-2px;\n    left:-3px;\n    -webkit-box-shadow:0 1px 1px 1px rgba(0,0,0,0.3);\n    box-shadow:0 1px 1px 1px rgba(0,0,0,0.3);\n    -webkit-transition:left .3s ease;\n    -o-transition:left .3s ease;\n    transition:left .3s ease\n}\n\ninput[type=checkbox].claro-min.claro-min-switch:checked+.lbl::before{\n    text-indent:8px;\n    color:#FFF;\n    text-shadow:0 0 0 #FFF;\n    background-color:#8ab2c9;\n    border-color:#6a8ca8\n}\n\ninput[type=checkbox].claro-min.claro-min-switch:checked+.lbl::after{\n    left:34px;\n    background-color:#FFF;\n    color:#98A0A5\n}\n\n// Estilo de Inputs en rediseño 2015\n.form-control {\n  color: @gray-lighter;\n  font-style: normal;\n    // .box-shadow(inset 0 1px 1px rgba(0,0,0,.075)); Redeclare so transitions work\n    &:focus {\n      border-color: darken(@gray-lighter, 10%);\n      @shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 6px lighten(@gray-lighter, 20%);\n      .box-shadow(@shadow);\n    }\n}\n\n.buscar {\n  .form-control {\n  color: @gray-lighter;\n  font-style: normal;\n    // .box-shadow(inset 0 1px 1px rgba(0,0,0,.075)); Redeclare so transitions work\n    &:focus {\n      border: 1px solid @gray;\n      box-shadow:none;\n    }\n  }\n}\n\n.help-block {\n  color: @gray6d;\n}\n// estilos select-dropdown\n\n.select-dropdown\n{\n   @media (max-width: @screen-sm-max) \n   {width: 100%;}\n  \n  margin-bottom: 20px;\n  .caret {\n  float: right;\n  margin-top: 9px;\n  color: red;\n  border-top: 4px solid #eeeeee;\n  }\n\n  .dropdown-menu {\n  margin:0;\n  width: 100%;\n  background-color: rgba(35, 35, 35, 1);\n  border:1px solid #666666;\n  border-top: none;\n  > li:last-child > a {\n  border-bottom: none;\n  }\n    > li > a\n   {\n    cursor: pointer;\n    border-bottom: 1px solid #373737;\n    line-height: 50px;\n    white-space: nowrap;\n    color: #eeeeee;\n    \n    &:hover, &:focus\n    {\n    background-color: rgba(0, 0, 0, 0.3);\n    }\n  }\n  &:before, &:after{\n    display: none;}\n  }\n\n}\n\n\n.form-tarjeta {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    #cboBirthDateMonth, #cboBirthDateDay, #cboBirthDateYear {\n      padding: 6px 4px;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    #cboBirthDateMonth, #cboBirthDateDay, #cboBirthDateYear {\n      padding: 6px 6px;\n    }\n  }  \n}","@import \"bootstrap.less\";\n\n/* TOOLTIP */\n\n.dynover-frame.posU {\n    .fa-caret-left {\n        position: absolute;\n        top: 100px;\n        left: -13px;\n    }\n}\n\n.dynover-frame.posD {\n    .fa-caret-left {\n        position: absolute;\n        bottom: 10px;\n        left: -13px;\n    }\n}\n\n.dynover-frame.posU {\n    .fa-caret-right {\n        position: absolute;\n        left: 327px;\n        top: 100px;\n    }\n}\n\n.dynover-frame.posD {\n    .fa-caret-right {\n        position: absolute;\n        left: 327px;\n        bottom: 10px;\n    }\n}\n\n.popover {\n    max-width: none;\n    padding: 0;\n}\n\n.popover-content {\n    padding: 0;\n}\n\n.tooltip-metadata {\n    background: @white;\n    width: 330px;\n    h4 {\n        margin-top: 3px;\n        text-decoration: none;\n    }\n    .item-serie-titulo-episodio {\n        float: left;\n        width: 100%;\n    }\n    .label-default {\n        /*border-radius: 0;\n        background: @gray-darker;\n        text-transform: uppercase;*/\n    }\n    .item-rating {\n       /* background: @white;\n        color: @gray-darker;\n        border: 1px solid @gray;*/\n    }\n    .tooltip-score {\n        cursor: default;\n        i {\n            cursor: pointer;\n        }\n    }\n    .tooltip-footer {\n        //a { color: @gray; }\n        h6 {\n            float: left;\n        }\n        i {\n            color: @white;\n        }\n    }\n    .precio-renta {\n        h2 {\n            color: @brand-claro;\n            margin: 0;\n        }\n        h5 {\n            margin: 0;\n        }\n    }\n}\n\n// Tooltip-score - Estrellitas\n.tooltip-score {\n    cursor: default;\n    display: inline-block;\n    & i {\n        cursor: pointer;\n    }\n\n    .fa-star-o, \n    .fa-star,\n    .fa-star-half-o\n    {\n        color: #EBAE3B;\n        \n    }\n}\n\n\n.panel-gray1{\n    background-color: @gray1;\n}\n\n.tooltip-footer{\n    display:table;\n}\n.dynover-frame > .fa {\n  color: #222222;\n}","@import \"bootstrap.less\";\n\n/* Estilos  VisTIME */\n\n\n.vistime-progress-bar-wrapper {\n  padding-top:5px;\n  line-height:0;\n  text-align: left;\n  margin:0;\n  padding:0;\n}\n.vistime-data-info{\n  display: inline-block;\n  float: left;\n  label {\n    display: inline-block;\n    color: @brand-claro;\n    font-size: 10px;\n    position: absolute;\n    text-align: center;\n    top: 9px;\n  }\n  .vistime-data-time { display: none;}\n  .vistime-data-seconds { display: none;}\n  .vistime-data-minutes { display: block;}\n  display: none;/*se apaga*/\n}\n\n.vistime-data-date {\n  display: block;\n  float: left;\n  font-size: 10px;\n  margin-left: 6px;\n  width:137px;\n  display: none;\n}\n\n.jcarousel-skin-recentlywatched .vistime-data-date { display:none;}\n\n\n.vistime-bar {\n  background-color: @brand-primary;\n  height: 10px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  \n}\n.vistime-data-duration .vistime-data-time { display: none;}\n.vistime-data-duration .vistime-data-seconds { display: none;}\n.vistime-data-duration .vistime-data-minutes { display: block;}\n.vistime-data-duration{\n  display: inline-block;\n  color: @black;\n  float: right;\n  label {\n    display: inline-block;\n    color: @gray-light;\n    font-size: 0.8125em;\n    font-size:10px;\n    position: absolute;\n    right: 0;\n    text-align: center;\n    top: 9px;\n  }\n  display: none;/*se apaga*/\n}\n\n\n.vistime-progress-bar {\n\n}\n.vistime-progress-last {\nbackground: none repeat scroll 0 0 none;\ndisplay: inline-block;\nposition: absolute;\nheight: 10px;\nwidth: 90%;\nleft:5%;  \nbottom: 0;\npadding: 1px;\nmargin-top: 3px;\nborder-radius: 6px;\noverflow: hidden;\nz-index: 99; /*revisar esto*/\nborder:1px solid @white;\n\n  .vistime-data-info label { top: 13px;}\n  .vistime-data-duration label {\n    right: 3px;\n    top: 13px;\n  }\n}\n\n.jcarousel-container .vistime-progress-last {\n  .vistime-data-info label, .vistime-data-duration label { top: 15px;}\n}\n","@import \"bootstrap.less\";\n\n//Landing 1\n//Header responsive\n\n\n@media (max-width: @screen-xs-max) {\n  \n  .layout-landing1 .navbar-wrapper-sm {\n  top: 0;\n  position: fixed;\n  width:100%;\n  z-index:10;\n  }\n\n}\n\n@media (min-width: @screen-sm-min) {\n  \n  .layout-landing1 .navbar-wrapper-lg {\n  margin-top: 20px;\n  }\n\n}\n\n\n\n//Panel\n\n.panel-transp-70 {\n  background: fade(@panel-bg, 70%);\n}\n\n.que-es {\n  .panel-lg {\n    h2 {\n      color: @brand-primary;\n      font-weight: bold;    \n      }\n    p {\n      font-size: (@font-size-base * 1.28)\n    }\n  }\n}\n@media (min-width: @screen-md-min) {\n\n.que-es .panel-lg {\n  background: fade(@panel-bg, 0%);\n  box-shadow: none;\n  }\n}\n\n\n//Seccion principal\n\n@media (max-width: @screen-sm-max) {\n\n.pull-down {\n  margin-top: 40%;\n  }\n}\n@media (max-width: 360px) {\n\n.pull-down {\n  margin-top: 65%;\n  }\n}\n\n//Mobile color\n\n@media (max-width: @screen-md-max) {\n  .text-md-dark {\n  color: @gray-dark;\n  }\n.text-md-light {\n  color: @gray-lighter;\n  }\n}\n\n// Precio\n\n\n.precio {\n    .moneda {\n      font-family: Roboto;\n      font-size: (@font-size-base * 2.3);\n      display:block;\n      line-height: (@line-height-base *1.5);\n      }\n    .monto {\n      font-family: Roboto;\n      font-weight: bold;\n      font-size: (@font-size-base * 5.7);\n      line-height: (@line-height-base * 0.7);\n      letter-spacing:0px;\n    }\n    .asterisco {\n      font-family: Roboto;\n      font-weight: bold;\n      font-size: (@font-size-base * 1.4);\n      display:block;\n      line-height: @line-height-base;\n    }\n    .periodo {\n      font-family: Roboto;\n      font-size: (@font-size-base * 2);\n      display:block;\n      line-height: (@line-height-base *0.35);\n      margin: 0px 0 0 14px;\n    }\n}\n\n// Pasos\n.layout-landing1 { //abre padre layout-landing1\n  //Precios por cifra\n@media (max-width: 360px) {\n  .col-xxs-12 {\n    width:100%;\n  }\n}\n.precio-container {\n    display: table;\n    margin: 0 auto;\n    float: none;\n  }\n//2 y 3 cifras\n.precio {\n    @media (max-width: 360px) {\n        margin-bottom: (@grid-gutter-width * 2);\n      }\n    .moneda {\n      font-family: Roboto;\n      font-size: (@font-size-base * 2.3);\n      display:block;\n      line-height: (@line-height-base *1.5);\n      }\n    .monto {\n      font-family: Roboto;\n      font-weight: bold;\n      font-size: (@font-size-base * 5);\n      line-height: (@line-height-base * 0.7);\n      letter-spacing:0px;\n    }\n    .asterisco {\n      font-family: Roboto;\n      font-weight: bold;\n      font-size: (@font-size-base * 1.4);\n      display:block;\n      line-height: @line-height-base;\n    }\n    .periodo {\n      font-family: Roboto;\n      font-size: (@font-size-base * 1.28);\n      display:block;\n      line-height: (@line-height-base * 0.7);\n      float:none;\n      clear:both;\n      margin:0px;\n    }\n}\n// 4 y 5 cifras\n.precio-4-5-cifras {\n  .moneda {\n      font-size: (@font-size-base * 1.7);\n      @media (min-width:361px) and (max-width: @screen-sm-max) {\n        font-size: (@font-size-base * 1.2);\n        }\n      }\n    .monto {\n      font-size: (@font-size-base * 3.85);\n      @media (min-width:361px) and (max-width: @screen-sm-max) {\n        font-size: (@font-size-base * 2.9);\n        }\n    }\n    .asterisco {\n      font-size: @font-size-base;\n    }\n    .periodo {\n      font-size: (@font-size-base * 1.28);\n      @media (min-width:361px) and (max-width: @screen-sm-max) {\n        font-size: (@font-size-base * 1.14);\n        }\n    }\n}\n.pasos {\n    height: 258px;\n    padding-left: 30px;\n    li {\n      width: 28%;\n      margin: 15px 18px 0 0;\n    }\n    p {\n        line-height: (@line-height-base * 0.75);\n        margin: 0px;\n    }\n    .thumb {\n    margin-bottom: 10px;\n      }  \n    h3 {\n    font-family: Roboto;\n    font-size: (@font-size-base * 1.85);\n    }    \n    h4 {\n    font-family: Roboto;\n    font-size: (@font-size-base * 1.85);\n    margin: 15px 10px 0 10px;\n  }\n}\n\n// Donde\n\n.donde {\n  height: 258px;\n  @media (min-width:@screen-xxs-min) and (max-width:@screen-sm-max){\n          height: 200px;\n            }\n    .dispositivos {\n      margin-top: 20px;\n      @media (min-width:@screen-md-min) and (max-width:@screen-md-max) {\n        margin-top:0px;\n      }\n      ul {\n        display: inline-block;\n        list-style: none outside none;\n        margin: 0;\n        padding: 0;\n          @media (min-width:@screen-sm-min) and (max-width:@screen-md-max){\n          width: 266px;\n          }\n          @media (min-width:@screen-xxs-min) and (max-width:@screen-xxs-max){\n          width: 266px;\n          }\n        li {\n          display: inline-block;\n          margin:5px 0;\n          img {width:55px;}\n          span {\n            display: block;\n            @media (min-width:@screen-xxs-min) and (max-width:@screen-sm-max){\n              display: none;\n            }\n          }\n        }\n      }\n    }\n    .descargas {\n      li {\n          display: inline-block;\n          margin:5px 0;}\n      @media (min-width:@screen-xxs-min) and (max-width:@screen-sm-max){\n          height: 270px;\n      }\n    }\n\n  h3 {\n    font-family: Roboto;\n    font-size: (@font-size-base * 1.85);\n    }\n  @media (min-width:@screen-md-min) and (max-width:@screen-md-max) {\n    h3 {\n        font-size: (@font-size-base * 1.7); \n        }\n    }\n  strong { \n        font-family: Roboto;\n        font-weight: bold;\n  }  \n}\n\n.registrate {\n  p {\n    margin-top: 5px;\n  }\n}\n\n//banners WEB-4451\n\n.content-banner{\n  margin-bottom: 10px;\n  ul li img{\n    max-width: 574px; \n    width:100%;\n    margin-bottom: 10px\n  }\n  @media (max-width: @screen-sm-max) {\n    li.col-xs-12, li.col-sm-12{\n      padding-left: 0px;\n    }\n  }\n}\n\n// End WEB-4451\n\n\n// Header\n\nheader {\n  .btn {\n    margin:0px 10px;\n    @media (max-width: @screen-xs-max) {\n      margin-left:0px;\n      padding: 10px;\n    }\n  }\n  .main-logo {\n    //margin-top: 3px;\n    margin-bottom: 0;\n    margin-top: -8px;\n    }\n  .ingresa {\n    padding-top: 3px;\n  }\n  .brand-right {\n    padding: 7px;\n  }\n  .navbar-text {\n    margin-bottom: 8px;\n    margin-top: 8px;\n  }\n  /* Chat Button */\n  .chat-button {\n      float: right;\n      margin-left: 11px;\n      position: relative;\n  } \n}\n\n.publicidad-300 {\n  border:none;\n  box-shadow: none;\n  padding: 4px;\n  @media (max-width: @screen-xs-max) {\n    background: none;\n  }\n  h3 {\n    margin: 0px;\n  }\n}\n@media (max-width: @screen-xs-max) {\n  .que-es {\n    p {\n      margin-bottom: 0;\n    }\n  }\n  .panel.padding-2 {\n    padding: 10px;\n  }\n  .panel {\n    margin-bottom: 10px;\n  }\n  .precio {\n    margin-bottom: 10px;\n  }\n}\n@media (min-width: @screen-lg-min) {\n  .pasos {\n    width: 525px;\n  }\n  .publicidad-300 {\n    border: 4px solid @white;\n    border-radius: 2px;\n    margin-left: 56px;\n    padding: 0;\n    width: 308px;\n  }\n}\n}//cierra padre .layout-landing1\n\n@media (max-width: @screen-sm-max) {\n  .centro-descarga {\n    padding-bottom: 10px;\n  }\n}\n  @media (max-width: @screen-md-max) {\n  .icono-descarga {\n    padding-bottom: 10px;\n  }\n}\n  @media (min-width: @screen-lg-min) {\n  .icono-padding {\n    padding-left: 20px;\n  }\n}\n @media (min-width: @screen-lg-min) {\n  .padd-icono {\n    text-align:right;\n  }\n}\n @media (min-width: @screen-lg-min) {\n  .padd-icono-l {\n    text-align:left;\n  }\n}","// Core variables and mixins\n@import \"bootstrap.less\";\n\n/////////////////////////////////\nbody.layout-landing2 {\n padding-bottom: 25px;\n padding-top: 98px;\n color: #5a5a5a;\n .precio {\n  .monto {\n    letter-spacing:-5px;}\n  }\n\n //header mobile\n     @media (max-width: 768px) {\n      padding-top: 52px;\n    }\n    /* CUSTOMIZE THE NAVBAR\n    -------------------------------------------------- */\n    /* Special class on .container surrounding .navbar, used for positioning it into place. */\n    .navbar-wrapper {\n     position: absolute;\n     top: 0;\n     left: 0;\n     right: 0;\n     z-index: 20;\n     .navbar{\n      height:75px;\n      min-width: 480px;\n      padding: 15px;\n     }\n     .container {\n      padding-left: 0;\n      padding-right: 0;\n     }\n    }\n    /* Flip around the padding for proper display in narrow viewports */\n    /* Logo at NAVBAR */\n    .navbar-brand {\n     background: url(\"../images/clarovideo-logo.png\") no-repeat scroll left top transparent;\n     height: 30px;\n     width: 190px;\n     span{\n      display: none;}\n     }\n     .navbar .brand-2\n     {\n      margin-left: 10px;\n      span{\n       display: none;\n      }\n     }\n     // CHAT BUTTON\n     .chat-button {\n          position: relative;\n          margin-right: 4px;\n          top: -2px;\n     }\n     /* Images */\n     .img-circle,\n     .img-rounded,\n     .img-thumbnail {\n      margin: 5px;\n     }\n\n     .legal{\n      margin: 10px auto 0;\n      display: table;\n      font-size: 20px;\n      span{ font-weight: bold;\n       color:#8f8f8f;}\n     } \n\n     header.main-header {\n      height:auto;\n      border-bottom: none;\n    }\n\n    ///////////////////////////\n    ///\n    /*secciones*/\n    .section-1\n    {\n     background: @gray-lighter;\n     &.text-module{\n     h2{\n       margin: 0;\n     }\n    }\n    }\n    .section-2\n    {\n     background: @gray6;\n     min-height: 152px;\n     color: @grayc;\n    }\n    .section-3{\n     height: auto;\n     margin: 0 auto;\n     width: 100%;\n     position: relative;\n     box-shadow: 0 0 50px rgba(0,0,0,0.8);\n     padding: 20px 0 30px;\n     //min-height: 450px;\n     color: @white;\n     .img-rounded.img-responsivel{\n      height: 324px;\n      width: 576px;\n     }\n     .img-rounded.img-responsive2 {\n      height: 324px;\n      width: 576px;\n     }\n    }\n\n    .section-4\n    {\n     background: @gray-lighter;\n    }\n    .section-5\n    {\n     height: auto;\n     margin: 0 auto;\n     width: 100%;\n     position: relative;\n     box-shadow: 0 0 50px rgba(0,0,0,0.8);\n     color: @white;\n     padding-top: 20px;\n     .jcarousel-3 .lead {\n      font-size: 14px; }\n     &.especial {\n      padding: 30px 0;\n     }\n     .principal,\n     .secundario,\n     .jcarousel-item\n     {\n      background-image:-moz-linear-gradient(rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 99%);\n      background-image:-webkit-gradient(linear,color-stop(0, rgba(0,0,0,0)),color-stop(0.99, rgba(0,0,0,0.8)));\n      background-image:-webkit-linear-gradient(rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 99%);\n      background-image:linear-gradient(rgba(0,0,0,0) 0%,rgba(0,0,0,0.8) 99%);\n\n     }\n\n     .brand-especial {\n      margin: 10px;\n     }\n     .secundario.item2 {\n     }\n    }\n    .section-6\n    {\n     background: @black;\n     color: @white;\n    }\n    .section-7\n    {\n     height: auto;\n     margin: 0 auto;\n     width: 100%;\n     position: relative;\n     box-shadow: 0 0 50px rgba(0,0,0,0.8);\n     padding: 30px 0;\n     color: @white;\n    }\n    .section-8\n    {\n     background: @gray-lighter;\n     padding-bottom: 20px\n    }\n    .section-9{\n     background: #232323;\n     p {\n      color: @white;\n      font-size: 20px;\n     }\n    }\n\n    .btn-block\n    { margin-top: 15px;}\n    .precio {\n     padding: 0 6px;\n    }\n    /*PRECIO*/\n    .precio-left, .precio-right {\n     display: block;\n     height: 130px;\n     width: 30px;\n    }\n    .precio > div {\n     float: left;\n    }\n    .precio-center {\n     background: none repeat scroll 0 0 #EA2F23;\n     color: @white;\n     height: 130px;\n     padding: 10px;\n    }\n    .precio .periodo\n    {\n     clear:both;\n     div &{\n      float: left;\n      clear: both;\n     }\n    }\n    .section-5\n    {\n     .h4-especial {\n      max-height: 40px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n     }\n    }\n   }\n //Carousel Size (temporal) -- PHP crop\n\n  // img size carousel son de prueba para los componentes, el del j-container2 funciona para IE\n\n  .disable .jcarousel-1.vertical .jcarousel-container-1 img{\n   height: 220px;\n   width: 147px;\n  }\n  .jcarousel-3.horizontal{\n   .disable .jcarousel-container-1 img\n   {\n    height: 300px;\n    width: 200px;\n   }\n   .jcarousel-container-2 img\n   {\n    height: 145px;\n    width: 256px;\n   }\n  }\n  body.layout-landing2 .carousel.slide .cliente img\n  {\n   width: auto;\n  }\n\n  body{\n   &.navigator-platform-android,\n   &.navigator-platform-iphone,\n   &.navigator-platform-ipad\n   {\n    section{\n    /* background-attachment: scroll !important;\n     background-position: center !important;*/}\n    }\n   }\n\n.nav-pills {\n  > li {\n    + li {\n      margin-left: 5px;\n    }\n  }\n}\n //FIN (temporal) -- PHP crop\n/* RESPONSIVE CSS\n-------------------------------------------------- */\n@media (max-width: 768px) {\n /* Remove the edge padding needed for mobile */\n  body.layout-landing2 .precio .periodo\n {font-size:23px;}\n .text-module{\n\n     h2{\n       margin: 0;\n     }\n    }\n .section-1.text-module h2{ font-size: 20px;}\n .section-0 .carousel-caption\n {position: relative;\n  left:0%;}\n }\n @media (max-width: 1200px) {\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center{ padding: 25px;}\n }\n @media (max-width: 990px) {\n  /* Remove the edge padding needed for mobile */\n  .section-1.text-module .center{ padding: 15px;\n  }\n }\n\n\n body.layout-landing2 .nav.nav-pills.navbar-right {\n    padding: 30px 10px;\n}\n\n//Logo de especiales (para cualquier sección)\n.logo-especial {\n    padding: 0 20px 20px 0;\n}","@import \"bootstrap.less\";\n//Landing 03\n//Header responsive\n@media (max-width: @screen-xs-max) {\n    .layout-landing03 .navbar-wrapper-sm {\n        top: 0;\n        position: fixed;\n        width: 100%;\n        z-index: 10;\n    }\n}\n\n@media (min-width: @screen-sm-min) {\n    .layout-landing03 .navbar-wrapper-lg {\n        margin-top: 20px;\n    }\n}\n\n//Panel\n.panel-transp-70 {\n    background: fade(@panel-bg, 70%);\n}\n\n.que-es {\n    .panel-lg {\n        h2 {\n            color: @brand-primary;\n            font-weight: bold;\n        }\n        p {\n            font-size: (@font-size-base * 1.28)\n        }\n    }\n}\n\n@media (min-width: @screen-md-min) {\n    .que-es .panel-lg {\n        background: fade(@panel-bg, 0%);\n        box-shadow: none;\n    }\n}\n\n//Seccion principal\n@media (max-width: @screen-sm-max) {\n    .pull-down {\n        margin-top: 40%;\n    }\n}\n\n@media (max-width: 360px) {\n    .pull-down {\n        margin-top: 65%;\n    }\n}\n\n//Mobile color\n@media (max-width: @screen-md-max) {\n    .text-md-dark {\n        color: @gray-dark;\n    }\n    .text-md-light {\n        color: @gray-lighter;\n    }\n}\n\n// Precio\n.precio {\n    .moneda {\n        font-family: Roboto;\n        font-size: (@font-size-base * 2.3);\n        display: block;\n        line-height: (@line-height-base *1.5);\n    }\n    .monto {\n        font-family: Roboto;\n        font-weight: bold;\n        font-size: (@font-size-base * 5.7);\n        line-height: (@line-height-base * 0.7);\n        letter-spacing: 0px;\n    }\n    .asterisco {\n        font-family: Roboto;\n        font-weight: bold;\n        font-size: (@font-size-base * 1.4);\n        display: block;\n        line-height: @line-height-base;\n    }\n    .periodo {\n        font-family: Roboto;\n        font-size: (@font-size-base * 2);\n        display: block;\n        line-height: (@line-height-base *0.35);\n        margin: 0px 0 0 14px;\n    }\n}\n\n// Pasos\n.layout-landing03 {\n    //abre padre layout-landing03\n    //Precios por cifra\n    @media (max-width: 360px) {\n        .col-xxs-12 {\n            width: 100%;\n        }\n    } // ???\n    .precio-container {\n        display: table;\n        margin: 0 auto;\n        float: none;\n    }\n    //2 y 3 cifras\n    .precio {\n        @media (max-width: 360px) {\n            margin-bottom: (@grid-gutter-width * 2);\n        }\n        .moneda {\n            font-family:Roboto;\n            font-size: (@font-size-base * 2.3);\n            display: block;\n            line-height: (@line-height-base *1.5);\n        }\n        .monto {\n            font-family: Roboto;\n            font-weight: bold;\n            font-size: (@font-size-base * 5);\n            line-height: (@line-height-base * 0.7);\n            letter-spacing: 0px;\n        }\n        .asterisco {\n            font-family: Roboto;\n            font-weight: bold;\n            font-size: (@font-size-base * 1.4);\n            display: block;\n            line-height: @line-height-base;\n        }\n        .periodo {\n            font-family: Roboto;\n            font-size: (@font-size-base * 1.28);\n            display: block;\n            line-height: (@line-height-base * 0.7);\n            float: none;\n            clear: both;\n            margin: 0px;\n        }\n    }\n    // 4 y 5 cifras\n    .precio-4-5-cifras {\n        .moneda {\n            font-size: (@font-size-base * 1.7);\n            @media (min-width: 361px) and (max-width: @screen-sm-max) {\n                font-size: (@font-size-base * 1.2);\n            }\n        }\n        .monto {\n            font-size: (@font-size-base * 3.85);\n            @media (min-width: 361px) and (max-width: @screen-sm-max) {\n                font-size: (@font-size-base * 2.9);\n            }\n        }\n        .asterisco {\n            font-size: @font-size-base;\n        }\n        .periodo {\n            font-size: (@font-size-base * 1.28);\n            @media (min-width: 361px) and (max-width: @screen-sm-max) {\n                font-size: (@font-size-base * 1.14);\n            }\n        }\n    }\n    .pasos {\n        height: 258px;\n        padding-left: 30px;\n        li {\n            width: 28%;\n            margin: 15px 18px 0 0;\n        }\n        p {\n            line-height: (@line-height-base * 0.75);\n            margin: 0px;\n        }\n        .thumb {\n            margin-bottom: 10px;\n        }\n        h3 {\n            font-family: Roboto;\n            font-size: (@font-size-base * 1.85);\n        }\n        h4 {\n            font-family: Roboto;\n            font-size: (@font-size-base * 1.85);\n            margin: 15px 10px 0 10px;\n        }\n    }\n    //* Donde (tienen que tener un height fijo*/\n    .donde {\n        height: 140px;\n        @media (min-width: @screen-xs-min) and (max-width: @screen-sm-max) {\n            height: 125px\n        }\n        h4 {\n            @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n                font-size: (@font-size-base * 0.99)\n            }\n            @media (max-width:@screen-xxs-max) {\n                font-size: (@font-size-base * 0.98)\n            }\n        }\n        .dispositivos {\n            margin-top: 20px;\n            @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n                margin-top: 0px;\n            }\n            ul {\n                display: inline-block;\n                list-style: none outside none;\n                margin: 0;\n                padding: 0;\n                li {\n                    display: inline-block;\n                    margin: 5px 0;\n                    img {\n                        width: 55px;\n                    }\n                    @media (min-width:@screen-xs-min) and (max-width:@screen-sm-max) {\n                        img {\n                            width: 45px;\n                        }\n                    }\n                    @media (max-width:@screen-xxs-max) {\n                        img {\n                            width: 42px;\n                        }\n                    }\n                    span {\n                        display: block;\n                        padding-top: 5px;\n                        @media (min-width: @screen-sm-min) and (max-width: @screen-md-max) {\n                            font-size: (@font-size-base * 0.85);\n                        }\n                        @media (max-width:@screen-sm-max) {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n        .descargas {\n            li {\n                display: inline-block;\n                margin: 5px 0;\n            }\n            @media (min-width:@screen-sm-min) and (max-width:@screen-md-max) {\n                .centro-descarga {height: 43px}\n            }\n            @media (min-width:@screen-xs-min) and (max-width:@screen-sm-max) {\n                .centro-descarga {height: 41px}\n            }\n            @media (max-width:@screen-xxs-max) {\n                .centro-descarga {height: 39px}\n            }\n        }\n        h3 {\n            font-family: Roboto;\n            font-size: (@font-size-base * 1.85);\n        }\n        @media (min-width:@screen-md-min) and (max-width:@screen-md-max) {\n            h3 {\n                font-size: (@font-size-base * 1.7);\n            }\n        }\n        strong {\n            font-family: Roboto;\n            font-weight: bold;\n        }\n    }\n    .registrate {\n        p {\n            margin-top: 5px;\n        }\n    }\n    //banners WEB-4451\n    .content-banner {\n        margin-bottom: 10px;\n        ul li img {\n            max-width: 574px;\n            width: 100%;\n            margin-bottom: 10px\n        }\n        @media (max-width: @screen-sm-max) {\n            li.col-xs-12,\n            li.col-sm-12 {\n                padding-left: 0px;\n            }\n        }\n    }\n    // End WEB-4451\n    // Header\n    header {\n        .btn {\n            margin: 0px 10px;\n            @media (max-width: @screen-xs-max) {\n                margin-left: 0px;\n                padding: 10px;\n            }\n        }\n        .main-logo {\n            //margin-top: 3px;\n            margin-bottom: 0;\n            margin-top: -8px;\n        }\n        .ingresa {\n            padding-top: 3px;\n        }\n        .brand-right {\n            padding: 7px;\n        }\n        .navbar-text {\n            margin-bottom: 8px;\n            margin-top: 8px;\n        }\n        /* Chat Button */\n        .chat-button {\n            float: right;\n            margin-left: 11px;\n            position: relative;\n        }\n        .chat-button2 {\n            a {\n                text-decoration: underline;\n                i {\n                    padding-right: 5px\n                }\n            }\n        }\n    }\n    .publicidad-300 {\n        border: none;\n        box-shadow: none;\n        padding: 4px;\n        @media (max-width: @screen-xs-max) {\n            background: none;\n        }\n        h3 {\n            margin: 0px;\n        }\n    }\n    @media (max-width: @screen-xs-max) {\n        .que-es {\n            p {\n                margin-bottom: 0;\n            }\n        }\n        .panel.padding-2 {\n            padding: 10px;\n        }\n        .panel {\n            margin-bottom: 10px;\n        }\n        .precio {\n            margin-bottom: 10px;\n        }\n    }\n    @media (min-width: @screen-lg-min) {\n        .pasos {\n            width: 525px;\n        }\n        .publicidad-300 {\n            border: 4px solid @white;\n            border-radius: 2px;\n            margin-left: 56px;\n            padding: 0;\n            width: 308px;\n        }\n    }\n} //cierra padre .layout-landing03\n@media (max-width: @screen-sm-max) {\n    .centro-descarga {\n        padding-bottom: 10px;\n    }\n}\n\n@media (max-width: @screen-md-max) {\n    .icono-descarga {\n        padding-bottom: 10px;\n    }\n}\n\n@media (min-width: @screen-lg-min) {\n    .icono-padding {\n        padding-left: 20px;\n    }\n}\n\n@media (min-width: @screen-lg-min) {\n    .padd-icono {\n        text-align: right;\n    }\n}\n\n@media (min-width: @screen-lg-min) {\n    .padd-icono-l {\n        text-align: left;\n    }\n}\n\n//CARRUSEL DESTACADO LANDING\n.layout-landing03 .carousel.slide .carousel-caption img {\n    width: auto;\n}\n.layout-landing03 .txt-promo {\n  margin-bottom: -4px;\n  float: left;\n}\n.promo-bajada{\n    display: table;\n}\n.promo-bajada li\n{\n    vertical-align: middle;\n    padding: 0;\n}\n\n\n/*XS*/\n\n@media (max-width: @screen-sm) {\n    .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n        height: 251px;\n    }\n}\n\n@media (max-width: @screen-xs) {\n    .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n        height: 251px;\n        height: auto;\n        width: 100%;\n    }\n}\n\n/* sm */\n\n\n\n@media  (min-width: @screen-sm-min) and (max-width: @screen-lg-max) {\n    /*SM & MD*/\n    .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n        height: 163px;\n    }\n}\n\n@media (min-width: @screen-lg-min) {\n    /*LG */\n    .layout-landing03 .carousel.slide .carousel-caption .item-wrapper img {\n        height: 251px;\n    }\n}\n\n\n.layout-landing03 .bg-blur-wrapper {\n    position: absolute;\n    z-index: -5;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: linear-gradient(rgba(0, 0, 0, 0.2), #000);\n    display: block;\n    margin: 0;\n    overflow: hidden;\n    width: 100%;\n}\n\n.layout-landing03 .carousel-indicators {\n    bottom: 0px;\n}\n\n.layout-landing03 .carousel-caption {\n    bottom: 25px;\n}\n\n.layout-landing03 header .navbar {\n    z-index: 3;\n}\n\n.layout-landing03 .bg-blur-wrapper img {\n    width: 100%;\n    height: auto;\n}\n\n.layout-landing03 .bg-blur-wrapper img.blur {\n    left: 50%;\n    margin-left: -540px;\n    position: relative;\n    z-index: -1;\n    width: auto;\n}\n\n@media (max-width: 768px) {\n    .layout-landing03 .bg-blur-wrapper img {\n        opacity: 0.8;\n    }\n}\n\n.layout-landing03 .main-wrapper > img {\n    height: auto;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .layout-landing03 .main-wrapper {\n        margin-top: -105px;\n    }\n}\n\n//FIX tamaño\n\n@media (min-width: @screen-sm-min) and (max-width: @screen-lg-max) {\n    /*SM & MD*/\n    .layout-landing03 .carousel.slide .carousel-inner {\n        padding-top: calc(100% * 0.562264);\n    }\n}\n\n@media (min-width: @screen-lg-min) {\n    /*LG */\n    .layout-landing03 .carousel.slide .carousel-inner {\n        padding-top: calc(100% * 0.4546875);\n    }\n}\n\n/*XS*/\n\n/*@media (max-width: @screen-xs) {\n    .layout-landing03 .carousel.slide .carousel-inner {}\n}*/\n\n\n\n\n/**/\n/*mediaquery Xs para landing*/\n\n@media (max-width: @screen-xs-max) {\n  .landing.layout-landing03{\n    .bg-blur-wrapper {position: absolute;}\n    .section-destacado {min-height: 610px;}\n      .carousel-caption {bottom: auto;}\n    }\n}\n\n\n.layout-landing03 .dispositivos li span {\n  font-size: 11.5px;\n  color: @gray4;\n}\n\n//* bg gradient*/\n@media (max-width: @screen-xs-max) {\n  .layout-landing03  .bg-blur-wrapper:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,1) 100%);\n  }\n}\n\n.layout-landing03 .carousel.slide.destacado h2\n{\n    font-size: 27px;\n}","@import \"bootstrap.less\";\n//Seccion Registro\n\n\nbody.layout-registro, body.layout-registro-logout {\n  @media (min-width: @screen-xl-min) {\n    .bg-blur {\n      background: url(../images/bg-registro-xl_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-xl.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-lg-max) {\n    .bg-blur {\n      background: url(../images/bg-registro-lg_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-lg.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n}\n\nbody.layout-registro.region-peru, body.layout-registro-logout.region-peru, body.layout-registro.region-mexico, body.layout-registro-logout.region-mexico {\n  @media (min-width: @screen-xl-min) {\n    .bg-blur {\n      background: url(../images/bg-registro-xl-peru_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-xl-peru.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-lg-max) {\n    .bg-blur {\n      background: url(../images/bg-registro-lg-peru_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-lg-peru.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n}\n\nbody.layout-registro, body.layout-registro-logout, body.layout-registro.region-peru, body.layout-registro-logout.region-peru, body.layout-registro.region-mexico, body.layout-registro-logout.region-mexico {\n\n  @media (max-width: @screen-md-max) {\n    .bg-blur {\n      background: url(../images/bg-registro-md_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-md.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-sm-max) {\n    .bg-blur {\n      background: url(../images/bg-registro-sm_blur.jpg) no-repeat left bottom @black;\n      background-size: @background-size;}\n    background: url(../images/bg-registro-sm.jpg) no-repeat left bottom @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-xs-max) {\n      .bg-blur {\n      background-image: none;\n      background-color: transparent;}\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 34px @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: 360px) {\n    .bg-blur {\n      background-image: none;\n      background-color: transparent;}\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 72px @black;\n    background-size: @background-size;\n    }\n} //Background body\n\n// Registro - Renta\n// A unificar\n.registro, .renta {\n  .promocional {\n    display: table;\n      min-height: @pasos-height;\n      padding: (@grid-gutter-width *4) (@grid-gutter-width *2) (@grid-gutter-width *2) (@grid-gutter-width *2);\n        .oferta {\n      h2, h3, h4, { color: @white;}\n            h2 {\n              margin-top: 0px;\n        strong, span { color:@brand-primary;}\n                }\n            h3 {\n              font-size: (@font-size-base * 1.28);\n            }\n            h4 {\n              font-size: (@font-size-base * 1.07);\n        small { display: block;}\n                .infinitum {\n                    color:@gray;\n                    font-weight: bold;\n                  }\n            }\n        }\n        @media (max-width: @screen-sm-max) {\n      .oferta { width:330px;}\n          }\n    }\n  .col-form {\n  \tmin-height: @pasos-height;\n  }\n}\n\n.region-mexico {\n  .registro {\n    .oferta {\n      h2, h3, h4, { color: @gray-lighter;}\n    }\n    .userdetectws {\n     h2, h3, h4, { color: @gray-dark;} \n    }\n  }\n}","@import \"bootstrap.less\";\n/*\nVersion: @@ver@@ Timestamp: @@timestamp@@\n*/\n.select2-container {\n    margin: 0;\n    position: relative;\n    display: inline-block;\n    /* inline-block for ie7 */\n    zoom: 1;\n    *display: inline;\n    vertical-align: middle;\n}\n\n.select2-container,\n.select2-drop,\n.select2-search,\n.select2-search input {\n  /*\n    Force border-box so that % widths fit the parent\n    container without overlap because of margin/padding.\n    More Info : http://www.quirksmode.org/css/box.html\n  */\n   min-width: 180px;\n  -webkit-box-sizing: border-box; /* webkit */\n     -moz-box-sizing: border-box; /* firefox */\n          box-sizing: border-box; /* css3 */\n}\n\n.select2-container .select2-choice {\n    display: block;\n    height: 30px;\n    padding: 0 0 0 8px;\n    overflow: hidden;\n    position: relative;\n    border: 1px solid @gray6;\n    white-space: nowrap;\n    line-height: 30px;\n    color:  @gray-dark4;\n    text-decoration: none;\n    border-radius: 2px;\n    margin-bottom: 1px;\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    background-color: @white;\n    /*background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.5, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#ffffff', endColorstr = '#eeeeee', GradientType = 0);\n    background-image: linear-gradient(to top, #eee 0%, #fff 50%);*/\n}\n\n.select2-container.select2-drop-above .select2-choice {\n    border-bottom-color: @gray6;\n\n    border-radius: 0 0 2px 2px;\n\n   /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.9, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#eeeeee', GradientType=0);\n    background-image: linear-gradient(to bottom, #eee 0%, #fff 90%);*/\n}\n\n.select2-container.select2-allowclear .select2-choice .select2-chosen {\n    margin-right: 42px;\n}\n\n.select2-container .select2-choice > .select2-chosen {\n    margin-right: 26px;\n    display: block;\n    overflow: hidden;\n\n    white-space: nowrap;\n\n    text-overflow: ellipsis;\n    float: none;\n    width: auto;\n}\n\n.select2-container .select2-choice abbr {\n    display: none;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 24px;\n    top: 8px;\n\n    font-size: 1px;\n    text-decoration: none;\n\n    border: 0;\n    background: url(\"../images/select2.png\") right top no-repeat;\n    cursor: pointer;\n    outline: 0;\n}\n\n.select2-container.select2-allowclear .select2-choice abbr {\n    display: inline-block;\n}\n\n.select2-container .select2-choice abbr:hover {\n    background-position: right -11px;\n    cursor: pointer;\n}\n\n.select2-drop-mask {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    position: fixed;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    min-width: 100%;\n    height: auto;\n    width: auto;\n    opacity: 0;\n    z-index: 9998;\n    /* styles required for IE to work */\n    background-color: @white;\n    filter: alpha(opacity=0);\n}\n\n.select2-drop {\n    width: 100%;\n    margin-top: -1px;\n    position: absolute;\n    z-index: 9999;\n    top: 100%;\n\n    background: @white;\n    color: @black;\n    border: 1px solid @gray6;\n    border-top: 0;\n\n    border-radius: 0 0 2px 2px;\n\n    -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop.select2-drop-above {\n    margin-top: 1px;\n    border-top: 1px solid @gray6;\n    border-bottom: 0;\n\n    border-radius: 2px 2px 0 0;\n\n    -webkit-box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop-active {\n    border: 1px solid @grayc;\n    border-top: none;\n}\n\n.select2-drop.select2-drop-above.select2-drop-active {\n    border-top: 1px solid @grayc;\n}\n\n.select2-drop-auto-width {\n    border-top: 1px solid @gray6;\n    width: auto;\n}\n\n.select2-drop-auto-width .select2-search {\n    padding-top: 4px;\n}\n\n.select2-container .select2-choice .select2-arrow {\n    display: inline-block;\n    width: 18px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    /*border-left: 1px solid @gray6;\n    border-radius: 0 2px 2px 0;*/\n\n    background-clip: padding-box;\n\n   /* background: @grayc;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #ccc), color-stop(0.6, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    background-image: -moz-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#eeeeee', endColorstr = '@grayc', GradientType = 0);\n    background-image: linear-gradient(to top, #ccc 0%, #eee 60%);*/\n}\n\n.select2-container .select2-choice .select2-arrow b {\n    display: block;\n    width: 100%;\n    height: 100%;\n    background: url(\"../images/select2.png\") no-repeat 0 1px;\n}\n\n.select2-search {\n    display: inline-block;\n    width: 100%;\n    min-height: 26px;\n    margin: 0;\n    padding-left: 4px;\n    padding-right: 4px;\n\n    position: relative;\n    z-index: 10000;\n\n    white-space: nowrap;\n}\n\n.select2-search input {\n    width: 100%;\n    height: auto !important;\n    min-height: 26px;\n    padding: 4px 20px 4px 5px;\n    margin: 0;\n\n    outline: 0;\n    \n   \n\n    border: 1px solid @gray6;\n    border-radius: 0;\n\n    -webkit-box-shadow: none;\n            box-shadow: none;\n\n    background: @white url(\"../images/select2.png\") no-repeat 100% -22px;\n   /* background: url(\"../images/select2.png\") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2.png\") no-repeat 100% -22px, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/\n}\n\n.select2-drop.select2-drop-above .select2-search input {\n    margin-top: 4px;\n}\n\n.select2-search input.select2-active {\n    background: @white url(\"../images/select2-spinner.gif\") no-repeat 100%;\n   /* background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(\"../images/select2-spinner.gif\") no-repeat 100%, linear-gradient(to bottom, #fff 85%, #eee 99%) 0 0;*/\n}\n\n.select2-container-active .select2-choice,\n.select2-container-active .select2-choices {\n    border: 1px solid @grayc;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n\n.select2-dropdown-open .select2-choice {\n    border-bottom-color: transparent;\n    -webkit-box-shadow: 0 1px 0 @white inset;\n            box-shadow: 0 1px 0 @white inset;\n\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n    background-color: @white;\n   /* background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(to top, #fff 0%, #eee 50%);*/\n}\n\n.select2-dropdown-open.select2-drop-above .select2-choice,\n.select2-dropdown-open.select2-drop-above .select2-choices {\n    border: 1px solid @grayc;\n    border-top-color: transparent;\n\n   /* background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center top, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center top, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(to bottom, #fff 0%, #eee 50%);*/\n}\n\n.select2-dropdown-open .select2-choice .select2-arrow {\n    background: transparent;\n    border-left: none;\n    filter: none;\n}\n.select2-dropdown-open .select2-choice .select2-arrow b {\n    background-position: -18px 1px;\n}\n\n.select2-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n}\n\n/* results */\n.select2-results {\n    max-height: 200px;\n    padding: 0 0 0 0px;\n   /* margin: 4px 0px 4px 0;*/\n    margin: 0px;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.select2-results ul.select2-result-sub {\n    margin: 0;\n    padding-left: 0;\n}\n\n.select2-results li {\n    list-style: none;\n    display: list-item;\n    background-image: none;\n     border-top: 1px solid @grayc;\n     color: @gray-dark;\n}\n\n.select2-results li.select2-result-with-children > .select2-result-label {\n    font-weight: bold;\n}\n\n.select2-results .select2-result-label {\n    padding: 3px 7px 4px;\n    margin: 0;\n    cursor: pointer;\n\n    min-height: 1em;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n}\n\n.select2-results-dept-1 .select2-result-label { padding-left: 20px }\n.select2-results-dept-2 .select2-result-label { padding-left: 40px }\n.select2-results-dept-3 .select2-result-label { padding-left: 60px }\n.select2-results-dept-4 .select2-result-label { padding-left: 80px }\n.select2-results-dept-5 .select2-result-label { padding-left: 100px }\n.select2-results-dept-6 .select2-result-label { padding-left: 110px }\n.select2-results-dept-7 .select2-result-label { padding-left: 120px }\n\n.select2-results .select2-highlighted {\n    background: @gray-light;\n    color: @white;\n}\n\n.select2-results li em {\n    background: #feffde;\n    font-style: normal;\n}\n\n.select2-results .select2-highlighted em {\n    background: transparent;\n}\n\n.select2-results .select2-highlighted ul {\n    background: @white;\n    color: @black;\n}\n\n\n.select2-results .select2-no-results,\n.select2-results .select2-searching,\n.select2-results .select2-selection-limit {\n    background: @grayf4;\n    display: list-item;\n    padding-left: 5px;\n}\n\n/*\ndisabled look for disabled choices in the results dropdown\n*/\n.select2-results .select2-disabled.select2-highlighted {\n    color: @gray6;\n    background: @grayf4;\n    display: list-item;\n    cursor: default;\n}\n.select2-results .select2-disabled {\n  background: @grayf4;\n  display: list-item;\n  cursor: default;\n}\n\n.select2-results .select2-selected {\n    display: none;\n}\n\n.select2-more-results.select2-active {\n    background: @grayf4 url(\"../images/select2-spinner.gif\") no-repeat 100%;\n}\n\n.select2-more-results {\n    background: @grayf4;\n    display: list-item;\n}\n\n/* disabled styles */\n\n.select2-container.select2-container-disabled .select2-choice {\n    background-color: @grayf4;\n    background-image: none;\n    border: 1px solid @grayd;\n    cursor: default;\n}\n\n.select2-container.select2-container-disabled .select2-choice .select2-arrow {\n    background-color: @grayf4;\n    background-image: none;\n    border-left: 0;\n}\n\n.select2-container.select2-container-disabled .select2-choice abbr {\n    display: none;\n}\n\n\n/* multiselect */\n\n.select2-container-multi .select2-choices {\n    height: auto !important;\n    height: 1%;\n    margin: 0;\n    padding: 0 5px 0 0;\n    position: relative;\n\n    border: 1px solid @gray6;\n    cursor: text;\n    overflow: hidden;\n\n    background-color:red;\n   /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(1%, #eee), color-stop(15%, #fff));\n    background-image: -webkit-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: -moz-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);*/\n}\n\n.select2-locked {\n  padding: 3px 5px 3px 5px !important;\n}\n\n.select2-container-multi .select2-choices {\n    min-height: 26px;\n}\n\n.select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid @grayc;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n.select2-container-multi .select2-choices li {\n    float: left;\n    list-style: none;\n}\nhtml[dir=\"rtl\"] .select2-container-multi .select2-choices li\n{\n    float: right;\n}\n.select2-container-multi .select2-choices .select2-search-field {\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input {\n    padding: 5px;\n    margin: 1px 0;\n\n    \n    font-size: 100%;\n    color: @gray6;\n    outline: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    background: transparent !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input.select2-active {\n    background: @white url(\"../images/select2-spinner.gif\") no-repeat 100% !important;\n}\n\n.select2-default {\n    color: @gray-light !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 18px;\n    margin: 3px 0 3px 5px;\n    position: relative;\n\n    line-height: 13px;\n    color: @gray-dark;\n    cursor: default;\n    border: 1px solid @gray6;\n\n    border-radius: 2px;\n\n    -webkit-box-shadow: 0 0 2px @white inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n            box-shadow: 0 0 2px @white inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n\n    background-color: #e4e4e4;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#f4f4f4', GradientType=0);\n   /* background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(20%, #f4f4f4), color-stop(50%, #f0f0f0), color-stop(52%, #e8e8e8), color-stop(100%, #eee));\n    background-image: -webkit-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: -moz-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: linear-gradient(to top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);*/\n}\nhtml[dir=\"rtl\"] .select2-container-multi .select2-choices .select2-search-choice\n{\n    margin-left: 0;\n    margin-right: 5px;\n}\n.select2-container-multi .select2-choices .select2-search-choice .select2-chosen {\n    cursor: default;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus {\n    background: #d4d4d4;\n}\n\n.select2-search-choice-close {\n    display: block;\n    width: 12px;\n    height: 13px;\n    position: absolute;\n    right: 3px;\n    top: 4px;\n\n    font-size: 1px;\n    outline: none;\n    background: url(\"../images/select2.png\") right top no-repeat;\n}\nhtml[dir=\"rtl\"] .select2-search-choice-close {\n    right: auto;\n    left: 3px;\n}\n\n.select2-container-multi .select2-search-choice-close {\n    left: 3px;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover {\n  background-position: right -11px;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close {\n    background-position: right -11px;\n}\n\n/* disabled styles */\n.select2-container-multi.select2-container-disabled .select2-choices {\n    background-color: @grayf4;\n    background-image: none;\n    border: 1px solid @grayd;\n    cursor: default;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 5px;\n    border: 1px solid @grayd;\n    background-image: none;\n    background-color: @grayf4;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close {    display: none;\n    background: none;\n}\n/* end multiselect */\n\n\n.select2-result-selectable .select2-match,\n.select2-result-unselectable .select2-match {\n    text-decoration: underline;\n}\n\n.select2-offscreen, .select2-offscreen:focus {\n    clip: rect(0 0 0 0) !important;\n    width: 1px !important;\n    height: 1px !important;\n    border: 0 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    position: absolute !important;\n    outline: 0 !important;\n    left: 0px !important;\n    top: 0px !important;\n}\n\n.select2-display-none {\n    display: none;\n}\n\n.select2-measure-scrollbar {\n    position: absolute;\n    top: -10000px;\n    left: -10000px;\n    width: 100px;\n    height: 100px;\n    overflow: scroll;\n}\n\n\n.form-control .select2-choice {\n    border: 0;\n    border-radius: 2px;\n}\n\n.form-control .select2-choice .select2-arrow {\n    border-radius: 0 2px 2px 0;   \n}\n\n.form-control.select2-container {\n    height: auto !important;\n    padding: 0;\n}\n\n.form-control.select2-container.select2-dropdown-open {\n    border-color: @grayc;\n    border-radius: 2px 2px 0 0;\n}\n\n.form-control .select2-container.select2-dropdown-open .select2-choices {\n    border-radius: 2px 2px 0 0;\n}\n\n.form-control.select2-container .select2-choices {\n    border: 0 !important;\n    border-radius: 2px;\n}\n\n.control-group.warning .select2-container .select2-choice,\n.control-group.warning .select2-container .select2-choices,\n.control-group.warning .select2-container-active .select2-choice,\n.control-group.warning .select2-container-active .select2-choices,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.warning .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid @brown !important;\n}\n\n.control-group.warning .select2-container .select2-choice div {\n    border-left: 1px solid @brown !important;\n    background: #FCF8E3 !important;\n}\n\n.control-group.error .select2-container .select2-choice,\n.control-group.error .select2-container .select2-choices,\n.control-group.error .select2-container-active .select2-choice,\n.control-group.error .select2-container-active .select2-choices,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.error .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid @red-light !important;\n}\n\n.control-group.error .select2-container .select2-choice div {\n    border-left: 1px solid @red-light !important;\n    background: #F2DEDE !important;\n}\n\n.control-group.info .select2-container .select2-choice,\n.control-group.info .select2-container .select2-choices,\n.control-group.info .select2-container-active .select2-choice,\n.control-group.info .select2-container-active .select2-choices,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.info .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #3A87AD !important;\n}\n\n.control-group.info .select2-container .select2-choice div {\n    border-left: 1px solid #3A87AD !important;\n    background: #D9EDF7 !important;\n}\n\n.control-group.success .select2-container .select2-choice,\n.control-group.success .select2-container .select2-choices,\n.control-group.success .select2-container-active .select2-choice,\n.control-group.success .select2-container-active .select2-choices,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.success .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #468847 !important;\n}\n\n.control-group.success .select2-container .select2-choice div {\n    border-left: 1px solid #468847 !important;\n    background: #DFF0D8 !important;\n}\n\n\n\n\n\n// -------------       Bootstrap fix     ------//////////////////////////\n\n\n\n.form-control .select2-choice {\n    border: 0;\n    border-radius: 2px;\n}\n\n.form-control .select2-choice .select2-arrow {\n    border-radius: 0 2px 2px 0;   \n}\n\n.form-control.select2-container {\n    height: auto !important;\n    padding: 0;\n}\n\n.form-control.select2-container.select2-dropdown-open {\n    border-color: @grayc;\n    border-radius: 2px 2px 0 0;\n}\n\n.form-control .select2-container.select2-dropdown-open .select2-choices {\n    border-radius: 2px 2px 0 0;\n}\n\n.form-control.select2-container .select2-choices {\n    border: 0 !important;\n    border-radius: 2px;\n}\n\n.control-group.warning .select2-container .select2-choice,\n.control-group.warning .select2-container .select2-choices,\n.control-group.warning .select2-container-active .select2-choice,\n.control-group.warning .select2-container-active .select2-choices,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.warning .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid @brown !important;\n}\n\n.control-group.warning .select2-container .select2-choice div {\n    border-left: 1px solid @brown !important;\n    background: #FCF8E3 !important;\n}\n\n.control-group.error .select2-container .select2-choice,\n.control-group.error .select2-container .select2-choices,\n.control-group.error .select2-container-active .select2-choice,\n.control-group.error .select2-container-active .select2-choices,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.error .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid @red-light !important;\n}\n\n.control-group.error .select2-container .select2-choice div {\n    border-left: 1px solid @red-light !important;\n    background: #F2DEDE !important;\n}\n\n.control-group.info .select2-container .select2-choice,\n.control-group.info .select2-container .select2-choices,\n.control-group.info .select2-container-active .select2-choice,\n.control-group.info .select2-container-active .select2-choices,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.info .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #3A87AD !important;\n}\n\n.control-group.info .select2-container .select2-choice div {\n    border-left: 1px solid #3A87AD !important;\n    background: #D9EDF7 !important;\n}\n\n.control-group.success .select2-container .select2-choice,\n.control-group.success .select2-container .select2-choices,\n.control-group.success .select2-container-active .select2-choice,\n.control-group.success .select2-container-active .select2-choices,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.success .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #468847 !important;\n}\n\n.control-group.success .select2-container .select2-choice div {\n    border-left: 1px solid #468847 !important;\n    background: #DFF0D8 !important;\n}  ","@import \"bootstrap.less\";\n\n.section-ficha {\n    border-bottom: 1px solid @gray2;\n\n  @media (min-width: @screen-lg-min) {\n    .purchaseBtn--view {\n      padding-left: 2em\n    }\n  }\n}\n\n // Ficha\n\n.ficha {\n  background: @grayf4;\n  .info { background-color: @grayd;\n    a {color: @gray}\n    a:hover {color: @gray-darker}\n    .well {\n      background-color: #eeeeee;\n      .radio { margin-top: 0;}\n    }\n    .item-wrapper { width: 100%;}\n  }\n\n  h3 {\n    font-weight: bold;\n    color: @gray-dark;\n  }\n\n  .label-default {\n    border-radius: 0;\n    background: @gray-lighter;\n    color: @gray-dark;\n    font-weight: normal;\n    line-height: @line-height-base * 1.5;\n  }\n  \n  .item-rating {\n    color: @gray5;\n    border: 1px solid @gray5;\n    border-radius: 0;\n    background: none ;\n  }\n\n  .tooltip-footer {\n    h6 { float: left; }\n    i { color:@white; }\n  }\n\n  .item-image img {\n    width: 100%;\n  }\n\n\n\n  .well {\n    .btn {\n      text-align: left;\n      white-space: normal;\n    }\n  }\n  button.costo_promo {\n    margin-top: 5px;\n    .tiempo {\n      font-size: @font-size-small;\n      font-weight: normal;\n    }\n    .texto {\n      font-size: (@font-size-large * 0.95);\n      font-weight: bold; margin-bottom: 0px;\n      white-space: normal;\n    }\n  }\n\n  .caja_descuento {\n    margin-top: -18px;\n    .fa-caret-up {\n      width: 100%;\n      text-align: center;\n    }\n    .mensaje {\n      background-color: @gray-darker;\n      .signo {font-size: (@font-size-base * 1.5); text-align: right;}\n      .texto {font-size: @font-size-small;\n      }\n      @media (max-width: @screen-xs-max) {\n        .texto {\n          font-size: @font-size-large;\n        }\n      }\n    }\n    .tit_original, .fecha_tiempo, .director, .actores, .generos {\n      font-size: @font-size-small;\n    }\n    .redes_sociales ul.list-inline li:last-child {\n      display:block;\n      padding-top: 5px;\n      width: 90px;\n    }\n  }\n  .series {\n    .tabla {\n      display: table;\n      width: 100%;\n      }\n    .tabla.detalle_compras{\n      background: (@gray-light * 1.5);\n      }\n\n    .col_temporada ul, .col_datos ul {\n      list-style-type: none;\n      display: block;\n      padding: 0;\n      margin: 0;\n      h5 {\n        margin: 0;\n        padding: 8px;\n        font-weight: bold;\n      }\n    }\n    .col_temporada ul li, .col_datos ul li {display: block;}\n   /* .col_temporada ul li:first-child {border-bottom: 2px solid @grayd;}\n    .col_datos ul li:first-child {border-bottom: 2px solid @grayd;}*/\n\n    //cambio flor mangian//\n    .col_temporada ul li a, .col_datos ul li.estaspor  {\n      display: block;\n      padding: 8px 8px 8px 24px;\n      color: @gray-darker;\n      text-decoration: none;\n    }\n\n    .col_datos ul li {\n     /* border-bottom: 1px solid @grayd;*/\n\n      a {\n           color: @gray5;\n           text-decoration: none;\n           display: block;\n           padding: 8px;\n           height: 46px;\n           line-height: 46px;\n           padding: 0 8px;\n           width: 100%;\n           word-wrap: break-word;\n           text-overflow: ellipsis;\n           overflow: hidden;\n        }\n      a:hover { background-color: fade(@gray2, 50%) }\n      a.active { background-color: fade(@gray2, 50%) }\n      i { color: @brand-primary;}\n    }\n\n    .col_datos ul.list-striped li:nth-of-type(2n+1){\n        background : @gray2;\n        background : fade(@gray2, 25%);\n    }\n\n    // cambio vir //\n    .col_datos ul li.episode {\n    .btn i{color:@white}\n    }\n\n   .col_datos .vistime, .col_datos .calification, .col_datos .date {\n    text-align: center;\n    p{text-align:left;}\n    }\n    // fin cambio vir //\n\n    .col_datos .vistime, .col_datos .calification, .col_datos .date { text-align: center;}\n    .col_datos .vistime-progress-last {\n      position: relative;\n      background-color: transparent;\n      height: 18px;}\n    .col_datos .date { font-size: @font-size-small;}\n  }\n\n  @media (min-width: @screen-lg-min) {\n    .box_data { padding-left: 20px;}\n  }\n\n  @media (max-width: @screen-xs-max) {\n    .info.padding-2 {\n      padding: 10px;\n    }\n    .vistime { margin-top: 10px }\n    h2 { font-size: (@font-size-base * 1.7);}\n    .tooltip-score {\n      float: none;\n      margin: -5px 0 15px 0\n    }\n    .redes_sociales ul.list-inline li {\n      padding: 10px 0 0 0;\n      float: none;\n      display: block;\n    }\n  }\n  .twitter-share-button {\n    display: inline-block;\n    margin-bottom: -5px;\n  }\n\n  /* Ficha EST */\n  .est-button-disabled {\n    background: none;\n    color: @gray-light;\n    border: 1px solid @gray-light;\n    cursor: default;\n    i {\n      color: #008C00;\n    }\n  }\n  .fb_iframe_widget {\n    display: inline !important;\n    z-index: 100;\n  }\n  @media (max-width: @screen-md-max) and (min-width: @screen-md-min) {\n    .costo_promo {\n      max-width: 200px;\n    }\n    .btn_download {\n      max-width: 200px;\n    }\n  }\n}\n\n/* Estás por (hay que mover este parche a FORMS-claro.less)*/\n.sin-medio-pago, .renta-medio-pago {\n  .medios-pagos-web.padding-2 {\n    padding: 14px;\n  }\n.form-container {\n    padding: 20px;\n    h5 {\n      padding-left: 5px;\n    }\n    @media (max-width: @screen-xs-max) {\n      padding: 0;\n    }\n  }\n  @media (max-width: @screen-xs-max) {\n    .padding-2 {\n      padding: 10px;\n    }\n  }\n}\n\n//EST Mexico\n.region-mexico {\n  .ficha {\n    .caja_descuento {\n      margin-top: -20px;\n      position:relative;\n      .fa-caret-up {\n        position: absolute;\n        top: -18px;\n        left: 50%;\n        margin-left:-8px;\n        width:16px;\n      }\n    }\n  }\n}\n\n\n\n\n//cambios 2016\n.section-ficha-bg {\n  height: 100%;\n  /*overflow: hidden;*/\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -999;\n}\n\n.section-ficha-bg > img {\n  position: relative;\n  width: 100%;\n}\n.wrapper-img {\n  overflow: hidden;\n  width: 100%;\n}\n.section-ficha-bg > img.img-responsive {\n  opacity: 0.6;\n  width: 100%;\n}\n.img-responsive2 {\n  left: 50%;\n  margin-left: -640px;\n  position: relative;\n  opacity: 0.6;\n}\n/*se setea por el tamaño de la img*/\n\n.section-ficha .item-wrapper {\n /*   display: block;*/\n}\n.section-ficha .item-wrapper img {\n width: 100%;\n}\n.ficha {\n  background: none;\n}\n\n.ficha.temporada {\n  background-image:  linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 14.13%, rgba(0, 0, 0, 0.7) 100%);\n  margin: 0;\n  width: 100%;\n}\n\n.img-responsive3 {\n  height: 150%;\n  left: 50%;\n  margin-left: calc(~\"-25% - 640px\");\n  opacity: 0.5;\n  overflow: hidden;\n  position: relative;}\n\n  .section-ficha-bg2 {\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: -99;\n  }\n\n.col_datos.col-sm-12.serie-contents{\n  position: relative;\n}\n.section-ficha .fecha_tiempo ul {\n  line-height: 35px;\n}\n.season-loading {\n  position: absolute;\n  top: 60px;\n  left: 50%;\n  margin-left: -25px;\n}\n\n/*.season-loading {\nanimation: seasonfade 0.2s;\n}\n\n@keyframes seasonfade {\n    from { opacity: 0.2; }\n    to   { opacity: 1; }\n}*/\n\n//PLAY DISPOSITIVOS\n.devicetype-mobile.layout-fichabts .section-ficha .play{\n  opacity:1;\n  visibility: visible;\n}\n\n.card-button-prices {\n  background:#0071bd;\n  border: #147fef;\n  color: white;\n  box-shadow: 0 0 1px rgba(0,0,0, 0.28);\n}\n\n.card-button-prices:hover {\n  background: #14579f;\n  color: white !important;\n  box-shadow: 1px 0px 10px rgba(0,0,0, 0.6);\n}\n\n.box_data {\n  position: inherit;\n}\n\n.disabled .precio {\n  display: none;\n}","@import \"bootstrap.less\";\n\n/* RESULTADO DE BUSQUEDA\n-------------------------------------------------- */\n\n\n//Background body Respuesta-buscador\n\nbody.layout-respuesta-buscador {\n  @media (min-width: @screen-xl-min) {\n    background: url(../images/bg-registro-xl_blur.jpg) no-repeat left top @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-lg-max) {\n    background: url(../images/bg-registro-lg_blur.jpg) no-repeat left top @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-md-max) {\n    background: url(../images/bg-registro-md_blur.jpg) no-repeat left top @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-sm-max) {\n    background: url(../images/bg-registro-sm_blur.jpg) no-repeat left top @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: @screen-xs-max) {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 34px @black;\n    background-size: @background-size;\n    }\n\n  @media (max-width: 360px) {\n    background: url(../images/bg-registro-xs_blur.jpg) no-repeat 0 72px @black;\n    background-size: @background-size;\n    }\n  } //Background body\n\n.resultado-busqueda {\n  background-color: @gray-darker;\n  .row-even {background-color: @gray-dark;}\n  h3 {color: @white !important}\n  @media (max-width: @screen-xs-max) {\n    .tooltip-score {padding-top: 0; margin: 0}\n    h2 { font-size: 10px; }\n    h3 { font-size: (@font-size-base * 1.1) !important}\n  }\n}\n\n\n.resultado-busqueda .tooltip-score {\n  //margin: 0 0 15px 0;\n}\n.resultado-busqueda img {\n    height: auto !important;\n}\n.highlight {\n  text-decoration: underline;\n}\n.sugerencia-buscador-respuesta{\n\t@media (max-width: @screen-xs-max) {\n\t\th4 { font-size: (@font-size-base * 0.98);}\n\t}\n}\n\n\n/* DESTACADO - RESULTADO DE BUSQUEDA\n-------------------------------------------------- */\n\n.section-carrousel {\n  .carousel.slide.destacado.resultado-busqueda {\n    padding-bottom: 20px;    \n    background:fade(@black, 75);\n    .bkg_box{\n      height: 485px;\n      overflow: hidden;\n    }\n    .carousel-indicators li {box-shadow: 0 1px 2px rgba(0, 0, 0, 1);}\n    h2 {\n      font-size: (@font-size-base * 1.8);\n      color: @white;\n      text-shadow: 0 1px 2px rgba(0, 0, 0, 1);\n    }\n      .bkg_destacado {\n        position:relative;\n        top:0px;\n        left:0px;\n        z-index: 0;\n        height: 535px;\n          img.blur {\n            filter: blur(13px);\n            -webkit-filter: blur(13px);\n            -moz-filter: blur(13px);\n            -o-filter: blur(13px);\n            -ms-filter: blur(13px);\n          }\n      }\n      .titulo-buscado {\n        position:absolute;\n        top:15px;\n        z-index: 1;\n      }\n      .carousel-inner {\n        position:absolute;\n        top:60px;\n        left:0px;\n        z-index: 1;\n        border: 0;        \n      }\n      a.carousel-control {\n        position:absolute;\n        z-index: 10;\n      }\n      .section-buscador, .ficha.resultado-busqueda {\n        background: none !important;\n      h3 {color: @white !important}\n      }\n    \n    @media (max-width: @screen-md-max) {\n      .titulo-buscado {\n        top:15px;\n      }\n    }\n\n    @media (max-width: @screen-sm-max) {\n\t  .bkg_destacado {\n        min-width: 1024px;\n      }\n      .titulo-buscado {\n        top:0px;\n      }\n    }\n\n  \t@media (min-width: @screen-sm-min) {\n      .ficha.resultado-busqueda {\n    \t.box-tit {\n      \tdisplay: block;\n      \twidth: 540px;\n      \theight: 30px;\n      \toverflow: hidden;\n      \ttext-overflow: ellipsis;\n      \twhite-space: nowrap;\n      \t}\n      }\n  \t}\n\n    @media (max-width: @screen-xs-max) {\n      height: 440px; background-color: @gray-dark;\n      .box-tit {\n      \tspan {font-size: (@font-size-h4);}\n    \t}\n      h2 {font-size: (@font-size-base * 1.7);}\n      .titulo-buscado {\n        top:0px;\n      }\n    }\n    @media (max-width: @screen-xxs-max) {\n      height: 295px; background-color: @gray-dark;      \n      h2 {font-size: (@font-size-base * 1.3);}\n      .titulo-buscado {\n        top:-5px;\n        margin-right: 5px;\n      }\n    }   \n  }   \n}\n\n\n/* DESTACADO - GENERO\n-------------------------------------------------- */\n\n.section-sugerencia-genero {\n  background-color: @gray-dark;\n  @media (max-width: @screen-xs-max) {\n    h4 {font-size: (@font-size-base * 1.1);}\n  }\n\n  @media (max-width: 768px) {\n    .item-wrapper img {\n      height: auto;\n    }\n  } \n}\n\n\n/* Listado Busqueda no encontrada\n-------------------------------------------------- */\nul.listado {\n  color: @gray-light;\n  font-weight: normal;\n  margin-left: 0px;\n  margin-top: 25px;\n  padding-left: 18px;  \n  font-size: 18px;\n  li {    \n    font-size: 18px;\n    font-family: Roboto;\n    font-weight: normal;\n    color: @headings-color;\n    @media (min-width: @screen-sm-max) {\n      line-height: 25px;\n      font-size: 18px;\n    }\n    @media (max-width: @screen-sm-max) {\n      font-size: 15px !important;\n      line-height: 16px;\n      margin-bottom:5px;\n    } \n    span {\n      color: @white;\n    }   \n  }\n}\n.section-buscadorcarrousel {\n  padding-bottom: 35px;\n  padding-top: 25px;\n}","@import \"bootstrap.less\";\n\n// Mi cuenta\n\n.mi-cuenta {\n\n  .nav-pills>li.active>a, .nav-pills>li.active>a:hover, .nav-pills>li.active>a:focus{ color: @black;}\n  background-color: @gray23;\n  .item-rating {\n    /*background: @white;\n    color: @gray-darker;\n    border: 1px solid @gray;*/\n  }\n  .tooltip-score {\n    float: left;\n    color: @brand-claro;\n    cursor: default;\n  }\n  .tooltip-score i {\n    cursor: pointer;\n    font-size: 1em;\n  }\n  .box-dispositivos.impar {\n    background-color: @gray-dark;\n    span.deviceName {\n      display: block;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .box-dispositivos {\n    img {\n      width: 50px;\n    }\n  }\n  h3 {\n    font-weight: normal;\n    color: @white !important;\n  }\n  /* Headers Fijos */\n  .cont-title-fixed.stickOnScroll-on {\n    left: 0;\n    width: 100%;\n    z-index: 5;\n    .container {padding: 0}\n    h3.hasStickOnScroll {\n      display: block;\n      z-index: 2;\n      padding: 10px 0px;\n      width: 100%;\n      background: @gray23;\n      box-shadow: 0px 4px 9px @black;\n      padding-left: 30px;\n      @media (max-width: 767px) {\n        background-position: 0 -7px;\n      }\n    }\n    .hasStickOnScroll {\n      display: block;\n      z-index: 2;\n      width: 100%;\n      background-color: @gray23;\n      box-shadow: 0px 4px 9px @black;\n      padding:0 30px;\n      margin: 0px;\n      h3 {\n        margin-top: 12px;\n      }\n    }\n  }\n  /* Headers Fijos */\n  .box-dispositivos-asociados {\n    .impar {\n      background-color: @gray2;\n    }\n  }\n  .btn-dispositivos-asociados {\n    a {\n    text-decoration: none;\n    color: @white;\n    }\n  }\n  .descarga-silverlight {\n   \theight: 39px;\n   \tposition: relative;\n  }\n  /* HISTORIAL */\n  .box-historial.impar { background-color: @gray-dark;}\n  .box-historial {\n    .img-horinzontal {\n      width:100%;\n    }\n    .img-vertical {\n      width: 100%;\n    }\n    .disabled {\n      .img-horinzontal, .img-vertical {\n        opacity:0.5;\n      }\n      h4 {\n        opacity:0.5;\n      }\n      .vistime-progress-last {\n        opacity:0.5;\n      }\n      .label-default-hd {\n        opacity: 0.5;\n      }\n      .tooltip-score {\n        opacity: 0.5;\n      }\n      .datos {\n        opacity: 0.5;\n      }\n    }\n  }\n\n\n\n  .tit-peli h4 {\n    margin:0px;\n    font-weight: bold;\n  }\n  .label {\n    border-radius: 0em;\n  }\n\n  &.section-micuentahistorial .nav-pills {\n    margin-bottom: 10px;\n    padding: 5px 0 0;\n  }\n  h3 .nav-pills{\n    margin-top: -8px;\n  }\n\n\n/*--- VISTIME PROGRESS HISTORIAL*/\n\n.vistime-progress-last {\n  height: 16px;\n  left: 10%;\n  margin-top: 3px;\n  overflow: hidden;\n  position: relative;\n  width: 80%;\n  z-index: 99;\n}\n.vistime-progress-bar-wrapper {\n  padding-top:5px;\n  line-height:0;\n  text-align: left;\n  margin:0;\n  padding:0;\n}\n.vistime-data-info{\n  display: inline-block;\n  float: left;\n  /*display:none*/;\n  label {\n    display: inline-block;\n    color: @brand-claro;\n    font-size: 10px;\n    position: absolute;\n    text-align: center;\n    top: 9px;\n  }\n  .vistime-data-time { display: none;}\n  .vistime-data-seconds { display: none;}\n  .vistime-data-minutes { display: block;}\n}\n\n.vistime-data-date {\n  display: block;\n  float: left;\n  font-size: 10px;\n  margin-left: 6px;\n  width:137px;\n}\n.jcarousel-skin-recentlywatched .vistime-data-date {\n  display:none;\n}\n.vistime-progress-bar {\n  background-color: #6D6D6D;\n  display: inline-block;\n  height: 3px;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n}\n.vistime-bar {\n  background-color: #ED080D;\n  height: 3px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n}\n.vistime-data-duration .vistime-data-time { display: none;}\n.vistime-data-duration .vistime-data-seconds { display: none;}\n.vistime-data-duration .vistime-data-minutes { display: block;}\n.vistime-data-duration{\n  display: inline-block;\n  color: @black;\n  float: right;\n  /*display:none;*/\n}\n\n.vistime-data-duration label {\n  display: inline-block;\n  color: @gray-light;\n  font-size: 0.8125em;\n  font-size:10px;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 9px;\n}\n.vidrierawidgetficha-html {\n  display:none;\n}\n.vistime-data-date {\n  display:none !important;\n}\n.vistime-progress-last {\n  background: none;\n  padding: 1px;\n  width: 100%;\n  left:0;\n  bottom: 0;\n  height: 25px;\n  z-index: 2;\n  .vistime-progress-bar {\n    width: 100%;\n  }\n  .vistime-data-info label {\n    top: 13px;\n  }\n  .vistime-data-duration label {\n    right: 3px;\n    top: 13px;\n  }\n}\n\n/*--- FIN VISTIME PROGRESS HISTORIAL*/\n/* FIN HISTORIAL */\n\n\n/* REDES SOCIALES */\n\n  .btn-fb {\n    background-color: @fb-color;\n    border-color: @fb-color;\n  }\n  .thumb-img-fb {\n    width: 65px;\n    height: 65px;\n    background-color: @gray6;\n  }\n  /* FIN REDES SOCIALES */\n\n  .fa-certificate {\n    color: #ea2f23;\n    float: left;\n    font-size: 77px;\n  }\n  .fa-certificate span {\n    color: @white;\n    font-size: 27px;\n    left: -43px;\n    position: relative;\n    top: -19px;\n  }\n  .app-img-descarga {\n    width: 64px;\n    height: auto !important;\n  }\n\n  /* PROMOCIONES */\n  .box-promociones {\n    margin-top: (@grid-gutter-width / 1.5);\n    .promo-icon{\n     span {\n      display: block;\n      height: 21px;\n      width: 67px;\n      color: @white;\n      font-size: 12px;\n      font-weight: bold;\n      padding: 3px 0 0 5px;\n      text-transform: uppercase;\n      }\n    }\n    .fa-certificate {\n        font-size: 40px;\n        color: @brand-claro;\n        float: left;\n      span {\n        color: @white;\n        font-size: 22px;\n        left: -25px;\n        position: relative;\n        top: -6px;\n      }\n    }\n    .fa-caret-right {\n      color: @gray-darker;\n      float: left;\n      font-size: 50px;\n      position: relative;\n      top: 6px;\n      left: -7px;\n    }\n    .fa-caret-down {\n      color: @gray-darker;\n      font-size: 50px;\n    }\n    .promo-titulos {\n      color: @brand-claro;\n    }\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    span {\n      top: 10px;\n    }\n  }\n  @media (max-width: @screen-xs-max) {\n    .fa-certificate {\n      padding-top: 0;\n      }\n    }\n  }\n  .box-promociones-open {\n    margin-bottom: (@grid-gutter-width / 3);\n    @media (min-width: @screen-md-min) {\n      img {\n        width: 160px;\n      }\n    }\n    @media (max-width: @screen-sm-max) {\n      img {\n        width: 100%;\n      }\n      h4 {\n        margin-top: 0;\n      }\n    }\n    @media (max-width: @screen-xs-max) {\n      .listado-titulos {\n      .impar {\n        background-color: @grayf4;\n        }\n      }\n    }\n    button.ver-detalles {\n      right: 0;\n      top: 0;\n    }\n    .info-promociones-open {\n      display: table;\n    }\n    .valor-desc {\n      span {\n        font-size: @font-size-base * 2;\n        font-weight: bold;\n        color: @brand-claro;\n      }\n      .cantidad-desc-titulos {\n      padding-top: 15px;\n      }\n       .titulos-disponibles {\n        color: @brand-claro;\n        @media (min-width: @screen-sm-min) {\n          padding-top: 15px;\n        }\n      }\n    }\n    .ver-mas-titulos {\n      background-color: white;\n      display: table;\n    }\n  }\n\n  /* FIN PROMOCIONES  */\n\n  @media (max-width: @screen-sm-max) {\n    .vigencia {\n      padding-left: 5px;\n    }\n    .input-padding {\n      padding-top:5px;\n    }\n    .dispositivos-asociados {\n      text-align: left;\n    }\n  }\n\n  @media (max-width: @screen-md-max) and (min-width: @screen-md-min) {\n    .padding-label-0 {\n      padding-top:0px;\n    }\n\n  }\n\n  @media (max-width: @screen-xs-max) {\n    h4 {\n      font-size: (@font-size-large * 0.85);\n    }\n    p {\n      font-size: (@font-size-large * 0.65);\n    }\n    .app-img-descarga {\n      max-width: 100%;\n    }\n    .fa-certificate{\n      color: #ea2f23;\n      float: left;\n      font-size: 56px;\n      padding-top:10px;\n    }\n    .fa-certificate span {\n      color: @white;\n      font-size: 27px;\n      left: -36px;\n      position: relative;\n      top: -12px;\n    }\n  }\n}\n\n.section-micuentacontrolpin {\n  .micuenta-title {\n    i.success {color:#5cb85c}\n  }\n}\n","// se importa este componente externo a bootstrap para WEBCLIP\n.ath-viewport * {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n\n.ath-viewport {\n\tposition: relative;\n\tz-index: 2147483641;\n\tpointer-events: none;\n\n\t-webkit-tap-highlight-color: rgba(0,0,0,0);\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-text-size-adjust: none;\n\t-moz-text-size-adjust: none;\n\t-ms-text-size-adjust: none;\n\t-o-text-size-adjust: none;\n\ttext-size-adjust: none;\n}\n\n.ath-modal {\n\tpointer-events: auto !important;\n\tbackground: rgba(0,0,0,0.6);\n}\n\n.ath-mandatory {\n\tbackground: #000;\n}\n\n.ath-container {\n\tpointer-events: auto !important;\n\tposition: absolute;\n\tz-index: 2147483641;\n\tpadding: 0.7em 0.6em;\n\twidth: 18em;\n\n\tbackground: #eee;\n\tbackground-size: 100% auto;\n\n\tbox-shadow: 0 0.2em 0 #d1d1d1;\n\n\tfont-family: Roboto;\n\tfont-size: 15px;\n\tline-height: 1.5em;\n\ttext-align: center;\n}\n\n.ath-ios.ath-phone {\n\tbottom: 1.8em;\n\tleft: 50%;\n\tmargin-left: -9em;\n}\n\n.ath-ios7.ath-tablet {\n\tleft: 0.7em;\n\ttop: 1.8em;\n}\n\n.ath-ios6.ath-tablet {\n\tleft: 5em;\n\ttop: 1.8em;\n}\n\n.ath-android {\n\tright: 1.5em;\n\ttop: 1.8em;\n}\n\n/* close icon */\n.ath-container:before {\n\tcontent: '';\n\tposition: relative;\n\tdisplay: block;\n\tfloat: right;\n\tmargin: -0.7em -0.6em 0 0.5em;\n\tbackground-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAMAAABmmnOVAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAeHAAAHhwFd+hRDAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAHVQTFRFAAAAOTk5MzMzOzs7Nzc3QUFBQEBAPz8/Pj4+QUFBQEBAPz8/Pj4+QUFBQEBAPz8/QUFBPj4+Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pj4+Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/Pz8/Pj4+Pz8/Pz8/Pz8/Pz8/QEBAPz8/n3QmjwAAACZ0Uk5TAAkKDQ4zODk6OzxBQkNERUusrbG0tba7vL3Excbu8fL19fb3+PgucqJgAAACqklEQVR42sXc23LCIBAGYKy2pgft0WpP2vTA+z9i0+goCZAs7O7P3oWZTL5ZYAh7sca0MXmYG3jM7yfu4/TV1jdow01tX6cdg4UrGoN1FNM3a+GK1nBSzPYGrOJgsPZt1hrerYUrjoa9wjHgFI7B2veZWVk3tpCdWm07H30y8+4AIhedPFj7cW7wioABrggawIqIAaroGbYXzlGCUvQNnc0IUgwaQIoRA0QxagAoCAZ1BcmgrCAaVBVkg6IiwaCmSDIoKRINKopkg4IiwyCuyDIIKzINoopsg6CCYRBTsAxCCqZBRLGo2RcrtkLAwFaIGJgKIQNLIWZgKAQN2QpRg1dKoCmEDVkKcUOGQsGQrFAxJCqUDEkKNUOCQtFAVqgaiAplg69YFDAQFADDqAJiGFGADI1iF1XADAOKvqHSLApHFFBDRAE2BBVwQ0BRwOApfn8LGDxFEcOQAmeIK5CGmAJrCCvQBq8A8r9Zrw08qp6irvAGs/zpIr4XBQxf3nQsyhvwipABrQgbsIqYAamIG3CKnqH+LKDoGXbVwD84zDB4E4AZ4IqgAayIGKCKqMGYS5RiwOArlgUMnuJrWcAAUYwaAAqCQV1BMigriAZVBdmgqEgwqCmSDEqKRIOKItmgoMgwiCv6hkvaa6KKTIOoItsgqGAYxBQsg5CCaRBRsA0CCgEDWyFiYCqEDCyFmIGhEDRkK0QNmQphQ5ZC3JChUDAkK1QMiQolQ5JCzZCguNUzkBV3P4oGokLZQFKoGwgKgGFUATGMKECGQQXMYMxVTAE0RBVQQ0QBNgQVcENI8QwoBo8cUiszWYPz4OVi3bQ9cBQoQ0exblsvTDZwg6PYHNo/tE0XmvVwa4BxWBentgtnL+A8HHPxcnYaaBRoQ6twDY3iEW5oFI8Hwx/QxSE448b+MwAAAABJRU5ErkJggg==);\n\tbackground-color: rgba(255,255,255,0.8);\n\tbackground-size: 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50%;\n\twidth: 2.7em;\n\theight: 2.7em;\n\ttext-align: center;\n\toverflow: hidden;\n\tcolor: #a33;\n\tz-index: 2147483642;\n}\n\n.ath-container.ath-icon:before {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tmargin: 0;\n\tfloat: none;\n}\n\n.ath-mandatory .ath-container:before {\n\tdisplay: none;\n}\n\n.ath-container.ath-android:before {\n\tfloat: left;\n\tmargin: -0.7em 0.5em 0 -0.6em;\n}\n\n.ath-container.ath-android.ath-icon:before {\n\tposition: absolute;\n\tright: auto;\n\tleft: 0;\n\tmargin: 0;\n\tfloat: none;\n}\n\n\n/* applied only if the application icon is shown */\n.ath-container.ath-icon {\n\n}\n\n.ath-action-icon {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tbackground-position: 50%;\n\tbackground-repeat: no-repeat;\n\ttext-indent: -9999em;\n\toverflow: hidden;\n}\n\n.ath-android .ath-action-icon {\n\twidth: 1.2em;\n\theight: 1.8em;\n\tbackground-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAADcBAMAAAAig/QJAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAFtDAABbQwH5xg68AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAB5QTFRFAAAA////cXFxaWlp////ZmZmnJycoaGhpqam////1D9b6wAAAAV0Uk5TAAgJERExZxYzAAAAYklEQVRYw+3WoQ2AUBAE0SsBOiBUQEIDCArA4FFoHBaJxNItFYz/x5+xz282VmwJTdM0rRzbsS1e7Pm9zdgUVn491rkFmqZpSezEjqo/Sos1HoAEjdjgFmiapiWxG7tq/igfnYteFlnOWZEAAAAASUVORK5CYII=);\n\tbackground-size: auto 100%;\n}\n\n.ath-ios7 .ath-action-icon {\n\twidth: 1.6em;\n\theight: 1.6em;\n\tbackground-image:url(data:image/png;base64,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);\n\tmargin-top: -0.3em;\n\tbackground-size: auto 100%;\n}\n\n.ath-ios6 .ath-action-icon {\n\twidth: 1.8em;\n\theight: 1.8em;\n\tbackground-image:url(data:image/png;base64,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);\n\tmargin-bottom: 0.4em;\n\tbackground-size: 100% auto;\n}\n\n.ath-container p {\n\tmargin: 0;\n\tpadding: 0;\n\tposition: relative;\n\tz-index: 2147483642;\n\ttext-shadow: 0 0.1em 0 #fff;\n\tfont-size: 1.1em;\n}\n\n.ath-ios.ath-phone:after {\n\tcontent: '';\n\tbackground: #eee;\n\tposition: absolute;\n\twidth: 2em;\n\theight: 2em;\n\tbottom: -0.9em;\n\tleft: 50%;\n\tmargin-left: -1em;\n\t-webkit-transform: scaleX(0.9) rotate(45deg);\n\ttransform: scaleX(0.9) rotate(45deg);\n\tbox-shadow: 0.2em 0.2em 0 #d1d1d1;\n}\n\n.ath-ios.ath-tablet:after {\n\tcontent: '';\n\tbackground: #eee;\n\tposition: absolute;\n\twidth: 2em;\n\theight: 2em;\n\ttop: -0.9em;\n\tleft: 50%;\n\tmargin-left: -1em;\n\t-webkit-transform: scaleX(0.9) rotate(45deg);\n\ttransform: scaleX(0.9) rotate(45deg);\n\tz-index: 2147483641;\n}\n\n.ath-android:after {\n\tcontent: '';\n\tbackground: #eee;\n\tbackground: -webkit-linear-gradient(-45deg, rgba(238,238,238,0) 0%,rgba(238,238,238,0) 50%,rgba(238,238,238,1) 50%,rgba(238,238,238,1) 100%);\n\tposition: absolute;\n\twidth: 2em;\n\theight: 2em;\n\ttop: -1.5em;\n\tright: 0;\n}\n\n.ath-application-icon {\n\tposition: relative;\n\tpadding: 0;\n\tborder: 0;\n\tmargin: 0 auto 0.2em auto;\n\theight: 6em;\n\twidth: 6em;\n\tz-index: 2147483642;\n\tbox-shadow: 0 0.2em 0.4em rgba(0,0,0,0.3),\n\t\tinset 0 0.07em 0 rgba(255,255,255,0.5);\n}\n\n/* OS specific classes */\n.ath-container.ath-ios .ath-application-icon{\n\tborder-radius: 1em;\n\tbox-shadow: 0 0.2em 0.4em rgba(0,0,0,0.3),\n\t\tinset 0 0.07em 0 rgba(255,255,255,0.5);\n\tmargin: 0 auto 0.4em auto;\n}\n\n@media only screen and (orientation: landscape) {\n\t.ath-container.ath-phone {\n\t\twidth: 24em;\n\t}\n\n\t.ath-ios.ath-phone {\n\t\tmargin-left: -12em;\n\t}\n\n\t.ath-ios6:after {\n\t\tleft: 39%;\n\t}\n}\n","/* FONT PATH\n * -------------------------- */\n\n@font-face {\n  font-family: FontAwesome;\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?v=@{fa-version}');\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?#iefix&v=@{fa-version}') format('embedded-opentype'),\n    url('@{fa-font-path}/fontawesome-webfont.woff?v=@{fa-version}') format('woff'),\n    url('@{fa-font-path}/fontawesome-webfont.ttf?v=@{fa-version}') format('truetype'),\n    url('@{fa-font-path}/fontawesome-webfont.svg?v=@{fa-version}#fontawesomeregular') format('svg');\n//  src: url('@{fa-font-path}/FontAwesome.otf') format('opentype'); // used when developing fonts\n  font-weight: normal;\n  font-style: normal;\n}","// Base Class Definition\n// -------------------------\n\n.@{fa-css-prefix} {\n  display: inline-block;\n  font-family: FontAwesome;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n","// Icon Sizes\n// -------------------------\n\n/* makes the font 33% larger relative to the icon container */\n.@{fa-css-prefix}-lg {\n  font-size: (4em / 3);\n  line-height: (3em / 4);\n  vertical-align: -15%;\n}\n.@{fa-css-prefix}-2x { font-size: 2em; }\n.@{fa-css-prefix}-3x { font-size: 3em; }\n.@{fa-css-prefix}-4x { font-size: 4em; }\n.@{fa-css-prefix}-5x { font-size: 5em; }\n","// Fixed Width Icons\n// -------------------------\n.@{fa-css-prefix}-fw {\n  width: (18em / 14);\n  text-align: center;\n}\n","// List Icons\n// -------------------------\n\n.@{fa-css-prefix}-ul {\n  padding-left: 0;\n  margin-left: @fa-li-width;\n  list-style-type: none;\n  > li { position: relative; }\n}\n.@{fa-css-prefix}-li {\n  position: absolute;\n  left: -@fa-li-width;\n  width: @fa-li-width;\n  top: (2em / 14);\n  text-align: center;\n  &.@{fa-css-prefix}-lg {\n    left: -@fa-li-width + (4em / 14);\n  }\n}\n","// Spinning Icons\n// --------------------------\n\n.@{fa-css-prefix}-spin {\n  -webkit-animation: spin 2s infinite linear;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n\n@-moz-keyframes spin {\n  0% { -moz-transform: rotate(0deg); }\n  100% { -moz-transform: rotate(359deg); }\n}\n@-webkit-keyframes spin {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(359deg); }\n}\n@-o-keyframes spin {\n  0% { -o-transform: rotate(0deg); }\n  100% { -o-transform: rotate(359deg); }\n}\n@-ms-keyframes spin {\n  0% { -ms-transform: rotate(0deg); }\n  100% { -ms-transform: rotate(359deg); }\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(359deg); }\n}\n","// Rotated & Flipped Icons\n// -------------------------\n\n.@{fa-css-prefix}-rotate-90  { .fa-icon-rotate(90deg, 1);  }\n.@{fa-css-prefix}-rotate-180 { .fa-icon-rotate(180deg, 2); }\n.@{fa-css-prefix}-rotate-270 { .fa-icon-rotate(270deg, 3); }\n\n.@{fa-css-prefix}-flip-horizontal { .fa-icon-flip(-1, 1, 0); }\n.@{fa-css-prefix}-flip-vertical   { .fa-icon-flip(1, -1, 2); }\n","// Mixins\n// --------------------------\n\n.fa-icon-rotate(@degrees, @rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=@rotation);\n  -webkit-transform: rotate(@degrees);\n     -moz-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees);\n       -o-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n\n.fa-icon-flip(@horiz, @vert, @rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=@rotation, mirror=1);\n  -webkit-transform: scale(@horiz, @vert);\n     -moz-transform: scale(@horiz, @vert);\n      -ms-transform: scale(@horiz, @vert);\n       -o-transform: scale(@horiz, @vert);\n          transform: scale(@horiz, @vert);\n}\n","// Stacked Icons\n// -------------------------\n\n.@{fa-css-prefix}-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.@{fa-css-prefix}-stack-1x, .@{fa-css-prefix}-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.@{fa-css-prefix}-stack-1x { line-height: inherit; }\n.@{fa-css-prefix}-stack-2x { font-size: 2em; }\n.@{fa-css-prefix}-inverse { color: @fa-inverse; }\n","/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n\n.@{fa-css-prefix}-glass:before { content: @fa-var-glass; }\n.@{fa-css-prefix}-music:before { content: @fa-var-music; }\n.@{fa-css-prefix}-search:before { content: @fa-var-search; }\n.@{fa-css-prefix}-envelope-o:before { content: @fa-var-envelope-o; }\n.@{fa-css-prefix}-hashtag:before { content: @fa-var-hashtag; }\n.@{fa-css-prefix}-heart:before { content: @fa-var-heart; }\n.@{fa-css-prefix}-star:before { content: @fa-var-star; }\n.@{fa-css-prefix}-star-o:before { content: @fa-var-star-o; }\n.@{fa-css-prefix}-user:before { content: @fa-var-user; }\n.@{fa-css-prefix}-user-o:before { content: @fa-var-user-o; }\n.@{fa-css-prefix}-film:before { content: @fa-var-film; }\n.@{fa-css-prefix}-th-large:before { content: @fa-var-th-large; }\n.@{fa-css-prefix}-th:before { content: @fa-var-th; }\n.@{fa-css-prefix}-th-list:before { content: @fa-var-th-list; }\n.@{fa-css-prefix}-check:before { content: @fa-var-check; }\n.@{fa-css-prefix}-times:before { content: @fa-var-times; }\n.@{fa-css-prefix}-search-plus:before { content: @fa-var-search-plus; }\n.@{fa-css-prefix}-search-minus:before { content: @fa-var-search-minus; }\n.@{fa-css-prefix}-power-off:before { content: @fa-var-power-off; }\n.@{fa-css-prefix}-signal:before { content: @fa-var-signal; }\n.@{fa-css-prefix}-gear:before,\n.@{fa-css-prefix}-cog:before { content: @fa-var-cog; }\n.@{fa-css-prefix}-trash-o:before { content: @fa-var-trash-o; }\n.@{fa-css-prefix}-home:before { content: @fa-var-home; }\n.@{fa-css-prefix}-file-o:before { content: @fa-var-file-o; }\n.@{fa-css-prefix}-clock-o:before { content: @fa-var-clock-o; }\n.@{fa-css-prefix}-road:before { content: @fa-var-road; }\n.@{fa-css-prefix}-download:before { content: @fa-var-download; }\n.@{fa-css-prefix}-arrow-circle-o-down:before { content: @fa-var-arrow-circle-o-down; }\n.@{fa-css-prefix}-arrow-circle-o-up:before { content: @fa-var-arrow-circle-o-up; }\n.@{fa-css-prefix}-inbox:before { content: @fa-var-inbox; }\n.@{fa-css-prefix}-play-circle-o:before { content: @fa-var-play-circle-o; }\n.@{fa-css-prefix}-rotate-right:before,\n.@{fa-css-prefix}-repeat:before { content: @fa-var-repeat; }\n.@{fa-css-prefix}-refresh:before { content: @fa-var-refresh; }\n.@{fa-css-prefix}-list-alt:before { content: @fa-var-list-alt; }\n.@{fa-css-prefix}-lock:before { content: @fa-var-lock; }\n.@{fa-css-prefix}-flag:before { content: @fa-var-flag; }\n.@{fa-css-prefix}-headphones:before { content: @fa-var-headphones; }\n.@{fa-css-prefix}-volume-off:before { content: @fa-var-volume-off; }\n.@{fa-css-prefix}-volume-down:before { content: @fa-var-volume-down; }\n.@{fa-css-prefix}-volume-up:before { content: @fa-var-volume-up; }\n.@{fa-css-prefix}-qrcode:before { content: @fa-var-qrcode; }\n.@{fa-css-prefix}-barcode:before { content: @fa-var-barcode; }\n.@{fa-css-prefix}-tag:before { content: @fa-var-tag; }\n.@{fa-css-prefix}-tags:before { content: @fa-var-tags; }\n.@{fa-css-prefix}-book:before { content: @fa-var-book; }\n.@{fa-css-prefix}-bookmark:before { content: @fa-var-bookmark; }\n.@{fa-css-prefix}-print:before { content: @fa-var-print; }\n.@{fa-css-prefix}-camera:before { content: @fa-var-camera; }\n.@{fa-css-prefix}-font:before { content: @fa-var-font; }\n.@{fa-css-prefix}-bold:before { content: @fa-var-bold; }\n.@{fa-css-prefix}-italic:before { content: @fa-var-italic; }\n.@{fa-css-prefix}-text-height:before { content: @fa-var-text-height; }\n.@{fa-css-prefix}-text-width:before { content: @fa-var-text-width; }\n.@{fa-css-prefix}-align-left:before { content: @fa-var-align-left; }\n.@{fa-css-prefix}-align-center:before { content: @fa-var-align-center; }\n.@{fa-css-prefix}-align-right:before { content: @fa-var-align-right; }\n.@{fa-css-prefix}-align-justify:before { content: @fa-var-align-justify; }\n.@{fa-css-prefix}-list:before { content: @fa-var-list; }\n.@{fa-css-prefix}-dedent:before,\n.@{fa-css-prefix}-outdent:before { content: @fa-var-outdent; }\n.@{fa-css-prefix}-indent:before { content: @fa-var-indent; }\n.@{fa-css-prefix}-video-camera:before { content: @fa-var-video-camera; }\n.@{fa-css-prefix}-picture-o:before { content: @fa-var-picture-o; }\n.@{fa-css-prefix}-pencil:before { content: @fa-var-pencil; }\n.@{fa-css-prefix}-map-marker:before { content: @fa-var-map-marker; }\n.@{fa-css-prefix}-adjust:before { content: @fa-var-adjust; }\n.@{fa-css-prefix}-tint:before { content: @fa-var-tint; }\n.@{fa-css-prefix}-edit:before,\n.@{fa-css-prefix}-pencil-square-o:before { content: @fa-var-pencil-square-o; }\n.@{fa-css-prefix}-share-square-o:before { content: @fa-var-share-square-o; }\n.@{fa-css-prefix}-check-square-o:before { content: @fa-var-check-square-o; }\n.@{fa-css-prefix}-arrows:before { content: @fa-var-arrows; }\n.@{fa-css-prefix}-step-backward:before { content: @fa-var-step-backward; }\n.@{fa-css-prefix}-fast-backward:before { content: @fa-var-fast-backward; }\n.@{fa-css-prefix}-backward:before { content: @fa-var-backward; }\n.@{fa-css-prefix}-play:before { content: @fa-var-play; }\n.@{fa-css-prefix}-pause:before { content: @fa-var-pause; }\n.@{fa-css-prefix}-stop:before { content: @fa-var-stop; }\n.@{fa-css-prefix}-forward:before { content: @fa-var-forward; }\n.@{fa-css-prefix}-fast-forward:before { content: @fa-var-fast-forward; }\n.@{fa-css-prefix}-step-forward:before { content: @fa-var-step-forward; }\n.@{fa-css-prefix}-eject:before { content: @fa-var-eject; }\n.@{fa-css-prefix}-chevron-left:before { content: @fa-var-chevron-left; }\n.@{fa-css-prefix}-chevron-right:before { content: @fa-var-chevron-right; }\n.@{fa-css-prefix}-plus-circle:before { content: @fa-var-plus-circle; }\n.@{fa-css-prefix}-minus-circle:before { content: @fa-var-minus-circle; }\n.@{fa-css-prefix}-times-circle:before { content: @fa-var-times-circle; }\n.@{fa-css-prefix}-check-circle:before { content: @fa-var-check-circle; }\n.@{fa-css-prefix}-question-circle:before { content: @fa-var-question-circle; }\n.@{fa-css-prefix}-info-circle:before { content: @fa-var-info-circle; }\n.@{fa-css-prefix}-crosshairs:before { content: @fa-var-crosshairs; }\n.@{fa-css-prefix}-times-circle-o:before { content: @fa-var-times-circle-o; }\n.@{fa-css-prefix}-check-circle-o:before { content: @fa-var-check-circle-o; }\n.@{fa-css-prefix}-ban:before { content: @fa-var-ban; }\n.@{fa-css-prefix}-arrow-left:before { content: @fa-var-arrow-left; }\n.@{fa-css-prefix}-arrow-right:before { content: @fa-var-arrow-right; }\n.@{fa-css-prefix}-arrow-up:before { content: @fa-var-arrow-up; }\n.@{fa-css-prefix}-arrow-down:before { content: @fa-var-arrow-down; }\n.@{fa-css-prefix}-mail-forward:before,\n.@{fa-css-prefix}-share:before { content: @fa-var-share; }\n.@{fa-css-prefix}-expand:before { content: @fa-var-expand; }\n.@{fa-css-prefix}-compress:before { content: @fa-var-compress; }\n.@{fa-css-prefix}-plus:before { content: @fa-var-plus; }\n.@{fa-css-prefix}-minus:before { content: @fa-var-minus; }\n.@{fa-css-prefix}-asterisk:before { content: @fa-var-asterisk; }\n.@{fa-css-prefix}-exclamation-circle:before { content: @fa-var-exclamation-circle; }\n.@{fa-css-prefix}-gift:before { content: @fa-var-gift; }\n.@{fa-css-prefix}-leaf:before { content: @fa-var-leaf; }\n.@{fa-css-prefix}-fire:before { content: @fa-var-fire; }\n.@{fa-css-prefix}-eye:before { content: @fa-var-eye; }\n.@{fa-css-prefix}-eye-slash:before { content: @fa-var-eye-slash; }\n.@{fa-css-prefix}-warning:before,\n.@{fa-css-prefix}-exclamation-triangle:before { content: @fa-var-exclamation-triangle; }\n.@{fa-css-prefix}-plane:before { content: @fa-var-plane; }\n.@{fa-css-prefix}-calendar:before { content: @fa-var-calendar; }\n.@{fa-css-prefix}-random:before { content: @fa-var-random; }\n.@{fa-css-prefix}-comment:before { content: @fa-var-comment; }\n.@{fa-css-prefix}-magnet:before { content: @fa-var-magnet; }\n.@{fa-css-prefix}-chevron-up:before { content: @fa-var-chevron-up; }\n.@{fa-css-prefix}-chevron-down:before { content: @fa-var-chevron-down; }\n.@{fa-css-prefix}-retweet:before { content: @fa-var-retweet; }\n.@{fa-css-prefix}-shopping-cart:before { content: @fa-var-shopping-cart; }\n.@{fa-css-prefix}-folder:before { content: @fa-var-folder; }\n.@{fa-css-prefix}-folder-open:before { content: @fa-var-folder-open; }\n.@{fa-css-prefix}-arrows-v:before { content: @fa-var-arrows-v; }\n.@{fa-css-prefix}-arrows-h:before { content: @fa-var-arrows-h; }\n.@{fa-css-prefix}-bar-chart-o:before { content: @fa-var-bar-chart-o; }\n.@{fa-css-prefix}-twitter-square:before { content: @fa-var-twitter-square; }\n.@{fa-css-prefix}-facebook-square:before { content: @fa-var-facebook-square; }\n.@{fa-css-prefix}-facebook-official:before { content: @fa-var-facebook-official; }\n.@{fa-css-prefix}-camera-retro:before { content: @fa-var-camera-retro; }\n.@{fa-css-prefix}-key:before { content: @fa-var-key; }\n.@{fa-css-prefix}-gears:before,\n.@{fa-css-prefix}-cogs:before { content: @fa-var-cogs; }\n.@{fa-css-prefix}-comments:before { content: @fa-var-comments; }\n.@{fa-css-prefix}-thumbs-o-up:before { content: @fa-var-thumbs-o-up; }\n.@{fa-css-prefix}-thumbs-o-down:before { content: @fa-var-thumbs-o-down; }\n.@{fa-css-prefix}-star-half:before { content: @fa-var-star-half; }\n.@{fa-css-prefix}-heart-o:before { content: @fa-var-heart-o; }\n.@{fa-css-prefix}-sign-out:before { content: @fa-var-sign-out; }\n.@{fa-css-prefix}-linkedin-square:before { content: @fa-var-linkedin-square; }\n.@{fa-css-prefix}-thumb-tack:before { content: @fa-var-thumb-tack; }\n.@{fa-css-prefix}-external-link:before { content: @fa-var-external-link; }\n.@{fa-css-prefix}-sign-in:before { content: @fa-var-sign-in; }\n.@{fa-css-prefix}-trophy:before { content: @fa-var-trophy; }\n.@{fa-css-prefix}-github-square:before { content: @fa-var-github-square; }\n.@{fa-css-prefix}-upload:before { content: @fa-var-upload; }\n.@{fa-css-prefix}-lemon-o:before { content: @fa-var-lemon-o; }\n.@{fa-css-prefix}-phone:before { content: @fa-var-phone; }\n.@{fa-css-prefix}-square-o:before { content: @fa-var-square-o; }\n.@{fa-css-prefix}-bookmark-o:before { content: @fa-var-bookmark-o; }\n.@{fa-css-prefix}-phone-square:before { content: @fa-var-phone-square; }\n.@{fa-css-prefix}-twitter:before { content: @fa-var-twitter; }\n.@{fa-css-prefix}-facebook:before { content: @fa-var-facebook; }\n.@{fa-css-prefix}-github:before { content: @fa-var-github; }\n.@{fa-css-prefix}-unlock:before { content: @fa-var-unlock; }\n.@{fa-css-prefix}-credit-card:before { content: @fa-var-credit-card; }\n.@{fa-css-prefix}-rss:before { content: @fa-var-rss; }\n.@{fa-css-prefix}-hdd-o:before { content: @fa-var-hdd-o; }\n.@{fa-css-prefix}-bullhorn:before { content: @fa-var-bullhorn; }\n.@{fa-css-prefix}-bell:before { content: @fa-var-bell; }\n.@{fa-css-prefix}-certificate:before { content: @fa-var-certificate; }\n.@{fa-css-prefix}-hand-o-right:before { content: @fa-var-hand-o-right; }\n.@{fa-css-prefix}-hand-o-left:before { content: @fa-var-hand-o-left; }\n.@{fa-css-prefix}-hand-o-up:before { content: @fa-var-hand-o-up; }\n.@{fa-css-prefix}-hand-o-down:before { content: @fa-var-hand-o-down; }\n.@{fa-css-prefix}-arrow-circle-left:before { content: @fa-var-arrow-circle-left; }\n.@{fa-css-prefix}-arrow-circle-right:before { content: @fa-var-arrow-circle-right; }\n.@{fa-css-prefix}-arrow-circle-up:before { content: @fa-var-arrow-circle-up; }\n.@{fa-css-prefix}-arrow-circle-down:before { content: @fa-var-arrow-circle-down; }\n.@{fa-css-prefix}-globe:before { content: @fa-var-globe; }\n.@{fa-css-prefix}-wrench:before { content: @fa-var-wrench; }\n.@{fa-css-prefix}-tasks:before { content: @fa-var-tasks; }\n.@{fa-css-prefix}-filter:before { content: @fa-var-filter; }\n.@{fa-css-prefix}-briefcase:before { content: @fa-var-briefcase; }\n.@{fa-css-prefix}-arrows-alt:before { content: @fa-var-arrows-alt; }\n.@{fa-css-prefix}-group:before,\n.@{fa-css-prefix}-users:before { content: @fa-var-users; }\n.@{fa-css-prefix}-chain:before,\n.@{fa-css-prefix}-link:before { content: @fa-var-link; }\n.@{fa-css-prefix}-cloud:before { content: @fa-var-cloud; }\n.@{fa-css-prefix}-flask:before { content: @fa-var-flask; }\n.@{fa-css-prefix}-cut:before,\n.@{fa-css-prefix}-scissors:before { content: @fa-var-scissors; }\n.@{fa-css-prefix}-copy:before,\n.@{fa-css-prefix}-files-o:before { content: @fa-var-files-o; }\n.@{fa-css-prefix}-paperclip:before { content: @fa-var-paperclip; }\n.@{fa-css-prefix}-save:before,\n.@{fa-css-prefix}-floppy-o:before { content: @fa-var-floppy-o; }\n.@{fa-css-prefix}-square:before { content: @fa-var-square; }\n.@{fa-css-prefix}-bars:before { content: @fa-var-bars; }\n.@{fa-css-prefix}-list-ul:before { content: @fa-var-list-ul; }\n.@{fa-css-prefix}-list-ol:before { content: @fa-var-list-ol; }\n.@{fa-css-prefix}-strikethrough:before { content: @fa-var-strikethrough; }\n.@{fa-css-prefix}-underline:before { content: @fa-var-underline; }\n.@{fa-css-prefix}-table:before { content: @fa-var-table; }\n.@{fa-css-prefix}-magic:before { content: @fa-var-magic; }\n.@{fa-css-prefix}-truck:before { content: @fa-var-truck; }\n.@{fa-css-prefix}-pinterest:before { content: @fa-var-pinterest; }\n.@{fa-css-prefix}-pinterest-square:before { content: @fa-var-pinterest-square; }\n.@{fa-css-prefix}-google-plus-square:before { content: @fa-var-google-plus-square; }\n.@{fa-css-prefix}-google-plus:before { content: @fa-var-google-plus; }\n.@{fa-css-prefix}-money:before { content: @fa-var-money; }\n.@{fa-css-prefix}-caret-down:before { content: @fa-var-caret-down; }\n.@{fa-css-prefix}-caret-up:before { content: @fa-var-caret-up; }\n.@{fa-css-prefix}-caret-left:before { content: @fa-var-caret-left; }\n.@{fa-css-prefix}-caret-right:before { content: @fa-var-caret-right; }\n.@{fa-css-prefix}-columns:before { content: @fa-var-columns; }\n.@{fa-css-prefix}-unsorted:before,\n.@{fa-css-prefix}-sort:before { content: @fa-var-sort; }\n.@{fa-css-prefix}-sort-down:before,\n.@{fa-css-prefix}-sort-asc:before { content: @fa-var-sort-asc; }\n.@{fa-css-prefix}-sort-up:before,\n.@{fa-css-prefix}-sort-desc:before { content: @fa-var-sort-desc; }\n.@{fa-css-prefix}-envelope:before { content: @fa-var-envelope; }\n.@{fa-css-prefix}-linkedin:before { content: @fa-var-linkedin; }\n.@{fa-css-prefix}-rotate-left:before,\n.@{fa-css-prefix}-undo:before { content: @fa-var-undo; }\n.@{fa-css-prefix}-legal:before,\n.@{fa-css-prefix}-gavel:before { content: @fa-var-gavel; }\n.@{fa-css-prefix}-dashboard:before,\n.@{fa-css-prefix}-tachometer:before { content: @fa-var-tachometer; }\n.@{fa-css-prefix}-comment-o:before { content: @fa-var-comment-o; }\n.@{fa-css-prefix}-comments-o:before { content: @fa-var-comments-o; }\n.@{fa-css-prefix}-flash:before,\n.@{fa-css-prefix}-bolt:before { content: @fa-var-bolt; }\n.@{fa-css-prefix}-sitemap:before { content: @fa-var-sitemap; }\n.@{fa-css-prefix}-umbrella:before { content: @fa-var-umbrella; }\n.@{fa-css-prefix}-paste:before,\n.@{fa-css-prefix}-clipboard:before { content: @fa-var-clipboard; }\n.@{fa-css-prefix}-lightbulb-o:before { content: @fa-var-lightbulb-o; }\n.@{fa-css-prefix}-exchange:before { content: @fa-var-exchange; }\n.@{fa-css-prefix}-cloud-download:before { content: @fa-var-cloud-download; }\n.@{fa-css-prefix}-cloud-upload:before { content: @fa-var-cloud-upload; }\n.@{fa-css-prefix}-user-md:before { content: @fa-var-user-md; }\n.@{fa-css-prefix}-stethoscope:before { content: @fa-var-stethoscope; }\n.@{fa-css-prefix}-suitcase:before { content: @fa-var-suitcase; }\n.@{fa-css-prefix}-bell-o:before { content: @fa-var-bell-o; }\n.@{fa-css-prefix}-coffee:before { content: @fa-var-coffee; }\n.@{fa-css-prefix}-cutlery:before { content: @fa-var-cutlery; }\n.@{fa-css-prefix}-file-text-o:before { content: @fa-var-file-text-o; }\n.@{fa-css-prefix}-building-o:before { content: @fa-var-building-o; }\n.@{fa-css-prefix}-hospital-o:before { content: @fa-var-hospital-o; }\n.@{fa-css-prefix}-ambulance:before { content: @fa-var-ambulance; }\n.@{fa-css-prefix}-medkit:before { content: @fa-var-medkit; }\n.@{fa-css-prefix}-fighter-jet:before { content: @fa-var-fighter-jet; }\n.@{fa-css-prefix}-beer:before { content: @fa-var-beer; }\n.@{fa-css-prefix}-h-square:before { content: @fa-var-h-square; }\n.@{fa-css-prefix}-plus-square:before { content: @fa-var-plus-square; }\n.@{fa-css-prefix}-angle-double-left:before { content: @fa-var-angle-double-left; }\n.@{fa-css-prefix}-angle-double-right:before { content: @fa-var-angle-double-right; }\n.@{fa-css-prefix}-angle-double-up:before { content: @fa-var-angle-double-up; }\n.@{fa-css-prefix}-angle-double-down:before { content: @fa-var-angle-double-down; }\n.@{fa-css-prefix}-angle-left:before { content: @fa-var-angle-left; }\n.@{fa-css-prefix}-angle-right:before { content: @fa-var-angle-right; }\n.@{fa-css-prefix}-angle-up:before { content: @fa-var-angle-up; }\n.@{fa-css-prefix}-angle-down:before { content: @fa-var-angle-down; }\n.@{fa-css-prefix}-desktop:before { content: @fa-var-desktop; }\n.@{fa-css-prefix}-laptop:before { content: @fa-var-laptop; }\n.@{fa-css-prefix}-tablet:before { content: @fa-var-tablet; }\n.@{fa-css-prefix}-mobile-phone:before,\n.@{fa-css-prefix}-mobile:before { content: @fa-var-mobile; }\n.@{fa-css-prefix}-circle-o:before { content: @fa-var-circle-o; }\n.@{fa-css-prefix}-quote-left:before { content: @fa-var-quote-left; }\n.@{fa-css-prefix}-quote-right:before { content: @fa-var-quote-right; }\n.@{fa-css-prefix}-spinner:before { content: @fa-var-spinner; }\n.@{fa-css-prefix}-circle:before { content: @fa-var-circle; }\n.@{fa-css-prefix}-mail-reply:before,\n.@{fa-css-prefix}-reply:before { content: @fa-var-reply; }\n.@{fa-css-prefix}-github-alt:before { content: @fa-var-github-alt; }\n.@{fa-css-prefix}-folder-o:before { content: @fa-var-folder-o; }\n.@{fa-css-prefix}-folder-open-o:before { content: @fa-var-folder-open-o; }\n.@{fa-css-prefix}-smile-o:before { content: @fa-var-smile-o; }\n.@{fa-css-prefix}-frown-o:before { content: @fa-var-frown-o; }\n.@{fa-css-prefix}-meh-o:before { content: @fa-var-meh-o; }\n.@{fa-css-prefix}-gamepad:before { content: @fa-var-gamepad; }\n.@{fa-css-prefix}-keyboard-o:before { content: @fa-var-keyboard-o; }\n.@{fa-css-prefix}-flag-o:before { content: @fa-var-flag-o; }\n.@{fa-css-prefix}-flag-checkered:before { content: @fa-var-flag-checkered; }\n.@{fa-css-prefix}-terminal:before { content: @fa-var-terminal; }\n.@{fa-css-prefix}-code:before { content: @fa-var-code; }\n.@{fa-css-prefix}-reply-all:before { content: @fa-var-reply-all; }\n.@{fa-css-prefix}-mail-reply-all:before { content: @fa-var-mail-reply-all; }\n.@{fa-css-prefix}-star-half-empty:before,\n.@{fa-css-prefix}-star-half-full:before,\n.@{fa-css-prefix}-star-half-o:before { content: @fa-var-star-half-o; }\n.@{fa-css-prefix}-location-arrow:before { content: @fa-var-location-arrow; }\n.@{fa-css-prefix}-crop:before { content: @fa-var-crop; }\n.@{fa-css-prefix}-code-fork:before { content: @fa-var-code-fork; }\n.@{fa-css-prefix}-unlink:before,\n.@{fa-css-prefix}-chain-broken:before { content: @fa-var-chain-broken; }\n.@{fa-css-prefix}-question:before { content: @fa-var-question; }\n.@{fa-css-prefix}-info:before { content: @fa-var-info; }\n.@{fa-css-prefix}-exclamation:before { content: @fa-var-exclamation; }\n.@{fa-css-prefix}-superscript:before { content: @fa-var-superscript; }\n.@{fa-css-prefix}-subscript:before { content: @fa-var-subscript; }\n.@{fa-css-prefix}-eraser:before { content: @fa-var-eraser; }\n.@{fa-css-prefix}-puzzle-piece:before { content: @fa-var-puzzle-piece; }\n.@{fa-css-prefix}-microphone:before { content: @fa-var-microphone; }\n.@{fa-css-prefix}-microphone-slash:before { content: @fa-var-microphone-slash; }\n.@{fa-css-prefix}-shield:before { content: @fa-var-shield; }\n.@{fa-css-prefix}-calendar-o:before { content: @fa-var-calendar-o; }\n.@{fa-css-prefix}-fire-extinguisher:before { content: @fa-var-fire-extinguisher; }\n.@{fa-css-prefix}-rocket:before { content: @fa-var-rocket; }\n.@{fa-css-prefix}-maxcdn:before { content: @fa-var-maxcdn; }\n.@{fa-css-prefix}-chevron-circle-left:before { content: @fa-var-chevron-circle-left; }\n.@{fa-css-prefix}-chevron-circle-right:before { content: @fa-var-chevron-circle-right; }\n.@{fa-css-prefix}-chevron-circle-up:before { content: @fa-var-chevron-circle-up; }\n.@{fa-css-prefix}-chevron-circle-down:before { content: @fa-var-chevron-circle-down; }\n.@{fa-css-prefix}-html5:before { content: @fa-var-html5; }\n.@{fa-css-prefix}-css3:before { content: @fa-var-css3; }\n.@{fa-css-prefix}-anchor:before { content: @fa-var-anchor; }\n.@{fa-css-prefix}-unlock-alt:before { content: @fa-var-unlock-alt; }\n.@{fa-css-prefix}-bullseye:before { content: @fa-var-bullseye; }\n.@{fa-css-prefix}-ellipsis-h:before { content: @fa-var-ellipsis-h; }\n.@{fa-css-prefix}-ellipsis-v:before { content: @fa-var-ellipsis-v; }\n.@{fa-css-prefix}-rss-square:before { content: @fa-var-rss-square; }\n.@{fa-css-prefix}-play-circle:before { content: @fa-var-play-circle; }\n.@{fa-css-prefix}-ticket:before { content: @fa-var-ticket; }\n.@{fa-css-prefix}-minus-square:before { content: @fa-var-minus-square; }\n.@{fa-css-prefix}-minus-square-o:before { content: @fa-var-minus-square-o; }\n.@{fa-css-prefix}-level-up:before { content: @fa-var-level-up; }\n.@{fa-css-prefix}-level-down:before { content: @fa-var-level-down; }\n.@{fa-css-prefix}-check-square:before { content: @fa-var-check-square; }\n.@{fa-css-prefix}-pencil-square:before { content: @fa-var-pencil-square; }\n.@{fa-css-prefix}-external-link-square:before { content: @fa-var-external-link-square; }\n.@{fa-css-prefix}-share-square:before { content: @fa-var-share-square; }\n.@{fa-css-prefix}-compass:before { content: @fa-var-compass; }\n.@{fa-css-prefix}-toggle-down:before,\n.@{fa-css-prefix}-caret-square-o-down:before { content: @fa-var-caret-square-o-down; }\n.@{fa-css-prefix}-toggle-up:before,\n.@{fa-css-prefix}-caret-square-o-up:before { content: @fa-var-caret-square-o-up; }\n.@{fa-css-prefix}-toggle-right:before,\n.@{fa-css-prefix}-caret-square-o-right:before { content: @fa-var-caret-square-o-right; }\n.@{fa-css-prefix}-euro:before,\n.@{fa-css-prefix}-eur:before { content: @fa-var-eur; }\n.@{fa-css-prefix}-gbp:before { content: @fa-var-gbp; }\n.@{fa-css-prefix}-dollar:before,\n.@{fa-css-prefix}-usd:before { content: @fa-var-usd; }\n.@{fa-css-prefix}-rupee:before,\n.@{fa-css-prefix}-inr:before { content: @fa-var-inr; }\n.@{fa-css-prefix}-cny:before,\n.@{fa-css-prefix}-rmb:before,\n.@{fa-css-prefix}-yen:before,\n.@{fa-css-prefix}-jpy:before { content: @fa-var-jpy; }\n.@{fa-css-prefix}-ruble:before,\n.@{fa-css-prefix}-rouble:before,\n.@{fa-css-prefix}-rub:before { content: @fa-var-rub; }\n.@{fa-css-prefix}-won:before,\n.@{fa-css-prefix}-krw:before { content: @fa-var-krw; }\n.@{fa-css-prefix}-bitcoin:before,\n.@{fa-css-prefix}-btc:before { content: @fa-var-btc; }\n.@{fa-css-prefix}-file:before { content: @fa-var-file; }\n.@{fa-css-prefix}-file-text:before { content: @fa-var-file-text; }\n.@{fa-css-prefix}-sort-alpha-asc:before { content: @fa-var-sort-alpha-asc; }\n.@{fa-css-prefix}-sort-alpha-desc:before { content: @fa-var-sort-alpha-desc; }\n.@{fa-css-prefix}-sort-amount-asc:before { content: @fa-var-sort-amount-asc; }\n.@{fa-css-prefix}-sort-amount-desc:before { content: @fa-var-sort-amount-desc; }\n.@{fa-css-prefix}-sort-numeric-asc:before { content: @fa-var-sort-numeric-asc; }\n.@{fa-css-prefix}-sort-numeric-desc:before { content: @fa-var-sort-numeric-desc; }\n.@{fa-css-prefix}-thumbs-up:before { content: @fa-var-thumbs-up; }\n.@{fa-css-prefix}-thumbs-down:before { content: @fa-var-thumbs-down; }\n.@{fa-css-prefix}-youtube-square:before { content: @fa-var-youtube-square; }\n.@{fa-css-prefix}-youtube:before { content: @fa-var-youtube; }\n.@{fa-css-prefix}-xing:before { content: @fa-var-xing; }\n.@{fa-css-prefix}-xing-square:before { content: @fa-var-xing-square; }\n.@{fa-css-prefix}-youtube-play:before { content: @fa-var-youtube-play; }\n.@{fa-css-prefix}-dropbox:before { content: @fa-var-dropbox; }\n.@{fa-css-prefix}-stack-overflow:before { content: @fa-var-stack-overflow; }\n.@{fa-css-prefix}-instagram:before { content: @fa-var-instagram; }\n.@{fa-css-prefix}-flickr:before { content: @fa-var-flickr; }\n.@{fa-css-prefix}-adn:before { content: @fa-var-adn; }\n.@{fa-css-prefix}-bitbucket:before { content: @fa-var-bitbucket; }\n.@{fa-css-prefix}-bitbucket-square:before { content: @fa-var-bitbucket-square; }\n.@{fa-css-prefix}-tumblr:before { content: @fa-var-tumblr; }\n.@{fa-css-prefix}-tumblr-square:before { content: @fa-var-tumblr-square; }\n.@{fa-css-prefix}-long-arrow-down:before { content: @fa-var-long-arrow-down; }\n.@{fa-css-prefix}-long-arrow-up:before { content: @fa-var-long-arrow-up; }\n.@{fa-css-prefix}-long-arrow-left:before { content: @fa-var-long-arrow-left; }\n.@{fa-css-prefix}-long-arrow-right:before { content: @fa-var-long-arrow-right; }\n.@{fa-css-prefix}-apple:before { content: @fa-var-apple; }\n.@{fa-css-prefix}-windows:before { content: @fa-var-windows; }\n.@{fa-css-prefix}-android:before { content: @fa-var-android; }\n.@{fa-css-prefix}-linux:before { content: @fa-var-linux; }\n.@{fa-css-prefix}-dribbble:before { content: @fa-var-dribbble; }\n.@{fa-css-prefix}-skype:before { content: @fa-var-skype; }\n.@{fa-css-prefix}-foursquare:before { content: @fa-var-foursquare; }\n.@{fa-css-prefix}-trello:before { content: @fa-var-trello; }\n.@{fa-css-prefix}-female:before { content: @fa-var-female; }\n.@{fa-css-prefix}-male:before { content: @fa-var-male; }\n.@{fa-css-prefix}-gittip:before { content: @fa-var-gittip; }\n.@{fa-css-prefix}-sun-o:before { content: @fa-var-sun-o; }\n.@{fa-css-prefix}-moon-o:before { content: @fa-var-moon-o; }\n.@{fa-css-prefix}-archive:before { content: @fa-var-archive; }\n.@{fa-css-prefix}-bug:before { content: @fa-var-bug; }\n.@{fa-css-prefix}-vk:before { content: @fa-var-vk; }\n.@{fa-css-prefix}-weibo:before { content: @fa-var-weibo; }\n.@{fa-css-prefix}-renren:before { content: @fa-var-renren; }\n.@{fa-css-prefix}-pagelines:before { content: @fa-var-pagelines; }\n.@{fa-css-prefix}-stack-exchange:before { content: @fa-var-stack-exchange; }\n.@{fa-css-prefix}-arrow-circle-o-right:before { content: @fa-var-arrow-circle-o-right; }\n.@{fa-css-prefix}-arrow-circle-o-left:before { content: @fa-var-arrow-circle-o-left; }\n.@{fa-css-prefix}-toggle-left:before,\n.@{fa-css-prefix}-caret-square-o-left:before { content: @fa-var-caret-square-o-left; }\n.@{fa-css-prefix}-dot-circle-o:before { content: @fa-var-dot-circle-o; }\n.@{fa-css-prefix}-wheelchair:before { content: @fa-var-wheelchair; }\n.@{fa-css-prefix}-vimeo-square:before { content: @fa-var-vimeo-square; }\n.@{fa-css-prefix}-turkish-lira:before,\n.@{fa-css-prefix}-try:before { content: @fa-var-try; }\n.@{fa-css-prefix}-plus-square-o:before { content: @fa-var-plus-square-o; }\n","@import \"bootstrap.less\";\n  \n//Index Android (sugiere instalar la app)\n  body.android-install-app {\n    h3 { margin:0;\n       @media (min-width: @screen-sm-min) {\n        margin-top:30px;\n      }\n    }\n    .android-pict {\n    width:100%;\n    max-width:308px;\n    padding: 30px 10px 0px 10px;\n  }\n  @media (max-width: 360px) {\n    .android-pict {\n      width:200px;\n      padding-top:0;\n    }\n    h3 {\n      margin:0;\n    }\n  }\n  @media (max-width: @screen-xs-max) {\n    h3, p {\n      text-align: center;\n    }\n    .padding-2 {\n      padding:0px 20px;\n    }\n  }\n}\n.margin-top-10-percent {\n   margin-top:10%;\n   @media (max-width: @screen-xs-max) {\n    margin: 0;\n     }\n  }\n  @media (max-width: @screen-xs-max) {\n      .poster-mobile-hor.padding-1 {\n      padding-top:0;\n    }\n  }","// componente multilevel\n@import \"bootstrap.less\";\n\n/*### -multilevel push menu-###*/\n.multilevelpushmenu_wrapper {\n    position: absolute;\n   /* overflow: hidden;*/ //revisar si se rompe\n    min-width: 100%;\n    min-height: 100%;\n    margin: 0;\n    padding: 0;\n    bottom: 16px;\n}\n\n.multilevelpushmenu_wrapper h2 {\n   background-color: #1a1a1a;\n   font-size: 14px;\n   font-weight: bold;\n   color: #fafafa;\n   padding: 3px 20px;\n   line-height: 50px;\n   margin-top: 0;\n   margin-bottom: 0;\n}\n\n.multilevelpushmenu_wrapper .levelHolderClass {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    /*background: #1a1a1a;\n    background-color: #2e2e2e;*/\n    background-color: fade(@black , 75%);\n    width: auto;\n    min-height: 100%;\n    height: 100%;\n    border-radius: 4px;\n      border: 1px solid @gray1;\n  //  zoom: 1;\n     /*solo cuando se necesite-revisar*/\n}\n.multilevelpushmenu_wrapper .levelHolderClass {\n     overflow-y:auto;\n}\n\n.multilevelpushmenu_wrapper .ltr {\n    margin-left: -100%;\n    left: 0;\n}\n\n.multilevelpushmenu_wrapper .rtl {\n    margin-right: -100%;\n    right: 0;\n}\n\n.multilevelpushmenu_wrapper .multilevelpushmenu_inactive {\n  /*  background: #2e6196;*/\n       overflow-y:hidden;\n}\n\n.multilevelpushmenu_wrapper ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.multilevelpushmenu_wrapper li {\n    cursor: pointer;\n    border-top: 1px solid #424242;\n    padding: 3px 15px;\n    line-height: 50px;\n}\n\n.multilevelpushmenu_wrapper li:last-child {\n   /* border-bottom: 1px solid #295685;*/\n}\n\n.multilevelpushmenu_wrapper li:hover {\n    background-color: #424242;\n}\n\n.multilevelpushmenu_wrapper a {\n    display: block;\n    outline: none;\n    overflow: hidden;\n    font-size: 14px;\n    text-decoration: none;\n    color: #fff;\n}\n\n.multilevelpushmenu_wrapper a:hover {\n    color: #ffe;\n}\n\n.multilevelpushmenu_wrapper .backItemClass {\n    display: block;\n}\n\n.multilevelpushmenu_wrapper .floatRight {\n    float: right;\n}\n\n.multilevelpushmenu_wrapper .floatLeft {\n    float: left;\n}\n\n.multilevelpushmenu_wrapper .cursorPointer {\n    cursor: pointer;\n}\n\n.multilevelpushmenu_wrapper .iconSpacing_ltr {\n\n}\n\n.multilevelpushmenu_wrapper .iconSpacing_rtl {\n}\n\n/*ellipsis revisar camellcase claselevelholderclas*/\n.chapter-sel .levelholderClass.ltr a span,\n.chapter-sel .multilevelpushmenu_wrapper a span\n{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 160px;\n}\n\n\n.chapter-sel,\n.chapter-sel02\n{ position: relative;}\n.chapter-sel > div#menu,\n.chapter-sel02 > div#menu\n\n{\n    bottom: 27px;\n    right:-28px;\n    height: 365px !important;\n    min-height: 365px !important;\n    position: absolute;\n}\nnav.multilevelpushmenu_wrapper\n{\n    height: 343px !important;\n    min-height: 343px !important;\n}\n.chapter-sel > div#menuResponsive,\n.chapter-sel02 > div#menuResponsive\n { //Estilos agregados para el selector Responsive.\n  bottom: 34px;\n  right:0px;\n  position: absolute;\n}\n.chapter-sel3 a span.episode-name\n{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 160px;\n}\n\n.levelHolderClass h2 i.fa.pull-left\n{\n    margin-right: 10px;\n    line-height: 50px;\n\n}\n\n\n.levelHolderClass.ltr {\n    z-index: 1; /*(fix de  error animacion)*/\n}\n\n.multilevelpushmenu_wrapper a .fa {\n    line-height: 50px;\n}\n\n/**/\n\n/*.levelHolderClass.ltr ul li a .fa\n{\n  display: none !important;\n}\n*/\n//esto era para evitar doble icono-sacar\n\n/*hover ruedita*/\n\n\n.multilevelpushmenu_wrapper .levelHolderClass ul li {\n     background-color: fade(@gray1 , 35%);\n}\n\n.multilevelpushmenu_wrapper .levelHolderClass ul li.selected{\n    background-color: fade(@gray2, 50%);\n  /*color: #d8d8d8;*/\n}\n.multilevelpushmenu_wrapper li:hover {\n   background-color: fade(@gray1 , 90%);\n}\n.multilevelpushmenu_wrapper .levelHolderClass ul li:hover {\n    background-color: fade(@gray1 , 90%);\n}\n\n\n\n\n//lalalala\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  content:\"\";\n  height:0;\n  width:0;\n  position:absolute;\n  bottom:100%;\n  border:solid transparent;\n}\n\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after\n {\n  border-bottom-color:#fff;\n  border-width:6px;\n  left:33%;\n  margin-left:-6px;\n}\n\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  border-bottom-color:#ddd;\n  border-width:7px;\n  left:33%;\n  margin-left:-7px;\n}\n\n\n\n//allala\n\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  top:100%;\n}\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:after,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:after {\n  border-bottom-color:transparent;\n  border-top-color:fade(@gray1,95%);\n  border-width:auto;\n  left:auto;\n  margin-left:auto;\n  right:23%;\n  margin-right:-6px;\n}\n\n.chapter-sel > div#menu .multilevelpushmenu_wrapper:before,\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper:before {\n  border-bottom-color:transparent;\n  border-top-color:fade(@gray1,95%);\n  border-width:8px;\n  left:auto;\n  margin-left:auto;\n  right:23%;\n  margin-right:-8px;\n}\n\n.chapter-sel2 #menuResponsive {\n  bottom: 34px;\n  height: 245px !important;\n  min-height: 245px !important;\n  position: absolute;\n  right: -27px;\n}\n.chapter-sel2 #menuResponsive .multilevelpushmenu_wrapper {\n  height: 235px !important;\n  min-height: 235px !important;\n\n}\n\n//small fix ruedita hay que hacer esto por js y estilos\n.levelHolderClass.ltr .levelHolderClass.ltr {\n  opacity: 0;\n}\n\n\n.levelHolderClass.ltr.multilevelpushmenu_inactive {\n  h2 {display: none;}\n}\n\n.levelHolderClass.ltr.multilevelpushmenu_inactive .levelHolderClass.ltr {\n  opacity: 1;\n  h2 {display: block;}\n}\n\n.levelHolderClass.ltr {\n  transition: all 0.2s ease;\n}\n\n\n\n.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu li a,\n.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu li a {\n  width: 270px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.videoph5-container .selector-temporada-fin .btn-group .dropdown-menu,\n.videoph5-container .selector-episodio-fin .btn-group .dropdown-menu {\n  min-width: auto;\n  width: 280px;\n}\n","// Componente player\n@import \"bootstrap.less\";\n\n\nvideoph5 button {\n    cursor: pointer;\n}\nvideoph5.fullscreen {\n    left: 0;\n    position: fixed;\n    top: 0;\n  }\nvideoph5 vph5-media, .void {\n    display: block;\n    height: 100%;\n    left: 0;\n    top: 0;\n    width: 100%;\n}\nvideoph5 video, .void {\n    display: block;\n    border: 0 none;\n    height: 100%;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    top: 0;\n    width: 100%;\n}\n//angular-screenfull\n.fullscreen {\n  width: 100%;\n  height: 100%;\n}\n\n\n//DEFINIR\n\nvideoph5 .vgTimeDisplay {\n    display: table-cell;\n    font-family: Roboto;\n    font-size: 18px;\n    width: auto;\n}\nvideoph5 vph5-buffering .bufferingContainer {\n}\n\nvideoph5 vph5-fullscreen-button, .void {\n    cursor: pointer;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    width: 50px;\n}\nvideoph5 vph5-buffering, .void {\n    position: absolute;\n    top: 50%;\n    width: 60px;\n    height: 60px;\n    z-index: 2;\n    margin-top: -60px;\n    margin-left: -30px;\n    left: 50%;\n}\nvideoph5 vph5-buffering {\n  /*background-color: rgba(0,0,0,.8);*/\n}\n\nvideoph5 vph5-controls .btn-default {\n    color: #f2f2f2;\n    border: none;\n    font-size: 16px;\n    \n}\n\nvideoph5 vph5-controls .btn-default .fa{\n    font-size: 22px;\n    line-height: 31px;\n}\n\n.vph5-player .label.label-player {\n    border: 1px solid #ccc;\n    display: table;\n    float: left;\n    font-size: 100%;\n    line-height: normal;\n    margin: 10px 5px 10px 0;\n    padding: 10px;\n    position: relative;\n}\n.vph5-player .item-salir {\n    background: transparent;\n    /*color: #ccc;*/\n    display: table;\n    height: 30px;\n    left: 10px;\n    line-height: 28px;\n    padding: 0 10px 0 0;\n    position: absolute;\n    top: 10px;\n    z-index: 3;\n}\n\n\nvph5-container, .void {\n   /* background: pink none repeat scroll 0 0;*/\n    display: block;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    position: relative;\n    overflow: hidden;\n}\n\n.videoph5-container {\n    height: 100%;\n    width: 100%;\n}\n\n.videoph5-container.full-player {\n    display: block;\n    height: 100%;\n    position: relative;\n    transition: all 0.5s ease-out 0s;\n    width: 100%;\n}\n\n.vph5-player {\n    height: 100%;\n    position: absolute;\n    width: 100%;\n}\n\nvideoph5.videoph5-cont, .void {\n    display: table;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top:0;\n    left:0;\n}\n\n\n/*fix fullscreen*/\nvideoph5, .void {\n    display: block;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n    width: 100%;\n}\n\n\n//  ------------------------------------------------------------------------------------------------------------------------------------------------------------\n// CONTROL BAR\nvideoph5 vph5-controls, .void {\n    display: block;\n    height: 165px;\n    position: absolute;\n    top: ~\"calc(100% - 165px)\";\n    width: 100%;\n    z-index: 3;\n    background-image: linear-gradient(rgba(0, 0, 0, 0), #000000);\n}\nvideoph5 vph5-controls .controls-container {\n   /* background-color: #000;\n    background-color: rgba(0, 0, 0, 0.7);*/\n    display: table;\n    height: 50px;\n    left: 1%;\n    position: absolute;\n    padding: 0 5px;\n    width: 98%;\n   bottom:0;\n}\nvideoph5 vph5-play-pause-button, .void {\n    cursor: pointer;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    width: 50px;\n}\nvideoph5 vph5-play-pause-button .btn\n{\n     width: 40px;\n}\nvideoph5 vph5-time-display, .void {\n    color: #ffffff;\n    cursor: default;\n    display: table-cell;\n    font-family: Roboto;\n    font-size: 16px;\n    text-align: center;\n    vertical-align: middle;\n    width: 75px;\n}\n\n//margin seek-progress-bar\nvph5-play-pause-button.controls {\n    padding-right: 30px;\n}\n.sub-controls {\n    padding-left: 30px;\n}\n\n\n.play-bar {\n    background: #272727 none repeat scroll 0 0;\n}\n.play-bar-wrapper {\n    padding: 0 15px;\n    text-align: center;\n    width: 100%;\n}\n\n@media (max-width: @screen-xs-max) {\n  .play-bar-wrapper.is_live {\n    visibility: hidden;\n  }\n}\n\n.vc-seekbar {\n    left: 0;\n    position: absolute;\n    z-index: 999;\n}\n.vc {\n    -moz-user-select: none;\n    background-color: #1b1b1b;\n    color: #777777;\n    height: 28px;\n    position: relative;\n    width: 100%;\n    z-index: 9000;\n}\n\n.vc-seeker {\n    background-color: @gray2;\n    border: 1px solid @gray2;\n    cursor: pointer;\n    display: inline-block;\n    height: 6px;\n    left: 0;\n    top: 0;\n    width: 100%;\n    margin: 0;\n    border-radius: 6px;\n    position: absolute;\n    transition: height 0.25s linear 0s, top 0.25s linear 0s;\n}\n.vc-player > .vc > .vc-seeker {\n    background-color: #444444;\n    height: 8px;\n    top: -5px;\n}\n.vc-range {    \n    height: 20px;\n    width: 20px;\n    line-height: 0;\n    margin: -8px 0 0 -5px;\n    text-align: center;\n    transition: height 0.25s linear 0s, width 0.25s linear 0s, margin 0.25s linear 0s, line-height 0.25s linear 0s;\n}\n.vc-range-little {\n    display: inline-block;\n    transition: height 0.25s linear 0s, width 0.25s linear 0s, opacity 0s linear 0.2s;\n    vertical-align: middle;\n    background-color: @gray5;\n    border: 1px solid @gray5;\n    border-radius: 100%;\n    height: 18px;\n    width: 18px;\n    margin-top: 1px;\n    opacity: 1;\n    box-shadow: 0px 0px 8px 2px #f2f2f2;\n}\n.vc-loadingbar {\n    background-color: @gray4;\n    display: inline-block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 0;\n}\n.vc-progressbar {\n    background-color: @gray5;\n    background-size: 30px 30px !important;\n    display: inline-block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 0;\n}\n.vc-progressbarbuffer {\n    background-color: fade(@gray4 , 0.3);\n    display: inline-block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n}\n\n.vc-progressbar, .vc-progressbarbuffer {\n    border-radius: 4px 0 0 4px;\n}\n\nvideoph5 finplayer-plugin {\n    background: rgba(0, 0, 0, 0) none repeat scroll 0 0 !important;\n    display: table !important;\n    height: 100%;\n    width: 100%;\n    z-index: auto !important;\n}\nvideoph5 finplayer-plugin .finplayer-wrapper {\n    display: table;\n    height: 100%;\n    width: 100%;\n}\nvideoph5 vph5-dubsub-selector.vph5-dubsub-selector {\n    cursor: pointer;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    width: 50px;\n}\n.play-bar-wrapper {\n    padding: 0 15px;\n    width: 100%;\n}\n\n.controls-container > * {\n    display: table-cell;\n    vertical-align: middle;\n}\n.sub-controls > *, .controls {\n    padding: 0 3px;\n}\n.controls-container .sub-controls > div, .controls-container .sub-controls vph5-dropdown {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n}\n\n.controls-container .play-bar {\n    border-radius: 4px;\n    height: 5px;\n    position: relative;\n    width: 100%;\n}\n.controls-container .btn-group .btn .filter-option {\n    display: inline-block;\n    overflow: hidden;\n    text-align: left;\n    width: 100%;\n}\n\n /*controls container*/\n.videoph5-container .dropdown-menu {\n    //background: #3c3c3c none repeat scroll 0 0;\n    border: medium none;\n    //color: #fafafa;\n}\n.videoph5-container .dropdown-menu > li > a {\n    border-bottom: 1px solid @gray1;\n    //color: #ffffff;\n    line-height: 50px;\n    white-space: nowrap;\n    \n    \n}\n.videoph5-container .dropdown-menu > li:last-child > a\n{\n      border-bottom:none;\n}\n.videoph5-container .dropdown-submenu:hover > a::after {\n    border-left-color: #fff;\n}\n.videoph5-container .btn-group .dropdown-menu {\n  /*background-color: #2e2e2e;*/\n  border: 1px solid @gray1;\n  box-sizing: border-box;\n  min-width: 100%;\n  left:0;\n  width: 200px;\n  z-index: 1035;\n  padding: 0px;\n}\n.videoph5-container .controls-container .btn-group .dropdown-menu{\n    left: auto;\n    right: -13px;\n}\n\n.videoph5-container .controls-container vph5-quality-selector .btn-group .dropdown-menu{\n    right: -4px;\n}\n\n.dropdown-wrappper\n{ display: none;}\n\n.open .dropdown-wrappper{\n  // Show the menu\n  display: block;\n  > .dropdown-menu {\n    display: block;\n  }\n\n  // Remove the outline when :focus is triggered\n  > a {\n    outline: 0;\n  }\n}\n\n\n.videoph5-container .btn-group .dropdown-menu.inner {\n   /* background-color: #2e2e2e;*/\n}\n.open > .dropdown-toggle.btn-default\n{\n /* background-color: #393939;\n      border-color: #393939;*/\n      color: #d8d8d8; \n}\n\n.videoph5-container .btn-group  {\n  .dropdown-menu > li > a\n  {\n      &:hover,\n      &:focus {\n      /* background-color: #424242;\n      color: #d8d8d8;*/\n      }\n\n  }\n\n  .dropdown-menu\n  .btn-default{\n      &.active  \n      &.focus\n      &:hover,\n      &:focus,\n      &:active {\n      /* background-color: #393939;\n      border-color: #393939;*/\n      color: #d8d8d8;\n      }\n  }\n}\n\n.videoph5-container .controls-container .btn-group .dropdown-menu {\n  bottom: 15px;\n}\n\n.videoph5-container .controls-container .dropdown-wrappper {\n  position: absolute;\n  height: 240px;\n  /*background: pink;*/\n  bottom: 25px;\n  right: -10px;\n  min-height: 200px;\n  width: 200px;\n}\n\n\n\n/**/\n\nvph5-volume {\n    position: relative;\n}\nvideoph5 vph5-volume-bar {\n    cursor: pointer;\n    height: 80px;\n    position: absolute;\n    right: 6px;\n    text-align: center;\n    top: -80px;\n    vertical-align: middle;\n    width: 30px;\n}\n@media not all, not all {\n    videoph5 vph5-volume-bar {\n        opacity: 0.5;\n    }\n}\n.vc-range-little2 {\n    background-color: @gray5;\n    border: 1px solid @gray5;\n     box-shadow: 0px 0px 8px 2px #f2f2f2;\n    border-radius: 100%;\n    height: 18px;\n    width: 18px;\n    display: inline-block;\n    position: absolute;\n    top: -2px;\n    left: -7px;\n    opacity: 1;\n}\n\n\nvideoph5 vph5-volume-bar .verticalVolumeBar {\n    height: 80px;\n    position: absolute;\n    width: 30px;\n}\nvideoph5 vph5-volume-bar .volumeBackground {\n    background-color: @gray2;\n   /* border: 1px solid @gray2;*/\n    height: 80px;\n    left: 12px;\n    position: absolute;\n    top: 0;\n    width: 4px;\n    border-radius: 4px;\n\n}\nvideoph5 vph5-volume-bar .volumeValue {\n    background-color: @gray5;\n    height: 100%;\n    position: absolute;\n    width: 4px;\n    border-radius: 4px;\n\n}\nvideoph5 vph5-volume-bar .volumeClickArea {\n    height: 100%;\n    position: absolute;\n    width: 40px;\n    left: -15px;\n}\n/*ancho volume-mute*/\nvph5-mute-button .btn{\n    width:38px;\n}\n\n\n\n.vph5-player {\n  .dropdown-menu > li > a:hover,\n  .dropdown-menu > li > a:focus\n  { background-color: fade(@gray1 , 90%);}\n    .dropdown-menu li a {\n        text-align: left;\n    }\n    .dropdown-menu li{\n      background-color: fade(@gray1 , 35%);\n      &:first-child {\n          /* background-color: fade(@black , 80%); */        \n      }\n\n      &.selected {\n           background-color: fade(@gray2, 50%);\n         /* color: #d8d8d8;*/\n      }\n    }\n\n    vph5-dropdown span.filter-option {\n      max-width: 290px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n  }\n\n  /*fix selector capitulos fin player -pasar a less*/\n  @media (max-width: 990px) {\n      vph5-dropdown span.filter-option {\n          max-width: 190px;\n          text-overflow: ellipsis;\n          overflow: hidden;\n      }\n  }\n\n}\n\nvideoph5 div.scrollablearea { \n    position: absolute;\n}\n\n//control bar item-title 2016\n.controls-title-wrapper {\n    position: absolute;\n    bottom: 60px;\n    //background: red;\n}\n\n//FIN CONTROL BAR\n//  ------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n\n\n\n\n\n//PAUSA PLAYER\n.ficha-player .box_data .fecha_tiempo .item-year {\n    font-weight: bold;\n}\nvideoph5 vph5-pause-plugin {\n    display: block;\n    position: absolute;\n    top: 0;\n    z-index: 1;\n}\nvideoph5 vph5-pause-plugin {\n    color: inherit !important;\n    height: 100%;\n    width: 100%;\n}\n.pausa-wrapper {\n    background: rgba(0, 0, 0, 0.8) none repeat scroll 0 0;\n    color: #ccc;\n    height: 100%;\n    padding-top: 50px;\n    position: relative;\n}\nvph5-pause-plugin .section-ficha {\n    height: 100%;\n    width: 100%;\n    border-bottom: none;\n}\nvph5-pause-plugin .section-ficha.vertical-align {\n    display: table-cell;\n    vertical-align: middle;\n}\n\nvph5-pausemobile-plugin {\n    height: 160px;\n    width: 100%;\n    display: block;\n    position: absolute;\n    bottom: 0;\n    z-index: 1;\n    /*PASAR A MIXIN*/\n    background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.25) 5%, rgba(0,0,0,0.75) 26%, rgba(0,0,0,1) 58%, rgba(0,0,0,1) 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(0,0,0,0)), color-stop(5%,rgba(0,0,0,0.25)), color-stop(26%,rgba(0,0,0,0.75)), color-stop(58%,rgba(0,0,0,1)), color-stop(100%,rgba(0,0,0,1))); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 5%,rgba(0,0,0,0.75) 26%,rgba(0,0,0,1) 58%,rgba(0,0,0,1) 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 5%,rgba(0,0,0,0.75) 26%,rgba(0,0,0,1) 58%,rgba(0,0,0,1) 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 5%,rgba(0,0,0,0.75) 26%,rgba(0,0,0,1) 58%,rgba(0,0,0,1) 100%); /* IE10+ */\n    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 5%,rgba(0,0,0,0.75) 26%,rgba(0,0,0,1) 58%,rgba(0,0,0,1) 100%); //mixin revisar\n    // CUIDADO CON IE\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 ); /* IE6-9 */\n}\n\nvph5-pausemobile-plugin .pausa-mobile-wrapper {\n    margin:20px 10px 0 10px;\n    color:#ccc;\n    display:block;\n}\n\nvph5-pausemobile-plugin .pausa-mobile-wrapper .h2_content_title {\n    font-size: 30px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\nvideoph5 pause-plugin {\n    display: block;\n    position: absolute;\n    top: 0;\n    z-index: 0;\n}\nvideoph5 finplayer-plugin {\n    color: red;\n    display: block;\n    position: absolute;\n    top: 0;\n    z-index: 50;\n}\nvideoph5 pause-plugin {\n    color: inherit !important;\n    height: 100%;\n    min-height: 320px;\n    width: 100%;\n}\npause-plugin .section-ficha {\n    left: 0;\n    margin-top: -170px;\n    position: absolute;\n    top: 50%;\n}\n\n.pausa-wrapper .content {\n    height: 100%;\n    position: relative;\n    width: 100%;\n}\n.pausa-wrapper .content.center-wrapper {\n    display: table;\n    vertical-align: middle;\n}\n.pausa-wrapper .h2_content_title {\n    color: #fafafa;\n    font-size: 42px;\n}\n.pausa-wrapper .fecha_tiempo {\n    margin-left: 10px;\n}\n//FIN PAUSA\n\n//FICHA\n.vph5-player .section-7 {\n    display: block;\n    position: absolute;\n    right: 2em;\n    top: 0;\n    width: 600px;\n    z-index: 3;\n}\n//FIN FICHA\n//  ------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n//embed responsive\n\n.video-container {\n    display: block;\n    height: 100%;\n    width: 100%;\n}\n\n.embed-responsive{\n  position:relative;\n  display:block;\n  height:0;\n  padding:0;\n  overflow:hidden\n}\n\n.embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video{\n  position:absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  width:100%;\n  height:100%;\n  border:0\n}\n\n.embed-responsive-16by9{\n  padding-bottom:56.25%\n}\n\n.embed-responsive-4by3{\n  padding-bottom:75%\n} \n\n.vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9{\n    background-color: #000000;\n}\n\n\n/**/\n//dropdowns 2016\n\n//solo player\n.videoph5-container .dropdown-menu{\n    background-color: transparent;\n    background-color: rgba(0,0,0,0.90)\n}\n\n.vph5-player {\n  vph5-dropdown span.filter-option{\n    padding-right: 10px;\n  }\n  .dropup .btn-default .caret {\n    margin-left: 10px;\n  }\n  .selector-episodio-fin .button-label2.dropdown-toggle::before,\n  .selector-temporada-fin .button-label2.dropdown-toggle::before {\n    content: \"\";\n    border-left: 1px solid #464646;\n    height: 100%;\n    display: block;\n    position: absolute;\n    right: 29px;\n    top: 0px;\n  }\n  .dropdown-menu > li > a {\n     color: @gray5;\n  }\n\n  ul.dropdown-menu:after,\n  ul.dropdown-menu:before {\n    top:100%;\n  }\n  ul.dropdown-menu:after {\n    border-bottom-color:transparent;\n    border-top-color:fade(@gray1,95%);\n    border-width:auto;\n    left:auto;\n    margin-left:auto;\n    right:23%;\n    margin-right:-6px;\n  }\n\n  ul.dropdown-menu:before {\n    border-bottom-color:transparent;\n    border-top-color:fade(@gray1,95%);\n   \n    border-width:8px;\n    left:auto;\n    margin-left:auto;\n    right:23%;\n    margin-right:-8px;\n  }\n\n}\n\n\n\n//WEBKIT HACKS\n\n\n:-webkit-full-screen\n{\n    background-color: #000000;\n}\n.vph5-player{\n  ::-webkit-scrollbar{\n    width:10px; \n    height: 10px;\n  }\n  ::-webkit-scrollbar-button:end:increment,\n  ::-webkit-scrollbar-button:start:decrement{\n    height: 10px;\n    display: block;\n    background-color: #2b2b2b;\n    border-color: #3b3b3b;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n   }\n  ::-webkit-scrollbar-track-piece  {\n    background-color: #3b3b3b;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n   }\n  ::-webkit-scrollbar-thumb:vertical {\n    height: 40px;\n    background-color: #666;\n    border: 1px solid #3b3b3b;\n    -webkit-border-radius: 6px;\n   }\n}\n\n.finplayer-wrapper2 .btn-default\n{background-color: rgba(35,35,35,0.85);\n    border-color: #232323;\n    color: #666666;\n}\n\n.recover-pin{\n  line-height: 32px;\n}\n\n.videoph5-container vph5-channel-selector .btn-group .dropdown-menu{\n    width: 240px;\n}\n\n.videoph5-container vph5-channel-selector .dropdown-menu > li > a{\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.brand01, .on-live {\n    padding: 0;\n}\n.brand01 img,\n.on-live span2 {\n    margin-bottom: 6px;\n}\n\n.on-live span {\n    float: left;\n    margin-left: 10px;\n}\n\n.vph5-player  vph5-channel-selector ul.dropdown-menu:after,\n.vph5-player  vph5-channel-selector ul.dropdown-menu:before\n{ right: 18%}\n\n//disable tv live\n.controls-container .disable {\n  color: #272727;\n}\n\n.vph5-player  .controls-container .btn{\n  text-overflow:initial;\n  height: 45px;\n}\n","@import \"bootstrap.less\";\n\n.section-fin-series .image.container2 {\n  display: block;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n\n.countdown-container {\n  font-size: 20px;\n}\n.countdown-container .countdown {\n /* color: #ff0000;*/\n}\n.vph5-player\n{\n  .section-fin-series .item-img {\n    display: block;\n    float: left;\n    height: auto;\n    max-width: 100%;\n    position: relative;\n  }\n\n  .section-fin-series .item-wrapper2 {\n    margin: 0 auto;\n    max-width: 675px;\n  }\n  .section-fin-series {\n    margin-top: 120px;\n  }\n\n  .section-fin-series {\n    max-width: 675px; /*small-fix problema imagen chica*/\n  }\n\n  .section-fin-series .dropdown-menu {\n    height: 285px;\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n.vph5-finplayer vph5-exitbutton-plugin .item-salir {\n  left: 10px;\n  top: 10px;\n  display:inherit;\n}\n\n.fin-player .image.container2 {\n  left: 15px;\n  position: absolute;\n  top: 0;\n}\n.fin-player .image.container2 img { \n  width: 100%;\n}\n\n/*---*/\n\nvph5-container.fin-player {\n  display: table;\n  height: 100%;\n  transition: all .4s ease-out 0s;\n}\n\nvph5-finplayer-plugin {\n  transition: all 0.4s ease-out 0s;\n  opacity: 1;\n  transition: 1s all;\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n}\n\n\n// CARRUSELES FIN PLAYER\n.vph5-player .jcarousel.jcarousel-2.horizontal .scrollwrapper {\n  min-height: 250px;\n}\n\n.vph5-player  .jcarousel.jcarousel-1 {\n  height: 252px;\n}\n\n.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper\n{\n  min-height: 250px;\n}\n\n.vph5-player .jcarousel.jcarousel-1.vertical .scrollwrapper\n{\n  min-height: 250px;\n}\n\n//fix proyecto imng appi\n.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 {\n    width: 440px;\n}\n.vph5-player .jcarousel-2 .jcarousel-container.jcarousel-container-1 img {\n    max-width: 440px;\n}\n.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 {\n    width: 170px;\n}\n.vph5-player .jcarousel-1 .jcarousel-container.jcarousel-container-1 img {\n    max-width: 170px;\n}\nvph5-container.fin-player {\n  /*  display: table;*/ /*esto es para fullscreen*/\n  height: 100%;\n  /*transition: all 1.4s ease-out 0s;*/\n}\n\n\n/*logo fin player*/\nvph5-finplayer-fondo .brand, .brand\n{\n  display: block;\n  left: 25px;\n  position: absolute;\n  top: 10px;\n  z-index: 1;\n}\n\n/*mas fin*/\n.vph5-finplayer vph5-media {\n  margin: 180px 0 0;\n  padding: 0 24px;\n  height: auto;\n  position:relative;\n  transition: all 0.4s ease-out 0s;\n}\n.vph5-fin-movie .finplayer-wrapper2 {\n    margin-top: 140px;\n}\n\n@media (max-width: 767px) {\n  .fin-player vph5-media {\n  margin-top: 60px;\n  padding: 0;}\n  .vph5-player .vph5-finplayer vph5-media .embed-responsive-16by9{\n     padding-bottom: 75%;\n}\n\n}\n\n/*MISC*/\n.vph5-finplayer a,\n.videoph5-container .dropdown-menu > li > a{\n  cursor: pointer;\n}\n\n.vph5-finplayer .item-salir {\n  /*left: 30px;\n  top: 80px;*/\n}\n\n.vph5-player {\n  .tooltip-score .fa {\n    font-size: 1.8em;\n  }\n\n  .tooltip-score .msg .fa {\n    font-size: 1.4em;\n    line-height: 1.4em;\n  }\n \n  .tooltip-score .msg span {\n    color: #fafafa;\n  }\n\n  .tooltip-score .msg .fa.check {\n    color: #008c00;\n  }\n}\n\n.fa.fa_green {\n  color: #08b755;\n  margin-top: 4px;\n}\n\n/*estrellitas*/\n.finplayer-wrapper2,\n.fin-player \n{\n  color: #fff;\n}\n.finplayer-wrapper2 .tooltip-score .fa,\n.fin-player .tooltip-score .fa\n{\n\n //font-size: 2.2em;\n  margin: 5px;\n}\n.finplayer-wrapper2 .tooltip-score .fa.empty,\n.fin-player .tooltip-score .fa.empty\n\n{\n /* border: 1px solid red;\n border-color: #1c1c1c;*/\n}\n.finplayer-wrapper2 .tooltip-score.panel-default,\n.fin-player .tooltip-score.panel-default\n{\n  background: #3e3e3e none repeat scroll 0 0;\n  border: medium none;\n  border-radius: 6px;\n  padding: 10px;\n  min-height: 40px;\n}\n\n.finplayer-wrapper2 .panel.panel-primary,\n.fin-player .panel.panel-primary\n{\n  background-color: #1a1a1a;\n  border-color: #bbbbbb;\n  margin-top: 30px;\n}\n\n\n\nvph5-finplayer-fondo {\n  display: block;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n  width: 100%;\n}\n.fin-player-bg1 {\n  background: rgba(0, 0, 0, 0.8) repeat scroll 0 0;\n  height: 100%;\n}\n.fin-player-bg2 {\n  /*background: rgba(0, 0, 0, 0) radial-gradient(ellipse at center center , #1d1d1d 0%, #0f0f0f 100%) repeat scroll 0 0;*/\n  height: 100%;\n}\n/*/*/\n\n\n\n//FONDOS 2016\n\n/*.vph5-finplayer-fondo > img\n{\n  z-index: -3;\n  height: 100%; \n  position: absolute; \n  top: 0;\n  left: 0;\n}\n*/\n.vph5-player{\n  .open .dropdown-toggle.btn-default,\n  .btn-default{\n    &:hover,\n    &:focus,\n    &:active,\n    &.active\n    {\n    /* background-color: rgba(35, 35, 35, 0.85);\n     border-color: #232323;*/\n    }\n  }\n}\n.vph5-finplayer .dropup {\n  .btn-default:hover,\n  .btn-default:focus, \n  .btn-default:active,\n  .btn-default.active, \n  .open .dropdown-toggle.btn-default\n  {    \n       background-color:rgba(35, 35, 35, 0.85);\n       border-color: #232323;\n  }\n}\n.vph5-player{\n  .season-sel > * {\n    float: left;\n    margin-right: 10px;\n  }\n  .cargando2-player {\n    display: table;\n    height: 35px;\n    line-height: 35px;\n    vertical-align: middle;\n    padding-top: 12px;\n  }\n}\n//ANGULAR RATINGS FIX\n@media (max-width: 991px) {\n  .angular-ratings-02 .tooltip-score .fa,\n  .finplayer-wrapper2 .angular-ratings-02 .tooltip-score .fa,\n  .finplayer .angular-ratings-02 .tooltip-score .fa {\n    font-size: 1.5em;\n    margin: 2px;}\n}\n\n@media (min-width: 991px) {\n  .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,\n  .finplayer-wrapper2  .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa,\n  .finplayer .angular-ratings-serie .angular-ratings-02 .tooltip-score .fa {\n    font-size: 1.5em;\n    margin: 2px;}\n}\n\n    /*hack for chrome -hotfix-carrusel*/\n@media screen and (-webkit-min-device-pixel-ratio:0)  {\n  .vph5-player .jcarousel-separador{\n    display: table-cell;\n    float: inherit;\n    margin: 0px;\n    background: inherit;\n    width: 15px;\n    padding: 1px;\n    border-left: 2px solid #202020;\n    border-right: 0px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
